webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	
	"use strict";
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularAnimate = __webpack_require__(3);
	
	var _angularAnimate2 = _interopRequireDefault(_angularAnimate);
	
	var _angularCookies = __webpack_require__(5);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _angularResource = __webpack_require__(7);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	var _angularSanitize = __webpack_require__(9);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	var _angularGettext = __webpack_require__(11);
	
	var _angularGettext2 = _interopRequireDefault(_angularGettext);
	
	var _angularLocalStorage = __webpack_require__(13);
	
	var _angularLocalStorage2 = _interopRequireDefault(_angularLocalStorage);
	
	var _angularMediaQueries = __webpack_require__(15);
	
	var _angularMediaQueries2 = _interopRequireDefault(_angularMediaQueries);
	
	__webpack_require__(16);
	
	__webpack_require__(17);
	
	__webpack_require__(18);
	
	__webpack_require__(22);
	
	__webpack_require__(23);
	
	var _angularUiRouter = __webpack_require__(24);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularUiBootstrap = __webpack_require__(25);
	
	var _angularUiBootstrap2 = _interopRequireDefault(_angularUiBootstrap);
	
	__webpack_require__(27);
	
	var _app = __webpack_require__(29);
	
	var _auth = __webpack_require__(30);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _account = __webpack_require__(41);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _permission = __webpack_require__(58);
	
	var _permission2 = _interopRequireDefault(_permission);
	
	var _permission3 = __webpack_require__(157);
	
	var _permission4 = _interopRequireDefault(_permission3);
	
	var _admin = __webpack_require__(158);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _author = __webpack_require__(162);
	
	var _author2 = _interopRequireDefault(_author);
	
	var _directDrMemberAuthors = __webpack_require__(166);
	
	var _directDrMemberAuthors2 = _interopRequireDefault(_directDrMemberAuthors);
	
	var _navbar = __webpack_require__(170);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _footer = __webpack_require__(172);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _main = __webpack_require__(174);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _files = __webpack_require__(179);
	
	var _files2 = _interopRequireDefault(_files);
	
	var _app2 = __webpack_require__(31);
	
	var _app3 = _interopRequireDefault(_app2);
	
	var _util = __webpack_require__(33);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _socket = __webpack_require__(182);
	
	var _socket2 = _interopRequireDefault(_socket);
	
	var _language = __webpack_require__(237);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _password = __webpack_require__(240);
	
	var _password2 = _interopRequireDefault(_password);
	
	var _elastic = __webpack_require__(241);
	
	var _elastic2 = _interopRequireDefault(_elastic);
	
	var _modal = __webpack_require__(242);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _wanted = __webpack_require__(244);
	
	var _wanted2 = _interopRequireDefault(_wanted);
	
	__webpack_require__(248);
	
	__webpack_require__(250);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_angular2.default.module("dalApp", [_angularAnimate2.default, _angularCookies2.default, _angularResource2.default, _angularSanitize2.default, "btford.socket-io", _angularUiRouter2.default, _angularUiBootstrap2.default, _auth2.default, _account2.default, _admin2.default, _author2.default, _directDrMemberAuthors2.default, _permission2.default, _permission4.default, "validation.match", _navbar2.default, _footer2.default, _main2.default, _app3.default, _socket2.default, _util2.default, _angularGettext2.default, _angularLocalStorage2.default, _language2.default, _elastic2.default, _modal2.default, "matchMedia", "lr.upload", "isteven-multi-select", _password2.default, _files2.default, _wanted2.default]).config(_app.routeConfig).run(['$rootScope', '$location', 'Auth', 'gettextCatalog', '$http', 'LanguageService', function ($rootScope, $location, Auth, gettextCatalog, $http, LanguageService) {
	  "ngInject";
	
	  gettextCatalog.debug = true;
	  gettextCatalog.debugPrefix = "[A traduire] ";
	
	  $http({
	    method: "GET",
	    url: "assets/translations/template.json",
	    cache: gettextCatalog.cache,
	    transformResponse: function transformResponse(json) {
	      return JSON.parse(json);
	    }
	  }).then(function (results) {
	    var data = results.data || {};
	    for (var l in data) {
	      if (data.hasOwnProperty(l)) {
	        gettextCatalog.setStrings(l, data[l]);
	      }
	    }
	
	    LanguageService.init();
	    var dismissText = void 0;
	    var linkText = void 0;
	    var message = void 0;
	    if (LanguageService.lang == "fr") {
	      dismissText = "J'ai compris";
	      linkText = "En savoir plus";
	      message = "Notre site internet utilise des cookies, afin d'améliorer votre expérience lorsque vous naviguez sur notre site.";
	    } else {
	      dismissText = "Got it!";
	      linkText = "Learn more";
	      message = "This website uses cookies to ensure you get the best experience on our website.";
	    }
	
	    window.cookieconsent.initialise({
	      cookie: {
	        expiryDays: 365
	      },
	      palette: {
	        popup: {
	          background: "#343c66"
	        },
	        button: {
	          background: "#be0f38"
	        }
	      },
	      theme: "classic",
	      position: "bottom-right",
	      content: {
	        dismiss: dismissText,
	        link: linkText,
	        message: message,
	        href: "/legal"
	      },
	      blacklistPage: ["/wanted", "/direct-dr-member-authors"]
	    });
	  });
	
	  $rootScope.$on("$stateChangeStart", function (event, next) {
	    Auth.isLoggedIn(function (loggedIn) {
	      if (next.authenticate && !loggedIn) {
	        $location.path("/main");
	      }
	    });
	  });
	}]);
	
	_angular2.default.element(document).ready(function () {
	  _angular2.default.bootstrap(document, ["dalApp"], {
	    strictDi: true
	  });
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(12);
	module.exports = 'gettext';


/***/ }),
/* 12 */
/***/ (function(module, exports) {

	/**
	 * @ngdoc module
	 * @name gettext
	 * @packageName angular-gettext
	 * @description Super simple Gettext for Angular.JS
	 *
	 * A sample application can be found at https://github.com/rubenv/angular-gettext-example.
	 * This is an adaptation of the [TodoMVC](http://todomvc.com/) example. You can use this as a guideline while adding {@link angular-gettext angular-gettext} to your own application.
	 */
	/**
	 * @ngdoc factory
	 * @module gettext
	 * @name gettextPlurals
	 * @param {String} [langCode=en] language code
	 * @param {Number} [n=0] number to calculate form for
	 * @returns {Number} plural form number
	 * @description Provides correct plural form id for the given language
	 *
	 * Example
	 * ```js
	 * gettextPlurals('ru', 10); // 1
	 * gettextPlurals('en', 1);  // 0
	 * gettextPlurals();         // 1
	 * ```
	 */
	angular.module('gettext', []);
	/**
	 * @ngdoc object
	 * @module gettext
	 * @name gettext
	 * @kind function
	 * @param {String} str annotation key
	 * @description Gettext constant function for annotating strings
	 *
	 * ```js
	 * angular.module('myApp', ['gettext']).config(function(gettext) {
	 *   /// MyApp document title
	 *   gettext('my-app.title');
	 *   ...
	 * })
	 * ```
	 */
	angular.module('gettext').constant('gettext', function (str) {
	    /*
	     * Does nothing, simply returns the input string.
	     *
	     * This function serves as a marker for `grunt-angular-gettext` to know that
	     * this string should be extracted for translations.
	     */
	    return str;
	});
	
	/**
	 * @ngdoc service
	 * @module gettext
	 * @name gettextCatalog
	 * @requires gettextPlurals
	 * @requires gettextFallbackLanguage
	 * @requires https://docs.angularjs.org/api/ng/service/$http $http
	 * @requires https://docs.angularjs.org/api/ng/service/$cacheFactory $cacheFactory
	 * @requires https://docs.angularjs.org/api/ng/service/$interpolate $interpolate
	 * @requires https://docs.angularjs.org/api/ng/service/$rootScope $rootScope
	 * @description Provides set of method to translate stings
	 */
	angular.module('gettext').factory('gettextCatalog', ["gettextPlurals", "gettextFallbackLanguage", "$http", "$cacheFactory", "$interpolate", "$rootScope", function (gettextPlurals, gettextFallbackLanguage, $http, $cacheFactory, $interpolate, $rootScope) {
	    var catalog;
	    var noContext = '$$noContext';
	
	    // IE8 returns UPPER CASE tags, even though the source is lower case.
	    // This can causes the (key) string in the DOM to have a different case to
	    // the string in the `po` files.
	    // IE9, IE10 and IE11 reorders the attributes of tags.
	    var test = '<span id="test" title="test" class="tested">test</span>';
	    var isHTMLModified = (angular.element('<span>' + test + '</span>').html() !== test);
	
	    var prefixDebug = function (string) {
	        if (catalog.debug && catalog.currentLanguage !== catalog.baseLanguage) {
	            return catalog.debugPrefix + string;
	        } else {
	            return string;
	        }
	    };
	
	    var addTranslatedMarkers = function (string) {
	        if (catalog.showTranslatedMarkers) {
	            return catalog.translatedMarkerPrefix + string + catalog.translatedMarkerSuffix;
	        } else {
	            return string;
	        }
	    };
	
	    function broadcastUpdated() {
	        /**
	         * @ngdoc event
	         * @name gettextCatalog#gettextLanguageChanged
	         * @eventType broadcast on $rootScope
	         * @description Fires language change notification without any additional parameters.
	         */
	        $rootScope.$broadcast('gettextLanguageChanged');
	    }
	
	    catalog = {
	        /**
	         * @ngdoc property
	         * @name gettextCatalog#debug
	         * @public
	         * @type {Boolean} false
	         * @see gettextCatalog#debug
	         * @description Whether or not to prefix untranslated strings with `[MISSING]:` or a custom prefix.
	         */
	        debug: false,
	        /**
	         * @ngdoc property
	         * @name gettextCatalog#debugPrefix
	         * @public
	         * @type {String} [MISSING]:
	         * @description Custom prefix for untranslated strings when {@link gettextCatalog#debug gettextCatalog#debug} set to `true`.
	         */
	        debugPrefix: '[MISSING]: ',
	        /**
	         * @ngdoc property
	         * @name gettextCatalog#showTranslatedMarkers
	         * @public
	         * @type {Boolean} false
	         * @description Whether or not to wrap all processed text with markers.
	         *
	         * Example output: `[Welcome]`
	         */
	        showTranslatedMarkers: false,
	        /**
	         * @ngdoc property
	         * @name gettextCatalog#translatedMarkerPrefix
	         * @public
	         * @type {String} [
	         * @description Custom prefix to mark strings that have been run through {@link angular-gettext angular-gettext}.
	         */
	        translatedMarkerPrefix: '[',
	        /**
	         * @ngdoc property
	         * @name gettextCatalog#translatedMarkerSuffix
	         * @public
	         * @type {String} ]
	         * @description Custom suffix to mark strings that have been run through {@link angular-gettext angular-gettext}.
	         */
	        translatedMarkerSuffix: ']',
	        /**
	         * @ngdoc property
	         * @name gettextCatalog#strings
	         * @private
	         * @type {Object}
	         * @description An object of loaded translation strings. Shouldn't be used directly.
	         */
	        strings: {},
	        /**
	         * @ngdoc property
	         * @name gettextCatalog#baseLanguage
	         * @protected
	         * @deprecated
	         * @since 2.0
	         * @type {String} en
	         * @description The default language, in which you're application is written.
	         *
	         * This defaults to English and it's generally a bad idea to use anything else:
	         * if your language has different pluralization rules you'll end up with incorrect translations.
	         */
	        baseLanguage: 'en',
	        /**
	         * @ngdoc property
	         * @name gettextCatalog#currentLanguage
	         * @public
	         * @type {String}
	         * @description Active language.
	         */
	        currentLanguage: 'en',
	        /**
	         * @ngdoc property
	         * @name gettextCatalog#cache
	         * @public
	         * @type {String} en
	         * @description Language cache for lazy load
	         */
	        cache: $cacheFactory('strings'),
	
	        /**
	         * @ngdoc method
	         * @name gettextCatalog#setCurrentLanguage
	         * @public
	         * @param {String} lang language name
	         * @description Sets the current language and makes sure that all translations get updated correctly.
	         */
	        setCurrentLanguage: function (lang) {
	            this.currentLanguage = lang;
	            broadcastUpdated();
	        },
	
	        /**
	         * @ngdoc method
	         * @name gettextCatalog#getCurrentLanguage
	         * @public
	         * @returns {String} current language
	         * @description Returns the current language.
	         */
	        getCurrentLanguage: function () {
	            return this.currentLanguage;
	        },
	
	        /**
	         * @ngdoc method
	         * @name gettextCatalog#setStrings
	         * @public
	         * @param {String} language language name
	         * @param {Object.<String>} strings set of strings where the key is the translation `key` and `value` is the translated text
	         * @description Processes an object of string definitions. {@link guide:manual-setstrings More details here}.
	         */
	        setStrings: function (language, strings) {
	            if (!this.strings[language]) {
	                this.strings[language] = {};
	            }
	
	            var defaultPlural = gettextPlurals(language, 1);
	            for (var key in strings) {
	                var val = strings[key];
	
	                if (isHTMLModified) {
	                    // Use the DOM engine to render any HTML in the key (#131).
	                    key = angular.element('<span>' + key + '</span>').html();
	                }
	
	                if (angular.isString(val) || angular.isArray(val)) {
	                    // No context, wrap it in $$noContext.
	                    var obj = {};
	                    obj[noContext] = val;
	                    val = obj;
	                }
	
	                if (!this.strings[language][key]) {
	                    this.strings[language][key] = {};
	                }
	
	                for (var context in val) {
	                    var str = val[context];
	                    if (!angular.isArray(str)) {
	                        // Expand single strings
	                        this.strings[language][key][context] = [];
	                        this.strings[language][key][context][defaultPlural] = str;
	                    } else {
	                        this.strings[language][key][context] = str;
	                    }
	                }
	            }
	
	            broadcastUpdated();
	        },
	
	        /**
	         * @ngdoc method
	         * @name gettextCatalog#getStringFormFor
	         * @protected
	         * @param {String} language language name
	         * @param {String} string translation key
	         * @param {Number=} n number to build sting form for
	         * @param {String=} context translation key context, e.g. {@link doc:context Verb, Noun}
	         * @returns {String|Null} translated or annotated string or null if language is not set
	         * @description Translate a string with the given language, count and context.
	         */
	        getStringFormFor: function (language, string, n, context) {
	            if (!language) {
	                return null;
	            }
	            var stringTable = this.strings[language] || {};
	            var contexts = stringTable[string] || {};
	            var plurals = contexts[context || noContext] || [];
	            return plurals[gettextPlurals(language, n)];
	        },
	
	        /**
	         * @ngdoc method
	         * @name gettextCatalog#getString
	         * @public
	         * @param {String} string translation key
	         * @param {$rootScope.Scope=} scope scope to do interpolation against
	         * @param {String=} context translation key context, e.g. {@link doc:context Verb, Noun}
	         * @returns {String} translated or annotated string
	         * @description Translate a string with the given scope and context.
	         *
	         * First it tries {@link gettextCatalog#currentLanguage gettextCatalog#currentLanguage} (e.g. `en-US`) then {@link gettextFallbackLanguage fallback} (e.g. `en`).
	         *
	         * When `scope` is supplied it uses Angular.JS interpolation, so something like this will do what you expect:
	         * ```js
	         * var hello = gettextCatalog.getString("Hello {{name}}!", { name: "Ruben" });
	         * // var hello will be "Hallo Ruben!" in Dutch.
	         * ```
	         * Avoid using scopes - this skips interpolation and is a lot faster.
	         */
	        getString: function (string, scope, context) {
	            var fallbackLanguage = gettextFallbackLanguage(this.currentLanguage);
	            string = this.getStringFormFor(this.currentLanguage, string, 1, context) ||
	                     this.getStringFormFor(fallbackLanguage, string, 1, context) ||
	                     prefixDebug(string);
	            string = scope ? $interpolate(string)(scope) : string;
	            return addTranslatedMarkers(string);
	        },
	
	        /**
	         * @ngdoc method
	         * @name gettextCatalog#getPlural
	         * @public
	         * @param {Number} n number to build sting form for
	         * @param {String} string translation key
	         * @param {String} stringPlural plural translation key
	         * @param {$rootScope.Scope=} scope scope to do interpolation against
	         * @param {String=} context translation key context, e.g. {@link doc:context Verb, Noun}
	         * @returns {String} translated or annotated string
	         * @see {@link gettextCatalog#getString gettextCatalog#getString} for details
	         * @description Translate a plural string with the given context.
	         */
	        getPlural: function (n, string, stringPlural, scope, context) {
	            var fallbackLanguage = gettextFallbackLanguage(this.currentLanguage);
	            string = this.getStringFormFor(this.currentLanguage, string, n, context) ||
	                     this.getStringFormFor(fallbackLanguage, string, n, context) ||
	                     prefixDebug(n === 1 ? string : stringPlural);
	            if (scope) {
	                scope.$count = n;
	                string = $interpolate(string)(scope);
	            }
	            return addTranslatedMarkers(string);
	        },
	
	        /**
	         * @ngdoc method
	         * @name gettextCatalog#loadRemote
	         * @public
	         * @param {String} url location of the translations
	         * @description Load a set of translation strings from a given URL.
	         *
	         * This should be a JSON catalog generated with [angular-gettext-tools](https://github.com/rubenv/angular-gettext-tools).
	         * {@link guide:lazy-loading More details here}.
	         */
	        loadRemote: function (url) {
	            return $http({
	                method: 'GET',
	                url: url,
	                cache: catalog.cache
	            }).then(function (response) {
	                var data = response.data;
	                for (var lang in data) {
	                    catalog.setStrings(lang, data[lang]);
	                }
	                return response;
	            });
	        }
	    };
	
	    return catalog;
	}]);
	
	/**
	 * @ngdoc directive
	 * @module gettext
	 * @name translate
	 * @requires gettextCatalog
	 * @requires gettextUtil
	 * @requires https://docs.angularjs.org/api/ng/service/$parse $parse
	 * @requires https://docs.angularjs.org/api/ng/service/$animate $animate
	 * @requires https://docs.angularjs.org/api/ng/service/$compile $compile
	 * @requires https://docs.angularjs.org/api/ng/service/$window $window
	 * @restrict AE
	 * @param {String} [translatePlural] plural form
	 * @param {Number} translateN value to watch to substitute correct plural form
	 * @param {String} translateContext context value, e.g. {@link doc:context Verb, Noun}
	 * @description Annotates and translates text inside directive
	 *
	 * Full interpolation support is available in translated strings, so the following will work as expected:
	 * ```js
	 * <div translate>Hello {{name}}!</div>
	 * ```
	 *
	 * You can also use custom context parameters while interpolating. This approach allows usage
	 * of angular filters as well as custom logic inside your translated messages without unnecessary impact on translations.
	 *
	 * So for example when you have message like this:
	 * ```js
	 * <div translate>Last modified {{modificationDate | date:'yyyy-MM-dd HH:mm:ss Z'}} by {{author}}.</div>
	 * ```
	 * you will have it extracted in exact same version so it would look like this:
	 * `Last modified {{modificationDate | date:'yyyy-MM-dd HH:mm:ss Z'}} by {{author}}`.
	 * To start with it might be too complicated to read and handle by non technical translator. It's easy to make mistake
	 * when copying format for example. Secondly if you decide to change format by some point of the project translation will broke
	 * as it won't be the same string anymore.
	 *
	 * Instead your translator should only be concerned to place {{modificationDate}} correctly and you should have a free hand
	 * to modify implementation details on how to present the results. This is how you can achieve the goal:
	 * ```js
	 * <div translate translate-params-modification-date="modificationDate | date:'yyyy-MM-dd HH:mm:ss Z'">Last modified {{modificationDate}} by {{author}}.</div>
	 * ```
	 *
	 * There's a few more things worth to point out:
	 * 1. You can use as many parameters as you want. Each parameter begins with `translate-params-` followed by snake-case parameter name.
	 * Each parameter will be available for interpolation in camelCase manner (just like angular directive works by default).
	 * ```js
	 * <div translate translate-params-my-custom-param="param1" translate-params-name="name">Param {{myCustomParam}} has been changed by {{name}}.</div>
	 * ```
	 * 2. You can rename your variables from current scope to simple ones if you like.
	 * ```js
	 * <div translate translate-params-date="veryUnintuitiveNameForDate">Today's date is: {{date}}.</div>
	 * ```
	 * 3. You can use translate-params only for some interpolations. Rest would be treated as usual.
	 * ```js
	 * <div translate translate-params-cost="cost | currency">This product: {{product}} costs {{cost}}.</div>
	 * ```
	 */
	angular.module('gettext').directive('translate', ["gettextCatalog", "$parse", "$animate", "$compile", "$window", "gettextUtil", function (gettextCatalog, $parse, $animate, $compile, $window, gettextUtil) {
	    var msie = parseInt((/msie (\d+)/.exec(angular.lowercase($window.navigator.userAgent)) || [])[1], 10);
	    var PARAMS_PREFIX = 'translateParams';
	
	    function getCtxAttr(key) {
	        return gettextUtil.lcFirst(key.replace(PARAMS_PREFIX, ''));
	    }
	
	    function handleInterpolationContext(scope, attrs, update) {
	        var attributes = Object.keys(attrs).filter(function (key) {
	            return gettextUtil.startsWith(key, PARAMS_PREFIX) && key !== PARAMS_PREFIX;
	        });
	
	        if (!attributes.length) {
	            return null;
	        }
	
	        var interpolationContext = angular.extend({}, scope);
	        var unwatchers = [];
	        attributes.forEach(function (attribute) {
	            var unwatch = scope.$watch(attrs[attribute], function (newVal) {
	                var key = getCtxAttr(attribute);
	                interpolationContext[key] = newVal;
	                update(interpolationContext);
	            });
	            unwatchers.push(unwatch);
	        });
	        scope.$on('$destroy', function () {
	            unwatchers.forEach(function (unwatch) {
	                unwatch();
	            });
	        });
	        return interpolationContext;
	    }
	
	    return {
	        restrict: 'AE',
	        terminal: true,
	        compile: function compile(element, attrs) {
	            // Validate attributes
	            gettextUtil.assert(!attrs.translatePlural || attrs.translateN, 'translate-n', 'translate-plural');
	            gettextUtil.assert(!attrs.translateN || attrs.translatePlural, 'translate-plural', 'translate-n');
	
	            var msgid = gettextUtil.trim(element.html());
	            var translatePlural = attrs.translatePlural;
	            var translateContext = attrs.translateContext;
	
	            if (msie <= 8) {
	                // Workaround fix relating to angular adding a comment node to
	                // anchors. angular/angular.js/#1949 / angular/angular.js/#2013
	                if (msgid.slice(-13) === '<!--IE fix-->') {
	                    msgid = msgid.slice(0, -13);
	                }
	            }
	
	            return {
	                post: function (scope, element, attrs) {
	                    var countFn = $parse(attrs.translateN);
	                    var pluralScope = null;
	                    var linking = true;
	
	                    function update(interpolationContext) {
	                        interpolationContext = interpolationContext || null;
	
	                        // Fetch correct translated string.
	                        var translated;
	                        if (translatePlural) {
	                            scope = pluralScope || (pluralScope = scope.$new());
	                            scope.$count = countFn(scope);
	                            translated = gettextCatalog.getPlural(scope.$count, msgid, translatePlural, interpolationContext, translateContext);
	                        } else {
	                            translated = gettextCatalog.getString(msgid, interpolationContext, translateContext);
	                        }
	                        var oldContents = element.contents();
	
	                        if (!oldContents && !translated){
	                            return;
	                        }
	
	                        // Avoid redundant swaps
	                        if (translated === gettextUtil.trim(oldContents.html())){
	                            // Take care of unlinked content
	                            if (linking){
	                                $compile(oldContents)(scope);
	                            }
	                            return;
	                        }
	
	                        // Swap in the translation
	                        var newWrapper = angular.element('<span>' + translated + '</span>');
	                        $compile(newWrapper.contents())(scope);
	                        var newContents = newWrapper.contents();
	
	                        $animate.enter(newContents, element);
	                        $animate.leave(oldContents);
	                    }
	
	                    var interpolationContext = handleInterpolationContext(scope, attrs, update);
	                    update(interpolationContext);
	                    linking = false;
	
	                    if (attrs.translateN) {
	                        scope.$watch(attrs.translateN, function () {
	                            update(interpolationContext);
	                        });
	                    }
	
	                    /**
	                     * @ngdoc event
	                     * @name translate#gettextLanguageChanged
	                     * @eventType listen on scope
	                     * @description Listens for language updates and changes translation accordingly
	                     */
	                    scope.$on('gettextLanguageChanged', function () {
	                        update(interpolationContext);
	                    });
	
	                }
	            };
	        }
	    };
	}]);
	
	/**
	 * @ngdoc factory
	 * @module gettext
	 * @name gettextFallbackLanguage
	 * @param {String} langCode language code
	 * @returns {String|Null} fallback language
	 * @description Strips regional code and returns language code only
	 *
	 * Example
	 * ```js
	 * gettextFallbackLanguage('ru');     // "null"
	 * gettextFallbackLanguage('en_GB');  // "en"
	 * gettextFallbackLanguage();         // null
	 * ```
	 */
	angular.module("gettext").factory("gettextFallbackLanguage", function () {
	    var cache = {};
	    var pattern = /([^_]+)_[^_]+$/;
	
	    return function (langCode) {
	        if (cache[langCode]) {
	            return cache[langCode];
	        }
	
	        var matches = pattern.exec(langCode);
	        if (matches) {
	            cache[langCode] = matches[1];
	            return matches[1];
	        }
	
	        return null;
	    };
	});
	/**
	 * @ngdoc filter
	 * @module gettext
	 * @name translate
	 * @requires gettextCatalog
	 * @param {String} input translation key
	 * @param {String} context context to evaluate key against
	 * @returns {String} translated string or annotated key
	 * @see {@link doc:context Verb, Noun}
	 * @description Takes key and returns string
	 *
	 * Sometimes it's not an option to use an attribute (e.g. when you want to annotate an attribute value).
	 * There's a `translate` filter available for this purpose.
	 *
	 * ```html
	 * <input type="text" placeholder="{{'Username'|translate}}" />
	 * ```
	 * This filter does not support plural strings.
	 *
	 * You may want to use {@link guide:custom-annotations custom annotations} to avoid using the `translate` filter all the time. * Is
	 */
	angular.module('gettext').filter('translate', ["gettextCatalog", function (gettextCatalog) {
	    function filter(input, context) {
	        return gettextCatalog.getString(input, null, context);
	    }
	    filter.$stateful = true;
	    return filter;
	}]);
	
	// Do not edit this file, it is autogenerated using genplurals.py!
	angular.module("gettext").factory("gettextPlurals", function () {
	    var languageCodes = {
	        "pt_BR": "pt_BR",
	        "pt-BR": "pt_BR"
	    };
	    return function (langCode, n) {
	        switch (getLanguageCode(langCode)) {
	            case "ay":  // Aymará
	            case "bo":  // Tibetan
	            case "cgg": // Chiga
	            case "dz":  // Dzongkha
	            case "fa":  // Persian
	            case "id":  // Indonesian
	            case "ja":  // Japanese
	            case "jbo": // Lojban
	            case "ka":  // Georgian
	            case "kk":  // Kazakh
	            case "km":  // Khmer
	            case "ko":  // Korean
	            case "ky":  // Kyrgyz
	            case "lo":  // Lao
	            case "ms":  // Malay
	            case "my":  // Burmese
	            case "sah": // Yakut
	            case "su":  // Sundanese
	            case "th":  // Thai
	            case "tt":  // Tatar
	            case "ug":  // Uyghur
	            case "vi":  // Vietnamese
	            case "wo":  // Wolof
	            case "zh":  // Chinese
	                // 1 form
	                return 0;
	            case "is":  // Icelandic
	                // 2 forms
	                return (n%10!=1 || n%100==11) ? 1 : 0;
	            case "jv":  // Javanese
	                // 2 forms
	                return n!=0 ? 1 : 0;
	            case "mk":  // Macedonian
	                // 2 forms
	                return n==1 || n%10==1 ? 0 : 1;
	            case "ach": // Acholi
	            case "ak":  // Akan
	            case "am":  // Amharic
	            case "arn": // Mapudungun
	            case "br":  // Breton
	            case "fil": // Filipino
	            case "fr":  // French
	            case "gun": // Gun
	            case "ln":  // Lingala
	            case "mfe": // Mauritian Creole
	            case "mg":  // Malagasy
	            case "mi":  // Maori
	            case "oc":  // Occitan
	            case "pt_BR":  // Brazilian Portuguese
	            case "tg":  // Tajik
	            case "ti":  // Tigrinya
	            case "tr":  // Turkish
	            case "uz":  // Uzbek
	            case "wa":  // Walloon
	            case "zh":  // Chinese
	                // 2 forms
	                return n>1 ? 1 : 0;
	            case "lv":  // Latvian
	                // 3 forms
	                return (n%10==1 && n%100!=11 ? 0 : n != 0 ? 1 : 2);
	            case "lt":  // Lithuanian
	                // 3 forms
	                return (n%10==1 && n%100!=11 ? 0 : n%10>=2 && (n%100<10 || n%100>=20) ? 1 : 2);
	            case "be":  // Belarusian
	            case "bs":  // Bosnian
	            case "hr":  // Croatian
	            case "ru":  // Russian
	            case "sr":  // Serbian
	            case "uk":  // Ukrainian
	                // 3 forms
	                return (n%10==1 && n%100!=11 ? 0 : n%10>=2 && n%10<=4 && (n%100<10 || n%100>=20) ? 1 : 2);
	            case "mnk": // Mandinka
	                // 3 forms
	                return (n==0 ? 0 : n==1 ? 1 : 2);
	            case "ro":  // Romanian
	                // 3 forms
	                return (n==1 ? 0 : (n==0 || (n%100 > 0 && n%100 < 20)) ? 1 : 2);
	            case "pl":  // Polish
	                // 3 forms
	                return (n==1 ? 0 : n%10>=2 && n%10<=4 && (n%100<10 || n%100>=20) ? 1 : 2);
	            case "cs":  // Czech
	            case "sk":  // Slovak
	                // 3 forms
	                return (n==1) ? 0 : (n>=2 && n<=4) ? 1 : 2;
	            case "sl":  // Slovenian
	                // 4 forms
	                return (n%100==1 ? 1 : n%100==2 ? 2 : n%100==3 || n%100==4 ? 3 : 0);
	            case "mt":  // Maltese
	                // 4 forms
	                return (n==1 ? 0 : n==0 || ( n%100>1 && n%100<11) ? 1 : (n%100>10 && n%100<20 ) ? 2 : 3);
	            case "gd":  // Scottish Gaelic
	                // 4 forms
	                return (n==1 || n==11) ? 0 : (n==2 || n==12) ? 1 : (n > 2 && n < 20) ? 2 : 3;
	            case "cy":  // Welsh
	                // 4 forms
	                return (n==1) ? 0 : (n==2) ? 1 : (n != 8 && n != 11) ? 2 : 3;
	            case "kw":  // Cornish
	                // 4 forms
	                return (n==1) ? 0 : (n==2) ? 1 : (n == 3) ? 2 : 3;
	            case "ga":  // Irish
	                // 5 forms
	                return n==1 ? 0 : n==2 ? 1 : n<7 ? 2 : n<11 ? 3 : 4;
	            case "ar":  // Arabic
	                // 6 forms
	                return (n==0 ? 0 : n==1 ? 1 : n==2 ? 2 : n%100>=3 && n%100<=10 ? 3 : n%100>=11 ? 4 : 5);
	            default: // Everything else
	                return n != 1 ? 1 : 0;
	        }
	    };
	
	    /**
	     * Method extracts iso639-2 language code from code with locale e.g. pl_PL, en_US, etc.
	     * If it's provided with standalone iso639-2 language code it simply returns it.
	     * @param {String} langCode
	     * @returns {String} iso639-2 language Code
	     */
	    function getLanguageCode(langCode) {
	        if (!languageCodes[langCode]) {
	            languageCodes[langCode] = langCode.split(/\-|_/).shift();
	        }
	        return languageCodes[langCode];
	    }
	});
	
	/**
	 * @ngdoc factory
	 * @module gettext
	 * @name gettextUtil
	 * @description Utility service for common operations and polyfills.
	 */
	angular.module('gettext').factory('gettextUtil', function gettextUtil() {
	    /**
	     * @ngdoc method
	     * @name gettextUtil#trim
	     * @public
	     * @param {string} value String to be trimmed.
	     * @description Trim polyfill for old browsers (instead of jQuery). Based on AngularJS-v1.2.2 (angular.js#620).
	     *
	     * Example
	     * ```js
	     * gettextUtil.assert('  no blanks  '); // "no blanks"
	     * ```
	     */
	    var trim = (function () {
	        if (!String.prototype.trim) {
	            return function (value) {
	                return (typeof value === 'string') ? value.replace(/^\s*/, '').replace(/\s*$/, '') : value;
	            };
	        }
	        return function (value) {
	            return (typeof value === 'string') ? value.trim() : value;
	        };
	    })();
	
	    /**
	     * @ngdoc method
	     * @name gettextUtil#assert
	     * @public
	     * @param {bool} condition condition to check
	     * @param {String} missing name of the directive missing attribute
	     * @param {String} found name of attribute that has been used with directive
	     * @description Throws error if condition is not met, which means that directive was used with certain parameter
	     * that requires another one (which is missing).
	     *
	     * Example
	     * ```js
	     * gettextUtil.assert(!attrs.translatePlural || attrs.translateN, 'translate-n', 'translate-plural');
	     * //You should add a translate-n attribute whenever you add a translate-plural attribute.
	     * ```
	     */
	    function assert(condition, missing, found) {
	        if (!condition) {
	            throw new Error('You should add a ' + missing + ' attribute whenever you add a ' + found + ' attribute.');
	        }
	    }
	
	    /**
	     * @ngdoc method
	     * @name gettextUtil#startsWith
	     * @public
	     * @param {string} target String on which checking will occur.
	     * @param {string} query String expected to be at the beginning of target.
	     * @returns {boolean} Returns true if object has no ownProperties. For arrays returns true if length == 0.
	     * @description Checks if string starts with another string.
	     *
	     * Example
	     * ```js
	     * gettextUtil.startsWith('Home sweet home.', 'Home'); //true
	     * gettextUtil.startsWith('Home sweet home.', 'sweet'); //false
	     * ```
	     */
	    function startsWith(target, query) {
	        return target.indexOf(query) === 0;
	    }
	
	    /**
	     * @ngdoc method
	     * @name gettextUtil#lcFirst
	     * @public
	     * @param {string} target String to transform.
	     * @returns {string} Strings beginning with lowercase letter.
	     * @description Makes first letter of the string lower case
	     *
	     * Example
	     * ```js
	     * gettextUtil.lcFirst('Home Sweet Home.'); //'home Sweet Home'
	     * gettextUtil.lcFirst('ShouldBeCamelCase.'); //'shouldBeCamelCase'
	     * ```
	     */
	    function lcFirst(target) {
	        var first = target.charAt(0).toLowerCase();
	        return first + target.substr(1);
	    }
	
	    return {
	        trim: trim,
	        assert: assert,
	        startsWith: startsWith,
	        lcFirst: lcFirst
	    };
	});


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(14);
	module.exports = 'LocalStorageModule';


/***/ }),
/* 14 */
/***/ (function(module, exports) {

	/**
	 * An Angular module that gives you access to the browsers local storage
	 * @version v0.6.0 - 2017-05-18
	 * @link https://github.com/grevory/angular-local-storage
	 * @author grevory <greg@gregpike.ca>
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	(function (window, angular) {
	var isDefined = angular.isDefined,
	  isUndefined = angular.isUndefined,
	  isNumber = angular.isNumber,
	  isObject = angular.isObject,
	  isArray = angular.isArray,
	  isString = angular.isString,
	  extend = angular.extend,
	  toJson = angular.toJson;
	
	angular
	  .module('LocalStorageModule', [])
	  .provider('localStorageService', function() {
	    // You should set a prefix to avoid overwriting any local storage variables from the rest of your app
	    // e.g. localStorageServiceProvider.setPrefix('yourAppName');
	    // With provider you can use config as this:
	    // myApp.config(function (localStorageServiceProvider) {
	    //    localStorageServiceProvider.prefix = 'yourAppName';
	    // });
	    this.prefix = 'ls';
	
	    // You could change web storage type localstorage or sessionStorage
	    this.storageType = 'localStorage';
	
	    // Cookie options (usually in case of fallback)
	    // expiry = Number of days before cookies expire // 0 = Does not expire
	    // path = The web path the cookie represents
	    // secure = Wether the cookies should be secure (i.e only sent on HTTPS requests)
	    this.cookie = {
	      expiry: 30,
	      path: '/',
	      secure: false
	    };
	
	    // Decides wether we should default to cookies if localstorage is not supported.
	    this.defaultToCookie = true;
	
	    // Send signals for each of the following actions?
	    this.notify = {
	      setItem: true,
	      removeItem: false
	    };
	
	    // Setter for the prefix
	    this.setPrefix = function(prefix) {
	      this.prefix = prefix;
	      return this;
	    };
	
	    // Setter for the storageType
	    this.setStorageType = function(storageType) {
	      this.storageType = storageType;
	      return this;
	    };
	    // Setter for defaultToCookie value, default is true.
	    this.setDefaultToCookie = function (shouldDefault) {
	      this.defaultToCookie = !!shouldDefault; // Double-not to make sure it's a bool value.
	      return this;
	    };
	    // Setter for cookie config
	    this.setStorageCookie = function(exp, path, secure) {
	      this.cookie.expiry = exp;
	      this.cookie.path = path;
	      this.cookie.secure = secure;
	      return this;
	    };
	
	    // Setter for cookie domain
	    this.setStorageCookieDomain = function(domain) {
	      this.cookie.domain = domain;
	      return this;
	    };
	
	    // Setter for notification config
	    // itemSet & itemRemove should be booleans
	    this.setNotify = function(itemSet, itemRemove) {
	      this.notify = {
	        setItem: itemSet,
	        removeItem: itemRemove
	      };
	      return this;
	    };
	
	    this.$get = ['$rootScope', '$window', '$document', '$parse','$timeout', function($rootScope, $window, $document, $parse, $timeout) {
	      var self = this;
	      var prefix = self.prefix;
	      var cookie = self.cookie;
	      var notify = self.notify;
	      var storageType = self.storageType;
	      var webStorage;
	
	      // When Angular's $document is not available
	      if (!$document) {
	        $document = document;
	      } else if ($document[0]) {
	        $document = $document[0];
	      }
	
	      // If there is a prefix set in the config lets use that with an appended period for readability
	      if (prefix.substr(-1) !== '.') {
	        prefix = !!prefix ? prefix + '.' : '';
	      }
	      var deriveQualifiedKey = function(key) {
	        return prefix + key;
	      };
	
	      // Removes prefix from the key.
	      var underiveQualifiedKey = function (key) {
	        return key.replace(new RegExp('^' + prefix, 'g'), '');
	      };
	
	      // Check if the key is within our prefix namespace.
	      var isKeyPrefixOurs = function (key) {
	        return key.indexOf(prefix) === 0;
	      };
	
	      // Checks the browser to see if local storage is supported
	      var checkSupport = function () {
	        try {
	          var supported = (storageType in $window && $window[storageType] !== null);
	
	          // When Safari (OS X or iOS) is in private browsing mode, it appears as though localStorage
	          // is available, but trying to call .setItem throws an exception.
	          //
	          // "QUOTA_EXCEEDED_ERR: DOM Exception 22: An attempt was made to add something to storage
	          // that exceeded the quota."
	          var key = deriveQualifiedKey('__' + Math.round(Math.random() * 1e7));
	          if (supported) {
	            webStorage = $window[storageType];
	            webStorage.setItem(key, '');
	            webStorage.removeItem(key);
	          }
	
	          return supported;
	        } catch (e) {
	          // Only change storageType to cookies if defaulting is enabled.
	          if (self.defaultToCookie)
	            storageType = 'cookie';
	          $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
	          return false;
	        }
	      };
	      var browserSupportsLocalStorage = checkSupport();
	
	      // Directly adds a value to local storage
	      // If local storage is not available in the browser use cookies
	      // Example use: localStorageService.add('library','angular');
	      var addToLocalStorage = function (key, value, type) {
	        var previousType = getStorageType();
	
	        try {
	          setStorageType(type);
	
	          // Let's convert undefined values to null to get the value consistent
	          if (isUndefined(value)) {
	            value = null;
	          } else {
	            value = toJson(value);
	          }
	
	          // If this browser does not support local storage use cookies
	          if (!browserSupportsLocalStorage && self.defaultToCookie || self.storageType === 'cookie') {
	            if (!browserSupportsLocalStorage) {
	              $rootScope.$broadcast('LocalStorageModule.notification.warning', 'LOCAL_STORAGE_NOT_SUPPORTED');
	            }
	
	            if (notify.setItem) {
	              $rootScope.$broadcast('LocalStorageModule.notification.setitem', {key: key, newvalue: value, storageType: 'cookie'});
	            }
	            return addToCookies(key, value);
	          }
	
	          try {
	            if (webStorage) {
	              webStorage.setItem(deriveQualifiedKey(key), value);
	            }
	            if (notify.setItem) {
	              $rootScope.$broadcast('LocalStorageModule.notification.setitem', {key: key, newvalue: value, storageType: self.storageType});
	            }
	          } catch (e) {
	            $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
	            return addToCookies(key, value);
	          }
	          return true;
	        } finally {
	          setStorageType(previousType);
	        }
	      };
	
	      // Directly get a value from local storage
	      // Example use: localStorageService.get('library'); // returns 'angular'
	      var getFromLocalStorage = function (key, type) {
	        var previousType = getStorageType();
	
	        try {
	          setStorageType(type);
	
	          if (!browserSupportsLocalStorage && self.defaultToCookie  || self.storageType === 'cookie') {
	            if (!browserSupportsLocalStorage) {
	              $rootScope.$broadcast('LocalStorageModule.notification.warning', 'LOCAL_STORAGE_NOT_SUPPORTED');
	            }
	
	            return getFromCookies(key);
	          }
	
	          var item = webStorage ? webStorage.getItem(deriveQualifiedKey(key)) : null;
	          // angular.toJson will convert null to 'null', so a proper conversion is needed
	          // FIXME not a perfect solution, since a valid 'null' string can't be stored
	          if (!item || item === 'null') {
	            return null;
	          }
	
	          try {
	            return JSON.parse(item);
	          } catch (e) {
	            return item;
	          }
	        } finally {
	          setStorageType(previousType);
	        }
	      };
	
	      // Remove an item from local storage
	      // Example use: localStorageService.remove('library'); // removes the key/value pair of library='angular'
	      //
	      // This is var-arg removal, check the last argument to see if it is a storageType
	      // and set type accordingly before removing.
	      //
	      var removeFromLocalStorage = function () {
	        var previousType = getStorageType();
	
	        try {
	          // can't pop on arguments, so we do this
	          var consumed = 0;
	          if (arguments.length >= 1 &&
	              (arguments[arguments.length - 1] === 'localStorage' ||
	               arguments[arguments.length - 1] === 'sessionStorage')) {
	            consumed = 1;
	            setStorageType(arguments[arguments.length - 1]);
	          }
	
	          var i, key;
	          for (i = 0; i < arguments.length - consumed; i++) {
	            key = arguments[i];
	            if (!browserSupportsLocalStorage && self.defaultToCookie || self.storageType === 'cookie') {
	              if (!browserSupportsLocalStorage) {
	                $rootScope.$broadcast('LocalStorageModule.notification.warning', 'LOCAL_STORAGE_NOT_SUPPORTED');
	              }
	
	              if (notify.removeItem) {
	                $rootScope.$broadcast('LocalStorageModule.notification.removeitem', {key: key, storageType: 'cookie'});
	              }
	              removeFromCookies(key);
	            }
	            else {
	              try {
	                webStorage.removeItem(deriveQualifiedKey(key));
	                if (notify.removeItem) {
	                  $rootScope.$broadcast('LocalStorageModule.notification.removeitem', {
	                    key: key,
	                    storageType: self.storageType
	                  });
	                }
	              } catch (e) {
	                $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
	                removeFromCookies(key);
	              }
	            }
	          }
	        } finally {
	          setStorageType(previousType);
	        }
	      };
	
	      // Return array of keys for local storage
	      // Example use: var keys = localStorageService.keys()
	      var getKeysForLocalStorage = function (type) {
	        var previousType = getStorageType();
	
	        try {
	          setStorageType(type);
	
	          if (!browserSupportsLocalStorage) {
	            $rootScope.$broadcast('LocalStorageModule.notification.warning', 'LOCAL_STORAGE_NOT_SUPPORTED');
	            return [];
	          }
	
	          var prefixLength = prefix.length;
	          var keys = [];
	          for (var key in webStorage) {
	            // Only return keys that are for this app
	            if (key.substr(0, prefixLength) === prefix) {
	              try {
	                keys.push(key.substr(prefixLength));
	              } catch (e) {
	                $rootScope.$broadcast('LocalStorageModule.notification.error', e.Description);
	                return [];
	              }
	            }
	          }
	
	          return keys;
	        } finally {
	          setStorageType(previousType);
	        }
	      };
	
	      // Remove all data for this app from local storage
	      // Also optionally takes a regular expression string and removes the matching key-value pairs
	      // Example use: localStorageService.clearAll();
	      // Should be used mostly for development purposes
	      var clearAllFromLocalStorage = function (regularExpression, type) {
	        var previousType = getStorageType();
	
	        try {
	          setStorageType(type);
	
	          // Setting both regular expressions independently
	          // Empty strings result in catchall RegExp
	          var prefixRegex = !!prefix ? new RegExp('^' + prefix) : new RegExp();
	          var testRegex = !!regularExpression ? new RegExp(regularExpression) : new RegExp();
	
	          if (!browserSupportsLocalStorage && self.defaultToCookie  || self.storageType === 'cookie') {
	            if (!browserSupportsLocalStorage) {
	              $rootScope.$broadcast('LocalStorageModule.notification.warning', 'LOCAL_STORAGE_NOT_SUPPORTED');
	            }
	            return clearAllFromCookies();
	          }
	          if (!browserSupportsLocalStorage && !self.defaultToCookie)
	            return false;
	          var prefixLength = prefix.length;
	
	          for (var key in webStorage) {
	            // Only remove items that are for this app and match the regular expression
	            if (prefixRegex.test(key) && testRegex.test(key.substr(prefixLength))) {
	              try {
	                removeFromLocalStorage(key.substr(prefixLength));
	              } catch (e) {
	                $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
	                return clearAllFromCookies();
	              }
	            }
	          }
	
	          return true;
	        } finally {
	          setStorageType(previousType);
	        }
	      };
	
	      // Checks the browser to see if cookies are supported
	      var browserSupportsCookies = (function() {
	        try {
	          return $window.navigator.cookieEnabled ||
	          ("cookie" in $document && ($document.cookie.length > 0 ||
	            ($document.cookie = "test").indexOf.call($document.cookie, "test") > -1));
	          } catch (e) {
	            $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
	            return false;
	          }
	        }());
	
	        // Directly adds a value to cookies
	        // Typically used as a fallback if local storage is not available in the browser
	        // Example use: localStorageService.cookie.add('library','angular');
	        var addToCookies = function (key, value, daysToExpiry, secure) {
	
	          if (isUndefined(value)) {
	            return false;
	          } else if(isArray(value) || isObject(value)) {
	            value = toJson(value);
	          }
	
	          if (!browserSupportsCookies) {
	            $rootScope.$broadcast('LocalStorageModule.notification.error', 'COOKIES_NOT_SUPPORTED');
	            return false;
	          }
	
	          try {
	            var expiry = '',
	            expiryDate = new Date(),
	            cookieDomain = '';
	
	            if (value === null) {
	              // Mark that the cookie has expired one day ago
	              expiryDate.setTime(expiryDate.getTime() + (-1 * 24 * 60 * 60 * 1000));
	              expiry = "; expires=" + expiryDate.toGMTString();
	              value = '';
	            } else if (isNumber(daysToExpiry) && daysToExpiry !== 0) {
	              expiryDate.setTime(expiryDate.getTime() + (daysToExpiry * 24 * 60 * 60 * 1000));
	              expiry = "; expires=" + expiryDate.toGMTString();
	            } else if (cookie.expiry !== 0) {
	              expiryDate.setTime(expiryDate.getTime() + (cookie.expiry * 24 * 60 * 60 * 1000));
	              expiry = "; expires=" + expiryDate.toGMTString();
	            }
	            if (!!key) {
	              var cookiePath = "; path=" + cookie.path;
	              if (cookie.domain) {
	                cookieDomain = "; domain=" + cookie.domain;
	              }
	              /* Providing the secure parameter always takes precedence over config
	               * (allows developer to mix and match secure + non-secure) */
	              if (typeof secure === 'boolean') {
	                  if (secure === true) {
	                      /* We've explicitly specified secure,
	                       * add the secure attribute to the cookie (after domain) */
	                      cookieDomain += "; secure";
	                  }
	                  // else - secure has been supplied but isn't true - so don't set secure flag, regardless of what config says
	              }
	              else if (cookie.secure === true) {
	                  // secure parameter wasn't specified, get default from config
	                  cookieDomain += "; secure";
	              }
	              $document.cookie = deriveQualifiedKey(key) + "=" + encodeURIComponent(value) + expiry + cookiePath + cookieDomain;
	            }
	          } catch (e) {
	            $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
	            return false;
	          }
	          return true;
	        };
	
	        // Directly get a value from a cookie
	        // Example use: localStorageService.cookie.get('library'); // returns 'angular'
	        var getFromCookies = function (key) {
	          if (!browserSupportsCookies) {
	            $rootScope.$broadcast('LocalStorageModule.notification.error', 'COOKIES_NOT_SUPPORTED');
	            return false;
	          }
	
	          var cookies = $document.cookie && $document.cookie.split(';') || [];
	          for(var i=0; i < cookies.length; i++) {
	            var thisCookie = cookies[i];
	            while (thisCookie.charAt(0) === ' ') {
	              thisCookie = thisCookie.substring(1,thisCookie.length);
	            }
	            if (thisCookie.indexOf(deriveQualifiedKey(key) + '=') === 0) {
	              var storedValues = decodeURIComponent(thisCookie.substring(prefix.length + key.length + 1, thisCookie.length));
	              try {
	                var parsedValue = JSON.parse(storedValues);
	                return typeof(parsedValue) === 'number' ? storedValues : parsedValue;
	              } catch(e) {
	                return storedValues;
	              }
	            }
	          }
	          return null;
	        };
	
	        var removeFromCookies = function (key) {
	          addToCookies(key,null);
	        };
	
	        var clearAllFromCookies = function () {
	          var thisCookie = null;
	          var prefixLength = prefix.length;
	          var cookies = $document.cookie.split(';');
	          for(var i = 0; i < cookies.length; i++) {
	            thisCookie = cookies[i];
	
	            while (thisCookie.charAt(0) === ' ') {
	              thisCookie = thisCookie.substring(1, thisCookie.length);
	            }
	
	            var key = thisCookie.substring(prefixLength, thisCookie.indexOf('='));
	            removeFromCookies(key);
	          }
	        };
	
	        var getStorageType = function() {
	          return storageType;
	        };
	
	        var setStorageType = function(type) {
	          if (type && storageType !== type) {
	            storageType = type;
	            browserSupportsLocalStorage = checkSupport();
	          }
	          return browserSupportsLocalStorage;
	        };
	
	        // Add a listener on scope variable to save its changes to local storage
	        // Return a function which when called cancels binding
	        var bindToScope = function(scope, key, def, lsKey, type) {
	          lsKey = lsKey || key;
	          var value = getFromLocalStorage(lsKey, type);
	
	          if (value === null && isDefined(def)) {
	            value = def;
	          } else if (isObject(value) && isObject(def)) {
	            value = extend(value, def);
	          }
	
	          $parse(key).assign(scope, value);
	
	          return scope.$watch(key, function(newVal) {
	            addToLocalStorage(lsKey, newVal, type);
	          }, isObject(scope[key]));
	        };
	
	        // Add listener to local storage, for update callbacks.
	        if (browserSupportsLocalStorage) {
	            if ($window.addEventListener) {
	                $window.addEventListener("storage", handleStorageChangeCallback, false);
	                $rootScope.$on('$destroy', function() {
	                    $window.removeEventListener("storage", handleStorageChangeCallback);
	                });
	            } else if($window.attachEvent){
	                // attachEvent and detachEvent are proprietary to IE v6-10
	                $window.attachEvent("onstorage", handleStorageChangeCallback);
	                $rootScope.$on('$destroy', function() {
	                    $window.detachEvent("onstorage", handleStorageChangeCallback);
	                });
	            }
	        }
	
	        // Callback handler for storage changed.
	        function handleStorageChangeCallback(e) {
	            if (!e) { e = $window.event; }
	            if (notify.setItem) {
	                if (isString(e.key) && isKeyPrefixOurs(e.key)) {
	                    var key = underiveQualifiedKey(e.key);
	                    // Use timeout, to avoid using $rootScope.$apply.
	                    $timeout(function () {
	                        $rootScope.$broadcast('LocalStorageModule.notification.changed', { key: key, newvalue: e.newValue, storageType: self.storageType });
	                    });
	                }
	            }
	        }
	
	        // Return localStorageService.length
	        // ignore keys that not owned
	        var lengthOfLocalStorage = function(type) {
	          var previousType = getStorageType();
	
	          try {
	            setStorageType(type);
	
	            var count = 0;
	            var storage = $window[storageType];
	            for(var i = 0; i < storage.length; i++) {
	              if(storage.key(i).indexOf(prefix) === 0 ) {
	                count++;
	              }
	            }
	            
	            return count;
	          } finally {
	            setStorageType(previousType);
	          }
	        };
	
	        return {
	          isSupported: browserSupportsLocalStorage,
	          getStorageType: getStorageType,
	          setStorageType: setStorageType,
	          set: addToLocalStorage,
	          add: addToLocalStorage, //DEPRECATED
	          get: getFromLocalStorage,
	          keys: getKeysForLocalStorage,
	          remove: removeFromLocalStorage,
	          clearAll: clearAllFromLocalStorage,
	          bind: bindToScope,
	          deriveKey: deriveQualifiedKey,
	          underiveKey: underiveQualifiedKey,
	          length: lengthOfLocalStorage,
	          defaultToCookie: this.defaultToCookie,
	          cookie: {
	            isSupported: browserSupportsCookies,
	            set: addToCookies,
	            add: addToCookies, //DEPRECATED
	            get: getFromCookies,
	            remove: removeFromCookies,
	            clearAll: clearAllFromCookies
	          }
	        };
	      }];
	  });
	})(window, window.angular);

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	(function () {
	  'use strict';
	
	  /*
	   * Angular matchMedia Module
	   * Version 0.6.0
	   * Uses Bootstrap 3 breakpoint sizes
	   * Exposes service "screenSize" which returns true if breakpoint(s) matches.
	   * Includes matchMedia polyfill for backward compatibility.
	   * Copyright © Jack Tarantino <https://jack.ofspades.com>.
	   **/
	
	
	  var app = angular.module('matchMedia', []);
	
	
	  app.run(function initializeNgMatchMedia() {
	    /*! matchMedia() polyfill - Test a CSS media type/query in JS.
	     * Authors & copyright (c) 2012: Scott Jehl, Paul Irish, Nicholas Zakas, David Knight.
	     * Dual MIT/BSD license
	     **/
	
	    window.matchMedia || (window.matchMedia = function matchMediaPolyfill() {
	
	      // For browsers that support matchMedium api such as IE 9 and webkit
	      var styleMedia = (window.styleMedia || window.media);
	
	      // For those that don't support matchMedium
	      if (!styleMedia) {
	        var style = document.createElement('style'),
	          script = document.getElementsByTagName('script')[0],
	          info = null;
	
	        style.type = 'text/css';
	        style.id = 'matchmediajs-test';
	
	        script.parentNode.insertBefore(style, script);
	
	        // 'style.currentStyle' is used by IE <= 8
	        // 'window.getComputedStyle' for all other browsers
	        info = ('getComputedStyle' in window) && window.getComputedStyle(style, null) || style.currentStyle;
	
	        styleMedia = {
	          matchMedium: function (media) {
	            var text = '@media ' + media + '{ #matchmediajs-test { width: 1px; } }';
	
	            // 'style.styleSheet' is used by IE <= 8
	            // 'style.textContent' for all other browsers
	            if (style.styleSheet) {
	              style.styleSheet.cssText = text;
	            } else {
	              style.textContent = text;
	            }
	
	            // Test if media query is true or false
	            return info.width === '1px';
	          }
	        };
	      }
	
	      return function (media) {
	        return {
	          matches: styleMedia.matchMedium(media || 'all'),
	          media: media || 'all'
	        };
	      };
	    }());
	  });
	
	  //Service to use in controllers
	  app.service('screenSize', screenSize);
	
	  screenSize.$inject = ['$rootScope'];
	
	  function screenSize($rootScope) {
	
	    var defaultRules = {
	      lg: '(min-width: 1200px)',
	      md: '(min-width: 992px) and (max-width: 1199px)',
	      sm: '(min-width: 768px) and (max-width: 991px)',
	      xs: '(max-width: 767px)'
	    };
	
	    this.isRetina = (
	    	window.devicePixelRatio > 1 ||
	    	(window.matchMedia && window.matchMedia('(-webkit-min-device-pixel-ratio: 1.5),(-moz-min-device-pixel-ratio: 1.5),(min-device-pixel-ratio: 1.5),(min-resolution: 192dpi),(min-resolution: 2dppx)').matches)
	    );
	
	    var that = this;
	
	    // Executes Angular $apply in a safe way
	    var safeApply = function (fn, scope) {
	      scope = scope || $rootScope;
	      var phase = scope.$root.$$phase;
	      if (phase === '$apply' || phase === '$digest') {
	        if (fn && (typeof (fn) === 'function')) {
	          fn();
	        }
	      } else {
	        scope.$apply(fn);
	      }
	    };
	
	    // Validates that we're getting a string or array.
	    // When string: converts string(comma seperated) to an array.
	    var assureList = function (list) {
	
	      if (typeof list !== 'string' && Object.prototype.toString.call(list) !== '[object Array]') {
	        throw new Error('screenSize requires array or comma-separated list');
	      }
	
	      return typeof list === 'string' ? list.split(/\s*,\s*/) : list;
	    };
	
	    var getCurrentMatch = function () {
	      var rules = that.rules || defaultRules;
	
	      for (var property in rules) {
	        if (rules.hasOwnProperty(property)) {
	          if (window.matchMedia(rules[property]).matches) {
	            return property;
	          }
	        }
	      }
	    };
	    
	    // Return the actual size (it's string name defined in the rules)
	    this.get = getCurrentMatch;
	
	    this.is = function (list) {
	      list = assureList(list);
	      return list.indexOf(getCurrentMatch()) !== -1;
	    };
	
	    // Executes the callback function on window resize with the match truthiness as the first argument.
	    // Returns the current match truthiness.
	    // The 'scope' parameter is optional. If it's not passed in, '$rootScope' is used.
	    this.on = function (list, callback, scope) {
	      window.addEventListener('resize', listenerFunc);
	
	      if (scope) {
	        scope.$on('$destroy', function () {
	          window.removeEventListener('resize', listenerFunc);
	        });
	      }
	
	      return that.is(list);
	
	      function listenerFunc() {
	        safeApply(callback(that.is(list)), scope);
	      }
	    };
	
	    // Executes the callback function ONLY when the match differs from previous match.
	    // Returns the current match truthiness.
	    // The 'scope' parameter is required for cleanup reasons (destroy event).
	    this.onChange = function (scope, list, callback) {
	      var currentMatch = getCurrentMatch();
	      list = assureList(list);
	      if (!scope) {
	        throw 'scope has to be applied for cleanup reasons. (destroy)';
	      }
	
	      window.addEventListener('resize', listenerFunc);
	
	      scope.$on('$destroy', function () {
	        window.removeEventListener('resize', listenerFunc);
	      });
	
	      return that.is(list);
	
	      function listenerFunc() {
	        var previousMatch = currentMatch;
	        currentMatch = getCurrentMatch();
	
	        var wasPreviousMatch = list.indexOf(previousMatch) !== -1;
	        var doesCurrentMatch = list.indexOf(currentMatch) !== -1;
	        if (wasPreviousMatch !== doesCurrentMatch) {
	          safeApply(callback(doesCurrentMatch), scope);
	        }
	      }
	    };
	
	    // Executes the callback only when inside of the particular screensize.
	    // The 'scope' parameter is optional. If it's not passed in, '$rootScope' is used.
	    this.when = function (list, callback, scope) {
	      window.addEventListener('resize', function () {
	        if (that.is(list) === true) {
	          safeApply(callback(that.is(list)), scope);
	        }
	      });
	
	      return that.is(list);
	    };
	  }
	
	  app.filter('media', ['screenSize', function (screenSize) {
	
	    var mediaFilter = function (inputValue, options) {
	      // Get actual size
	      var size = screenSize.get();
	
	      // Variable for the value being return (either a size/rule name or a group name)
	      var returnedName = '';
	
	      if (!options) {
	        // Return the size/rule name
	        return size;
	      }
	
	      // Replace placeholder with group name in input value
	      if (options.groups) {
	        for (var prop in options.groups) {
	          if (options.groups.hasOwnProperty(prop)) {
	            var index = options.groups[prop].indexOf(size);
	            if (index >= 0) {
	              returnedName = prop;
	            }
	          }
	        }
	
	        // If no group name is found for size use the size itself
	        if (returnedName === '') {
	          returnedName = size;
	        }
	      }
	
	      // Replace or return size/rule name?
	      if (options.replace && typeof options.replace === 'string' && options.replace.length > 0) {
	        return inputValue.replace(options.replace, returnedName);
	      } else {
	        return returnedName;
	      }
	    };
	
	    // Since AngularJS 1.3, filters which are not stateless (depending at the scope)
	    // have to explicit define this behavior.
	    mediaFilter.$stateful = true;
	    return mediaFilter;
	  }]);
	
	})();


/***/ }),
/* 16 */
/***/ (function(module, exports) {

	/* 
	 * Angular JS Multi Select
	 * Creates a dropdown-like button with checkboxes. 
	 *
	 * Project started on: Tue, 14 Jan 2014 - 5:18:02 PM
	 * Current version: 4.0.0
	 * 
	 * Released under the MIT License
	 * --------------------------------------------------------------------------------
	 * The MIT License (MIT)
	 *
	 * Copyright (c) 2014 Ignatius Steven (https://github.com/isteven)
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy 
	 * of this software and associated documentation files (the "Software"), to deal 
	 * in the Software without restriction, including without limitation the rights 
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell 
	 * copies of the Software, and to permit persons to whom the Software is 
	 * furnished to do so, subject to the following conditions: 
	 *
	 * The above copyright notice and this permission notice shall be included in all 
	 * copies or substantial portions of the Software.
	 * 
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR 
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, 
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE 
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER 
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, 
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE 
	 * SOFTWARE.
	 * --------------------------------------------------------------------------------
	 */
	
	'use strict'
	
	angular.module( 'isteven-multi-select', ['ng'] ).directive( 'istevenMultiSelect' , [ '$sce', '$timeout', '$templateCache', function ( $sce, $timeout, $templateCache ) {
	    return {
	        restrict: 
	            'AE',
	
	        scope: 
	        {   
	            // models
	            inputModel      : '=',
	            outputModel     : '=',
	
	            // settings based on attribute
	            isDisabled      : '=',
	
	            // callbacks
	            onClear         : '&',  
	            onClose         : '&',
	            onSearchChange  : '&',  
	            onItemClick     : '&',            
	            onOpen          : '&', 
	            onReset         : '&',  
	            onSelectAll     : '&',  
	            onSelectNone    : '&',  
	
	            // i18n
	            translation     : '='   
	        },
	        
	        /* 
	         * The rest are attributes. They don't need to be parsed / binded, so we can safely access them by value.
	         * - buttonLabel, directiveId, helperElements, itemLabel, maxLabels, orientation, selectionMode, minSearchLength,
	         *   tickProperty, disableProperty, groupProperty, searchProperty, maxHeight, outputProperties
	         */
	                                                         
	         templateUrl: 
	            'isteven-multi-select.htm',                            
	
	        link: function ( $scope, element, attrs ) {                       
	
	            $scope.backUp           = [];
	            $scope.varButtonLabel   = '';               
	            $scope.spacingProperty  = '';
	            $scope.indexProperty    = '';                        
	            $scope.orientationH     = false;
	            $scope.orientationV     = true;
	            $scope.filteredModel    = [];
	            $scope.inputLabel       = { labelFilter: '' };                        
	            $scope.tabIndex         = 0;            
	            $scope.lang             = {};
	            $scope.helperStatus     = {
	                all     : true,
	                none    : true,
	                reset   : true,
	                filter  : true
	            };
	
	            var 
	                prevTabIndex        = 0,
	                helperItems         = [],
	                helperItemsLength   = 0,
	                checkBoxLayer       = '',
	                scrolled            = false,
	                selectedItems       = [],
	                formElements        = [],
	                vMinSearchLength    = 0,
	                clickedItem         = null                
	
	            // v3.0.0
	            // clear button clicked
	            $scope.clearClicked = function( e ) {                
	                $scope.inputLabel.labelFilter = '';
	                $scope.updateFilter();
	                $scope.select( 'clear', e );                
	            }
	
	            // A little hack so that AngularJS ng-repeat can loop using start and end index like a normal loop
	            // http://stackoverflow.com/questions/16824853/way-to-ng-repeat-defined-number-of-times-instead-of-repeating-over-array
	            $scope.numberToArray = function( num ) {
	                return new Array( num );   
	            }
	
	            // Call this function when user type on the filter field
	            $scope.searchChanged = function() {                                                
	                if ( $scope.inputLabel.labelFilter.length < vMinSearchLength && $scope.inputLabel.labelFilter.length > 0 ) {
	                    return false;
	                }                
	                $scope.updateFilter();
	            }
	
	            $scope.updateFilter = function()
	            {      
	                // we check by looping from end of input-model
	                $scope.filteredModel = [];
	                var i = 0;
	
	                if ( typeof $scope.inputModel === 'undefined' ) {
	                    return false;                   
	                }
	
	                for( i = $scope.inputModel.length - 1; i >= 0; i-- ) {
	
	                    // if it's group end, we push it to filteredModel[];
	                    if ( typeof $scope.inputModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.inputModel[ i ][ attrs.groupProperty ] === false ) {
	                        $scope.filteredModel.push( $scope.inputModel[ i ] );
	                    }
	                    
	                    // if it's data 
	                    var gotData = false;
	                    if ( typeof $scope.inputModel[ i ][ attrs.groupProperty ] === 'undefined' ) {                        
	                        
	                        // If we set the search-key attribute, we use this loop. 
	                        if ( typeof attrs.searchProperty !== 'undefined' && attrs.searchProperty !== '' ) {
	
	                            for (var key in $scope.inputModel[ i ]  ) {
	                                if ( 
	                                    typeof $scope.inputModel[ i ][ key ] !== 'boolean'
	                                    && String( $scope.inputModel[ i ][ key ] ).toUpperCase().indexOf( $scope.inputLabel.labelFilter.toUpperCase() ) >= 0                                     
	                                    && attrs.searchProperty.indexOf( key ) > -1
	                                ) {
	                                    gotData = true;
	                                    break;
	                                }
	                            }                        
	                        }
	                        // if there's no search-key attribute, we use this one. Much better on performance.
	                        else {
	                            for ( var key in $scope.inputModel[ i ]  ) {
	                                if ( 
	                                    typeof $scope.inputModel[ i ][ key ] !== 'boolean'
	                                    && String( $scope.inputModel[ i ][ key ] ).toUpperCase().indexOf( $scope.inputLabel.labelFilter.toUpperCase() ) >= 0                                     
	                                ) {
	                                    gotData = true;
	                                    break;
	                                }
	                            }                        
	                        }
	
	                        if ( gotData === true ) {    
	                            // push
	                            $scope.filteredModel.push( $scope.inputModel[ i ] );
	                        }
	                    }
	
	                    // if it's group start
	                    if ( typeof $scope.inputModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.inputModel[ i ][ attrs.groupProperty ] === true ) {
	
	                        if ( typeof $scope.filteredModel[ $scope.filteredModel.length - 1 ][ attrs.groupProperty ] !== 'undefined' 
	                                && $scope.filteredModel[ $scope.filteredModel.length - 1 ][ attrs.groupProperty ] === false ) {
	                            $scope.filteredModel.pop();
	                        }
	                        else {
	                            $scope.filteredModel.push( $scope.inputModel[ i ] );
	                        }
	                    }
	                }                
	
	                $scope.filteredModel.reverse();  
	                
	                $timeout( function() {                    
	
	                    $scope.getFormElements();               
	                    
	                    // Callback: on filter change                      
	                    if ( $scope.inputLabel.labelFilter.length > vMinSearchLength ) {
	
	                        var filterObj = [];
	
	                        angular.forEach( $scope.filteredModel, function( value, key ) {
	                            if ( typeof value !== 'undefined' ) {                   
	                                if ( typeof value[ attrs.groupProperty ] === 'undefined' ) {                                                                    
	                                    var tempObj = angular.copy( value );
	                                    var index = filterObj.push( tempObj );                                
	                                    delete filterObj[ index - 1 ][ $scope.indexProperty ];
	                                    delete filterObj[ index - 1 ][ $scope.spacingProperty ];      
	                                }
	                            }
	                        });
	
	                        $scope.onSearchChange({ 
	                            data: 
	                            {
	                                keyword: $scope.inputLabel.labelFilter, 
	                                result: filterObj 
	                            } 
	                        });
	                    }
	                },0);
	            };
	
	            // List all the input elements. We need this for our keyboard navigation.
	            // This function will be called everytime the filter is updated. 
	            // Depending on the size of filtered mode, might not good for performance, but oh well..
	            $scope.getFormElements = function() {                                     
	                formElements = [];
	
	                var 
	                    selectButtons   = [],
	                    inputField      = [],
	                    checkboxes      = [],
	                    clearButton     = [];
	                
	                // If available, then get select all, select none, and reset buttons
	                if ( $scope.helperStatus.all || $scope.helperStatus.none || $scope.helperStatus.reset ) {                                                       
	                    selectButtons = element.children().children().next().children().children()[ 0 ].getElementsByTagName( 'button' );                    
	                    // If available, then get the search box and the clear button
	                    if ( $scope.helperStatus.filter ) {                                            
	                        // Get helper - search and clear button. 
	                        inputField =    element.children().children().next().children().children().next()[ 0 ].getElementsByTagName( 'input' );                    
	                        clearButton =   element.children().children().next().children().children().next()[ 0 ].getElementsByTagName( 'button' );                        
	                    }
	                }
	                else {
	                    if ( $scope.helperStatus.filter ) {   
	                        // Get helper - search and clear button. 
	                        inputField =    element.children().children().next().children().children()[ 0 ].getElementsByTagName( 'input' );                    
	                        clearButton =   element.children().children().next().children().children()[ 0 ].getElementsByTagName( 'button' );
	                    }
	                }
	               
	                // Get checkboxes
	                if ( !$scope.helperStatus.all && !$scope.helperStatus.none && !$scope.helperStatus.reset && !$scope.helperStatus.filter ) {
	                    checkboxes = element.children().children().next()[ 0 ].getElementsByTagName( 'input' );
	                }
	                else {
	                    checkboxes = element.children().children().next().children().next()[ 0 ].getElementsByTagName( 'input' );
	                }
	
	                // Push them into global array formElements[] 
	                for ( var i = 0; i < selectButtons.length ; i++ )   { formElements.push( selectButtons[ i ] );  }
	                for ( var i = 0; i < inputField.length ; i++ )      { formElements.push( inputField[ i ] );     }
	                for ( var i = 0; i < clearButton.length ; i++ )     { formElements.push( clearButton[ i ] );    }
	                for ( var i = 0; i < checkboxes.length ; i++ )      { formElements.push( checkboxes[ i ] );     }                                
	            }            
	
	            // check if an item has attrs.groupProperty (be it true or false)
	            $scope.isGroupMarker = function( item , type ) {
	                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === type ) return true; 
	                return false;
	            }
	
	            $scope.removeGroupEndMarker = function( item ) {
	                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === false ) return false; 
	                return true;
	            }                       
	
	            // call this function when an item is clicked
	            $scope.syncItems = function( item, e, ng_repeat_index ) {                                      
	
	                e.preventDefault();
	                e.stopPropagation();
	
	                // if the directive is globaly disabled, do nothing
	                if ( typeof attrs.disableProperty !== 'undefined' && item[ attrs.disableProperty ] === true ) {                                        
	                    return false;
	                }
	
	                // if item is disabled, do nothing
	                if ( typeof attrs.isDisabled !== 'undefined' && $scope.isDisabled === true ) {                        
	                    return false;
	                }                                
	
	                // if end group marker is clicked, do nothing
	                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === false ) {
	                    return false;
	                }                
	
	                var index = $scope.filteredModel.indexOf( item );       
	
	                // if the start of group marker is clicked ( only for multiple selection! )
	                // how it works:
	                // - if, in a group, there are items which are not selected, then they all will be selected
	                // - if, in a group, all items are selected, then they all will be de-selected                
	                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === true ) {                                  
	
	                    // this is only for multiple selection, so if selection mode is single, do nothing
	                    if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' ) {
	                        return false;
	                    }
	                    
	                    var i,j,k;
	                    var startIndex = 0;
	                    var endIndex = $scope.filteredModel.length - 1;
	                    var tempArr = [];
	
	                    // nest level is to mark the depth of the group.
	                    // when you get into a group (start group marker), nestLevel++
	                    // when you exit a group (end group marker), nextLevel--
	                    var nestLevel = 0;                    
	
	                    // we loop throughout the filtered model (not whole model)
	                    for( i = index ; i < $scope.filteredModel.length ; i++) {  
	
	                        // this break will be executed when we're done processing each group
	                        if ( nestLevel === 0 && i > index ) 
	                        {
	                            break;
	                        }
	                    
	                        if ( typeof $scope.filteredModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.filteredModel[ i ][ attrs.groupProperty ] === true ) {
	                            
	                            // To cater multi level grouping
	                            if ( tempArr.length === 0 ) {
	                                startIndex = i + 1; 
	                            }                            
	                            nestLevel = nestLevel + 1;
	                        }                                                
	
	                        // if group end
	                        else if ( typeof $scope.filteredModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.filteredModel[ i ][ attrs.groupProperty ] === false ) {
	
	                            nestLevel = nestLevel - 1;                            
	
	                            // cek if all are ticked or not                            
	                            if ( tempArr.length > 0 && nestLevel === 0 ) {                                
	
	                                var allTicked = true;       
	
	                                endIndex = i;
	
	                                for ( j = 0; j < tempArr.length ; j++ ) {                                
	                                    if ( typeof tempArr[ j ][ $scope.tickProperty ] !== 'undefined' &&  tempArr[ j ][ $scope.tickProperty ] === false ) {
	                                        allTicked = false;
	                                        break;
	                                    }
	                                }                                                                                    
	
	                                if ( allTicked === true ) {
	                                    for ( j = startIndex; j <= endIndex ; j++ ) {
	                                        if ( typeof $scope.filteredModel[ j ][ attrs.groupProperty ] === 'undefined' ) {
	                                            if ( typeof attrs.disableProperty === 'undefined' ) {
	                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = false;
	                                                // we refresh input model as well
	                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
	                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = false;
	                                            }
	                                            else if ( $scope.filteredModel[ j ][ attrs.disableProperty ] !== true ) {
	                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = false;
	                                                // we refresh input model as well
	                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
	                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = false;
	                                            }
	                                        }
	                                    }                                
	                                }
	
	                                else {
	                                    for ( j = startIndex; j <= endIndex ; j++ ) {
	                                        if ( typeof $scope.filteredModel[ j ][ attrs.groupProperty ] === 'undefined' ) {
	                                            if ( typeof attrs.disableProperty === 'undefined' ) {
	                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = true;                                                
	                                                // we refresh input model as well
	                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
	                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = true;
	
	                                            }                                            
	                                            else if ( $scope.filteredModel[ j ][ attrs.disableProperty ] !== true ) {
	                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = true;
	                                                // we refresh input model as well
	                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
	                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = true;
	                                            }
	                                        }
	                                    }                                
	                                }                                                                                    
	                            }
	                        }
	            
	                        // if data
	                        else {                            
	                            tempArr.push( $scope.filteredModel[ i ] );                                                                                    
	                        }
	                    }                                 
	                }
	
	                // if an item (not group marker) is clicked
	                else {
	
	                    // If it's single selection mode
	                    if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' ) {
	                        
	                        // first, set everything to false
	                        for( i=0 ; i < $scope.filteredModel.length ; i++) {                            
	                            $scope.filteredModel[ i ][ $scope.tickProperty ] = false;                            
	                        }        
	                        for( i=0 ; i < $scope.inputModel.length ; i++) {                            
	                            $scope.inputModel[ i ][ $scope.tickProperty ] = false;                            
	                        }        
	                        
	                        // then set the clicked item to true
	                        $scope.filteredModel[ index ][ $scope.tickProperty ] = true;                                                                 
	                    }   
	
	                    // Multiple
	                    else {
	                        $scope.filteredModel[ index ][ $scope.tickProperty ]   = !$scope.filteredModel[ index ][ $scope.tickProperty ];
	                    }
	
	                    // we refresh input model as well
	                    var inputModelIndex = $scope.filteredModel[ index ][ $scope.indexProperty ];                                        
	                    $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = $scope.filteredModel[ index ][ $scope.tickProperty ];                    
	                }                                  
	
	                // we execute the callback function here
	                clickedItem = angular.copy( item );                                                    
	                if ( clickedItem !== null ) {                        
	                    $timeout( function() {
	                        delete clickedItem[ $scope.indexProperty ];
	                        delete clickedItem[ $scope.spacingProperty ];      
	                        $scope.onItemClick( { data: clickedItem } );
	                        clickedItem = null;                    
	                    }, 0 );                                                 
	                }                                    
	                
	                $scope.refreshOutputModel();
	                $scope.refreshButton();                              
	
	                // We update the index here
	                prevTabIndex = $scope.tabIndex;
	                $scope.tabIndex = ng_repeat_index + helperItemsLength;
	                                
	                // Set focus on the hidden checkbox 
	                e.target.focus();
	
	                // set & remove CSS style
	                $scope.removeFocusStyle( prevTabIndex );
	                $scope.setFocusStyle( $scope.tabIndex );
	
	                if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' ) {
	                    // on single selection mode, we then hide the checkbox layer
	                    $scope.toggleCheckboxes( e );       
	                }
	            }     
	
	            // update $scope.outputModel
	            $scope.refreshOutputModel = function() {            
	                
	                $scope.outputModel  = [];
	                var 
	                    outputProps     = [],
	                    tempObj         = {};
	
	                // v4.0.0
	                if ( typeof attrs.outputProperties !== 'undefined' ) {                    
	                    outputProps = attrs.outputProperties.split(' ');                
	                    angular.forEach( $scope.inputModel, function( value, key ) {                    
	                        if ( 
	                            typeof value !== 'undefined' 
	                            && typeof value[ attrs.groupProperty ] === 'undefined' 
	                            && value[ $scope.tickProperty ] === true 
	                        ) {
	                            tempObj         = {};
	                            angular.forEach( value, function( value1, key1 ) {                                
	                                if ( outputProps.indexOf( key1 ) > -1 ) {                                                                         
	                                    tempObj[ key1 ] = value1;                                    
	                                }
	                            });
	                            var index = $scope.outputModel.push( tempObj );                                                               
	                            delete $scope.outputModel[ index - 1 ][ $scope.indexProperty ];
	                            delete $scope.outputModel[ index - 1 ][ $scope.spacingProperty ];                                      
	                        }
	                    });         
	                }
	                else {
	                    angular.forEach( $scope.inputModel, function( value, key ) {                    
	                        if ( 
	                            typeof value !== 'undefined' 
	                            && typeof value[ attrs.groupProperty ] === 'undefined' 
	                            && value[ $scope.tickProperty ] === true 
	                        ) {
	                            var temp = angular.copy( value );
	                            var index = $scope.outputModel.push( temp );                                                               
	                            delete $scope.outputModel[ index - 1 ][ $scope.indexProperty ];
	                            delete $scope.outputModel[ index - 1 ][ $scope.spacingProperty ];                                      
	                        }
	                    });         
	                }
	            }
	
	            // refresh button label
	            $scope.refreshButton = function() {
	
	                $scope.varButtonLabel   = '';                
	                var ctr                 = 0;                  
	
	                // refresh button label...
	                if ( $scope.outputModel.length === 0 ) {
	                    // https://github.com/isteven/angular-multi-select/pull/19                    
	                    $scope.varButtonLabel = $scope.lang.nothingSelected;
	                }
	                else {                
	                    var tempMaxLabels = $scope.outputModel.length;
	                    if ( typeof attrs.maxLabels !== 'undefined' && attrs.maxLabels !== '' ) {
	                        tempMaxLabels = attrs.maxLabels;
	                    }
	
	                    // if max amount of labels displayed..
	                    if ( $scope.outputModel.length > tempMaxLabels ) {
	                        $scope.more = true;
	                    }
	                    else {
	                        $scope.more = false;
	                    }                
	                    
	                    angular.forEach( $scope.inputModel, function( value, key ) {
	                        if ( typeof value !== 'undefined' && value[ attrs.tickProperty ] === true ) {                        
	                            if ( ctr < tempMaxLabels ) {                            
	                                $scope.varButtonLabel += ( $scope.varButtonLabel.length > 0 ? '</div>, <div class="buttonLabel">' : '<div class="buttonLabel">') + $scope.writeLabel( value, 'buttonLabel' );
	                            }
	                            ctr++;
	                        }
	                    });                
	
	                    if ( $scope.more === true ) {
	                        // https://github.com/isteven/angular-multi-select/pull/16
	                        if (tempMaxLabels > 0) {
	                            $scope.varButtonLabel += ', ... ';
	                        }
	                        $scope.varButtonLabel += '(' + $scope.outputModel.length + ')';                        
	                    }
	                }
	                $scope.varButtonLabel = $sce.trustAsHtml( $scope.varButtonLabel + '<span class="caret"></span>' );                
	            }
	
	            // Check if a checkbox is disabled or enabled. It will check the granular control (disableProperty) and global control (isDisabled)
	            // Take note that the granular control has higher priority.
	            $scope.itemIsDisabled = function( item ) {
	                
	                if ( typeof attrs.disableProperty !== 'undefined' && item[ attrs.disableProperty ] === true ) {                                        
	                    return true;
	                }
	                else {             
	                    if ( $scope.isDisabled === true ) {                        
	                        return true;
	                    }
	                    else {
	                        return false;
	                    }
	                }
	                
	            }
	
	            // A simple function to parse the item label settings. Used on the buttons and checkbox labels.
	            $scope.writeLabel = function( item, type ) {
	                
	                // type is either 'itemLabel' or 'buttonLabel'
	                var temp    = attrs[ type ].split( ' ' );                    
	                var label   = '';                
	
	                angular.forEach( temp, function( value, key ) {                    
	                    item[ value ] && ( label += '&nbsp;' + value.split( '.' ).reduce( function( prev, current ) {
	                        return prev[ current ]; 
	                    }, item ));        
	                });
	                
	                if ( type.toUpperCase() === 'BUTTONLABEL' ) {                    
	                    return label;
	                }
	                return $sce.trustAsHtml( label );
	            }                                
	
	            // UI operations to show/hide checkboxes based on click event..
	            $scope.toggleCheckboxes = function( e ) {                                    
	                
	                // We grab the button
	                var clickedEl = element.children()[0];
	
	                // Just to make sure.. had a bug where key events were recorded twice
	                angular.element( document ).off( 'click', $scope.externalClickListener );
	                angular.element( document ).off( 'keydown', $scope.keyboardListener );        
	
	                // The idea below was taken from another multi-select directive - https://github.com/amitava82/angular-multiselect 
	                // His version is awesome if you need a more simple multi-select approach.                                
	
	                // close
	                if ( angular.element( checkBoxLayer ).hasClass( 'show' )) {                         
	
	                    angular.element( checkBoxLayer ).removeClass( 'show' );                    
	                    angular.element( clickedEl ).removeClass( 'buttonClicked' );                    
	                    angular.element( document ).off( 'click', $scope.externalClickListener );
	                    angular.element( document ).off( 'keydown', $scope.keyboardListener );                                    
	
	                    // clear the focused element;
	                    $scope.removeFocusStyle( $scope.tabIndex );
	                    if ( typeof formElements[ $scope.tabIndex ] !== 'undefined' ) {
	                        formElements[ $scope.tabIndex ].blur();
	                    }
	
	                    // close callback
	                    $timeout( function() {
	                        $scope.onClose();
	                    }, 0 );
	
	                    // set focus on button again
	                    element.children().children()[ 0 ].focus();
	                } 
	                // open
	                else                 
	                {    
	                    // clear filter
	                    $scope.inputLabel.labelFilter = '';                
	                    $scope.updateFilter();                                
	
	                    helperItems = [];
	                    helperItemsLength = 0;
	
	                    angular.element( checkBoxLayer ).addClass( 'show' );
	                    angular.element( clickedEl ).addClass( 'buttonClicked' );       
	
	                    // Attach change event listener on the input filter. 
	                    // We need this because ng-change is apparently not an event listener.                    
	                    angular.element( document ).on( 'click', $scope.externalClickListener );
	                    angular.element( document ).on( 'keydown', $scope.keyboardListener );  
	
	                    // to get the initial tab index, depending on how many helper elements we have. 
	                    // priority is to always focus it on the input filter                                                                
	                    $scope.getFormElements();
	                    $scope.tabIndex = 0;
	
	                    var helperContainer = angular.element( element[ 0 ].querySelector( '.helperContainer' ) )[0];                
	                    
	                    if ( typeof helperContainer !== 'undefined' ) {
	                        for ( var i = 0; i < helperContainer.getElementsByTagName( 'BUTTON' ).length ; i++ ) {
	                            helperItems[ i ] = helperContainer.getElementsByTagName( 'BUTTON' )[ i ];
	                        }
	                        helperItemsLength = helperItems.length + helperContainer.getElementsByTagName( 'INPUT' ).length;
	                    }
	                    
	                    // focus on the filter element on open. 
	                    if ( element[ 0 ].querySelector( '.inputFilter' ) ) {                        
	                        element[ 0 ].querySelector( '.inputFilter' ).focus();    
	                        $scope.tabIndex = $scope.tabIndex + helperItemsLength - 2;
	                        // blur button in vain
	                        angular.element( element ).children()[ 0 ].blur();
	                    }
	                    // if there's no filter then just focus on the first checkbox item
	                    else {                  
	                        if ( !$scope.isDisabled ) {                        
	                            $scope.tabIndex = $scope.tabIndex + helperItemsLength;
	                            if ( $scope.inputModel.length > 0 ) {
	                                formElements[ $scope.tabIndex ].focus();
	                                $scope.setFocusStyle( $scope.tabIndex );
	                                // blur button in vain
	                                angular.element( element ).children()[ 0 ].blur();
	                            }                            
	                        }
	                    }                          
	
	                    // open callback
	                    $scope.onOpen();
	                }                            
	            }
	            
	            // handle clicks outside the button / multi select layer
	            $scope.externalClickListener = function( e ) {                   
	
	                var targetsArr = element.find( e.target.tagName );
	                for (var i = 0; i < targetsArr.length; i++) {                                        
	                    if ( e.target == targetsArr[i] ) {
	                        return;
	                    }
	                }
	
	                angular.element( checkBoxLayer.previousSibling ).removeClass( 'buttonClicked' );                    
	                angular.element( checkBoxLayer ).removeClass( 'show' );
	                angular.element( document ).off( 'click', $scope.externalClickListener ); 
	                angular.element( document ).off( 'keydown', $scope.keyboardListener );                
	                
	                // close callback                
	                $timeout( function() {
	                    $scope.onClose();
	                }, 0 );
	
	                // set focus on button again
	                element.children().children()[ 0 ].focus();
	            }
	   
	            // select All / select None / reset buttons
	            $scope.select = function( type, e ) {
	
	                var helperIndex = helperItems.indexOf( e.target );
	                $scope.tabIndex = helperIndex;
	
	                switch( type.toUpperCase() ) {
	                    case 'ALL':
	                        angular.forEach( $scope.filteredModel, function( value, key ) {                            
	                            if ( typeof value !== 'undefined' && value[ attrs.disableProperty ] !== true ) {                                
	                                if ( typeof value[ attrs.groupProperty ] === 'undefined' ) {                                
	                                    value[ $scope.tickProperty ] = true;
	                                }
	                            }
	                        });                            
	                        $scope.refreshOutputModel();                                    
	                        $scope.refreshButton();                                                  
	                        $scope.onSelectAll();                                                
	                        break;
	                    case 'NONE':
	                        angular.forEach( $scope.filteredModel, function( value, key ) {
	                            if ( typeof value !== 'undefined' && value[ attrs.disableProperty ] !== true ) {                        
	                                if ( typeof value[ attrs.groupProperty ] === 'undefined' ) {                                
	                                    value[ $scope.tickProperty ] = false;
	                                }
	                            }
	                        });               
	                        $scope.refreshOutputModel();                                    
	                        $scope.refreshButton();                                                                          
	                        $scope.onSelectNone();                        
	                        break;
	                    case 'RESET':            
	                        angular.forEach( $scope.filteredModel, function( value, key ) {                            
	                            if ( typeof value[ attrs.groupProperty ] === 'undefined' && typeof value !== 'undefined' && value[ attrs.disableProperty ] !== true ) {                        
	                                var temp = value[ $scope.indexProperty ];                                
	                                value[ $scope.tickProperty ] = $scope.backUp[ temp ][ $scope.tickProperty ];
	                            }
	                        });               
	                        $scope.refreshOutputModel();                                    
	                        $scope.refreshButton();                                                                          
	                        $scope.onReset();                        
	                        break;
	                    case 'CLEAR':
	                        $scope.tabIndex = $scope.tabIndex + 1;
	                        $scope.onClear();    
	                        break;
	                    case 'FILTER':                        
	                        $scope.tabIndex = helperItems.length - 1;
	                        break;
	                    default:                        
	                }                                                                                 
	            }            
	
	            // just to create a random variable name                
	            function genRandomString( length ) {                
	                var possible    = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
	                var temp        = '';
	                for( var i=0; i < length; i++ ) {
	                     temp += possible.charAt( Math.floor( Math.random() * possible.length ));
	                }
	                return temp;
	            }
	
	            // count leading spaces
	            $scope.prepareGrouping = function() {
	                var spacing     = 0;                                                
	                angular.forEach( $scope.filteredModel, function( value, key ) {
	                    value[ $scope.spacingProperty ] = spacing;                    
	                    if ( value[ attrs.groupProperty ] === true ) {
	                        spacing+=2;
	                    }                    
	                    else if ( value[ attrs.groupProperty ] === false ) {
	                        spacing-=2;
	                    }                 
	                });
	            }
	
	            // prepare original index
	            $scope.prepareIndex = function() {
	                var ctr = 0;
	                angular.forEach( $scope.filteredModel, function( value, key ) {
	                    value[ $scope.indexProperty ] = ctr;
	                    ctr++;
	                });
	            }
	
	            // navigate using up and down arrow
	            $scope.keyboardListener = function( e ) { 
	                
	                var key = e.keyCode ? e.keyCode : e.which;      
	                var isNavigationKey = false;                                                
	
	                // ESC key (close)
	                if ( key === 27 ) {
	                    e.preventDefault();                   
	                    e.stopPropagation();
	                    $scope.toggleCheckboxes( e );
	                }                    
	                
	                
	                // next element ( tab, down & right key )                    
	                else if ( key === 40 || key === 39 || ( !e.shiftKey && key == 9 ) ) {                    
	                    
	                    isNavigationKey = true;
	                    prevTabIndex = $scope.tabIndex; 
	                    $scope.tabIndex++;                         
	                    if ( $scope.tabIndex > formElements.length - 1 ) {
	                        $scope.tabIndex = 0;
	                        prevTabIndex = formElements.length - 1; 
	                    }                                                            
	                    while ( formElements[ $scope.tabIndex ].disabled === true ) {
	                        $scope.tabIndex++;
	                        if ( $scope.tabIndex > formElements.length - 1 ) {
	                            $scope.tabIndex = 0;                            
	                        }                                                                                    
	                        if ( $scope.tabIndex === prevTabIndex ) {
	                            break;
	                        }
	                    }              
	                }
	                  
	                // prev element ( shift+tab, up & left key )
	                else if ( key === 38 || key === 37 || ( e.shiftKey && key == 9 ) ) { 
	                    isNavigationKey = true;
	                    prevTabIndex = $scope.tabIndex; 
	                    $scope.tabIndex--;                              
	                    if ( $scope.tabIndex < 0 ) {
	                        $scope.tabIndex = formElements.length - 1;
	                        prevTabIndex = 0;
	                    }                                         
	                    while ( formElements[ $scope.tabIndex ].disabled === true ) {                        
	                        $scope.tabIndex--;
	                        if ( $scope.tabIndex === prevTabIndex ) {
	                            break;
	                        }                                            
	                        if ( $scope.tabIndex < 0 ) {
	                            $scope.tabIndex = formElements.length - 1;
	                        }                             
	                    }                                                     
	                }                    
	
	                if ( isNavigationKey === true ) {                                         
	                    
	                    e.preventDefault();
	
	                    // set focus on the checkbox                    
	                    formElements[ $scope.tabIndex ].focus();    
	                    var actEl = document.activeElement;                     
	                    
	                    if ( actEl.type.toUpperCase() === 'CHECKBOX' ) {                                                   
	                        $scope.setFocusStyle( $scope.tabIndex );
	                        $scope.removeFocusStyle( prevTabIndex );
	                    }                    
	                    else {
	                        $scope.removeFocusStyle( prevTabIndex );
	                        $scope.removeFocusStyle( helperItemsLength );
	                        $scope.removeFocusStyle( formElements.length - 1 );
	                    } 
	                }                
	
	                isNavigationKey = false;
	            }
	
	            // set (add) CSS style on selected row
	            $scope.setFocusStyle = function( tabIndex ) {                                
	                angular.element( formElements[ tabIndex ] ).parent().parent().parent().addClass( 'multiSelectFocus' );                        
	            }
	
	            // remove CSS style on selected row
	            $scope.removeFocusStyle = function( tabIndex ) {                
	                angular.element( formElements[ tabIndex ] ).parent().parent().parent().removeClass( 'multiSelectFocus' );
	            }
	
	            /*********************
	             *********************             
	             *
	             * 1) Initializations
	             *
	             *********************
	             *********************/
	
	            // attrs to $scope - attrs-$scope - attrs - $scope
	            // Copy some properties that will be used on the template. They need to be in the $scope.
	            $scope.groupProperty    = attrs.groupProperty;   
	            $scope.tickProperty     = attrs.tickProperty;
	            $scope.directiveId      = attrs.directiveId;
	            
	            // Unfortunately I need to add these grouping properties into the input model
	            var tempStr = genRandomString( 5 );
	            $scope.indexProperty = 'idx_' + tempStr;
	            $scope.spacingProperty = 'spc_' + tempStr;         
	
	            // set orientation css            
	            if ( typeof attrs.orientation !== 'undefined' ) {
	
	                if ( attrs.orientation.toUpperCase() === 'HORIZONTAL' ) {                    
	                    $scope.orientationH = true;
	                    $scope.orientationV = false;
	                }
	                else 
	                {
	                    $scope.orientationH = false;
	                    $scope.orientationV = true;
	                }
	            }            
	
	            // get elements required for DOM operation
	            checkBoxLayer = element.children().children().next()[0];
	
	            // set max-height property if provided
	            if ( typeof attrs.maxHeight !== 'undefined' ) {                
	                var layer = element.children().children().children()[0];
	                angular.element( layer ).attr( "style", "height:" + attrs.maxHeight + "; overflow-y:scroll;" );                                
	            }
	
	            // some flags for easier checking            
	            for ( var property in $scope.helperStatus ) {
	                if ( $scope.helperStatus.hasOwnProperty( property )) {                    
	                    if ( 
	                        typeof attrs.helperElements !== 'undefined' 
	                        && attrs.helperElements.toUpperCase().indexOf( property.toUpperCase() ) === -1 
	                    ) {
	                        $scope.helperStatus[ property ] = false;
	                    }
	                }
	            }
	            if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' )  {
	                $scope.helperStatus[ 'all' ] = false;
	                $scope.helperStatus[ 'none' ] = false;
	            }
	
	            // helper button icons.. I guess you can use html tag here if you want to. 
	            $scope.icon        = {};            
	            $scope.icon.selectAll  = '&#10003;';    // a tick icon
	            $scope.icon.selectNone = '&times;';     // x icon
	            $scope.icon.reset      = '&#8630;';     // undo icon            
	            // this one is for the selected items
	            $scope.icon.tickMark   = '&#10003;';    // a tick icon 
	
	            // configurable button labels                       
	            if ( typeof attrs.translation !== 'undefined' ) {
	                $scope.lang.selectAll       = $sce.trustAsHtml( $scope.icon.selectAll  + '&nbsp;&nbsp;' + $scope.translation.selectAll );
	                $scope.lang.selectNone      = $sce.trustAsHtml( $scope.icon.selectNone + '&nbsp;&nbsp;' + $scope.translation.selectNone );
	                $scope.lang.reset           = $sce.trustAsHtml( $scope.icon.reset      + '&nbsp;&nbsp;' + $scope.translation.reset );
	                $scope.lang.search          = $scope.translation.search;                
	                $scope.lang.nothingSelected = $sce.trustAsHtml( $scope.translation.nothingSelected );                
	            }
	            else {
	                $scope.lang.selectAll       = $sce.trustAsHtml( $scope.icon.selectAll  + '&nbsp;&nbsp;Select All' );                
	                $scope.lang.selectNone      = $sce.trustAsHtml( $scope.icon.selectNone + '&nbsp;&nbsp;Select None' );
	                $scope.lang.reset           = $sce.trustAsHtml( $scope.icon.reset      + '&nbsp;&nbsp;Reset' );
	                $scope.lang.search          = 'Search...';
	                $scope.lang.nothingSelected = 'None Selected';                
	            }
	            $scope.icon.tickMark = $sce.trustAsHtml( $scope.icon.tickMark );
	                
	            // min length of keyword to trigger the filter function
	            if ( typeof attrs.MinSearchLength !== 'undefined' && parseInt( attrs.MinSearchLength ) > 0 ) {
	                vMinSearchLength = Math.floor( parseInt( attrs.MinSearchLength ) );
	            }
	
	            /*******************************************************
	             *******************************************************
	             *
	             * 2) Logic starts here, initiated by watch 1 & watch 2
	             *
	             *******************************************************
	             *******************************************************/
	            
	            // watch1, for changes in input model property
	            // updates multi-select when user select/deselect a single checkbox programatically
	            // https://github.com/isteven/angular-multi-select/issues/8            
	            $scope.$watch( 'inputModel' , function( newVal ) {                                 
	                if ( newVal ) {                            
	                    $scope.refreshOutputModel();                                    
	                    $scope.refreshButton();                                                  
	                }
	            }, true );
	            
	            // watch2 for changes in input model as a whole
	            // this on updates the multi-select when a user load a whole new input-model. We also update the $scope.backUp variable
	            $scope.$watch( 'inputModel' , function( newVal ) {  
	                if ( newVal ) {
	                    $scope.backUp = angular.copy( $scope.inputModel );    
	                    $scope.updateFilter();
	                    $scope.prepareGrouping();
	                    $scope.prepareIndex();                                                              
	                    $scope.refreshOutputModel();                
	                    $scope.refreshButton();                                                                                                                 
	                }
	            });                        
	
	            // watch for changes in directive state (disabled or enabled)
	            $scope.$watch( 'isDisabled' , function( newVal ) {         
	                $scope.isDisabled = newVal;                               
	            });            
	            
	            // this is for touch enabled devices. We don't want to hide checkboxes on scroll. 
	            var onTouchStart = function( e ) { 
	            	$scope.$apply( function() {
	            		$scope.scrolled = false;
	            	}); 
	            };
	            angular.element( document ).bind( 'touchstart', onTouchStart);
	            var onTouchMove = function( e ) { 
	            	$scope.$apply( function() {
	            		$scope.scrolled = true;                
	            	});
	            };
	            angular.element( document ).bind( 'touchmove', onTouchMove);            
	
	            // unbind document events to prevent memory leaks
	            $scope.$on( '$destroy', function () {
				    angular.element( document ).unbind( 'touchstart', onTouchStart);
	            	angular.element( document ).unbind( 'touchmove', onTouchMove);
	            });
	        }
	    }
	}]).run( [ '$templateCache' , function( $templateCache ) {
	    var template = 
	        '<span class="multiSelect inlineBlock">' +
	            // main button
	            '<button id="{{directiveId}}" type="button"' +                
	                'ng-click="toggleCheckboxes( $event ); refreshSelectedItems(); refreshButton(); prepareGrouping; prepareIndex();"' +
	                'ng-bind-html="varButtonLabel"' +
	                'ng-disabled="disable-button"' +
	            '>' +
	            '</button>' +
	            // overlay layer
	            '<div class="checkboxLayer">' +
	                // container of the helper elements
	                '<div class="helperContainer" ng-if="helperStatus.filter || helperStatus.all || helperStatus.none || helperStatus.reset ">' +
	                    // container of the first 3 buttons, select all, none and reset
	                    '<div class="line" ng-if="helperStatus.all || helperStatus.none || helperStatus.reset ">' +
	                        // select all
	                        '<button type="button" class="helperButton"' +
	                            'ng-disabled="isDisabled"' + 
	                            'ng-if="helperStatus.all"' +
	                            'ng-click="select( \'all\', $event );"' +
	                            'ng-bind-html="lang.selectAll">' +
	                        '</button>'+
	                        // select none
	                        '<button type="button" class="helperButton"' +
	                            'ng-disabled="isDisabled"' + 
	                            'ng-if="helperStatus.none"' +
	                            'ng-click="select( \'none\', $event );"' +
	                            'ng-bind-html="lang.selectNone">' +
	                        '</button>'+
	                        // reset
	                        '<button type="button" class="helperButton reset"' +
	                            'ng-disabled="isDisabled"' + 
	                            'ng-if="helperStatus.reset"' +
	                            'ng-click="select( \'reset\', $event );"' +
	                            'ng-bind-html="lang.reset">'+
	                        '</button>' +
	                    '</div>' +
	                    // the search box
	                    '<div class="line" style="position:relative" ng-if="helperStatus.filter">'+
	                        // textfield                
	                        '<input placeholder="{{lang.search}}" type="text"' +
	                            'ng-click="select( \'filter\', $event )" '+
	                            'ng-model="inputLabel.labelFilter" '+
	                            'ng-change="searchChanged()" class="inputFilter"'+
	                            '/>'+
	                        // clear button
	                        '<button type="button" class="clearButton" ng-click="clearClicked( $event )" >×</button> '+
	                    '</div> '+
	                '</div> '+
	                // selection items
	                '<div class="checkBoxContainer">'+
	                    '<div '+
	                        'ng-repeat="item in filteredModel | filter:removeGroupEndMarker" class="multiSelectItem"'+
	                        'ng-class="{selected: item[ tickProperty ], horizontal: orientationH, vertical: orientationV, multiSelectGroup:item[ groupProperty ], disabled:itemIsDisabled( item )}"'+
	                        'ng-click="syncItems( item, $event, $index );" '+
	                        'ng-mouseleave="removeFocusStyle( tabIndex );"> '+
	                        // this is the spacing for grouped items
	                        '<div class="acol" ng-if="item[ spacingProperty ] > 0" ng-repeat="i in numberToArray( item[ spacingProperty ] ) track by $index">'+                        
	                    '</div>  '+        
	                    '<div class="acol">'+
	                        '<label>'+                                
	                            // input, so that it can accept focus on keyboard click
	                            '<input class="checkbox focusable" type="checkbox" '+
	                                'ng-disabled="itemIsDisabled( item )" '+
	                                'ng-checked="item[ tickProperty ]" '+
	                                'ng-click="syncItems( item, $event, $index )" />'+
	                            // item label using ng-bind-hteml
	                            '<span '+
	                                'ng-class="{disabled:itemIsDisabled( item )}" '+
	                                'ng-bind-html="writeLabel( item, \'itemLabel\' )">'+
	                            '</span>'+
	                        '</label>'+
	                    '</div>'+
	                    // the tick/check mark
	                    '<span class="tickMark" ng-if="item[ groupProperty ] !== true && item[ tickProperty ] === true" ng-bind-html="icon.tickMark"></span>'+
	                '</div>'+
	            '</div>'+
	        '</div>'+
	    '</span>';
		$templateCache.put( 'isteven-multi-select.htm' , template );
	}]); 


/***/ }),
/* 17 */
/***/ (function(module, exports) {

	!function(e){if(!e.hasInitialised){var t={escapeRegExp:function(e){return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g,"\\$&")},hasClass:function(e,t){var i=" ";return 1===e.nodeType&&(i+e.className+i).replace(/[\n\t]/g,i).indexOf(i+t+i)>=0},addClass:function(e,t){e.className+=" "+t},removeClass:function(e,t){var i=new RegExp("\\b"+this.escapeRegExp(t)+"\\b");e.className=e.className.replace(i,"")},interpolateString:function(e,t){var i=/{{([a-z][a-z0-9\-_]*)}}/gi;return e.replace(i,function(e){return t(arguments[1])||""})},getCookie:function(e){var t="; "+document.cookie,i=t.split("; "+e+"=");return 2!=i.length?void 0:i.pop().split(";").shift()},setCookie:function(e,t,i,n,o){var s=new Date;s.setDate(s.getDate()+(i||365));var r=[e+"="+t,"expires="+s.toUTCString(),"path="+(o||"/")];n&&r.push("domain="+n),document.cookie=r.join(";")},deepExtend:function(e,t){for(var i in t)t.hasOwnProperty(i)&&(i in e&&this.isPlainObject(e[i])&&this.isPlainObject(t[i])?this.deepExtend(e[i],t[i]):e[i]=t[i]);return e},throttle:function(e,t){var i=!1;return function(){i||(e.apply(this,arguments),i=!0,setTimeout(function(){i=!1},t))}},hash:function(e){var t,i,n,o=0;if(0===e.length)return o;for(t=0,n=e.length;t<n;++t)i=e.charCodeAt(t),o=(o<<5)-o+i,o|=0;return o},normaliseHex:function(e){return"#"==e[0]&&(e=e.substr(1)),3==e.length&&(e=e[0]+e[0]+e[1]+e[1]+e[2]+e[2]),e},getContrast:function(e){e=this.normaliseHex(e);var t=parseInt(e.substr(0,2),16),i=parseInt(e.substr(2,2),16),n=parseInt(e.substr(4,2),16),o=(299*t+587*i+114*n)/1e3;return o>=128?"#000":"#fff"},getLuminance:function(e){var t=parseInt(this.normaliseHex(e),16),i=38,n=(t>>16)+i,o=(t>>8&255)+i,s=(255&t)+i,r=(16777216+65536*(n<255?n<1?0:n:255)+256*(o<255?o<1?0:o:255)+(s<255?s<1?0:s:255)).toString(16).slice(1);return"#"+r},isMobile:function(){return/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)},isPlainObject:function(e){return"object"==typeof e&&null!==e&&e.constructor==Object}};e.status={deny:"deny",allow:"allow",dismiss:"dismiss"},e.transitionEnd=function(){var e=document.createElement("div"),t={t:"transitionend",OT:"oTransitionEnd",msT:"MSTransitionEnd",MozT:"transitionend",WebkitT:"webkitTransitionEnd"};for(var i in t)if(t.hasOwnProperty(i)&&"undefined"!=typeof e.style[i+"ransition"])return t[i];return""}(),e.hasTransition=!!e.transitionEnd;var i=Object.keys(e.status).map(t.escapeRegExp);e.customStyles={},e.Popup=function(){function n(){this.initialise.apply(this,arguments)}function o(e){this.openingTimeout=null,t.removeClass(e,"cc-invisible")}function s(t){t.style.display="none",t.removeEventListener(e.transitionEnd,this.afterTransition),this.afterTransition=null}function r(){var t=this.options.onInitialise.bind(this);if(!window.navigator.cookieEnabled)return t(e.status.deny),!0;if(window.CookiesOK||window.navigator.CookiesOK)return t(e.status.allow),!0;var i=Object.keys(e.status),n=this.getStatus(),o=i.indexOf(n)>=0;return o&&t(n),o}function a(){var e=this.options.position.split("-"),t=[];return e.forEach(function(e){t.push("cc-"+e)}),t}function c(){var e=this.options,i="top"==e.position||"bottom"==e.position?"banner":"floating";t.isMobile()&&(i="floating");var n=["cc-"+i,"cc-type-"+e.type,"cc-theme-"+e.theme];e["static"]&&n.push("cc-static"),n.push.apply(n,a.call(this));p.call(this,this.options.palette);return this.customStyleSelector&&n.push(this.customStyleSelector),n}function l(){var e={},i=this.options;i.showLink||(i.elements.link="",i.elements.messagelink=i.elements.message),Object.keys(i.elements).forEach(function(n){e[n]=t.interpolateString(i.elements[n],function(e){var t=i.content[e];return e&&"string"==typeof t&&t.length?t:""})});var n=i.compliance[i.type];n||(n=i.compliance.info),e.compliance=t.interpolateString(n,function(t){return e[t]});var o=i.layouts[i.layout];return o||(o=i.layouts.basic),t.interpolateString(o,function(t){return e[t]})}function u(i){var n=this.options,o=document.createElement("div"),s=n.container&&1===n.container.nodeType?n.container:document.body;o.innerHTML=i;var r=o.children[0];return r.style.display="none",t.hasClass(r,"cc-window")&&e.hasTransition&&t.addClass(r,"cc-invisible"),this.onButtonClick=h.bind(this),r.addEventListener("click",this.onButtonClick),n.autoAttach&&(s.firstChild?s.insertBefore(r,s.firstChild):s.appendChild(r)),r}function h(n){var o=n.target;if(t.hasClass(o,"cc-btn")){var s=o.className.match(new RegExp("\\bcc-("+i.join("|")+")\\b")),r=s&&s[1]||!1;r&&(this.setStatus(r),this.close(!0))}t.hasClass(o,"cc-close")&&(this.setStatus(e.status.dismiss),this.close(!0)),t.hasClass(o,"cc-revoke")&&this.revokeChoice()}function p(e){var i=t.hash(JSON.stringify(e)),n="cc-color-override-"+i,o=t.isPlainObject(e);return this.customStyleSelector=o?n:null,o&&d(i,e,"."+n),o}function d(i,n,o){if(e.customStyles[i])return void++e.customStyles[i].references;var s={},r=n.popup,a=n.button,c=n.highlight;r&&(r.text=r.text?r.text:t.getContrast(r.background),r.link=r.link?r.link:r.text,s[o+".cc-window"]=["color: "+r.text,"background-color: "+r.background],s[o+".cc-revoke"]=["color: "+r.text,"background-color: "+r.background],s[o+" .cc-link,"+o+" .cc-link:active,"+o+" .cc-link:visited"]=["color: "+r.link],a&&(a.text=a.text?a.text:t.getContrast(a.background),a.border=a.border?a.border:"transparent",s[o+" .cc-btn"]=["color: "+a.text,"border-color: "+a.border,"background-color: "+a.background],"transparent"!=a.background&&(s[o+" .cc-btn:hover, "+o+" .cc-btn:focus"]=["background-color: "+v(a.background)]),c?(c.text=c.text?c.text:t.getContrast(c.background),c.border=c.border?c.border:"transparent",s[o+" .cc-highlight .cc-btn:first-child"]=["color: "+c.text,"border-color: "+c.border,"background-color: "+c.background]):s[o+" .cc-highlight .cc-btn:first-child"]=["color: "+r.text]));var l=document.createElement("style");document.head.appendChild(l),e.customStyles[i]={references:1,element:l.sheet};var u=-1;for(var h in s)s.hasOwnProperty(h)&&l.sheet.insertRule(h+"{"+s[h].join(";")+"}",++u)}function v(e){return e=t.normaliseHex(e),"000000"==e?"#222":t.getLuminance(e)}function f(i){if(t.isPlainObject(i)){var n=t.hash(JSON.stringify(i)),o=e.customStyles[n];if(o&&!--o.references){var s=o.element.ownerNode;s&&s.parentNode&&s.parentNode.removeChild(s),e.customStyles[n]=null}}}function m(e,t){for(var i=0,n=e.length;i<n;++i){var o=e[i];if(o instanceof RegExp&&o.test(t)||"string"==typeof o&&o.length&&o===t)return!0}return!1}function b(){var t=this.setStatus.bind(this),i=this.options.dismissOnTimeout;"number"==typeof i&&i>=0&&(this.dismissTimeout=window.setTimeout(function(){t(e.status.dismiss)},Math.floor(i)));var n=this.options.dismissOnScroll;if("number"==typeof n&&n>=0){var o=function(i){window.pageYOffset>Math.floor(n)&&(t(e.status.dismiss),window.removeEventListener("scroll",o),this.onWindowScroll=null)};this.onWindowScroll=o,window.addEventListener("scroll",o)}}function y(){if("info"!=this.options.type&&(this.options.revokable=!0),t.isMobile()&&(this.options.animateRevokable=!1),this.options.revokable){var e=a.call(this);this.options.animateRevokable&&e.push("cc-animate"),this.customStyleSelector&&e.push(this.customStyleSelector);var i=this.options.revokeBtn.replace("{{classes}}",e.join(" "));this.revokeBtn=u.call(this,i);var n=this.revokeBtn;if(this.options.animateRevokable){var o=t.throttle(function(e){var i=!1,o=20,s=window.innerHeight-20;t.hasClass(n,"cc-top")&&e.clientY<o&&(i=!0),t.hasClass(n,"cc-bottom")&&e.clientY>s&&(i=!0),i?t.hasClass(n,"cc-active")||t.addClass(n,"cc-active"):t.hasClass(n,"cc-active")&&t.removeClass(n,"cc-active")},200);this.onMouseMove=o,window.addEventListener("mousemove",o)}}}var g={enabled:!0,container:null,cookie:{name:"cookieconsent_status",path:"/",domain:"",expiryDays:365},onPopupOpen:function(){},onPopupClose:function(){},onInitialise:function(e){},onStatusChange:function(e,t){},onRevokeChoice:function(){},content:{header:"Cookies used on the website!",message:"This website uses cookies to ensure you get the best experience on our website.",dismiss:"Got it!",allow:"Allow cookies",deny:"Decline",link:"Learn more",href:"http://cookiesandyou.com",close:"&#x274c;"},elements:{header:'<span class="cc-header">{{header}}</span>&nbsp;',message:'<span id="cookieconsent:desc" class="cc-message">{{message}}</span>',messagelink:'<span id="cookieconsent:desc" class="cc-message">{{message}} <a aria-label="learn more about cookies" role=button tabindex="0" class="cc-link" href="{{href}}" rel="noopener noreferrer nofollow" target="_blank">{{link}}</a></span>',dismiss:'<a aria-label="dismiss cookie message" role=button tabindex="0" class="cc-btn cc-dismiss">{{dismiss}}</a>',allow:'<a aria-label="allow cookies" role=button tabindex="0"  class="cc-btn cc-allow">{{allow}}</a>',deny:'<a aria-label="deny cookies" role=button tabindex="0" class="cc-btn cc-deny">{{deny}}</a>',link:'<a aria-label="learn more about cookies" role=button tabindex="0" class="cc-link" href="{{href}}" target="_blank">{{link}}</a>',close:'<span aria-label="dismiss cookie message" role=button tabindex="0" class="cc-close">{{close}}</span>'},window:'<div role="dialog" aria-live="polite" aria-label="cookieconsent" aria-describedby="cookieconsent:desc" class="cc-window {{classes}}"><!--googleoff: all-->{{children}}<!--googleon: all--></div>',revokeBtn:'<div class="cc-revoke {{classes}}">Cookie Policy</div>',compliance:{info:'<div class="cc-compliance">{{dismiss}}</div>',"opt-in":'<div class="cc-compliance cc-highlight">{{dismiss}}{{allow}}</div>',"opt-out":'<div class="cc-compliance cc-highlight">{{deny}}{{dismiss}}</div>'},type:"info",layouts:{basic:"{{messagelink}}{{compliance}}","basic-close":"{{messagelink}}{{compliance}}{{close}}","basic-header":"{{header}}{{message}}{{link}}{{compliance}}"},layout:"basic",position:"bottom",theme:"block","static":!1,palette:null,revokable:!1,animateRevokable:!0,showLink:!0,dismissOnScroll:!1,dismissOnTimeout:!1,autoOpen:!0,autoAttach:!0,whitelistPage:[],blacklistPage:[],overrideHTML:null};return n.prototype.initialise=function(e){this.options&&this.destroy(),t.deepExtend(this.options={},g),t.isPlainObject(e)&&t.deepExtend(this.options,e),r.call(this)&&(this.options.enabled=!1),m(this.options.blacklistPage,location.pathname)&&(this.options.enabled=!1),m(this.options.whitelistPage,location.pathname)&&(this.options.enabled=!0);var i=this.options.window.replace("{{classes}}",c.call(this).join(" ")).replace("{{children}}",l.call(this)),n=this.options.overrideHTML;if("string"==typeof n&&n.length&&(i=n),this.options["static"]){var o=u.call(this,'<div class="cc-grower">'+i+"</div>");o.style.display="",this.element=o.firstChild,this.element.style.display="none",t.addClass(this.element,"cc-invisible")}else this.element=u.call(this,i);b.call(this),y.call(this),this.options.autoOpen&&this.autoOpen()},n.prototype.destroy=function(){this.onButtonClick&&this.element&&(this.element.removeEventListener("click",this.onButtonClick),this.onButtonClick=null),this.dismissTimeout&&(clearTimeout(this.dismissTimeout),this.dismissTimeout=null),this.onWindowScroll&&(window.removeEventListener("scroll",this.onWindowScroll),this.onWindowScroll=null),this.onMouseMove&&(window.removeEventListener("mousemove",this.onMouseMove),this.onMouseMove=null),this.element&&this.element.parentNode&&this.element.parentNode.removeChild(this.element),this.element=null,this.revokeBtn&&this.revokeBtn.parentNode&&this.revokeBtn.parentNode.removeChild(this.revokeBtn),this.revokeBtn=null,f(this.options.palette),this.options=null},n.prototype.open=function(t){if(this.element)return this.isOpen()||(e.hasTransition?this.fadeIn():this.element.style.display="",this.options.revokable&&this.toggleRevokeButton(),this.options.onPopupOpen.call(this)),this},n.prototype.close=function(t){if(this.element)return this.isOpen()&&(e.hasTransition?this.fadeOut():this.element.style.display="none",t&&this.options.revokable&&this.toggleRevokeButton(!0),this.options.onPopupClose.call(this)),this},n.prototype.fadeIn=function(){var i=this.element;if(e.hasTransition&&i&&(this.afterTransition&&s.call(this,i),t.hasClass(i,"cc-invisible"))){if(i.style.display="",this.options["static"]){var n=this.element.clientHeight;this.element.parentNode.style.maxHeight=n+"px"}var r=20;this.openingTimeout=setTimeout(o.bind(this,i),r)}},n.prototype.fadeOut=function(){var i=this.element;e.hasTransition&&i&&(this.openingTimeout&&(clearTimeout(this.openingTimeout),o.bind(this,i)),t.hasClass(i,"cc-invisible")||(this.options["static"]&&(this.element.parentNode.style.maxHeight=""),this.afterTransition=s.bind(this,i),i.addEventListener(e.transitionEnd,this.afterTransition),t.addClass(i,"cc-invisible")))},n.prototype.isOpen=function(){return this.element&&""==this.element.style.display&&(!e.hasTransition||!t.hasClass(this.element,"cc-invisible"))},n.prototype.toggleRevokeButton=function(e){this.revokeBtn&&(this.revokeBtn.style.display=e?"":"none")},n.prototype.revokeChoice=function(e){this.options.enabled=!0,this.clearStatus(),this.options.onRevokeChoice.call(this),e||this.autoOpen()},n.prototype.hasAnswered=function(t){return Object.keys(e.status).indexOf(this.getStatus())>=0},n.prototype.hasConsented=function(t){var i=this.getStatus();return i==e.status.allow||i==e.status.dismiss},n.prototype.autoOpen=function(e){!this.hasAnswered()&&this.options.enabled&&this.open()},n.prototype.setStatus=function(i){var n=this.options.cookie,o=t.getCookie(n.name),s=Object.keys(e.status).indexOf(o)>=0;Object.keys(e.status).indexOf(i)>=0?(t.setCookie(n.name,i,n.expiryDays,n.domain,n.path),this.options.onStatusChange.call(this,i,s)):this.clearStatus()},n.prototype.getStatus=function(){return t.getCookie(this.options.cookie.name)},n.prototype.clearStatus=function(){var e=this.options.cookie;t.setCookie(e.name,"",-1,e.domain,e.path)},n}(),e.Location=function(){function e(e){t.deepExtend(this.options={},s),t.isPlainObject(e)&&t.deepExtend(this.options,e),this.currentServiceIndex=-1}function i(e,t,i){var n,o=document.createElement("script");o.type="text/"+(e.type||"javascript"),o.src=e.src||e,o.async=!1,o.onreadystatechange=o.onload=function(){var e=o.readyState;clearTimeout(n),t.done||e&&!/loaded|complete/.test(e)||(t.done=!0,t(),o.onreadystatechange=o.onload=null)},document.body.appendChild(o),n=setTimeout(function(){t.done=!0,t(),o.onreadystatechange=o.onload=null},i)}function n(e,t,i,n,o){var s=new(window.XMLHttpRequest||window.ActiveXObject)("MSXML2.XMLHTTP.3.0");if(s.open(n?"POST":"GET",e,1),s.setRequestHeader("X-Requested-With","XMLHttpRequest"),s.setRequestHeader("Content-type","application/x-www-form-urlencoded"),Array.isArray(o))for(var r=0,a=o.length;r<a;++r){var c=o[r].split(":",2);s.setRequestHeader(c[0].replace(/^\s+|\s+$/g,""),c[1].replace(/^\s+|\s+$/g,""))}"function"==typeof t&&(s.onreadystatechange=function(){s.readyState>3&&t(s)}),s.send(n)}function o(e){return new Error("Error ["+(e.code||"UNKNOWN")+"]: "+e.error)}var s={timeout:5e3,services:["freegeoip","ipinfo","maxmind"],serviceDefinitions:{freegeoip:function(){return{url:"//freegeoip.net/json/?callback={callback}",isScript:!0,callback:function(e,t){try{var i=JSON.parse(t);return i.error?o(i):{code:i.country_code}}catch(n){return o({error:"Invalid response ("+n+")"})}}}},ipinfo:function(){return{url:"//ipinfo.io",headers:["Accept: application/json"],callback:function(e,t){try{var i=JSON.parse(t);return i.error?o(i):{code:i.country}}catch(n){return o({error:"Invalid response ("+n+")"})}}}},ipinfodb:function(e){return{url:"//api.ipinfodb.com/v3/ip-country/?key={api_key}&format=json&callback={callback}",isScript:!0,callback:function(e,t){try{var i=JSON.parse(t);return"ERROR"==i.statusCode?o({error:i.statusMessage}):{code:i.countryCode}}catch(n){return o({error:"Invalid response ("+n+")"})}}}},maxmind:function(){return{url:"//js.maxmind.com/js/apis/geoip2/v2.1/geoip2.js",isScript:!0,callback:function(e){return window.geoip2?void geoip2.country(function(t){try{e({code:t.country.iso_code})}catch(i){e(o(i))}},function(t){e(o(t))}):void e(new Error("Unexpected response format. The downloaded script should have exported `geoip2` to the global scope"))}}}}};return e.prototype.getNextService=function(){var e;do e=this.getServiceByIdx(++this.currentServiceIndex);while(this.currentServiceIndex<this.options.services.length&&!e);return e},e.prototype.getServiceByIdx=function(e){var i=this.options.services[e];if("function"==typeof i){var n=i();return n.name&&t.deepExtend(n,this.options.serviceDefinitions[n.name](n)),n}return"string"==typeof i?this.options.serviceDefinitions[i]():t.isPlainObject(i)?this.options.serviceDefinitions[i.name](i):null},e.prototype.locate=function(e,t){var i=this.getNextService();return i?(this.callbackComplete=e,this.callbackError=t,void this.runService(i,this.runNextServiceOnError.bind(this))):void t(new Error("No services to run"))},e.prototype.setupUrl=function(e){var t=this.getCurrentServiceOpts();return e.url.replace(/\{(.*?)\}/g,function(i,n){if("callback"===n){var o="callback"+Date.now();return window[o]=function(t){e.__JSONP_DATA=JSON.stringify(t)},o}if(n in t.interpolateUrl)return t.interpolateUrl[n]})},e.prototype.runService=function(e,t){var o=this;if(e&&e.url&&e.callback){var s=e.isScript?i:n,r=this.setupUrl(e);s(r,function(i){var n=i?i.responseText:"";e.__JSONP_DATA&&(n=e.__JSONP_DATA,delete e.__JSONP_DATA),o.runServiceCallback.call(o,t,e,n)},this.options.timeout,e.data,e.headers)}},e.prototype.runServiceCallback=function(e,t,i){var n=this,o=function(t){s||n.onServiceResult.call(n,e,t)},s=t.callback(o,i);s&&this.onServiceResult.call(this,e,s)},e.prototype.onServiceResult=function(e,t){t instanceof Error||t&&t.error?e.call(this,t,null):e.call(this,null,t)},e.prototype.runNextServiceOnError=function(e,t){if(e){this.logError(e);var i=this.getNextService();i?this.runService(i,this.runNextServiceOnError.bind(this)):this.completeService.call(this,this.callbackError,new Error("All services failed"))}else this.completeService.call(this,this.callbackComplete,t)},e.prototype.getCurrentServiceOpts=function(){var e=this.options.services[this.currentServiceIndex];return"string"==typeof e?{name:e}:"function"==typeof e?e():t.isPlainObject(e)?e:{}},e.prototype.completeService=function(e,t){this.currentServiceIndex=-1,e&&e(t)},e.prototype.logError=function(e){var t=this.currentServiceIndex,i=this.getServiceByIdx(t);console.error("The service["+t+"] ("+i.url+") responded with the following error",e)},e}(),e.Law=function(){function e(e){this.initialise.apply(this,arguments)}var i={regionalLaw:!0,hasLaw:["AT","BE","BG","HR","CZ","CY","DK","EE","FI","FR","DE","EL","HU","IE","IT","LV","LT","LU","MT","NL","PL","PT","SK","SI","ES","SE","GB","UK"],revokable:["HR","CY","DK","EE","FR","DE","LV","LT","NL","PT","ES"],explicitAction:["HR","IT","ES"]};return e.prototype.initialise=function(e){t.deepExtend(this.options={},i),t.isPlainObject(e)&&t.deepExtend(this.options,e)},e.prototype.get=function(e){var t=this.options;return{hasLaw:t.hasLaw.indexOf(e)>=0,revokable:t.revokable.indexOf(e)>=0,explicitAction:t.explicitAction.indexOf(e)>=0}},e.prototype.applyLaw=function(e,t){var i=this.get(t);return i.hasLaw||(e.enabled=!1),this.options.regionalLaw&&(i.revokable&&(e.revokable=!0),i.explicitAction&&(e.dismissOnScroll=!1,e.dismissOnTimeout=!1)),e},e}(),e.initialise=function(t,i,n){var o=new e.Law(t.law);i||(i=function(){}),n||(n=function(){}),e.getCountryCode(t,function(n){delete t.law,delete t.location,n.code&&(t=o.applyLaw(t,n.code)),i(new e.Popup(t))},function(i){delete t.law,delete t.location,n(i,new e.Popup(t))})},e.getCountryCode=function(t,i,n){if(t.law&&t.law.countryCode)return void i({code:t.law.countryCode});if(t.location){var o=new e.Location(t.location);return void o.locate(function(e){i(e||{})},n)}i({})},e.utils=t,e.hasInitialised=!0,window.cookieconsent=e}}(window.cookieconsent||{});

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */,
/* 20 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 22 */
/***/ (function(module, exports) {

	'use strict';
	angular.module('lr.upload', [
	  'lr.upload.formdata',
	  'lr.upload.iframe',
	  'lr.upload.directives'
	]);
	angular.module('lr.upload.directives', []);
	'use strict';
	angular.module('lr.upload.directives').directive('uploadButton', [
	  'upload',
	  function (upload) {
	    return {
	      restrict: 'EA',
	      scope: {
	        data: '=?data',
	        url: '@',
	        id: '@',
	        param: '@',
	        method: '@',
	        onUpload: '&',
	        onSuccess: '&',
	        onError: '&',
	        onComplete: '&'
	      },
	      link: function (scope, element, attr) {
	        var el = angular.element(element);
	        var fileInput = angular.element('<input id="' + scope.id + '" type="file" />');
	        el.append(fileInput);
	        fileInput.on('change', function uploadButtonFileInputChange() {
	          // without this, iframeUpload always upload the first time picked file
	          var fileInput = angular.element(this);
	          if (fileInput[0].files && fileInput[0].files.length === 0) {
	            return;
	          }
	          var options = {
	              url: scope.url,
	              method: scope.method || 'POST',
	              forceIFrameUpload: scope.$eval(attr.forceIframeUpload) || false,
	              data: scope.data || {}
	            };
	          options.data[scope.param || 'file'] = fileInput;
	          scope.$apply(function () {
	            scope.onUpload({ files: fileInput[0].files });
	          });
	          upload(options).then(function (response) {
	            scope.onSuccess({ response: response });
	            scope.onComplete({ response: response });
	          }, function (response) {
	            scope.onError({ response: response });
	            scope.onComplete({ response: response });
	          });
	        });
	        // Add required to file input and ng-invalid-required
	        // Since the input is reset when upload is complete, we need to check something in the
	        // onSuccess and set required="false" when we feel that the upload is correct
	        if ('required' in attr) {
	          attr.$observe('required', function uploadButtonRequiredObserve(value) {
	            var required = value === '' ? true : scope.$eval(value);
	            fileInput.attr('required', required);
	            element.toggleClass('ng-valid', !required);
	            element.toggleClass('ng-invalid ng-invalid-required', required);
	          });
	        }
	        if ('accept' in attr) {
	          attr.$observe('accept', function uploadButtonAcceptObserve(value) {
	            fileInput.attr('accept', value);
	          });
	        }
	        if (upload.support.formData) {
	          var uploadButtonMultipleObserve = function () {
	            fileInput.attr('multiple', !!(scope.$eval(attr.multiple) && !scope.$eval(attr.forceIframeUpload)));
	          };
	          attr.$observe('multiple', uploadButtonMultipleObserve);
	          attr.$observe('forceIframeUpload', uploadButtonMultipleObserve);
	        }
	      }
	    };
	  }
	]);
	'use strict';
	angular.module('lr.upload.formdata', []).factory('formDataTransform', function () {
	  return function formDataTransform(data) {
	    var formData = new FormData();
	    // Extract file elements from within config.data
	    angular.forEach(data, function (value, key) {
	      // If it's an element that means we should extract the files
	      if (angular.isElement(value)) {
	        var files = [];
	        // Extract all the Files from the element
	        angular.forEach(value, function (el) {
	          angular.forEach(el.files, function (file) {
	            files.push(file);
	          });
	          // Reset input value so that we don't upload the same files next time
	          el.value = '';
	        });
	        // Do we have any files?
	        if (files.length !== 0) {
	          // If we have multiple files we send them as a 0 based array of params
	          // file[0]=file1&file[1]=file2...
	          if (files.length > 1) {
	            angular.forEach(files, function (file, index) {
	              formData.append(key + '[' + index + ']', file);
	            });
	          } else {
	            formData.append(key, files[0]);
	          }
	        }
	      } else {
	        // If it's not a element we append the data as normal
	        formData.append(key, value);
	      }
	    });
	    return formData;
	  };
	}).factory('formDataUpload', [
	  '$http',
	  'formDataTransform',
	  function ($http, formDataTransform) {
	    return function formDataUpload(config) {
	      // Apply FormData transform to the request
	      config.transformRequest = formDataTransform;
	      // Set method to POST if not defined
	      config.method = config.method || 'POST';
	      // Extend the headers so that the browser will set the correct content type
	      config.headers = angular.extend(config.headers || {}, { 'Content-Type': undefined });
	      return $http(config);
	    };
	  }
	]);
	'use strict';
	angular.module('lr.upload.iframe', []).factory('iFrameUpload', [
	  '$q',
	  '$http',
	  '$document',
	  '$rootScope',
	  function ($q, $http, $document, $rootScope) {
	    function indexOf(array, obj) {
	      if (array.indexOf) {
	        return array.indexOf(obj);
	      }
	      for (var i = 0; i < array.length; i++) {
	        if (obj === array[i]) {
	          return i;
	        }
	      }
	      return -1;
	    }
	    function iFrameUpload(config) {
	      var files = [];
	      var deferred = $q.defer(), promise = deferred.promise;
	      // Extract file elements from the within config.data
	      angular.forEach(config.data || {}, function (value, key) {
	        if (angular.isElement(value)) {
	          delete config.data[key];
	          value.attr('name', key);
	          files.push(value);
	        }
	      });
	      // If the method is something else than POST append the _method parameter
	      var addParamChar = /\?/.test(config.url) ? '&' : '?';
	      // XDomainRequest only supports GET and POST:
	      if (config.method === 'DELETE') {
	        config.url = config.url + addParamChar + '_method=DELETE';
	        config.method = 'POST';
	      } else if (config.method === 'PUT') {
	        config.url = config.url + addParamChar + '_method=PUT';
	        config.method = 'POST';
	      } else if (config.method === 'PATCH') {
	        config.url = config.url + addParamChar + '_method=PATCH';
	        config.method = 'POST';
	      }
	      var body = angular.element($document[0].body);
	      // Generate a unique name using getUid() https://github.com/angular/angular.js/blob/master/src/Angular.js#L292
	      // But since getUid isn't exported we get it from a temporary scope
	      var uniqueScope = $rootScope.$new();
	      var uniqueName = 'iframe-transport-' + uniqueScope.$id;
	      uniqueScope.$destroy();
	      var form = angular.element('<form></form>');
	      form.attr('target', uniqueName);
	      form.attr('action', config.url);
	      form.attr('method', config.method || 'POST');
	      form.css('display', 'none');
	      if (files.length) {
	        form.attr('enctype', 'multipart/form-data');
	        // enctype must be set as encoding for IE:
	        form.attr('encoding', 'multipart/form-data');
	      }
	      // Add iframe that we will post to
	      var iframe = angular.element('<iframe name="' + uniqueName + '" src="javascript:false;"></iframe>');
	      // The first load is called when the javascript:false is loaded,
	      // that means we can continue with adding the hidden form and posting it to the iframe;
	      iframe.on('load', function () {
	        iframe.off('load').on('load', function () {
	          // The upload is complete and we not need to parse the contents and resolve the deferred
	          var response;
	          // Wrap in a try/catch block to catch exceptions thrown
	          // when trying to access cross-domain iframe contents:
	          try {
	            var doc = this.contentWindow ? this.contentWindow.document : this.contentDocument;
	            response = angular.element(doc.body).text();
	            // Google Chrome and Firefox do not throw an
	            // exception when calling iframe.contents() on
	            // cross-domain requests, so we unify the response:
	            if (!response.length) {
	              throw new Error();
	            }
	          } catch (e) {
	          }
	          // Fix for IE endless progress bar activity bug
	          // (happens on form submits to iframe targets):
	          form.append(angular.element('<iframe src="javascript:false;"></iframe>'));
	          // Convert response into JSON
	          try {
	            response = transformData(response, $http.defaults.transformResponse);
	          } catch (e) {
	          }
	          deferred.resolve({
	            data: response,
	            status: 200,
	            headers: [],
	            config: config
	          });
	        });
	        // Add all existing data as hidden variables
	        angular.forEach(config.data, function (value, name) {
	          var input = angular.element('<input type="hidden" />');
	          input.attr('name', name);
	          input.val(value);
	          form.append(input);
	        });
	        // Move file inputs to hidden form, adding files last, as this is a
	        // requirement for uploading to S3
	        angular.forEach(files, function (input) {
	          // Clone the original input also cloning it's event
	          // @fix jQuery supports the option of cloning with events, but angular doesn't
	          // this means that if you don't use jQuery the input will only work the first time.
	          // because when we place the clone in the originals place we will not have a
	          // change event hooked on to it.
	          var clone = input.clone(true);
	          // Insert clone directly after input
	          input.after(clone);
	          // Move original input to hidden form
	          form.append(input);
	        });
	        config.$iframeTransportForm = form;
	        // Add the config to the $http pending requests to indicate that we are doing a request via the iframe
	        $http.pendingRequests.push(config);
	        // Transform data using $http.defaults.response
	        function transformData(data, fns) {
	          // An iframe doesn't support headers :(
	          var headers = [];
	          if (angular.isFunction(fns)) {
	            return fns(data, headers);
	          }
	          angular.forEach(fns, function (fn) {
	            data = fn(data, headers);
	          });
	          return data;
	        }
	        // Remove everything when we are done
	        function removePendingReq() {
	          var idx = indexOf($http.pendingRequests, config);
	          if (idx !== -1) {
	            $http.pendingRequests.splice(idx, 1);
	            config.$iframeTransportForm.remove();
	            delete config.$iframeTransportForm;
	          }
	        }
	        // submit the form and wait for a response
	        form[0].submit();
	        promise.then(removePendingReq, removePendingReq);
	      });
	      form.append(iframe);
	      body.append(form);
	      return promise;
	    }
	    return iFrameUpload;
	  }
	]);
	'use strict';
	angular.module('lr.upload').factory('upload', [
	  '$window',
	  'formDataUpload',
	  'iFrameUpload',
	  function ($window, formDataUpload, iFrameUpload) {
	    var support = {
	        fileInput: !(new RegExp('(Android (1\\.[0156]|2\\.[01]))' + '|(Windows Phone (OS 7|8\\.0))|(XBLWP)|(ZuneWP)|(WPDesktop)' + '|(w(eb)?OSBrowser)|(webOS)' + '|(Kindle/(1\\.0|2\\.[05]|3\\.0))').test($window.navigator.userAgent) || angular.element('<input type="file">').prop('disabled')),
	        fileUpload: !!($window.XMLHttpRequestUpload && $window.FileReader),
	        formData: !!$window.FormData
	      };
	    function upload(config) {
	      if (support.formData && !config.forceIFrameUpload) {
	        return formDataUpload(config);
	      }
	      return iFrameUpload(config);
	    }
	    upload.support = support;
	    return upload;
	  }
	]);

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(28);
	module.exports = 'validation.match';


/***/ }),
/* 28 */
/***/ (function(module, exports) {

	/*!
	 * angular-validation-match
	 * Checks if one input matches another
	 * @version v1.9.0
	 * @link https://github.com/TheSharpieOne/angular-validation-match
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	(function(window, angular, undefined){'use strict';
	
	match.$inject = ["$parse"];
	angular.module('validation.match', []);
	
	angular.module('validation.match').directive('match', match);
	
	function match ($parse) {
	    return {
	        require: '?ngModel',
	        restrict: 'A',
	        link: function(scope, elem, attrs, ctrl) {
	            if(!ctrl || !attrs.match) {
	                return;
	            }
	
	            var matchGetter = $parse(attrs.match);
	            var caselessGetter = $parse(attrs.matchCaseless);
	            var noMatchGetter = $parse(attrs.notMatch);
	            var matchIgnoreEmptyGetter = $parse(attrs.matchIgnoreEmpty);
	
	            scope.$watch(getMatchValue, function(){
	                ctrl.$$parseAndValidate();
	            });
	
	            ctrl.$validators.match = function(modelValue, viewValue){
	              var matcher = modelValue || viewValue;
	              var match = getMatchValue();
	              var notMatch = noMatchGetter(scope);
	              var value;
	
	              if (matchIgnoreEmptyGetter(scope) && !viewValue) {
	                return true;
	              }
	
	              if(caselessGetter(scope)){
	                value = angular.lowercase(matcher) === angular.lowercase(match);
	              }else{
	                value = matcher === match;
	              }
	              /*jslint bitwise: true */
	              value ^= notMatch;
	              /*jslint bitwise: false */
	              return !!value;
	            };
	
	            function getMatchValue(){
	                var match = matchGetter(scope);
	                if(angular.isObject(match) && match.hasOwnProperty('$viewValue')){
	                    match = match.$viewValue;
	                }
	                return match;
	            }
	        }
	    };
	}
	})(window, window.angular);


/***/ }),
/* 29 */
/***/ (function(module, exports) {

	'use strict';
	
	routeConfig.$inject = ['$urlRouterProvider', '$locationProvider', '$httpProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routeConfig = routeConfig;
	function routeConfig($urlRouterProvider, $locationProvider, $httpProvider) {
	  'ngInject';
	
	  if (!$httpProvider.defaults.headers.common) {
	    $httpProvider.defaults.headers.common = {};
	  }
	  $httpProvider.defaults.headers.common['Cache-Control'] = 'no-cache';
	  $httpProvider.defaults.headers.common.Pragma = 'no-cache';
	  $httpProvider.defaults.headers.common['If-Modified-Since'] = '0';
	
	  $urlRouterProvider.otherwise('/');
	
	  $locationProvider.html5Mode(true);
	}

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	addInterceptor.$inject = ['$httpProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _app = __webpack_require__(31);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _util = __webpack_require__(33);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _angularCookies = __webpack_require__(5);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _interceptor = __webpack_require__(35);
	
	var _router = __webpack_require__(36);
	
	var _auth = __webpack_require__(37);
	
	var _user = __webpack_require__(40);
	
	var _angularUiRouter = __webpack_require__(24);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addInterceptor($httpProvider) {
	  'ngInject';
	
	  $httpProvider.interceptors.push('authInterceptor');
	}
	
	exports.default = _angular2.default.module('dalApp.auth', [_app2.default, _util2.default, _angularCookies2.default, _angularUiRouter2.default]).factory('authInterceptor', _interceptor.authInterceptor).run(_router.routerDecorator).factory('Auth', _auth.AuthService).factory('User', _user.UserResource).config(['$httpProvider', addInterceptor]).name;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('dalApp.constants', []).constant('appConfig', __webpack_require__(32)).name;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports = module.exports = {
	  // List of user roles
	  userRoles: ["guest", "user", "admin"],
	  env: ("production")||'development'
	};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _util = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('dalApp.util', []).factory('Util', _util.UtilService).name;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	UtilService.$inject = ['$window'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UtilService = UtilService;
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function UtilService($window) {
	  'ngInject';
	
	  var Util = {
	    safeCb: function safeCb(cb) {
	      return _angular2.default.isFunction(cb) ? cb : _angular2.default.noop;
	    },
	    urlParse: function urlParse(url) {
	      var a = document.createElement('a');
	      a.href = url;
	
	      if (a.host === '') {
	        a.href = a.href;
	      }
	
	      return a;
	    },
	    isSameOrigin: function isSameOrigin(url, origins) {
	      url = Util.urlParse(url);
	      origins = origins && [].concat(origins) || [];
	      origins = origins.map(Util.urlParse);
	      origins.push($window.location);
	      origins = origins.filter(function (o) {
	        var hostnameCheck = url.hostname === o.hostname;
	        var protocolCheck = url.protocol === o.protocol;
	
	        var portCheck = url.port === o.port || o.port === '' && (url.port === '80' || url.port === '443');
	        return hostnameCheck && protocolCheck && portCheck;
	      });
	      return origins.length >= 1;
	    }
	  };
	
	  return Util;
	}

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	'use strict';
	
	authInterceptor.$inject = ['$rootScope', '$q', '$cookies', '$injector', 'Util'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.authInterceptor = authInterceptor;
	function authInterceptor($rootScope, $q, $cookies, $injector, Util) {
	  'ngInject';
	
	  var state;
	  return {
	    request: function request(config) {
	      config.headers = config.headers || {};
	      if ($cookies.get('token') && Util.isSameOrigin(config.url)) {
	        config.headers.Authorization = 'Bearer ' + $cookies.get('token');
	      }
	      return config;
	    },
	    responseError: function responseError(response) {
	      if (response.status === 401) {
	        (state || (state = $injector.get('$state'))).go('main');
	
	        $cookies.remove('token');
	      }
	      return $q.reject(response);
	    }
	  };
	}

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	'use strict';
	
	routerDecorator.$inject = ['$rootScope', '$state', 'Auth'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerDecorator = routerDecorator;
	function routerDecorator($rootScope, $state, Auth) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next) {
	    if (!next.authenticate) {
	      return;
	    }
	
	    if (typeof next.authenticate === 'string') {
	      Auth.hasRole(next.authenticate).then(function (has) {
	        if (has) {
	          return;
	        }
	        event.preventDefault();
	        return Auth.isLoggedIn().then(function (is) {
	          $state.go(is ? 'permission' : 'main');
	        });
	      });
	    } else {
	      Auth.isLoggedIn().then(function (is) {
	        if (is) {
	          return;
	        }
	
	        event.preventDefault();
	
	        $state.go('main');
	        return;
	      });
	    }
	  });
	}

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	AuthService.$inject = ['$location', '$http', '$cookies', '$q', 'appConfig', 'Util', 'User', 'gettextCatalog'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AuthService = AuthService;
	
	var _lodash = __webpack_require__(38);
	
	var _ = _interopRequireWildcard(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _User = function _User() {
	  _classCallCheck(this, _User);
	
	  this.id = '';
	  this.name = '';
	  this.email = '';
	  this.role = '';
	  this.$promise = undefined;
	};
	
	function AuthService($location, $http, $cookies, $q, appConfig, Util, User, gettextCatalog) {
	  'ngInject';
	
	  var safeCb = Util.safeCb;
	  var currentUser = new _User();
	  var userRoles = appConfig.userRoles || [];
	
	  var _hasRole = function _hasRole(userRole, role) {
	    return userRoles.indexOf(userRole) >= userRoles.indexOf(role);
	  };
	
	  if ($cookies.get('token') && $location.path() !== '/logout') {
	    currentUser = User.get();
	  }
	
	  var Auth = {
	    login: function login(_ref, callback) {
	      var email = _ref.email,
	          password = _ref.password;
	
	      return $http.post('/auth/local', {
	        email: email,
	        password: password
	      }).then(function (res) {
	        $cookies.put('token', res.data.token);
	        currentUser = User.get();
	        return currentUser.$promise;
	      }).then(function (user) {
	        safeCb(callback)(null, user);
	        return user;
	      }).catch(function (err) {
	        Auth.logout();
	        safeCb(callback)(err.data);
	        return $q.reject(err.data);
	      });
	    },
	    logout: function logout() {
	      if (currentUser.id) {
	        return User.logout().$promise.then(function () {
	          $cookies.remove('token');
	          currentUser = new _User();
	          return;
	        });
	      } else {
	        $cookies.remove('token');
	        currentUser = new _User();
	        return Promise.resolve(null);
	      }
	    },
	    createUser: function createUser(user, callback) {
	      return User.save(user, function (data) {
	        $cookies.put('token', data.token);
	        currentUser = User.get();
	        return safeCb(callback)(null, user);
	      }, function (err) {
	        Auth.logout();
	        return safeCb(callback)(err);
	      }).$promise;
	    },
	    changePassword: function changePassword(oldPassword, newPassword, callback) {
	      return User.changePassword({
	        id: currentUser.id
	      }, {
	        oldPassword: oldPassword,
	        newPassword: newPassword
	      }, function () {
	        return safeCb(callback)(null);
	      }, function (err) {
	        return safeCb(callback)(err);
	      }).$promise;
	    },
	    getCurrentUser: function getCurrentUser(callback) {
	      var value = _.get(currentUser, '$promise') ? currentUser.$promise : currentUser;
	
	      return $q.when(value).then(function (user) {
	        safeCb(callback)(user);
	        return user;
	      }, function () {
	        safeCb(callback)({});
	        return {};
	      });
	    },
	    getCurrentUserSync: function getCurrentUserSync() {
	      if ($cookies.get('token')) {
	        return currentUser;
	      } else {
	        return new _User();
	      }
	    },
	    isLoggedIn: function isLoggedIn(callback) {
	      return Auth.getCurrentUser(undefined).then(function (user) {
	
	        var is = null;
	        if ($cookies.get('token')) {
	          is = _.get(user, 'role');
	        }
	        safeCb(callback)(is);
	        return is;
	      });
	    },
	    isLoggedInSync: function isLoggedInSync() {
	      return !!_.get(currentUser, 'role');
	    },
	    pathTitle: function pathTitle() {
	      var title = gettextCatalog.getString('Demandes d\'autorisation');
	      var path = $location.path();
	      if (path == '/settings') {
	        title = gettextCatalog.getString('Mot de passe oublié');
	      } else if (path == '/contact') {
	        title = gettextCatalog.getString('Contactez-nous');
	      } else if (path == '/legal') {
	        title = gettextCatalog.getString('Mentions légales');
	      } else if (path == '/permission') {
	        var directive = $location.search().directive;
	        if (directive) {
	          title = gettextCatalog.getString('Demandes d\'autorisation');
	        } else {
	          title = gettextCatalog.getString('Mes projets');
	        }
	      }
	      return title;
	    },
	    hasRole: function hasRole(role, callback) {
	      return Auth.getCurrentUser(undefined).then(function (user) {
	        var has = _hasRole(_.get(user, 'role'), role);
	
	        safeCb(callback)(has);
	        return has;
	      });
	    },
	    hasRoleSync: function hasRoleSync(role) {
	      return _hasRole(_.get(currentUser, 'role'), role);
	    },
	    isAdmin: function isAdmin() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return Auth.hasRole(Reflect.apply([].concat, ['admin'], args));
	    },
	    isAdminSync: function isAdminSync() {
	      return Auth.hasRoleSync('admin');
	    },
	    getToken: function getToken() {
	      return $cookies.get('token');
	    }
	  };
	
	  return Auth;
	}

/***/ }),
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, exports) {

	'use strict';
	
	UserResource.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UserResource = UserResource;
	function UserResource($resource) {
	  'ngInject';
	
	  return $resource('/api/users/:id/:controller', {
	    id: '@id'
	  }, {
	    get: {
	      method: 'GET',
	      params: {
	        id: 'me'
	      }
	    },
	    logout: {
	      method: 'GET',
	      params: {
	        id: 'logout'
	      }
	    },
	
	    changePassword: {
	      method: 'PUT',
	      params: {
	        controller: 'password'
	      }
	    },
	    updateInfo: {
	      method: 'PUT',
	      params: {
	        controller: 'me'
	      }
	    }
	  });
	}

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(24);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _account = __webpack_require__(42);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _settings = __webpack_require__(48);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _forgotten = __webpack_require__(50);
	
	var _forgotten2 = _interopRequireDefault(_forgotten);
	
	var _signup = __webpack_require__(52);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	var _contact = __webpack_require__(54);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	var _legal = __webpack_require__(56);
	
	var _legal2 = _interopRequireDefault(_legal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module("dalApp.account", [_angularUiRouter2.default, _settings2.default, _forgotten2.default, _signup2.default, _contact2.default, _legal2.default]).config(_account2.default).run(['$rootScope', function ($rootScope) {
	  "ngInject";
	
	  $rootScope.$on("$stateChangeStart", function (event, next, nextParams, current) {
	    if (next.name === "logout" && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state("logout", {
	    url: "/logout?referrer",
	    referrer: "main",
	    template: "",
	    controller: ['$state', 'Auth', function controller($state, Auth) {
	      "ngInject";
	
	      var referrer = $state.params.referrer || $state.current.referrer || "main";
	      Auth.logout().then(function () {
	        $state.go(referrer);
	        return;
	      });
	    }]
	  }).state("contact", {
	    url: "/contact",
	    template: __webpack_require__(43),
	    controller: "ContactController",
	    controllerAs: "ct",
	    authenticate: false
	  }).state("legal", {
	    url: "/legal",
	    template: __webpack_require__(44),
	    controller: "LegalController",
	    controllerAs: "legal",
	    authenticate: false
	  }).state("settings", {
	    url: "/settings",
	    template: __webpack_require__(45),
	    controller: "SettingsController",
	    controllerAs: "vm",
	    authenticate: true
	  }).state("forgotten", {
	    url: "/forgotten",
	    template: __webpack_require__(46),
	    controller: "ForgottenController",
	    controllerAs: "vm",
	    authenticate: false
	  }).state("signup", {
	    url: "/signup",
	    template: __webpack_require__(47),
	    controller: "SignupController",
	    controllerAs: "vm",
	    authenticate: false
	  });
	}

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"panel\" ng-if=\"ct.mailSent\">\n    <div class=\"panel-body\">\n      <h3 translate>\n        Votre message a bien été envoyé. Il sera examiné par notre équipe\n        technique qui reviendra vers vous dès que possible.\n      </h3>\n      <hr />\n      <div class=\"pull-right\">\n        <a href=\"/permission\" class=\"btn btn-default\" ng-if=\"ct.isLoggedIn()\">\n          <i class=\"fa fa-folder-open\" aria-hidden=\"true\"></i>\n          <span translate>Revenir à la liste des projets</span>\n        </a>\n        <a href=\"/permission\" class=\"btn btn-danger\" ng-if=\"!ct.isLoggedIn()\">\n          <i class=\"fa fa-sign-in\" aria-hidden=\"true\"></i>\n          <span translate>Se connecter</span>\n        </a>\n      </div>\n      <div class=\"clearfix\"></div>\n    </div>\n  </div>\n\n  <div class=\"row\" ng-if=\"!ct.mailSent\">\n    <div class=\"col-sm-12 col-lg-offset-1 col-lg-10\">\n      <p translate>\n        En cas de difficultés d'utilisation de ce site, n'hésitez pas à remplir\n        le formulaire ci-dessous pour nous signaler votre problème, ou bien\n        appelez-nous au +33 (0) 1 43 59 09 79.\n      </p>\n      <p style=\"font-size: 1em; font-style: italic\">\n        NB : {{\"Ce formulaire ne doit pas être utilisé pour soumettre vos\n        demandes d’autorisation.\"|translate}}\n      </p>\n    </div>\n    <div class=\"col-sm-12 col-lg-offset-1 col-lg-10\">\n      <form class=\"form\" name=\"form\" ng-submit=\"ct.send(form)\" novalidate>\n        <div\n          class=\"form-group\"\n          ng-class=\"{ 'has-error': form.lastname.$invalid && ct.submitted }\"\n        >\n          <label translate>Nom</label> :\n          <input\n            type=\"text\"\n            name=\"lastname\"\n            class=\"form-control\"\n            ng-model=\"ct.mail.lastname\"\n            required\n          />\n        </div>\n\n        <div\n          class=\"form-group\"\n          ng-class=\"{ 'has-error': form.firstname.$invalid && ct.submitted }\"\n        >\n          <label translate>Prénom</label> :\n          <input\n            type=\"text\"\n            name=\"firstname\"\n            class=\"form-control\"\n            ng-model=\"ct.mail.firstname\"\n            required\n          />\n        </div>\n\n        <div\n          class=\"form-group\"\n          ng-class=\"{ 'has-error': form.email.$invalid && ct.submitted }\"\n        >\n          <label translate>E-mail</label> :\n          <input\n            type=\"email\"\n            name=\"email\"\n            class=\"form-control\"\n            ng-model=\"ct.mail.email\"\n            required\n          />\n        </div>\n\n        <div\n          class=\"form-group\"\n          ng-class=\"{ 'has-error': form.title.$invalid && ct.submitted }\"\n        >\n          <label translate>Objet</label> :\n          <input\n            type=\"text\"\n            name=\"title\"\n            class=\"form-control\"\n            ng-model=\"ct.mail.title\"\n            required\n          />\n        </div>\n\n        <div\n          class=\"form-group\"\n          ng-class=\"{ 'has-error': form.content.$invalid && ct.submitted }\"\n        >\n          <label translate>Message</label> :\n          <textarea\n            name=\"content\"\n            rows=\"7\"\n            class=\"form-control\"\n            ng-model=\"ct.mail.content\"\n            required\n          >\n          </textarea>\n        </div>\n\n        <p class=\"has-error\" ng-if=\"ct.errors\">\n          <i class=\"fa fa-info-circle\" aria-hidden=\"true\"></i>\n          <span translate\n            >Un problème est survenu, vous pouvez nous envoyer directement un\n            e-mail à l'adresse</span\n          >\n          Un problème est survenu, vous pouvez nous envoyer directement un\n          e-mail à l'adresse\n          <b\n            ><i><u>adagp@adagp.fr</u></i></b\n          >.\n        </p>\n\n        <div align=\"right\">\n          <button class=\"btn btn-primary\" type=\"submit\" translate>\n            Envoyer\n          </button>\n        </div>\n      </form>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container legal\">\n  <div class=\"panel\">\n    <div class=\"panel-body\" ng-if=\"legal.ls.lang == 'fr' \">\n      <p>\n        Le site est édité par l’ADAGP (Société des Auteurs dans les Arts\n        graphiques et plastiques), société civile à capital variable\n        immatriculée au Registre du Commerce et des Sociétés de Paris sous le\n        numéro D 339 330 722\n      </p>\n\n      <h3>Contact :</h3>\n      <p>\n        ADAGP <br />\n        11, rue Duguay-Trouin <br />\n        75006 Paris <br />\n        France <br />\n\n        Téléphone : +33 1 43 59 09 79 <br />\n        Fax : +33 1 43 59 61 48 <br />\n        E-mail : <a href=\"mailto:adagp@adagp.fr\">adagp@adagp.fr</a> <br />\n      </p>\n\n      <h3>Hébergement :</h3>\n      <p>\n        Le site est hébergé par la société\n        <a href=\"http://www.ovh.com\" target=\"_blank\"> OVH </a>\n      </p>\n\n      <h3>Données à caractère personnel :</h3>\n      <p>\n        Les données soumises par les utilisateurs par l’intermédiaire du\n        formulaire de demande sont utilisées par l’ADAGP aux seules fins du\n        traitement des demandes d’autorisation.\n      </p>\n\n      <p>\n        Ces données sont exclusivement destinées au personnel de l’ADAGP, aux\n        organismes de gestion collective établis dans et hors de l’Union\n        européenne avec lesquels l’ADAGP a conclu un accord de représentation\n        (sociétés sœurs) ainsi qu’aux personnes disposant d’un droit d’accès en\n        application des dispositions légales en vigueur.\n      </p>\n\n      <p>\n        Sous réserve des obligations légales, notamment fiscales, imposant la\n        conservation de certaines informations pour une durée plus longue, les\n        données collectées par l’ADAGP sont conservées jusqu’au terme de\n        l’exploitation faisant l’objet de la demande d’autorisation.\n      </p>\n\n      <p>\n        Conformément à la législation en vigueur, vous disposez, à l’égard des\n        données personnelles vous concernant, d'un droit d'accès, de\n        rectification, d’opposition, de limitation du traitement, d’effacement\n        et de portabilité que vous pouvez exercer en contactant le délégué à la\n        protection des données par courrier postal (ADAGP – Délégué à la\n        protection des données, 11 rue Duguay-Trouin, 75006 Paris), courrier\n        électronique (<a href=\"mailto:dpd@adagp.fr\">dpd@adagp.fr</a>) ou\n        téléphone (+33 (0)1 43 59 09 79).\n      </p>\n\n      <p>\n        Toute réclamation relative aux traitements de données à caractère\n        personnel mis en œuvre par l’ADAGP peut être adressée à la Commission\n        nationale de l’informatique et des libertés (CNIL).\n      </p>\n    </div>\n\n    <div class=\"panel-body\" ng-if=\"legal.ls.lang != 'fr' \">\n      <p>\n        The website is published by ADAGP (Société des Auteurs dans les Arts\n        Graphiques et Plastiques), civil company with variable capital\n        registered in the Paris Register of Companies under number D 339 330\n        722.\n      </p>\n\n      <h3>Contact :</h3>\n      <p>\n        ADAGP <br />\n        11, rue Duguay-Trouin <br />\n        75006 Paris <br />\n        France <br />\n\n        Tel : +33 1 43 59 09 79 <br />\n        Fax : +33 1 43 59 61 48 <br />\n        E-mail : <a href=\"mailto:adagp@adagp.fr\">adagp@adagp.fr</a> <br />\n      </p>\n\n      <h3>Hosting :</h3>\n      <p>\n        The website is hosted by\n        <a href=\"http://www.ovh.com\" target=\"_blank\"> OVH </a>\n      </p>\n\n      <h3>Personal data :</h3>\n      <p>\n        The data supplied by users through the request form are processed by\n        ADAGP for the sole purpose of processing autorisation requests.\n      </p>\n\n      <p>\n        This data are intended for use by the staff of ADAGP, collective\n        management organisations based within and outside the European Union\n        with which ADAGP has signed a representation agreement (sister societes)\n        and persons with an access right according to legal provisions in force.\n      </p>\n\n      <p>\n        Subject to the legal obligations, particularly in relation to tax,\n        providing certain information must be retained for a longer period, the\n        data collected by the ADAGP shall be retained for the duration of the\n        autorisation requested.\n      </p>\n\n      <p>\n        In accordance with the legislation in force, you will be granted the\n        right to access, correct, oppose, limit the processing, deletion and\n        portability of the personal data which concerns you by contacting the\n        data protection officer by post (ADAGP – data protection officer, 11 rue\n        Duguay-Trouin, 75006 Paris), email (<a href=\"mailto:dpd@adagp.fr\"\n          >dpd@adagp.fr</a\n        >) or telephone (+33 (0)1 43 59 09 79).\n      </p>\n\n      <p>\n        All complaints relating to the processing of personal data by ADAGP may\n        be send to the French data protection authority (Commission nationale de\n        l’informatique et des libertés (CNIL)).\n      </p>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	module.exports = "<!--div class=\"container-fluid\" -->\n<div class=\"container\">\n  <div class=\"col-sm-12 col-md-9\">\n    <div>\n      <h2 translate>Modifiez votre mot de passe</h2>\n    </div>\n    <div>\n      <form\n        class=\"form\"\n        name=\"form\"\n        ng-submit=\"vm.changePassword(form)\"\n        novalidate\n      >\n        <div\n          class=\"form-group\"\n          ng-class=\"{'has-error': form.password.$invalid && vm.submitted }\"\n        >\n          <label translate>Mot de passe actuel</label>\n\n          <input\n            type=\"password\"\n            name=\"password\"\n            class=\"form-control\"\n            ng-model=\"vm.user.oldPassword\"\n            mongoose-error\n            ng-change=\"form.password.$setValidity('mongoose', true)\"\n          />\n          <p class=\"help-block\" ng-show=\"form.password.$error.mongoose\">\n            {{ vm.errors.password }}\n          </p>\n        </div>\n\n        <div\n          class=\"form-group\"\n          ng-class=\"{'has-error': form.newPassword.$invalid && vm.submitted }\"\n        >\n          <label translate>Nouveau mot de passe</label>\n\n          <input\n            type=\"password\"\n            name=\"newPassword\"\n            class=\"form-control\"\n            ng-model=\"vm.user.newPassword\"\n            ng-minlength=\"7\"\n            required\n            ng-change=\"form.newPassword.$setValidity('mongoose', true)\"\n          />\n          <!--p class=\"help-block\" translate\n             ng-show=\"(form.newPassword.$error.minlength || form.newPassword.$error.required)\n              && (form.newPassword.$dirty || vm.submitted)\">\n            Le mot de passe doit être de 7 caractères au minimum.\n          </p-->\n          <p class=\"help-block\" ng-show=\"form.newPassword.$error.mongoose\">\n            {{ vm.errors.newPassword }}\n          </p>\n          <p class=\"help-block\">\n            <i class=\"fa fa-info-circle\" aria-hidden=\"true\"></i>\n            <span translate\n              >Votre mot de passe doit comporter au moins 7 caractères et doit\n              comporter au moins une majuscule et un caractère numérique ou de\n              ponctuation.</span\n            >\n          </p>\n        </div>\n\n        <div\n          class=\"form-group\"\n          ng-class=\"{'has-error': form.confirmPassword.$invalid && vm.submitted }\"\n        >\n          <label translate>Confirmez votre nouveau mot de passe</label>\n\n          <input\n            type=\"password\"\n            name=\"confirmPassword\"\n            class=\"form-control\"\n            ng-model=\"vm.user.confirmPassword\"\n            match=\"vm.user.newPassword\"\n            required=\"\"\n            ng-change=\"form.confirmPassword.$setValidity('mongoose', true)\"\n          />\n          <p\n            class=\"help-block\"\n            ng-show=\"form.confirmPassword.$error.match && vm.submitted\"\n            translate\n          >\n            Les mots de passe doivent être identiques.\n          </p>\n        </div>\n\n        <!--p class=\"help-block\" style=\"color:green\"> {{ vm.message }} </p-->\n\n        <div align=\"right\">\n          <button class=\"btn btn-primary\" type=\"submit\" translate>\n            Modifier\n          </button>\n          <a href=\"/permission\" class=\"btn btn-default\" translate>Fermer</a>\n        </div>\n      </form>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"main-container\" class=\"container-fluid\">\n  <div class=\"panel panel-dal\" ng-if=\"!vm.resetPasswordView\">\n    <div class=\"panel-body\">\n      <h2 class=\"main-header-title\">\n        <img\n          src=\"assets/images/logo_adagp_64.png\"\n          alt=\"Logo\"\n          class=\"main-logo\"\n        />\n        {{\"Mot de passe oublié\"|translate}}\n      </h2>\n      <div ng-if=\"!vm.forgottenMailSend\">\n        <p class=\"main-header-text\" translate>\n          Si vous avez oublié votre mot de passe, veuillez saisir votre email\n          afin de recevoir un email contenant les instructions pour\n          réinitialiser votre mot de passe.\n        </p>\n        <form class=\"form\" name=\"form_forgotten\" novalidate>\n          <div\n            class=\"form-group\"\n            ng-class=\"{ 'has-success': form_forgotten.email.$valid && vm.submittedForgotten, 'has-error': form_forgotten.email.$invalid && vm.submittedForgotten }\"\n          >\n            <!--label>{{'Veuillez saisir votre e-mail'|translate}}: </label-->\n            <input\n              type=\"email\"\n              name=\"email\"\n              class=\"form-control input-lg\"\n              ng-model=\"vm.user.email\"\n              required\n              placeholder=\"{{'E-mail'|translate}}\"\n            />\n          </div>\n          <div class=\"form-group has-error\">\n            <p\n              class=\"help-block\"\n              ng-show=\"(form_forgotten.email.$error.required ||\n            form_forgotten.email.$error.email) && vm.submittedForgotten\"\n              translate\n            >\n              Veuillez saisir une adresse e-mail valide.\n            </p>\n            <p\n              class=\"help-block\"\n              ng-show=\"vm.errors.forgotten && vm.submittedForgotten\"\n            >\n              {{vm.errors.forgotten}}\n            </p>\n          </div>\n          <div class=\"form-group\">\n            <button\n              class=\"btn btn-danger btn-lg btn-block\"\n              ng-click=\"vm.generateLink(form_forgotten)\"\n              ng-disabled=\"vm.generateLinkOnProcess\"\n              translate\n            >\n              Réinitialiser\n            </button>\n          </div>\n        </form>\n      </div>\n\n      <div ng-if=\"vm.forgottenMailSend\">\n        <p class=\"main-header-text\" translate>\n          Un email vous permettant de renouveler votre mot de passe a été envoyé\n          à votre adresse e-mail.\n        </p>\n        <div align=\"right\">\n          <a href=\"/\" class=\"btn btn-danger\">OK</a>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <!------------------------------------------------------------>\n\n  <div class=\"panel panel-dal\" ng-if=\"vm.resetPasswordView\">\n    <div class=\"panel-body\">\n      <h2 class=\"main-header-title\" align=\"center\">\n        {{\"Mot de passe\"|translate}}\n        <img\n          src=\"assets/images/logo_adagp_64.png\"\n          alt=\"Logo\"\n          class=\"main-logo\"\n        />\n      </h2>\n      <div ng-if=\"vm.passwordChanged\">\n        <p class=\"main-header-text\" translate>\n          Votre mot de passe a bien été modifié.\n        </p>\n        <div align=\"right\">\n          <a href=\"/\" class=\"btn btn-danger\">OK</a>\n        </div>\n      </div>\n      <div ng-if=\"!vm.passwordChanged\">\n        <p class=\"main-header-text\" translate>\n          Veuillez saisir votre nouveau mot de passe.\n        </p>\n        <form class=\"form\" name=\"form_reset\" novalidate>\n          <div\n            class=\"form-group\"\n            ng-class=\"{ 'has-success': form_reset.password.$valid && vm.submittedReset,\n          'has-error': (form_reset.password.$invalid || vm.getStrength(vm.user.password)<3) && vm.submittedReset }\"\n          >\n            <div ng-class=\"[vm.user.password?'input-group':'']\">\n              <input\n                type=\"password\"\n                name=\"password\"\n                class=\"form-control input-lg\"\n                ng-model=\"vm.user.password\"\n                placeholder=\"{{'Nouveau mot de passe'|translate}}\"\n                required\n                mongoose-error\n                ng-change=\"form_reset.password.$setValidity('mongoose', true)\"\n              />\n              <span class=\"input-group-addon\" ng-if=\"vm.user.password\">\n                <i\n                  class=\"fa fa-check\"\n                  ng-if=\"vm.getStrength(vm.user.password)>=3\"\n                  style=\"color: green\"\n                ></i>\n                <i\n                  class=\"fa fa-exclamation-triangle\"\n                  ng-if=\"vm.getStrength(vm.user.password)<3\"\n                  style=\"color: red\"\n                ></i>\n              </span>\n            </div>\n            <p\n              class=\"help-block\"\n              ng-show=\"form_reset.password.$error.required && vm.submittedReset\"\n              translate\n            >\n              Veuillez saisir un mot de passe.\n            </p>\n            <p class=\"help-block\" ng-show=\"form_reset.password.$error.mongoose\">\n              {{ vm.errors.password }}\n            </p>\n          </div>\n\n          <!--div class=\"form-group\" ng-class=\"{ 'has-success': form_reset.password.$valid && vm.submittedReset,\n          'has-error': form_reset.password.$invalid && vm.submittedReset }\">\n            <input type=\"password\" name=\"password\" class=\"form-control input-lg\" ng-model=\"vm.user.password\"\n            ng-minlength=\"7\" placeholder=\"{{'Nouveau mot de passe'|translate}}\" required mongoose-error\n            ng-change=\"form_reset.password.$setValidity('mongoose', true)\"/>\n            <p class=\"help-block\" ng-show=\"form_reset.password.$error.mongoose\">\n              {{ vm.errors.password }}\n            </p>\n          </div-->\n\n          <div\n            class=\"form-group\"\n            ng-class=\"{ 'has-success': form_reset.confirmPassword.$valid && vm.submittedReset,\n                                              'has-error': form_reset.confirmPassword.$invalid && vm.submittedReset }\"\n          >\n            <div\n              ng-class=\"[(vm.user.confirmPassword && vm.user.confirmPassword==vm.user.password)?'input-group':'']\"\n            >\n              <input\n                type=\"password\"\n                name=\"confirmPassword\"\n                class=\"form-control input-lg\"\n                ng-model=\"vm.user.confirmPassword\"\n                match=\"vm.user.password\"\n                required\n                placeholder=\"{{'Confirmez votre mot de passe'|translate}}\"\n              />\n              <span class=\"input-group-addon\" ng-if=\"vm.user.confirmPassword\">\n                <i\n                  class=\"fa fa-check\"\n                  ng-if=\"vm.user.confirmPassword==vm.user.password\"\n                  style=\"color: green\"\n                ></i>\n              </span>\n            </div>\n            <p\n              class=\"help-block\"\n              translate\n              ng-show=\"form_reset.confirmPassword.$error.match && vm.submittedReset\"\n            >\n              Les mots de passe doivent être identiques.\n            </p>\n          </div>\n\n          <p class=\"help-block\">\n            <i class=\"fa fa-info-circle\" aria-hidden=\"true\"></i>\n            <span translate\n              >Votre mot de passe doit comporter au minimum 7 caractères\n              comprenant au moins 3 des catégories suivantes : majuscules /\n              minuscules / chiffres / caractères spéciaux (ponctuation)</span\n            >\n          </p>\n\n          <div class=\"form-group has-error\">\n            <p class=\"help-block\">{{ vm.errors.resetPassword }}</p>\n          </div>\n          <div class=\"form-group\" align=\"right\">\n            <button\n              class=\"btn btn-danger btn-lg btn-block\"\n              translate\n              ng-click=\"vm.resetPassword(form_reset)\"\n            >\n              Envoyer\n            </button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div>\n\n  <p align=\"right\">\n    <a href=\"/signup\" translate>Inscription</a> |\n    <a href=\"/login\" translate>Connexion</a>\n  </p>\n  <!--div class=\"panel panel-dal\">\n    <div class=\"panel-body\">\n      <p  class=\"main-header-text\">\n        {{\"Si vous avez déjà créé un compte veuillez-vous identifier\"|translate}}.\n      </p>\n      <a href=\"/\" class=\"btn btn-danger btn-lg btn-block\" translate> Se connecter</a>\n\n    </div>\n  </div-->\n</div>\n"

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"main-container\" class=\"container-fluid\">\n  <div class=\"panel panel-dal\">\n    <div class=\"panel-body\">\n      <h2 class=\"main-header-title\">\n        <img\n          src=\"assets/images/logo_adagp_64.png\"\n          alt=\"Logo\"\n          class=\"main-logo\"\n        />\n        {{\"Inscription\"|translate}}\n      </h2>\n      <p class=\"main-header-text\" translate>\n        Veuillez saisir votre email et un mot de passe pour créer le compte qui\n        vous permettra de gérer vos demandes d'autorisation\n      </p>\n      <form class=\"form\" name=\"form_signup\" novalidate>\n        <!--div class=\"form-group\" ng-class=\"{ 'has-success': form_signup.alias.$valid && vm.submitted,\n                                            'has-error': form_signup.alias.$invalid && vm.submitted }\">\n          <label>{{'Pseudo'|translate}}: </label>\n\n          <input type=\"text\" name=\"alias\" class=\"form-control\" ng-model=\"vm.user.alias\"\n                 required/>\n          <p class=\"help-block\" ng-show=\"form_signup.alias.$error.required && vm.submitted\" translate>\n            Veuillez saisir votre pseudo\n          </p>\n        </div-->\n\n        <div\n          class=\"form-group\"\n          ng-class=\"{ 'has-success': form_signup.email.$valid && vm.submitted,\n                                            'has-error': form_signup.email.$invalid && vm.submitted }\"\n        >\n          <!--label>{{'E-mail'|translate}}: </label-->\n\n          <input\n            type=\"email\"\n            name=\"email\"\n            class=\"form-control input-lg\"\n            ng-model=\"vm.user.email\"\n            required\n            mongoose-error\n            placeholder=\"{{'E-mail'|translate}}\"\n            ng-change=\"form_signup.email.$setValidity('mongoose', true)\"\n          />\n          <p\n            class=\"help-block\"\n            ng-show=\"form_signup.email.$error.email && vm.submitted\"\n            translate\n          >\n            Veuillez saisir une adresse e-mail valide.\n          </p>\n          <p\n            class=\"help-block\"\n            ng-show=\"form_signup.email.$error.required && vm.submitted\"\n            translate\n          >\n            Veuillez saisir votre adresse e-mail.\n          </p>\n          <p class=\"help-block\" ng-show=\"form_signup.email.$error.mongoose\">\n            {{ vm.errors.email }}\n          </p>\n        </div>\n\n        <div\n          class=\"form-group\"\n          ng-class=\"{ 'has-success': form_signup.password.$valid && vm.submitted,\n        'has-error': (form_signup.password.$invalid || vm.getStrength(vm.user.password)<3) && vm.submitted }\"\n        >\n          <div ng-class=\"[vm.user.password?'input-group':'']\">\n            <input\n              type=\"password\"\n              name=\"password\"\n              class=\"form-control input-lg\"\n              ng-model=\"vm.user.password\"\n              required\n              mongoose-error\n              placeholder=\"{{'Mot de passe'|translate}}\"\n              ng-change=\"form_signup.password.$setValidity('mongoose', true)\"\n            />\n            <span class=\"input-group-addon\" ng-if=\"vm.user.password\">\n              <i\n                class=\"fa fa-check\"\n                ng-if=\"vm.getStrength(vm.user.password)>=3\"\n                style=\"color: green\"\n              ></i>\n              <i\n                class=\"fa fa-exclamation-triangle\"\n                ng-if=\"vm.getStrength(vm.user.password)<3\"\n                style=\"color: red\"\n              ></i>\n            </span>\n          </div>\n\n          <p\n            class=\"help-block\"\n            ng-show=\"form_signup.password.$error.required && vm.submitted\"\n            translate\n          >\n            Veuillez saisir un mot de passe.\n          </p>\n          <!--p class=\"help-block\" ng-show=\"! form_signup.password.$error.required &&\n          vm.getStrength(vm.user.password)<3 && vm.submitted\" translate>\n            Votre mot de passe n'est pas assez robuste.\n          </p-->\n          <p class=\"help-block\" ng-show=\"form_signup.password.$error.mongoose\">\n            {{ vm.errors.password }}\n          </p>\n        </div>\n\n        <div\n          class=\"form-group\"\n          ng-class=\"{ 'has-success': form_signup.confirmPassword.$valid && vm.submitted,\n        'has-error': form_signup.confirmPassword.$invalid && vm.submitted }\"\n        >\n          <div\n            ng-class=\"[(vm.user.confirmPassword && vm.user.confirmPassword==vm.user.password)?'input-group':'']\"\n          >\n            <input\n              type=\"password\"\n              name=\"confirmPassword\"\n              class=\"form-control input-lg\"\n              ng-model=\"vm.user.confirmPassword\"\n              match=\"vm.user.password\"\n              required\n              placeholder=\"{{'Confirmez votre mot de passe'|translate}}\"\n            />\n            <span class=\"input-group-addon\" ng-if=\"vm.user.confirmPassword\">\n              <i\n                class=\"fa fa-check\"\n                ng-if=\"vm.user.confirmPassword==vm.user.password\"\n                style=\"color: green\"\n              ></i>\n            </span>\n          </div>\n\n          <p\n            class=\"help-block\"\n            ng-show=\"form_signup.confirmPassword.$error.match && vm.submitted\"\n            translate\n          >\n            Les mots de passe doivent être identiques.\n          </p>\n        </div>\n\n        <p class=\"help-block\">\n          <i class=\"fa fa-info-circle\" aria-hidden=\"true\"></i>\n          <span translate\n            >Votre mot de passe doit comporter au minimum 7 caractères\n            comprenant au moins 3 des catégories suivantes : majuscules /\n            minuscules / chiffres / caractères spéciaux (ponctuation)</span\n          >\n        </p>\n\n        <button\n          class=\"btn btn-danger btn-lg btn-block\"\n          ng-click=\"vm.register(form_signup)\"\n          translate\n        >\n          S'inscrire\n        </button>\n      </form>\n    </div>\n  </div>\n\n  <div class=\"panel panel-dal\">\n    <div class=\"panel-body\">\n      <p class=\"main-header-text\" translate>\n        Si vous avez déjà créé un compte, veuillez vous identifier\n      </p>\n      <a href=\"/\" class=\"btn btn-danger btn-lg btn-block\" translate>\n        Se connecter</a\n      >\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _settings = __webpack_require__(49);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module("dalApp.settings", []).controller("SettingsController", _settings2.default).name;

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SettingsController = function () {
	
	  /*@ngInject*/
	  SettingsController.$inject = ['Auth', 'gettextCatalog', 'LanguageService', 'Modal'];
	  function SettingsController(Auth, gettextCatalog, LanguageService, Modal) {
	    _classCallCheck(this, SettingsController);
	
	    this.user = {
	      oldPassword: "",
	      newPassword: "",
	      confirmPassword: ""
	    };
	    this.errors = {
	      other: undefined
	    };
	    this.message = "";
	    this.submitted = false;
	
	    this.Auth = Auth;
	    this.gettextCatalog = gettextCatalog;
	    this.ls = LanguageService;
	    this.Modal = Modal;
	  }
	
	  _createClass(SettingsController, [{
	    key: "changePassword",
	    value: function changePassword(form) {
	      var _this = this;
	
	      this.submitted = true;
	      var that = this;
	      if (form.$valid) {
	        this.Auth.changePassword(this.user.oldPassword, this.user.newPassword).then(function () {
	          _this.Modal.confirm.info(function () {})(_this.gettextCatalog.getString("Mot de passe"), _this.gettextCatalog.getString("Votre mot de passe a bien été modifié."), "OK", "primary");
	        }).catch(function (err) {
	
	          err = err.data;
	          _this.errors = {};
	
	          if (err.name == "dal-error") {
	            for (var fname in err.fields) {
	              if (err.fields.hasOwnProperty(fname)) {
	                form[fname].$setValidity("mongoose", false);
	                _this.errors[fname] = _this.ls.lang == "fr" ? err.fr : err.en;
	              }
	            }
	          } else {
	            for (var fname in err.fields) {
	              if (err.fields.hasOwnProperty(fname)) {
	                form[fname].$setValidity("mongoose", false);
	                _this.errors[fname] = err.message;
	              }
	            }
	          }
	        });
	      }
	    }
	  }]);
	
	  return SettingsController;
	}();
	
	exports.default = SettingsController;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _forgotten = __webpack_require__(51);
	
	var _forgotten2 = _interopRequireDefault(_forgotten);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module("dalApp.forgotten", []).controller("ForgottenController", _forgotten2.default).name;

/***/ }),
/* 51 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ForgottenController = function () {
	
	  /*@ngInject*/
	  ForgottenController.$inject = ['$http', '$location', 'gettextCatalog', 'LanguageService', 'PasswordService'];
	  function ForgottenController($http, $location, gettextCatalog, LanguageService, PasswordService) {
	    "ngInject";
	
	    _classCallCheck(this, ForgottenController);
	
	    this.errors = {
	      forgotten: undefined
	    };
	    this.submittedForgotten = false;
	    this.submittedReset = false;
	    this.submitted = false;
	    this.forgottenMailSend = false;
	    this.$http = $http;
	    this.location = $location;
	    this.gettextCatalog = gettextCatalog;
	    this.ls = LanguageService;
	    this.getStrength = PasswordService.getStrength;
	
	    this.parameters = $location.search();
	    if (this.parameters && this.parameters.data) {
	      this.resetPasswordView = true;
	    }
	  }
	
	  _createClass(ForgottenController, [{
	    key: "generateLink",
	    value: function generateLink(form) {
	      var _this = this;
	
	      this.submittedForgotten = true;
	
	      if (form.$valid) {
	        this.generateLinkOnProcess = true;
	        this.$http.post("api/users/generate-link/", {
	          email: this.user.email
	        }).then(function () {
	          _this.forgottenMailSend = true;
	          _this.generateLinkOnProcess = false;
	        }).catch(function (err) {
	          _this.generateLinkOnProcess = false;
	          if (err.status == 404) {
	            _this.errors.forgotten = _this.gettextCatalog.getString("Adresse e-mail introuvable.");
	          } else if (err.status == 500) {
	            _this.errors.forgotten = _this.gettextCatalog.getString("Une erreur technique est survenue durant le traitement de votre requête.");
	          }
	        });
	      }
	    }
	  }, {
	    key: "resetPassword",
	    value: function resetPassword(form) {
	      var _this2 = this;
	
	      this.submittedReset = true;
	
	      if (form.$valid && this.parameters.data) {
	        this.$http.put("api/users/reset-password/", {
	          data: this.parameters.data,
	          newPassword: this.user.password
	        }).then(function () {
	          _this2.passwordChanged = true;
	        }).catch(function (err) {
	          if (err && err.data) {
	            err = err.data;
	            _this2.errors = {};
	
	            if (err.name == "dal-error") {
	              for (var fname in err.fields) {
	                if (err.fields.hasOwnProperty(fname)) {
	                  form[fname].$setValidity("mongoose", false);
	                  _this2.errors[fname] = _this2.ls.lang == "fr" ? err.fr : err.en;
	                }
	              }
	            } else if (err.name == "dal-error-text") {
	              _this2.errors.resetPassword = _this2.ls.lang == "fr" ? err.fr : err.en;
	            } else {
	              for (var fname in err.fields) {
	                if (err.fields.hasOwnProperty(fname)) {
	                  form[fname].$setValidity("mongoose", false);
	                  _this2.errors[fname] = err.message;
	                }
	              }
	            }
	          }
	        });
	      }
	    }
	  }]);
	
	  return ForgottenController;
	}();
	
	exports.default = ForgottenController;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _signup = __webpack_require__(53);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module("dalApp.signup", []).controller("SignupController", _signup2.default).name;

/***/ }),
/* 53 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SignupController = function () {
	  SignupController.$inject = ['Auth', '$state', 'LanguageService', 'PasswordService'];
	  function SignupController(Auth, $state, LanguageService, PasswordService) {
	    "ngInject";
	
	    _classCallCheck(this, SignupController);
	
	    this.user = {
	      email: "",
	      password: "",
	      confirmPassword: ""
	    };
	    this.errors = {};
	    this.submitted = false;
	    this.Auth = Auth;
	    this.$state = $state;
	    this.ls = LanguageService;
	    this.getStrength = PasswordService.getStrength;
	  }
	
	  _createClass(SignupController, [{
	    key: "register",
	    value: function register(form) {
	      var _this = this;
	
	      this.submitted = true;
	
	      if (form.$valid) {
	        this.Auth.createUser({
	          email: this.user.email,
	          password: this.user.password
	        }).then(function () {
	          _this.$state.go("permission");
	        }).catch(function (err) {
	          err = err.data;
	          _this.errors = {};
	
	          if (err.name == "dal-error") {
	            for (var fname in err.fields) {
	              if (err.fields.hasOwnProperty(fname)) {
	                form[fname].$setValidity("mongoose", false);
	                _this.errors[fname] = _this.ls.lang == "fr" ? err.fr : err.en;
	              }
	            }
	          } else {
	            for (var fname in err.fields) {
	              if (err.fields.hasOwnProperty(fname)) {
	                form[fname].$setValidity("mongoose", false);
	                _this.errors[fname] = err.message;
	              }
	            }
	          }
	        });
	      }
	    }
	  }]);
	
	  return SignupController;
	}();
	
	exports.default = SignupController;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _contact = __webpack_require__(55);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module("dalApp.contact", []).controller("ContactController", _contact2.default).name;

/***/ }),
/* 55 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ContactController = function () {
	
	  /*@ngInject*/
	  ContactController.$inject = ['$http', 'Auth'];
	  function ContactController($http, Auth) {
	    _classCallCheck(this, ContactController);
	
	    this.mail = {
	      title: "",
	      content: "",
	      firstname: "",
	      lastname: "",
	      email: ""
	    };
	    this.submitted = false;
	
	    this.isLoggedIn = Auth.isLoggedInSync;
	    this.$http = $http;
	    this.mailSent = false;
	  }
	
	  _createClass(ContactController, [{
	    key: "send",
	    value: function send(form) {
	      var that = this;
	      this.submitted = true;
	      this.errors = false;
	      this.mailSent = false;
	      if (form.$valid) {
	        this.$http.post("api/users/send-mail", this.mail).then(function () {
	          that.mailSent = true;
	        }).catch(function (err) {
	          that.errors = true;
	        });
	      }
	    }
	  }]);
	
	  return ContactController;
	}();
	
	exports.default = ContactController;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _legal = __webpack_require__(57);
	
	var _legal2 = _interopRequireDefault(_legal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module("dalApp.legal", []).controller("LegalController", _legal2.default).name;

/***/ }),
/* 57 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LegalController =
	/*@ngInject*/
	['LanguageService', function LegalController(LanguageService) {
	  _classCallCheck(this, LegalController);
	
	  this.ls = LanguageService;
	  this.message = "test jilfkjgilj";
	}];
	
	exports.default = LegalController;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _permission = __webpack_require__(59);
	
	var _permission2 = _interopRequireDefault(_permission);
	
	var _permission3 = __webpack_require__(61);
	
	var _permission4 = _interopRequireDefault(_permission3);
	
	var _condition = __webpack_require__(63);
	
	var _condition2 = _interopRequireDefault(_condition);
	
	var _board = __webpack_require__(133);
	
	var _board2 = _interopRequireDefault(_board);
	
	var _introduction = __webpack_require__(135);
	
	var _introduction2 = _interopRequireDefault(_introduction);
	
	var _project = __webpack_require__(137);
	
	var _project2 = _interopRequireDefault(_project);
	
	var _product = __webpack_require__(139);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _identification = __webpack_require__(141);
	
	var _identification2 = _interopRequireDefault(_identification);
	
	var _client = __webpack_require__(144);
	
	var _client2 = _interopRequireDefault(_client);
	
	var _share = __webpack_require__(147);
	
	var _share2 = _interopRequireDefault(_share);
	
	var _duplicate = __webpack_require__(149);
	
	var _duplicate2 = _interopRequireDefault(_duplicate);
	
	var _validation = __webpack_require__(151);
	
	var _validation2 = _interopRequireDefault(_validation);
	
	var _product3 = __webpack_require__(153);
	
	var _product4 = _interopRequireDefault(_product3);
	
	var _project3 = __webpack_require__(154);
	
	var _project4 = _interopRequireDefault(_project3);
	
	var _identification3 = __webpack_require__(155);
	
	var _identification4 = _interopRequireDefault(_identification3);
	
	var _jqueryMatchHeight = __webpack_require__(156);
	
	var _jqueryMatchHeight2 = _interopRequireDefault(_jqueryMatchHeight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var angular = __webpack_require__(1);
	var uiRouter = __webpack_require__(24);
	
	exports.default = angular.module("dalApp.permission", [uiRouter, _board2.default, _condition2.default, _introduction2.default, _project2.default, _project4.default, _product2.default, _product4.default, _identification2.default, _identification4.default, _client2.default, _share2.default, _duplicate2.default, _validation2.default]).config(_permission2.default).controller("PermissionController", _permission4.default).name;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state("permission", {
	    url: "/permission",
	    template: __webpack_require__(60),
	    controller: "PermissionController",
	    controllerAs: "permissionCtrl",
	    authenticate: true
	  });
	}

/***/ }),
/* 60 */
/***/ (function(module, exports) {

	module.exports = "<!-- container-fluid col-sm-12 col-lg-offset-1 col-lg-10 -->\n<div style=\"margin-top:50px;\">\n  <div id=\"permission-tabset\" ng-if=\"permissionCtrl.arrow.activeDir!=null\">\n    <uib-tabset active=\"permissionCtrl.arrow.activeDir\" justified=\"false\" type=\"pills\">\n\n      <uib-tab index=\"0\" class=\"permission-li start-tabset\"\n        select=\"permissionCtrl.arrow.goto(0)\" disable=\"true\"\n        ng-show=\"!permissionCtrl.isMobile ||(permissionCtrl.isMobile && permissionCtrl.arrow.activeDir == 0 )\">\n        <uib-tab-heading><span class=\"badge\" ng-if=\"permissionCtrl.arrow.activeDir==0\">1</span>\n          {{\"Introduction\"|translate}}\n          <span ng-if=\"!permissionCtrl.isMobile\" class=\"permission-next\"><i class=\"fa fa-caret-right fa-lg\" aria-hidden=\"true\"></i></span>\n        </uib-tab-heading>\n        <div class=\"permission-tab-panel\">\n          <introduction ng-if=\"permissionCtrl.arrow.directive=='introduction'\"></introduction>\n        </div>\n      </uib-tab>\n\n      <uib-tab index=\"1\" class=\"permission-li\"\n        select=\"permissionCtrl.arrow.goto(1)\" disable=\"true\"\n        ng-show=\"!permissionCtrl.isMobile ||(permissionCtrl.isMobile && permissionCtrl.arrow.activeDir == 1)\">\n        <uib-tab-heading><span class=\"badge\" ng-if=\"permissionCtrl.arrow.activeDir==1\">2</span>\n          {{\"Projet\"|translate}}\n          <span ng-if=\"!permissionCtrl.isMobile\" class=\"permission-next\"><i class=\"fa fa-caret-right fa-lg\" aria-hidden=\"true\"></i>\n        </uib-tab-heading>\n        <div class=\"permission-tab-panel \">\n          <project ng-if=\"permissionCtrl.arrow.directive=='project'\"></project>\n        </div>\n      </uib-tab>\n\n      <uib-tab index=\"2\" class=\"permission-li\"\n        select=\"permissionCtrl.arrow.goto(2)\" disable=\"true\"\n        ng-show=\"!permissionCtrl.isMobile ||(permissionCtrl.isMobile && permissionCtrl.arrow.activeDir == 2 )\">\n        <uib-tab-heading><span class=\"badge\" ng-if=\"permissionCtrl.arrow.activeDir==2\">3</span>\n          {{\"Utilisation\"|translate}}\n          <span ng-if=\"!permissionCtrl.isMobile\" class=\"permission-next\"><i class=\"fa fa-caret-right fa-lg\" aria-hidden=\"true\"></i>\n        </uib-tab-heading>\n        <div class=\"permission-tab-panel \">\n          <product ng-if=\"permissionCtrl.arrow.directive=='product'\"></product>\n        </div>\n      </uib-tab>\n\n      <uib-tab index=\"3\" class=\"permission-li\"\n      select=\"permissionCtrl.arrow.goto(3)\" disable=\"true\"\n      ng-show=\"!permissionCtrl.isMobile ||(permissionCtrl.isMobile && permissionCtrl.arrow.activeDir == 3 )\">\n        <uib-tab-heading><span class=\"badge\" ng-if=\"permissionCtrl.arrow.activeDir==3\">4</span>\n          {{\"Coordonnées\"|translate}}\n          <span ng-if=\"!permissionCtrl.isMobile\" class=\"permission-next\"><i class=\"fa fa-caret-right fa-lg\" aria-hidden=\"true\"></i>\n        </uib-tab-heading>\n        <div class=\"permission-tab-panel \">\n          <identification ng-if=\"permissionCtrl.arrow.directive=='identification'\"></identification>\n        </div>\n      </uib-tab>\n\n      <uib-tab index=\"4\" class=\"permission-li\"\n      select=\"permissionCtrl.arrow.goto(4)\" disable=\"true\"\n      ng-show=\"!permissionCtrl.isMobile ||(permissionCtrl.isMobile && permissionCtrl.arrow.activeDir == 4 )\">\n        <uib-tab-heading><span class=\"badge\" ng-if=\"permissionCtrl.arrow.activeDir==4\">5</span>\n          {{\"Récapitulatif\"|translate}}\n          <span ng-if=\"!permissionCtrl.isMobile\" class=\"permission-next\"><i class=\"fa fa-caret-right fa-lg\" aria-hidden=\"true\"></i>\n        </uib-tab-heading>\n        <div class=\"permission-tab-panel \">\n          <validation ng-if=\"permissionCtrl.arrow.directive=='validation'\"></validation>\n        </div>\n      </uib-tab>\n\n      <uib-tab index=\"5\" class=\"permission-li end-tabset\"\n      ng-show=\"!permissionCtrl.isMobile ||(permissionCtrl.isMobile && permissionCtrl.arrow.activeDir == 5)\"\n        select=\"permissionCtrl.arrow.goto(5)\" disable=\"true\">\n        <uib-tab-heading>\n          <span class=\"badge\" ng-if=\"permissionCtrl.arrow.activeDir==5\">6</span>\n          {{\"Confirmation\"|translate}}\n        </uib-tab-heading>\n        <div id=\"tab-confirmation\" class=\"container\">\n          <div class=\"panel panel-default permission-panel\">\n            <div class=\"panel-body\">\n              <h3 translate>Votre demande d’autorisation a bien été transmise au service concerné.</h3>\n\n              <hr>\n              <div style=\"text-align: justify;\" >\n                <p translate>\n                  Nous reviendrons vers vous très prochainement pour vous tenir informé de l’avancement\n                  de votre demande. Vous pourrez dès à présent prendre connaissance :\n                </p>\n                <ul class=\"ul-confirmation\">\n                  <li>\n                    <span translate>des copyrights applicables à chacun des auteurs représentés par l’ADAGP et qui devront\n                    figurer dans les légendes complètes des œuvres. Les copyrights à indiquer se trouvent\n                    dans la partie « Mentions obligatoires » (bas de page) dans les résultats de votre recherche\n                    effectuée dans le formulaire</span> <a href=\"http://www.adagp.fr/fr/mysearch/rp_rights\" target=\"_blank\" translate>\n                    Répertoire droit de reproduction</a>.\n                  </li>\n                  <li>\n                    <a href=\"http://www.adagp.fr/fr/jutilise-ou-vends-une-oeuvre/ma-boite-outils/tarifs\" target=\"_blank\" translate>\n                    des principes directeurs de l’ADAGP et des tarifs applicables</a>\n                  </li>\n                </ul>\n                <p ng-if=\"permissionCtrl.lang=='fr'\">\n                  Si vous souhaitez obtenir une autorisation pour un autre produit relevant du projet pour lequel vous venez\n                  d’effectuer une demande (exemple : vous effectuez plusieurs demandes dans le cadre d’une exposition),\n                  merci de cliquer sur « Faire une nouvelle demande ». Si vous souhaitez effectuer une demande dans le cadre\n                  d’un autre projet, merci de cliquer sur « Revenir à la liste des projets » et de créer si nécessaire un\n                  nouveau projet\n                </p>\n              </div>\n              <div class=\"pull-right\" >\n                <button type=\"button\" class=\"btn btn-primary \" ng-disabled=\"permissionCtrl.disabledDuplicatedButton\"\n                  ng-click=\"permissionCtrl.duplicateConfirmedDemand()\">\n                  <i class=\"fa fa-file-text\" aria-hidden=\"true\"></i>\n                  {{\"Copier les auteurs et les œuvres dans une nouvelle demande\"|translate}}\n                </button>\n                <button type=\"button\" class=\"btn btn-primary \"\n                  ng-click=\"permissionCtrl.openNewDemand()\">\n                  <i class=\"fa fa-file-text\" aria-hidden=\"true\"></i> {{\"Faire une nouvelle demande\"|translate}}\n                </button>\n                <a href=\"/permission\" class=\"btn btn-default \">\n                  <i class=\"fa fa-folder-open\" aria-hidden=\"true\"></i>{{\"Revenir à la liste des projets\"|translate}}\n                </a>\n              </div>\n              <div class='clearfix'></div>\n            </div>\n          </div>\n\n        </div>\n      </uib-tab>\n    </uib-tabset>\n  </div>\n\n  <board ng-if=\"permissionCtrl.arrow.directive=='board'\"></board>\n\n</div>\n"

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(62);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PermissionController = function () {
	  /*@ngInject*/
	  PermissionController.$inject = ['screenSize', '$rootScope', 'arrow', '$location', 'LanguageService', 'Auth', '$uibModal', '$http', 'ProductAPI', 'Modal', 'gettextCatalog'];
	  function PermissionController(screenSize, $rootScope, arrow, $location, LanguageService, Auth, $uibModal, $http, ProductAPI, Modal, gettextCatalog) {
	    "ngInject";
	
	    _classCallCheck(this, PermissionController);
	
	    (0, _jquery2.default)("#permission-tabset .nav-pills > li > a").addClass("btn-arrow-right");
	
	    Auth.getCurrentUser(undefined).then(function (user) {
	      if (user.language !== LanguageService.lang) {
	        $http.put("api/users/me", { language: LanguageService.lang }).catch(function (err) {
	          console.log("Error language");
	        });
	      }
	    });
	
	    var that = this;
	    this.$location = $location;
	    this.projectName = "Nouveau projet";
	    this.arrow = arrow;
	    this.Modal = Modal;
	    this.ProductAPI = ProductAPI;
	    this.gettextCatalog = gettextCatalog;
	
	    arrow.getDirective();
	    $rootScope.$on("$locationChangeSuccess", function () {
	      arrow.getDirective();
	    });
	    var that = this;
	    this.isMobile = screenSize.on("xs", function (match) {
	      that.isMobile = match;
	    });
	    this.lang = LanguageService.lang;
	
	    this.openDuplicate = function (_demand) {
	      var data = null;
	      var modalInstance = $uibModal.open({
	        windowClass: "modal-primary",
	        animation: true,
	        ariaLabelledBy: "modal-title",
	        ariaDescribedBy: "modal-body",
	        component: "duplicate",
	        size: "lg",
	        resolve: {
	          products: function products() {
	            return that.products;
	          },
	          demand: function demand() {
	            return _demand;
	          }
	        }
	      });
	
	      modalInstance.result.then(function (data) {
	        that.ProductAPI.save(data).$promise.then(function (duplicata) {
	          duplicata = JSON.parse(JSON.stringify(duplicata));
	          if (duplicata) {
	            that.$location.path("/permission").search({
	              directive: "product",
	              project: duplicata.projectId,
	              demand: duplicata.id
	            });
	            that.Modal.confirm.info(function () {})(that.gettextCatalog.getString("Copie réussie"), that.gettextCatalog.getString("Les auteurs et les œuvres ont bien été copiés dans la nouvelle demande") + ".", that.gettextCatalog.getString("Fermer"), "success");
	          }
	          return;
	        }).catch(function (err) {
	          var textError = "";
	          if (err.status === 403) {
	            textError = that.gettextCatalog.getString("Certains auteurs s\xE9lectionn\xE9s ne sont\n              pas g\xE9r\xE9s pour cette type d'utilisation");
	          } else {
	            textError = that.gettextCatalog.getString("Des probl\xE8mes sont survenus lors de la copie.\n              Veuillez recommencer, si le probl\xE8me persiste vous pouvez nous contacter directement.");
	          }
	          that.Modal.confirm.info(function () {})(that.gettextCatalog.getString("Erreur"), textError, that.gettextCatalog.getString("Fermer"), "danger");
	          return;
	        });
	      }, function () {});
	    };
	  }
	
	  _createClass(PermissionController, [{
	    key: "duplicateConfirmedDemand",
	    value: function duplicateConfirmedDemand() {
	      var that = this;
	      if (this.$location.search().demand) {
	        this.disabledDuplicatedButton = true;
	        that.ProductAPI.get({ id: parseInt(that.$location.search().demand) }).$promise.then(function (demand) {
	          that.demand = JSON.parse(JSON.stringify(demand));
	          return that.ProductAPI.getModels().$promise.then(function (response) {
	            that.disabledDuplicatedButton = false;
	            that.products = JSON.parse(JSON.stringify(response));
	            that.openDuplicate(that.demand);
	            return;
	          });
	        }).catch(function () {
	          console.log("---> Can't get demand");
	          return null;
	        });
	      }
	    }
	  }, {
	    key: "openNewDemand",
	    value: function openNewDemand() {
	      var s = this.$location.search();
	      if (s.project) {
	        this.$location.path("/permission").search({
	          project: s.project,
	          directive: "product"
	        });
	      }
	    }
	  }]);
	
	  return PermissionController;
	}();
	
	exports.default = PermissionController;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.2.1
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2017-03-20T18:59Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var document = window.document;
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	
	
		function DOMEval( code, doc ) {
			doc = doc || document;
	
			var script = doc.createElement( "script" );
	
			script.text = code;
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.2.1",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android <=4.0 only
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && Array.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isFunction: function( obj ) {
			return jQuery.type( obj ) === "function";
		},
	
		isWindow: function( obj ) {
			return obj != null && obj === obj.window;
		},
	
		isNumeric: function( obj ) {
	
			// As of jQuery 3.0, isNumeric is limited to
			// strings and numbers (primitives or objects)
			// that can be coerced to finite numbers (gh-2662)
			var type = jQuery.type( obj );
			return ( type === "number" || type === "string" ) &&
	
				// parseFloat NaNs numeric-cast false positives ("")
				// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
				// subtraction forces infinities to NaN
				!isNaN( obj - parseFloat( obj ) );
		},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
	
			/* eslint-disable no-unused-vars */
			// See https://github.com/eslint/eslint/issues/6125
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
	
			// Support: Android <=2.3 only (functionish RegExp)
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call( obj ) ] || "object" :
				typeof obj;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			DOMEval( code );
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Support: IE <=9 - 11, Edge 12 - 13
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android <=4.0 only
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var tmp, args, proxy;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: Date.now,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.3
	 * https://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-08-08
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		disabledAncestor = addCombinator(
			function( elem ) {
				return elem.disabled === true && ("form" in elem || "label" in elem);
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[i] = "#" + nid + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement("fieldset");
	
		try {
			return !!fn( el );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
							disabledAncestor( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( preferredDoc !== document &&
			(subWindow = document.defaultView) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( el ) {
			el.className = "i";
			return !el.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( el ) {
			el.appendChild( document.createComment("") );
			return !el.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( (elem = elems[i++]) ) {
							node = elem.getAttributeNode("id");
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( el ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll(":enabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll(":disabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( el ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return (sel + "").replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( (oldCache = uniqueCache[ key ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( el ) {
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( el ) {
		return el.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	
	
	function nodeName( elem, name ) {
	
	  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	};
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Simple selector that can be filtered directly, removing non-Elements
		if ( risSimple.test( qualifier ) ) {
			return jQuery.filter( qualifier, elements, not );
		}
	
		// Complex selector, compare the two sets, removing non-Elements
		qualifier = jQuery.filter( qualifier, elements );
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not && elem.nodeType === 1;
		} );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
	        if ( nodeName( elem, "iframe" ) ) {
	            return elem.contentDocument;
	        }
	
	        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
	        // Treat the template element as a regular one in browsers that
	        // don't support it.
	        if ( nodeName( elem, "template" ) ) {
	            elem = elem.content || elem;
	        }
	
	        return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( jQuery.isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && jQuery.isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && jQuery.isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = jQuery.isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( jQuery.isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the master Deferred
				master = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							master.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( master.state() === "pending" ||
					jQuery.isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return master.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
			}
	
			return master.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ jQuery.camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ jQuery.camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ jQuery.camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( jQuery.camelCase );
				} else {
					key = jQuery.camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				jQuery.contains( elem.ownerDocument, elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted,
			scale = 1,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			do {
	
				// If previous iteration zeroed out, double until we get *something*.
				// Use string for doubling so we don't accidentally see scale as unchanged below
				scale = scale || ".5";
	
				// Adjust and apply
				initialInUnit = initialInUnit / scale;
				jQuery.style( elem, prop, initialInUnit + unit );
	
			// Update scale, tolerating zero or NaN from tween.cur()
			// Break the loop if scale is unchanged or perfect, or if we've just had enough.
			} while (
				scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
			);
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );
	
	var rscriptType = ( /^$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE <=9 only
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE <=9 only
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	var documentElement = document.documentElement;
	
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 only
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			// Make a writable jQuery.Event from the native event object
			var event = jQuery.event.fix( nativeEvent );
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: jQuery.isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
								return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
								return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
	
		which: function( event ) {
			var button = event.button;
	
			// Add which for key events
			if ( event.which == null && rkeyEvent.test( event.type ) ) {
				return event.charCode != null ? event.charCode : event.keyCode;
			}
	
			// Add which for click: 1 === left; 2 === middle; 3 === right
			if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
				if ( button & 1 ) {
					return 1;
				}
	
				if ( button & 2 ) {
					return 3;
				}
	
				if ( button & 4 ) {
					return 2;
				}
	
				return 0;
			}
	
			return event.which;
		}
	}, jQuery.event.addProp );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		/* eslint-disable max-len */
	
		// See https://github.com/eslint/eslint/issues/3229
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
	
		/* eslint-enable */
	
		// Support: IE <=10 - 11, Edge 12 - 13
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( ">tbody", elem )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
	
		if ( match ) {
			elem.type = match[ 1 ];
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rmargin = ( /^margin/ );
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			div.style.cssText =
				"box-sizing:border-box;" +
				"position:relative;display:block;" +
				"margin:auto;border:1px;padding:1px;" +
				"top:1%;width:50%";
			div.innerHTML = "";
			documentElement.appendChild( container );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = divStyle.marginLeft === "2px";
			boxSizingReliableVal = divStyle.width === "4px";
	
			// Support: Android 4.0 - 4.3 only
			// Some styles come back with percentage values, even though they shouldn't
			div.style.marginRight = "50%";
			pixelMarginRightVal = divStyle.marginRight === "4px";
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
			"padding:0;margin-top:1px;position:absolute";
		container.appendChild( div );
	
		jQuery.extend( support, {
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelMarginRight: function() {
				computeStyleTests();
				return pixelMarginRightVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rcustomProp = /^--/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a property mapped along what jQuery.cssProps suggests or to
	// a vendor prefixed property.
	function finalPropName( name ) {
		var ret = jQuery.cssProps[ name ];
		if ( !ret ) {
			ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
		}
		return ret;
	}
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i,
			val = 0;
	
		// If we already have the right measurement, avoid augmentation
		if ( extra === ( isBorderBox ? "border" : "content" ) ) {
			i = 4;
	
		// Otherwise initialize for horizontal or vertical properties
		} else {
			i = name === "width" ? 1 : 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
	
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// At this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
	
				// At this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// At this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with computed style
		var valueIsBorderBox,
			styles = getStyles( elem ),
			val = curCSS( elem, name, styles ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// Computed unit is not pixels. Stop here and return.
		if ( rnumnonpx.test( val ) ) {
			return val;
		}
	
		// Check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = isBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ name ] );
	
		// Fall back to offsetWidth/Height when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		if ( val === "auto" ) {
			val = elem[ "offset" + name[ 0 ].toUpperCase() + name.slice( 1 ) ];
		}
	
		// Normalize "", auto, and prepare for extra
		val = parseFloat( val ) || 0;
	
		// Use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
			"float": "cssFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = jQuery.camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, name, extra );
							} ) :
							getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = extra && getStyles( elem ),
					subtract = extra && augmentWidthOrHeight(
						elem,
						name,
						extra,
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					);
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ name ] = value;
					value = jQuery.css( elem, name );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 13
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
				/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( jQuery.isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						jQuery.proxy( result.stop, result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://html.spec.whatwg.org/multipage/infrastructure.html#strip-and-collapse-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnothtmlwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnothtmlwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( type === "string" ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = value.match( rnothtmlwhite ) || [];
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
						return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						elem[ type ]();
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	support.focusin = "onfocusin" in window;
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = jQuery.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = jQuery.isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 13
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( jQuery.isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" ).prop( {
						charset: s.scriptCharset,
						src: s.url
					} ).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var doc, docElem, rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			rect = elem.getBoundingClientRect();
	
			doc = elem.ownerDocument;
			docElem = doc.documentElement;
			win = doc.defaultView;
	
			return {
				top: rect.top + win.pageYOffset - docElem.clientTop,
				left: rect.left + win.pageXOffset - docElem.clientLeft
			};
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
			// because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume getBoundingClientRect is there when computed position is fixed
				offset = elem.getBoundingClientRect();
	
			} else {
	
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset = {
					top: parentOffset.top + jQuery.css( offsetParent[ 0 ], "borderTopWidth", true ),
					left: parentOffset.left + jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true )
				};
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( jQuery.isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		}
	} );
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.conditionService = conditionService;
	
	var _underscore = __webpack_require__(64);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _validator = __webpack_require__(65);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var angular = __webpack_require__(1);
	
	/*@ngInject*/
	function conditionService() {
	  "ngInject";
	
	  function getBooleanValue(inputs, iname, uses) {
	    var parentShowed = true;
	    if (!inputs[iname]) {
	      var uValue = false;
	      for (var u in uses) {
	        if (uses[u][iname]) {
	          var _parentModelId = uses[u][iname].parentModelId;
	          var _parent = uses["input_" + _parentModelId] || inputs["input_" + _parentModelId];
	          if (_parentModelId && _parent) {
	            parentShowed = _parent.showed || false;
	          }
	          uValue = uValue || uses[u][iname].value && parentShowed;
	        }
	      }
	      return uValue;
	    }
	
	    var parentModelId = inputs[iname].parentModelId;
	    var parent = inputs["input_" + parentModelId];
	    if (parentModelId && parent) {
	      parentShowed = parent.showed || false;
	    }
	    return inputs[iname].showed && inputs[iname].value && parentShowed || false;
	  }
	
	  function getBoolean3(condObj, inputs, uses) {
	    var op = Object.keys(condObj)[0].trim().toUpperCase();
	    if (!(op === "AND" || op === "OR")) {
	      new Error("Operator must be AND or OR");
	      return null;
	    }
	
	    var cont = condObj[Object.keys(condObj)[0]];
	
	    for (var c in cont) {
	      if (_typeof(cont[c]) === "object") {
	        cont[c] = getBoolean3(cont[c], inputs, uses);
	      }
	    }
	    var result = null;
	    for (var c in cont) {
	      if (typeof cont[c] === "string" || typeof cont[c] === "number") {
	        cont[c] = getBooleanValue(inputs, "input_" + cont[c], uses);
	      }
	      if (op === "AND") {
	        result = result === null ? cont[c] : result && cont[c];
	      } else {
	        result = result === null ? cont[c] : result || cont[c];
	      }
	    }
	    return result;
	  }
	
	  function getBoolean4(inputs, condObj) {
	    var val = inputs["input_" + condObj.input].value;
	    var op = condObj.operator.trim();
	    var comp = condObj.value;
	    if (op == "==") {
	      return val == comp;
	    } else if (op == "==") {
	      return val == comp;
	    } else if (op == "!=") {
	      return val != comp;
	    } else if (op == ">") {
	      return val > comp;
	    } else if (op == ">=") {
	      return val >= comp;
	    } else if (op == "<") {
	      return val < comp;
	    } else if (op == "<=") {
	      return val <= comp;
	    } else {
	      new Error("Incorrect syntaxe");
	    }
	  }
	
	
	  function getBoolean5(inputs, condObj) {
	    var val = inputs["input_" + condObj.input].value;
	    var func = condObj.function.trim();
	    var comp = condObj.value;
	    if (func == "isEmpty") {
	      if (!val && val !== 0 && val !== false || val === "[]") {
	        val = "";
	      } else {
	        val = "" + val;
	      }
	      return _validator2.default.isEmpty(val);
	    } else {
	      new Error("Incorrect syntaxe");
	    }
	  }
	
	  return {
	    getBoolean: function getBoolean(syntaxe, generals, uses, use) {
	      var inputs = use ? _underscore2.default.extend(JSON.parse(JSON.stringify(generals)), use) : generals;
	      var synt = syntaxe.split(";");
	      var type = Number.parseInt(synt[0]);
	      var cond = synt[1].trim();
	      if (type === 1) {
	        return cond.toUpperCase() === "TRUE";
	      } else if (type === 2) {
	        return getBooleanValue(inputs, "input_" + cond, uses);
	      } else if (type === 3) {
	        var condObj = null;
	        try {
	          condObj = JSON.parse(cond);
	        } catch (e) {
	          condObj = null;
	        }
	        if (condObj) {
	          return getBoolean3(condObj, inputs, uses);
	        } else {
	          return false;
	        }
	      } else if (type === 4) {
	        return getBoolean4(inputs, JSON.parse(cond));
	      } else if (type === 5) {
	        return getBoolean5(inputs, JSON.parse(cond));
	      }
	    }
	  };
	}
	
	exports.default = angular.module("dalApp.condition", []).service("Condition", conditionService).name;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
	//     http://underscorejs.org
	//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Underscore may be freely distributed under the MIT license.
	
	(function() {
	
	  // Baseline setup
	  // --------------
	
	  // Establish the root object, `window` in the browser, or `exports` on the server.
	  var root = this;
	
	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var
	    push             = ArrayProto.push,
	    slice            = ArrayProto.slice,
	    toString         = ObjProto.toString,
	    hasOwnProperty   = ObjProto.hasOwnProperty;
	
	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var
	    nativeIsArray      = Array.isArray,
	    nativeKeys         = Object.keys,
	    nativeBind         = FuncProto.bind,
	    nativeCreate       = Object.create;
	
	  // Naked function reference for surrogate-prototype-swapping.
	  var Ctor = function(){};
	
	  // Create a safe reference to the Underscore object for use below.
	  var _ = function(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };
	
	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for the old `require()` API. If we're in
	  // the browser, add `_` as a global object.
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }
	
	  // Current version.
	  _.VERSION = '1.8.3';
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  var optimizeCb = function(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      case 2: return function(value, other) {
	        return func.call(context, value, other);
	      };
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  };
	
	  // A mostly-internal function to generate callbacks that can be applied
	  // to each element in a collection, returning the desired result — either
	  // identity, an arbitrary callback, a property matcher, or a property accessor.
	  var cb = function(value, context, argCount) {
	    if (value == null) return _.identity;
	    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
	    if (_.isObject(value)) return _.matcher(value);
	    return _.property(value);
	  };
	  _.iteratee = function(value, context) {
	    return cb(value, context, Infinity);
	  };
	
	  // An internal function for creating assigner functions.
	  var createAssigner = function(keysFunc, undefinedOnly) {
	    return function(obj) {
	      var length = arguments.length;
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  };
	
	  // An internal function for creating a new object that inherits from another.
	  var baseCreate = function(prototype) {
	    if (!_.isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    Ctor.prototype = prototype;
	    var result = new Ctor;
	    Ctor.prototype = null;
	    return result;
	  };
	
	  var property = function(key) {
	    return function(obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  };
	
	  // Helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object
	  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	  var getLength = property('length');
	  var isArrayLike = function(collection) {
	    var length = getLength(collection);
	    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
	  };
	
	  // Collection Functions
	  // --------------------
	
	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  _.each = _.forEach = function(obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var keys = _.keys(obj);
	      for (i = 0, length = keys.length; i < length; i++) {
	        iteratee(obj[keys[i]], keys[i], obj);
	      }
	    }
	    return obj;
	  };
	
	  // Return the results of applying the iteratee to each element.
	  _.map = _.collect = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  };
	
	  // Create a reducing function iterating left or right.
	  function createReduce(dir) {
	    // Optimized iterator function as using arguments.length
	    // in the main function will deoptimize the, see #1991.
	    function iterator(obj, iteratee, memo, keys, index, length) {
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = keys ? keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    }
	
	    return function(obj, iteratee, memo, context) {
	      iteratee = optimizeCb(iteratee, context, 4);
	      var keys = !isArrayLike(obj) && _.keys(obj),
	          length = (keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      // Determine the initial value if none is provided.
	      if (arguments.length < 3) {
	        memo = obj[keys ? keys[index] : index];
	        index += dir;
	      }
	      return iterator(obj, iteratee, memo, keys, index, length);
	    };
	  }
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  _.reduce = _.foldl = _.inject = createReduce(1);
	
	  // The right-associative version of reduce, also known as `foldr`.
	  _.reduceRight = _.foldr = createReduce(-1);
	
	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function(obj, predicate, context) {
	    var key;
	    if (isArrayLike(obj)) {
	      key = _.findIndex(obj, predicate, context);
	    } else {
	      key = _.findKey(obj, predicate, context);
	    }
	    if (key !== void 0 && key !== -1) return obj[key];
	  };
	
	  // Return all the elements that pass a truth test.
	  // Aliased as `select`.
	  _.filter = _.select = function(obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    _.each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  };
	
	  // Return all the elements for which a truth test fails.
	  _.reject = function(obj, predicate, context) {
	    return _.filter(obj, _.negate(cb(predicate)), context);
	  };
	
	  // Determine whether all of the elements match a truth test.
	  // Aliased as `all`.
	  _.every = _.all = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  };
	
	  // Determine if at least one element in the object matches a truth test.
	  // Aliased as `any`.
	  _.some = _.any = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  };
	
	  // Determine if the array or object contains a given item (using `===`).
	  // Aliased as `includes` and `include`.
	  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = _.values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return _.indexOf(obj, item, fromIndex) >= 0;
	  };
	
	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = function(obj, method) {
	    var args = slice.call(arguments, 2);
	    var isFunc = _.isFunction(method);
	    return _.map(obj, function(value) {
	      var func = isFunc ? method : value[method];
	      return func == null ? func : func.apply(value, args);
	    });
	  };
	
	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function(obj, key) {
	    return _.map(obj, _.property(key));
	  };
	
	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function(obj, attrs) {
	    return _.filter(obj, _.matcher(attrs));
	  };
	
	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function(obj, attrs) {
	    return _.find(obj, _.matcher(attrs));
	  };
	
	  // Return the maximum element (or element-based computation).
	  _.max = function(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Return the minimum element (or element-based computation).
	  _.min = function(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed < lastComputed || computed === Infinity && result === Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Shuffle a collection, using the modern version of the
	  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  _.shuffle = function(obj) {
	    var set = isArrayLike(obj) ? obj : _.values(obj);
	    var length = set.length;
	    var shuffled = Array(length);
	    for (var index = 0, rand; index < length; index++) {
	      rand = _.random(0, index);
	      if (rand !== index) shuffled[index] = shuffled[rand];
	      shuffled[rand] = set[index];
	    }
	    return shuffled;
	  };
	
	  // Sample **n** random values from a collection.
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `map`.
	  _.sample = function(obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = _.values(obj);
	      return obj[_.random(obj.length - 1)];
	    }
	    return _.shuffle(obj).slice(0, Math.max(0, n));
	  };
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  _.sortBy = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    return _.pluck(_.map(obj, function(value, index, list) {
	      return {
	        value: value,
	        index: index,
	        criteria: iteratee(value, index, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  };
	
	  // An internal function used for aggregate "group by" operations.
	  var group = function(behavior) {
	    return function(obj, iteratee, context) {
	      var result = {};
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  };
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `groupBy`, but for
	  // when you know that your index values will be unique.
	  _.indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  // Safely create a real, live array from anything iterable.
	  _.toArray = function(obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (isArrayLike(obj)) return _.map(obj, _.identity);
	    return _.values(obj);
	  };
	
	  // Return the number of elements in an object.
	  _.size = function(obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
	  };
	
	  // Split a collection into two arrays: one whose elements all satisfy the given
	  // predicate, and one whose elements all do not satisfy the predicate.
	  _.partition = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var pass = [], fail = [];
	    _.each(obj, function(value, key, obj) {
	      (predicate(value, key, obj) ? pass : fail).push(value);
	    });
	    return [pass, fail];
	  };
	
	  // Array Functions
	  // ---------------
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[0];
	    return _.initial(array, array.length - n);
	  };
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  _.initial = function(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  };
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  _.last = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[array.length - 1];
	    return _.rest(array, Math.max(0, array.length - n));
	  };
	
	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array.
	  _.rest = _.tail = _.drop = function(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  };
	
	  // Trim out all falsy values from an array.
	  _.compact = function(array) {
	    return _.filter(array, _.identity);
	  };
	
	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function(input, shallow, strict, startIndex) {
	    var output = [], idx = 0;
	    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
	        //flatten current level of array or arguments object
	        if (!shallow) value = flatten(value, shallow, strict);
	        var j = 0, len = value.length;
	        output.length += len;
	        while (j < len) {
	          output[idx++] = value[j++];
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  };
	
	  // Flatten out an array, either recursively (by default), or just one level.
	  _.flatten = function(array, shallow) {
	    return flatten(array, shallow, false);
	  };
	
	  // Return a version of the array that does not contain the specified value(s).
	  _.without = function(array) {
	    return _.difference(array, slice.call(arguments, 1));
	  };
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
	    if (!_.isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!_.contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!_.contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  };
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = function() {
	    return _.uniq(flatten(arguments, true, true));
	  };
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function(array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (_.contains(result, item)) continue;
	      for (var j = 1; j < argsLength; j++) {
	        if (!_.contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  };
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = function(array) {
	    var rest = flatten(arguments, true, true, 1);
	    return _.filter(array, function(value){
	      return !_.contains(rest, value);
	    });
	  };
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = function() {
	    return _.unzip(arguments);
	  };
	
	  // Complement of _.zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices
	  _.unzip = function(array) {
	    var length = array && _.max(array, getLength).length || 0;
	    var result = Array(length);
	
	    for (var index = 0; index < length; index++) {
	      result[index] = _.pluck(array, index);
	    }
	    return result;
	  };
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values.
	  _.object = function(list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };
	
	  // Generator function to create the findIndex and findLastIndex functions
	  function createPredicateIndexFinder(dir) {
	    return function(array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  }
	
	  // Returns the first index on an array-like that passes a predicate test
	  _.findIndex = createPredicateIndexFinder(1);
	  _.findLastIndex = createPredicateIndexFinder(-1);
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function(array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  };
	
	  // Generator function to create the indexOf and lastIndexOf functions
	  function createIndexFinder(dir, predicateFind, sortedIndex) {
	    return function(array, item, idx) {
	      var i = 0, length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	            i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), _.isNaN);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  }
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
	  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function(start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    step = step || 1;
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  };
	
	  // Function (ahem) Functions
	  // ------------------
	
	  // Determines whether to execute a function as a constructor
	  // or a normal function with the provided arguments
	  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (_.isObject(result)) return result;
	    return self;
	  };
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = function(func, context) {
	    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
	    var args = slice.call(arguments, 2);
	    var bound = function() {
	      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
	    };
	    return bound;
	  };
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. _ acts
	  // as a placeholder, allowing any combination of arguments to be pre-filled.
	  _.partial = function(func) {
	    var boundArgs = slice.call(arguments, 1);
	    var bound = function() {
	      var position = 0, length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  };
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  _.bindAll = function(obj) {
	    var i, length = arguments.length, key;
	    if (length <= 1) throw new Error('bindAll must be passed function names');
	    for (i = 1; i < length; i++) {
	      key = arguments[i];
	      obj[key] = _.bind(obj[key], obj);
	    }
	    return obj;
	  };
	
	  // Memoize an expensive function by storing its results.
	  _.memoize = function(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  };
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = function(func, wait) {
	    var args = slice.call(arguments, 2);
	    return setTimeout(function(){
	      return func.apply(null, args);
	    }, wait);
	  };
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = _.partial(_.delay, _, 1);
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  _.throttle = function(func, wait, options) {
	    var context, args, result;
	    var timeout = null;
	    var previous = 0;
	    if (!options) options = {};
	    var later = function() {
	      previous = options.leading === false ? 0 : _.now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	    return function() {
	      var now = _.now();
	      if (!previous && options.leading === false) previous = now;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	  };
	
	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function(func, wait, immediate) {
	    var timeout, args, context, timestamp, result;
	
	    var later = function() {
	      var last = _.now() - timestamp;
	
	      if (last < wait && last >= 0) {
	        timeout = setTimeout(later, wait - last);
	      } else {
	        timeout = null;
	        if (!immediate) {
	          result = func.apply(context, args);
	          if (!timeout) context = args = null;
	        }
	      }
	    };
	
	    return function() {
	      context = this;
	      args = arguments;
	      timestamp = _.now();
	      var callNow = immediate && !timeout;
	      if (!timeout) timeout = setTimeout(later, wait);
	      if (callNow) {
	        result = func.apply(context, args);
	        context = args = null;
	      }
	
	      return result;
	    };
	  };
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function(func, wrapper) {
	    return _.partial(wrapper, func);
	  };
	
	  // Returns a negated version of the passed-in predicate.
	  _.negate = function(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  };
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  };
	
	  // Returns a function that will only be executed on and after the Nth call.
	  _.after = function(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };
	
	  // Returns a function that will only be executed up to (but not including) the Nth call.
	  _.before = function(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  };
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = _.partial(_.before, 2);
	
	  // Object Functions
	  // ----------------
	
	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
	                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	  function collectNonEnumProps(obj, keys) {
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;
	
	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);
	
	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
	        keys.push(prop);
	      }
	    }
	  }
	
	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`
	  _.keys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (_.has(obj, key)) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve all the property names of an object.
	  _.allKeys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve the values of an object's properties.
	  _.values = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[keys[i]];
	    }
	    return values;
	  };
	
	  // Returns the results of applying the iteratee to each element of the object
	  // In contrast to _.map it returns an object
	  _.mapObject = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys =  _.keys(obj),
	          length = keys.length,
	          results = {},
	          currentKey;
	      for (var index = 0; index < length; index++) {
	        currentKey = keys[index];
	        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	      }
	      return results;
	  };
	
	  // Convert an object into a list of `[key, value]` pairs.
	  _.pairs = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [keys[i], obj[keys[i]]];
	    }
	    return pairs;
	  };
	
	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function(obj) {
	    var result = {};
	    var keys = _.keys(obj);
	    for (var i = 0, length = keys.length; i < length; i++) {
	      result[obj[keys[i]]] = keys[i];
	    }
	    return result;
	  };
	
	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`
	  _.functions = _.methods = function(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };
	
	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = createAssigner(_.allKeys);
	
	  // Assigns a given object with all the own properties in the passed-in object(s)
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  _.extendOwn = _.assign = createAssigner(_.keys);
	
	  // Returns the first key on an object that passes a predicate test
	  _.findKey = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = _.keys(obj), key;
	    for (var i = 0, length = keys.length; i < length; i++) {
	      key = keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  };
	
	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = function(object, oiteratee, context) {
	    var result = {}, obj = object, iteratee, keys;
	    if (obj == null) return result;
	    if (_.isFunction(oiteratee)) {
	      keys = _.allKeys(obj);
	      iteratee = optimizeCb(oiteratee, context);
	    } else {
	      keys = flatten(arguments, false, false, 1);
	      iteratee = function(value, key, obj) { return key in obj; };
	      obj = Object(obj);
	    }
	    for (var i = 0, length = keys.length; i < length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  };
	
	   // Return a copy of the object without the blacklisted properties.
	  _.omit = function(obj, iteratee, context) {
	    if (_.isFunction(iteratee)) {
	      iteratee = _.negate(iteratee);
	    } else {
	      var keys = _.map(flatten(arguments, false, false, 1), String);
	      iteratee = function(value, key) {
	        return !_.contains(keys, key);
	      };
	    }
	    return _.pick(obj, iteratee, context);
	  };
	
	  // Fill in a given object with default properties.
	  _.defaults = createAssigner(_.allKeys, true);
	
	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  _.create = function(prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) _.extendOwn(result, props);
	    return result;
	  };
	
	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };
	
	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  _.isMatch = function(object, attrs) {
	    var keys = _.keys(attrs), length = keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  };
	
	
	  // Internal recursive comparison function for `isEqual`.
	  var eq = function(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // A strict comparison is necessary because `null == undefined`.
	    if (a == null || b == null) return a === b;
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	      case '[object RegExp]':
	      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	    }
	
	    var areArrays = className === '[object Array]';
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;
	
	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
	                               _.isFunction(bCtor) && bCtor instanceof bCtor)
	                          && ('constructor' in a && 'constructor' in b)) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var keys = _.keys(a), key;
	      length = keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (_.keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = keys[length];
	        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  };
	
	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function(a, b) {
	    return eq(a, b);
	  };
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function(obj) {
	    if (obj == null) return true;
	    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
	    return _.keys(obj).length === 0;
	  };
	
	  // Is a given value a DOM element?
	  _.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	  };
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) === '[object Array]';
	  };
	
	  // Is a given variable an object?
	  _.isObject = function(obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !!obj;
	  };
	
	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
	  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
	    _['is' + name] = function(obj) {
	      return toString.call(obj) === '[object ' + name + ']';
	    };
	  });
	
	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function(obj) {
	      return _.has(obj, 'callee');
	    };
	  }
	
	  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
	  // IE 11 (#1621), and in Safari 8 (#1929).
	  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
	    _.isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  // Is a given object a finite number?
	  _.isFinite = function(obj) {
	    return isFinite(obj) && !isNaN(parseFloat(obj));
	  };
	
	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	  _.isNaN = function(obj) {
	    return _.isNumber(obj) && obj !== +obj;
	  };
	
	  // Is a given value a boolean?
	  _.isBoolean = function(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  };
	
	  // Is a given value equal to null?
	  _.isNull = function(obj) {
	    return obj === null;
	  };
	
	  // Is a given variable undefined?
	  _.isUndefined = function(obj) {
	    return obj === void 0;
	  };
	
	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function(obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  };
	
	  // Utility Functions
	  // -----------------
	
	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function() {
	    root._ = previousUnderscore;
	    return this;
	  };
	
	  // Keep the identity function around for default iteratees.
	  _.identity = function(value) {
	    return value;
	  };
	
	  // Predicate-generating functions. Often useful outside of Underscore.
	  _.constant = function(value) {
	    return function() {
	      return value;
	    };
	  };
	
	  _.noop = function(){};
	
	  _.property = property;
	
	  // Generates a function for a given object that returns a given property.
	  _.propertyOf = function(obj) {
	    return obj == null ? function(){} : function(key) {
	      return obj[key];
	    };
	  };
	
	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  _.matcher = _.matches = function(attrs) {
	    attrs = _.extendOwn({}, attrs);
	    return function(obj) {
	      return _.isMatch(obj, attrs);
	    };
	  };
	
	  // Run a function **n** times.
	  _.times = function(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  };
	
	  // Return a random integer between min and max (inclusive).
	  _.random = function(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  _.now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	   // List of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	  var unescapeMap = _.invert(escapeMap);
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  var createEscaper = function(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped
	    var source = '(?:' + _.keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  };
	  _.escape = createEscaper(escapeMap);
	  _.unescape = createEscaper(unescapeMap);
	
	  // If the value of the named `property` is a function then invoke it with the
	  // `object` as context; otherwise, return it.
	  _.result = function(object, property, fallback) {
	    var value = object == null ? void 0 : object[property];
	    if (value === void 0) {
	      value = fallback;
	    }
	    return _.isFunction(value) ? value.call(object) : value;
	  };
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };
	
	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate    : /<%([\s\S]+?)%>/g,
	    interpolate : /<%=([\s\S]+?)%>/g,
	    escape      : /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'":      "'",
	    '\\':     '\\',
	    '\r':     'r',
	    '\n':     'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  var escapeChar = function(match) {
	    return '\\' + escapes[match];
	  };
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  _.template = function(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = _.defaults({}, settings, _.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escaper, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offest.
	      return match;
	    });
	    source += "';\n";
	
	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    try {
	      var render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    var argument = settings.variable || 'obj';
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  };
	
	  // Add a "chain" function. Start chaining a wrapped Underscore object.
	  _.chain = function(obj) {
	    var instance = _(obj);
	    instance._chain = true;
	    return instance;
	  };
	
	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.
	
	  // Helper function to continue chaining intermediate results.
	  var result = function(instance, obj) {
	    return instance._chain ? _(obj).chain() : obj;
	  };
	
	  // Add your own custom functions to the Underscore object.
	  _.mixin = function(obj) {
	    _.each(_.functions(obj), function(name) {
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return result(this, func.apply(_, args));
	      };
	    });
	  };
	
	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);
	
	  // Add all mutator Array functions to the wrapper.
	  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
	      return result(this, obj);
	    };
	  });
	
	  // Add all accessor Array functions to the wrapper.
	  _.each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return result(this, method.apply(this._wrapped, arguments));
	    };
	  });
	
	  // Extracts the result from a wrapped and chained object.
	  _.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // Provide unwrapping proxy for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
	
	  _.prototype.toString = function() {
	    return '' + this._wrapped;
	  };
	
	  // AMD registration happens at the end for compatibility with AMD loaders
	  // that may not enforce next-turn semantics on modules. Even though general
	  // practice for AMD registration is to be anonymous, underscore registers
	  // as a named module because, like jQuery, it is a base library that is
	  // popular enough to be bundled in a third party lib, but not be part of
	  // an AMD load request. Those cases could generate an error when an
	  // anonymous define() is called outside of a loader request.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}.call(this));


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toDate = __webpack_require__(66);
	
	var _toDate2 = _interopRequireDefault(_toDate);
	
	var _toFloat = __webpack_require__(68);
	
	var _toFloat2 = _interopRequireDefault(_toFloat);
	
	var _toInt = __webpack_require__(69);
	
	var _toInt2 = _interopRequireDefault(_toInt);
	
	var _toBoolean = __webpack_require__(70);
	
	var _toBoolean2 = _interopRequireDefault(_toBoolean);
	
	var _equals = __webpack_require__(71);
	
	var _equals2 = _interopRequireDefault(_equals);
	
	var _contains = __webpack_require__(72);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _matches = __webpack_require__(74);
	
	var _matches2 = _interopRequireDefault(_matches);
	
	var _isEmail = __webpack_require__(75);
	
	var _isEmail2 = _interopRequireDefault(_isEmail);
	
	var _isURL = __webpack_require__(79);
	
	var _isURL2 = _interopRequireDefault(_isURL);
	
	var _isMACAddress = __webpack_require__(81);
	
	var _isMACAddress2 = _interopRequireDefault(_isMACAddress);
	
	var _isIP = __webpack_require__(80);
	
	var _isIP2 = _interopRequireDefault(_isIP);
	
	var _isFQDN = __webpack_require__(78);
	
	var _isFQDN2 = _interopRequireDefault(_isFQDN);
	
	var _isBoolean = __webpack_require__(82);
	
	var _isBoolean2 = _interopRequireDefault(_isBoolean);
	
	var _isAlpha = __webpack_require__(83);
	
	var _isAlpha2 = _interopRequireDefault(_isAlpha);
	
	var _isAlphanumeric = __webpack_require__(85);
	
	var _isAlphanumeric2 = _interopRequireDefault(_isAlphanumeric);
	
	var _isNumeric = __webpack_require__(86);
	
	var _isNumeric2 = _interopRequireDefault(_isNumeric);
	
	var _isLowercase = __webpack_require__(87);
	
	var _isLowercase2 = _interopRequireDefault(_isLowercase);
	
	var _isUppercase = __webpack_require__(88);
	
	var _isUppercase2 = _interopRequireDefault(_isUppercase);
	
	var _isAscii = __webpack_require__(89);
	
	var _isAscii2 = _interopRequireDefault(_isAscii);
	
	var _isFullWidth = __webpack_require__(90);
	
	var _isFullWidth2 = _interopRequireDefault(_isFullWidth);
	
	var _isHalfWidth = __webpack_require__(91);
	
	var _isHalfWidth2 = _interopRequireDefault(_isHalfWidth);
	
	var _isVariableWidth = __webpack_require__(92);
	
	var _isVariableWidth2 = _interopRequireDefault(_isVariableWidth);
	
	var _isMultibyte = __webpack_require__(93);
	
	var _isMultibyte2 = _interopRequireDefault(_isMultibyte);
	
	var _isSurrogatePair = __webpack_require__(94);
	
	var _isSurrogatePair2 = _interopRequireDefault(_isSurrogatePair);
	
	var _isInt = __webpack_require__(95);
	
	var _isInt2 = _interopRequireDefault(_isInt);
	
	var _isFloat = __webpack_require__(96);
	
	var _isFloat2 = _interopRequireDefault(_isFloat);
	
	var _isDecimal = __webpack_require__(97);
	
	var _isDecimal2 = _interopRequireDefault(_isDecimal);
	
	var _isHexadecimal = __webpack_require__(98);
	
	var _isHexadecimal2 = _interopRequireDefault(_isHexadecimal);
	
	var _isDivisibleBy = __webpack_require__(99);
	
	var _isDivisibleBy2 = _interopRequireDefault(_isDivisibleBy);
	
	var _isHexColor = __webpack_require__(100);
	
	var _isHexColor2 = _interopRequireDefault(_isHexColor);
	
	var _isISRC = __webpack_require__(101);
	
	var _isISRC2 = _interopRequireDefault(_isISRC);
	
	var _isMD = __webpack_require__(102);
	
	var _isMD2 = _interopRequireDefault(_isMD);
	
	var _isHash = __webpack_require__(103);
	
	var _isHash2 = _interopRequireDefault(_isHash);
	
	var _isJSON = __webpack_require__(104);
	
	var _isJSON2 = _interopRequireDefault(_isJSON);
	
	var _isEmpty = __webpack_require__(105);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _isLength = __webpack_require__(106);
	
	var _isLength2 = _interopRequireDefault(_isLength);
	
	var _isByteLength = __webpack_require__(77);
	
	var _isByteLength2 = _interopRequireDefault(_isByteLength);
	
	var _isUUID = __webpack_require__(107);
	
	var _isUUID2 = _interopRequireDefault(_isUUID);
	
	var _isMongoId = __webpack_require__(108);
	
	var _isMongoId2 = _interopRequireDefault(_isMongoId);
	
	var _isAfter = __webpack_require__(109);
	
	var _isAfter2 = _interopRequireDefault(_isAfter);
	
	var _isBefore = __webpack_require__(110);
	
	var _isBefore2 = _interopRequireDefault(_isBefore);
	
	var _isIn = __webpack_require__(111);
	
	var _isIn2 = _interopRequireDefault(_isIn);
	
	var _isCreditCard = __webpack_require__(112);
	
	var _isCreditCard2 = _interopRequireDefault(_isCreditCard);
	
	var _isISIN = __webpack_require__(113);
	
	var _isISIN2 = _interopRequireDefault(_isISIN);
	
	var _isISBN = __webpack_require__(114);
	
	var _isISBN2 = _interopRequireDefault(_isISBN);
	
	var _isISSN = __webpack_require__(115);
	
	var _isISSN2 = _interopRequireDefault(_isISSN);
	
	var _isMobilePhone = __webpack_require__(116);
	
	var _isMobilePhone2 = _interopRequireDefault(_isMobilePhone);
	
	var _isCurrency = __webpack_require__(117);
	
	var _isCurrency2 = _interopRequireDefault(_isCurrency);
	
	var _isISO = __webpack_require__(118);
	
	var _isISO2 = _interopRequireDefault(_isISO);
	
	var _isBase = __webpack_require__(119);
	
	var _isBase2 = _interopRequireDefault(_isBase);
	
	var _isDataURI = __webpack_require__(120);
	
	var _isDataURI2 = _interopRequireDefault(_isDataURI);
	
	var _isLatLong = __webpack_require__(121);
	
	var _isLatLong2 = _interopRequireDefault(_isLatLong);
	
	var _isPostalCode = __webpack_require__(122);
	
	var _isPostalCode2 = _interopRequireDefault(_isPostalCode);
	
	var _ltrim = __webpack_require__(123);
	
	var _ltrim2 = _interopRequireDefault(_ltrim);
	
	var _rtrim = __webpack_require__(124);
	
	var _rtrim2 = _interopRequireDefault(_rtrim);
	
	var _trim = __webpack_require__(125);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	var _escape = __webpack_require__(126);
	
	var _escape2 = _interopRequireDefault(_escape);
	
	var _unescape = __webpack_require__(127);
	
	var _unescape2 = _interopRequireDefault(_unescape);
	
	var _stripLow = __webpack_require__(128);
	
	var _stripLow2 = _interopRequireDefault(_stripLow);
	
	var _whitelist = __webpack_require__(130);
	
	var _whitelist2 = _interopRequireDefault(_whitelist);
	
	var _blacklist = __webpack_require__(129);
	
	var _blacklist2 = _interopRequireDefault(_blacklist);
	
	var _isWhitelisted = __webpack_require__(131);
	
	var _isWhitelisted2 = _interopRequireDefault(_isWhitelisted);
	
	var _normalizeEmail = __webpack_require__(132);
	
	var _normalizeEmail2 = _interopRequireDefault(_normalizeEmail);
	
	var _toString = __webpack_require__(73);
	
	var _toString2 = _interopRequireDefault(_toString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var version = '8.2.0';
	
	var validator = {
	  version: version,
	  toDate: _toDate2.default,
	  toFloat: _toFloat2.default,
	  toInt: _toInt2.default,
	  toBoolean: _toBoolean2.default,
	  equals: _equals2.default,
	  contains: _contains2.default,
	  matches: _matches2.default,
	  isEmail: _isEmail2.default,
	  isURL: _isURL2.default,
	  isMACAddress: _isMACAddress2.default,
	  isIP: _isIP2.default,
	  isFQDN: _isFQDN2.default,
	  isBoolean: _isBoolean2.default,
	  isAlpha: _isAlpha2.default,
	  isAlphanumeric: _isAlphanumeric2.default,
	  isNumeric: _isNumeric2.default,
	  isLowercase: _isLowercase2.default,
	  isUppercase: _isUppercase2.default,
	  isAscii: _isAscii2.default,
	  isFullWidth: _isFullWidth2.default,
	  isHalfWidth: _isHalfWidth2.default,
	  isVariableWidth: _isVariableWidth2.default,
	  isMultibyte: _isMultibyte2.default,
	  isSurrogatePair: _isSurrogatePair2.default,
	  isInt: _isInt2.default,
	  isFloat: _isFloat2.default,
	  isDecimal: _isDecimal2.default,
	  isHexadecimal: _isHexadecimal2.default,
	  isDivisibleBy: _isDivisibleBy2.default,
	  isHexColor: _isHexColor2.default,
	  isISRC: _isISRC2.default,
	  isMD5: _isMD2.default,
	  isHash: _isHash2.default,
	  isJSON: _isJSON2.default,
	  isEmpty: _isEmpty2.default,
	  isLength: _isLength2.default,
	  isByteLength: _isByteLength2.default,
	  isUUID: _isUUID2.default,
	  isMongoId: _isMongoId2.default,
	  isAfter: _isAfter2.default,
	  isBefore: _isBefore2.default,
	  isIn: _isIn2.default,
	  isCreditCard: _isCreditCard2.default,
	  isISIN: _isISIN2.default,
	  isISBN: _isISBN2.default,
	  isISSN: _isISSN2.default,
	  isMobilePhone: _isMobilePhone2.default,
	  isPostalCode: _isPostalCode2.default,
	  isCurrency: _isCurrency2.default,
	  isISO8601: _isISO2.default,
	  isBase64: _isBase2.default,
	  isDataURI: _isDataURI2.default,
	  isLatLong: _isLatLong2.default,
	  ltrim: _ltrim2.default,
	  rtrim: _rtrim2.default,
	  trim: _trim2.default,
	  escape: _escape2.default,
	  unescape: _unescape2.default,
	  stripLow: _stripLow2.default,
	  whitelist: _whitelist2.default,
	  blacklist: _blacklist2.default,
	  isWhitelisted: _isWhitelisted2.default,
	  normalizeEmail: _normalizeEmail2.default,
	  toString: _toString2.default
	};
	
	exports.default = validator;
	module.exports = exports['default'];

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toDate;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toDate(date) {
	  (0, _assertString2.default)(date);
	  date = Date.parse(date);
	  return !isNaN(date) ? new Date(date) : null;
	}
	module.exports = exports['default'];

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = assertString;
	function assertString(input) {
	  var isString = typeof input === 'string' || input instanceof String;
	
	  if (!isString) {
	    throw new TypeError('This library (validator.js) validates strings only');
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toFloat;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toFloat(str) {
	  (0, _assertString2.default)(str);
	  return parseFloat(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toInt;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toInt(str, radix) {
	  (0, _assertString2.default)(str);
	  return parseInt(str, radix || 10);
	}
	module.exports = exports['default'];

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toBoolean;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toBoolean(str, strict) {
	  (0, _assertString2.default)(str);
	  if (strict) {
	    return str === '1' || str === 'true';
	  }
	  return str !== '0' && str !== 'false' && str !== '';
	}
	module.exports = exports['default'];

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = equals;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function equals(str, comparison) {
	  (0, _assertString2.default)(str);
	  return str === comparison;
	}
	module.exports = exports['default'];

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = contains;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _toString = __webpack_require__(73);
	
	var _toString2 = _interopRequireDefault(_toString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function contains(str, elem) {
	  (0, _assertString2.default)(str);
	  return str.indexOf((0, _toString2.default)(elem)) >= 0;
	}
	module.exports = exports['default'];

/***/ }),
/* 73 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = toString;
	function toString(input) {
	  if ((typeof input === 'undefined' ? 'undefined' : _typeof(input)) === 'object' && input !== null) {
	    if (typeof input.toString === 'function') {
	      input = input.toString();
	    } else {
	      input = '[object Object]';
	    }
	  } else if (input === null || typeof input === 'undefined' || isNaN(input) && !input.length) {
	    input = '';
	  }
	  return String(input);
	}
	module.exports = exports['default'];

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = matches;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function matches(str, pattern, modifiers) {
	  (0, _assertString2.default)(str);
	  if (Object.prototype.toString.call(pattern) !== '[object RegExp]') {
	    pattern = new RegExp(pattern, modifiers);
	  }
	  return pattern.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEmail;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _merge = __webpack_require__(76);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _isByteLength = __webpack_require__(77);
	
	var _isByteLength2 = _interopRequireDefault(_isByteLength);
	
	var _isFQDN = __webpack_require__(78);
	
	var _isFQDN2 = _interopRequireDefault(_isFQDN);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_email_options = {
	  allow_display_name: false,
	  require_display_name: false,
	  allow_utf8_local_part: true,
	  require_tld: true
	};
	
	/* eslint-disable max-len */
	/* eslint-disable no-control-regex */
	var displayName = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\,\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\s]*<(.+)>$/i;
	var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
	var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
	var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
	var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
	/* eslint-enable max-len */
	/* eslint-enable no-control-regex */
	
	function isEmail(str, options) {
	  (0, _assertString2.default)(str);
	  options = (0, _merge2.default)(options, default_email_options);
	
	  if (options.require_display_name || options.allow_display_name) {
	    var display_email = str.match(displayName);
	    if (display_email) {
	      str = display_email[1];
	    } else if (options.require_display_name) {
	      return false;
	    }
	  }
	
	  var parts = str.split('@');
	  var domain = parts.pop();
	  var user = parts.join('@');
	
	  var lower_domain = domain.toLowerCase();
	  if (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com') {
	    user = user.replace(/\./g, '').toLowerCase();
	  }
	
	  if (!(0, _isByteLength2.default)(user, { max: 64 }) || !(0, _isByteLength2.default)(domain, { max: 254 })) {
	    return false;
	  }
	
	  if (!(0, _isFQDN2.default)(domain, { require_tld: options.require_tld })) {
	    return false;
	  }
	
	  if (user[0] === '"') {
	    user = user.slice(1, user.length - 1);
	    return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
	  }
	
	  var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;
	
	  var user_parts = user.split('.');
	  for (var i = 0; i < user_parts.length; i++) {
	    if (!pattern.test(user_parts[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	module.exports = exports['default'];

/***/ }),
/* 76 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = merge;
	function merge() {
	  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var defaults = arguments[1];
	
	  for (var key in defaults) {
	    if (typeof obj[key] === 'undefined') {
	      obj[key] = defaults[key];
	    }
	  }
	  return obj;
	}
	module.exports = exports['default'];

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isByteLength;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable prefer-rest-params */
	function isByteLength(str, options) {
	  (0, _assertString2.default)(str);
	  var min = void 0;
	  var max = void 0;
	  if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
	    min = options.min || 0;
	    max = options.max;
	  } else {
	    // backwards compatibility: isByteLength(str, min [, max])
	    min = arguments[1];
	    max = arguments[2];
	  }
	  var len = encodeURI(str).split(/%..|./).length - 1;
	  return len >= min && (typeof max === 'undefined' || len <= max);
	}
	module.exports = exports['default'];

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFDQN;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _merge = __webpack_require__(76);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_fqdn_options = {
	  require_tld: true,
	  allow_underscores: false,
	  allow_trailing_dot: false
	};
	
	function isFDQN(str, options) {
	  (0, _assertString2.default)(str);
	  options = (0, _merge2.default)(options, default_fqdn_options);
	
	  /* Remove the optional trailing dot before checking validity */
	  if (options.allow_trailing_dot && str[str.length - 1] === '.') {
	    str = str.substring(0, str.length - 1);
	  }
	  var parts = str.split('.');
	  if (options.require_tld) {
	    var tld = parts.pop();
	    if (!parts.length || !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
	      return false;
	    }
	    // disallow spaces
	    if (/[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20]/.test(tld)) {
	      return false;
	    }
	  }
	  for (var part, i = 0; i < parts.length; i++) {
	    part = parts[i];
	    if (options.allow_underscores) {
	      part = part.replace(/_/g, '');
	    }
	    if (!/^[a-z\u00a1-\uffff0-9-]+$/i.test(part)) {
	      return false;
	    }
	    // disallow full-width chars
	    if (/[\uff01-\uff5e]/.test(part)) {
	      return false;
	    }
	    if (part[0] === '-' || part[part.length - 1] === '-') {
	      return false;
	    }
	  }
	  return true;
	}
	module.exports = exports['default'];

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isURL;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _isFQDN = __webpack_require__(78);
	
	var _isFQDN2 = _interopRequireDefault(_isFQDN);
	
	var _isIP = __webpack_require__(80);
	
	var _isIP2 = _interopRequireDefault(_isIP);
	
	var _merge = __webpack_require__(76);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_url_options = {
	  protocols: ['http', 'https', 'ftp'],
	  require_tld: true,
	  require_protocol: false,
	  require_host: true,
	  require_valid_protocol: true,
	  allow_underscores: false,
	  allow_trailing_dot: false,
	  allow_protocol_relative_urls: false
	};
	
	var wrapped_ipv6 = /^\[([^\]]+)\](?::([0-9]+))?$/;
	
	function isRegExp(obj) {
	  return Object.prototype.toString.call(obj) === '[object RegExp]';
	}
	
	function checkHost(host, matches) {
	  for (var i = 0; i < matches.length; i++) {
	    var match = matches[i];
	    if (host === match || isRegExp(match) && match.test(host)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	function isURL(url, options) {
	  (0, _assertString2.default)(url);
	  if (!url || url.length >= 2083 || /[\s<>]/.test(url)) {
	    return false;
	  }
	  if (url.indexOf('mailto:') === 0) {
	    return false;
	  }
	  options = (0, _merge2.default)(options, default_url_options);
	  var protocol = void 0,
	      auth = void 0,
	      host = void 0,
	      hostname = void 0,
	      port = void 0,
	      port_str = void 0,
	      split = void 0,
	      ipv6 = void 0;
	
	  split = url.split('#');
	  url = split.shift();
	
	  split = url.split('?');
	  url = split.shift();
	
	  split = url.split('://');
	  if (split.length > 1) {
	    protocol = split.shift();
	    if (options.require_valid_protocol && options.protocols.indexOf(protocol) === -1) {
	      return false;
	    }
	  } else if (options.require_protocol) {
	    return false;
	  } else if (options.allow_protocol_relative_urls && url.substr(0, 2) === '//') {
	    split[0] = url.substr(2);
	  }
	  url = split.join('://');
	
	  if (url === '') {
	    return false;
	  }
	
	  split = url.split('/');
	  url = split.shift();
	
	  if (url === '' && !options.require_host) {
	    return true;
	  }
	
	  split = url.split('@');
	  if (split.length > 1) {
	    auth = split.shift();
	    if (auth.indexOf(':') >= 0 && auth.split(':').length > 2) {
	      return false;
	    }
	  }
	  hostname = split.join('@');
	
	  port_str = null;
	  ipv6 = null;
	  var ipv6_match = hostname.match(wrapped_ipv6);
	  if (ipv6_match) {
	    host = '';
	    ipv6 = ipv6_match[1];
	    port_str = ipv6_match[2] || null;
	  } else {
	    split = hostname.split(':');
	    host = split.shift();
	    if (split.length) {
	      port_str = split.join(':');
	    }
	  }
	
	  if (port_str !== null) {
	    port = parseInt(port_str, 10);
	    if (!/^[0-9]+$/.test(port_str) || port <= 0 || port > 65535) {
	      return false;
	    }
	  }
	
	  if (!(0, _isIP2.default)(host) && !(0, _isFQDN2.default)(host, options) && (!ipv6 || !(0, _isIP2.default)(ipv6, 6))) {
	    return false;
	  }
	
	  host = host || ipv6;
	
	  if (options.host_whitelist && !checkHost(host, options.host_whitelist)) {
	    return false;
	  }
	  if (options.host_blacklist && checkHost(host, options.host_blacklist)) {
	    return false;
	  }
	
	  return true;
	}
	module.exports = exports['default'];

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isIP;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ipv4Maybe = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
	var ipv6Block = /^[0-9A-F]{1,4}$/i;
	
	function isIP(str) {
	  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  (0, _assertString2.default)(str);
	  version = String(version);
	  if (!version) {
	    return isIP(str, 4) || isIP(str, 6);
	  } else if (version === '4') {
	    if (!ipv4Maybe.test(str)) {
	      return false;
	    }
	    var parts = str.split('.').sort(function (a, b) {
	      return a - b;
	    });
	    return parts[3] <= 255;
	  } else if (version === '6') {
	    var blocks = str.split(':');
	    var foundOmissionBlock = false; // marker to indicate ::
	
	    // At least some OS accept the last 32 bits of an IPv6 address
	    // (i.e. 2 of the blocks) in IPv4 notation, and RFC 3493 says
	    // that '::ffff:a.b.c.d' is valid for IPv4-mapped IPv6 addresses,
	    // and '::a.b.c.d' is deprecated, but also valid.
	    var foundIPv4TransitionBlock = isIP(blocks[blocks.length - 1], 4);
	    var expectedNumberOfBlocks = foundIPv4TransitionBlock ? 7 : 8;
	
	    if (blocks.length > expectedNumberOfBlocks) {
	      return false;
	    }
	    // initial or final ::
	    if (str === '::') {
	      return true;
	    } else if (str.substr(0, 2) === '::') {
	      blocks.shift();
	      blocks.shift();
	      foundOmissionBlock = true;
	    } else if (str.substr(str.length - 2) === '::') {
	      blocks.pop();
	      blocks.pop();
	      foundOmissionBlock = true;
	    }
	
	    for (var i = 0; i < blocks.length; ++i) {
	      // test for a :: which can not be at the string start/end
	      // since those cases have been handled above
	      if (blocks[i] === '' && i > 0 && i < blocks.length - 1) {
	        if (foundOmissionBlock) {
	          return false; // multiple :: in address
	        }
	        foundOmissionBlock = true;
	      } else if (foundIPv4TransitionBlock && i === blocks.length - 1) {
	        // it has been checked before that the last
	        // block is a valid IPv4 address
	      } else if (!ipv6Block.test(blocks[i])) {
	        return false;
	      }
	    }
	    if (foundOmissionBlock) {
	      return blocks.length >= 1;
	    }
	    return blocks.length === expectedNumberOfBlocks;
	  }
	  return false;
	}
	module.exports = exports['default'];

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMACAddress;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var macAddress = /^([0-9a-fA-F][0-9a-fA-F]:){5}([0-9a-fA-F][0-9a-fA-F])$/;
	
	function isMACAddress(str) {
	  (0, _assertString2.default)(str);
	  return macAddress.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBoolean;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBoolean(str) {
	  (0, _assertString2.default)(str);
	  return ['true', 'false', '1', '0'].indexOf(str) >= 0;
	}
	module.exports = exports['default'];

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAlpha;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _alpha = __webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isAlpha(str) {
	  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
	
	  (0, _assertString2.default)(str);
	  if (locale in _alpha.alpha) {
	    return _alpha.alpha[locale].test(str);
	  }
	  throw new Error('Invalid locale \'' + locale + '\'');
	}
	module.exports = exports['default'];

/***/ }),
/* 84 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var alpha = exports.alpha = {
	  'en-US': /^[A-Z]+$/i,
	  'cs-CZ': /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
	  'da-DK': /^[A-ZÆØÅ]+$/i,
	  'de-DE': /^[A-ZÄÖÜß]+$/i,
	  'es-ES': /^[A-ZÁÉÍÑÓÚÜ]+$/i,
	  'fr-FR': /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
	  'it-IT': /^[A-ZÀÉÈÌÎÓÒÙ]+$/i,
	  'nb-NO': /^[A-ZÆØÅ]+$/i,
	  'nl-NL': /^[A-ZÁÉËÏÓÖÜÚ]+$/i,
	  'nn-NO': /^[A-ZÆØÅ]+$/i,
	  'hu-HU': /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
	  'pl-PL': /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
	  'pt-PT': /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]+$/i,
	  'ru-RU': /^[А-ЯЁ]+$/i,
	  'sr-RS@latin': /^[A-ZČĆŽŠĐ]+$/i,
	  'sr-RS': /^[А-ЯЂЈЉЊЋЏ]+$/i,
	  'sv-SE': /^[A-ZÅÄÖ]+$/i,
	  'tr-TR': /^[A-ZÇĞİıÖŞÜ]+$/i,
	  'uk-UA': /^[А-ЩЬЮЯЄIЇҐ]+$/i,
	  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/
	};
	
	var alphanumeric = exports.alphanumeric = {
	  'en-US': /^[0-9A-Z]+$/i,
	  'cs-CZ': /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
	  'da-DK': /^[0-9A-ZÆØÅ]+$/i,
	  'de-DE': /^[0-9A-ZÄÖÜß]+$/i,
	  'es-ES': /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
	  'fr-FR': /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
	  'it-IT': /^[0-9A-ZÀÉÈÌÎÓÒÙ]+$/i,
	  'hu-HU': /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
	  'nb-NO': /^[0-9A-ZÆØÅ]+$/i,
	  'nl-NL': /^[0-9A-ZÁÉËÏÓÖÜÚ]+$/i,
	  'nn-NO': /^[0-9A-ZÆØÅ]+$/i,
	  'pl-PL': /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
	  'pt-PT': /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]+$/i,
	  'ru-RU': /^[0-9А-ЯЁ]+$/i,
	  'sr-RS@latin': /^[0-9A-ZČĆŽŠĐ]+$/i,
	  'sr-RS': /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
	  'sv-SE': /^[0-9A-ZÅÄÖ]+$/i,
	  'tr-TR': /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
	  'uk-UA': /^[0-9А-ЩЬЮЯЄIЇҐ]+$/i,
	  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/
	};
	
	var englishLocales = exports.englishLocales = ['AU', 'GB', 'HK', 'IN', 'NZ', 'ZA', 'ZM'];
	
	for (var locale, i = 0; i < englishLocales.length; i++) {
	  locale = 'en-' + englishLocales[i];
	  alpha[locale] = alpha['en-US'];
	  alphanumeric[locale] = alphanumeric['en-US'];
	}
	
	alpha['pt-BR'] = alpha['pt-PT'];
	alphanumeric['pt-BR'] = alphanumeric['pt-PT'];
	
	// Source: http://www.localeplanet.com/java/
	var arabicLocales = exports.arabicLocales = ['AE', 'BH', 'DZ', 'EG', 'IQ', 'JO', 'KW', 'LB', 'LY', 'MA', 'QM', 'QA', 'SA', 'SD', 'SY', 'TN', 'YE'];
	
	for (var _locale, _i = 0; _i < arabicLocales.length; _i++) {
	  _locale = 'ar-' + arabicLocales[_i];
	  alpha[_locale] = alpha.ar;
	  alphanumeric[_locale] = alphanumeric.ar;
	}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAlphanumeric;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _alpha = __webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isAlphanumeric(str) {
	  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
	
	  (0, _assertString2.default)(str);
	  if (locale in _alpha.alphanumeric) {
	    return _alpha.alphanumeric[locale].test(str);
	  }
	  throw new Error('Invalid locale \'' + locale + '\'');
	}
	module.exports = exports['default'];

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isNumeric;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var numeric = /^[-+]?[0-9]+$/;
	
	function isNumeric(str) {
	  (0, _assertString2.default)(str);
	  return numeric.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isLowercase;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isLowercase(str) {
	  (0, _assertString2.default)(str);
	  return str === str.toLowerCase();
	}
	module.exports = exports['default'];

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isUppercase;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isUppercase(str) {
	  (0, _assertString2.default)(str);
	  return str === str.toUpperCase();
	}
	module.exports = exports['default'];

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAscii;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-control-regex */
	var ascii = /^[\x00-\x7F]+$/;
	/* eslint-enable no-control-regex */
	
	function isAscii(str) {
	  (0, _assertString2.default)(str);
	  return ascii.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fullWidth = undefined;
	exports.default = isFullWidth;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fullWidth = exports.fullWidth = /[^\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
	
	function isFullWidth(str) {
	  (0, _assertString2.default)(str);
	  return fullWidth.test(str);
	}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.halfWidth = undefined;
	exports.default = isHalfWidth;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var halfWidth = exports.halfWidth = /[\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
	
	function isHalfWidth(str) {
	  (0, _assertString2.default)(str);
	  return halfWidth.test(str);
	}

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isVariableWidth;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _isFullWidth = __webpack_require__(90);
	
	var _isHalfWidth = __webpack_require__(91);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isVariableWidth(str) {
	  (0, _assertString2.default)(str);
	  return _isFullWidth.fullWidth.test(str) && _isHalfWidth.halfWidth.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMultibyte;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-control-regex */
	var multibyte = /[^\x00-\x7F]/;
	/* eslint-enable no-control-regex */
	
	function isMultibyte(str) {
	  (0, _assertString2.default)(str);
	  return multibyte.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSurrogatePair;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var surrogatePair = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;
	
	function isSurrogatePair(str) {
	  (0, _assertString2.default)(str);
	  return surrogatePair.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isInt;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var int = /^(?:[-+]?(?:0|[1-9][0-9]*))$/;
	var intLeadingZeroes = /^[-+]?[0-9]+$/;
	
	function isInt(str, options) {
	  (0, _assertString2.default)(str);
	  options = options || {};
	
	  // Get the regex to use for testing, based on whether
	  // leading zeroes are allowed or not.
	  var regex = options.hasOwnProperty('allow_leading_zeroes') && !options.allow_leading_zeroes ? int : intLeadingZeroes;
	
	  // Check min/max/lt/gt
	  var minCheckPassed = !options.hasOwnProperty('min') || str >= options.min;
	  var maxCheckPassed = !options.hasOwnProperty('max') || str <= options.max;
	  var ltCheckPassed = !options.hasOwnProperty('lt') || str < options.lt;
	  var gtCheckPassed = !options.hasOwnProperty('gt') || str > options.gt;
	
	  return regex.test(str) && minCheckPassed && maxCheckPassed && ltCheckPassed && gtCheckPassed;
	}
	module.exports = exports['default'];

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFloat;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var float = /^(?:[-+])?(?:[0-9]+)?(?:\.[0-9]*)?(?:[eE][\+\-]?(?:[0-9]+))?$/;
	
	function isFloat(str, options) {
	  (0, _assertString2.default)(str);
	  options = options || {};
	  if (str === '' || str === '.') {
	    return false;
	  }
	  return float.test(str) && (!options.hasOwnProperty('min') || str >= options.min) && (!options.hasOwnProperty('max') || str <= options.max) && (!options.hasOwnProperty('lt') || str < options.lt) && (!options.hasOwnProperty('gt') || str > options.gt);
	}
	module.exports = exports['default'];

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDecimal;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var decimal = /^[-+]?([0-9]+|\.[0-9]+|[0-9]+\.[0-9]+)$/;
	
	function isDecimal(str) {
	  (0, _assertString2.default)(str);
	  return str !== '' && decimal.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isHexadecimal;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hexadecimal = /^[0-9A-F]+$/i;
	
	function isHexadecimal(str) {
	  (0, _assertString2.default)(str);
	  return hexadecimal.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDivisibleBy;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _toFloat = __webpack_require__(68);
	
	var _toFloat2 = _interopRequireDefault(_toFloat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isDivisibleBy(str, num) {
	  (0, _assertString2.default)(str);
	  return (0, _toFloat2.default)(str) % parseInt(num, 10) === 0;
	}
	module.exports = exports['default'];

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isHexColor;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hexcolor = /^#?([0-9A-F]{3}|[0-9A-F]{6})$/i;
	
	function isHexColor(str) {
	  (0, _assertString2.default)(str);
	  return hexcolor.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISRC;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// see http://isrc.ifpi.org/en/isrc-standard/code-syntax
	var isrc = /^[A-Z]{2}[0-9A-Z]{3}\d{2}\d{5}$/;
	
	function isISRC(str) {
	  (0, _assertString2.default)(str);
	  return isrc.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMD5;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var md5 = /^[a-f0-9]{32}$/;
	
	function isMD5(str) {
	  (0, _assertString2.default)(str);
	  return md5.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isHash;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lengths = {
	  md5: 32,
	  md4: 32,
	  sha1: 40,
	  sha256: 64,
	  sha384: 96,
	  sha512: 128,
	  ripemd128: 32,
	  ripemd160: 40,
	  tiger128: 32,
	  tiger160: 40,
	  tiger192: 48,
	  crc32: 8,
	  crc32b: 8
	};
	
	function isHash(str, algorithm) {
	  (0, _assertString2.default)(str);
	  var hash = new RegExp('^[a-f0-9]{' + lengths[algorithm] + '}$');
	  return hash.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isJSON;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isJSON(str) {
	  (0, _assertString2.default)(str);
	  try {
	    var obj = JSON.parse(str);
	    return !!obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
	  } catch (e) {/* ignore */}
	  return false;
	}
	module.exports = exports['default'];

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEmpty;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isEmpty(str) {
	  (0, _assertString2.default)(str);
	  return str.length === 0;
	}
	module.exports = exports['default'];

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isLength;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable prefer-rest-params */
	function isLength(str, options) {
	  (0, _assertString2.default)(str);
	  var min = void 0;
	  var max = void 0;
	  if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
	    min = options.min || 0;
	    max = options.max;
	  } else {
	    // backwards compatibility: isLength(str, min [, max])
	    min = arguments[1];
	    max = arguments[2];
	  }
	  var surrogatePairs = str.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [];
	  var len = str.length - surrogatePairs.length;
	  return len >= min && (typeof max === 'undefined' || len <= max);
	}
	module.exports = exports['default'];

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isUUID;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var uuid = {
	  3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
	  4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
	  5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
	  all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i
	};
	
	function isUUID(str) {
	  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';
	
	  (0, _assertString2.default)(str);
	  var pattern = uuid[version];
	  return pattern && pattern.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMongoId;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _isHexadecimal = __webpack_require__(98);
	
	var _isHexadecimal2 = _interopRequireDefault(_isHexadecimal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isMongoId(str) {
	  (0, _assertString2.default)(str);
	  return (0, _isHexadecimal2.default)(str) && str.length === 24;
	}
	module.exports = exports['default'];

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAfter;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _toDate = __webpack_require__(66);
	
	var _toDate2 = _interopRequireDefault(_toDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isAfter(str) {
	  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : String(new Date());
	
	  (0, _assertString2.default)(str);
	  var comparison = (0, _toDate2.default)(date);
	  var original = (0, _toDate2.default)(str);
	  return !!(original && comparison && original > comparison);
	}
	module.exports = exports['default'];

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBefore;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _toDate = __webpack_require__(66);
	
	var _toDate2 = _interopRequireDefault(_toDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBefore(str) {
	  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : String(new Date());
	
	  (0, _assertString2.default)(str);
	  var comparison = (0, _toDate2.default)(date);
	  var original = (0, _toDate2.default)(str);
	  return !!(original && comparison && original < comparison);
	}
	module.exports = exports['default'];

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isIn;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _toString = __webpack_require__(73);
	
	var _toString2 = _interopRequireDefault(_toString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isIn(str, options) {
	  (0, _assertString2.default)(str);
	  var i = void 0;
	  if (Object.prototype.toString.call(options) === '[object Array]') {
	    var array = [];
	    for (i in options) {
	      if ({}.hasOwnProperty.call(options, i)) {
	        array[i] = (0, _toString2.default)(options[i]);
	      }
	    }
	    return array.indexOf(str) >= 0;
	  } else if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
	    return options.hasOwnProperty(str);
	  } else if (options && typeof options.indexOf === 'function') {
	    return options.indexOf(str) >= 0;
	  }
	  return false;
	}
	module.exports = exports['default'];

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isCreditCard;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	var creditCard = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11}|62[0-9]{14})$/;
	/* eslint-enable max-len */
	
	function isCreditCard(str) {
	  (0, _assertString2.default)(str);
	  var sanitized = str.replace(/[- ]+/g, '');
	  if (!creditCard.test(sanitized)) {
	    return false;
	  }
	  var sum = 0;
	  var digit = void 0;
	  var tmpNum = void 0;
	  var shouldDouble = void 0;
	  for (var i = sanitized.length - 1; i >= 0; i--) {
	    digit = sanitized.substring(i, i + 1);
	    tmpNum = parseInt(digit, 10);
	    if (shouldDouble) {
	      tmpNum *= 2;
	      if (tmpNum >= 10) {
	        sum += tmpNum % 10 + 1;
	      } else {
	        sum += tmpNum;
	      }
	    } else {
	      sum += tmpNum;
	    }
	    shouldDouble = !shouldDouble;
	  }
	  return !!(sum % 10 === 0 ? sanitized : false);
	}
	module.exports = exports['default'];

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISIN;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isin = /^[A-Z]{2}[0-9A-Z]{9}[0-9]$/;
	
	function isISIN(str) {
	  (0, _assertString2.default)(str);
	  if (!isin.test(str)) {
	    return false;
	  }
	
	  var checksumStr = str.replace(/[A-Z]/g, function (character) {
	    return parseInt(character, 36);
	  });
	
	  var sum = 0;
	  var digit = void 0;
	  var tmpNum = void 0;
	  var shouldDouble = true;
	  for (var i = checksumStr.length - 2; i >= 0; i--) {
	    digit = checksumStr.substring(i, i + 1);
	    tmpNum = parseInt(digit, 10);
	    if (shouldDouble) {
	      tmpNum *= 2;
	      if (tmpNum >= 10) {
	        sum += tmpNum + 1;
	      } else {
	        sum += tmpNum;
	      }
	    } else {
	      sum += tmpNum;
	    }
	    shouldDouble = !shouldDouble;
	  }
	
	  return parseInt(str.substr(str.length - 1), 10) === (10000 - sum) % 10;
	}
	module.exports = exports['default'];

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISBN;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isbn10Maybe = /^(?:[0-9]{9}X|[0-9]{10})$/;
	var isbn13Maybe = /^(?:[0-9]{13})$/;
	var factor = [1, 3];
	
	function isISBN(str) {
	  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  (0, _assertString2.default)(str);
	  version = String(version);
	  if (!version) {
	    return isISBN(str, 10) || isISBN(str, 13);
	  }
	  var sanitized = str.replace(/[\s-]+/g, '');
	  var checksum = 0;
	  var i = void 0;
	  if (version === '10') {
	    if (!isbn10Maybe.test(sanitized)) {
	      return false;
	    }
	    for (i = 0; i < 9; i++) {
	      checksum += (i + 1) * sanitized.charAt(i);
	    }
	    if (sanitized.charAt(9) === 'X') {
	      checksum += 10 * 10;
	    } else {
	      checksum += 10 * sanitized.charAt(9);
	    }
	    if (checksum % 11 === 0) {
	      return !!sanitized;
	    }
	  } else if (version === '13') {
	    if (!isbn13Maybe.test(sanitized)) {
	      return false;
	    }
	    for (i = 0; i < 12; i++) {
	      checksum += factor[i % 2] * sanitized.charAt(i);
	    }
	    if (sanitized.charAt(12) - (10 - checksum % 10) % 10 === 0) {
	      return !!sanitized;
	    }
	  }
	  return false;
	}
	module.exports = exports['default'];

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISSN;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var issn = '^\\d{4}-?\\d{3}[\\dX]$';
	
	function isISSN(str) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  (0, _assertString2.default)(str);
	  var testIssn = issn;
	  testIssn = options.require_hyphen ? testIssn.replace('?', '') : testIssn;
	  testIssn = options.case_sensitive ? new RegExp(testIssn) : new RegExp(testIssn, 'i');
	  if (!testIssn.test(str)) {
	    return false;
	  }
	  var issnDigits = str.replace('-', '');
	  var position = 8;
	  var checksum = 0;
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = issnDigits[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var digit = _step.value;
	
	      var digitValue = digit.toUpperCase() === 'X' ? 10 : +digit;
	      checksum += digitValue * position;
	      --position;
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return checksum % 11 === 0;
	}
	module.exports = exports['default'];

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMobilePhone;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	var phones = {
	  'ar-AE': /^((\+?971)|0)?5[024568]\d{7}$/,
	  'ar-DZ': /^(\+?213|0)(5|6|7)\d{8}$/,
	  'ar-EG': /^((\+?20)|0)?1[012]\d{8}$/,
	  'ar-JO': /^(\+?962|0)?7[789]\d{7}$/,
	  'ar-SY': /^(!?(\+?963)|0)?9\d{8}$/,
	  'ar-SA': /^(!?(\+?966)|0)?5\d{8}$/,
	  'en-US': /^(\+?1)?[2-9]\d{2}[2-9](?!11)\d{6}$/,
	  'cs-CZ': /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
	  'sk-SK': /^(\+?421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
	  'de-DE': /^(\+?49[ \.\-])?([\(]{1}[0-9]{1,6}[\)])?([0-9 \.\-\/]{3,20})((x|ext|extension)[ ]?[0-9]{1,4})?$/,
	  'da-DK': /^(\+?45)?(\d{8})$/,
	  'el-GR': /^(\+?30)?(69\d{8})$/,
	  'en-AU': /^(\+?61|0)4\d{8}$/,
	  'en-GB': /^(\+?44|0)7\d{9}$/,
	  'en-HK': /^(\+?852\-?)?[569]\d{3}\-?\d{4}$/,
	  'en-IN': /^(\+?91|0)?[789]\d{9}$/,
	  'en-KE': /^(\+?254|0)?[7]\d{8}$/,
	  'en-NG': /^(\+?234|0)?[789]\d{9}$/,
	  'en-NZ': /^(\+?64|0)2\d{7,9}$/,
	  'en-UG': /^(\+?256|0)?[7]\d{8}$/,
	  'en-RW': /^(\+?250|0)?[7]\d{8}$/,
	  'en-TZ': /^(\+?255|0)?[67]\d{8}$/,
	  'en-ZA': /^(\+?27|0)\d{9}$/,
	  'en-ZM': /^(\+?26)?09[567]\d{7}$/,
	  'es-ES': /^(\+?34)?(6\d{1}|7[1234])\d{7}$/,
	  'fi-FI': /^(\+?358|0)\s?(4(0|1|2|4|5|6)?|50)\s?(\d\s?){4,8}\d$/,
	  'fa-IR': /^(\+?98[\-\s]?|0)9[0-39]\d[\-\s]?\d{3}[\-\s]?\d{4}$/,
	  'fr-FR': /^(\+?33|0)[67]\d{8}$/,
	  'he-IL': /^(\+972|0)([23489]|5[0248]|77)[1-9]\d{6}/,
	  'hu-HU': /^(\+?36)(20|30|70)\d{7}$/,
	  'lt-LT': /^(\+370|8)\d{8}$/,
	  'id-ID': /^(\+?62|0[1-9])[\s|\d]+$/,
	  'it-IT': /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
	  'ko-KR': /^((\+?82)[ \-]?)?0?1([0|1|6|7|8|9]{1})[ \-]?\d{3,4}[ \-]?\d{4}$/,
	  'ja-JP': /^(\+?81|0)\d{1,4}[ \-]?\d{1,4}[ \-]?\d{4}$/,
	  'ms-MY': /^(\+?6?01){1}(([145]{1}(\-|\s)?\d{7,8})|([236789]{1}(\s|\-)?\d{7}))$/,
	  'nb-NO': /^(\+?47)?[49]\d{7}$/,
	  'nl-BE': /^(\+?32|0)4?\d{8}$/,
	  'nn-NO': /^(\+?47)?[49]\d{7}$/,
	  'pl-PL': /^(\+?48)? ?[5-8]\d ?\d{3} ?\d{2} ?\d{2}$/,
	  'pt-BR': /^(\+?55|0)\-?[1-9]{2}\-?[2-9]{1}\d{3,4}\-?\d{4}$/,
	  'pt-PT': /^(\+?351)?9[1236]\d{7}$/,
	  'ro-RO': /^(\+?4?0)\s?7\d{2}(\/|\s|\.|\-)?\d{3}(\s|\.|\-)?\d{3}$/,
	  'en-PK': /^((\+92)|(0092))-{0,1}\d{3}-{0,1}\d{7}$|^\d{11}$|^\d{4}-\d{7}$/,
	  'ru-RU': /^(\+?7|8)?9\d{9}$/,
	  'sr-RS': /^(\+3816|06)[- \d]{5,9}$/,
	  'tr-TR': /^(\+?90|0)?5\d{9}$/,
	  'vi-VN': /^(\+?84|0)?((1(2([0-9])|6([2-9])|88|99))|(9((?!5)[0-9])))([0-9]{7})$/,
	  'zh-CN': /^(\+?0?86\-?)?1[345789]\d{9}$/,
	  'zh-TW': /^(\+?886\-?|0)?9\d{8}$/
	};
	/* eslint-enable max-len */
	
	// aliases
	phones['en-CA'] = phones['en-US'];
	phones['fr-BE'] = phones['nl-BE'];
	phones['zh-HK'] = phones['en-HK'];
	
	function isMobilePhone(str, locale) {
	  (0, _assertString2.default)(str);
	  if (locale in phones) {
	    return phones[locale].test(str);
	  } else if (locale === 'any') {
	    for (var key in phones) {
	      if (phones.hasOwnProperty(key)) {
	        var phone = phones[key];
	        if (phone.test(str)) {
	          return true;
	        }
	      }
	    }
	    return false;
	  }
	  throw new Error('Invalid locale \'' + locale + '\'');
	}
	module.exports = exports['default'];

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isCurrency;
	
	var _merge = __webpack_require__(76);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function currencyRegex(options) {
	  var decimal_digits = '\\d{' + options.digits_after_decimal[0] + '}';
	  options.digits_after_decimal.forEach(function (digit, index) {
	    if (index !== 0) decimal_digits = decimal_digits + '|\\d{' + digit + '}';
	  });
	  var symbol = '(\\' + options.symbol.replace(/\./g, '\\.') + ')' + (options.require_symbol ? '' : '?'),
	      negative = '-?',
	      whole_dollar_amount_without_sep = '[1-9]\\d*',
	      whole_dollar_amount_with_sep = '[1-9]\\d{0,2}(\\' + options.thousands_separator + '\\d{3})*',
	      valid_whole_dollar_amounts = ['0', whole_dollar_amount_without_sep, whole_dollar_amount_with_sep],
	      whole_dollar_amount = '(' + valid_whole_dollar_amounts.join('|') + ')?',
	      decimal_amount = '(\\' + options.decimal_separator + '(' + decimal_digits + '))' + (options.require_decimal ? '' : '?');
	  var pattern = whole_dollar_amount + (options.allow_decimal || options.require_decimal ? decimal_amount : '');
	
	  // default is negative sign before symbol, but there are two other options (besides parens)
	  if (options.allow_negatives && !options.parens_for_negatives) {
	    if (options.negative_sign_after_digits) {
	      pattern += negative;
	    } else if (options.negative_sign_before_digits) {
	      pattern = negative + pattern;
	    }
	  }
	
	  // South African Rand, for example, uses R 123 (space) and R-123 (no space)
	  if (options.allow_negative_sign_placeholder) {
	    pattern = '( (?!\\-))?' + pattern;
	  } else if (options.allow_space_after_symbol) {
	    pattern = ' ?' + pattern;
	  } else if (options.allow_space_after_digits) {
	    pattern += '( (?!$))?';
	  }
	
	  if (options.symbol_after_digits) {
	    pattern += symbol;
	  } else {
	    pattern = symbol + pattern;
	  }
	
	  if (options.allow_negatives) {
	    if (options.parens_for_negatives) {
	      pattern = '(\\(' + pattern + '\\)|' + pattern + ')';
	    } else if (!(options.negative_sign_before_digits || options.negative_sign_after_digits)) {
	      pattern = negative + pattern;
	    }
	  }
	
	  // ensure there's a dollar and/or decimal amount, and that
	  // it doesn't start with a space or a negative sign followed by a space
	  return new RegExp('^(?!-? )(?=.*\\d)' + pattern + '$');
	}
	
	var default_currency_options = {
	  symbol: '$',
	  require_symbol: false,
	  allow_space_after_symbol: false,
	  symbol_after_digits: false,
	  allow_negatives: true,
	  parens_for_negatives: false,
	  negative_sign_before_digits: false,
	  negative_sign_after_digits: false,
	  allow_negative_sign_placeholder: false,
	  thousands_separator: ',',
	  decimal_separator: '.',
	  allow_decimal: true,
	  require_decimal: false,
	  digits_after_decimal: [2],
	  allow_space_after_digits: false
	};
	
	function isCurrency(str, options) {
	  (0, _assertString2.default)(str);
	  options = (0, _merge2.default)(options, default_currency_options);
	  return currencyRegex(options).test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISO8601;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	// from http://goo.gl/0ejHHW
	var iso8601 = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
	/* eslint-enable max-len */
	
	function isISO8601(str) {
	  (0, _assertString2.default)(str);
	  return iso8601.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBase64;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var notBase64 = /[^A-Z0-9+\/=]/i;
	
	function isBase64(str) {
	  (0, _assertString2.default)(str);
	  var len = str.length;
	  if (!len || len % 4 !== 0 || notBase64.test(str)) {
	    return false;
	  }
	  var firstPaddingChar = str.indexOf('=');
	  return firstPaddingChar === -1 || firstPaddingChar === len - 1 || firstPaddingChar === len - 2 && str[len - 1] === '=';
	}
	module.exports = exports['default'];

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDataURI;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dataURI = /^\s*data:([a-z]+\/[a-z0-9\-\+]+(;[a-z\-]+=[a-z0-9\-]+)?)?(;base64)?,[a-z0-9!\$&',\(\)\*\+,;=\-\._~:@\/\?%\s]*\s*$/i; // eslint-disable-line max-len
	
	function isDataURI(str) {
	  (0, _assertString2.default)(str);
	  return dataURI.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (str) {
	  (0, _assertString2.default)(str);
	  if (!str.includes(',')) return false;
	  var pair = str.split(',');
	  return lat.test(pair[0]) && long.test(pair[1]);
	};
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lat = /^\(?[+-]?(90(\.0+)?|[1-8]?\d(\.\d+)?)$/;
	var long = /^\s?[+-]?(180(\.0+)?|1[0-7]\d(\.\d+)?|\d{1,2}(\.\d+)?)\)?$/;
	
	module.exports = exports['default'];

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.locales = undefined;
	
	exports.default = function (str, locale) {
	  (0, _assertString2.default)(str);
	  if (locale in patterns) {
	    return patterns[locale].test(str);
	  } else if (locale === 'any') {
	    for (var key in patterns) {
	      if (patterns.hasOwnProperty(key)) {
	        var pattern = patterns[key];
	        if (pattern.test(str)) {
	          return true;
	        }
	      }
	    }
	    return false;
	  }
	  throw new Error('Invalid locale \'' + locale + '\'');
	};
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// common patterns
	var threeDigit = /^\d{3}$/;
	var fourDigit = /^\d{4}$/;
	var fiveDigit = /^\d{5}$/;
	var sixDigit = /^\d{6}$/;
	
	var patterns = {
	  AT: fourDigit,
	  AU: sixDigit,
	  BE: fourDigit,
	  CA: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][\s\-]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
	  CH: fourDigit,
	  CZ: /^\d{3}\s?\d{2}$/,
	  DE: fiveDigit,
	  DK: fourDigit,
	  DZ: fiveDigit,
	  ES: fiveDigit,
	  FI: fiveDigit,
	  FR: /^\d{2}\s?\d{3}$/,
	  GB: /^(gir\s?0aa|[a-z]{1,2}\d[\da-z]?\s?(\d[a-z]{2})?)$/i,
	  GR: /^\d{3}\s?\d{2}$/,
	  IL: fiveDigit,
	  IN: sixDigit,
	  IS: threeDigit,
	  IT: fiveDigit,
	  JP: /^\d{3}\-\d{4}$/,
	  KE: fiveDigit,
	  LI: /^(948[5-9]|949[0-7])$/,
	  MX: fiveDigit,
	  NL: /^\d{4}\s?[a-z]{2}$/i,
	  NO: fourDigit,
	  PL: /^\d{2}\-\d{3}$/,
	  PT: /^\d{4}(\-\d{3})?$/,
	  RO: sixDigit,
	  RU: sixDigit,
	  SA: fiveDigit,
	  SE: /^\d{3}\s?\d{2}$/,
	  TW: /^\d{3}(\d{2})?$/,
	  US: /^\d{5}(-\d{4})?$/,
	  ZA: fourDigit,
	  ZM: fiveDigit
	};
	
	var locales = exports.locales = Object.keys(patterns);

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ltrim;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ltrim(str, chars) {
	  (0, _assertString2.default)(str);
	  var pattern = chars ? new RegExp('^[' + chars + ']+', 'g') : /^\s+/g;
	  return str.replace(pattern, '');
	}
	module.exports = exports['default'];

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = rtrim;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function rtrim(str, chars) {
	  (0, _assertString2.default)(str);
	  var pattern = chars ? new RegExp('[' + chars + ']') : /\s/;
	
	  var idx = str.length - 1;
	  while (idx >= 0 && pattern.test(str[idx])) {
	    idx--;
	  }
	
	  return idx < str.length ? str.substr(0, idx + 1) : str;
	}
	module.exports = exports['default'];

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = trim;
	
	var _rtrim = __webpack_require__(124);
	
	var _rtrim2 = _interopRequireDefault(_rtrim);
	
	var _ltrim = __webpack_require__(123);
	
	var _ltrim2 = _interopRequireDefault(_ltrim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function trim(str, chars) {
	  return (0, _rtrim2.default)((0, _ltrim2.default)(str, chars), chars);
	}
	module.exports = exports['default'];

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = escape;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escape(str) {
	  (0, _assertString2.default)(str);
	  return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\//g, '&#x2F;').replace(/\\/g, '&#x5C;').replace(/`/g, '&#96;');
	}
	module.exports = exports['default'];

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = unescape;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function unescape(str) {
	  (0, _assertString2.default)(str);
	  return str.replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&#x2F;/g, '/').replace(/&#x5C;/g, '\\').replace(/&#96;/g, '`');
	}
	module.exports = exports['default'];

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = stripLow;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _blacklist = __webpack_require__(129);
	
	var _blacklist2 = _interopRequireDefault(_blacklist);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function stripLow(str, keep_new_lines) {
	  (0, _assertString2.default)(str);
	  var chars = keep_new_lines ? '\\x00-\\x09\\x0B\\x0C\\x0E-\\x1F\\x7F' : '\\x00-\\x1F\\x7F';
	  return (0, _blacklist2.default)(str, chars);
	}
	module.exports = exports['default'];

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = blacklist;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function blacklist(str, chars) {
	  (0, _assertString2.default)(str);
	  return str.replace(new RegExp('[' + chars + ']+', 'g'), '');
	}
	module.exports = exports['default'];

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = whitelist;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function whitelist(str, chars) {
	  (0, _assertString2.default)(str);
	  return str.replace(new RegExp('[^' + chars + ']+', 'g'), '');
	}
	module.exports = exports['default'];

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWhitelisted;
	
	var _assertString = __webpack_require__(67);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isWhitelisted(str, chars) {
	  (0, _assertString2.default)(str);
	  for (var i = str.length - 1; i >= 0; i--) {
	    if (chars.indexOf(str[i]) === -1) {
	      return false;
	    }
	  }
	  return true;
	}
	module.exports = exports['default'];

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = normalizeEmail;
	
	var _isEmail = __webpack_require__(75);
	
	var _isEmail2 = _interopRequireDefault(_isEmail);
	
	var _merge = __webpack_require__(76);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_normalize_email_options = {
	  // The following options apply to all email addresses
	  // Lowercases the local part of the email address.
	  // Please note this may violate RFC 5321 as per http://stackoverflow.com/a/9808332/192024).
	  // The domain is always lowercased, as per RFC 1035
	  all_lowercase: true,
	
	  // The following conversions are specific to GMail
	  // Lowercases the local part of the GMail address (known to be case-insensitive)
	  gmail_lowercase: true,
	  // Removes dots from the local part of the email address, as that's ignored by GMail
	  gmail_remove_dots: true,
	  // Removes the subaddress (e.g. "+foo") from the email address
	  gmail_remove_subaddress: true,
	  // Conversts the googlemail.com domain to gmail.com
	  gmail_convert_googlemaildotcom: true,
	
	  // The following conversions are specific to Outlook.com / Windows Live / Hotmail
	  // Lowercases the local part of the Outlook.com address (known to be case-insensitive)
	  outlookdotcom_lowercase: true,
	  // Removes the subaddress (e.g. "+foo") from the email address
	  outlookdotcom_remove_subaddress: true,
	
	  // The following conversions are specific to Yahoo
	  // Lowercases the local part of the Yahoo address (known to be case-insensitive)
	  yahoo_lowercase: true,
	  // Removes the subaddress (e.g. "-foo") from the email address
	  yahoo_remove_subaddress: true,
	
	  // The following conversions are specific to iCloud
	  // Lowercases the local part of the iCloud address (known to be case-insensitive)
	  icloud_lowercase: true,
	  // Removes the subaddress (e.g. "+foo") from the email address
	  icloud_remove_subaddress: true
	};
	
	// List of domains used by iCloud
	var icloud_domains = ['icloud.com', 'me.com'];
	
	// List of domains used by Outlook.com and its predecessors
	// This list is likely incomplete.
	// Partial reference:
	// https://blogs.office.com/2013/04/17/outlook-com-gets-two-step-verification-sign-in-by-alias-and-new-international-domains/
	var outlookdotcom_domains = ['hotmail.at', 'hotmail.be', 'hotmail.ca', 'hotmail.cl', 'hotmail.co.il', 'hotmail.co.nz', 'hotmail.co.th', 'hotmail.co.uk', 'hotmail.com', 'hotmail.com.ar', 'hotmail.com.au', 'hotmail.com.br', 'hotmail.com.gr', 'hotmail.com.mx', 'hotmail.com.pe', 'hotmail.com.tr', 'hotmail.com.vn', 'hotmail.cz', 'hotmail.de', 'hotmail.dk', 'hotmail.es', 'hotmail.fr', 'hotmail.hu', 'hotmail.id', 'hotmail.ie', 'hotmail.in', 'hotmail.it', 'hotmail.jp', 'hotmail.kr', 'hotmail.lv', 'hotmail.my', 'hotmail.ph', 'hotmail.pt', 'hotmail.sa', 'hotmail.sg', 'hotmail.sk', 'live.be', 'live.co.uk', 'live.com', 'live.com.ar', 'live.com.mx', 'live.de', 'live.es', 'live.eu', 'live.fr', 'live.it', 'live.nl', 'msn.com', 'outlook.at', 'outlook.be', 'outlook.cl', 'outlook.co.il', 'outlook.co.nz', 'outlook.co.th', 'outlook.com', 'outlook.com.ar', 'outlook.com.au', 'outlook.com.br', 'outlook.com.gr', 'outlook.com.pe', 'outlook.com.tr', 'outlook.com.vn', 'outlook.cz', 'outlook.de', 'outlook.dk', 'outlook.es', 'outlook.fr', 'outlook.hu', 'outlook.id', 'outlook.ie', 'outlook.in', 'outlook.it', 'outlook.jp', 'outlook.kr', 'outlook.lv', 'outlook.my', 'outlook.ph', 'outlook.pt', 'outlook.sa', 'outlook.sg', 'outlook.sk', 'passport.com'];
	
	// List of domains used by Yahoo Mail
	// This list is likely incomplete
	var yahoo_domains = ['rocketmail.com', 'yahoo.ca', 'yahoo.co.uk', 'yahoo.com', 'yahoo.de', 'yahoo.fr', 'yahoo.in', 'yahoo.it', 'ymail.com'];
	
	function normalizeEmail(email, options) {
	  options = (0, _merge2.default)(options, default_normalize_email_options);
	
	  if (!(0, _isEmail2.default)(email)) {
	    return false;
	  }
	
	  var raw_parts = email.split('@');
	  var domain = raw_parts.pop();
	  var user = raw_parts.join('@');
	  var parts = [user, domain];
	
	  // The domain is always lowercased, as it's case-insensitive per RFC 1035
	  parts[1] = parts[1].toLowerCase();
	
	  if (parts[1] === 'gmail.com' || parts[1] === 'googlemail.com') {
	    // Address is GMail
	    if (options.gmail_remove_subaddress) {
	      parts[0] = parts[0].split('+')[0];
	    }
	    if (options.gmail_remove_dots) {
	      parts[0] = parts[0].replace(/\./g, '');
	    }
	    if (!parts[0].length) {
	      return false;
	    }
	    if (options.all_lowercase || options.gmail_lowercase) {
	      parts[0] = parts[0].toLowerCase();
	    }
	    parts[1] = options.gmail_convert_googlemaildotcom ? 'gmail.com' : parts[1];
	  } else if (~icloud_domains.indexOf(parts[1])) {
	    // Address is iCloud
	    if (options.icloud_remove_subaddress) {
	      parts[0] = parts[0].split('+')[0];
	    }
	    if (!parts[0].length) {
	      return false;
	    }
	    if (options.all_lowercase || options.icloud_lowercase) {
	      parts[0] = parts[0].toLowerCase();
	    }
	  } else if (~outlookdotcom_domains.indexOf(parts[1])) {
	    // Address is Outlook.com
	    if (options.outlookdotcom_remove_subaddress) {
	      parts[0] = parts[0].split('+')[0];
	    }
	    if (!parts[0].length) {
	      return false;
	    }
	    if (options.all_lowercase || options.outlookdotcom_lowercase) {
	      parts[0] = parts[0].toLowerCase();
	    }
	  } else if (~yahoo_domains.indexOf(parts[1])) {
	    // Address is Yahoo
	    if (options.yahoo_remove_subaddress) {
	      var components = parts[0].split('-');
	      parts[0] = components.length > 1 ? components.slice(0, -1).join('-') : components[0];
	    }
	    if (!parts[0].length) {
	      return false;
	    }
	    if (options.all_lowercase || options.yahoo_lowercase) {
	      parts[0] = parts[0].toLowerCase();
	    }
	  } else if (options.all_lowercase) {
	    // Any other address
	    parts[0] = parts[0].toLowerCase();
	  }
	  return parts.join('@');
	}
	module.exports = exports['default'];

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BoardComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(62);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(64);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BoardComponent = exports.BoardComponent = function () {
	  BoardComponent.$inject = ['screenSize', '$location', 'ProjectAPI', 'arrow', 'ProductAPI', 'LanguageService', '$uibModal', 'Modal', 'gettextCatalog', 'Auth'];
	  function BoardComponent(screenSize, $location, ProjectAPI, arrow, ProductAPI, LanguageService, $uibModal, Modal, gettextCatalog, Auth) {
	    "ngInject";
	
	    _classCallCheck(this, BoardComponent);
	
	    var that = this;
	
	    (0, _jquery2.default)(function () {
	      (0, _jquery2.default)(".col-callout").matchHeight();
	    });
	
	    this.spinnerEnabled = true;
	    this.Modal = Modal;
	    this.ls = LanguageService;
	    this.gettextCatalog = gettextCatalog;
	    this.ProjectAPI = ProjectAPI;
	    this.ProductAPI = ProductAPI;
	    this.$location = $location;
	    this.arrow = arrow;
	    this.statusList = {
	      11: this.gettextCatalog.getString("En cours de saisie"),
	      12: this.gettextCatalog.getString("Envoyée"),
	      13: this.gettextCatalog.getString("Demande soumise"),
	      20: this.gettextCatalog.getString("En cours de traitement"),
	      21: this.gettextCatalog.getString("Modification en cours"),
	      22: this.gettextCatalog.getString("Modification envoyée"),
	      23: this.gettextCatalog.getString("Demande soumise"),
	      30: this.gettextCatalog.getString("Accordée"),
	      31: this.gettextCatalog.getString("Accordée - Modification en cours"),
	      32: this.gettextCatalog.getString("Accordée - Modification envoyée"),
	      33: this.gettextCatalog.getString("Demande soumise"),
	      40: this.gettextCatalog.getString("Refusée"),
	      41: this.gettextCatalog.getString("Refusée - Modification en cours"),
	      42: this.gettextCatalog.getString("Refusée - Modification envoyée"),
	      43: this.gettextCatalog.getString("Demande soumise"),
	      50: this.gettextCatalog.getString("Abandonnée"),
	      60: this.gettextCatalog.getString("Abandonnée"),
	      70: this.gettextCatalog.getString("Transférée à notre correspondant"),
	      74: this.gettextCatalog.getString("Transférée à notre correspondant"),
	      80: this.gettextCatalog.getString("Annulée (doublon)"),
	      90: this.gettextCatalog.getString("Bloquée")
	    };
	
	    this.fetch();
	
	    this.confirmDelete = Modal.confirm.delete;
	
	    this.isMobile = screenSize.on("xs", function (match) {
	      that.isMobile = match;
	    });
	    this.activeUser = Auth.getCurrentUserSync();
	
	    ProductAPI.getModels().$promise.then(function (response) {
	      that.products = JSON.parse(JSON.stringify(response));
	      return;
	    }).catch(function () {
	      console.log("---> Error on load products type");
	    });
	
	    this.openDuplicate = function (_demand2) {
	      var data = null;
	      var modalInstance = $uibModal.open({
	        windowClass: "modal-primary",
	        animation: true,
	        ariaLabelledBy: "modal-title",
	        ariaDescribedBy: "modal-body",
	        component: "duplicate",
	        size: "lg",
	        resolve: {
	          products: function products() {
	            return that.products;
	          },
	          demand: function demand() {
	            return _demand2;
	          }
	        }
	      });
	
	      modalInstance.result.then(function (data) {
	        data.isOriginalCopy = true;
	        that.ProductAPI.save(data).$promise.then(function (duplicata) {
	          duplicata = JSON.parse(JSON.stringify(duplicata));
	          if (duplicata) {
	            that.$location.path("/permission").search({
	              directive: "product",
	              project: duplicata.projectId,
	              demand: duplicata.id
	            });
	            that.Modal.confirm.info(function () {})(that.gettextCatalog.getString("Copie réussie"), that.gettextCatalog.getString("Les auteurs et les œuvres ont bien été copiés dans la nouvelle demande") + ".", that.gettextCatalog.getString("Fermer"), "success");
	          }
	
	          return;
	        }).catch(function (err) {
	          var textError = "";
	          if (err.status === 403) {
	            textError = that.gettextCatalog.getString("Certains auteurs s\xE9lectionn\xE9s ne sont\n              pas g\xE9r\xE9s pour cette type d'utilisation");
	          } else {
	            textError = that.gettextCatalog.getString("Des probl\xE8mes sont survenus lors de la copie.\n              Veuillez recommencer, si le probl\xE8me persiste vous pouvez nous contacter directement.");
	          }
	          that.Modal.confirm.info(function () {})(that.gettextCatalog.getString("Erreur"), textError, "Fermer", "danger");
	          return;
	        });
	      }, function () {});
	    };
	
	    this.openShare = function (project) {
	      var data = null;
	      var modalInstance = $uibModal.open({
	        windowClass: "modal-primary",
	        animation: true,
	        ariaLabelledBy: "modal-title",
	        ariaDescribedBy: "modal-body",
	        component: "share",
	        size: "lg",
	        resolve: {
	          users: function users() {
	            return project.user;
	          },
	          createdBy: function createdBy() {
	            return project.createdBy;
	          }
	        }
	      });
	
	      modalInstance.result.then(function (result) {
	        that.ProjectAPI.manageUser({
	          op: result.op,
	          id: project.id,
	          email: result.email
	        }).$promise.then(function (_project) {
	          project.user = _project.user;
	          if (result.op == "add") {
	            that.Modal.confirm.info(function () {})(that.gettextCatalog.getString("Partage réussi"), that.gettextCatalog.getString("Votre projet a bien été partagé avec") + " \" " + result.email + " \".", "Fermer", "success");
	          } else if (result.op == "remove") {
	            that.Modal.confirm.info(function () {})(that.gettextCatalog.getString("Partage supprimé"), "\" " + result.email + " \" " + that.gettextCatalog.getString("n'a plus accès à ce projet."), "Fermer", "success");
	
	            if (result.email == that.activeUser.email) {
	              that.fetch();
	              return;
	            }
	          }
	        }).catch(function (err) {
	          that.Modal.confirm.info(function () {})(that.gettextCatalog.getString("Erreur"), that.gettextCatalog.getString("Des probl\xE8mes sont survenus lors du partage.\n          Veuillez v\xE9rifier l'adresse e-mail sp\xE9cifi\xE9.\n          Si le probl\xE8me persiste vous pouvez nous contacter directement."), "Fermer", "danger");
	        });
	      }, function () {});
	    };
	  }
	
	  _createClass(BoardComponent, [{
	    key: "fetch",
	    value: function fetch() {
	      var _this = this;
	
	      this.spinnerEnabled = true;
	      this.ProjectAPI.query().$promise.then(function (projects) {
	        projects = JSON.parse(JSON.stringify(projects));
	        for (var p in projects) {
	          projects[p].isRemovable = true;
	          for (var d in projects[p].demand) {
	            var status = projects[p].demand[d].status;
	            if ([11, 21, 31, 41].indexOf(status) != -1) {
	              projects[p].demand[d]._status = 0;
	            } else if ([12, 22, 32, 42].indexOf(status) != -1) {
	              projects[p].demand[d]._status = 1;
	            } else if (status == 20 || [13, 23, 33, 43].indexOf(status) != -1) {
	              projects[p].demand[d]._status = 2;
	            } else if (status == 30) {
	              projects[p].demand[d]._status = 3;
	            } else if (status == 40) {
	              projects[p].demand[d]._status = 4;
	            } else if (status == 50 || status == 60 || status == 70 || status == 74 || status == 80 || status == 90) {
	              projects[p].demand[d]._status = 5;
	            }
	            projects[p].demand[d].input = _underscore2.default.sortBy(projects[p].demand[d].input, "useNumber");
	            projects[p].demand[d].listArtist = [];
	            for (var u in projects[p].demand[d].input) {
	              if (projects[p].demand[d].input[u].artist && projects[p].demand[d].input[u].artist.label) {
	                projects[p].demand[d].listArtist.push(projects[p].demand[d].input[u].artist.label);
	              }
	            }
	            projects[p].demand[d].listArtist = projects[p].demand[d].listArtist.join(", ");
	
	            if ([11, 12].indexOf(projects[p].demand[d].status) == -1) {
	              projects[p].isRemovable = false;
	            }
	          }
	
	          projects[p].demand = _underscore2.default.sortBy(projects[p].demand, function (o) {
	            return -new Date(o.dateAmended).getTime();
	          });
	
	          projects[p].lastDateAmended = projects[p].dateCreated;
	          if (projects[p].demand.length > 0) {
	            projects[p].lastDateAmended = projects[p].demand[0].dateAmended;
	          }
	        }
	
	        projects = _underscore2.default.sortBy(projects, function (p) {
	          return -new Date(p.lastDateAmended).getTime();
	        });
	
	        _this.projects = projects;
	        _this.spinnerEnabled = false;
	      });
	    }
	  }, {
	    key: "deleteProject",
	    value: function deleteProject(id, pKey) {
	      var that = this;
	      var title = this.gettextCatalog.getString("Confirmation");
	      var text1 = this.gettextCatalog.getString("Supprimer le projet");
	      text1 = text1 + " \"" + this.projects[pKey].name + " \"";
	      var text2 = this.gettextCatalog.getString("et toutes les demandes d’autorisation qu’il contient");
	      var text = text1 + " " + text2 + " ?";
	      var confirmText = this.gettextCatalog.getString("Supprimer");
	      var cancelText = this.gettextCatalog.getString("Annuler");
	      this.confirmDelete(function (result) {
	        return that.ProjectAPI.delete({
	          id: id
	        }).$promise.then(function () {
	          that.fetch();
	          return;
	        }).catch(function () {});
	      })(title, text, confirmText, cancelText);
	    }
	  }, {
	    key: "deleteDemand",
	    value: function deleteDemand(id, project, key) {
	      var that = this;
	      var title = this.gettextCatalog.getString("Confirmation");
	      var text = "";
	      var confirmText = "";
	      if (project.demand[key].status == 11 || project.demand[key].status == 12) {
	        text = this.gettextCatalog.getString("Supprimer la demande d’autorisation n°");
	        confirmText = this.gettextCatalog.getString("Supprimer");
	      } else {
	        text = this.gettextCatalog.getString("Abandonner la demande d’autorisation n°");
	        confirmText = this.gettextCatalog.getString("Abandonner");
	      }
	
	      text = text + " " + project.demand[key].id + " ?";
	      var cancelText = this.gettextCatalog.getString("Annuler");
	      this.confirmDelete(function (result) {
	        return that.ProductAPI.delete({
	          id: id
	        }).$promise.then(function (_demand) {
	          if (project.demand[key]) {
	            if ([11, 12].indexOf(project.demand[key].status) != -1) {
	              project.demand.splice(key, 1);
	            } else if ([20, 21, 22, 30, 31, 32, 40, 41, 42].indexOf(project.demand[key].status) != -1) {
	              project.demand[key].status = 50;
	              project.demand[key]._status = 5;
	            }
	          }
	        });
	      })(title, text, confirmText, cancelText);
	    }
	  }, {
	    key: "listProprety",
	    value: function listProprety(_array, _prop) {
	      var list = _array.map(function (item) {
	        return item[_prop];
	      });
	      return list.join(", ");
	    }
	  }, {
	    key: "createProject",
	    value: function createProject() {
	      this.$location.path("/permission").search({
	        project: null,
	        directive: "introduction"
	      });
	    }
	  }, {
	    key: "openDemand",
	    value: function openDemand(project, demand) {
	      if (project) {
	        this.$location.path("/permission").search({
	          project: project.id,
	          directive: "product",
	          demand: demand ? demand.id : null
	        });
	      }
	    }
	  }, {
	    key: "openProject",
	    value: function openProject(project) {
	      if (project) {
	        this.$location.path("/permission").search({
	          project: project.id,
	          directive: "project"
	        });
	      }
	    }
	  }]);
	
	  return BoardComponent;
	}();
	
	exports.default = angular.module("dalApp.permission.board", []).component("board", {
	  template: __webpack_require__(134),
	  controller: BoardComponent,
	  controllerAs: "boardCtrl"
	}).name;

/***/ }),
/* 134 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"panel panel-default permission-panel\" style=\"margin-top: -50px\">\n  <div class=\"panel-body\">\n    <form class=\"\">\n      <div class=\"form-group\">\n        <button\n          type=\"button\"\n          id=\"btn-project\"\n          class=\"btn btn-lg btn-block\"\n          ng-click=\"boardCtrl.createProject()\"\n        >\n          <i class=\"glyphicon glyphicon-plus\"></i>\n          {{'Créer un nouveau projet'|translate}}\n        </button>\n      </div>\n    </form>\n    <p align=\"center\" ng-if=\"boardCtrl.spinnerEnabled\" class=\"waitting-spinner\">\n      <i class=\"fa fa-spinner fa-spin fa-5x fa-fw\"></i>\n    </p>\n    <uib-accordion close-others=\"true\">\n      <div ng-repeat=\"(pKey, project) in boardCtrl.projects\">\n        <div class=\"btn-group pull-right\" uib-dropdown is-open=\"project.menu\">\n          <button\n            type=\"button\"\n            class=\"btn btn-default btn-menu-project\"\n            uib-dropdown-toggle\n          >\n            <i class=\"fa fa-list\" aria-hidden=\"true\"></i>\n            <b>{{project.demand.length||'0'}}</b>\n          </button>\n          <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\">\n            <li role=\"menuitem\">\n              <a href=\"#\" ng-click=\"boardCtrl.openProject(project)\" translate\n                >Modifier</a\n              >\n            </li>\n            <li role=\"menuitem\">\n              <a href=\"#\" ng-click=\"boardCtrl.openShare(project)\" translate\n                >Partager</a\n              >\n            </li>\n            <li role=\"menuitem\" ng-if=\"project.isRemovable\">\n              <a\n                href=\"#\"\n                ng-click=\"boardCtrl.deleteProject(project.id, pKey)\"\n                translate\n                >Supprimer</a\n              >\n            </li>\n            <li\n              role=\"menuitem\"\n              ng-if=\"!project.isRemovable\"\n              disabled\n              class=\"demand-locked\"\n            >\n              <a href=\"#\" translate>(Verrouillé)</a>\n            </li>\n            <li class=\"divider\"></li>\n            <li role=\"menuitem\">\n              <a href=\"#\" ng-click=\"boardCtrl.openDemand(project)\" translate\n                >Nouvelle demande</a\n              >\n            </li>\n          </ul>\n        </div>\n\n        <div\n          uib-accordion-group\n          ng-class=\"['project-panel', 'panel-default', 'none-focus',\n        project.open?'project-panel-open':'']\"\n          is-open=\"project.open\"\n        >\n          <uib-accordion-heading>\n            <!--h3 class=\"panel-title pull-left\">{{project.title}}</h3>\n            <button class=\"btn btn-default pull-right\"><i class=\"glyphicon pull-right\"\n              ng-class=\"{'glyphicon-chevron-down': project.open,\n              'glyphicon-chevron-right': !project.open}\"></i></button>\n            <div class=\"clearfix project-heading\"></div-->\n            <div>\n              <h4 class=\"project-title project-header-text\">\n                {{project.name}}\n              </h4>\n              <p class=\"project-description project-header-text\">\n                {{project.description}}\n              </p>\n              <!--span class=\"badge\"> {{project.demand.length||'0'}} </span-->\n            </div>\n            <div class=\"clearfix\"></div>\n          </uib-accordion-heading>\n\n          <div class=\"row\">\n            <!--div class=\"btn-group project-menu\" uib-dropdown is-open=\"project.menu\">\n              <button type=\"button\" class=\"btn btn-default\" uib-dropdown-toggle >\n                <i class=\"fa fa-list\" aria-hidden=\"true\"></i>\n              </button>\n              <ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu role=\"menu\" >\n                <li role=\"menuitem\"><a href=\"#\" ng-click=\"boardCtrl.openProject(project)\" translate>Modifier</a></li>\n                <li role=\"menuitem\"><a href=\"#\" ng-click=\"boardCtrl.deleteProject(project.id)\" translate>Supprimer</a></li>\n                <li class=\"divider\"></li>\n                <li role=\"menuitem\"><a href=\"#\" ng-click=\"boardCtrl.openDemand(project)\" translate>Nouvelle demande</a></li>\n              </ul>\n            </div-->\n\n            <div\n              class=\"col-callout col-xs-12\"\n              ng-repeat=\"(key, demand) in project.demand\"\n            >\n              <div\n                class=\"btn-group pull-right\"\n                uib-dropdown\n                ng-if=\"demand.status!=50 && demand.status!=60\"\n              >\n                <button\n                  type=\"button\"\n                  uib-dropdown-toggle\n                  ng-class=\"['btn','btn-sm', 'btn-demand-right',\n                demand._status==0?'btn-default':'',\n                demand._status==1?'btn-primary':'',\n                demand._status==2?'btn-warning':'',\n                demand._status==3?'btn-success':'',\n                (demand._status==4||demand._status==5)?'btn-danger':'']\"\n                >\n                  <i class=\"fa fa-bars\" aria-hidden=\"true\"></i>\n                </button>\n                <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\">\n                  <li role=\"menuitem\">\n                    <a\n                      href=\"#\"\n                      ng-click=\"boardCtrl.openDemand(project,demand)\"\n                      translate\n                      >Ouvrir</a\n                    >\n                  </li>\n                  <li role=\"menuitem\" ng-if=\"demand.listArtist\">\n                    <a\n                      href=\"#\"\n                      ng-click=\"boardCtrl.openDuplicate(demand)\"\n                      translate\n                      >Copier les auteurs et les œuvres dans une nouvelle\n                      demande</a\n                    >\n                  </li>\n                  <li class=\"divider\"></li>\n                  <li\n                    role=\"menuitem\"\n                    ng-if=\"demand.status==11 || demand.status==12\"\n                  >\n                    <a\n                      href=\"#\"\n                      ng-click=\"boardCtrl.deleteDemand(demand.id, project, key)\"\n                      translate\n                      >Supprimer</a\n                    >\n                  </li>\n                  <li\n                    role=\"menuitem\"\n                    ng-if=\"demand.status==13 ||demand.status==23 ||demand.status==33 ||demand.status==43\"\n                    disabled\n                    class=\"demand-locked\"\n                  >\n                    <a href=\"#\" translate>(Verrouillée)</a>\n                  </li>\n                  <li\n                    role=\"menuitem\"\n                    ng-if=\"demand.status==20 ||demand.status==21 ||demand.status==22\n                  ||demand.status==30 ||demand.status==31 ||demand.status==32\n                  ||demand.status==40 ||demand.status==41 ||demand.status==42\"\n                  >\n                    <a\n                      href=\"#\"\n                      ng-click=\"boardCtrl.deleteDemand(demand.id, project, key)\"\n                      translate\n                      >Abandonner</a\n                    >\n                  </li>\n                </ul>\n              </div>\n\n              <div\n                ng-class=\"['bs-callout', 'bs-demand',\n              demand._status==0?'bs-callout-default':'',\n              demand._status==1?'bs-callout-primary':'',\n              demand._status==2?'bs-callout-warning':'',\n              demand._status==3?'bs-callout-success':'',\n              (demand._status==4||demand._status==5)?'bs-callout-danger':'',\n\n              demand._status==0?'text-default':'',\n              demand._status==1?'text-info':'',\n              demand._status==2?'text-warning':'',\n              demand._status==3?'text-success':'',\n              (demand._status==4||demand._status==5)?'text-danger':'']\"\n                ng-click=\"boardCtrl.openDemand(project,demand)\"\n              >\n                <div ng-class=\"[]\">\n                  <div class=\"pull-right\" style=\"padding-right: 5px\">\n                    <b>\n                      [ {{ boardCtrl.statusList[demand.status] }}\n                      <i\n                        ng-class=\"['fa',\n                      demand._status==0?'fa-edit':'',\n                      demand._status==1?'fa-paper-plane':'',\n                      demand._status==2?'fa-cogs':'',\n                      demand._status==3?'fa-handshake-o':'',\n                      demand._status==4?'fa-ban':'',\n                      demand._status==5?'fa-exclamation-triangle':''\n                      ]\"\n                      ></i>\n                      ]\n                    </b>\n                  </div>\n                  <h4 class=\"pull-left\">\n                    N°{{demand.id}} - {{demand.product.nameFr}}\n                  </h4>\n                  <div class=\"clearfix\"></div>\n                </div>\n                <p class=\"list-artist\">\n                  <b translate>Auteur(s)</b> :\n                  <i ng-if=\"demand.listArtist\">\n                    {{demand.subListArtist?demand.subListArtist:demand.listArtist}}\n                  </i>\n                </p>\n                <p\n                  ng-if=\"demand.firstnameAdagp && demand.lastnameAdagp && demand.status>=20\"\n                >\n                  <b translate>Suivi par</b> :\n                  <i\n                    >{{(demand.firstnameAdagp||'')+'\n                    '+(demand.lastnameAdagp||'')+'\n                    ('+(demand.emailAdagp||'')+')'}}</i\n                  >\n                </p>\n                <div class=\"clearfix\"></div>\n              </div>\n            </div>\n\n            <div class=\"text-center col-xs-12\">\n              <button\n                type=\"button\"\n                class=\"btn btn-lg btn-block btn-new-demand\"\n                ng-click=\"boardCtrl.openDemand(project)\"\n                translate\n              >\n                Faire une nouvelle demande\n              </button>\n            </div>\n\n            <!--div class=\"col-callout  col-sm-6 col-md-4\">\n              <div class=\"bs-callout bs-callout-primary bs-callout-new\">\n                <h4 >Nouvelle demande</h4>\n                <button type=\"button\" class=\"btn btn-primary\" ng-click=\"boardCtrl.openDemand(project)\">\n                  Faire une nouvelle demande\n                </button>\n              </div>\n            </div-->\n          </div>\n        </div>\n      </div>\n    </uib-accordion>\n  </div>\n</div>\n"

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var IntroductionController = exports.IntroductionController = ['arrow', 'LanguageService', function IntroductionController(arrow, LanguageService) {
	  "ngInject";
	
	  _classCallCheck(this, IntroductionController);
	
	  this.arrow = arrow;
	  this.ls = LanguageService;
	}];
	
	exports.default = angular.module("dalApp.permission.introduction", []).component("introduction", {
	  template: __webpack_require__(136),
	  controller: IntroductionController
	}).name;

/***/ }),
/* 136 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"panel panel-default permission-panel\">\n  <div class=\"panel-body\">\n    <div class=\"notices\" ng-if=\"$ctrl.ls.lang == 'fr' \">\n      <!--p>Chère Madame, Cher Monsieur,</p-->\n\n      <p>\n        Nous vous remercions d’avoir choisi le formulaire en ligne de l’ADAGP\n        pour effectuer votre demande d’autorisation.\n      </p>\n\n      <!--p>Avant de poursuivre votre demande, il convient de prendre en compte les informations suivantes :</p-->\n      <p>\n        Avant de poursuivre, veuillez prendre en compte les informations\n        suivantes :\n      </p>\n\n      <ul class=\"list-intro-1\">\n        <li>\n          <p>\n            Afin de\n            <b>vérifier au préalable que l’ADAGP gère bien les droits</b> de\n            l’auteur dont vous souhaitez reproduire l’œuvre, nous vous invitons\n            à indiquer son nom dans\n            <a href=\"https://demande.adagp.fr/author\" target=\"_blank\"\n              >le formulaire de recherche de nos auteurs</a\n            >.\n          </p>\n        </li>\n        <li>\n          <p>\n            Une fois complétée, votre demande sera traitée dans les meilleurs\n            délais par nos services. Nous vous rappelons que vous devrez\n            <b\n              >attendre la réception de notre autorisation préalable et\n              écrite</b\n            >\n            dans laquelle seront rappelées les conditions de notre accord\n            <b\n              >avant de procéder à toute utilisation d’une œuvre de notre\n              répertoire</b\n            >.\n          </p>\n        </li>\n        <li>\n          <p>\n            Votre demande ne pourra être\n            <b\n              >traitée qu’à réception de l’ensemble des informations demandées\n              dans le formulaire</b\n            >. S’agissant des utilisations nécessitant l’envoi d’une maquette\n            définitive (couvertures, monographies, etc.), toute modification de\n            la maquette au cours du traitement de la demande fera l'objet d'un\n            nouvel examen par les titulaires de droits, entraînant dès lors de\n            nouveaux délais de traitement.\n          </p>\n        </li>\n        <li>\n          <p>\n            Dans l’attente de notre réponse, vous pourrez\n            <b>dès à présent prendre connaissance</b> :\n          </p>\n          <ul class=\"list-intro-2\">\n            <li>\n              <p>\n                des <b>copyrights applicables</b> à chacun des auteurs\n                représentés par l’ADAGP et qui devront figurer dans les légendes\n                complètes des œuvres. Les copyrights à indiquer seront\n                mentionnés dans le récapitulatif que vous recevrez par email à\n                l’issue de votre demande.\n              </p>\n            </li>\n            <li>\n              <p>\n                des\n                <a\n                  href=\"http://www.adagp.fr/fr/jutilise-ou-vends-une-oeuvre/ma-boite-outils/tarifs\"\n                  target=\"_blank\"\n                  >principes directeurs de l’ADAGP et des tarifs applicables </a\n                >.\n              </p>\n            </li>\n            <!-- <li>\n              <p>\n                du site\n                <a\n                  href=\"http://www.adagp.fr/fr/banque-images#/\"\n                  target=\"_blank\"\n                >\n                  <b>ADAGP Images</b>\n                </a>\n                ou interroger directement notre iconographe commerciale (tél.\n                +33(0) 1 73 79 78 92 /\n                <a href=\"mailto:adagp.images@adagp.fr\">\n                  adagp.images@adagp.fr\n                </a>\n                ) si vous souhaitez également acquérir les fichiers en haute\n                définition des œuvres pour lesquelles vous sollicitez une\n                autorisation. <br />\n                Attention ! L’achat d’un document photographique auprès d’une\n                banque d’images (ADAGP Images ou d’une autre) ne vous dispense\n                pas de formuler une demande d'autorisation auprès de ADAGP.\n                Votre achat concernera en effet uniquement les droits\n                photographiques.\n              </p>\n            </li> -->\n          </ul>\n        </li>\n      </ul>\n    </div>\n\n    <div class=\"notices\" ng-if=\"$ctrl.ls.lang != 'fr' \">\n      <!--p>Chère Madame, Cher Monsieur,</p-->\n\n      <p>Thank you for choosing the ADAGP online permission request form.</p>\n\n      <!--p>Avant de poursuivre votre demande, il convient de prendre en compte les informations suivantes :</p-->\n      <p>Before proceeding, please consider the following information:</p>\n\n      <ul class=\"list-intro-1\">\n        <li>\n          <p>\n            In order\n            <b\n              >to check beforehand that ADAGP does manage the rights of the\n              artist</b\n            >\n            whose work you wish to reproduce, please enter his/her name in\n            <a href=\"https://demande.adagp.fr/author\" target=\"_blank\"\n              >our authors’ search form</a\n            >.\n          </p>\n        </li>\n        <li>\n          <p>\n            Once submitted, your request will be processed as soon as possible\n            by our services. Please note that you need to\n            <b>wait to receive our permission in writing</b>, laying down the\n            terms and conditions of our agreement,\n            <b>before using any work in our repertory</b>.\n          </p>\n        </li>\n        <li>\n          <p>\n            We can process your request only\n            <b>once we receive all the information required in the form</b>. For\n            uses requiring submission of the final layout (covers, monographs,\n            etc.), any change made to the layout while we process your request\n            will need to be reviewed again by the rights holders, which will\n            extend the processing time\n          </p>\n        </li>\n        <li>\n          <p>\n            While awaiting our answer you can, from now on, <b>take note of</b>:\n          </p>\n          <ul class=\"list-intro-2\">\n            <li>\n              <p>\n                <b>the copyright by-lines</b> for each of the artists\n                represented by ADAGP, to be included in the works captions. The\n                copyright by-lines will be mentioned in the acknowledgement\n                receipt you will receive by e-mail after sending your request.\n              </p>\n            </li>\n            <li>\n              <p>\n                <a\n                  href=\"https://www.adagp.fr/sites/default/files/bareme_adagp.pdf\"\n                  target=\"_blank\"\n                >\n                  ADAGP Guiding Principles and Scale of Fees</a\n                >.\n              </p>\n            </li>\n            <li>\n              <p>\n                the\n                <a\n                  href=\"http://www.adagp.fr/fr/banque-images#/\"\n                  target=\"_blank\"\n                >\n                  <b>ADAGP Image Bank</b></a\n                >; you can email our picture researcher (tel. +33(0) 1 73 79 78\n                92 /\n                <a href=\"mailto:adagp.images@adagp.fr\">adagp.images@adagp.fr</a>\n                ) if you would also like to buy HD files of the works concerned\n                by your permission request.<br />\n                NB: Purchasing a photographic document from an image bank (ADAGP\n                Images or other) does not exempt you from requesting\n                reproduction permission from ADAGP, as such purchase covers only\n                photographic rights.\n              </p>\n            </li>\n          </ul>\n        </li>\n      </ul>\n    </div>\n\n    <nav aria-label=\"Pagination\">\n      {{directives}}\n      <ul class=\"pager\">\n        <li class=\"next\">\n          <a href=\"#\" ng-click=\"$ctrl.arrow.goto(1)\">\n            {{\"Suivant\"|translate}}\n            <i class=\"fa fa-arrow-right\" aria-hidden=\"true\"></i>\n          </a>\n        </li>\n      </ul>\n    </nav>\n  </div>\n</div>\n"

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var ProjectController = exports.ProjectController = function () {
	  ProjectController.$inject = ['arrow', 'ProjectAPI', '$location', 'screenSize'];
	  function ProjectController(arrow, ProjectAPI, $location, screenSize) {
	    "ngInject";
	
	    _classCallCheck(this, ProjectController);
	
	    this.project = {
	      name: "",
	      description: ""
	    };
	    this.errors = {
	      login: undefined
	    };
	    this.submitted = false;
	    var that = this;
	    this.arrow = arrow;
	
	    this.ProjectAPI = ProjectAPI;
	    var s = $location.search();
	    if (s.project && parseInt(s.project)) {
	      ProjectAPI.get({ id: parseInt(s.project) }).$promise.then(function (project) {
	        if (!project) {
	          return $location.path("/permission").search({});
	        }
	        that.project = JSON.parse(JSON.stringify(project));
	        return;
	      });
	    }
	
	    this.isMobile = screenSize.on("xs", function (match) {
	      that.isMobile = match;
	    });
	  }
	
	  _createClass(ProjectController, [{
	    key: "saveProject",
	    value: function saveProject(pageId) {
	      var that = this;
	      this.submitted = true;
	      if (this.form_project.$valid) {
	        if (this.project.id) {
	          return this.ProjectAPI.change({
	            id: this.project.id,
	            name: this.project.name,
	            description: this.project.description
	          }).$promise.then(function (result) {
	            pageId = pageId >= 0 ? pageId : 2;
	            that.arrow.goto(pageId, result.id);
	            return null;
	          }).catch(function (err) {
	            return null;
	          });
	        } else {
	            return this.ProjectAPI.save({
	              name: this.project.name,
	              description: this.project.description
	            }).$promise.then(function (result) {
	              pageId = pageId >= 0 ? pageId : 2;
	              that.arrow.goto(pageId, result.id);
	              return null;
	            }).catch(function (err) {
	              return null;
	            });
	          }
	      }
	    }
	  }, {
	    key: "prev",
	    value: function prev() {
	      if (this.form_project.$valid) {
	        this.saveProject(0);
	      } else {
	        this.arrow.goto(0);
	      }
	    }
	  }, {
	    key: "next",
	    value: function next() {
	      this.saveProject();
	    }
	  }]);
	
	  return ProjectController;
	}();
	
	exports.default = angular.module("dalApp.permission.project", []).component("project", {
	  template: __webpack_require__(138),
	  controller: ProjectController
	}).name;

/***/ }),
/* 138 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"panel panel-default permission-panel\">\n  <!--div class=\"panel-heading\"><b translate>PROJECT</b></div-->\n  <div class=\"panel-body\">\n    <form class=\"form-horizontal\" name=\"$ctrl.form_project\" novalidate>\n      <div\n        class=\"form-group\"\n        ng-class=\"{ 'has-error': $ctrl.form_project.project_name.$invalid && $ctrl.submitted }\"\n      >\n        <label class=\"control-label col-sm-3\" for=\"project_name\"\n          >* {{'Nom du projet'|translate}} :</label\n        >\n        <div class=\"col-sm-8\">\n          <input\n            type=\"text\"\n            class=\"form-control\"\n            name=\"project_name\"\n            ng-model=\"$ctrl.project.name\"\n            required\n            maxlength=\"250\"\n          />\n          <p class=\"help-block\">\n            <i class=\"fa fa-info-circle\" aria-hidden=\"true\"></i>\n            {{'Veuillez saisir le nom du projet'|translate}}.\n          </p>\n        </div>\n      </div>\n      <div\n        class=\"form-group\"\n        ng-class=\"{ 'has-error': $ctrl.form_project.description.$invalid && $ctrl.submitted }\"\n      >\n        <label class=\"control-label col-sm-3\" for=\"description\"\n          >* {{'Description / Commentaires'|translate}} :</label\n        >\n        <div class=\"col-sm-8\">\n          <textarea\n            class=\"form-control\"\n            rows=\"5\"\n            name=\"description\"\n            ng-model=\"$ctrl.project.description\"\n            required\n            maxlength=\"250\"\n          ></textarea>\n          <p class=\"help-block\">\n            <i class=\"fa fa-info-circle\" aria-hidden=\"true\"></i>\n            {{'Merci de décrire brièvement le projet'|translate}}.\n          </p>\n        </div>\n      </div>\n    </form>\n\n    <!--*****************PAGINATION*****************-->\n    <nav aria-label=\"Pagination\">\n      <ul class=\"pager\">\n        <li class=\"previous\">\n          <a href=\"#\" ng-click=\"$ctrl.prev()\">\n            <i class=\"fa fa-arrow-left\" aria-hidden=\"true\"></i>\n            <span ng-if=\"!$ctrl.isMobile\">\n              {{\"Précédent\"|translate}}\n              <i\n                class=\"fa fa-floppy-o\"\n                aria-hidden=\"true\"\n                style=\"margin-left: 7px\"\n              ></i>\n            </span>\n          </a>\n        </li>\n        <li class=\"next\">\n          <a id=\"dal-next\" href=\"#\" ng-click=\"$ctrl.next()\">\n            <span ng-if=\"!$ctrl.isMobile\">\n              <i\n                class=\"fa fa-floppy-o\"\n                aria-hidden=\"true\"\n                style=\"margin-right: 7px\"\n              ></i>\n              {{\"Suivant\"|translate}}\n            </span>\n            <i class=\"fa fa-arrow-right\" aria-hidden=\"true\"></i>\n          </a>\n        </li>\n      </ul>\n    </nav>\n  </div>\n</div>\n"

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProductController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _underscore = __webpack_require__(64);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var ProductController = exports.ProductController = function () {
	  ProductController.$inject = ['arrow', 'ElasticAPI', 'ProductAPI', 'Condition', 'ProjectAPI', 'LanguageService', '$location', '$sce', 'screenSize', 'Modal', 'gettextCatalog', 'appConfig', '$scope'];
	  function ProductController(arrow, ElasticAPI, ProductAPI, Condition, ProjectAPI, LanguageService, $location, $sce, screenSize, Modal, gettextCatalog, appConfig, $scope) {
	    "ngInject";
	
	    _classCallCheck(this, ProductController);
	
	    var that = this;
	
	    var ovhBase = "https://storage.sbg.cloud.ovh.net/v1/AUTH_bcdf554d7a774b40975e6151a6bd1b8a/dal_";
	    this.ovhBaseURI = ovhBase + appConfig.env + "/";
	
	    this.spinnerEnabled = true;
	    this.ls = LanguageService;
	    this.arrow = arrow;
	    this.cart = [];
	    this.count = 0;
	    this.ElasticAPI = ElasticAPI;
	    this.ProductAPI = ProductAPI;
	    this.s = $location.search();
	    this.trustAsHtml = $sce.trustAsHtml;
	    this.getBoolean = Condition.getBoolean;
	    this.disabledInput = false;
	    this.blockedInput = false;
	    this.popupDate = {};
	    this.isSaved = true;
	    this.Modal = Modal;
	    this.gettextCatalog = gettextCatalog;
	    this.maxUsesNb = 10;
	    this.lastScroll = +new Date();
	    this.$scope = $scope;
	
	    this.isMobile = screenSize.on("xs", function (match) {
	      that.isMobile = match;
	    });
	
	    this.inputs = {
	      generals: {},
	      uses: [{}]
	    };
	
	    if (this.s.project && parseInt(this.s.project)) {
	      ProjectAPI.get({
	        id: parseInt(that.s.project)
	      }).$promise.then(function (project) {
	        if (!project) {
	          $location.path("/permission").search({});
	        }
	        that.project = JSON.parse(JSON.stringify(project));
	        return null;
	      }).catch(function () {
	        console.log("---> Can't get project");
	        return null;
	      });
	    } else {
	      arrow.goto(1);
	    }
	    ProductAPI.getModels().$promise.then(function (response) {
	      response = JSON.parse(JSON.stringify(response));
	      if (response.length > 0) {
	        that.products = response;
	        if (that.s.demand && parseInt(that.s.demand)) {
	          ProductAPI.get({
	            id: parseInt(that.s.demand)
	          }).$promise.then(function (demand) {
	            if (!demand || demand && demand.project.id != that.s.project) {
	              $location.path("/permission").search({});
	              return null;
	            }
	            if (demand) {
	              that.demand = JSON.parse(JSON.stringify(demand));
	              that.loadDemand(demand);
	              if (that.demand.isOriginalCopy) {
	                that.loadDefaultInputs();
	              }
	            }
	            that.spinnerEnabled = false;
	            return;
	          }).catch(function () {
	            console.log("---> Can't get demand");
	            return null;
	          });
	        } else {
	          that.spinnerEnabled = false;
	        }
	      }
	      return;
	    }).catch(function () {
	      console.log("---> Error on load products type");
	    });
	
	    this.multiSelectFr = {
	      selectAll: "Tous",
	      selectNone: "Aucun",
	      reset: "Réinitialiser",
	      search: "Recherche...",
	      nothingSelected: "Aucune séléction" };
	    this.multiSelectEn = {
	      selectAll: "Select all",
	      selectNone: "Select none",
	      reset: "Reset",
	      search: "Search...",
	      nothingSelected: "None selected" };
	
	    window.onscroll = function () {
	      that.scrollHandler();
	    };
	
	    setInterval(function () {
	      if (that.inputs && that.inputs.uses && that.inputs.uses.length > that.maxUsesNb) {
	        var last = +new Date();
	        if (last - that.lastScroll > 500) {
	          that.lastScroll = last;
	          that.maxUsesNb += 1;
	          that.$scope.$apply();
	        }
	      }
	    }, 1000);
	  }
	
	  _createClass(ProductController, [{
	    key: "scrollHandler",
	    value: function scrollHandler() {
	      if (this.inputs && this.inputs.uses && this.inputs.uses.length > this.maxUsesNb) {
	        var top = document.documentElement.scrollHeight - document.documentElement.scrollTop;
	        var height = document.documentElement.clientHeight;
	        if (top - height <= 200) {
	          var last = +new Date();
	          if (last - this.lastScroll > 500) {
	            this.lastScroll = last;
	            this.maxUsesNb += 1;
	          }
	        }
	        this.$scope.$apply();
	      }
	    }
	  }, {
	    key: "productChanged",
	    value: function productChanged(oldProduct) {
	      var oldUses = this.inputs.uses;
	      this.resetInputs();
	      this.maxUsesNb = 10;
	      if (this.demand && this.selectedProduct.id === this.demand.productId) {
	        this.loadDemand(this.demand);
	      } else if (oldProduct && this.inputs.uses.length > 0) {
	        var authorInputNew = _underscore2.default.findWhere(this.selectedProduct.inputModel, {
	          sigedavMatchType: 50
	        });
	        var titleInputNew = _underscore2.default.findWhere(this.selectedProduct.inputModel, {
	          sigedavMatchType: 51
	        });
	
	        var authorInputOld = _underscore2.default.findWhere(oldProduct.inputModel, {
	          sigedavMatchType: 50
	        });
	        var titleInputOld = _underscore2.default.findWhere(oldProduct.inputModel, {
	          sigedavMatchType: 51
	        });
	
	        if (authorInputNew && titleInputNew && authorInputOld && titleInputOld) {
	          this.inputs.uses = [];
	          for (var o in oldUses) {
	            var author = oldUses[o]["input_" + authorInputOld.id];
	            var title = oldUses[o]["input_" + titleInputOld.id];
	
	            if (author && author.author && author.author.detail) {
	              author.author.isManaged = _underscore2.default.pluck(author.author.detail.rights, "right_id").indexOf(this.selectedProduct.rightId) != -1;
	            }
	
	            if (author && author.value && author.author.isManaged || title && title.value) {
	              this.addInUses();
	              if (author && author.value && author.author.isManaged) {
	                this.inputs.uses[o]["input_" + authorInputNew.id].value = author.value;
	                this.inputs.uses[o]["input_" + authorInputNew.id].author = author.author;
	              }
	              if (title && title.value) {
	                this.inputs.uses[o]["input_" + titleInputNew.id].value = title.value;
	              }
	            }
	          }
	          if (this.inputs.uses.length == 0) {
	            this.addInUses();
	          }
	        }
	      }
	      this.loadDefaultInputs();
	    }
	  }, {
	    key: "resetInputs",
	    value: function resetInputs() {
	      this.disabledInput = false;
	      this.blockedInput = false;
	      this.inputs = {
	        generals: {},
	        uses: [{}]
	      };
	      for (var iname in this.selectedProduct.listedModels) {
	        if (this.selectedProduct.listedModels[iname].isGeneral) {
	          this.inputs.generals[iname] = {
	            value: null,
	            required: false,
	            showed: false,
	            inputModelId: this.selectedProduct.listedModels[iname].id,
	            parentModelId: this.selectedProduct.listedModels[iname].inputModelId,
	            templateGroupId: this.selectedProduct.listedModels[iname].templateGroupId,
	            type: this.selectedProduct.listedModels[iname].type
	          };
	        } else {
	          this.inputs.uses[0][iname] = {
	            value: null,
	            required: false,
	            showed: false,
	            inputModelId: this.selectedProduct.listedModels[iname].id,
	            parentModelId: this.selectedProduct.listedModels[iname].inputModelId,
	            templateGroupId: this.selectedProduct.listedModels[iname].templateGroupId,
	            type: this.selectedProduct.listedModels[iname].type
	          };
	        }
	      }
	      this.changed();
	    }
	  }, {
	    key: "parseValue",
	    value: function parseValue(value, type) {
	      if (value) {
	        if (type === "date") {
	          return new Date(value);
	        }
	        if (type === "integer") {
	          return Number(value);
	        }
	        if (type === "decimal") {
	          return Number(value);
	        }
	      }
	      return value;
	    }
	  }, {
	    key: "updateSelectAfterFetch",
	    value: function updateSelectAfterFetch(iname, data, models) {
	      for (var m in models) {
	        if (data[models[m].iname].value) {
	          data[iname].value = models[m].iname;
	          break;
	        }
	      }
	    }
	  }, {
	    key: "updateSelectAfterChange",
	    value: function updateSelectAfterChange(iname, data, models) {
	      for (var m in models) {
	        if (data[models[m].iname]) {
	          data[models[m].iname].value = false;
	        } else {
	          data[models[m].iname] = {
	            value: false
	          };
	        }
	      }
	
	      if (data[iname].value && data[iname].value.length > 0) {
	        data[data[iname].value].value = true;
	      }
	    }
	  }, {
	    key: "updateCheckboxAfterChangeOrFetch",
	    value: function updateCheckboxAfterChangeOrFetch(iname, data, models) {
	      data[iname].value = "";
	      for (var m in models) {
	        if (data[models[m].iname] && data[models[m].iname].value) {
	          data[iname].value = data[iname].value + " " + models[m].iname;
	        }
	      }
	    }
	  }, {
	    key: "getSortedIname",
	    value: function getSortedIname(array) {
	      var keys = [];
	      for (var a in array) {
	        keys.push({
	          iname: a,
	          rank: array[a].rank
	        });
	      }
	      keys = keys.sort(function (a, b) {
	        return a.rank - b.rank;
	      });
	      return keys;
	    }
	  }, {
	    key: "changed",
	    value: function changed(iname, useKey) {
	      this.isSaved = false;
	
	      var listedModels = this.selectedProduct.listedModels;
	
	      var keysG = this.getSortedIname(this.inputs.generals);
	      for (var k in keysG) {
	        var iname1 = keysG[k].iname;
	        if (listedModels[iname1].subInputModel && listedModels[iname1].subInputModel.length > 0) {
	          if (listedModels[iname1].type == "selectList") {
	            this.updateSelectAfterChange(iname1, this.inputs.generals, listedModels[iname1].subInputModel);
	          } else if (listedModels[iname1].type == "checkboxList") {
	            this.updateCheckboxAfterChangeOrFetch(iname1, this.inputs.generals, listedModels[iname1].subInputModel);
	          }
	        }
	      }
	
	      for (var u1 in this.inputs.uses) {
	        var keysU = this.getSortedIname(this.inputs.uses[u1]);
	        for (var k2 in keysU) {
	          var iname2 = keysU[k2].iname;
	          if (listedModels[iname2].subInputModel && listedModels[iname2].subInputModel.length > 0) {
	            if (listedModels[iname2].type == "selectList") {
	              this.updateSelectAfterChange(iname2, this.inputs.uses[u1], listedModels[iname2].subInputModel);
	            } else if (listedModels[iname2].type == "checkboxList") {
	              this.updateCheckboxAfterChangeOrFetch(iname2, this.inputs.uses[u1], listedModels[iname2].subInputModel);
	            }
	          }
	        }
	      }
	
	      for (var _k in keysG) {
	        var iname3 = keysG[_k].iname;
	        var syntShow = listedModels[iname3].showOn;
	        var syntRequired = listedModels[iname3].requiredOn;
	        this.inputs.generals[iname3].showed = this.getBoolean(syntShow, this.inputs.generals, this.inputs.uses);
	        this.inputs.generals[iname3].required = this.getBoolean(syntRequired, this.inputs.generals, this.inputs.uses);
	      }
	      for (var u in this.inputs.uses) {
	        var _keysU = this.getSortedIname(this.inputs.uses[u]);
	        for (var k4 in _keysU) {
	          var iname4 = _keysU[k4].iname;
	          var _syntShow = listedModels[iname4].showOn;
	          var _syntRequired = listedModels[iname4].requiredOn;
	          this.inputs.uses[u][iname4].showed = this.getBoolean(_syntShow, this.inputs.generals, this.inputs.uses, this.inputs.uses[u]);
	          this.inputs.uses[u][iname4].required = this.getBoolean(_syntRequired, this.inputs.generals, this.inputs.uses, this.inputs.uses[u]);
	        }
	      }
	
	      this.hideUse = true;
	      for (var s in this.inputs.uses) {
	        for (var inp in this.selectedProduct.uses) {
	          var inputM = this.selectedProduct.uses[inp];
	          if (this.inputs.uses[s][inputM.iname].showed) {
	            this.hideUse = false;
	            break;
	          }
	        }
	      }
	    }
	  }, {
	    key: "setHour12",
	    value: function setHour12(iname, useKey) {
	      if (useKey && this.inputs.uses[useKey][iname].value) {
	        var date = new Date(this.inputs.uses[useKey][iname].value);
	        date.setHours(12);
	        this.inputs.uses[useKey][iname].value = date;
	      } else if (!useKey && this.inputs.generals[iname].value) {
	        var _date = new Date(this.inputs.generals[iname].value);
	        _date.setHours(12);
	        this.inputs.generals[iname].value = _date;
	      }
	    }
	  }, {
	    key: "onStartUpload",
	    value: function onStartUpload(files, iname, useKey) {
	      this.onUpload = this.onUpload || {};
	      this.onErrorUpload = this.onErrorUpload || {};
	      if (Number.isInteger(useKey)) {
	        this.onUpload[iname + "_" + useKey] = true;
	        this.onErrorUpload[iname + "_" + useKey] = false;
	      } else {
	        this.onUpload[iname] = true;
	        this.onErrorUpload[iname] = false;
	      }
	      return null;
	    }
	  }, {
	    key: "onSuccessUpload",
	    value: function onSuccessUpload(response, iname, useKey) {
	      if (Number.isInteger(useKey)) {
	        this.inputs.uses[useKey][iname].objFiles = this.inputs.uses[useKey][iname].objFiles && this.inputs.uses[useKey][iname].objFiles.length > 0 ? this.inputs.uses[useKey][iname].objFiles : [];
	        this.inputs.uses[useKey][iname].objFiles.push({
	          url: response.data.url,
	          originalname: response.data.originalname
	        });
	        this.inputs.uses[useKey][iname].value = JSON.stringify(this.inputs.uses[useKey][iname].objFiles);
	        this.inputs.uses[useKey][iname].originalnames = _underscore2.default.pluck(this.inputs.uses[useKey][iname].objFiles, "originalname");
	      } else {
	        this.inputs.generals[iname].objFiles = this.inputs.generals[iname].objFiles && this.inputs.generals[iname].objFiles.length > 0 ? this.inputs.generals[iname].objFiles : [];
	        this.inputs.generals[iname].objFiles.push({
	          url: response.data.url,
	          originalname: response.data.originalname
	        });
	        this.inputs.generals[iname].value = JSON.stringify(this.inputs.generals[iname].objFiles);
	        this.inputs.generals[iname].originalnames = _underscore2.default.pluck(this.inputs.generals[iname].objFiles, "originalname");
	      }
	      if (Number.isInteger(useKey)) {
	        this.onUpload[iname + "_" + useKey] = false;
	        this.onErrorUpload[iname + "_" + useKey] = false;
	      } else {
	        this.onUpload[iname] = false;
	        this.onErrorUpload[iname] = false;
	      }
	      this.changed(iname, useKey);
	      return null;
	    }
	  }, {
	    key: "onErrorUpload",
	    value: function onErrorUpload(response, iname, useKey) {
	      if (Number.isInteger(useKey)) {
	        this.onUpload[iname + "_" + useKey] = false;
	        this.onErrorUpload[iname + "_" + useKey] = true;
	      } else {
	        this.onUpload[iname] = false;
	        this.onErrorUpload[iname] = true;
	      }
	      return null;
	    }
	  }, {
	    key: "onCompleteUpload",
	    value: function onCompleteUpload(response, iname, useKey) {
	      if (Number.isInteger(useKey)) {
	        this.onUpload[iname + "_" + useKey] = false;
	      } else {
	        this.onUpload[iname] = false;
	      }
	      return null;
	    }
	  }, {
	    key: "removeFile",
	    value: function removeFile(rank, iname, useKey) {
	      if (Number.isInteger(useKey)) {
	        this.inputs.uses[useKey][iname].objFiles.splice(rank, 1);
	        if (this.inputs.uses[useKey][iname].objFiles && this.inputs.uses[useKey][iname].objFiles.length > 0) {
	          this.inputs.uses[useKey][iname].value = JSON.stringify(this.inputs.uses[useKey][iname].objFiles);
	        } else {
	          this.inputs.uses[useKey][iname].value = "";
	        }
	        this.inputs.uses[useKey][iname].originalnames = _underscore2.default.pluck(this.inputs.uses[useKey][iname].objFiles, "originalname");
	      } else {
	        this.inputs.generals[iname].objFiles.splice(rank, 1);
	        if (this.inputs.generals[iname].objFiles && this.inputs.generals[iname].objFiles.length > 0) {
	          this.inputs.generals[iname].value = JSON.stringify(this.inputs.generals[iname].objFiles);
	        } else {
	          this.inputs.generals[iname].value = "";
	        }
	        this.inputs.generals[iname].originalnames = _underscore2.default.pluck(this.inputs.generals[iname].objFiles, "originalname");
	      }
	      this.changed(iname, useKey);
	    }
	  }, {
	    key: "addInUses",
	    value: function addInUses() {
	      var newUse = {};
	      for (var iname in this.selectedProduct.listedModels) {
	        if (!this.selectedProduct.listedModels[iname].isGeneral) {
	          newUse[iname] = {
	            value: null,
	            required: false,
	            showed: false
	          };
	        }
	      }
	      this.inputs.uses.push(newUse);
	      this.changed();
	    }
	  }, {
	    key: "duplicateUse",
	    value: function duplicateUse(use) {
	      use = JSON.parse(JSON.stringify(use));
	      var newUse = {};
	      for (var iname in this.selectedProduct.listedModels) {
	        if (!this.selectedProduct.listedModels[iname].isGeneral) {
	          use[iname].id = null;
	          use[iname].useNumber = null;
	          newUse[iname] = use[iname];
	        }
	      }
	      this.inputs.uses.push(newUse);
	      this.changed();
	    }
	  }, {
	    key: "removeFromUses",
	    value: function removeFromUses(rank) {
	      if (this.inputs.uses.length > 1) {
	        this.inputs.uses.splice(rank, 1);
	      }
	      this.changed();
	    }
	  }, {
	    key: "searchAuthors",
	    value: function searchAuthors(query) {
	      var that = this;
	      return this.ElasticAPI.searchAuthors({
	        name: query
	      }, function (results) {
	        return results;
	      }).$promise.then(function (results) {
	        results = JSON.parse(JSON.stringify(results));
	        for (var r in results) {
	          var detail = results[r].detail;
	          results[r].isManaged = _underscore2.default.pluck(detail.rights, "right_id").indexOf(that.selectedProduct.rightId) != -1;
	          results[r].percentage = 0;
	          if (results[r].isManaged) {
	            results[r].percentage = _underscore2.default.findWhere(detail.rights, {
	              right_id: that.selectedProduct.rightId
	            }).percentage;
	          }
	          results[r].label = (detail.firstname || "") + " " + (detail.lastname || "") + " " + (detail.birth_year || detail.decease_year ? "(" : "") + (detail.birth_year || " ") + (detail.decease_year ? " - " + detail.decease_year : "") + (detail.birth_year || detail.decease_year ? ")" : "");
	          results[r].label = results[r].label.trim();
	          results[r].copyright = detail.copyright;
	          var notManaged = that.gettextCatalog.getString("Non géré pour");
	          results[r].notManaged = notManaged + " " + (that.ls.lang == "fr" ? that.selectedProduct.nameFr : that.selectedProduct.nameEn);
	          if (results[r].percentage < 100 && results[r].isManaged) {
	            if (that.ls.lang == "fr") {
	              results[r].labelPercentage = "Attention, l’ADAGP ne représente que " + results[r].percentage + "% de la succession";
	            } else {
	              results[r].labelPercentage = "Warning: ADAGP represents only " + results[r].percentage + "% of the Estate";
	            }
	          }
	        }
	        return results;
	      });
	    }
	  }, {
	    key: "blurSearchInput",
	    value: function blurSearchInput(data) {
	      if (!data || typeof data === "string") {
	        data = null;
	      }
	    }
	  }, {
	    key: "onAuthorSelected",
	    value: function onAuthorSelected(use, iname, useKey) {
	      if (use.author.isManaged) {
	        use.value = use.author.detail.name_id;
	      } else {
	        use.author = null;
	        use.value = null;
	      }
	      this.changed(iname, useKey);
	    }
	  }, {
	    key: "deleteAuthor",
	    value: function deleteAuthor(use, iname, useKey) {
	      use.value = null;
	      use.author = null;
	      this.changed(iname, useKey);
	    }
	  }, {
	    key: "prev",
	    value: function prev(form) {
	      if (this.selectedProduct) {
	        this.submitted = true;
	        if (this.disabledInput) {
	          this.arrow.goto(1);
	        } else {
	          var toPage = 1;
	          this.saveDemand(true, toPage);
	        }
	      } else {
	        this.arrow.goto(1);
	      }
	    }
	  }, {
	    key: "next",
	    value: function next(form) {
	      this.submitted = true;
	      if (form.$valid) {
	        if (this.disabledInput) {
	          var amendedDate = new Date(this.demand.dateAmended).getTime();
	          this.arrow.goto(3, this.project.id, this.demand.id, false, {
	            date: amendedDate
	          });
	        } else {
	          this.saveDemand(true);
	        }
	      }
	    }
	  }, {
	    key: "enableChange",
	    value: function enableChange() {
	      var _this = this;
	
	      var that = this;
	      if (this.demand.status) {
	        var status = parseInt(this.demand.status);
	        var demand = JSON.parse(JSON.stringify(this.demand));
	        demand.status = status - status % 10 + 1;
	        this.ProductAPI.changeStatus(demand).$promise.then(function (result) {
	          if (result.status % 10 != 2) {
	            that.demand.status = demand.status;
	            that.disabledInput = false;
	            _this.blockedInput = false;
	          }
	        });
	      }
	    }
	  }, {
	    key: "saveDemand",
	    value: function saveDemand(isFull, page) {
	      var _this2 = this;
	
	      if (this.selectedProduct && this.project && !this.disabledInput && !this.hideUse) {
	        this.saveClicked = true;
	        this.disabledInput = true;
	        var that = this;
	        var _inputs = {
	          generals: [],
	          uses: []
	        };
	        for (var iname in this.inputs.generals) {
	          _inputs.generals.push({
	            id: this.inputs.generals[iname].id || null,
	            value: this.inputs.generals[iname].value,
	            inputModelId: this.selectedProduct.listedModels[iname].id,
	            type: this.selectedProduct.listedModels[iname].type
	          });
	        }
	        for (var u in this.inputs.uses) {
	          _inputs.uses[u] = [];
	          for (var iname in this.inputs.uses[u]) {
	            _inputs.uses[u].push({
	              id: this.inputs.uses[u][iname].id || null,
	              value: this.inputs.uses[u][iname].value,
	              inputModelId: this.selectedProduct.listedModels[iname].id,
	              type: this.selectedProduct.listedModels[iname].type
	            });
	          }
	        }
	        var service = this.demand ? this.ProductAPI.change : this.ProductAPI.save;
	        var data = {
	          productId: this.selectedProduct.id,
	          projectId: this.project.id,
	          generals: _inputs.generals,
	          uses: _inputs.uses
	        };
	        if (this.demand) {
	          data.id = this.demand.id;
	        }
	        return service(data).$promise.then(function (demand) {
	          that.demand = JSON.parse(JSON.stringify(demand));
	          if (isFull) {
	            page = page >= 0 ? page : 3;
	
	            if (page == 3) {
	              var amendedDate = new Date(that.demand.dateAmended).getTime();
	              that.arrow.goto(page, _this2.project.id, demand.id, false, {
	                date: amendedDate
	              });
	            } else {
	              that.arrow.goto(page, _this2.project.id, demand.id);
	            }
	          } else if (!that.s.demand) {
	            that.arrow.goto(2, _this2.project.id, demand.id, true);
	          } else {
	            that.Modal.confirm.info(function () {})(that.gettextCatalog.getString("Sauvegarde"), that.gettextCatalog.getString("Vos données ont bien été sauvegardées"), "OK", "primary");
	            that.loadDemand(demand);
	          }
	          that.saveClicked = false;
	          that.disabledInput = false;
	          return null;
	        }).catch(function () {
	          console.log("---->Error on try to save");
	          that.saveClicked = false;
	          that.disabledInput = false;
	          return null;
	        });
	      }
	    }
	  }, {
	    key: "loadDemand",
	    value: function loadDemand(demand) {
	      if (demand.status == 50 || demand.status == 60 || demand.status == 70 || demand.status == 74 || demand.status == 80 || demand.status == 90) {
	        this.arrow.goto(4, this.project.id, demand.id);
	      }
	      this.selectedProduct = _underscore2.default.findWhere(this.products, {
	        id: demand.productId
	      }) || this.selectedProduct;
	      var _inputs = [];
	      for (var i in demand.input) {
	        var imodel = demand.input[i].inputModel;
	        var _input = {
	          showed: false,
	          required: false,
	          value: this.parseValue(demand.input[i][imodel.type], imodel.type),
	          id: demand.input[i].id,
	          useNumber: demand.input[i].useNumber,
	          inputModelId: demand.input[i].inputModel.id,
	          parentModelId: demand.input[i].inputModel.inputModelId,
	          templateGroupId: demand.input[i].inputModel.templateGroupId,
	          isGeneral: demand.input[i].inputModel.isGeneral,
	          iname: "input_" + imodel.id,
	          rank: imodel.rank,
	          type: imodel.type
	        };
	        if (imodel.type == "author" && demand.input[i].artist) {
	          _input.author = demand.input[i].artist;
	          if (_input.author) {
	            var agreement = _underscore2.default.findWhere(_input.author.agreement, {
	              rightId: this.selectedProduct.rightId
	            });
	            _input.author.percentage = agreement ? parseInt(agreement.percentage) : 0;
	          }
	        }
	        if (imodel.type == "file" && demand.input[i].file) {
	          _input.originalnames = null;
	          _input.objFiles = null;
	          if (demand.input[i].objFiles && demand.input[i].objFiles.length > 0) {
	            _input.objFiles = demand.input[i].objFiles;
	            _input.originalnames = _underscore2.default.pluck(_input.objFiles, "originalname");
	          }
	        }
	        _inputs.push(_input);
	      }
	
	      var _generals = _underscore2.default.where(_inputs, {
	        isGeneral: true
	      });
	      _generals = _underscore2.default.indexBy(_generals, "iname");
	      var _uses = _underscore2.default.where(_inputs, {
	        isGeneral: false
	      });
	      _uses = _underscore2.default.groupBy(_uses, "useNumber");
	
	      var _temp = [];
	      var _tempUN = _underscore2.default.keys(_uses);
	      _tempUN.sort();
	      for (var un in _tempUN) {
	        _temp.push(_underscore2.default.indexBy(_uses[_tempUN[un]], "iname"));
	      }
	      _uses = _temp;
	
	      var listedModels = this.selectedProduct.listedModels;
	
	      for (var iname1 in _generals) {
	        if (listedModels[iname1].subInputModel && listedModels[iname1].subInputModel.length > 0) {
	          if (listedModels[iname1].type == "selectList") {
	            this.updateSelectAfterFetch(iname1, _generals, listedModels[iname1].subInputModel);
	          } else if (listedModels[iname1].type == "checkboxList") {
	            this.updateCheckboxAfterChangeOrFetch(iname1, _generals, listedModels[iname1].subInputModel);
	          }
	        }
	      }
	      for (var u1 in _uses) {
	        for (var iname2 in _uses[u1]) {
	          if (listedModels[iname2].subInputModel && listedModels[iname2].subInputModel.length > 0) {
	            if (listedModels[iname2].type == "selectList") {
	              this.updateSelectAfterFetch(iname2, _uses[u1], listedModels[iname2].subInputModel);
	            } else if (listedModels[iname2].type == "checkboxList") {
	              this.updateCheckboxAfterChangeOrFetch(iname2, _uses[u1], listedModels[iname2].subInputModel);
	            }
	          }
	        }
	      }
	      this.inputs.generals = _generals;
	      this.inputs.uses = _uses;
	
	      this.disabledInput = false;
	      this.blockedInput = false;
	      if (this.demand.status && parseInt(this.demand.status) % 10 !== 1) {
	        this.disabledInput = true;
	        if (parseInt(this.demand.status) % 10 === 3) {
	          this.blockedInput = true;
	        }
	      }
	
	      this.changed();
	      this.isSaved = true;
	    }
	  }, {
	    key: "loadDefaultInputs",
	    value: function loadDefaultInputs() {
	      var that = this;
	      this.ProductAPI.getDefaultInputs({
	        projectId: parseInt(that.s.project),
	        productId: that.selectedProduct.id,
	        demandId: that.demand && that.demand.id ? that.demand.id : null
	      }).$promise.then(function (defInputs) {
	        if (defInputs) {
	          defInputs = JSON.parse(JSON.stringify(defInputs));
	
	          var updatedModelIds = [];
	          for (var d in defInputs) {
	            that._loadDefaultInput(defInputs[d], that.inputs.generals, updatedModelIds);
	            that._loadDefaultInput(defInputs[d], that.inputs.uses, updatedModelIds);
	          }
	
	          var listedModels = that.selectedProduct.listedModels;
	          for (var iname1 in that.inputs.generals) {
	            if (listedModels[iname1].subInputModel && listedModels[iname1].subInputModel.length > 0) {
	              if (listedModels[iname1].type == "selectList") {
	                that.updateSelectAfterFetch(iname1, that.inputs.generals, listedModels[iname1].subInputModel);
	              } else if (listedModels[iname1].type == "checkboxList") {
	                that.updateCheckboxAfterChangeOrFetch(iname1, that.inputs.generals, listedModels[iname1].subInputModel);
	              }
	            }
	          }
	          for (var u1 in that.inputs.uses) {
	            for (var iname2 in that.inputs.uses[u1]) {
	              if (listedModels[iname2].subInputModel && listedModels[iname2].subInputModel.length > 0) {
	                if (listedModels[iname2].type == "selectList") {
	                  that.updateSelectAfterFetch(iname2, that.inputs.uses[u1], listedModels[iname2].subInputModel);
	                } else if (listedModels[iname2].type == "checkboxList") {
	                  that.updateCheckboxAfterChangeOrFetch(iname2, that.inputs.uses[u1], listedModels[iname2].subInputModel);
	                }
	              }
	            }
	          }
	
	          that.changed();
	          return;
	        }
	      }).catch(function (err) {});
	    }
	  }, {
	    key: "_loadDefaultInput",
	    value: function _loadDefaultInput(defInput, inputs, updatedModelIds) {
	      var imodel = defInput.inputModel;
	      for (var i in inputs) {
	        if (inputs[i].templateGroupId && inputs[i].templateGroupId == imodel.templateGroupId && updatedModelIds.indexOf(imodel.id) == -1) {
	          updatedModelIds.push(imodel.id);
	          inputs[i].value = this.parseValue(defInput[imodel.type], imodel.type);
	        }
	      }
	    }
	  }]);
	
	  return ProductController;
	}();
	
	exports.default = angular.module("dalApp.permission.product", []).component("product", {
	  template: __webpack_require__(140),
	  controller: ProductController
	}).name;

/***/ }),
/* 140 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"panel panel-default permission-panel\">\n  <div class=\"panel-body\">\n    <!--h2>Utilisation</h2-->\n\n    <form\n      class=\"form-horizontal\"\n      name=\"form_product\"\n      ng-show=\"!$ctrl.spinnerEnabled\"\n      novalidate\n    >\n      <!--*******************GENERALS INPUTS*******************-->\n      <fieldset>\n        <!--button class=\"btn btn-default\"\n          type=\"button\"\n          uib-tooltip=\"I'm a tooltip!\">\n          I'm a button!\n        </button-->\n\n        <div\n          class=\"form-group\"\n          ng-class=\"{ 'has-error': form_product.type.$invalid && $ctrl.submitted }\"\n        >\n          <label class=\"control-label col-sm-3\" for=\"type\"\n            >* {{\"Type d'utilisation\"|translate}} :</label\n          >\n          <div class=\"col-sm-8\">\n            <select\n              class=\"form-control\"\n              ng-model=\"$ctrl.selectedProduct\"\n              name=\"type\"\n              required\n              ng-change=\"$ctrl.productChanged({{$ctrl.selectedProduct}})\"\n              ng-disabled=\"$ctrl.disabledInput\"\n            >\n              <option ng-repeat=\"option in $ctrl.products\" ng-value=\"option\">\n                {{$ctrl.ls.lang=='fr'?option.nameFr:option.nameEn}}\n              </option>\n            </select>\n          </div>\n        </div>\n\n        <div\n          class=\"form-group\"\n          ng-repeat=\"inputModel in $ctrl.selectedProduct.generals track by inputModel.id\"\n          ng-if=\"$ctrl.inputs.generals[inputModel.iname].showed\"\n          ng-class=\"{ 'has-error': form_product[inputModel.iname].$invalid && $ctrl.submitted }\"\n        >\n          <label class=\"control-label col-sm-3\">\n            <span ng-if=\"$ctrl.inputs.generals[inputModel.iname].required\"\n              >*\n            </span>\n            {{$ctrl.ls.lang=='fr'?inputModel.labelFr:inputModel.labelEn}}\n          </label>\n          <div class=\"col-sm-8\">\n            <input\n              type=\"number\"\n              min=\"1\"\n              class=\"form-control\"\n              ng-if=\"inputModel.type=='integer'\"\n              ng-disabled=\"$ctrl.disabledInput\"\n              ng-required=\"$ctrl.inputs.generals[inputModel.iname].required\"\n              name=\"{{inputModel.iname}}\"\n              ng-model=\"$ctrl.inputs.generals[inputModel.iname].value\"\n              ng-change=\"$ctrl.changed(inputModel.iname)\"\n            />\n\n            <input\n              type=\"number\"\n              min=\"0.001\"\n              class=\"form-control\"\n              ng-if=\"inputModel.type=='decimal'\"\n              ng-disabled=\"$ctrl.disabledInput\"\n              ng-required=\"$ctrl.inputs.generals[inputModel.iname].required\"\n              name=\"{{inputModel.iname}}\"\n              ng-model=\"$ctrl.inputs.generals[inputModel.iname].value\"\n              ng-change=\"$ctrl.changed(inputModel.iname)\"\n            />\n\n            <input\n              type=\"text\"\n              class=\"form-control\"\n              ng-if=\"inputModel.type=='char255'\"\n              ng-disabled=\"$ctrl.disabledInput\"\n              ng-required=\"$ctrl.inputs.generals[inputModel.iname].required\"\n              name=\"{{inputModel.iname}}\"\n              maxlength=\"255\"\n              ng-model=\"$ctrl.inputs.generals[inputModel.iname].value\"\n              ng-change=\"$ctrl.changed(inputModel.iname)\"\n            />\n\n            <p\n              class=\"input-group\"\n              ng-if=\"inputModel.type=='date'\"\n              ng-disabled=\"$ctrl.disabledInput\"\n            >\n              <input\n                type=\"text\"\n                class=\"form-control\"\n                uib-datepicker-popup=\"{{'dd-MM-yyyy'}}\"\n                ng-disabled=\"$ctrl.disabledInput\"\n                ng-model=\"$ctrl.inputs.generals[inputModel.iname].value\"\n                ng-click=\"$ctrl.popupDate[opened+inputModel.iname]= true\"\n                is-open=\"$ctrl.popupDate[opened+inputModel.iname]\"\n                ng-required=\"$ctrl.inputs.generals[inputModel.iname].required\"\n                name=\"{{inputModel.iname}}\"\n                show-button-bar=\"false\"\n                ng-change=\"$ctrl.setHour12(inputModel.iname);$ctrl.changed(inputModel.iname)\"\n              />\n              <span class=\"input-group-btn\">\n                <button\n                  type=\"button\"\n                  class=\"btn btn-default\"\n                  ng-disabled=\"$ctrl.disabledInput\"\n                  ng-click=\"$ctrl.popupDate[opened+inputModel.iname]= !$ctrl.popupDate[opened+inputModel.iname]\"\n                >\n                  <i class=\"glyphicon glyphicon-calendar\"></i>\n                </button>\n              </span>\n            </p>\n\n            <textarea\n              class=\"form-control\"\n              rows=\"4\"\n              ng-if=\"inputModel.type=='text'\"\n              ng-disabled=\"$ctrl.disabledInput\"\n              ng-required=\"$ctrl.inputs.generals[inputModel.iname].required\"\n              name=\"{{inputModel.iname}}\"\n              ng-model=\"$ctrl.inputs.generals[inputModel.iname].value\"\n              ng-change=\"$ctrl.changed(inputModel.iname)\"\n            ></textarea>\n\n            <!--div ng-if=\"inputModel.type=='multiSelectList'\" ng-disabled=\"$ctrl.disabledInput\"\n                isteven-multi-select\n                input-model=\"inputModel.subInputModel\"\n                output-model=\"$ctrl.outputBrowsers\"\n                button-label=\"{{$ctrl.ls.lang=='fr'?'labelFr':'labelEn'}}\"\n                item-label=\"{{$ctrl.ls.lang=='fr'?'labelFr':'labelEn'}}\"\n                tick-property=\"ticked\"\n                translation=\"$ctrl.ls.lang=='fr'?$ctrl.multiSelectFr:$ctrl.multiSelectEn\"\n            >\n          </div-->\n\n            <select\n              class=\"form-control\"\n              ng-if=\"inputModel.type=='selectList'\"\n              ng-disabled=\"$ctrl.disabledInput\"\n              ng-model=\"$ctrl.inputs.generals[inputModel.iname].value\"\n              ng-required=\"$ctrl.inputs.generals[inputModel.iname].required\"\n              name=\"{{inputModel.iname}}\"\n              ng-change=\"$ctrl.changed(inputModel.iname)\"\n            >\n              <option value=\"\" disabled selected hidden translate>\n                Veuillez sélectionner...\n              </option>\n              <option\n                ng-repeat=\"option in inputModel.subInputModel\"\n                ng-value=\"option.iname\"\n              >\n                {{$ctrl.ls.lang=='fr'?option.labelFr:option.labelEn}}\n              </option>\n            </select>\n\n            <span ng-if=\"inputModel.type=='checkboxList'\">\n              <label\n                class=\"radio-inline option-list-box\"\n                ng-repeat=\"option in inputModel.subInputModel\"\n              >\n                <input\n                  type=\"checkbox\"\n                  ng-model=\"$ctrl.inputs.generals[option.iname].value\"\n                  ng-disabled=\"$ctrl.disabledInput\"\n                  ng-required=\"$ctrl.inputs.generals[inputModel.iname].required && !$ctrl.inputs.generals[inputModel.iname].value\"\n                  name=\"{{inputModel.iname}}\"\n                  ng-change=\"$ctrl.changed(option.iname)\"\n                />\n                {{$ctrl.ls.lang=='fr'?option.labelFr:option.labelEn}}\n              </label>\n            </span>\n\n            <span ng-if=\"inputModel.type=='radioButtonList'\">\n              <label\n                class=\"radio-inline option-list-box\"\n                ng-repeat=\"option in inputModel.subInputModel\"\n              >\n                <input\n                  type=\"radio\"\n                  ng-model=\"$ctrl.inputs.generals[option.iname].value\"\n                  ng-disabled=\"$ctrl.disabledInput\"\n                  ng-required=\"$ctrl.inputs.generals[option.iname].required\"\n                  name=\"{{inputModel.iname}}\"\n                  ng-change=\"$ctrl.changed(option.iname)\"\n                />\n                {{$ctrl.ls.lang=='fr'?option.labelFr:option.labelEn}}\n              </label>\n            </span>\n\n            <!--span ng-if=\"inputModel.type=='file' && !$ctrl.onUpload[inputModel.iname]\">\n              {{$ctrl.inputs.generals[inputModel.iname].originalnames.join(', ')}}\n            </span-->\n\n            <ul\n              ng-if=\"inputModel.type=='file' && !$ctrl.onUpload[inputModel.iname]\"\n              class=\"ul-file\"\n            >\n              <li\n                ng-repeat=\"(fId, oFile) in $ctrl.inputs.generals[inputModel.iname].objFiles track by $index\"\n              >\n                <button\n                  class=\"btn btn-danger btn-xs btn-trash-sketch\"\n                  ng-click=\"$ctrl.removeFile(fId, inputModel.iname)\"\n                  ng-if=\"!$ctrl.disabledInput\"\n                >\n                  <i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i>\n                </button>\n                <a\n                  href=\"{{$ctrl.ovhBaseURI+oFile.url}}\"\n                  download\n                  target=\"_blank\"\n                >\n                  {{oFile.originalname}}\n                </a>\n              </li>\n            </ul>\n            <span\n              ng-if=\"inputModel.type=='file' && $ctrl.onUpload[inputModel.iname]\"\n            >\n              <i class=\"fa fa-spinner fa-spin\" aria-hidden=\"true\"></i>\n            </span>\n\n            <input\n              type=\"hidden\"\n              name=\"{{inputModel.iname}}\"\n              ng-if=\"inputModel.type=='file'\"\n              ng-required=\"$ctrl.inputs.generals[inputModel.iname].required\"\n              ng-model=\"$ctrl.inputs.generals[inputModel.iname].value\"\n            />\n            <upload-button\n              class=\"btn btn-primary btn-upload\"\n              ng-if=\"inputModel.type=='file' && !$ctrl.disabledInput && !$ctrl.onUpload[inputModel.iname]\"\n              url=\"/api/demands/upload\"\n              param=\"sketch_file\"\n              force-iframe-upload=\"{{forceIframeUpload}}\"\n              accept=\"{{\n              'image/jpeg, image/png, image/jpg, image/tiff, image/gif, video/*,\n              application/zip, application/gzip, application/x-gzip, application/x-bzip, application/x-bzip2, \n              application/x-zip-compressed, application/x-7z-compressed, application/x-tar,\n              application/msword, application/vnd.ms-excel,application/vnd.ms-powerpoint,\n              text/plain, application/pdf, application/acrobat, application/x-photoshop, application/postscript'}}\"\n              on-upload=\"$ctrl.onStartUpload(files, inputModel.iname)\"\n              on-success=\"$ctrl.onSuccessUpload(response, inputModel.iname)\"\n              on-error=\"$ctrl.onErrorUpload(response, inputModel.iname)\"\n              on-complete=\"$ctrl.onCompleteUpload(response, inputModel.iname)\"\n              ><i class=\"fa fa-upload fa-1x\" aria-hidden=\"true\"></i>\n              {{'Télécharger un fichier'|translate}}</upload-button\n            >\n\n            <p\n              class=\"help-block info-block\"\n              style=\"color: red\"\n              ng-if=\"$ctrl.onErrorUpload[inputModel.iname]\"\n            >\n              <span translate>Format de fichier non supporté</span>\n            </p>\n\n            <p\n              class=\"help-block info-block\"\n              ng-if=\"inputModel.informationFr||inputModel.informationEn\"\n            >\n              <i class=\"fa fa-info-circle\" aria-hidden=\"true\"></i>\n              <span\n                ng-bind-html=\"$ctrl.trustAsHtml($ctrl.ls.lang=='fr'?inputModel.informationFr:inputModel.informationEn)\"\n              ></span>\n            </p>\n            <p\n              class=\"help-block info-block\"\n              ng-repeat=\"sub in inputModel.subInputModel\"\n              ng-if=\"(sub.informationFr||sub.informationEn) && $ctrl.inputs.generals[sub.iname].value\"\n            >\n              <i class=\"fa fa-info-circle\" aria-hidden=\"true\"></i>\n              <span\n                ng-bind-html=\"$ctrl.trustAsHtml($ctrl.ls.lang=='fr'?sub.informationFr:sub.informationEn)\"\n              ></span>\n            </p>\n            <p\n              class=\"help-block required-block\"\n              ng-if=\"(inputModel.requiredMessageFr||inputModel.requiredMessageEn) &&\n            form_product[inputModel.iname].$invalid && $ctrl.submitted \"\n            >\n              <i class=\"fa fa-exclamation-triangle\" aria-hidden=\"true\"></i>\n              <span\n                ng-bind-html=\"$ctrl.trustAsHtml($ctrl.ls.lang=='fr'?inputModel.requiredMessageFr:inputModel.requiredMessageEn)\"\n              ></span>\n              *\n            </p>\n          </div>\n        </div>\n      </fieldset>\n\n      <!--*******************USES INPUTS*******************-->\n      <fieldset\n        id=\"fieldset-uses\"\n        ng-repeat=\"(useKey , use ) in $ctrl.inputs.uses track by $index\"\n        ng-class=\"{'colored-fieldset' : $index%2==0, 'use-fieldset': true}\"\n        ng-if=\"$ctrl.selectedProduct && !$ctrl.hideUse && useKey< $ctrl.maxUsesNb\"\n      >\n        <legend class=\"text-center header\"></legend>\n        <div class=\"form-group use-number col-sm-12\">\n          <button\n            type=\"button\"\n            class=\"btn btn-danger btn-trash-work btn-xs\"\n            ng-click=\"$ctrl.removeFromUses(useKey)\"\n            ng-if=\"!$ctrl.disabledInput && $ctrl.inputs.uses.length>1 \"\n          >\n            <i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i>\n          </button>\n          <label\n            class=\"control-label\"\n            style=\"font-size: 1.2em; text-align: left; margin-left: 10px\"\n          >\n            {{\"Oeuvre\"|translate}} n°{{$index+1}} .\n          </label>\n        </div>\n\n        <div\n          class=\"form-group\"\n          ng-repeat=\"inputModel in $ctrl.selectedProduct.uses track by inputModel.id\"\n          ng-if=\"$ctrl.inputs.uses[useKey][inputModel.iname].showed\"\n          ng-class=\"{ 'has-error': form_product[inputModel.iname+'_'+useKey].$invalid && $ctrl.submitted }\"\n        >\n          <label class=\"control-label col-sm-3\">\n            <span ng-if=\"$ctrl.inputs.uses[useKey][inputModel.iname].required\"\n              >*\n            </span>\n            {{$ctrl.ls.lang=='fr'?inputModel.labelFr:inputModel.labelEn}}\n          </label>\n          <script type=\"text/ng-template\" id=\"customTemplate.html\">\n            <a >\n              <span ng-class=\"{'author-not-managed' : !match.model.isManaged}\" >\n                <span ng-if=\"!match.model.isManaged\"><i class=\"fa fa-exclamation-triangle\" aria-hidden=\"true\"></i></span>\n                <span ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"></span>\n                <span ng-if=\"!match.model.isManaged\" style=\"font-size:0.8em; font-style:italic;\">- {{match.model.notManaged}}</span>\n                <span ng-if=\"match.model.percentage<100 && match.model.isManaged\"\n                style=\"font-size:0.8em; font-style:italic; color: orange\">\n                  - {{ match.model.labelPercentage }}\n                </span>\n              </span>\n            </a>\n          </script>\n          <div class=\"col-sm-8\">\n            <div ng-if=\"inputModel.type=='author'\">\n              <div ng-if=\"!$ctrl.inputs.uses[useKey][inputModel.iname].value\">\n                <input\n                  type=\"text\"\n                  ng-model=\"$ctrl.inputs.uses[useKey][inputModel.iname].author\"\n                  placeholder=\"{{'Recherche'|translate}} ...\"\n                  typeahead-append-to-body=\"true\"\n                  class=\"form-control\"\n                  ng-disabled=\"$ctrl.disabledInput\"\n                  uib-typeahead=\"author as author.label for author in $ctrl.searchAuthors($viewValue)\"\n                  typeahead-loading=\"loadingAuthorList\"\n                  typeahead-min-length=\"2\"\n                  typeahead-no-results=\"noAuthorResults\"\n                  typeahead-template-url=\"customTemplate.html\"\n                  typeahead-on-select=\"$ctrl.onAuthorSelected($ctrl.inputs.uses[useKey][inputModel.iname], inputModel.iname, useKey)\"\n                  ng-required=\"$ctrl.inputs.uses[useKey][inputModel.iname].required\"\n                  name=\"{{inputModel.iname+'_'+useKey}}\"\n                  ng-blur=\"$ctrl.inputs.uses[useKey][inputModel.iname].author = null\"\n                />\n                <i\n                  ng-show=\"loadingAuthorList\"\n                  class=\"glyphicon glyphicon-refresh\"\n                ></i>\n                <div ng-show=\"noAuthorResults\">\n                  <i class=\"glyphicon glyphicon-remove\"></i> Aucun résultat\n                </div>\n              </div>\n              <div\n                class=\"input-group col-sm-12\"\n                ng-if=\"$ctrl.inputs.uses[useKey][inputModel.iname].value\"\n              >\n                <input\n                  type=\"text\"\n                  class=\"form-control\"\n                  disabled\n                  style=\"cursor: default\"\n                  ng-value=\"$ctrl.inputs.uses[useKey][inputModel.iname].author.label\"\n                />\n                <span class=\"input-group-btn\">\n                  <button\n                    type=\"button\"\n                    class=\"btn btn-primary\"\n                    ng-disabled=\"$ctrl.disabledInput\"\n                    ng-click=\"$ctrl.deleteAuthor($ctrl.inputs.uses[useKey][inputModel.iname], inputModel.iname, useKey)\"\n                    translate\n                  >\n                    Modifier\n                  </button>\n                </span>\n              </div>\n              <p\n                class=\"help-block info-block\"\n                style=\"color: orange\"\n                ng-if=\"$ctrl.inputs.uses[useKey][inputModel.iname].value && $ctrl.inputs.uses[useKey][inputModel.iname].author\n              && $ctrl.inputs.uses[useKey][inputModel.iname].author.percentage<100\"\n              >\n                <i class=\"fa fa-exclamation-triangle\" aria-hidden=\"true\"></i>\n                <span ng-if=\"$ctrl.ls.lang=='fr'\"\n                  >Attention, l’ADAGP ne représente que\n                  {{$ctrl.inputs.uses[useKey][inputModel.iname].author.percentage}}%\n                  de la succession</span\n                >\n                <span ng-if=\"$ctrl.ls.lang=='en'\"\n                  >Warning: ADAGP represents only\n                  {{$ctrl.inputs.uses[useKey][inputModel.iname].author.percentage}}%\n                  of the Estate</span\n                >\n              </p>\n\n              <p\n                class=\"help-block info-block\"\n                ng-if=\"$ctrl.inputs.uses[useKey][inputModel.iname].value\"\n                style=\"color: #398bd2\"\n              >\n                <i class=\"fa fa-exclamation-triangle\" aria-hidden=\"true\"></i>\n                <span translate>\n                  Toute reproduction ou représentation d'une oeuvre de l'auteur\n                  doit être accompagnée des mentions suivantes </span\n                >:\n                <b\n                  >{{$ctrl.inputs.uses[useKey][inputModel.iname].author.copyright}}</b\n                >\n              </p>\n            </div>\n\n            <input\n              type=\"number\"\n              min=\"1\"\n              class=\"form-control\"\n              ng-if=\"inputModel.type=='integer'\"\n              ng-disabled=\"$ctrl.disabledInput\"\n              ng-required=\"$ctrl.inputs.uses[useKey][inputModel.iname].required\"\n              name=\"{{inputModel.iname+'_'+useKey}}\"\n              ng-change=\"$ctrl.changed(inputModel.iname,useKey)\"\n              ng-model=\"$ctrl.inputs.uses[useKey][inputModel.iname].value\"\n            />\n\n            <input\n              type=\"number\"\n              min=\"0.001\"\n              class=\"form-control\"\n              ng-if=\"inputModel.type=='decimal'\"\n              ng-disabled=\"$ctrl.disabledInput\"\n              ng-required=\"$ctrl.inputs.uses[useKey][inputModel.iname].required\"\n              name=\"{{inputModel.iname+'_'+useKey}}\"\n              ng-change=\"$ctrl.changed(inputModel.iname,useKey)\"\n              ng-model=\"$ctrl.inputs.uses[useKey][inputModel.iname].value\"\n            />\n\n            <input\n              type=\"text\"\n              class=\"form-control\"\n              ng-if=\"inputModel.type=='char255'\"\n              ng-disabled=\"$ctrl.disabledInput\"\n              ng-required=\"$ctrl.inputs.uses[useKey][inputModel.iname].required\"\n              name=\"{{inputModel.iname+'_'+useKey}}\"\n              maxlength=\"255\"\n              ng-change=\"$ctrl.changed(inputModel.iname,useKey)\"\n              ng-model=\"$ctrl.inputs.uses[useKey][inputModel.iname].value\"\n            />\n\n            <p\n              class=\"input-group\"\n              ng-if=\"inputModel.type=='date'\"\n              ng-disabled=\"$ctrl.disabledInput\"\n            >\n              <input\n                type=\"text\"\n                class=\"form-control\"\n                uib-datepicker-popup=\"{{'dd-MM-yyyy'}}\"\n                ng-disabled=\"$ctrl.disabledInput\"\n                ng-model=\"$ctrl.inputs.uses[useKey][inputModel.iname].value\"\n                ng-click=\"$ctrl.popupDate[opened+inputModel.iname+'_'+useKey]= true\"\n                is-open=\"$ctrl.popupDate[opened+inputModel.iname+'_'+useKey]\"\n                ng-required=\"$ctrl.inputs.uses[useKey][inputModel.iname].required\"\n                name=\"{{inputModel.iname+'_'+useKey}}\"\n                show-button-bar=\"false\"\n                ng-change=\"$ctrl.setHour12(inputModel.iname,useKey) ; $ctrl.changed(inputModel.iname,useKey)\"\n              />\n              <span class=\"input-group-btn\">\n                <button\n                  type=\"button\"\n                  class=\"btn btn-default\"\n                  ng-disabled=\"$ctrl.disabledInput\"\n                  ng-click=\"$ctrl.popupDate[opened+inputModel.iname+'_'+useKey]= !$ctrl.popupDate[opened+inputModel.iname+'_'+useKey]\"\n                >\n                  <i class=\"glyphicon glyphicon-calendar\"></i>\n                </button>\n              </span>\n            </p>\n\n            <textarea\n              class=\"form-control\"\n              rows=\"4\"\n              ng-if=\"inputModel.type=='text'\"\n              ng-disabled=\"$ctrl.disabledInput\"\n              ng-required=\"$ctrl.inputs.uses[useKey][inputModel.iname].required\"\n              name=\"{{inputModel.iname+'_'+useKey}}\"\n              ng-change=\"$ctrl.changed(inputModel.iname,useKey)\"\n              ng-model=\"$ctrl.inputs.uses[useKey][inputModel.iname].value\"\n            ></textarea>\n\n            <!--div ng-if=\"inputModel.type=='multiSelectList'\" ng-disabled=\"$ctrl.disabledInput\"\n                isteven-multi-select\n                input-model=\"inputModel.subInputModel\"\n                output-model=\"$ctrl.outputBrowsers\"\n                button-label=\"{{$ctrl.ls.lang=='fr'?'labelFr':'labelEn'}}\"\n                item-label=\"{{$ctrl.ls.lang=='fr'?'labelFr':'labelEn'}}\"\n                tick-property=\"ticked\"\n                translation=\"$ctrl.ls.lang=='fr'?$ctrl.multiSelectFr:$ctrl.multiSelectEn\">\n            </div-->\n\n            <select\n              class=\"form-control\"\n              ng-if=\"inputModel.type=='selectList'\"\n              ng-disabled=\"$ctrl.disabledInput\"\n              ng-model=\"$ctrl.inputs.uses[useKey][inputModel.iname].value\"\n              ng-required=\"$ctrl.inputs.uses[useKey][inputModel.iname].required\"\n              name=\"{{inputModel.iname+'_'+useKey}}\"\n              ng-change=\"$ctrl.changed(inputModel.iname,useKey)\"\n            >\n              <option value=\"\" disabled selected hidden translate>\n                Veuillez sélectionner...\n              </option>\n              <option\n                ng-repeat=\"option in inputModel.subInputModel\"\n                ng-value=\"option.iname\"\n              >\n                {{$ctrl.ls.lang=='fr'?option.labelFr:option.labelEn}}\n              </option>\n            </select>\n\n            <span ng-if=\"inputModel.type=='checkboxList'\">\n              <label\n                class=\"radio-inline option-list-box\"\n                ng-repeat=\"option in inputModel.subInputModel\"\n              >\n                <input\n                  type=\"checkbox\"\n                  ng-model=\"$ctrl.inputs.uses[useKey][option.iname].value\"\n                  ng-disabled=\"$ctrl.disabledInput\"\n                  ng-required=\"$ctrl.inputs.uses[useKey][inputModel.iname].required  && !$ctrl.inputs.uses[useKey][inputModel.iname].value\"\n                  name=\"{{inputModel.iname+'_'+useKey}}\"\n                  ng-change=\"$ctrl.changed(option.iname,useKey)\"\n                />\n                {{$ctrl.ls.lang=='fr'?option.labelFr:option.labelEn}}\n              </label>\n            </span>\n\n            <span ng-if=\"inputModel.type=='radioButtonList'\">\n              <label\n                class=\"radio-inline option-list-box\"\n                ng-repeat=\"option in inputModel.subInputModel\"\n              >\n                <input\n                  type=\"radio\"\n                  ng-model=\"$ctrl.inputs.uses[useKey][option.iname].value\"\n                  ng-disabled=\"$ctrl.disabledInput\"\n                  ng-required=\"$ctrl.inputs.uses[useKey][option.iname].required\"\n                  name=\"{{inputModel.iname+'_'+useKey}}\"\n                  ng-change=\"$ctrl.changed(option.iname,useKey)\"\n                />\n                {{$ctrl.ls.lang=='fr'?option.labelFr:option.labelEn}}\n              </label>\n            </span>\n\n            <!--span ng-if=\"inputModel.type=='file' && !$ctrl.onUpload[inputModel.iname+useKey]\">\n              {{$ctrl.inputs.uses[useKey][inputModel.iname].originalnames}}\n            </span-->\n\n            <ul\n              ng-if=\"inputModel.type=='file' && !$ctrl.onUpload[inputModel.iname+'_'+useKey]\"\n              class=\"ul-file\"\n            >\n              <li\n                ng-repeat=\"(fId, oFile) in $ctrl.inputs.uses[useKey][inputModel.iname].objFiles track by $index\"\n              >\n                <button\n                  class=\"btn btn-danger btn-xs btn-trash-sketch\"\n                  ng-click=\"$ctrl.removeFile(fId, inputModel.iname, useKey)\"\n                  ng-if=\"!$ctrl.disabledInput\"\n                >\n                  <i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i>\n                </button>\n                <a\n                  href=\"{{$ctrl.ovhBaseURI+oFile.url}}\"\n                  download\n                  target=\"_blank\"\n                >\n                  {{oFile.originalname}}\n                </a>\n              </li>\n            </ul>\n            <span\n              ng-if=\"inputModel.type=='file' && $ctrl.onUpload[inputModel.iname+'_'+useKey]\"\n            >\n              <i class=\"fa fa-spinner fa-spin\" aria-hidden=\"true\"></i>\n            </span>\n            <input\n              type=\"hidden\"\n              name=\"{{inputModel.iname+'_'+useKey}}\"\n              ng-if=\"inputModel.type=='file'\"\n              ng-required=\"$ctrl.inputs.uses[useKey][inputModel.iname].required\"\n              ng-model=\"$ctrl.inputs.uses[useKey][inputModel.iname].value\"\n            />\n            <upload-button\n              class=\"btn btn-primary btn-upload\"\n              ng-if=\"inputModel.type=='file' && !$ctrl.disabledInput && !$ctrl.onUpload[inputModel.iname+'_'+useKey]\"\n              url=\"/api/demands/upload\"\n              param=\"sketch_file\"\n              ng-disabled=\"$ctrl.disabledInput\"\n              force-iframe-upload=\"{{forceIframeUpload}}\"\n              required=\"false\"\n              accept=\"{{'image/jpeg, image/png, image/jpg, image/tiff, image/gif,video/*,\n              application/zip,application/msword, application/vnd.ms-excel,\n              application/vnd.ms-powerpoint,text/plain, application/pdf'}}\"\n              on-upload=\"$ctrl.onStartUpload(files, inputModel.iname , useKey)\"\n              on-success=\"$ctrl.onSuccessUpload(response, inputModel.iname , useKey)\"\n              on-error=\"$ctrl.onErrorUpload(response, inputModel.iname , useKey)\"\n              on-complete=\"$ctrl.onCompleteUpload(response, inputModel.iname , useKey)\"\n              ><i class=\"fa fa-upload\" aria-hidden=\"true\"></i>\n              {{'Télécharger un fichier'|translate}}\n            </upload-button>\n\n            <p\n              class=\"help-block info-block\"\n              style=\"color: red\"\n              ng-if=\"$ctrl.onErrorUpload[inputModel.iname+'_'+useKey]\"\n            >\n              <span translate>Format de fichier non supporté</span>\n            </p>\n\n            <p\n              class=\"help-block info-block\"\n              ng-if=\"inputModel.informationFr||inputModel.informationEn\"\n            >\n              <i class=\"fa fa-info-circle\" aria-hidden=\"true\"></i>\n              <span\n                ng-bind-html=\"$ctrl.trustAsHtml($ctrl.ls.lang=='fr'?inputModel.informationFr:inputModel.informationEn)\"\n              ></span>\n            </p>\n            <p\n              class=\"help-block info-block\"\n              ng-repeat=\"sub in inputModel.subInputModel\"\n              ng-if=\"(sub.informationFr||sub.informationEn) && $ctrl.inputs.uses[useKey][sub.iname].value\"\n            >\n              <i class=\"fa fa-info-circle\" aria-hidden=\"true\"></i>\n              <span\n                ng-bind-html=\"$ctrl.trustAsHtml($ctrl.ls.lang=='fr'?sub.informationFr:sub.informationEn)\"\n              ></span>\n            </p>\n            <p\n              class=\"help-block required-block\"\n              ng-if=\"(inputModel.requiredMessageFr||inputModel.requiredMessageEn)  &&\n            form_product[inputModel.iname+'_'+useKey].$invalid && $ctrl.submitted \"\n            >\n              <i class=\"fa fa-exclamation-triangle\" aria-hidden=\"true\"></i>\n              <span\n                ng-bind-html=\"$ctrl.trustAsHtml($ctrl.ls.lang=='fr'?inputModel.requiredMessageFr:inputModel.requiredMessageEn)\"\n              ></span>\n              *\n            </p>\n          </div>\n        </div>\n\n        <div\n          class=\"form-group\"\n          ng-if=\"!$ctrl.disabledInput && $ctrl.inputs.uses.length>=1\"\n        >\n          <div class=\"col-sm-11\" align=\"right\">\n            <button\n              type=\"button\"\n              class=\"btn btn-uses\"\n              ng-click=\"$ctrl.addInUses(demand)\"\n              translate\n            >\n              Ajouter une nouvelle oeuvre ou un nouvel artiste\n            </button>\n            <button\n              type=\"button\"\n              class=\"btn btn-uses\"\n              ng-click=\"$ctrl.duplicateUse($ctrl.inputs.uses[useKey])\"\n              translate\n            >\n              Dupliquer\n            </button>\n          </div>\n        </div>\n\n        <!--div class=\"form-group\" ng-if=\"!$ctrl.disabledInput && $ctrl.inputs.uses.length>1\">\n          <div class=\"col-sm-11\" align=\"right\">\n            <button type=\"button\" class=\"btn btn-primary\"\n              ng-if=\"!$ctrl.disabledInput && useKey+1==$ctrl.inputs.uses.length\"\n              ng-click=\"$ctrl.addInUses(demand)\" translate>Ajouter</button>\n            <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$ctrl.removeFromUses(useKey)\" translate>Supprimer</button>\n          </div>\n        </div-->\n\n        <!--div class=\"form-group\" ng-if=\"useKey+1==$ctrl.inputs.uses.length\">\n          <legend></legend>\n        </div-->\n      </fieldset>\n\n      <!--fieldset ng-if=\"$ctrl.selectedProduct && !$ctrl.hideUse \"\n        ng-class=\"{'colored-fieldset' : $ctrl.inputs.uses.length%2==0}\">\n        <legend class=\"text-center header\"></legend>\n        <div align=\"right\" class=\"div-new-use\">\n          <button type=\"button\" class=\"btn btn-default btn-lg\" ng-click=\"$ctrl.addInUses(demand)\"\n            ng-disabled=\"$ctrl.disabledInput\" translate>Ajouter une nouvelle oeuvre ou un nouvel artiste</button>\n        </div>\n      </fieldset-->\n    </form>\n\n    <p\n      align=\"center\"\n      ng-if=\"$ctrl.saveClicked || $ctrl.spinnerEnabled || \n      ($ctrl.selectedProduct && !$ctrl.hideUse && $ctrl.inputs.uses.length && $ctrl.inputs.uses.length> $ctrl.maxUsesNb)\"\n      class=\"waitting-spinner\"\n    >\n      <i class=\"fa fa-spinner fa-spin fa-5x fa-fw\"></i>\n    </p>\n\n    <!--*****************PAGINATION*****************-->\n    <nav\n      aria-label=\"Pagination\"\n      ng-if=\"!$ctrl.saveClicked && !$ctrl.spinnerEnabled && \n      !($ctrl.selectedProduct && !$ctrl.hideUse && $ctrl.inputs.uses.length && $ctrl.inputs.uses.length> $ctrl.maxUsesNb)\"\n    >\n      <p\n        ng-if=\"$ctrl.disabledInput && $ctrl.blockedInput\"\n        class=\"blocked-input-msg\"\n      >\n        <i class=\"fa fa-exclamation-triangle\" aria-hidden=\"true\"></i>\n        {{\"Votre demande est en cours de traitement, vous ne pouvez pas la\n        modifier pour le moment.\"|translate}}\n      </p>\n      <p\n        ng-if=\"!form_product.$valid && $ctrl.submitted\"\n        class=\"blocked-input-msg\"\n        style=\"text-align: right\"\n      >\n        <i class=\"fa fa-exclamation-triangle\" aria-hidden=\"true\"></i>\n        {{\"Tous les champs obligatoires ne sont pas remplis.\"|translate}}\n      </p>\n      <p\n        ng-if=\"$ctrl.demand && $ctrl.demand.dateValidated && $ctrl.demand.status && $ctrl.demand.status%10==1 \"\n        class=\"blocked-input-msg\"\n      >\n        <i class=\"fa fa-exclamation-triangle\" aria-hidden=\"true\"></i>\n        <span ng-if=\"$ctrl.ls.lang == 'fr'\">\n          ATTENTION, votre demande ne pourra pas être traitée tant que vous\n          n'aurez pas validé vos modifications (aller jusqu'à l'envoi de le\n          demande).\n        </span>\n        <span ng-if=\"$ctrl.ls.lang != 'fr'\">\n          WARNING, your request cannot be processed until you have validated\n          your changes (proceeding to submit the request).\n        </span>\n      </p>\n      <ul class=\"pager\">\n        <li class=\"previous\">\n          <a href=\"#\" ng-click=\"$ctrl.prev(form_product)\">\n            <i class=\"fa fa-arrow-left\" aria-hidden=\"true\"></i>\n            <span ng-if=\"!$ctrl.isMobile\">\n              {{\"Précédent\"|translate}}\n              <i\n                class=\"fa fa-floppy-o\"\n                aria-hidden=\"true\"\n                style=\"margin-left: 7px\"\n              ></i>\n            </span>\n          </a>\n        </li>\n\n        <li ng-if=\"$ctrl.selectedProduct\" class=\"center\">\n          <a\n            href=\"#\"\n            class=\"primary\"\n            ng-click=\"$ctrl.saveDemand()\"\n            ng-if=\"!$ctrl.disabledInput && $ctrl.selectedProduct && $ctrl.project && !$ctrl.hideUse\"\n          >\n            <i\n              class=\"fa fa-floppy-o\"\n              aria-hidden=\"true\"\n              style=\"margin-right: 7px\"\n            ></i>\n            {{\"Sauvegarder\"|translate}}\n          </a>\n          <a\n            href=\"#\"\n            class=\"warning\"\n            ng-click=\"$ctrl.enableChange()\"\n            ng-if=\"$ctrl.disabledInput && !$ctrl.blockedInput\"\n          >\n            {{\"Activer la modification\"|translate}}\n          </a>\n          <a\n            href=\"#\"\n            class=\"danger\"\n            ng-if=\"$ctrl.disabledInput && $ctrl.blockedInput\"\n            disabled\n          >\n            {{\"Demande verrouillée\"|translate}}\n          </a>\n        </li>\n\n        <li class=\"next\" ng-if=\"!$ctrl.hideUse\">\n          <a href=\"#\" ng-click=\"$ctrl.next(form_product)\">\n            <span ng-if=\"!$ctrl.isMobile\">\n              <i\n                class=\"fa fa-floppy-o\"\n                aria-hidden=\"true\"\n                style=\"margin-right: 7px\"\n              ></i>\n              {{\"Suivant\"|translate}}\n            </span>\n            <i class=\"fa fa-arrow-right\" aria-hidden=\"true\"></i>\n          </a>\n        </li>\n      </ul>\n\n      <!--p align=\"center\" ng-if=\"!$ctrl.disabledInput && $ctrl.selectedProduct\"> *\n        <span ng-if=\"$ctrl.isSaved\" translate>Données sauvegardées</span>\n        <span ng-if=\"!$ctrl.isSaved\" translate>Modifications non enregistrées</span>\n      </p-->\n    </nav>\n  </div>\n</div>\n"

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IdentificationController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _siret = __webpack_require__(142);
	
	var _siret2 = _interopRequireDefault(_siret);
	
	var _underscore = __webpack_require__(64);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var IdentificationController = exports.IdentificationController = function () {
	  IdentificationController.$inject = ['arrow', '$uibModal', '$log', 'LanguageService', 'IdentificationAPI', 'ProductAPI', '$location', 'screenSize', 'Modal', 'gettextCatalog', '$http'];
	  function IdentificationController(arrow, $uibModal, $log, LanguageService, IdentificationAPI, ProductAPI, $location, screenSize, Modal, gettextCatalog, $http) {
	    "ngInject";
	
	    var _this = this;
	
	    _classCallCheck(this, IdentificationController);
	
	    this.arrow = arrow;
	    var that = this;
	
	    this.isSiret = false;
	    this.isVatNumber = false;
	    this.Siret = _siret2.default;
	    this.$http = $http;
	
	    this.Modal = Modal;
	    this.gettextCatalog = gettextCatalog;
	
	    this.isMobile = screenSize.on("xs", function (match) {
	      that.isMobile = match;
	    });
	
	    this.title = {
	      fr: {
	        10000: "M.",
	        10001: "Mme"
	      },
	      en: {
	        10000: "Mr.",
	        10001: "Mrs"
	      }
	    };
	    this.IdentificationAPI = IdentificationAPI;
	    this.ProductAPI = ProductAPI;
	    this.contacts = [];
	    this.societies = [];
	
	    this.ls = LanguageService;
	    this.s = $location.search();
	    if (this.s.demand && parseInt(this.s.demand) && that.s.date) {
	      if (this.s.project && parseInt(this.s.project)) {
	        this.refreshClients().then(function () {
	          ProductAPI.getRestricted({
	            id: parseInt(that.s.demand)
	          }).$promise.then(function (demand) {
	            if (!demand || demand && demand.project.id != that.s.project) {
	              $location.path("/permission").search({});
	              return null;
	            }
	            that.demand = JSON.parse(JSON.stringify(demand));
	
	            that.disabledInput = false;
	            if (that.demand.status && parseInt(that.demand.status) % 10 !== 1) {
	              that.disabledInput = true;
	              that.arrow.disableConfirmation = true;
	              if (parseInt(that.demand.status) % 10 === 3) {
	                that.blockedInput = true;
	              }
	            }
	
	            var dateAmended = new Date(that.demand.dateAmended).getTime();
	            if (!that.disabledInput && that.s.date != dateAmended) {
	              that.arrow.goto(2);
	              return;
	            }
	
	            if (parseInt(that.demand.status) == 50 || parseInt(that.demand.status) == 60 || parseInt(that.demand.status) == 70 || parseInt(that.demand.status) == 74 || parseInt(that.demand.status) == 80 || parseInt(that.demand.status) == 90) {
	              that.arrow.goto(4, _this.s.project, that.demand.id);
	            }
	
	            that.loadClients();
	            return null;
	          }).catch(function () {
	            $location.path("/permission");
	            return null;
	          });
	        });
	      } else {
	        arrow.goto(1);
	      }
	    } else {
	      arrow.goto(2);
	    }
	
	    this.animationsEnabled = true;
	    this.open = function (form, action, type) {
	      var data = null;
	      if (action == "update") {
	        var tCap = type.replace(/\b\w/g, function (l) {
	          return l.toUpperCase();
	        });
	        data = that[form + tCap];
	      }
	      if (type == "address") {
	        data = data || {};
	        if (that[form + "Society"]) {
	          data.clientId = that[form + "Society"].id;
	        } else if (that[form + "Contact"] && that[form + "Contact"].privateIndividual) {
	          data.isPriviteAndNoSociety = true;
	          data.contactId = that[form + "Contact"].id;
	        }
	      }
	      var modalInstance = $uibModal.open({
	        windowClass: "modal-warning",
	        animation: that.animationsEnabled,
	        ariaLabelledBy: "modal-title",
	        ariaDescribedBy: "modal-body",
	        component: "client",
	        size: "lg",
	        resolve: {
	          parameters: function parameters() {
	            return {
	              action: action,
	              type: type,
	              data: data,
	              userId: that.clients.userId
	            };
	          }
	        }
	      });
	
	      modalInstance.result.then(function (result) {
	        that.refreshClients().then(function () {
	          if (result) {
	            if (result.contact) {
	              that[form + "Contact"] = _underscore2.default.findWhere(that.contacts, {
	                id: result.contact
	              });
	            }
	            if (result.society) {
	              that[form + "Society"] = _underscore2.default.findWhere(that.societies, {
	                id: result.society
	              });
	            }
	            if (result.address) {
	              that[form + "Society"] = _underscore2.default.findWhere(that.societies, {
	                id: that[form + "Society"].id
	              }) || null;
	              var list = that[form + "Society"].address || [];
	              that[form + "Address"] = _underscore2.default.findWhere(list, {
	                id: result.address
	              });
	            }
	          }
	          that.loadLocalClient();
	        });
	      }, function () {});
	    };
	  }
	
	  _createClass(IdentificationController, [{
	    key: "contactChanged",
	    value: function contactChanged(form) {
	      var that = this;
	      if (that[form + "Contact"] && that[form + "Contact"].privateIndividual) {
	        var societyId = that[form + "Contact"].societyId;
	        if (societyId) {
	          that[form + "Society"] = _underscore2.default.findWhere(that.societies, { id: societyId }) || null;
	
	          if (that[form + "Society"]) {
	            var society = that[form + "Society"];
	            that[form + "Address"] = society.address && society.address.length > 0 ? society.address[0] : null;
	          }
	        } else {
	          that[form + "Society"] = null;
	          that[form + "Adress"] = null;
	        }
	      }
	    }
	  }, {
	    key: "societyChanged",
	    value: function societyChanged(addressName, society, societyName) {
	      if (society) {
	        this[addressName] = society.address && society.address.length > 0 ? society.address[0] : null;
	        this.checkSiret(society.siret, societyName);
	        this.checkVatNumber(society.vatNumber, societyName);
	      }
	    }
	  }, {
	    key: "checkSiret",
	    value: function checkSiret(siret, society) {
	      var that = this;
	      this[society].isValidSiret = false;
	
	      if (siret) {
	        siret = siret.trim();
	        siret = siret.replace(/\s/g, "");
	        siret = siret.replace(/[^0-9]/g, "");
	        if (this.Siret.isSIRET(siret)) {
	          return this.IdentificationAPI.checkSiret({
	            siret: siret
	          }).$promise.then(function (resp) {
	            resp = JSON.parse(JSON.stringify(resp));
	            if (resp && resp.forceSiret) {
	              that[society].isValidSiret = true;
	            }
	            if (resp && resp.etablissement) {
	              that[society].isValidSiret = true;
	            }
	          }).catch(function (err) {});
	        }
	      }
	    }
	  }, {
	    key: "checkVatNumber",
	    value: function checkVatNumber(vatNumber, society) {
	      var that = this;
	      this[society].isValidVatNumber = false;
	      if (vatNumber) {
	        vatNumber = vatNumber.trim().toUpperCase();
	        vatNumber = vatNumber.replace(/\s/g, "");
	        vatNumber = vatNumber.replace(/[^a-zA-Z0-9]/g, "");
	        if (vatNumber.length >= 10) {
	          return this.IdentificationAPI.checkVatNumber({
	            countryCode: vatNumber.substring(0, 2),
	            vatNumber: vatNumber.substring(2)
	          }).$promise.then(function (resp) {
	            resp = JSON.parse(JSON.stringify(resp));
	            if (resp && resp.valid) {
	              that[society].isValidVatNumber = true;
	            }
	          }).catch(function (err) {});
	        }
	      }
	    }
	  }, {
	    key: "refreshClients",
	    value: function refreshClients() {
	      var that = this;
	      return this.IdentificationAPI.getClients().$promise.then(function (result) {
	        that.clients = JSON.parse(JSON.stringify(result));
	        if (result) {
	          that.owner = that.clients.owner;
	          that.contacts = that.clients.contacts;
	          that.societies = that.clients.societies;
	        }
	        return;
	      }).catch(function () {
	        console.log("Error on get clients");
	        return;
	      });
	    }
	  }, {
	    key: "loadClients",
	    value: function loadClients() {
	      var that = this;
	      that.mainIsInvoice = false;
	      that.mainIsFinal = true;
	      that.finalIsInvoice = false;
	
	      var dContact = that.owner ? _underscore2.default.findWhere(that.contacts, {
	        id: that.owner.id
	      }) : null;
	      var dSociety = null;
	      if (that.clients.latestSocietyId) {
	        dSociety = _underscore2.default.findWhere(that.societies, {
	          id: that.clients.latestSocietyId
	        }) || null;
	      }
	      if (!dSociety) {
	        dSociety = that.owner && that.owner.society ? _underscore2.default.findWhere(that.societies, {
	          id: that.owner.society.id
	        }) : null;
	      }
	
	      var dAddress = dSociety && dSociety.address ? dSociety.address[0] : null;
	
	      that.mainIsFinal = that.demand.mainIsFinal;
	      that.mainIsInvoice = that.demand.mainIsInvoice;
	      that.finalIsInvoice = that.demand.finalIsInvoice;
	
	      that.mainContact = that.demand.contactIdMain ? _underscore2.default.findWhere(that.contacts, {
	        id: that.demand.contactIdMain
	      }) : dContact;
	      that.finalContact = that.demand.contactIdFinal ? _underscore2.default.findWhere(that.contacts, {
	        id: that.demand.contactIdFinal
	      }) : null;
	      that.invoiceContact = that.demand.contactIdInvoice ? _underscore2.default.findWhere(that.contacts, {
	        id: that.demand.contactIdInvoice
	      }) : null;
	
	      that.mainSociety = that.demand.societyIdMain ? _underscore2.default.findWhere(that.societies, {
	        id: that.demand.societyIdMain
	      }) : dSociety;
	      that.finalSociety = that.demand.societyIdFinal ? _underscore2.default.findWhere(that.societies, {
	        id: that.demand.societyIdFinal
	      }) : null;
	      that.invoiceSociety = that.demand.societyIdInvoice ? _underscore2.default.findWhere(that.societies, {
	        id: that.demand.societyIdInvoice
	      }) : null;
	
	      that.mainAddress = that.demand.addressIdMain && that.mainSociety && that.mainSociety.address ? _underscore2.default.findWhere(that.mainSociety.address, {
	        id: that.demand.addressIdMain
	      }) : dAddress;
	      that.finalAddress = that.demand.addressIdFinal && that.finalSociety && that.finalSociety.address ? _underscore2.default.findWhere(that.finalSociety.address, {
	        id: that.demand.addressIdFinal
	      }) : null;
	      that.invoiceAddress = that.demand.addressIdInvoice && that.invoiceSociety && that.invoiceSociety.address ? _underscore2.default.findWhere(that.invoiceSociety.address, {
	        id: that.demand.addressIdInvoice
	      }) : null;
	
	      if (that.mainIsFinal) {
	        that.finalContact = that.mainContact;
	        that.finalSociety = that.mainSociety;
	        that.finalAddress = that.mainAddress;
	      }
	      if (that.mainIsInvoice) {
	        that.invoiceContact = that.mainContact;
	        that.invoiceSociety = that.mainSociety;
	        that.invoiceAddress = that.mainAddress;
	      }
	      if (!that.mainIsInvoice && that.finalIsInvoice) {
	        that.invoiceContact = that.finalContact;
	        that.invoiceSociety = that.finalSociety;
	        that.invoiceAddress = that.finalAddress;
	      }
	      that.checkAllSiretAndVatNumberValid();
	    }
	  }, {
	    key: "enableChange",
	    value: function enableChange() {
	      var that = this;
	      if (this.demand.status) {
	        var status = parseInt(this.demand.status);
	        var demand = JSON.parse(JSON.stringify(this.demand));
	        demand.status = status - status % 10 + 1;
	        this.ProductAPI.changeStatus(demand).$promise.then(function () {
	          that.demand.status = demand.status;
	          that.disabledInput = false;
	        });
	      }
	    }
	  }, {
	    key: "prev",
	    value: function prev(form) {
	      this.submitted = true;
	      if (this.demand.id) {
	        if (this.disabledInput) {
	          this.arrow.goto(2, this.s.project, this.s.demand);
	        } else {
	          var toPage = 2;
	          this.save(true, toPage);
	        }
	      }
	    }
	  }, {
	    key: "isSiretAndVatNumberValid",
	    value: function isSiretAndVatNumberValid() {
	      return !(this.invoiceSociety.isFrenchRegisteredCompany == null || this.invoiceSociety.hasVatNumber == null || this.mainSociety && this.mainSociety.isFrenchRegisteredCompany && !this.mainSociety.isValidSiret || this.invoiceSociety && this.invoiceSociety.isFrenchRegisteredCompany && !this.invoiceSociety.isValidSiret || this.finalSociety && this.finalSociety.isFrenchRegisteredCompany && !this.finalSociety.isValidSiret || this.mainSociety && this.mainSociety.hasVatNumber && !this.mainSociety.isFrenchRegisteredCompany && !this.mainSociety.isValidVatNumber || this.invoiceSociety && this.invoiceSociety.hasVatNumber && !this.invoiceSociety.isFrenchRegisteredCompany && !this.invoiceSociety.isValidVatNumber || this.finalSociety && this.finalSociety.hasVatNumber && !this.finalSociety.isFrenchRegisteredCompany && !this.finalSociety.isValidVatNumber);
	    }
	  }, {
	    key: "clientChanged",
	    value: function clientChanged() {
	      var that = this;
	
	
	      if (that.mainIsFinal) {
	        that.finalContact = that.mainContact;
	        that.finalSociety = that.mainSociety;
	        that.finalAddress = that.mainAddress;
	        that.finalIsInvoice = false;
	      }
	      if (that.mainIsInvoice) {
	        that.invoiceContact = that.mainContact;
	        that.invoiceSociety = that.mainSociety;
	        that.invoiceAddress = that.mainAddress;
	      }
	      if (!that.mainIsInvoice && that.finalIsInvoice) {
	        that.invoiceContact = that.finalContact;
	        that.invoiceSociety = that.finalSociety;
	        that.invoiceAddress = that.finalAddress;
	      }
	      that.checkAllSiretAndVatNumberValid();
	    }
	  }, {
	    key: "checkAllSiretAndVatNumberValid",
	    value: function checkAllSiretAndVatNumberValid() {
	      var that = this;
	      if (that.mainSociety) {
	        that.checkSiret(that.mainSociety.siret, "mainSociety");
	        that.checkVatNumber(that.mainSociety.vatNumber, "mainSociety");
	      }
	      if (that.finalSociety) {
	        that.checkSiret(that.finalSociety.siret, "finalSociety");
	        that.checkVatNumber(that.finalSociety.vatNumber, "finalSociety");
	      }
	      if (that.invoiceSociety) {
	        that.checkSiret(that.invoiceSociety.siret, "invoiceSociety");
	        that.checkVatNumber(that.invoiceSociety.vatNumber, "invoiceSociety");
	      }
	    }
	  }, {
	    key: "next",
	    value: function next(form) {
	      this.submitted = true;
	      if (this.demand.id && form.$valid && this.isSiretAndVatNumberValid()) {
	        if (this.disabledInput) {
	          this.arrow.goto(4, this.s.project, this.s.demand);
	        } else {
	          this.save(true);
	        }
	      }
	    }
	  }, {
	    key: "save",
	    value: function save(isFull, page) {
	      var that = this;
	      this.ProductAPI.manageClient({
	        id: that.demand.id,
	        mainIsFinal: that.mainIsFinal,
	        mainIsInvoice: that.mainIsInvoice,
	        finalIsInvoice: that.finalIsInvoice,
	
	        contactIdMain: that.mainContact ? that.mainContact.id : null,
	        societyIdMain: that.mainSociety ? that.mainSociety.id : null,
	        addressIdMain: that.mainAddress ? that.mainAddress.id : null,
	
	        contactIdFinal: that.finalContact ? that.finalContact.id : null,
	        societyIdFinal: that.finalSociety ? that.finalSociety.id : null,
	        addressIdFinal: that.finalAddress ? that.finalAddress.id : null,
	
	        contactIdInvoice: that.invoiceContact ? that.invoiceContact.id : null,
	        societyIdInvoice: that.invoiceSociety ? that.invoiceSociety.id : null,
	        addressIdInvoice: that.invoiceAddress ? that.invoiceAddress.id : null
	      }).$promise.then(function (_demand) {
	        var amendedDate = new Date(_demand.dateAmended).getTime();
	        if (isFull) {
	          page = page >= 0 ? page : 4;
	          that.arrow.goto(page, that.s.project, that.s.demand, false, {
	            date: amendedDate
	          });
	        } else {
	          that.Modal.confirm.info(function () {})(that.gettextCatalog.getString("Sauvegarde"), that.gettextCatalog.getString("Vos données ont bien été sauvegardées"), "OK", "primary");
	        }
	        return null;
	      }).catch(function (err) {
	        console.log(err);
	        console.log("---->Error on try to save");
	        return null;
	      });
	    }
	  }, {
	    key: "loadLocalClient",
	    value: function loadLocalClient() {
	      var that = this;
	      that.mainContact = that.mainContact ? _underscore2.default.findWhere(that.contacts, {
	        id: that.mainContact.id
	      }) : null;
	      that.finalContact = that.finalContact ? _underscore2.default.findWhere(that.contacts, {
	        id: that.finalContact.id
	      }) : null;
	      that.invoiceContact = that.invoiceContact ? _underscore2.default.findWhere(that.contacts, {
	        id: that.invoiceContact.id
	      }) : null;
	
	      that.mainSociety = that.mainSociety ? _underscore2.default.findWhere(that.societies, {
	        id: that.mainSociety.id
	      }) : null;
	      that.finalSociety = that.finalSociety ? _underscore2.default.findWhere(that.societies, {
	        id: that.finalSociety.id
	      }) : null;
	      that.invoiceSociety = that.invoiceSociety ? _underscore2.default.findWhere(that.societies, {
	        id: that.invoiceSociety.id
	      }) : null;
	
	      that.mainAddress = that.mainAddress && that.mainSociety && that.mainSociety.address ? _underscore2.default.findWhere(that.mainSociety.address, {
	        id: that.mainAddress.id
	      }) : null;
	      that.finalAddress = that.finalAddress && that.finalSociety && that.finalSociety.address ? _underscore2.default.findWhere(that.finalSociety.address, {
	        id: that.finalAddress.id
	      }) : null;
	      that.invoiceAddress = that.invoiceAddress && that.invoiceSociety && that.invoiceSociety.address ? _underscore2.default.findWhere(that.invoiceSociety.address, {
	        id: that.invoiceAddress.id
	      }) : null;
	
	      if (that.mainIsFinal) {
	        that.finalContact = that.mainContact;
	        that.finalSociety = that.mainSociety;
	        that.finalAddress = that.mainAddress;
	        that.finalIsInvoice = false;
	      }
	      if (that.mainIsInvoice) {
	        that.invoiceContact = that.mainContact;
	        that.invoiceSociety = that.mainSociety;
	        that.invoiceAddress = that.mainAddress;
	      }
	      if (!that.mainIsInvoice && that.finalIsInvoice) {
	        that.invoiceContact = that.finalContact;
	        that.invoiceSociety = that.finalSociety;
	        that.invoiceAddress = that.finalAddress;
	      }
	      that.checkAllSiretAndVatNumberValid();
	    }
	  }]);
	
	  return IdentificationController;
	}();
	
	exports.default = angular.module("dalApp.permission.identification", []).component("identification", {
	  template: __webpack_require__(143),
	  controller: IdentificationController
	}).name;

/***/ }),
/* 142 */
/***/ (function(module, exports) {

	var isSIRET = function(siret){
	    return verify(siret,14);
	}
	
	var isSIREN = function(siren){
	    return verify(siren,9)
	}
	
	function verify(number, size){
	    if (isNaN(number) || number.length!=size) return false;
	    var bal = 0;
	    var total = 0;
	    for (var i=size-1; i>=0; i--){
	        var step = (number.charCodeAt(i)-48)*(bal+1);
	        /*if (step>9) { step -= 9; }
	         total += step;*/
	        total += (step>9)?step-9:step;
	        bal = 1-bal;
	    }
	    return (total%10==0)?true:false;
	}
	
	module.exports = isSIRET;
	module.exports.isSIRET = isSIRET;
	module.exports.isSIREN = isSIREN;

/***/ }),
/* 143 */
/***/ (function(module, exports) {

	module.exports = "<form class=\"form-horizontal\" name=\"form_ident\">\n  <div class=\"panel panel-default permission-panel\">\n    <div class=\"panel-body\">\n      <h4 translate>Qui êtes-vous?</h4>\n      <br />\n      <fieldset ng-if=\"!$ctrl.owner\">\n        <div class=\"form-group text-center\">\n          <button\n            type=\"button\"\n            class=\"btn btn-primary btn-lg\"\n            ng-click=\"$ctrl.open('main','create','full')\"\n            ng-disabled=\"$ctrl.disabledInput\"\n          >\n            <i class=\"fa fa-file-text-o\" aria-hidden=\"true\"></i> {{\"Créer une\n            fiche client\"|translate}}\n          </button>\n        </div>\n      </fieldset>\n\n      <fieldset\n        ng-if=\"$ctrl.owner || ($ctrl.contacts && $ctrl.contacts.length>0)\n      || ($ctrl.societies && $ctrl.societies.length>0)\"\n      >\n        <div\n          class=\"form-group\"\n          ng-class=\"{'has-error': form_ident.mainContact.$invalid && $ctrl.submitted }\"\n        >\n          <label class=\"control-label col-sm-2\" for=\"mainContact\"\n            >{{\"Contact\"|translate}} :</label\n          >\n          <div class=\"col-sm-10\">\n            <div class=\"col-xs-7 col-sub\">\n              <select\n                class=\"form-control\"\n                ng-disabled=\"$ctrl.disabledInput\"\n                ng-model=\"$ctrl.mainContact\"\n                name=\"mainContact\"\n                required\n                ng-change=\"$ctrl.contactChanged('main')\"\n              >\n                <option\n                  ng-repeat=\"contact in $ctrl.contacts\"\n                  ng-value=\"contact\"\n                >\n                  {{$ctrl.title[$ctrl.ls.lang][contact.title]+'\n                  '+contact.firstname+' '+contact.lastname}}\n                </option>\n              </select>\n              <div ng-if=\"$ctrl.mainContact.privateIndividual\">\n                <i>({{\"Particulier\"|translate}})</i>\n              </div>\n            </div>\n\n            <div class=\"col-xs-5 col-sub\">\n              <button\n                type=\"button\"\n                class=\"btn btn-primary\"\n                ng-if=\"!$ctrl.disabledInput\"\n                ng-click=\"$ctrl.open('main','create','contact')\"\n              >\n                <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\n                {{\"Créer\"|translate}}\n              </button>\n              <button\n                type=\"button\"\n                class=\"btn btn-success\"\n                ng-if=\"!$ctrl.disabledInput\"\n                ng-click=\"$ctrl.open('main','update','contact')\"\n                ng-if=\"$ctrl.mainContact\"\n              >\n                <i class=\"fa fa-eye\" aria-hidden=\"true\"></i>\n                {{\"Détails\"|translate}}\n              </button>\n            </div>\n          </div>\n        </div>\n\n        <div\n          class=\"form-group\"\n          ng-class=\"{'has-error': (form_ident.mainSociety.$invalid && $ctrl.submitted)\n        || $ctrl.mainSociety && (\n          $ctrl.mainSociety.isFrenchRegisteredCompany==null ||\n          $ctrl.mainSociety.hasVatNumber==null ||\n          ($ctrl.mainSociety.isFrenchRegisteredCompany && !$ctrl.mainSociety.isValidSiret) ||\n          ($ctrl.mainSociety.isFrenchRegisteredCompany==false && $ctrl.mainSociety.hasVatNumber && !$ctrl.mainSociety.isValidVatNumber)              \n        )}\"\n          ng-if=\"!$ctrl.mainContact.privateIndividual\"\n        >\n          <label class=\"control-label col-sm-2\" for=\"mainSociety\"\n            >{{\"Société\"|translate}} :</label\n          >\n          <div class=\"col-sm-10\">\n            <div class=\"col-xs-7 col-sub\">\n              <select\n                class=\"form-control\"\n                ng-disabled=\"$ctrl.disabledInput\"\n                ng-model=\"$ctrl.mainSociety\"\n                name=\"mainSociety\"\n                required\n                ng-change=\"$ctrl.societyChanged('mainAddress', $ctrl.mainSociety, 'mainSociety')\"\n              >\n                <option\n                  ng-repeat=\"society in $ctrl.societies\"\n                  ng-value=\"society\"\n                >\n                  {{society.name}}\n                </option>\n              </select>\n            </div>\n            <div class=\"col-xs-5 col-sub\">\n              <button\n                type=\"button\"\n                class=\"btn btn-primary\"\n                ng-if=\"!$ctrl.disabledInput\"\n                ng-click=\"$ctrl.open('main','create','society')\"\n              >\n                <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\n                {{\"Créer\"|translate}}\n              </button>\n              <button\n                type=\"button\"\n                class=\"btn btn-success\"\n                ng-if=\"!$ctrl.disabledInput\"\n                ng-click=\"$ctrl.open('main','update','society')\"\n                ng-if=\"$ctrl.mainSociety\"\n              >\n                <i class=\"fa fa-eye\" aria-hidden=\"true\"></i>\n                {{\"Détails\"|translate}}\n              </button>\n            </div>\n          </div>\n          <div\n            class=\"col-sm-offset-2 col-sm-10 error-block\"\n            ng-if=\"$ctrl.mainSociety && (\n              $ctrl.mainSociety.isFrenchRegisteredCompany==null ||\n              $ctrl.mainSociety.hasVatNumber==null ||\n              ($ctrl.mainSociety.isFrenchRegisteredCompany && !$ctrl.mainSociety.isValidSiret) ||\n              ($ctrl.mainSociety.isFrenchRegisteredCompany==false && $ctrl.mainSociety.hasVatNumber && !$ctrl.mainSociety.isValidVatNumber)              \n            )\"\n          >\n            <i class=\"fa fa-warning\" aria-hidden=\"true\"></i>\n            <span translate\n              >Certains champs obligatoires ne sont pas correctement\n              remplis.</span\n            >\n            <button\n              type=\"button\"\n              class=\"btn btn-success btn-xs\"\n              ng-if=\"!$ctrl.disabledInput\"\n              ng-click=\"$ctrl.open('main','update','society')\"\n              ng-if=\"$ctrl.mainSociety\"\n            >\n              {{\"Modifier\"|translate}}\n            </button>\n          </div>\n          <!-- <div class=\"col-sm-offset-2 col-sm-10 error-block\"\n            ng-if=\"$ctrl.mainSociety && $ctrl.mainSociety.isFrenchRegisteredCompany && !$ctrl.mainSociety.isValidSiret\">\n            <i class=\"fa fa-warning\" aria-hidden=\"true\"></i>\n            <span ng-if=\"$ctrl.mainSociety.isValidSiret\" translate> SIRET non valide</span>\n            <span ng-if=\"!$ctrl.mainSociety.isValidSiret\" translate>Veuillez saisir un numéro de SIRET</span>\n            <button type=\"button\" class=\"btn btn-success btn-xs\" ng-if=\"!$ctrl.disabledInput\"\n              ng-click=\"$ctrl.open('main','update','society')\" ng-if=\"$ctrl.mainSociety\">\n              {{\"Modifier\"|translate}}\n            </button>\n          </div>\n          <div class=\"col-sm-offset-2 col-sm-10 error-block\"\n            ng-if=\"$ctrl.mainSociety && $ctrl.mainSociety.hasVatNumber && !$ctrl.mainSociety.isValidVatNumber\">\n            <i class=\"fa fa-warning\" aria-hidden=\"true\"></i>\n            <span ng-if=\"$ctrl.mainSociety.isValidVatNumber\" translate>\n              Numéro de TVA intracommunautaire non valide\n            </span>\n            <span ng-if=\"!$ctrl.mainSociety.isValidVatNumber\" translate>\n              Veuillez saisir un numéro de TVA intracommunautaire\n            </span>\n            <button type=\"button\" class=\"btn btn-success btn-xs\" ng-if=\"!$ctrl.disabledInput\"\n              ng-click=\"$ctrl.open('main','update','society')\" ng-if=\"$ctrl.mainSociety\">\n              {{\"Modifier\"|translate}}\n            </button>\n          </div> -->\n        </div>\n\n        <div\n          class=\"form-group\"\n          ng-class=\"{'has-error': form_ident.mainAddress.$invalid && $ctrl.submitted }\"\n          ng-if=\"$ctrl.mainSociety.address || $ctrl.mainContact.privateIndividual\"\n        >\n          <label class=\"control-label col-sm-2\" for=\"mainAddress\"\n            >{{\"Adresse\"|translate}} :</label\n          >\n          <div class=\"col-sm-10\">\n            <div class=\"col-xs-7 col-sub\">\n              <select\n                class=\"form-control\"\n                ng-disabled=\"$ctrl.disabledInput\"\n                ng-model=\"$ctrl.mainAddress\"\n                name=\"mainAddress\"\n                required\n              >\n                <option\n                  ng-repeat=\"address in $ctrl.mainSociety.address\"\n                  ng-value=\"address\"\n                >\n                  {{address.label}}\n                </option>\n              </select>\n            </div>\n            <div class=\"col-xs-5 col-sub\">\n              <button\n                type=\"button\"\n                class=\"btn btn-primary\"\n                ng-if=\"!$ctrl.disabledInput\"\n                ng-click=\"$ctrl.open('main','create','address')\"\n              >\n                <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\n                {{\"Créer\"|translate}}\n              </button>\n              <button\n                type=\"button\"\n                class=\"btn btn-success\"\n                ng-if=\"!$ctrl.disabledInput\"\n                ng-click=\"$ctrl.open('main','update','address')\"\n                ng-if=\"$ctrl.mainAddress\"\n              >\n                <i class=\"fa fa-eye\" aria-hidden=\"true\"></i>\n                {{\"Détails\"|translate}}\n              </button>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"form-group\">\n          <div class=\"col-sm-offset-2 col-sm-10\">\n            <input\n              type=\"checkbox\"\n              class=\"form-check-input\"\n              ng-disabled=\"$ctrl.disabledInput\"\n              ng-model=\"$ctrl.mainIsFinal\"\n              name=\"mainIsFinal\"\n              ng-change=\"$ctrl.clientChanged()\"\n            />\n            <label for=\"mainIsFinal\"\n              ><b translate\n                >Utiliser mes informations pour l'autorisation</b\n              ></label\n            >\n          </div>\n        </div>\n\n        <div class=\"form-group\">\n          <div class=\"col-sm-offset-2 col-sm-10\">\n            <input\n              type=\"checkbox\"\n              class=\"form-check-input\"\n              ng-disabled=\"$ctrl.disabledInput\"\n              ng-model=\"$ctrl.mainIsInvoice\"\n              ng-change=\"$ctrl.clientChanged()\"\n            />\n            <b translate>Utiliser mes informations pour la facturation</b>\n            <a\n              href=\"/assets/documents/Tarifs_ADAGP.pdf\"\n              target=\"_blank\"\n              style=\"margin-left: 10px\"\n            >\n              <i class=\"fa fa-file-pdf-o\" aria-hidden=\"true\"></i>\n              Tarifs généraux\n            </a>\n            <p ng-if=\"$ctrl.mainIsInvoice\" style=\"color: red\">\n              <span ng-if=\"$ctrl.ls.lang =='fr'\">\n                Attention, merci de noter que les factures seront adressées à la\n                personne physique ou morale renseignée ci-dessus qui sera dès\n                lors tenue de les régler. Dans l’éventualité où le destinataire\n                de la facture serait différent du bénéficiaire de\n                l’autorisation, ce dernier ne pourra en aucune manière invoquer\n                le bénéfice de l’autorisation en l’absence de règlement des\n                factures\n              </span>\n              <span ng-if=\"$ctrl.ls.lang !='fr'\">\n                Attention, please note that invoices will be sent to the person\n                or company mentioned above who will then be required to pay\n                them. In the event that the recipient of the invoice is\n                different from the beneficiary of the authorization, the latter\n                will not be able to invoke the benefit of the authorization in\n                the absence of payment of the invoices.\n              </span>\n            </p>\n          </div>\n        </div>\n      </fieldset>\n\n      <!--++++++++++++++++++++++++FINAL++++++++++++++++++++++++++-->\n\n      <fieldset ng-if=\"!$ctrl.mainIsFinal\">\n        <div class=\"form-group\">\n          <legend class=\"text-center header\"></legend>\n        </div>\n        <h4 translate>A qui sera adressée l'autorisation?</h4>\n        <br />\n\n        <div\n          class=\"form-group\"\n          ng-class=\"{'has-error': form_ident.finalContact.$invalid && $ctrl.submitted }\"\n        >\n          <label class=\"control-label col-sm-2\" for=\"finalContact\"\n            >{{\"Contact\"|translate}} :</label\n          >\n          <div class=\"col-sm-10\">\n            <div class=\"col-xs-7 col-sub\">\n              <select\n                class=\"form-control\"\n                ng-disabled=\"$ctrl.disabledInput\"\n                ng-model=\"$ctrl.finalContact\"\n                name=\"finalContact\"\n                required\n                ng-change=\"$ctrl.contactChanged('final')\"\n              >\n                <option\n                  ng-repeat=\"contact in $ctrl.contacts\"\n                  ng-value=\"contact\"\n                >\n                  {{$ctrl.title[$ctrl.ls.lang][contact.title]+'\n                  '+contact.firstname+' '+contact.lastname}}\n                </option>\n              </select>\n              <div ng-if=\"$ctrl.finalContact.privateIndividual\">\n                <i>({{\"Particulier\"|translate}})</i>\n              </div>\n            </div>\n\n            <div class=\"col-xs-5 col-sub\">\n              <button\n                type=\"button\"\n                class=\"btn btn-primary\"\n                ng-if=\"!$ctrl.disabledInput\"\n                ng-click=\"$ctrl.open('final','create','contact')\"\n              >\n                <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\n                {{\"Créer\"|translate}}\n              </button>\n              <button\n                type=\"button\"\n                class=\"btn btn-success\"\n                ng-if=\"!$ctrl.disabledInput\"\n                ng-click=\"$ctrl.open('final','update','contact')\"\n                ng-if=\"$ctrl.finalContact\"\n              >\n                <i class=\"fa fa-eye\" aria-hidden=\"true\"></i>\n                {{\"Détails\"|translate}}\n              </button>\n            </div>\n          </div>\n        </div>\n\n        <div\n          class=\"form-group\"\n          ng-class=\"{'has-error': (form_ident.finalSociety.$invalid && $ctrl.submitted )\n        || $ctrl.finalSociety && (\n          $ctrl.finalSociety.isFrenchRegisteredCompany==null ||\n          $ctrl.finalSociety.hasVatNumber==null ||\n          ($ctrl.finalSociety.isFrenchRegisteredCompany && !$ctrl.finalSociety.isValidSiret) ||\n          ($ctrl.finalSociety.isFrenchRegisteredCompany==false && $ctrl.finalSociety.hasVatNumber && !$ctrl.finalSociety.isValidVatNumber)              \n        )}\"\n          ng-if=\"!$ctrl.finalContact.privateIndividual\"\n        >\n          <label class=\"control-label col-sm-2\" for=\"finalSociety\"\n            >{{\"Société\"|translate}} :</label\n          >\n          <div class=\"col-sm-10\">\n            <div class=\"col-xs-7 col-sub\">\n              <select\n                class=\"form-control\"\n                ng-disabled=\"$ctrl.disabledInput\"\n                ng-model=\"$ctrl.finalSociety\"\n                name=\"finalSociety\"\n                ng-required=\"true\"\n                ng-change=\"$ctrl.societyChanged('finalAddress', $ctrl.finalSociety, 'finalSociety')\"\n              >\n                <option\n                  ng-repeat=\"society in $ctrl.societies\"\n                  ng-value=\"society\"\n                >\n                  {{society.name}}\n                </option>\n              </select>\n            </div>\n            <div class=\"col-xs-5 col-sub\">\n              <button\n                type=\"button\"\n                class=\"btn btn-primary\"\n                ng-if=\"!$ctrl.disabledInput\"\n                ng-click=\"$ctrl.open('final','create','society')\"\n              >\n                <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\n                {{\"Créer\"|translate}}\n              </button>\n              <button\n                type=\"button\"\n                class=\"btn btn-success\"\n                ng-if=\"!$ctrl.disabledInput\"\n                ng-click=\"$ctrl.open('final','update','society')\"\n                ng-if=\"$ctrl.finalSociety\"\n              >\n                <i class=\"fa fa-eye\" aria-hidden=\"true\"></i>\n                {{\"Détails\"|translate}}\n              </button>\n            </div>\n          </div>\n          <div\n            class=\"col-sm-offset-2 col-sm-10 error-block\"\n            ng-if=\"$ctrl.finalSociety && (\n            $ctrl.finalSociety.isFrenchRegisteredCompany==null ||\n            $ctrl.finalSociety.hasVatNumber==null ||\n            ($ctrl.finalSociety.isFrenchRegisteredCompany && !$ctrl.finalSociety.isValidSiret) ||\n            ($ctrl.finalSociety.isFrenchRegisteredCompany==false && $ctrl.finalSociety.hasVatNumber && !$ctrl.finalSociety.isValidVatNumber)              \n          )\"\n          >\n            <i class=\"fa fa-warning\" aria-hidden=\"true\"></i>\n            <span translate\n              >Certains champs obligatoires ne sont pas correctement\n              remplis.</span\n            >\n            <button\n              type=\"button\"\n              class=\"btn btn-success btn-xs\"\n              ng-if=\"!$ctrl.disabledInput\"\n              ng-click=\"$ctrl.open('final','update','society')\"\n              ng-if=\"$ctrl.finalSociety\"\n            >\n              {{\"Modifier\"|translate}}\n            </button>\n          </div>\n          <!-- <div class=\"col-sm-offset-2 col-sm-10 error-block\"\n            ng-if=\"$ctrl.finalSociety && $ctrl.finalSociety.isFrenchRegisteredCompany && !$ctrl.finalSociety.isValidSiret\">\n            <i class=\"fa fa-warning\" aria-hidden=\"true\"></i>\n            <span ng-if=\"$ctrl.finalSociety.isValidSiret\" translate> SIRET non valide</span>\n            <span ng-if=\"!$ctrl.finalSociety.isValidSiret\" translate>Veuillez saisir un numéro de SIRET</span>\n            <button type=\"button\" class=\"btn btn-success btn-xs\" ng-if=\"!$ctrl.disabledInput\"\n              ng-click=\"$ctrl.open('final','update','society')\" ng-if=\"$ctrl.finalSociety\">\n              {{\"Modifier\"|translate}}\n            </button>\n          </div>\n          <div class=\"col-sm-offset-2 col-sm-10 error-block\"\n            ng-if=\"$ctrl.finalSociety && $ctrl.finalSociety.hasVatNumber && !$ctrl.finalSociety.isValidVatNumber\">\n            <i class=\"fa fa-warning\" aria-hidden=\"true\"></i>\n            <span ng-if=\"$ctrl.finalSociety.isValidVatNumber\" translate>\n              Numéro de TVA intracommunautaire non valide\n            </span>\n            <span ng-if=\"!$ctrl.finalSociety.isValidVatNumber\" translate>\n              Veuillez saisir un numéro de TVA intracommunautaire\n            </span>\n            <button type=\"button\" class=\"btn btn-success btn-xs\" ng-if=\"!$ctrl.disabledInput\"\n              ng-click=\"$ctrl.open('final','update','society')\" ng-if=\"$ctrl.finalSociety\">\n              {{\"Modifier\"|translate}}\n            </button>\n          </div> -->\n        </div>\n\n        <div\n          class=\"form-group\"\n          ng-class=\"{'has-error': form_ident.finalAddress.$invalid && $ctrl.submitted }\"\n          ng-if=\"$ctrl.finalSociety.address || $ctrl.finalContact.privateIndividual\"\n        >\n          <label class=\"control-label col-sm-2\" for=\"finalAddress\"\n            >{{\"Adresse\"|translate}} :</label\n          >\n          <div class=\"col-sm-10\">\n            <div class=\"col-xs-7 col-sub\">\n              <select\n                class=\"form-control\"\n                ng-disabled=\"$ctrl.disabledInput\"\n                ng-model=\"$ctrl.finalAddress\"\n                name=\"finalAddress\"\n                required\n              >\n                <option\n                  ng-repeat=\"address in $ctrl.finalSociety.address\"\n                  ng-value=\"address\"\n                >\n                  {{address.label}}\n                </option>\n              </select>\n            </div>\n            <div class=\"col-xs-5 col-sub\">\n              <button\n                type=\"button\"\n                class=\"btn btn-primary\"\n                ng-if=\"!$ctrl.disabledInput\"\n                ng-click=\"$ctrl.open('final','create','address')\"\n              >\n                <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\n                {{\"Créer\"|translate}}\n              </button>\n              <button\n                type=\"button\"\n                class=\"btn btn-success\"\n                ng-if=\"!$ctrl.disabledInput\"\n                ng-click=\"$ctrl.open('final','update','address')\"\n                ng-if=\"$ctrl.finalAddress\"\n              >\n                <i class=\"fa fa-eye\" aria-hidden=\"true\"></i>\n                {{\"Détails\"|translate}}\n              </button>\n            </div>\n          </div>\n        </div>\n        <div class=\"form-group\" ng-if=\"!$ctrl.mainIsInvoice\">\n          <div class=\"col-sm-offset-2 col-sm-10\">\n            <input\n              type=\"checkbox\"\n              class=\"form-check-input\"\n              ng-disabled=\"$ctrl.disabledInput\"\n              ng-model=\"$ctrl.finalIsInvoice\"\n              ng-change=\"$ctrl.clientChanged()\"\n            />\n            <b translate\n              >Utiliser les informations du bénéficiaire pour la facturation</b\n            >\n            <a\n              href=\"/assets/documents/Tarifs_ADAGP.pdf\"\n              target=\"_blank\"\n              style=\"margin-left: 10px\"\n            >\n              <i class=\"fa fa-file-pdf-o\" aria-hidden=\"true\"></i>\n              Tarifs généraux\n            </a>\n          </div>\n        </div>\n      </fieldset>\n\n      <!--++++++++++++++++++++++++INVOICE++++++++++++++++++++++++++-->\n      <fieldset ng-if=\"!$ctrl.mainIsInvoice && (!$ctrl.finalIsInvoice || $ctrl.mainIsFinal)\">\n        <div class=\"form-group\">\n          <legend class=\"text-center header\"></legend>\n        </div>\n        <h4 translate>A qui sera adressée la facture?</h4>\n        <a\n          href=\"/assets/documents/Tarifs_ADAGP.pdf\"\n          target=\"_blank\"\n          style=\"margin-left: 10px\"\n        >\n          <i class=\"fa fa-file-pdf-o\" aria-hidden=\"true\"></i>\n          Tarifs généraux\n        </a>\n        <br />\n\n        <div\n          class=\"form-group\"\n          ng-class=\"{'has-error': form_ident.invoiceContact.$invalid && $ctrl.submitted }\"\n        >\n          <label class=\"control-label col-sm-2\" for=\"invoiceContact\"\n            >{{\"Contact\"|translate}} :</label\n          >\n          <div class=\"col-sm-10\">\n            <div class=\"col-xs-7 col-sub\">\n              <select\n                class=\"form-control\"\n                ng-disabled=\"$ctrl.disabledInput\"\n                ng-model=\"$ctrl.invoiceContact\"\n                name=\"invoiceContact\"\n                required\n                ng-change=\"$ctrl.contactChanged('invoice')\"\n              >\n                <option\n                  ng-repeat=\"contact in $ctrl.contacts\"\n                  ng-value=\"contact\"\n                >\n                  {{$ctrl.title[$ctrl.ls.lang][contact.title]+'\n                  '+contact.firstname+' '+contact.lastname}}\n                </option>\n              </select>\n              <div ng-if=\"$ctrl.invoiceContact.privateIndividual\">\n                <i>({{\"Particulier\"|translate}})</i>\n              </div>\n            </div>\n            <div class=\"col-xs-5 col-sub\">\n              <button\n                type=\"button\"\n                class=\"btn btn-primary\"\n                ng-if=\"!$ctrl.disabledInput\"\n                ng-click=\"$ctrl.open('invoice','create','contact')\"\n              >\n                <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\n                {{\"Créer\"|translate}}\n              </button>\n              <button\n                type=\"button\"\n                class=\"btn btn-success\"\n                ng-if=\"!$ctrl.disabledInput\"\n                ng-click=\"$ctrl.open('invoice','update','contact')\"\n                ng-if=\"$ctrl.invoiceContact\"\n              >\n                <i class=\"fa fa-eye\" aria-hidden=\"true\"></i>\n                {{\"Détails\"|translate}}\n              </button>\n            </div>\n          </div>\n        </div>\n\n        <div\n          class=\"form-group\"\n          ng-class=\"{'has-error': (form_ident.invoiceSociety.$invalid && $ctrl.submitted)\n      ||$ctrl.invoiceSociety && (\n        $ctrl.invoiceSociety.isFrenchRegisteredCompany==null ||\n        $ctrl.invoiceSociety.hasVatNumber==null ||\n        ($ctrl.invoiceSociety.isFrenchRegisteredCompany && !$ctrl.invoiceSociety.isValidSiret) ||\n        ($ctrl.invoiceSociety.isFrenchRegisteredCompany==false && $ctrl.invoiceSociety.hasVatNumber && !$ctrl.invoiceSociety.isValidVatNumber)              \n      ) }\"\n          ng-if=\"!$ctrl.invoiceContact.privateIndividual\"\n        >\n          <label class=\"control-label col-sm-2\" for=\"invoiceSociety\"\n            >{{\"Société\"|translate}} :</label\n          >\n          <div class=\"col-sm-10\">\n            <div class=\"col-xs-7 col-sub\">\n              <select\n                class=\"form-control\"\n                ng-disabled=\"$ctrl.disabledInput\"\n                ng-model=\"$ctrl.invoiceSociety\"\n                name=\"invoiceSociety\"\n                required\n                ng-change=\"$ctrl.societyChanged('invoiceAddress', $ctrl.invoiceSociety, 'invoiceSociety')\"\n              >\n                <option\n                  ng-repeat=\"society in $ctrl.societies\"\n                  ng-value=\"society\"\n                >\n                  {{society.name}}\n                </option>\n              </select>\n            </div>\n            <div class=\"col-xs-5 col-sub\">\n              <button\n                type=\"button\"\n                class=\"btn btn-primary\"\n                ng-if=\"!$ctrl.disabledInput\"\n                ng-click=\"$ctrl.open('invoice','create','society')\"\n              >\n                <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\n                {{\"Créer\"|translate}}\n              </button>\n              <button\n                type=\"button\"\n                class=\"btn btn-success\"\n                ng-if=\"!$ctrl.disabledInput\"\n                ng-click=\"$ctrl.open('invoice','update','society')\"\n                ng-if=\"$ctrl.invoiceSociety\"\n              >\n                <i class=\"fa fa-eye\" aria-hidden=\"true\"></i>\n                {{\"Détails\"|translate}}\n              </button>\n            </div>\n          </div>\n          <div\n            class=\"col-sm-offset-2 col-sm-10 error-block\"\n            ng-if=\"$ctrl.invoiceSociety && (\n              $ctrl.invoiceSociety.isFrenchRegisteredCompany==null ||\n              $ctrl.invoiceSociety.hasVatNumber==null ||\n              ($ctrl.invoiceSociety.isFrenchRegisteredCompany && !$ctrl.invoiceSociety.isValidSiret) ||\n              ($ctrl.invoiceSociety.isFrenchRegisteredCompany==false && $ctrl.invoiceSociety.hasVatNumber && !$ctrl.invoiceSociety.isValidVatNumber)              \n            )\"\n          >\n            <i class=\"fa fa-warning\" aria-hidden=\"true\"></i>\n            <span translate\n              >Certains champs obligatoires ne sont pas correctement\n              remplis.</span\n            >\n            <button\n              type=\"button\"\n              class=\"btn btn-success btn-xs\"\n              ng-if=\"!$ctrl.disabledInput\"\n              ng-click=\"$ctrl.open('invoice','update','society')\"\n              ng-if=\"$ctrl.invoiceSociety\"\n            >\n              {{\"Modifier\"|translate}}\n            </button>\n          </div>\n          <!-- <div class=\"col-sm-offset-2 col-sm-10 error-block\"\n            ng-if=\"$ctrl.invoiceSociety && $ctrl.invoiceSociety.isFrenchRegisteredCompany && !$ctrl.invoiceSociety.isValidSiret\">\n            <i class=\"fa fa-warning\" aria-hidden=\"true\"></i>\n            <span ng-if=\"$ctrl.invoiceSociety.isValidSiret\" translate> SIRET non valide</span>\n            <span ng-if=\"!$ctrl.invoiceSociety.isValidSiret\" translate>Veuillez saisir un numéro de SIRET</span>\n            <button type=\"button\" class=\"btn btn-success btn-xs\" ng-if=\"!$ctrl.disabledInput\"\n              ng-click=\"$ctrl.open('invoice','update','society')\" ng-if=\"$ctrl.invoiceSociety\">\n              {{\"Modifier\"|translate}}\n            </button>\n          </div>\n          <div class=\"col-sm-offset-2 col-sm-10 error-block\"\n            ng-if=\"$ctrl.invoiceSociety && $ctrl.invoiceSociety.hasVatNumber && !$ctrl.invoiceSociety.isValidVatNumber\">\n            <i class=\"fa fa-warning\" aria-hidden=\"true\"></i>\n            <span ng-if=\"$ctrl.invoiceSociety.isValidVatNumber\" translate>\n              Numéro de TVA intracommunautaire non valide\n            </span>\n            <span ng-if=\"!$ctrl.invoiceSociety.isValidVatNumber\" translate>\n              Veuillez saisir un numéro de TVA intracommunautaire\n            </span>\n            <button type=\"button\" class=\"btn btn-success btn-xs\" ng-if=\"!$ctrl.disabledInput\"\n              ng-click=\"$ctrl.open('invoice','update','society')\" ng-if=\"$ctrl.invoiceSociety\">\n              {{\"Modifier\"|translate}}\n            </button>\n          </div> -->\n        </div>\n\n        <div\n          class=\"form-group\"\n          ng-class=\"{'has-error': form_ident.invoiceAddress.$invalid && $ctrl.submitted }\"\n          ng-if=\"$ctrl.invoiceSociety.address || $ctrl.invoiceContact.privateIndividual\"\n        >\n          <label class=\"control-label col-sm-2\" for=\"invoiceAddress\"\n            >{{\"Adresse\"|translate}} :</label\n          >\n          <div class=\"col-sm-10\">\n            <div class=\"col-xs-7 col-sub\">\n              <select\n                class=\"form-control\"\n                ng-disabled=\"$ctrl.disabledInput\"\n                ng-model=\"$ctrl.invoiceAddress\"\n                name=\"invoiceAddress\"\n                required\n              >\n                <option\n                  ng-repeat=\"address in $ctrl.invoiceSociety.address\"\n                  ng-value=\"address\"\n                >\n                  {{address.label}}\n                </option>\n              </select>\n            </div>\n            <div class=\"col-xs-5 col-sub\">\n              <button\n                type=\"button\"\n                class=\"btn btn-primary\"\n                ng-if=\"!$ctrl.disabledInput\"\n                ng-click=\"$ctrl.open('invoice','create','address')\"\n              >\n                <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\n                {{\"Créer\"|translate}}\n              </button>\n              <button\n                type=\"button\"\n                class=\"btn btn-success\"\n                ng-if=\"!$ctrl.disabledInput\"\n                ng-click=\"$ctrl.open('invoice','update','address')\"\n                ng-if=\"$ctrl.invoiceAddress\"\n              >\n                <i class=\"fa fa-eye\" aria-hidden=\"true\"></i>\n                {{\"Détails\"|translate}}\n              </button>\n            </div>\n          </div>\n        </div>\n      </fieldset>\n\n      <!--*****************PAGINATION*****************-->\n      <nav aria-label=\"Pagination\">\n        <p\n          ng-if=\"$ctrl.disabledInput && $ctrl.blockedInput\"\n          class=\"blocked-input-msg\"\n        >\n          <i class=\"fa fa-exclamation-triangle\" aria-hidden=\"true\"></i>\n          {{\"Votre demande est en cours de traitement, vous ne pouvez pas la\n          modifier pour le moment.\"|translate}}\n        </p>\n        <p\n          ng-if=\"$ctrl.demand && $ctrl.demand.dateValidated && $ctrl.demand.status && $ctrl.demand.status%10==1 \"\n          class=\"blocked-input-msg\"\n        >\n          <i class=\"fa fa-exclamation-triangle\" aria-hidden=\"true\"></i>\n          <span ng-if=\"$ctrl.ls.lang == 'fr'\">\n            ATTENTION, votre demande ne pourra pas être traitée tant que vous\n            n'aurez pas validé vos modifications (aller jusqu'à l'envoi de le\n            demande).\n          </span>\n          <span ng-if=\"$ctrl.ls.lang != 'fr'\">\n            WARNING, your request cannot be processed until you have validated\n            your changes (proceeding to submit the request).\n          </span>\n        </p>\n        <ul class=\"pager\">\n          <li class=\"previous\">\n            <a href=\"#\" ng-click=\"$ctrl.prev(form_ident)\">\n              <i class=\"fa fa-arrow-left\" aria-hidden=\"true\"></i>\n              <span ng-if=\"!$ctrl.isMobile\">\n                {{\"Précédent\"|translate}}\n                <i\n                  class=\"fa fa-floppy-o\"\n                  aria-hidden=\"true\"\n                  style=\"margin-left: 7px\"\n                ></i>\n              </span>\n            </a>\n          </li>\n          <li\n            ng-if=\"$ctrl.owner || ($ctrl.contacts && $ctrl.contacts.length>0)\n          || ($ctrl.societies && $ctrl.societies.length>0)\"\n            class=\"center\"\n          >\n            <a\n              href=\"#\"\n              class=\"warning\"\n              ng-click=\"$ctrl.enableChange()\"\n              ng-if=\"$ctrl.disabledInput && !$ctrl.blockedInput\"\n            >\n              {{\"Activer la modification\"|translate}}\n            </a>\n            <a\n              href=\"#\"\n              class=\"danger\"\n              ng-if=\"$ctrl.disabledInput && $ctrl.blockedInput\"\n              disabled\n            >\n              {{\"Demande verrouillée\"|translate}}\n            </a>\n            <a\n              href=\"#\"\n              class=\"primary\"\n              ng-click=\"$ctrl.save()\"\n              ng-if=\"!$ctrl.disabledInput\"\n            >\n              <i\n                class=\"fa fa-floppy-o\"\n                aria-hidden=\"true\"\n                style=\"margin-right: 7px\"\n              ></i>\n              {{\"Sauvegarder\"|translate}}\n            </a>\n          </li>\n          <li\n            class=\"next\"\n            ng-if=\"$ctrl.owner || ($ctrl.contacts && $ctrl.contacts.length>0)\n          || ($ctrl.societies && $ctrl.societies.length>0)\"\n          >\n            <a href=\"#\" ng-click=\"$ctrl.next(form_ident)\">\n              <i\n                class=\"fa fa-floppy-o\"\n                aria-hidden=\"true\"\n                style=\"margin-right: 7px\"\n              ></i>\n              <span ng-if=\"!$ctrl.isMobile\">{{\"Suivant\"|translate}} </span>\n              <i class=\"fa fa-arrow-right\" aria-hidden=\"true\"></i>\n            </a>\n          </li>\n        </ul>\n      </nav>\n      <!--*****************PAGINATION*****************-->\n    </div>\n  </div>\n</form>\n"

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ClientController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _underscore = __webpack_require__(64);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _siret = __webpack_require__(142);
	
	var _siret2 = _interopRequireDefault(_siret);
	
	var _countries = __webpack_require__(145);
	
	var _countries2 = _interopRequireDefault(_countries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var ClientController = exports.ClientController = function () {
	  ClientController.$inject = ['IdentificationAPI', 'gettextCatalog', '$http', 'localStorageService'];
	  function ClientController(IdentificationAPI, gettextCatalog, $http, localStorageService) {
	    "ngInject";
	
	    _classCallCheck(this, ClientController);
	
	    var that = this;
	    this.$http = $http;
	    this.IdentificationAPI = IdentificationAPI;
	    this.Siret = _siret2.default;
	    this.gettextCatalog = gettextCatalog;
	    this.localStorageService = localStorageService;
	
	    this.countries = _countries2.default;
	    this.categories = ["Agence de publicité", "Agence Photo / Photothèque", "Association", "Autre", "Avocat", "Banque", "Centre d'art", "Commissaire priseur", "Diffuseur", "Distributeur", "Editeur", "Fabricant", "Fondation", "FRAC", "Galerie", "Musée", "Notaire", "Presse", "Prestataire", "Producteur", "Professionnel du marché de l'art", "Société d'auteurs", "Université, école"];
	
	    this.$onInit = function () {
	      var parameters = that.resolve.parameters;
	      that.action = parameters.action;
	      that.type = parameters.type;
	      that.data = parameters.data;
	      that.userId = parameters.userId;
	      that.contact.privateIndividual = false;
	      that.enableSave = true;
	      that.isSiret = false;
	      that.isVatNumber = false;
	      that.importedAddress = null;
	      if (that.type === "contact") {
	        that.isContact = true;
	        that.title = this.gettextCatalog.getString("Fiche contact");
	        that.contact = JSON.parse(JSON.stringify(that.data));
	        if (that.contact && that.contact.createdBy && that.contact.createdBy != that.userId) {
	          that.enableSave = false;
	        }
	      } else if (that.type === "society") {
	        that.isSociety = true;
	        that.title = this.gettextCatalog.getString("Fiche société");
	        that.society = JSON.parse(JSON.stringify(that.data));
	        if (that.society && that.society.createdBy && that.society.createdBy != that.userId) {
	          that.enableSave = false;
	        }
	        if (this.action == "update") {
	          if (that.society.siret) {
	            that.checkSiret(true);
	            that.showSiretError = true;
	          } else {}
	
	          if (that.society.vatNumber) {
	            that.checkVatNumber();
	            that.showVatNumberError = true;
	          } else {}
	        }
	      } else if (that.type === "address") {
	        that.isAddress = true;
	        that.title = this.gettextCatalog.getString("Fiche adresse");
	        that.address = JSON.parse(JSON.stringify(that.data));
	        if (that.address && that.address.country) {
	          that.address.objCountry = _underscore2.default.findWhere(that.countries, {
	            nameFr: that.address.country
	          });
	        }
	        if (that.address && that.address.createdBy && that.address.createdBy != that.userId) {
	          that.enableSave = false;
	        }
	        var importedAddress = that.localStorageService.get("imported_address");
	        if (that.action == "create" && importedAddress) {
	          that.importAddress(importedAddress);
	          localStorage.removeItem("ls.imported_address");
	        }
	      } else if (that.type === "full") {
	        that.isFull = true;
	        that.title = this.gettextCatalog.getString("Fiche ");
	      }
	    };
	
	    this.cancel = function () {
	      this.dismiss({
	        $value: "On annule"
	      });
	    };
	    this.contact = {
	      type: "individual"
	    };
	  }
	
	  _createClass(ClientController, [{
	    key: "importAddress",
	    value: function importAddress(address) {
	      this.address.line1 = address.line1;
	      this.address.zip = address.zip;
	      this.address.city = address.city;
	      this.address.objCountry = _underscore2.default.findWhere(this.countries, { code: "FR" });
	      this.address.country = this.address.objCountry ? this.address.objCountry.nameFr : null;
	    }
	  }, {
	    key: "checkSiret",
	    value: function checkSiret(dontUseData) {
	      var _this = this;
	
	      var that = this;
	      this.isSiret = false;
	      that.importedAddress = null;
	      if (this.society.siret) {
	        this.society.siret = this.society.siret.trim();
	        this.society.siret = this.society.siret.replace(/\s/g, "");
	        this.society.siret = this.society.siret.replace(/[^0-9]/g, "");
	
	        if (this.Siret.isSIRET(this.society.siret)) {
	          return this.IdentificationAPI.checkSiret({
	            siret: this.society.siret
	          }).$promise.then(function (resp) {
	            resp = JSON.parse(JSON.stringify(resp));
	            if (resp && resp.forceSiret) {
	              _this.isSiret = true;
	            }
	            if (resp && resp.etablissement) {
	              _this.isSiret = true;
	              if (!dontUseData) {
	                var etablissement = resp.etablissement;
	                that.society.name = etablissement.uniteLegale.denominationUniteLegale;
	
	                var _address = etablissement.adresseEtablissement;
	                var line1 = "";
	                if (_address.numeroVoieEtablissement) {
	                  line1 += _address.numeroVoieEtablissement + " ";
	                }
	                if (_address.indiceRepetitionEtablissement) {
	                  line1 += _address.indiceRepetitionEtablissement + " ";
	                }
	                if (_address.typeVoieEtablissement) {
	                  line1 += _address.typeVoieEtablissement + " ";
	                }
	                if (_address.libelleVoieEtablissement) {
	                  line1 += _address.libelleVoieEtablissement + " ";
	                }
	                line1 = line1.trim();
	
	                that.importedAddress = {
	                  line1: line1,
	                  line2: _address.complementAdresseEtablissement,
	                  zip: _address.codePostalEtablissement,
	                  city: _address.libelleCommuneEtablissement
	                };
	                if (that.type == "full") {
	                  that.importAddress(that.importedAddress);
	                }
	              }
	            }
	          }).catch(function (err) {});
	        }
	      }
	    }
	  }, {
	    key: "checkVatNumber",
	    value: function checkVatNumber() {
	      var that = this;
	      this.isVatNumber = false;
	      if (this.society.vatNumber) {
	        this.society.vatNumber = this.society.vatNumber.trim().toUpperCase();
	        this.society.vatNumber = this.society.vatNumber.replace(/\s/g, "");
	        this.society.vatNumber = this.society.vatNumber.replace(/[^a-zA-Z0-9]/g, "");
	        if (this.society.vatNumber.length >= 10) {
	          return this.IdentificationAPI.checkVatNumber({
	            countryCode: this.society.vatNumber.substring(0, 2),
	            vatNumber: this.society.vatNumber.substring(2)
	          }).$promise.then(function (resp) {
	            resp = JSON.parse(JSON.stringify(resp));
	
	            if (resp.valid) {
	              that.isVatNumber = true;
	            }
	          }).catch(function (err) {});
	        }
	      }
	    }
	  }, {
	    key: "searchCountries",
	    value: function searchCountries(query) {
	      if (!query || String(query).length < 2) {
	        return [];
	      }
	      var q = String(query).toLowerCase();
	      return this.countries.filter(function (country) {
	        return country.nameFr.toLowerCase().indexOf(q) !== -1;
	      }).sort(function (a, b) {
	        var rank = function rank(name) {
	          return name.toLowerCase().indexOf(q) === 0 ? 0 : 1;
	        };
	        return rank(a.nameFr) - rank(b.nameFr) || a.nameFr.localeCompare(b.nameFr, "fr");
	      });
	    }
	  }, {
	    key: "countrySelected",
	    value: function countrySelected(objCountry) {
	      var match = objCountry && _underscore2.default.findWhere(this.countries, {
	        nameFr: objCountry.nameFr,
	        code: objCountry.code
	      });
	      if (!match) {
	        this.address.country = null;
	        this.address.objCountry = null;
	        return;
	      }
	      this.address.country = match.nameFr;
	      this.address.objCountry = match;
	    }
	  }, {
	    key: "clearCountry",
	    value: function clearCountry() {
	      this.address.objCountry = null;
	      this.address.country = null;
	    }
	  }, {
	    key: "save",
	    value: function save(form) {
	      if (this.contact) {
	        this.contact.privateIndividual = !!this.contact.privateIndividual;
	      }
	
	      if (this.society && !this.society.isFrenchRegisteredCompany) {
	        this.society.siret = null;
	      }
	      if (this.society && !this.society.hasVatNumber) {
	        this.society.vatNumber = null;
	      }
	
	      this.submitted = true;
	      if (form.$valid) {
	        if (this.action === "create" && this.type === "full") {
	          this.createClient();
	        } else if (this.action === "create" && this.type === "contact") {
	          var _data = JSON.parse(JSON.stringify(this.contact));
	          if (this.contact.privateIndividual) {
	            this.society = this.society || {};
	            this.society.name = this.contact.firstname + " " + this.contact.lastname;
	            this.society.hasVatNumber = false;
	            this.society.isFrenchRegisteredCompany = false;
	            _data.society = this.society;
	          }
	          this.api(this.IdentificationAPI.createContact, _data);
	        } else if (this.action === "create" && this.type === "society") {
	          if (this.importedAddress) {
	            this.localStorageService.set("imported_address", this.importedAddress);
	          }
	          this.api(this.IdentificationAPI.createSociety, this.society);
	        } else if (this.action === "create" && this.type === "address") {
	          this.api(this.IdentificationAPI.createAddress, this.address);
	        } else if (this.action === "update" && this.type === "contact") {
	          this.api(this.IdentificationAPI.updateContact, this.contact);
	        } else if (this.action === "update" && this.type === "society") {
	          this.api(this.IdentificationAPI.updateSociety, this.society);
	        } else if (this.action === "update" && this.type === "address") {
	          this.api(this.IdentificationAPI.updateAddress, this.address);
	        }
	      }
	    }
	  }, {
	    key: "delete",
	    value: function _delete() {
	      if (this.type === "contact") {
	        this.api(this.IdentificationAPI.deleteContact, this.contact);
	      } else if (this.type === "society") {
	        this.api(this.IdentificationAPI.deleteSociety, this.society);
	      } else if (this.type === "address") {
	        this.api(this.IdentificationAPI.deleteAddress, this.address);
	      }
	    }
	  }, {
	    key: "api",
	    value: function api(service, data) {
	      var _this2 = this;
	
	      var that = this;
	      service(data).$promise.then(function (response) {
	        var res = {};
	        if (response) {
	          response = JSON.parse(JSON.stringify(response));
	          if (_this2.action === "create" && _this2.type === "contact" && data.privateIndividual) {
	            res = {
	              contact: response.id,
	              society: response.societyId
	            };
	          } else if (_this2.action === "create" && _this2.type === "address" && data.isPriviteAndNoSociety) {
	            res = {
	              society: response.clientId,
	              address: response.id
	            };
	          } else {
	            res[that.type] = response.id;
	          }
	        }
	        that.close({
	          $value: res
	        });
	        return null;
	      }).catch(function (err) {
	        if (err.status == 403) {
	          that.isForbiddenOwnerDelete = true;
	        }
	
	        return;
	      });
	    }
	  }, {
	    key: "createClient",
	    value: function createClient() {
	      var _this3 = this;
	
	      var that = this;
	      if (this.contact.privateIndividual) {
	        var society = {
	          name: this.contact.firstname + " " + this.contact.lastname,
	          hasVatNumber: false,
	          isFrenchRegisteredCompany: false,
	
	          website: this.society && this.society.website ? this.society.website : null
	        };
	        this.society = society;
	      }
	      this.IdentificationAPI.createClient({
	        contact: that.contact,
	        society: that.society,
	        address: that.address,
	        isOwner: this.data ? this.data.isOwner : null
	      }).$promise.then(function (response) {
	        response = JSON.parse(JSON.stringify(response));
	        _this3.close({
	          $value: {
	            contact: response.id,
	            society: response.society.id,
	            address: response.society.address[0].id
	          }
	        });
	        return null;
	      }).catch(function () {
	        return;
	      });
	    }
	  }]);
	
	  return ClientController;
	}();
	
	exports.default = angular.module("dalApp.permission.client", []).component("client", {
	  template: __webpack_require__(146),
	  controller: ClientController,
	  bindings: {
	    resolve: "<",
	    close: "&",
	    dismiss: "&"
	  }
	}).name;

/***/ }),
/* 145 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = [{
	  nameFr: 'Afghanistan',
	  nameEn: 'Afghanistan',
	  code: 'AF'
	}, {
	  nameFr: 'Afrique du Sud',
	  nameEn: 'South Africa',
	  code: 'ZA'
	}, {
	  nameFr: 'Albanie',
	  nameEn: 'Albania',
	  code: 'AL'
	}, {
	  nameFr: 'Algérie',
	  nameEn: 'Algeria',
	  code: 'DZ'
	}, {
	  nameFr: 'Allemagne',
	  nameEn: 'Germany',
	  code: 'DE'
	}, {
	  nameFr: 'Andorre',
	  nameEn: 'Andorra',
	  code: 'AD'
	}, {
	  nameFr: 'Angola',
	  nameEn: 'Angola',
	  code: 'AO'
	}, {
	  nameFr: 'Anguilla',
	  nameEn: 'Anguilla',
	  code: 'AI'
	}, {
	  nameFr: 'Antarctique',
	  nameEn: 'Antarctica',
	  code: 'AQ'
	}, {
	  nameFr: 'Antigua-et-Barbuda',
	  nameEn: 'Antigua and Barbuda',
	  code: 'AG'
	}, {
	  nameFr: 'Antilles néerlandaises',
	  nameEn: 'Antilles néerlandaises',
	  code: 'AN'
	}, {
	  nameFr: 'Arabie saoudite',
	  nameEn: 'Saudi Arabia',
	  code: 'SA'
	}, {
	  nameFr: 'Argentine',
	  nameEn: 'Argentina',
	  code: 'AR'
	}, {
	  nameFr: 'Arménie',
	  nameEn: 'Armenia',
	  code: 'AM'
	}, {
	  nameFr: 'Aruba',
	  nameEn: 'Aruba',
	  code: 'AW'
	}, {
	  nameFr: 'Australie',
	  nameEn: 'Australia',
	  code: 'AU'
	}, {
	  nameFr: 'Autriche',
	  nameEn: 'Austria',
	  code: 'AT'
	}, {
	  nameFr: 'Azerbaïdjan',
	  nameEn: 'Azerbaijan',
	  code: 'AZ'
	}, {
	  nameFr: 'Bahamas',
	  nameEn: 'Bahamas',
	  code: 'BS'
	}, {
	  nameFr: 'Bahreïn',
	  nameEn: 'Bahrain',
	  code: 'BH'
	}, {
	  nameFr: 'Bangladesh',
	  nameEn: 'Bangladesh',
	  code: 'BD'
	}, {
	  nameFr: 'Barbade',
	  nameEn: 'Barbados',
	  code: 'BB'
	}, {
	  nameFr: 'Biélorussie',
	  nameEn: 'Belarus',
	  code: 'BY'
	}, {
	  nameFr: 'Belgique',
	  nameEn: 'Belgium',
	  code: 'BE'
	}, {
	  nameFr: 'Belize',
	  nameEn: 'Belize',
	  code: 'BZ'
	}, {
	  nameFr: 'Bénin',
	  nameEn: 'Benin',
	  code: 'BJ'
	}, {
	  nameFr: 'Bermudes',
	  nameEn: 'Bermuda',
	  code: 'BM'
	}, {
	  nameFr: 'Bhoutan',
	  nameEn: 'Bhutan',
	  code: 'BT'
	}, {
	  nameFr: 'Bolivie',
	  nameEn: 'Bolivia',
	  code: 'BO'
	}, {
	  nameFr: 'Bosnie-Herzégovine',
	  nameEn: 'Bosnia and Herzegovina',
	  code: 'BA'
	}, {
	  nameFr: 'Botswana',
	  nameEn: 'Botswana',
	  code: 'BW'
	}, {
	  nameFr: 'Brésil',
	  nameEn: 'Brazil',
	  code: 'BR'
	}, {
	  nameFr: 'Brunéi Darussalam',
	  nameEn: 'Brunei',
	  code: 'BN'
	}, {
	  nameFr: 'Bulgarie',
	  nameEn: 'Bulgaria',
	  code: 'BG'
	}, {
	  nameFr: 'Burkina Faso',
	  nameEn: 'Burkina Faso',
	  code: 'BF'
	}, {
	  nameFr: 'Burundi',
	  nameEn: 'Burundi',
	  code: 'BI'
	}, {
	  nameFr: 'Cambodge',
	  nameEn: 'Cambodia',
	  code: 'KH'
	}, {
	  nameFr: 'Cameroun',
	  nameEn: 'Cameroon',
	  code: 'CM'
	}, {
	  nameFr: 'Canada',
	  nameEn: 'Canada',
	  code: 'CA'
	}, {
	  nameFr: 'Cap-Vert',
	  nameEn: 'Cape Verde',
	  code: 'CV'
	}, {
	  nameFr: 'Ceuta et Melilla',
	  nameEn: 'Ceuta et Melilla',
	  code: 'EA'
	}, {
	  nameFr: 'Chili',
	  nameEn: 'Chile',
	  code: 'CL'
	}, {
	  nameFr: 'Chine',
	  nameEn: 'China',
	  code: 'CN'
	}, {
	  nameFr: 'Chypre',
	  nameEn: 'Cyprus',
	  code: 'CY'
	}, {
	  nameFr: 'Colombie',
	  nameEn: 'Colombia',
	  code: 'CO'
	}, {
	  nameFr: 'Comores',
	  nameEn: 'Comoros',
	  code: 'KM'
	}, {
	  nameFr: 'Congo-Brazzaville',
	  nameEn: 'Republic of the Congo',
	  code: 'CG'
	}, {
	  nameFr: 'Corée du Nord',
	  nameEn: 'North Korea',
	  code: 'KP'
	}, {
	  nameFr: 'République de Corée',
	  nameEn: 'South Korea',
	  code: 'KR'
	}, {
	  nameFr: 'Costa Rica',
	  nameEn: 'Costa Rica',
	  code: 'CR'
	}, {
	  nameFr: 'Côte d’Ivoire',
	  nameEn: 'Ivory Coast',
	  code: 'CI'
	}, {
	  nameFr: 'Croatie',
	  nameEn: 'Croatia',
	  code: 'HR'
	}, {
	  nameFr: 'Cuba',
	  nameEn: 'Cuba',
	  code: 'CU'
	}, {
	  nameFr: 'Danemark',
	  nameEn: 'Denmark',
	  code: 'DK'
	}, {
	  nameFr: 'Diego Garcia',
	  nameEn: 'Diego Garcia',
	  code: 'DG'
	}, {
	  nameFr: 'Djibouti',
	  nameEn: 'Djibouti',
	  code: 'DJ'
	}, {
	  nameFr: 'Dominique',
	  nameEn: 'Dominica',
	  code: 'DM'
	}, {
	  nameFr: 'Égypte',
	  nameEn: 'Egypt',
	  code: 'EG'
	}, {
	  nameFr: 'El Salvador',
	  nameEn: 'El Salvador',
	  code: 'SV'
	}, {
	  nameFr: 'Émirats arabes unis',
	  nameEn: 'United Arab Emirates',
	  code: 'AE'
	}, {
	  nameFr: 'Équateur',
	  nameEn: 'Ecuador',
	  code: 'EC'
	}, {
	  nameFr: 'Érythrée',
	  nameEn: 'Eritrea',
	  code: 'ER'
	}, {
	  nameFr: 'Espagne',
	  nameEn: 'Spain',
	  code: 'ES'
	}, {
	  nameFr: 'Estonie',
	  nameEn: 'Estonia',
	  code: 'EE'
	}, {
	  nameFr: 'État de la Cité du Vatican',
	  nameEn: 'Vatican',
	  code: 'VA'
	}, {
	  nameFr: 'États fédérés de Micronésie',
	  nameEn: 'Micronesia',
	  code: 'FM'
	}, {
	  nameFr: 'États-Unis',
	  nameEn: 'United States',
	  code: 'US'
	}, {
	  nameFr: 'Éthiopie',
	  nameEn: 'Ethiopia',
	  code: 'ET'
	}, {
	  nameFr: 'Fidji',
	  nameEn: 'Fiji',
	  code: 'FJ'
	}, {
	  nameFr: 'Finlande',
	  nameEn: 'Finland',
	  code: 'FI'
	}, {
	  nameFr: 'France',
	  nameEn: 'France',
	  code: 'FR'
	}, {
	  nameFr: 'Gabon',
	  nameEn: 'Gabon',
	  code: 'GA'
	}, {
	  nameFr: 'Gambie',
	  nameEn: 'Gambia',
	  code: 'GM'
	}, {
	  nameFr: 'Géorgie',
	  nameEn: 'Georgia',
	  code: 'GE'
	}, {
	  nameFr: 'Géorgie du Sud et les îles Sandwich du Sud',
	  nameEn: 'South Georgia and the South Sandwich Islands',
	  code: 'GS'
	}, {
	  nameFr: 'Ghana',
	  nameEn: 'Ghana',
	  code: 'GH'
	}, {
	  nameFr: 'Gibraltar',
	  nameEn: 'Gibraltar',
	  code: 'GI'
	}, {
	  nameFr: 'Grèce',
	  nameEn: 'Greece',
	  code: 'GR'
	}, {
	  nameFr: 'Grenade',
	  nameEn: 'Grenada',
	  code: 'GD'
	}, {
	  nameFr: 'Groenland',
	  nameEn: 'Greenland',
	  code: 'GL'
	}, {
	  nameFr: 'Guam',
	  nameEn: 'Guam',
	  code: 'GU'
	}, {
	  nameFr: 'Guatemala',
	  nameEn: 'Guatemala',
	  code: 'GT'
	}, {
	  nameFr: 'Guernesey',
	  nameEn: 'Guernsey',
	  code: 'GG'
	}, {
	  nameFr: 'Guinée',
	  nameEn: 'Guinea',
	  code: 'GN'
	}, {
	  nameFr: 'Guinée équatoriale',
	  nameEn: 'Equatorial Guinea',
	  code: 'GQ'
	}, {
	  nameFr: 'Guinée-Bissau',
	  nameEn: 'Guinea-Bissau',
	  code: 'GW'
	}, {
	  nameFr: 'Guyana',
	  nameEn: 'Guyana',
	  code: 'GY'
	}, {
	  nameFr: 'Haïti',
	  nameEn: 'Haiti',
	  code: 'HT'
	}, {
	  nameFr: 'Honduras',
	  nameEn: 'Honduras',
	  code: 'HN'
	}, {
	  nameFr: 'Hongrie',
	  nameEn: 'Hungary',
	  code: 'HU'
	}, {
	  nameFr: 'Île Bouvet',
	  nameEn: 'Bouvet Island',
	  code: 'BV'
	}, {
	  nameFr: 'Île Christmas',
	  nameEn: 'Christmas Island',
	  code: 'CX'
	}, {
	  nameFr: 'Île de l\'Ascension',
	  nameEn: 'Île de l\'Ascension',
	  code: 'AC'
	}, {
	  nameFr: 'Île de Man',
	  nameEn: 'Isle of Man',
	  code: 'IM'
	}, {
	  nameFr: 'Île Norfolk',
	  nameEn: 'Norfolk Island',
	  code: 'NF'
	}, {
	  nameFr: 'Îles Åland',
	  nameEn: 'Aland Islands',
	  code: 'AX'
	}, {
	  nameFr: 'Îles Caïmans',
	  nameEn: 'Cayman Islands',
	  code: 'KY'
	}, {
	  nameFr: 'Îles Canaries',
	  nameEn: 'Îles Canaries',
	  code: 'IC'
	}, {
	  nameFr: 'Îles Cocos - Keeling',
	  nameEn: 'Cocos Islands',
	  code: 'CC'
	}, {
	  nameFr: 'Îles Cook',
	  nameEn: 'Cook Islands',
	  code: 'CK'
	}, {
	  nameFr: 'Îles Féroé',
	  nameEn: 'Faroe Islands',
	  code: 'FO'
	}, {
	  nameFr: 'Îles Heard et MacDonald',
	  nameEn: 'Heard Island and McDonald Islands',
	  code: 'HM'
	}, {
	  nameFr: 'Îles Malouines',
	  nameEn: 'Falkland Islands',
	  code: 'FK'
	}, {
	  nameFr: 'Îles Mariannes du Nord',
	  nameEn: 'Northern Mariana Islands',
	  code: 'MP'
	}, {
	  nameFr: 'Îles Marshall',
	  nameEn: 'Marshall Islands',
	  code: 'MH'
	}, {
	  nameFr: 'Îles Mineures Éloignées des États-Unis',
	  nameEn: 'United States Minor Outlying Islands',
	  code: 'UM'
	}, {
	  nameFr: 'Îles Salomon',
	  nameEn: 'Solomon Islands',
	  code: 'SB'
	}, {
	  nameFr: 'Îles Turks et Caïques',
	  nameEn: 'Turks and Caicos Islands',
	  code: 'TC'
	}, {
	  nameFr: 'Îles Vierges britanniques',
	  nameEn: 'British Virgin Islands',
	  code: 'VG'
	}, {
	  nameFr: 'Îles Vierges des États-Unis',
	  nameEn: 'U.S. Virgin Islands',
	  code: 'VI'
	}, {
	  nameFr: 'Inde',
	  nameEn: 'India',
	  code: 'IN'
	}, {
	  nameFr: 'Indonésie',
	  nameEn: 'Indonesia',
	  code: 'ID'
	}, {
	  nameFr: 'Irak',
	  nameEn: 'Iraq',
	  code: 'IQ'
	}, {
	  nameFr: 'Iran',
	  nameEn: 'Iran',
	  code: 'IR'
	}, {
	  nameFr: 'Irlande',
	  nameEn: 'Ireland',
	  code: 'IE'
	}, {
	  nameFr: 'Islande',
	  nameEn: 'Iceland',
	  code: 'IS'
	}, {
	  nameFr: 'Israël',
	  nameEn: 'Israel',
	  code: 'IL'
	}, {
	  nameFr: 'Italie',
	  nameEn: 'Italy',
	  code: 'IT'
	}, {
	  nameFr: 'Jamaïque',
	  nameEn: 'Jamaica',
	  code: 'JM'
	}, {
	  nameFr: 'Japon',
	  nameEn: 'Japan',
	  code: 'JP'
	}, {
	  nameFr: 'Jersey',
	  nameEn: 'Jersey',
	  code: 'JE'
	}, {
	  nameFr: 'Jordanie',
	  nameEn: 'Jordan',
	  code: 'JO'
	}, {
	  nameFr: 'Kazakhstan',
	  nameEn: 'Kazakhstan',
	  code: 'KZ'
	}, {
	  nameFr: 'Kenya',
	  nameEn: 'Kenya',
	  code: 'KE'
	}, {
	  nameFr: 'Kirghizistan',
	  nameEn: 'Kyrgyzstan',
	  code: 'KG'
	}, {
	  nameFr: 'Kiribati',
	  nameEn: 'Kiribati',
	  code: 'KI'
	}, {
	  nameFr: 'Koweït',
	  nameEn: 'Kuwait',
	  code: 'KW'
	}, {
	  nameFr: 'Laos',
	  nameEn: 'Laos',
	  code: 'LA'
	}, {
	  nameFr: 'Lesotho',
	  nameEn: 'Lesotho',
	  code: 'LS'
	}, {
	  nameFr: 'Lettonie',
	  nameEn: 'Latvia',
	  code: 'LV'
	}, {
	  nameFr: 'Liban',
	  nameEn: 'Lebanon',
	  code: 'LB'
	}, {
	  nameFr: 'Libéria',
	  nameEn: 'Liberia',
	  code: 'LR'
	}, {
	  nameFr: 'Libye',
	  nameEn: 'Libya',
	  code: 'LY'
	}, {
	  nameFr: 'Liechtenstein',
	  nameEn: 'Liechtenstein',
	  code: 'LI'
	}, {
	  nameFr: 'Lituanie',
	  nameEn: 'Lithuania',
	  code: 'LT'
	}, {
	  nameFr: 'Luxembourg',
	  nameEn: 'Luxembourg',
	  code: 'LU'
	}, {
	  nameFr: 'Macédoine',
	  nameEn: 'Macedonia',
	  code: 'MK'
	}, {
	  nameFr: 'Madagascar',
	  nameEn: 'Madagascar',
	  code: 'MG'
	}, {
	  nameFr: 'Malaisie',
	  nameEn: 'Malaysia',
	  code: 'MY'
	}, {
	  nameFr: 'Malawi',
	  nameEn: 'Malawi',
	  code: 'MW'
	}, {
	  nameFr: 'Maldives',
	  nameEn: 'Maldives',
	  code: 'MV'
	}, {
	  nameFr: 'Mali',
	  nameEn: 'Mali',
	  code: 'ML'
	}, {
	  nameFr: 'Malte',
	  nameEn: 'Malta',
	  code: 'MT'
	}, {
	  nameFr: 'Maroc',
	  nameEn: 'Morocco',
	  code: 'MA'
	}, {
	  nameFr: 'Maurice',
	  nameEn: 'Mauritius',
	  code: 'MU'
	}, {
	  nameFr: 'Mauritanie',
	  nameEn: 'Mauritania',
	  code: 'MR'
	}, {
	  nameFr: 'Mexique',
	  nameEn: 'Mexico',
	  code: 'MX'
	}, {
	  nameFr: 'Moldavie',
	  nameEn: 'Moldova',
	  code: 'MD'
	}, {
	  nameFr: 'Monaco',
	  nameEn: 'Monaco',
	  code: 'MC'
	}, {
	  nameFr: 'Mongolie',
	  nameEn: 'Mongolia',
	  code: 'MN'
	}, {
	  nameFr: 'Monténégro',
	  nameEn: 'Montenegro',
	  code: 'ME'
	}, {
	  nameFr: 'Montserrat',
	  nameEn: 'Montserrat',
	  code: 'MS'
	}, {
	  nameFr: 'Mozambique',
	  nameEn: 'Mozambique',
	  code: 'MZ'
	}, {
	  nameFr: 'Myanmar',
	  nameEn: 'Myanmar',
	  code: 'MM'
	}, {
	  nameFr: 'Namibie',
	  nameEn: 'Namibia',
	  code: 'NA'
	}, {
	  nameFr: 'Nauru',
	  nameEn: 'Nauru',
	  code: 'NR'
	}, {
	  nameFr: 'Népal',
	  nameEn: 'Nepal',
	  code: 'NP'
	}, {
	  nameFr: 'Nicaragua',
	  nameEn: 'Nicaragua',
	  code: 'NI'
	}, {
	  nameFr: 'Niger',
	  nameEn: 'Niger',
	  code: 'NE'
	}, {
	  nameFr: 'Nigéria',
	  nameEn: 'Nigeria',
	  code: 'NG'
	}, {
	  nameFr: 'Niue',
	  nameEn: 'Niue',
	  code: 'NU'
	}, {
	  nameFr: 'Norvège',
	  nameEn: 'Norway',
	  code: 'NO'
	}, {
	  nameFr: 'Nouvelle-Zélande',
	  nameEn: 'New Zealand',
	  code: 'NZ'
	}, {
	  nameFr: 'Oman',
	  nameEn: 'Oman',
	  code: 'OM'
	}, {
	  nameFr: 'Ouganda',
	  nameEn: 'Uganda',
	  code: 'UG'
	}, {
	  nameFr: 'Ouzbékistan',
	  nameEn: 'Uzbekistan',
	  code: 'UZ'
	}, {
	  nameFr: 'Pakistan',
	  nameEn: 'Pakistan',
	  code: 'PK'
	}, {
	  nameFr: 'Palaos',
	  nameEn: 'Palau',
	  code: 'PW'
	}, {
	  nameFr: 'Panama',
	  nameEn: 'Panama',
	  code: 'PA'
	}, {
	  nameFr: 'Papouasie-Nouvelle-Guinée',
	  nameEn: 'Papua New Guinea',
	  code: 'PG'
	}, {
	  nameFr: 'Paraguay',
	  nameEn: 'Paraguay',
	  code: 'PY'
	}, {
	  nameFr: 'Pays-Bas',
	  nameEn: 'Netherlands',
	  code: 'NL'
	}, {
	  nameFr: 'Pérou',
	  nameEn: 'Peru',
	  code: 'PE'
	}, {
	  nameFr: 'Philippines',
	  nameEn: 'Philippines',
	  code: 'PH'
	}, {
	  nameFr: 'Pitcairn',
	  nameEn: 'Pitcairn',
	  code: 'PN'
	}, {
	  nameFr: 'Pologne',
	  nameEn: 'Poland',
	  code: 'PL'
	}, {
	  nameFr: 'Porto Rico',
	  nameEn: 'Puerto Rico',
	  code: 'PR'
	}, {
	  nameFr: 'Portugal',
	  nameEn: 'Portugal',
	  code: 'PT'
	}, {
	  nameFr: 'Qatar',
	  nameEn: 'Qatar',
	  code: 'QA'
	}, {
	  nameFr: 'R.A.S. chinoise de Hong Kong',
	  nameEn: 'Hong Kong',
	  code: 'HK'
	}, {
	  nameFr: 'R.A.S. chinoise de Macao',
	  nameEn: 'Macao',
	  code: 'MO'
	}, {
	  nameFr: 'régions éloignées de l’Océanie',
	  nameEn: 'régions éloignées de l’Océanie',
	  code: 'QO'
	}, {
	  nameFr: 'République centrafricaine',
	  nameEn: 'Central African Republic',
	  code: 'CF'
	}, {
	  nameFr: 'République démocratique du Congo',
	  nameEn: 'Democratic Republic of the Congo',
	  code: 'CD'
	}, {
	  nameFr: 'République dominicaine',
	  nameEn: 'Dominican Republic',
	  code: 'DO'
	}, {
	  nameFr: 'République Tchèque',
	  nameEn: 'Czech Republic',
	  code: 'CZ'
	}, {
	  nameFr: 'Roumanie',
	  nameEn: 'Romania',
	  code: 'RO'
	}, {
	  nameFr: 'Royaume-Uni',
	  nameEn: 'United Kingdom',
	  code: 'GB'
	}, {
	  nameFr: 'Russie',
	  nameEn: 'Russia',
	  code: 'RU'
	}, {
	  nameFr: 'Rwanda',
	  nameEn: 'Rwanda',
	  code: 'RW'
	}, {
	  nameFr: 'Sahara occidental',
	  nameEn: 'Western Sahara',
	  code: 'EH'
	}, {
	  nameFr: 'Saint-Kitts-et-Nevis',
	  nameEn: 'Saint Kitts and Nevis',
	  code: 'KN'
	}, {
	  nameFr: 'Saint-Marin',
	  nameEn: 'San Marino',
	  code: 'SM'
	}, {
	  nameFr: 'Saint-Vincent-et-les Grenadines',
	  nameEn: 'Saint Vincent and the Grenadines',
	  code: 'VC'
	}, {
	  nameFr: 'Sainte-Hélène',
	  nameEn: 'Saint Helena',
	  code: 'SH'
	}, {
	  nameFr: 'Sainte-Lucie',
	  nameEn: 'Saint Lucia',
	  code: 'LC'
	}, {
	  nameFr: 'Samoa',
	  nameEn: 'Samoa',
	  code: 'WS'
	}, {
	  nameFr: 'Samoa américaines',
	  nameEn: 'American Samoa',
	  code: 'AS'
	}, {
	  nameFr: 'Sao Tomé-et-Principe',
	  nameEn: 'Sao Tome and Principe',
	  code: 'ST'
	}, {
	  nameFr: 'Sénégal',
	  nameEn: 'Senegal',
	  code: 'SN'
	}, {
	  nameFr: 'Serbie',
	  nameEn: 'Serbia',
	  code: 'RS'
	}, {
	  nameFr: 'Serbie-et-Monténégro',
	  nameEn: 'Serbie-et-Monténégro',
	  code: 'CS'
	}, {
	  nameFr: 'Seychelles',
	  nameEn: 'Seychelles',
	  code: 'SC'
	}, {
	  nameFr: 'Sierra Leone',
	  nameEn: 'Sierra Leone',
	  code: 'SL'
	}, {
	  nameFr: 'Singapour',
	  nameEn: 'Singapore',
	  code: 'SG'
	}, {
	  nameFr: 'Slovaquie',
	  nameEn: 'Slovakia',
	  code: 'SK'
	}, {
	  nameFr: 'Slovénie',
	  nameEn: 'Slovenia',
	  code: 'SI'
	}, {
	  nameFr: 'Somalie',
	  nameEn: 'Somalia',
	  code: 'SO'
	}, {
	  nameFr: 'Soudan',
	  nameEn: 'Sudan',
	  code: 'SD'
	}, {
	  nameFr: 'Sri Lanka',
	  nameEn: 'Sri Lanka',
	  code: 'LK'
	}, {
	  nameFr: 'Suède',
	  nameEn: 'Sweden',
	  code: 'SE'
	}, {
	  nameFr: 'Suisse',
	  nameEn: 'Switzerland',
	  code: 'CH'
	}, {
	  nameFr: 'Suriname',
	  nameEn: 'Suriname',
	  code: 'SR'
	}, {
	  nameFr: 'Svalbard et Île Jan Mayen',
	  nameEn: 'Svalbard and Jan Mayen',
	  code: 'SJ'
	}, {
	  nameFr: 'Swaziland',
	  nameEn: 'Swaziland',
	  code: 'SZ'
	}, {
	  nameFr: 'Syrie',
	  nameEn: 'Syria',
	  code: 'SY'
	}, {
	  nameFr: 'Tadjikistan',
	  nameEn: 'Tajikistan',
	  code: 'TJ'
	}, {
	  nameFr: 'Taïwan',
	  nameEn: 'Taiwan',
	  code: 'TW'
	}, {
	  nameFr: 'Tanzanie',
	  nameEn: 'Tanzania',
	  code: 'TZ'
	}, {
	  nameFr: 'Tchad',
	  nameEn: 'Chad',
	  code: 'TD'
	}, {
	  nameFr: 'Territoire britannique de l\'océan Indien',
	  nameEn: 'British Indian Ocean Territory',
	  code: 'IO'
	}, {
	  nameFr: 'Territoire palestinien',
	  nameEn: 'Palestinian Territory',
	  code: 'PS'
	}, {
	  nameFr: 'Thaïlande',
	  nameEn: 'Thailand',
	  code: 'TH'
	}, {
	  nameFr: 'Timor oriental',
	  nameEn: 'East Timor',
	  code: 'TL'
	}, {
	  nameFr: 'Togo',
	  nameEn: 'Togo',
	  code: 'TG'
	}, {
	  nameFr: 'Tokelau',
	  nameEn: 'Tokelau',
	  code: 'TK'
	}, {
	  nameFr: 'Tonga',
	  nameEn: 'Tonga',
	  code: 'TO'
	}, {
	  nameFr: 'Trinité-et-Tobago',
	  nameEn: 'Trinidad and Tobago',
	  code: 'TT'
	}, {
	  nameFr: 'Tristan da Cunha',
	  nameEn: 'Tristan da Cunha',
	  code: 'TA'
	}, {
	  nameFr: 'Tunisie',
	  nameEn: 'Tunisia',
	  code: 'TN'
	}, {
	  nameFr: 'Turkménistan',
	  nameEn: 'Turkmenistan',
	  code: 'TM'
	}, {
	  nameFr: 'Turquie',
	  nameEn: 'Turkey',
	  code: 'TR'
	}, {
	  nameFr: 'Tuvalu',
	  nameEn: 'Tuvalu',
	  code: 'TV'
	}, {
	  nameFr: 'Ukraine',
	  nameEn: 'Ukraine',
	  code: 'UA'
	}, {
	  nameFr: 'Uruguay',
	  nameEn: 'Uruguay',
	  code: 'UY'
	}, {
	  nameFr: 'Vanuatu',
	  nameEn: 'Vanuatu',
	  code: 'VU'
	}, {
	  nameFr: 'Venezuela',
	  nameEn: 'Venezuela',
	  code: 'VE'
	}, {
	  nameFr: 'Viêt Nam',
	  nameEn: 'Vietnam',
	  code: 'VN'
	}, {
	  nameFr: 'Yémen',
	  nameEn: 'Yemen',
	  code: 'YE'
	}, {
	  nameFr: 'Zambie',
	  nameEn: 'Zambia',
	  code: 'ZM'
	}, {
	  nameFr: 'Zimbabwe',
	  nameEn: 'Zimbabwe',
	  code: 'ZW'
	}];

/***/ }),
/* 146 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <button\n    type=\"button\"\n    ng-click=\"$ctrl.cancel()\"\n    class=\"close close-contact-form\"\n  >\n    &times;\n  </button>\n  <h3 class=\"modal-title\" id=\"modal-title\">{{$ctrl.title}}</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n  <!--Test controller\n  <ul>\n      <li ng-repeat=\"item in $ctrl.items\">\n          <a href=\"#\" ng-click=\"$event.preventDefault(); $ctrl.selected.item = item\">{{ item }}</a>\n      </li>\n  </ul>\n  Selected: <b>{{ $ctrl.selected.item }}</b>\n  <hr>\n-->\n\n  <form class=\"form-horizontal form-client\" name=\"form_client\" novalidate>\n    <!--         -->\n    <!--         -->\n    <!-- CONTACT -->\n    <!--         -->\n    <!--         -->\n    <fieldset ng-if=\"$ctrl.isFull || $ctrl.isContact\">\n      <legend class=\"text-center header\" ng-if=\"$ctrl.isFull\">Contact</legend>\n      <div\n        class=\"form-group\"\n        ng-class=\"{'has-error': form_client.title.$invalid && $ctrl.submitted }\"\n      >\n        <label class=\"control-label col-sm-3\" for=\"title\"\n          >* {{'Titre'|translate}}:\n        </label>\n        <div class=\"col-sm-9\">\n          <label class=\"radio-inline\"\n            ><input\n              ng-disabled=\"!$ctrl.enableSave\"\n              type=\"radio\"\n              name=\"title\"\n              ng-model=\"$ctrl.contact.title\"\n              ng-value=\"10000\"\n              required\n            />{{\"Monsieur\"|translate}}\n          </label>\n          <label class=\"radio-inline\"\n            ><input\n              ng-disabled=\"!$ctrl.enableSave\"\n              type=\"radio\"\n              name=\"title\"\n              ng-model=\"$ctrl.contact.title\"\n              ng-value=\"10001\"\n              required\n            />{{\"Madame\"|translate}}\n          </label>\n        </div>\n      </div>\n      <div\n        class=\"form-group\"\n        ng-class=\"{'has-error': form_client.firstname.$invalid && $ctrl.submitted }\"\n      >\n        <label class=\"control-label col-sm-3\" for=\"firstname\"\n          >* {{\"Prénom\"|translate}} :</label\n        >\n        <div class=\"col-sm-9\">\n          <input\n            ng-disabled=\"!$ctrl.enableSave\"\n            type=\"text\"\n            class=\"form-control\"\n            name=\"firstname\"\n            ng-model=\"$ctrl.contact.firstname\"\n            required\n          />\n        </div>\n      </div>\n      <div\n        class=\"form-group\"\n        ng-class=\"{'has-error': form_client.lastname.$invalid && $ctrl.submitted }\"\n      >\n        <label class=\"control-label col-sm-3\" for=\"lastname\"\n          >* {{\"Nom\"|translate}} :</label\n        >\n        <div class=\"col-sm-9\">\n          <input\n            ng-disabled=\"!$ctrl.enableSave\"\n            type=\"text\"\n            class=\"form-control\"\n            name=\"lastname\"\n            ng-model=\"$ctrl.contact.lastname\"\n            required\n          />\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <div class=\"col-sm-offset-3 col-sm-9\">\n          <label class=\"radio-inline\">\n            <input\n              ng-disabled=\"!$ctrl.enableSave || $ctrl.action == 'update' \"\n              type=\"checkbox\"\n              name=\"privateIndividual\"\n              ng-model=\"$ctrl.contact.privateIndividual\"\n            />\n            {{\"Je suis un particulier\"|translate}}\n          </label>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"control-label col-sm-3\" for=\"jobTitle\"\n          >{{\"Fonction\"|translate}} :</label\n        >\n        <div class=\"col-sm-9\">\n          <input\n            ng-disabled=\"!$ctrl.enableSave\"\n            type=\"text\"\n            class=\"form-control\"\n            name=\"jobTitle\"\n            ng-model=\"$ctrl.contact.jobTitle\"\n          />\n        </div>\n      </div>\n      <div\n        class=\"form-group\"\n        ng-class=\"{'has-error': form_client.email.$invalid && $ctrl.submitted }\"\n      >\n        <label class=\"control-label col-sm-3\" for=\"email\"\n          >* {{\"E-mail\"|translate}} :</label\n        >\n        <div class=\"col-sm-9\">\n          <input\n            ng-disabled=\"!$ctrl.enableSave\"\n            type=\"text\"\n            class=\"form-control\"\n            name=\"email\"\n            ng-model=\"$ctrl.contact.email\"\n            required\n          />\n        </div>\n      </div>\n      <div\n        class=\"form-group\"\n        ng-class=\"{'has-error': form_client.phone.$invalid && $ctrl.submitted }\"\n      >\n        <label class=\"control-label col-sm-3\" for=\"phone\"\n          >* {{\"Téléphone\"|translate}} :</label\n        >\n        <div class=\"col-sm-9\">\n          <input\n            ng-disabled=\"!$ctrl.enableSave\"\n            type=\"text\"\n            class=\"form-control\"\n            name=\"phone\"\n            ng-model=\"$ctrl.contact.phone\"\n            required\n          />\n        </div>\n      </div>\n      <div\n        class=\"form-group\"\n        ng-if=\"$ctrl.contact.privateIndividual && $ctrl.isFull\"\n      >\n        <label class=\"control-label col-sm-3\" for=\"website\"\n          >{{\"Site internet\"|translate}} :</label\n        >\n        <div class=\"col-sm-9\">\n          <input\n            ng-disabled=\"!$ctrl.enableSave\"\n            type=\"text\"\n            class=\"form-control\"\n            name=\"website\"\n            ng-model=\"$ctrl.society.website\"\n          />\n        </div>\n      </div>\n    </fieldset>\n\n    <!--         -->\n    <!--         -->\n    <!-- SOCIETY -->\n    <!--         -->\n    <!--         -->\n    <fieldset\n      ng-if=\"(!$ctrl.contact.privateIndividual && $ctrl.isFull) || $ctrl.isSociety\"\n    >\n      <legend class=\"text-center header\" ng-if=\"$ctrl.isFull\" translate>\n        Organisme\n      </legend>\n\n      <div\n        class=\"form-group\"\n        ng-class=\"{'has-error': $ctrl.society && $ctrl.society.isFrenchRegisteredCompany==null}\"\n      >\n        <div class=\"col-sm-12\">\n          <label class=\"radio-inline\" style=\"padding-left: 0px\">\n            *\n            <b translate>Est-ce que la société est immatriculée en France ?</b>\n          </label>\n          <label class=\"radio-inline radio-client\">\n            <input\n              type=\"radio\"\n              name=\"isFrenchRegisteredCompany\"\n              ng-disabled=\"!$ctrl.enableSave\"\n              ng-value=\"true\"\n              ng-model=\"$ctrl.society.isFrenchRegisteredCompany\"\n              ng-change=\"$ctrl.society.hasVatNumber = true\"\n              required\n            />\n            <span translate>OUI</span>\n          </label>\n          <label class=\"radio-inline radio-client\">\n            <input\n              type=\"radio\"\n              name=\"isFrenchRegisteredCompany\"\n              ng-disabled=\"!$ctrl.enableSave\"\n              ng-value=\"false\"\n              ng-model=\"$ctrl.society.isFrenchRegisteredCompany\"\n              required\n            />\n            <span translate>NON</span>\n          </label>\n        </div>\n      </div>\n\n      <div\n        class=\"form-group\"\n        ng-class=\"{'has-error': $ctrl.society.siret && $ctrl.society.siret.length>0 && \n        !$ctrl.isSiret}\"\n        ng-if=\"$ctrl.society.isFrenchRegisteredCompany\"\n      >\n        <label class=\"control-label col-sm-3\" for=\"siret\"\n          >* {{\"N° de SIRET\"|translate}} :</label\n        >\n        <div class=\"col-sm-9\">\n          <input\n            ng-disabled=\"!$ctrl.enableSave\"\n            type=\"text\"\n            class=\"form-control\"\n            ng-blur=\"$ctrl.showSiretError=true;\"\n            name=\"siret\"\n            ng-change=\"$ctrl.checkSiret()\"\n            ng-model=\"$ctrl.society.siret\"\n            required\n          />\n          <p\n            class=\"help-block required-block\"\n            ng-if=\"$ctrl.society.siret && $ctrl.society.siret.length>0 && \n            !$ctrl.isSiret && $ctrl.showSiretError\"\n          >\n            <i class=\"fa fa-exclamation-triangle\" aria-hidden=\"true\"></i>\n            <span translate> SIRET non valide</span>\n          </p>\n          <p\n            class=\"help-block checked-block\"\n            ng-if=\"$ctrl.society.siret && $ctrl.society.siret.length>0 && $ctrl.isSiret && $ctrl.showSiretError\"\n          >\n            <i class=\"fa fa-check\" aria-hidden=\"true\"></i>\n            <span translate> SIRET valide</span>\n          </p>\n        </div>\n      </div>\n\n      <div\n        class=\"form-group\"\n        ng-class=\"{'has-error': $ctrl.society && $ctrl.society.hasVatNumber==null}\"\n        ng-show=\"$ctrl.society.isFrenchRegisteredCompany!=true\"\n      >\n        <div class=\"col-sm-12\">\n          <label class=\"radio-inline\" style=\"padding-left: 0px\">\n            *\n            <b translate>\n              Est-ce que la société possède un numéro de TVA intracommunautaire\n              ?\n            </b>\n          </label>\n          <label class=\"radio-inline radio-client\">\n            <input\n              type=\"radio\"\n              name=\"hasVatNumber\"\n              ng-disabled=\"!$ctrl.enableSave\"\n              ng-value=\"true\"\n              ng-model=\"$ctrl.society.hasVatNumber\"\n              required\n            />\n            <span translate>OUI</span>\n          </label>\n          <label class=\"radio-inline radio-client\">\n            <input\n              type=\"radio\"\n              name=\"hasVatNumber\"\n              ng-disabled=\"!$ctrl.enableSave\"\n              ng-value=\"false\"\n              ng-model=\"$ctrl.society.hasVatNumber\"\n              required\n            />\n            <span translate>NON</span>\n          </label>\n        </div>\n        <div class=\"col-sm-12\">\n          <span class=\"help-block info-block\" translate>\n            (pour les sociétés basées dans la zone UE)\n          </span>\n        </div>\n      </div>\n\n      <!-- <div class=\"form-group\">\n        <div class=\"col-sm-offset-0 col-sm-12\">\n          <input ng-disabled=\"!$ctrl.enableSave\" type=\"checkbox\" class=\"form-check-input\"\n            ng-change=\"$ctrl.society.vatNumber=null;\" ng-model=\"$ctrl.society.hasVatNumber\" name=\"hasVatNumber\">\n          <label for=\"hasVatNumber\"><b translate>Pas de numéro de TVA intracommunautaire</b></label>\n        </div>\n      </div> -->\n\n      <div\n        class=\"form-group\"\n        ng-class=\"{'has-error': $ctrl.society.vatNumber && $ctrl.society.vatNumber.length>0 && \n        !$ctrl.isVatNumber && $ctrl.society.hasVatNumber}\"\n        ng-if=\"$ctrl.society.hasVatNumber && $ctrl.society.isFrenchRegisteredCompany==false\"\n      >\n        <label class=\"control-label col-sm-3\" for=\"vatNumber\"\n          >* {{\"N° de TVA intracommunautaire\"|translate}} :</label\n        >\n        <div class=\"col-sm-9\">\n          <input\n            ng-disabled=\"!$ctrl.enableSave\"\n            type=\"text\"\n            class=\"form-control\"\n            ng-blur=\"$ctrl.showVatNumberError=true;\"\n            name=\"vatNumber\"\n            ng-change=\"$ctrl.checkVatNumber()\"\n            ng-model=\"$ctrl.society.vatNumber\"\n            required\n          />\n          <p\n            class=\"help-block required-block\"\n            ng-if=\"$ctrl.society.vatNumber && $ctrl.society.vatNumber.length>0 && \n            !$ctrl.isVatNumber && $ctrl.society.hasVatNumber && $ctrl.showVatNumberError\"\n          >\n            <i class=\"fa fa-exclamation-triangle\" aria-hidden=\"true\"></i>\n            <span translate> Numéro de TVA intracommunautaire non valide</span>\n          </p>\n          <p\n            class=\"help-block checked-block\"\n            ng-if=\"$ctrl.society.vatNumber && $ctrl.society.vatNumber.length>0 && $ctrl.isVatNumber && $ctrl.society.hasVatNumber\"\n          >\n            <i class=\"fa fa-check\" aria-hidden=\"true\"></i>\n            <span translate> Numéro de TVA intracommunautaire valide</span>\n          </p>\n        </div>\n      </div>\n\n      <div class=\"form-group\" ng-if=\"$ctrl.society.isFrenchRegisteredCompany\">\n        <label class=\"control-label col-sm-3\" for=\"vatNumber\"\n          >{{\"N° de TVA intracommunautaire\"|translate}} :</label\n        >\n        <div class=\"col-sm-9\">\n          <input\n            ng-disabled=\"!$ctrl.enableSave\"\n            type=\"text\"\n            class=\"form-control\"\n            name=\"vatNumber\"\n            ng-model=\"$ctrl.society.vatNumber\"\n          />\n        </div>\n      </div>\n\n      <div\n        class=\"form-group\"\n        ng-class=\"{'has-error': form_client.name.$invalid && $ctrl.submitted }\"\n      >\n        <label class=\"control-label col-sm-3\" for=\"name\"\n          >* {{\"Nom de l’organisme / Raison sociale\"|translate}} :</label\n        >\n        <div class=\"col-sm-9\">\n          <input\n            ng-disabled=\"!$ctrl.enableSave\"\n            type=\"text\"\n            class=\"form-control\"\n            name=\"name\"\n            ng-model=\"$ctrl.society.name\"\n            required\n          />\n\n          <span class=\"help-block info-block\" translate>\n            Pour les groupes d’édition, merci de préciser le cas échéant le nom\n            du groupe et de la maison d’édition de la façon suivante : Groupe\n            YYY – XXX Editions\n          </span>\n        </div>\n      </div>\n      <!--div class=\"form-group\" ng-class=\"{'has-error': form_client.category.$invalid && $ctrl.submitted }\">\n        <label class=\"control-label col-sm-3\" for=\"category\">* {{\"Catégorie d’organisme\"|translate}} :</label>\n        <div class=\"col-sm-9\">\n          <select ng-disabled=\"!$ctrl.enableSave\" class=\"form-control\" name=\"category\" ng-model=\"$ctrl.society.category\" required>\n            <option ng-repeat=\"categ in $ctrl.categories\" value=\"{{categ}}\">{{categ}}</option>\n          </select>\n        </div>\n      </div>\n      <div class=\"form-group\" ng-if=\"$ctrl.society.category == 'Autre'\">\n        <label class=\"control-label col-sm-3\" for=\"otherCategory\">{{\"Autre catégorie\"|translate}} :</label>\n        <div class=\"col-sm-9\">\n          <input ng-disabled=\"!$ctrl.enableSave\" type=\"text\" class=\"form-control\"\n          name=\"otherCategory\" ng-model=\"$ctrl.society.otherCategory\" >\n        </div>\n      </div-->\n      <div class=\"form-group\">\n        <label class=\"control-label col-sm-3\" for=\"website\"\n          >{{\"Site internet\"|translate}} :</label\n        >\n        <div class=\"col-sm-9\">\n          <input\n            ng-disabled=\"!$ctrl.enableSave\"\n            type=\"text\"\n            class=\"form-control\"\n            name=\"website\"\n            ng-model=\"$ctrl.society.website\"\n          />\n        </div>\n      </div>\n    </fieldset>\n\n    <!--         -->\n    <!--         -->\n    <!-- ADDRESS -->\n    <!--         -->\n    <!--         -->\n    <fieldset ng-if=\"$ctrl.isFull || $ctrl.isAddress\">\n      <legend\n        class=\"text-center header\"\n        ng-if=\"$ctrl.isFull && $ctrl.contact.privateIndividual\"\n      >\n        {{\"Adresse du particulier\"|translate}}\n      </legend>\n      <legend\n        class=\"text-center header\"\n        ng-if=\"$ctrl.isFull && !$ctrl.contact.privateIndividual\"\n      >\n        {{\"Adresse de l'organisme\"|translate}}\n      </legend>\n      <div\n        class=\"form-group\"\n        ng-class=\"{'has-error': form_client.line1.$invalid && $ctrl.submitted }\"\n      >\n        <label class=\"control-label col-sm-3\" for=\"line1\"\n          >* {{\"Adresse\"|translate}} :</label\n        >\n        <div class=\"col-sm-9\">\n          <input\n            ng-disabled=\"!$ctrl.enableSave\"\n            type=\"text\"\n            class=\"form-control\"\n            maxlength=\"48\"\n            name=\"line1\"\n            ng-model=\"$ctrl.address.line1\"\n            placeholder=\"\"\n            required\n            autocomplete=\"off\"\n            autocorrect=\"off\"\n            autocapitalize=\"none\"\n            readonly\n            ng-focus=\"$event.target.removeAttribute('readonly')\"\n          />\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"control-label col-sm-3\" for=\"line2\"\n          >{{\"Adresse (suite)\"|translate}} :</label\n        >\n        <div class=\"col-sm-9\">\n          <input\n            ng-disabled=\"!$ctrl.enableSave\"\n            type=\"text\"\n            class=\"form-control\"\n            maxlength=\"48\"\n            name=\"line2\"\n            ng-model=\"$ctrl.address.line2\"\n            placeholder=\"\"\n            autocomplete=\"off\"\n            autocorrect=\"off\"\n            autocapitalize=\"none\"\n            readonly\n            ng-focus=\"$event.target.removeAttribute('readonly')\"\n          />\n        </div>\n      </div>\n      <div\n        class=\"form-group\"\n        ng-class=\"{'has-error': form_client.zip.$invalid && $ctrl.submitted }\"\n      >\n        <label class=\"control-label col-sm-3\" for=\"zip\"\n          >* {{\"ZIP/Code postal\"|translate}} :</label\n        >\n        <div class=\"col-sm-9\">\n          <input\n            ng-disabled=\"!$ctrl.enableSave\"\n            type=\"text\"\n            class=\"form-control\"\n            name=\"zip\"\n            ng-model=\"$ctrl.address.zip\"\n            required\n            autocomplete=\"off\"\n            autocorrect=\"off\"\n            autocapitalize=\"none\"\n            readonly\n            ng-focus=\"$event.target.removeAttribute('readonly')\"\n          />\n        </div>\n      </div>\n      <div\n        class=\"form-group\"\n        ng-class=\"{'has-error': form_client.city.$invalid && $ctrl.submitted }\"\n      >\n        <label class=\"control-label col-sm-3\" for=\"city\"\n          >* {{\"Ville\"|translate}} :</label\n        >\n        <div class=\"col-sm-9\">\n          <input\n            ng-disabled=\"!$ctrl.enableSave\"\n            type=\"text\"\n            class=\"form-control\"\n            name=\"city\"\n            ng-model=\"$ctrl.address.city\"\n            required\n            autocomplete=\"off\"\n            autocorrect=\"off\"\n            autocapitalize=\"none\"\n            readonly\n            ng-focus=\"$event.target.removeAttribute('readonly')\"\n          />\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"control-label col-sm-3\" for=\"state\"\n          >{{\"Etat/ Province/ Région\"|translate}} :</label\n        >\n        <div class=\"col-sm-9\">\n          <input\n            ng-disabled=\"!$ctrl.enableSave\"\n            type=\"text\"\n            class=\"form-control\"\n            name=\"state\"\n            ng-model=\"$ctrl.address.state\"\n            autocomplete=\"off\"\n            autocorrect=\"off\"\n            autocapitalize=\"none\"\n            readonly\n            ng-focus=\"$event.target.removeAttribute('readonly')\"\n          />\n        </div>\n      </div>\n      <div\n        class=\"form-group\"\n        ng-class=\"{'has-error': form_client.country.$invalid && $ctrl.submitted }\"\n      >\n        <label class=\"control-label col-sm-3\" for=\"country\"\n          >* {{\"Pays\"|translate}} :</label\n        >\n        <div class=\"col-sm-9\" ng-if=\"!$ctrl.address.country\">\n          <input\n            ng-disabled=\"!$ctrl.enableSave\"\n            type=\"text\"\n            ng-model=\"$ctrl.address.objCountry\"\n            placeholder=\"...\"\n            typeahead-editable=\"false\"\n            typeahead-on-select=\"$ctrl.countrySelected($item)\"\n            uib-typeahead=\"country as country.nameFr for country in $ctrl.searchCountries($viewValue)\"\n            class=\"form-control\"\n            typeahead-min-length=\"2\"\n            name=\"country\"\n            required\n            autocomplete=\"off\"\n            autocorrect=\"off\"\n            autocapitalize=\"none\"\n            readonly\n            ng-focus=\"$event.target.removeAttribute('readonly')\"\n          />\n        </div>\n        <div class=\"col-sm-9\" ng-if=\"$ctrl.address.country\">\n          <div class=\"col-xs-8 col-sub\">\n            <input\n              type=\"text\"\n              class=\"form-control\"\n              disabled\n              style=\"cursor: default\"\n              ng-value=\"$ctrl.address.country\"\n              name=\"country\"\n              required\n              autocomplete=\"off\"\n              autocorrect=\"off\"\n              autocapitalize=\"none\"\n            />\n          </div>\n          <div class=\"col-xs-4 col-sub\">\n            <button\n              type=\"button\"\n              class=\"btn btn-primary\"\n              ng-disabled=\"!$ctrl.enableSave\"\n              ng-click=\"$ctrl.clearCountry()\"\n              translate\n            >\n              Modifier\n            </button>\n          </div>\n        </div>\n      </div>\n    </fieldset>\n\n    <p class=\"help-block required-block\" ng-if=\"$ctrl.isForbiddenOwnerDelete\">\n      <i class=\"fa fa-info-circle\" aria-hidden=\"true\"></i>\n      <span translate> Vous ne pouvez pas supprimer cette information</span>\n    </p>\n\n    <p class=\"help-block required-block\" ng-if=\"!$ctrl.enableSave\">\n      <i class=\"fa fa-info-circle\" aria-hidden=\"true\"></i>\n      <span translate> Vous n'êtes pas autorisé à modifier cette fiche.</span>\n    </p>\n  </form>\n</div>\n<div class=\"modal-footer\">\n  <!--button class=\"btn btn-danger\" type=\"button\" ng-click=\"$ctrl.delete()\" ng-if=\"$ctrl.action == 'update'\" translate>Supprimer</button-->\n  <button\n    ng-disabled=\"\n  ( \n    ( \n      (!$ctrl.isSiret && $ctrl.society.isFrenchRegisteredCompany) || \n      (!$ctrl.isVatNumber && $ctrl.society.hasVatNumber && $ctrl.society.isFrenchRegisteredCompany==false) \n    ) &&\n    ($ctrl.type =='society' || $ctrl.type =='full')\n  ) || \n  !form_client.$valid\"\n    class=\"btn btn-primary\"\n    type=\"button\"\n    ng-click=\"$ctrl.save(form_client)\"\n    ng-if=\"$ctrl.enableSave\"\n  >\n    <span translate>Enregistrer les modifications et Fermer</span>\n  </button>\n\n  <!--button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.cancel()\" translate>Fermer</button-->\n</div>\n"

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var ShareComponent = exports.ShareComponent = function () {
	  /*@ngInject*/
	  function ShareComponent() {
	    _classCallCheck(this, ShareComponent);
	
	    var that = this;
	    this.$onInit = function () {
	      that.users = that.resolve.users;
	      that.createdBy = that.resolve.createdBy;
	    };
	
	    this.cancel = function () {
	      this.dismiss();
	    };
	  }
	
	  _createClass(ShareComponent, [{
	    key: "save",
	    value: function save(form) {
	      var that = this;
	      this.submitted = true;
	      if (form.$valid) {
	        that.close({ $value: { email: that.email, op: "add" } });
	      }
	    }
	  }, {
	    key: "delete",
	    value: function _delete(emailSelected) {
	      this.close({ $value: { email: emailSelected, op: "remove" } });
	    }
	  }]);
	
	  return ShareComponent;
	}();
	
	exports.default = angular.module("dalApp.permission.share", []).component("share", {
	  template: __webpack_require__(148),
	  controller: ShareComponent,
	  bindings: {
	    resolve: "<",
	    close: "&",
	    dismiss: "&"
	  }
	}).name;

/***/ }),
/* 148 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" ng-click=\"$ctrl.cancel()\" class=\"close\">&times;</button>\n  <h3 class=\"modal-title\" id=\"modal-title\" translate>Partager votre projet</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n  <span translate>Liste des comptes qui ont accès à ce projet:</span>\n  <ul>\n    <li\n      ng-repeat=\"user in $ctrl.users | orderBy:'email'\"\n      style=\"list-style-type: disc\"\n    >\n      {{user.email}}\n      <a\n        href=\"#\"\n        ng-if=\"$ctrl.createdBy && $ctrl.createdBy!=user.id\"\n        class=\"delete-manager\"\n        ng-click=\"$ctrl.delete(user.email)\"\n      >\n        <i class=\"fa fa-trash\" aria-hidden=\"true\"></i\n      ></a>\n      <span\n        style=\"padding-left: 10px\"\n        ng-if=\"$ctrl.createdBy && $ctrl.createdBy==user.id\"\n      >\n        <i class=\"fa fa-lock\" aria-hidden=\"true\"></i\n      ></span>\n    </li>\n  </ul>\n\n  <form name=\"form_share\" novalidate>\n    <div\n      class=\"form-group\"\n      ng-class=\"{'has-error': form_share.email.$invalid && $ctrl.submitted }\"\n    >\n      <label class=\"control-label\" for=\"email\" translate>\n        Veuillez préciser l'adresse e-mail de la personne avec qui vous voulez\n        partager votre projet.\n      </label>\n      <input\n        type=\"email\"\n        class=\"form-control\"\n        name=\"email\"\n        ng-model=\"$ctrl.email\"\n        required\n      />\n      <p\n        class=\"help-block\"\n        ng-show=\"form_share.email.$error.email && $ctrl.submitted\"\n        translate\n      >\n        Veuillez saisir une adresse e-mail valide.\n      </p>\n      <p\n        class=\"help-block\"\n        ng-show=\"form_share.email.$error.required && $ctrl.submitted\"\n        translate\n      >\n        Veuillez saisir votre adresse e-mail.\n      </p>\n      <p class=\"help-block\" ng-show=\"form_share.email.$error.mongoose\">\n        {{ vm.errors.email }}\n      </p>\n    </div>\n  </form>\n</div>\n<div class=\"modal-footer\">\n  <button\n    class=\"btn btn-primary\"\n    type=\"button\"\n    ng-click=\"$ctrl.save(form_share)\"\n    translate\n  >\n    Partager\n  </button>\n  <button\n    class=\"btn btn-default\"\n    type=\"button\"\n    ng-click=\"$ctrl.cancel()\"\n    translate\n  >\n    Fermer\n  </button>\n</div>\n"

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DuplicateComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _underscore = __webpack_require__(64);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var DuplicateComponent = exports.DuplicateComponent = function () {
	  /*@ngInject*/
	  DuplicateComponent.$inject = ['LanguageService'];
	  function DuplicateComponent(LanguageService) {
	    _classCallCheck(this, DuplicateComponent);
	
	    var that = this;
	    this.ls = LanguageService;
	    this.$onInit = function () {
	      that.demand = that.resolve.demand;
	      that.products = that.resolve.products;
	    };
	    this.cancel = function () {
	      this.dismiss();
	    };
	  }
	
	  _createClass(DuplicateComponent, [{
	    key: "parseValue",
	    value: function parseValue(value, type) {
	      if (value) {
	        if (type === "date") {
	          return new Date(value);
	        }
	        if (type === "integer") {
	          return Number(value);
	        }
	        if (type === "decimal") {
	          return Number(value);
	        }
	      }
	      return value;
	    }
	  }, {
	    key: "copy",
	    value: function copy(form) {
	      this.submitted = true;
	      if (this.selectedProduct && this.demand && this.products && form.$valid) {
	        var product = _underscore2.default.findWhere(this.products, {
	          id: this.demand.productId
	        });
	        var srcListedModels = product.listedModels;
	        var _inputsUses = [];
	        for (var i in this.demand.input) {
	          var inputModelId = this.demand.input[i].inputModelId;
	          var imodel = srcListedModels["input_" + inputModelId];
	          if ([50, 51].indexOf(imodel.sigedavMatchType) !== -1) {
	            _inputsUses.push({
	              value: this.parseValue(this.demand.input[i][imodel.type], imodel.type),
	              sigedavMatchType: imodel.sigedavMatchType,
	              useNumber: this.demand.input[i].useNumber
	            });
	          }
	        }
	
	        _inputsUses = _underscore2.default.sortBy(_inputsUses, "useNumber");
	        _inputsUses = _underscore2.default.groupBy(_inputsUses, "useNumber");
	
	        var inputs = {
	          generals: [],
	          uses: [[]]
	        };
	        for (var iname in this.selectedProduct.listedModels) {
	          var elt = {
	            value: null,
	            inputModelId: this.selectedProduct.listedModels[iname].id,
	            sigedavMatchType: this.selectedProduct.listedModels[iname].sigedavMatchType,
	            type: this.selectedProduct.listedModels[iname].type
	          };
	          if (this.selectedProduct.listedModels[iname].isGeneral) {
	            inputs.generals.push(elt);
	          } else {
	            inputs.uses[0].push(elt);
	          }
	        }
	
	        var use = inputs.uses[0];
	        inputs.uses = [];
	
	        var _loop = function _loop(u) {
	          var cUse = JSON.parse(JSON.stringify(use));
	          var authorInput = _underscore2.default.findWhere(_inputsUses[u], {
	            sigedavMatchType: 50
	          });
	          var titleInput = _underscore2.default.findWhere(_inputsUses[u], {
	            sigedavMatchType: 51
	          });
	          cUse = _underscore2.default.map(cUse, function (actuUse) {
	            if (actuUse.sigedavMatchType === 50) {
	              actuUse.value = authorInput ? authorInput.value : null;
	            } else if (actuUse.sigedavMatchType === 51) {
	              actuUse.value = titleInput ? titleInput.value : null;
	            }
	            return actuUse;
	          });
	          inputs.uses.push(cUse);
	        };
	
	        for (var u in _inputsUses) {
	          _loop(u);
	        }
	        this.close({
	          $value: {
	            productId: this.selectedProduct.id,
	            projectId: this.demand.projectId,
	            generals: inputs.generals,
	            uses: inputs.uses
	          }
	        });
	      }
	    }
	  }]);
	
	  return DuplicateComponent;
	}();
	
	exports.default = angular.module("dalApp.permission.duplicate", []).component("duplicate", {
	  template: __webpack_require__(150),
	  controller: DuplicateComponent,
	  bindings: {
	    resolve: "<",
	    close: "&",
	    dismiss: "&"
	  }
	}).name;

/***/ }),
/* 150 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" ng-click=\"$ctrl.cancel()\" class=\"close\">&times;</button>\n  <h3 class=\"modal-title\" id=\"modal-title\" translate>\n    Copier les auteurs et les œuvres dans une nouvelle demande\n  </h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n  <form name=\"form_duplicate\" novalidate>\n    <div\n      class=\"form-group\"\n      ng-class=\"{'has-error': form_duplicate.type.$invalid && $ctrl.submitted }\"\n    >\n      <label class=\"control-label\" for=\"type\" translate>\n        Veuillez choisir le type d'utilisation de la nouvelle demande.\n      </label>\n      <select\n        class=\"form-control\"\n        ng-model=\"$ctrl.selectedProduct\"\n        name=\"type\"\n        required\n      >\n        <option ng-repeat=\"option in $ctrl.products\" ng-value=\"option\">\n          {{$ctrl.ls.lang=='fr'?option.nameFr:option.nameEn}}\n        </option>\n      </select>\n    </div>\n  </form>\n</div>\n<div class=\"modal-footer\">\n  <button\n    class=\"btn btn-primary\"\n    type=\"button\"\n    ng-click=\"$ctrl.copy(form_duplicate)\"\n    translate\n  >\n    Copier\n  </button>\n  <button\n    class=\"btn btn-default\"\n    type=\"button\"\n    ng-click=\"$ctrl.cancel()\"\n    translate\n  >\n    Fermer\n  </button>\n</div>\n"

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ValidationController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _underscore = __webpack_require__(64);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var ValidationController = exports.ValidationController = function () {
	  ValidationController.$inject = ['arrow', 'appConfig', '$location', 'Modal', 'LanguageService', 'ProductAPI', 'Condition', 'screenSize'];
	  function ValidationController(arrow, appConfig, $location, Modal, LanguageService, ProductAPI, Condition, screenSize) {
	    "ngInject";
	
	    _classCallCheck(this, ValidationController);
	
	    var that = this;
	    this.isMobile = screenSize.on("xs", function (match) {
	      that.isMobile = match;
	    });
	    var ovhBase = "https://storage.sbg.cloud.ovh.net/v1/AUTH_bcdf554d7a774b40975e6151a6bd1b8a/dal_";
	    this.ovhBaseURI = ovhBase + appConfig.env + "/";
	    this.spinnerEnabled = true;
	    this.arrow = arrow;
	    this.ProductAPI = ProductAPI;
	    this.Modal = Modal;
	    this.$location = $location;
	    that.getBoolean = Condition.getBoolean;
	
	    this.ls = LanguageService;
	    this.s = $location.search();
	    if (this.s.demand && parseInt(this.s.demand)) {
	      if (this.s.project && parseInt(this.s.project)) {
	        ProductAPI.getModels().$promise.then(function (response) {
	          response = JSON.parse(JSON.stringify(response));
	          if (response.length > 0) {
	            that.products = response;
	            return ProductAPI.getFull({
	              id: parseInt(that.s.demand)
	            }).$promise.then(function (demand) {
	              if (!demand || demand && demand.project.id != that.s.project) {
	                $location.path("/permission").search({});
	              }
	              that.demand = JSON.parse(JSON.stringify(demand));
	              that.disabledInput = false;
	              if (that.demand.status && parseInt(that.demand.status) % 10 !== 1) {
	                that.disabledInput = true;
	              }
	
	              var dateAmended = new Date(that.demand.dateAmended).getTime();
	              if (!that.disabledInput && that.s.date != dateAmended) {
	                that.arrow.goto(3, that.s.project, that.s.demand, false, {
	                  date: dateAmended
	                });
	              }
	
	              if (!that.checkClient(that.demand)) {
	                that.arrow.goto(3, that.s.project, that.s.demand, false, {
	                  date: dateAmended
	                });
	              }
	
	              if (parseInt(that.demand.status) == 50 || parseInt(that.demand.status) == 60 || parseInt(that.demand.status) == 70 || parseInt(that.demand.status) == 74 || parseInt(that.demand.status) == 80 || parseInt(that.demand.status) == 90) {
	                that.prevIsHidden = true;
	              }
	
	              that.loadDemand();
	              that.spinnerEnabled = false;
	              return null;
	            }).catch(function () {
	              $location.path("/permission");
	              that.spinnerEnabled = false;
	              return null;
	            });
	          }
	          return;
	        }).catch(function () {
	          console.log("---> Error on load products type");
	        });
	      } else {
	        arrow.goto(1);
	      }
	    } else {
	      arrow.goto(2);
	    }
	  }
	
	  _createClass(ValidationController, [{
	    key: "validate",
	    value: function validate() {
	      var that = this;
	      if ([11, 21, 31, 41, 51].indexOf(that.demand.status) != -1) {
	        this.Modal.confirm.validate(function () {
	          that.validateClicked = true;
	          that.demand.status = parseInt(that.demand.status) + 1;
	          return that.ProductAPI.changeStatus(that.demand).$promise.then(function () {
	            that.$location.path("/permission").search({
	              directive: "confirmation",
	              project: that.s.project,
	              demand: that.s.demand
	            });
	            that.validateClicked = false;
	            return null;
	          });
	        })();
	      }
	    }
	  }, {
	    key: "checkClient",
	    value: function checkClient(d) {
	      if (!d.contactIdMain || !d.societyIdMain || !d.addressIdMain) {
	        return false;
	      }
	      if (!d.mainIsFinal && (!d.contactIdFinal || !d.societyIdFinal || !d.addressIdFinal)) {
	        return false;
	      }
	      if (!d.mainIsInvoice) {
	        if (!d.finalIsInvoice && (!d.contactIdInvoice || !d.societyIdInvoice || !d.addressInvoice)) {
	          return false;
	        }
	        if (d.finalIsInvoice && (!d.contactIdFinal || !d.societyIdFinal || !d.addressIdFinal)) {
	          return false;
	        }
	      }
	      return true;
	    }
	  }, {
	    key: "getSortedIname",
	    value: function getSortedIname(array) {
	      var keys = [];
	      for (var a in array) {
	        keys.push({
	          iname: a,
	          rank: array[a].rank
	        });
	      }
	      keys = keys.sort(function (a, b) {
	        return a.rank - b.rank;
	      });
	      return keys;
	    }
	  }, {
	    key: "loadDemand",
	    value: function loadDemand() {
	      var that = this;
	      var inputs = [];
	      var product = _underscore2.default.findWhere(that.products, {
	        id: that.demand.productId
	      });
	
	      var listedModels = product.listedModels;
	      _underscore2.default.each(that.demand.input, function (elt) {
	        var model = listedModels["input_" + elt.inputModelId];
	
	        if (model.type == "author" && elt.artist) {
	          elt.author = elt.artist.label;
	        }
	        if (model.type == "date" && elt.date) {
	          elt.date = new Date(elt.date).toLocaleDateString("en-GB");
	        }
	        if (model.type == "file" && elt.file) {
	          elt.file = elt.objFiles || [];
	        }
	
	        inputs.push({
	          id: elt.id,
	          inputModelId: elt.inputModelId,
	          iname: "input_" + elt.inputModelId,
	          useNumber: elt.useNumber,
	          demandId: elt.demandId,
	          isGeneral: model.isGeneral,
	          type: model.type,
	          parentModelId: model.inputModelId,
	          rank: model.rank,
	          value: elt[model.type],
	          labelFr: model.labelFr,
	          labelEn: model.labelEn,
	          sigedavMatchType: model.sigedavMatchType });
	      });
	
	      inputs = _underscore2.default.sortBy(inputs, "rank");
	
	      var _generals = _underscore2.default.where(inputs, {
	        isGeneral: true
	      });
	      _generals = _underscore2.default.indexBy(_generals, "iname");
	      var _uses = _underscore2.default.where(inputs, {
	        isGeneral: false
	      });
	      _uses = _underscore2.default.groupBy(_uses, "useNumber");
	      for (var useNumber in _uses) {
	        _uses[useNumber] = _underscore2.default.indexBy(_uses[useNumber], "iname");
	      }
	
	      var keysG = this.getSortedIname(_generals);
	      for (var k in keysG) {
	        var iname1 = keysG[k].iname;
	        var syntShow = listedModels[iname1].showOn;
	        _generals[iname1].showed = that.getBoolean(syntShow, _generals, _uses);
	      }
	
	      for (var u2 in _uses) {
	        var keysU = this.getSortedIname(_uses[u2]);
	        for (var k2 in keysU) {
	          var iname2 = keysU[k2].iname;
	          var _syntShow = listedModels[iname2].showOn;
	          _uses[u2][iname2].showed = that.getBoolean(_syntShow, _generals, _uses, _uses[u2]);
	        }
	      }
	
	      var inamesToDelete = [];
	      for (var iname3 in _generals) {
	        if (!_generals[iname3].showed) {
	          inamesToDelete.push(iname3);
	        }
	        if (listedModels[iname3] && listedModels[iname3].subInputModel && listedModels[iname3].subInputModel.length > 0) {
	          this.getValueList(iname3, _generals, listedModels[iname3].subInputModel);
	          inamesToDelete = inamesToDelete.concat(_underscore2.default.pluck(listedModels[iname3].subInputModel, "iname"));
	        }
	      }
	
	      inamesToDelete = _underscore2.default.uniq(inamesToDelete);
	      _generals = this.deleteInputs(inamesToDelete, _generals);
	      for (var u1 in _uses) {
	        inamesToDelete = [];
	        for (var iname4 in _uses[u1]) {
	          if (!_uses[u1][iname4].showed) {
	            inamesToDelete.push(iname4);
	          }
	          if (listedModels[iname4] && listedModels[iname4].subInputModel && listedModels[iname4].subInputModel.length > 0) {
	            this.getValueList(iname4, _uses[u1], listedModels[iname4].subInputModel);
	            inamesToDelete = inamesToDelete.concat(_underscore2.default.pluck(listedModels[iname4].subInputModel, "iname"));
	          }
	        }
	        inamesToDelete = _underscore2.default.uniq(inamesToDelete);
	        _uses[u1] = this.deleteInputs(inamesToDelete, _uses[u1]);
	      }
	
	      var _tempG = [];
	      for (var g in _generals) {
	        _tempG.push(_generals[g]);
	      }
	      _generals = _tempG;
	      _generals = _underscore2.default.sortBy(_generals, "rank");
	
	      var _tempU = [];
	      var _tempUN = _underscore2.default.keys(_uses);
	      _tempUN.sort();
	      for (var un in _tempUN) {
	        var u = _tempUN[un];
	
	        var _temp = [];
	        for (var a in _uses[u]) {
	          _temp.push(_uses[u][a]);
	        }
	        _tempU.push(_underscore2.default.sortBy(_temp, "rank"));
	      }
	      _uses = _tempU;
	      this.generals = _generals;
	      this.uses = _uses;
	      this.main = {
	        contact: that.demand.contactMain.firstname + " " + that.demand.contactMain.lastname,
	        society: that.demand.societyMain.name + " ",
	        address: that.demand.addressMain.label
	      };
	      this.final = JSON.parse(JSON.stringify(this.main));
	      this.invoice = JSON.parse(JSON.stringify(this.main));
	      if (!this.demand.mainIsFinal) {
	        this.final = {
	          contact: that.demand.contactFinal.firstname + " " + that.demand.contactFinal.lastname,
	          society: that.demand.societyFinal.name + " ",
	          address: that.demand.addressFinal.label
	        };
	      }
	      if (!this.demand.mainIsInvoice && this.demand.finalIsInvoice) {
	        this.invoice = JSON.parse(JSON.stringify(this.final));
	      }
	      if (!this.demand.mainIsInvoice && !this.demand.finalIsInvoice) {
	        this.invoice = {
	          contact: that.demand.contactInvoice.firstname + " " + that.demand.contactInvoice.lastname,
	          society: that.demand.societyInvoice.name + " ",
	          address: that.demand.addressInvoice.label
	        };
	      }
	    }
	  }, {
	    key: "prev",
	    value: function prev() {
	      var that = this;
	      var dateAmended = new Date(that.demand.dateAmended).getTime();
	      that.arrow.goto(3, that.s.project, that.s.demand, false, {
	        date: dateAmended
	      });
	    }
	  }, {
	    key: "deleteInputs",
	    value: function deleteInputs(inames, data) {
	      for (var i in inames) {
	        delete data[inames[i]];
	      }
	      return data;
	    }
	  }, {
	    key: "getValueList",
	    value: function getValueList(iname, data, models) {
	      var value = [];
	      for (var m in models) {
	        if (data[models[m].iname] && data[models[m].iname].value) {
	          var label = this.ls.lang == "fr" ? models[m].labelFr : models[m].labelEn;
	          value.push(label);
	        }
	      }
	      data[iname].value = value.join();
	    }
	  }]);
	
	  return ValidationController;
	}();
	
	exports.default = angular.module("dalApp.permission.validation", []).component("validation", {
	  template: __webpack_require__(152),
	  controller: ValidationController
	}).name;

/***/ }),
/* 152 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"panel panel-default permission-panel\">\n  <div class=\"panel-body\">\n    <form class=\"form-horizontal\" ng-show=\"!$ctrl.spinnerEnabled\">\n      <h3 translate>Projet :</h3>\n      <p>\n        <b translate>Nom du projet</b> : <i>{{$ctrl.demand.project.name}}</i>\n      </p>\n      <p>\n        <b translate>Description</b> :\n        <i>{{$ctrl.demand.project.description}}</i>\n      </p>\n\n      <hr />\n\n      <h3 translate>Utilisation :</h3>\n      <p>\n        <b translate>Type d'utilisation</b> :\n        <i\n          >{{$ctrl.ls.lang=='fr'?$ctrl.demand.product.nameFr:$ctrl.demand.product.nameEn}}</i\n        >\n      </p>\n      <p ng-repeat=\"inp in $ctrl.generals\" ng-if=\"inp.value\">\n        <b>{{$ctrl.ls.lang=='fr'?inp.labelFr:inp.labelEn}}</b>\n        <i ng-if=\"inp.type!='file'\">{{inp.value}}</i>\n        <i ng-if=\"inp.type=='file'\">\n          <span ng-repeat=\"oFile in inp.value track by $index\">\n            ({{$index+1}})\n            <a href=\"{{$ctrl.ovhBaseURI+oFile.url}}\" download target=\"_blank\"\n              >{{oFile.originalname}}</a\n            >\n            -\n          </span>\n        </i>\n      </p>\n\n      <hr />\n\n      <h3 translate>Auteurs / œuvres utilisés :</h3>\n      <div class=\"row\">\n        <div class=\"\" ng-repeat=\"use in $ctrl.uses track by $index\">\n          <p style=\"margin-left: 30px; float: left\"><b>{{$index+1}} .</b></p>\n          <div class=\"use\">\n            <p ng-repeat=\"inp in use\" ng-if=\"inp.value\">\n              <b>{{$ctrl.ls.lang=='fr'?inp.labelFr:inp.labelEn}}</b>\n              <i ng-if=\"inp.type!='file'\">{{inp.value}}</i>\n              <i ng-if=\"inp.type=='file'\">\n                <span ng-repeat=\"oFile in inp.value track by $index\">\n                  ({{$index+1}})\n                  <a\n                    href=\"{{$ctrl.ovhBaseURI+oFile.url}}\"\n                    download\n                    target=\"_blank\"\n                    >{{oFile.originalname}}</a\n                  >\n                  -\n                </span>\n              </i>\n            </p>\n          </div>\n        </div>\n      </div>\n\n      <hr />\n\n      <h3 translate>Demandeur :</h3>\n      <p><b translate>Contact</b> : <i>{{$ctrl.main.contact}}</i></p>\n      <p><b translate>Société</b> : <i>{{$ctrl.main.society}}</i></p>\n      <p><b translate>Adresse</b> : <i>{{$ctrl.main.address}}</i></p>\n      <p ng-if=\"$ctrl.demand.mainIsFinal\">\n        <b translate>Utiliser mes informations pour l'autorisation</b>\n      </p>\n      <p ng-if=\"$ctrl.demand.mainIsInvoice\">\n        <b translate>Utiliser mes informations pour la facturation</b>\n      </p>\n\n      <div ng-if=\"!$ctrl.demand.mainIsFinal\">\n        <h3 translate>Demande effectuée pour le compte de :</h3>\n        <p><b translate>Contact</b> : <i>{{$ctrl.final.contact}}</i></p>\n        <p><b translate>Société</b> : <i>{{$ctrl.final.society}}</i></p>\n        <p><b translate>Adresse</b> : <i>{{$ctrl.final.address}}</i></p>\n        <p ng-if=\"!$ctrl.demand.mainIsInvoice && $ctrl.demand.finalIsInvoice\">\n          <b translate\n            >Utiliser les informations du bénéficiaire pour la facturation</b\n          >\n        </p>\n      </div>\n\n      <div ng-if=\"!$ctrl.demand.mainIsInvoice && !$ctrl.demand.finalIsInvoice\">\n        <h3 translate>Facturer à :</h3>\n        <p><b translate>Contact</b> : <i>{{$ctrl.invoice.contact}}</i></p>\n        <p><b translate>Société</b> : <i>{{$ctrl.invoice.society}}</i></p>\n        <p><b translate>Adresse</b> : <i>{{$ctrl.invoice.address}}</i></p>\n      </div>\n\n      <!--div class=\"col-xs-12 form-group\">\n        <label for=\"email\">Bénéficiaire:</label>\n        <div class=\"bs-callout bs-callout-success bs-callout-margin bs-small\">\n          <h4>{{$ctrl.final.contact}}</h4>\n          <p><b>Société</b> : {{$ctrl.final.society}}</p>\n          <p><b>Adresse</b> : {{$ctrl.final.address}}</p>\n        </div>\n      </div>\n      <div class=\"col-xs-12 form-group\">\n        <label for=\"email\">Facturation:</label>\n        <div class=\"bs-callout bs-callout-success bs-callout-margin bs-small \">\n          <h4>{{$ctrl.invoice.contact}}</h4>\n          <p><b>Société</b> : {{$ctrl.invoice.society}}</p>\n          <p><b>Adresse</b> : {{$ctrl.invoice.address}}</p>\n        </div>\n      </div-->\n\n      <!--fieldset>\n        <h3 class=\"text-center header\">Utilisation</h3>\n\n        <div class=\"panel panel-default\">\n          <div class=\"panel-body\">\n\n          </div>\n        </div>\n      </fieldset-->\n\n      <!--fieldset>\n        <h3 class=\"text-center header\">Client et facturation</h3>\n\n        <div class=\"panel panel-default\">\n          <div class=\"panel-body\">\n\n          </div>\n        </div>\n      </fieldset-->\n    </form>\n\n    <p\n      align=\"center\"\n      ng-if=\"$ctrl.validateClicked || $ctrl.spinnerEnabled\"\n      class=\"waitting-spinner\"\n    >\n      <i class=\"fa fa-spinner fa-spin fa-5x fa-fw\"></i>\n    </p>\n\n    <!--*****************PAGINATION*****************-->\n    <nav\n      aria-label=\"Pagination\"\n      ng-if=\"!$ctrl.validateClicked && !$ctrl.spinnerEnabled\"\n    >\n      <ul class=\"pager\">\n        <li class=\"previous\" ng-if=\"!$ctrl.prevIsHidden\">\n          <a href=\"#\" ng-click=\"$ctrl.prev()\">\n            <i class=\"fa fa-arrow-left\" aria-hidden=\"true\"></i>\n            <span ng-if=\"!$ctrl.isMobile\">{{\"Précédent\"|translate}}</span>\n          </a>\n        </li>\n        <li class=\"next\">\n          <a href=\"#\" ng-click=\"$ctrl.validate()\" ng-if=\"!$ctrl.disabledInput\">\n            {{\"Envoyer la demande\"|translate}}\n            <i class=\"fa fa-arrow-right\" aria-hidden=\"true\"></i>\n          </a>\n          <a href=\"/permission\" ng-if=\"$ctrl.disabledInput\">\n            <i class=\"fa fa-folder-open\" aria-hidden=\"true\"></i> {{\"Voir mes\n            projets\"|translate}}\n          </a>\n        </li>\n      </ul>\n    </nav>\n  </div>\n</div>\n"

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	productService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.productService = productService;
	var angular = __webpack_require__(1);
	
	/*@ngInject*/
	function productService($resource) {
	  "ngInject";
	
	  return $resource("/api/demands/:id/:controller", {
	    id: "@id"
	  }, {
	    getModels: { method: "GET", params: { id: "products" }, isArray: true },
	    getFull: { method: "GET", params: { controller: "full" } },
	    getDefaultInputs: {
	      method: "GET",
	      params: { controller: "default-inputs" },
	      isArray: true
	    },
	    getRestricted: { method: "GET", params: { controller: "restricted" } },
	    get: { method: "GET" },
	    getFileInput: { method: "GET", params: { id: "files" } },
	    save: { method: "POST" },
	    change: { method: "PUT" },
	    manageClient: { method: "PUT", params: { controller: "manage-client" } },
	    changeStatus: { method: "PUT", params: { controller: "status" } },
	    delete: { method: "DELETE" }
	  });
	}
	
	exports.default = angular.module("dalApp.product.api", []).service("ProductAPI", productService).name;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	projectService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.projectService = projectService;
	var angular = __webpack_require__(1);
	
	/*@ngInject*/
	function projectService($resource) {
	  "ngInject";
	
	  return $resource("/api/projects/:id/:controller", {
	    id: "@id"
	  }, {
	    get: { method: "GET" },
	    save: { method: "POST" },
	    change: { method: "PUT" },
	    query: { method: "GET", isArray: true },
	    delete: { method: "DELETE" },
	    manageUser: { method: "PUT", params: { controller: "manage-user" } }
	  });
	}
	
	exports.default = angular.module("dalApp.project.api", []).service("ProjectAPI", projectService).name;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	identificationService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.identificationService = identificationService;
	var angular = __webpack_require__(1);
	
	/*@ngInject*/
	function identificationService($resource) {
	  "ngInject";
	
	  return $resource("/api/users/:controller/:id", {
	    id: "@id"
	  }, {
	    getClients: {
	      method: "GET",
	      params: {
	        controller: "clients"
	      }
	    },
	    checkVatNumber: {
	      method: "GET",
	      params: {
	        controller: "check-vat-number"
	      }
	    },
	    checkSiret: {
	      method: "GET",
	      params: {
	        controller: "check-siret"
	      }
	    },
	
	    createClient: {
	      method: "POST",
	      params: {
	        controller: "clients"
	      }
	    },
	    createContact: {
	      method: "POST",
	      params: {
	        controller: "contacts"
	      }
	    },
	    createSociety: {
	      method: "POST",
	      params: {
	        controller: "societies"
	      }
	    },
	    createAddress: {
	      method: "POST",
	      params: {
	        controller: "address"
	      }
	    },
	
	    updateContact: {
	      method: "PUT",
	      params: {
	        controller: "contacts"
	      }
	    },
	    updateSociety: {
	      method: "PUT",
	      params: {
	        controller: "societies"
	      }
	    },
	    updateAddress: {
	      method: "PUT",
	      params: {
	        controller: "address"
	      }
	    },
	
	    deleteContact: {
	      method: "DELETE",
	      params: {
	        controller: "contacts"
	      }
	    },
	    deleteSociety: {
	      method: "DELETE",
	      params: {
	        controller: "societies"
	      }
	    },
	    deleteAddress: {
	      method: "DELETE",
	      params: {
	        controller: "address"
	      }
	    }
	  });
	}
	
	exports.default = angular.module("dalApp.identification.api", []).service("IdentificationAPI", identificationService).name;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	* jquery-match-height 0.7.2 by @liabru
	* http://brm.io/jquery-match-height/
	* License: MIT
	*/
	
	;(function(factory) { // eslint-disable-line no-extra-semi
	    'use strict';
	    if (true) {
	        // AMD
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(62)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module !== 'undefined' && module.exports) {
	        // CommonJS
	        module.exports = factory(require('jquery'));
	    } else {
	        // Global
	        factory(jQuery);
	    }
	})(function($) {
	    /*
	    *  internal
	    */
	
	    var _previousResizeWidth = -1,
	        _updateTimeout = -1;
	
	    /*
	    *  _parse
	    *  value parse utility function
	    */
	
	    var _parse = function(value) {
	        // parse value and convert NaN to 0
	        return parseFloat(value) || 0;
	    };
	
	    /*
	    *  _rows
	    *  utility function returns array of jQuery selections representing each row
	    *  (as displayed after float wrapping applied by browser)
	    */
	
	    var _rows = function(elements) {
	        var tolerance = 1,
	            $elements = $(elements),
	            lastTop = null,
	            rows = [];
	
	        // group elements by their top position
	        $elements.each(function(){
	            var $that = $(this),
	                top = $that.offset().top - _parse($that.css('margin-top')),
	                lastRow = rows.length > 0 ? rows[rows.length - 1] : null;
	
	            if (lastRow === null) {
	                // first item on the row, so just push it
	                rows.push($that);
	            } else {
	                // if the row top is the same, add to the row group
	                if (Math.floor(Math.abs(lastTop - top)) <= tolerance) {
	                    rows[rows.length - 1] = lastRow.add($that);
	                } else {
	                    // otherwise start a new row group
	                    rows.push($that);
	                }
	            }
	
	            // keep track of the last row top
	            lastTop = top;
	        });
	
	        return rows;
	    };
	
	    /*
	    *  _parseOptions
	    *  handle plugin options
	    */
	
	    var _parseOptions = function(options) {
	        var opts = {
	            byRow: true,
	            property: 'height',
	            target: null,
	            remove: false
	        };
	
	        if (typeof options === 'object') {
	            return $.extend(opts, options);
	        }
	
	        if (typeof options === 'boolean') {
	            opts.byRow = options;
	        } else if (options === 'remove') {
	            opts.remove = true;
	        }
	
	        return opts;
	    };
	
	    /*
	    *  matchHeight
	    *  plugin definition
	    */
	
	    var matchHeight = $.fn.matchHeight = function(options) {
	        var opts = _parseOptions(options);
	
	        // handle remove
	        if (opts.remove) {
	            var that = this;
	
	            // remove fixed height from all selected elements
	            this.css(opts.property, '');
	
	            // remove selected elements from all groups
	            $.each(matchHeight._groups, function(key, group) {
	                group.elements = group.elements.not(that);
	            });
	
	            // TODO: cleanup empty groups
	
	            return this;
	        }
	
	        if (this.length <= 1 && !opts.target) {
	            return this;
	        }
	
	        // keep track of this group so we can re-apply later on load and resize events
	        matchHeight._groups.push({
	            elements: this,
	            options: opts
	        });
	
	        // match each element's height to the tallest element in the selection
	        matchHeight._apply(this, opts);
	
	        return this;
	    };
	
	    /*
	    *  plugin global options
	    */
	
	    matchHeight.version = '0.7.2';
	    matchHeight._groups = [];
	    matchHeight._throttle = 80;
	    matchHeight._maintainScroll = false;
	    matchHeight._beforeUpdate = null;
	    matchHeight._afterUpdate = null;
	    matchHeight._rows = _rows;
	    matchHeight._parse = _parse;
	    matchHeight._parseOptions = _parseOptions;
	
	    /*
	    *  matchHeight._apply
	    *  apply matchHeight to given elements
	    */
	
	    matchHeight._apply = function(elements, options) {
	        var opts = _parseOptions(options),
	            $elements = $(elements),
	            rows = [$elements];
	
	        // take note of scroll position
	        var scrollTop = $(window).scrollTop(),
	            htmlHeight = $('html').outerHeight(true);
	
	        // get hidden parents
	        var $hiddenParents = $elements.parents().filter(':hidden');
	
	        // cache the original inline style
	        $hiddenParents.each(function() {
	            var $that = $(this);
	            $that.data('style-cache', $that.attr('style'));
	        });
	
	        // temporarily must force hidden parents visible
	        $hiddenParents.css('display', 'block');
	
	        // get rows if using byRow, otherwise assume one row
	        if (opts.byRow && !opts.target) {
	
	            // must first force an arbitrary equal height so floating elements break evenly
	            $elements.each(function() {
	                var $that = $(this),
	                    display = $that.css('display');
	
	                // temporarily force a usable display value
	                if (display !== 'inline-block' && display !== 'flex' && display !== 'inline-flex') {
	                    display = 'block';
	                }
	
	                // cache the original inline style
	                $that.data('style-cache', $that.attr('style'));
	
	                $that.css({
	                    'display': display,
	                    'padding-top': '0',
	                    'padding-bottom': '0',
	                    'margin-top': '0',
	                    'margin-bottom': '0',
	                    'border-top-width': '0',
	                    'border-bottom-width': '0',
	                    'height': '100px',
	                    'overflow': 'hidden'
	                });
	            });
	
	            // get the array of rows (based on element top position)
	            rows = _rows($elements);
	
	            // revert original inline styles
	            $elements.each(function() {
	                var $that = $(this);
	                $that.attr('style', $that.data('style-cache') || '');
	            });
	        }
	
	        $.each(rows, function(key, row) {
	            var $row = $(row),
	                targetHeight = 0;
	
	            if (!opts.target) {
	                // skip apply to rows with only one item
	                if (opts.byRow && $row.length <= 1) {
	                    $row.css(opts.property, '');
	                    return;
	                }
	
	                // iterate the row and find the max height
	                $row.each(function(){
	                    var $that = $(this),
	                        style = $that.attr('style'),
	                        display = $that.css('display');
	
	                    // temporarily force a usable display value
	                    if (display !== 'inline-block' && display !== 'flex' && display !== 'inline-flex') {
	                        display = 'block';
	                    }
	
	                    // ensure we get the correct actual height (and not a previously set height value)
	                    var css = { 'display': display };
	                    css[opts.property] = '';
	                    $that.css(css);
	
	                    // find the max height (including padding, but not margin)
	                    if ($that.outerHeight(false) > targetHeight) {
	                        targetHeight = $that.outerHeight(false);
	                    }
	
	                    // revert styles
	                    if (style) {
	                        $that.attr('style', style);
	                    } else {
	                        $that.css('display', '');
	                    }
	                });
	            } else {
	                // if target set, use the height of the target element
	                targetHeight = opts.target.outerHeight(false);
	            }
	
	            // iterate the row and apply the height to all elements
	            $row.each(function(){
	                var $that = $(this),
	                    verticalPadding = 0;
	
	                // don't apply to a target
	                if (opts.target && $that.is(opts.target)) {
	                    return;
	                }
	
	                // handle padding and border correctly (required when not using border-box)
	                if ($that.css('box-sizing') !== 'border-box') {
	                    verticalPadding += _parse($that.css('border-top-width')) + _parse($that.css('border-bottom-width'));
	                    verticalPadding += _parse($that.css('padding-top')) + _parse($that.css('padding-bottom'));
	                }
	
	                // set the height (accounting for padding and border)
	                $that.css(opts.property, (targetHeight - verticalPadding) + 'px');
	            });
	        });
	
	        // revert hidden parents
	        $hiddenParents.each(function() {
	            var $that = $(this);
	            $that.attr('style', $that.data('style-cache') || null);
	        });
	
	        // restore scroll position if enabled
	        if (matchHeight._maintainScroll) {
	            $(window).scrollTop((scrollTop / htmlHeight) * $('html').outerHeight(true));
	        }
	
	        return this;
	    };
	
	    /*
	    *  matchHeight._applyDataApi
	    *  applies matchHeight to all elements with a data-match-height attribute
	    */
	
	    matchHeight._applyDataApi = function() {
	        var groups = {};
	
	        // generate groups by their groupId set by elements using data-match-height
	        $('[data-match-height], [data-mh]').each(function() {
	            var $this = $(this),
	                groupId = $this.attr('data-mh') || $this.attr('data-match-height');
	
	            if (groupId in groups) {
	                groups[groupId] = groups[groupId].add($this);
	            } else {
	                groups[groupId] = $this;
	            }
	        });
	
	        // apply matchHeight to each group
	        $.each(groups, function() {
	            this.matchHeight(true);
	        });
	    };
	
	    /*
	    *  matchHeight._update
	    *  updates matchHeight on all current groups with their correct options
	    */
	
	    var _update = function(event) {
	        if (matchHeight._beforeUpdate) {
	            matchHeight._beforeUpdate(event, matchHeight._groups);
	        }
	
	        $.each(matchHeight._groups, function() {
	            matchHeight._apply(this.elements, this.options);
	        });
	
	        if (matchHeight._afterUpdate) {
	            matchHeight._afterUpdate(event, matchHeight._groups);
	        }
	    };
	
	    matchHeight._update = function(throttle, event) {
	        // prevent update if fired from a resize event
	        // where the viewport width hasn't actually changed
	        // fixes an event looping bug in IE8
	        if (event && event.type === 'resize') {
	            var windowWidth = $(window).width();
	            if (windowWidth === _previousResizeWidth) {
	                return;
	            }
	            _previousResizeWidth = windowWidth;
	        }
	
	        // throttle updates
	        if (!throttle) {
	            _update(event);
	        } else if (_updateTimeout === -1) {
	            _updateTimeout = setTimeout(function() {
	                _update(event);
	                _updateTimeout = -1;
	            }, matchHeight._throttle);
	        }
	    };
	
	    /*
	    *  bind events
	    */
	
	    // apply on DOM ready event
	    $(matchHeight._applyDataApi);
	
	    // use on or bind where supported
	    var on = $.fn.on ? 'on' : 'bind';
	
	    // update heights on load and resize events
	    $(window)[on]('load', function(event) {
	        matchHeight._update(false, event);
	    });
	
	    // throttled update heights on resize events
	    $(window)[on]('resize orientationchange', function(event) {
	        matchHeight._update(true, event);
	    });
	
	});


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	arrowService.$inject = ['$rootScope', '$location'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.arrowService = arrowService;
	var angular = __webpack_require__(1);
	
	/*@ngInject*/
	function arrowService($rootScope, $location) {
	  "ngInject";
	
	  return {
	    directives: ["introduction", "project", "product", "identification", "validation", "confirmation", "board"],
	    directive: null,
	    activeDir: null,
	    projectId: null,
	    demandId: null,
	
	    getDirective: function getDirective() {
	      if ($location.path() === "/permission") {
	        var search = $location.search();
	        this.directive = "board";
	        var id = this.directives.indexOf(search.directive);
	        if (search.directive && id !== -1) {
	          this.directive = search.directive;
	        }
	        this.activeDir = this.directive !== "board" ? id : null;
	      }
	    },
	    goto: function goto(index, idProject, idDemand, reload, data) {
	      if (this.activeDir !== null && (this.activeDir !== index || reload) && this.directives[index] !== null && this.directives[index] !== "board") {
	        var s = $location.search();
	        var _projectId = s.project ? s.project : idProject || this.projectId;
	        var _demandId = s.demand ? s.demand : idDemand || this.demandId;
	        this.activeDir = index;
	        var params = {
	          directive: this.directives[index],
	          project: _projectId,
	          demand: _demandId
	        };
	        if (data && data.date) {
	          params.date = data.date;
	        }
	
	        $location.path("/permission").search(params);
	      }
	    }
	  };
	}
	
	exports.default = angular.module("dalApp.arrow", []).service("arrow", arrowService).name;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _admin = __webpack_require__(159);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _admin3 = __webpack_require__(161);
	
	var _admin4 = _interopRequireDefault(_admin3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module("dalApp.admin", ["dalApp.auth", "ui.router"]).config(_admin2.default).controller("AdminController", _admin4.default).name;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state("admin", {
	    url: "/admin",
	    template: __webpack_require__(160),
	    controller: "AdminController",
	    controllerAs: "admin",
	    authenticate: "admin"
	  });
	}

/***/ }),
/* 160 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\"></div>\n"

/***/ }),
/* 161 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AdminController =
	/*@ngInject*/
	['User', function AdminController(User) {
	  _classCallCheck(this, AdminController);
	}];
	
	exports.default = AdminController;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _author = __webpack_require__(163);
	
	var _author2 = _interopRequireDefault(_author);
	
	var _author3 = __webpack_require__(165);
	
	var _author4 = _interopRequireDefault(_author3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module("dalApp.author", ["dalApp.auth", "ui.router"]).config(_author2.default).controller("AuthorController", _author4.default).name;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state("author", {
	    url: "/author",
	    template: __webpack_require__(164),
	    controller: "AuthorController",
	    controllerAs: "authorCtrl"
	  });
	}

/***/ }),
/* 164 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 translate>Recherche auteurs</h2>\n\n  <form\n    class=\"form-horizontal\"\n    name=\"form_product\"\n    novalidate\n    style=\"margin-top: 15px\"\n  >\n    <div class=\"form-group\">\n      <label class=\"control-label col-sm-3\" for=\"type\"\n        >* {{\"Type d'utilisation\"|translate}} :</label\n      >\n      <div class=\"col-sm-8\">\n        <select\n          class=\"form-control input-lg\"\n          ng-model=\"authorCtrl.selectedProduct\"\n          name=\"type\"\n          required\n          ng-change=\"authorCtrl.productChanged()\"\n          ng-disabled=\"authorCtrl.disabledInput\"\n        >\n          <option ng-repeat=\"option in authorCtrl.products\" ng-value=\"option\">\n            {{authorCtrl.ls.lang=='fr'?option.nameFr:option.nameEn}}\n          </option>\n        </select>\n      </div>\n    </div>\n\n    <div class=\"form-group\">\n      <label class=\"control-label col-sm-3\" for=\"type\"\n        >* {{\"Nom de l'auteur\"|translate}} :</label\n      >\n      <div class=\"col-sm-8\">\n        <input\n          type=\"text\"\n          class=\"form-control input-lg\"\n          ng-model=\"authorCtrl.query\"\n          ng-keydown=\"authorCtrl.searchAuthorsKeyDown()\"\n        />\n        <!--div class=\"input-group input-group-lg\" >\n          <input type=\"text\" class=\"form-control\" ng-model=\"authorCtrl.query\">\n          <span class=\"input-group-btn\">\n            <button type=\"button\" class=\"btn btn-primary\"\n            ng-disabled=\"!authorCtrl.query || authorCtrl.query.length<3\"\n            ng-click=\"authorCtrl.searchAuthors()\">{{\"Rechercher\"|translate}}</button>\n          </span>\n        </div-->\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <div class=\"col-sm-11\">\n        <p align=\"right\">\n          <button\n            type=\"button\"\n            class=\"btn btn-primary btn-lg\"\n            ng-disabled=\"!authorCtrl.query || authorCtrl.query.length<2\"\n            ng-click=\"authorCtrl.searchAuthors()\"\n          >\n            {{\"Rechercher\"|translate}}\n          </button>\n        </p>\n      </div>\n    </div>\n  </form>\n\n  <h3 ng-if=\"authorCtrl.ls.lang=='fr'\" style=\"color: red\">\n    Pour rappel, vous êtes dans le formulaire de recherche des auteurs. Pour\n    poursuivre votre demande d’autorisation, merci de\n    <a href=\"/\">cliquer ici </a>.\n  </h3>\n\n  <h3 ng-if=\"authorCtrl.ls.lang!='fr'\" style=\"color: red\">\n    For reminder, you are in the authors’ search form. To continue your request\n    for permission, please <a href=\"/\">click here </a>.\n  </h3>\n\n  <div class=\"card\" ng-if=\" authorCtrl.query.length>1 && authorCtrl.enabled\">\n    <div class=\"card-header\">\n      <h3 ng-if=\"!authorCtrl.results || authorCtrl.results.length<20\">\n        {{authorCtrl.results.length}} {{\"resultat(s) pour\"|translate}}\n        {{authorCtrl._query}}\n      </h3>\n      <h3 ng-if=\"authorCtrl.results.length>=20\">\n        {{\"Seuls les 20 premiers résultats ont été affichés. Veuillez compléter\n        avec le prénom pour affiner votre recherche.\"|translate}}\n      </h3>\n    </div>\n    <ul class=\"list-group list-group-flush\">\n      <li class=\"list-group-item\" ng-repeat=\"author in authorCtrl.results\">\n        <h4>{{author.label}}</h4>\n        <p ng-if=\"author.isManaged\"><b>Copyright :</b> {{author.copyright}}</p>\n        <p>\n          <b ng-if=\"!author.isManaged\" style=\"color: red\"\n            >{{\"Non géré pour\"|translate}} :</b\n          >\n          <b ng-if=\"author.isManaged\" style=\"color: #4ca54c\"\n            >{{\"Géré pour\"|translate}} :</b\n          >\n          {{authorCtrl.ls.lang == 'fr' ? authorCtrl.selectedProduct.nameFr :\n          authorCtrl.selectedProduct.nameEn}}\n          <b ng-if=\"!author.isManaged\" style=\"color: red\">\n            <i class=\"fa fa-ban\" aria-hidden=\"true\"></i>\n          </b>\n          <b ng-if=\"author.isManaged\" style=\"color: #4ca54c\">\n            <i class=\"fa fa-check\" aria-hidden=\"true\"></i>\n          </b>\n        </p>\n      </li>\n    </ul>\n  </div>\n</div>\n"

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _underscore = __webpack_require__(64);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AuthorController = function () {
	  /*@ngInject*/
	  AuthorController.$inject = ['ElasticAPI', 'ProductAPI', 'LanguageService'];
	  function AuthorController(ElasticAPI, ProductAPI, LanguageService) {
	    _classCallCheck(this, AuthorController);
	
	    var that = this;
	    this.ElasticAPI = ElasticAPI;
	    this.ls = LanguageService;
	    this.products = [];
	    this.results = [];
	    this.rawResults = [];
	    this.enabled = false;
	
	    ProductAPI.getModels().$promise.then(function (response) {
	      response = JSON.parse(JSON.stringify(response));
	      for (var r in response) {
	        that.products.push({
	          id: response[r].id,
	          nameFr: response[r].nameFr,
	          nameEn: response[r].nameEn,
	          rightId: response[r].rightId
	        });
	      }
	      if (that.products && that.products.length > 0) {
	        that.selectedProduct = that.products[0];
	      }
	      return;
	    }).catch(function () {
	      console.log("---> Error on load products type");
	    });
	  }
	
	  _createClass(AuthorController, [{
	    key: "productChanged",
	    value: function productChanged() {
	      this.applyUse();
	    }
	  }, {
	    key: "searchAuthorsKeyDown",
	    value: function searchAuthorsKeyDown() {
	      if (event.keyCode == 13 && this.query && this.query.length > 1) {
	        this.searchAuthors(this.query);
	      }
	    }
	  }, {
	    key: "applyUse",
	    value: function applyUse() {
	      var that = this;
	      this.results = [];
	      if (this.selectedProduct && this.rawResults && this.rawResults.length > 0) {
	        var results = JSON.parse(JSON.stringify(this.rawResults));
	        for (var r in results) {
	          var detail = results[r].detail;
	          results[r].isManaged = _underscore2.default.pluck(detail.rights, "right_id").indexOf(that.selectedProduct.rightId) != -1;
	          results[r].label = (detail.firstname || "") + " " + (detail.lastname || "") + " " + (detail.birth_year || detail.decease_year ? "(" : "") + (detail.birth_year || " ") + (detail.decease_year ? " - " + detail.decease_year : "") + (detail.birth_year || detail.decease_year ? ")" : "");
	          results[r].label = results[r].label.trim();
	          results[r].copyright = detail.copyright;
	        }
	
	        that.results = results;
	      }
	    }
	  }, {
	    key: "searchAuthors",
	    value: function searchAuthors(query) {
	      this.results = null;
	      this.enabled = false;
	      this._query = this.query;
	      var that = this;
	      if (this.query && this.query.length > 1 && this.products.length > 0) {
	        return this.ElasticAPI.searchAuthors({ name: this.query }, function (results) {
	          return results;
	        }).$promise.then(function (results) {
	          results = JSON.parse(JSON.stringify(results));
	          that.rawResults = JSON.parse(JSON.stringify(results));
	          that.applyUse();
	          that.enabled = true;
	          return;
	        });
	      } else {
	        return;
	      }
	    }
	  }]);
	
	  return AuthorController;
	}();
	
	exports.default = AuthorController;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _directDrMemberAuthors = __webpack_require__(167);
	
	var _directDrMemberAuthors2 = _interopRequireDefault(_directDrMemberAuthors);
	
	var _directDrMemberAuthors3 = __webpack_require__(169);
	
	var _directDrMemberAuthors4 = _interopRequireDefault(_directDrMemberAuthors3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module("dalApp.directDrMemberAuthors", ["dalApp.auth", "ui.router"]).config(_directDrMemberAuthors2.default).controller("DirectDrMemberAuthorsController", _directDrMemberAuthors4.default).name;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state("directDrMemberAuthors", {
	    url: "/direct-dr-member-authors",
	    template: __webpack_require__(168),
	    controller: "DirectDrMemberAuthorsController",
	    controllerAs: "directDrMemberAuthorsCtrl"
	  });
	}

/***/ }),
/* 168 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container direct-dr-member-authors-page\">\n  <div class=\"direct-dr-member-authors-lang pull-right\">\n    <button\n      type=\"button\"\n      class=\"btn btn-sm\"\n      ng-click=\"directDrMemberAuthorsCtrl.changeLanguage('fr')\"\n      ng-if=\"directDrMemberAuthorsCtrl.ls.lang != 'fr'\"\n    >\n      Langue : FR\n    </button>\n    <button\n      type=\"button\"\n      class=\"btn btn-sm\"\n      ng-click=\"directDrMemberAuthorsCtrl.changeLanguage('en')\"\n      ng-if=\"directDrMemberAuthorsCtrl.ls.lang != 'en'\"\n    >\n      Language : EN\n    </button>\n  </div>\n  <div class=\"clearfix\"></div>\n\n  <h2 translate>Répertoire des auteurs</h2>\n\n  <form\n    class=\"form-inline direct-dr-member-authors-form\"\n    name=\"form_direct_dr_authors\"\n    novalidate\n    style=\"margin-top: 15px\"\n  >\n    <div class=\"form-group\">\n      <label class=\"sr-only\" for=\"directDrAuthorName\" translate\n        >Nom de l'auteur</label\n      >\n      <input\n        id=\"directDrAuthorName\"\n        type=\"text\"\n        class=\"form-control input-search input-lg\"\n        ng-model=\"directDrMemberAuthorsCtrl.query\"\n        placeholder=\"{{wantedCtrl.lang=='fr'? 'Tapez le nom de l\\'auteur' : 'Enter artist name'}}\"\n        ng-keydown=\"directDrMemberAuthorsCtrl.searchKeyDown($event)\"\n      />\n    </div>\n    <button\n      type=\"button\"\n      class=\"btn btn-danger btn-lg\"\n      ng-disabled=\"!directDrMemberAuthorsCtrl.query || directDrMemberAuthorsCtrl.query.length < 2\"\n      ng-click=\"directDrMemberAuthorsCtrl.searchDirectDrMemberAuthors()\"\n      translate\n    >\n      Rechercher\n    </button>\n  </form>\n\n  <div\n    class=\"card\"\n    ng-if=\"directDrMemberAuthorsCtrl.query.length > 1 && directDrMemberAuthorsCtrl.enabled\"\n  >\n    <div class=\"card-header\">\n      <h3\n        ng-if=\"!directDrMemberAuthorsCtrl.results || directDrMemberAuthorsCtrl.results.length < 20\"\n      >\n        {{ directDrMemberAuthorsCtrl.results.length }} {{\"resultat(s)\n        pour\"|translate}} {{ directDrMemberAuthorsCtrl._query }}\n      </h3>\n      <h3 ng-if=\"directDrMemberAuthorsCtrl.results.length >= 20\">\n        {{\"Seulement les 20 premiers résultats sont affichés. Veuillez affiner\n        votre recherche pour voir des résultats plus pertinents.\"|translate}}\n      </h3>\n    </div>\n    <ul class=\"list-group list-group-flush\">\n      <li\n        class=\"list-group-item\"\n        ng-repeat=\"row in directDrMemberAuthorsCtrl.results\"\n      >\n        <h4>{{ row.label }}</h4>\n        <p ng-if=\"row.copyright\">\n          <b translate>Copyright :</b> {{ row.copyright }}\n        </p>\n      </li>\n    </ul>\n  </div>\n</div>\n"

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DirectDrMemberAuthorsController = function () {
	  /*@ngInject*/
	  DirectDrMemberAuthorsController.$inject = ['ElasticAPI', 'LanguageService', '$window'];
	  function DirectDrMemberAuthorsController(ElasticAPI, LanguageService, $window) {
	    _classCallCheck(this, DirectDrMemberAuthorsController);
	
	    this.ElasticAPI = ElasticAPI;
	    this.ls = LanguageService;
	    this.$window = $window;
	    this.results = [];
	    this.enabled = false;
	    this._query = null;
	    this.query = "";
	  }
	
	  _createClass(DirectDrMemberAuthorsController, [{
	    key: "changeLanguage",
	    value: function changeLanguage(lang) {
	      this.ls.set(lang);
	      this.$window.location.reload();
	    }
	  }, {
	    key: "buildResultLabel",
	    value: function buildResultLabel(detail) {
	      var label = (detail.firstname || "") + " " + (detail.lastname || "") + " " + (detail.birth_year || detail.decease_year ? "(" : "") + (detail.birth_year || " ") + (detail.decease_year ? " - " + detail.decease_year : "") + (detail.birth_year || detail.decease_year ? ")" : "");
	      return label.trim();
	    }
	  }, {
	    key: "searchKeyDown",
	    value: function searchKeyDown($event) {
	      if ($event.keyCode === 13 && this.query && this.query.length > 1) {
	        this.searchDirectDrMemberAuthors();
	      }
	    }
	  }, {
	    key: "searchDirectDrMemberAuthors",
	    value: function searchDirectDrMemberAuthors() {
	      this.results = null;
	      this.enabled = false;
	      this._query = this.query;
	      var that = this;
	      if (!(this.query && this.query.length > 1)) {
	        return;
	      }
	      return this.ElasticAPI.searchDirectDrMemberAuthors({ name: this.query }, function (results) {
	        return results;
	      }).$promise.then(function (results) {
	        results = JSON.parse(JSON.stringify(results));
	        for (var r in results) {
	          var detail = results[r].detail;
	          results[r].label = that.buildResultLabel(detail);
	          results[r].copyright = detail.copyright;
	        }
	        that.results = results;
	        that.enabled = true;
	      });
	    }
	  }]);
	
	  return DirectDrMemberAuthorsController;
	}();
	
	exports.default = DirectDrMemberAuthorsController;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NavbarComponent = undefined;
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NavbarComponent = exports.NavbarComponent = ['Auth', '$location', function NavbarComponent(Auth, $location) {
	  'ngInject';
	
	  _classCallCheck(this, NavbarComponent);
	
	  this.menu = [];
	  this.isCollapsed = true;
	  this.isLoggedIn = Auth.isLoggedInSync;
	  this.pathTitle = Auth.pathTitle;
	  this.isAdmin = Auth.isAdminSync;
	  this.getCurrentUser = Auth.getCurrentUserSync;
	  this.location = $location;
	  this.show = true;
	
	  if ($location.path() == "/wanted" || $location.path() == "/direct-dr-member-authors") {
	    this.show = false;
	  }
	}];
	
	exports.default = _angular2.default.module('directives.navbar', []).component('navbar', {
	  template: __webpack_require__(171),
	  controller: NavbarComponent
	}).name;

/***/ }),
/* 171 */
/***/ (function(module, exports) {

	module.exports = "<nav class=\"navbar navbar-perso\" ng-if=\"$ctrl.show\">\n  <div class=\"container-fluid\">\n    <div class=\"navbar-header\">\n\n      <li ui-sref-active=\"active\" uib-dropdown ng-if=\"!$ctrl.isLoggedIn()\" class=\"menu-icon\">\n        <a href=\"#\" class=\"dropdown-toggle navbar-brand\" uib-dropdown-toggle data-toggle=\"dropdown\" role=\"button\"\n          aria-haspopup=\"true\" aria-expanded=\"false\">\n          <i class=\"fa fa-bars\" aria-hidden=\"true\"></i>\n        </a>\n        <ul class=\"dropdown-menu navbar-brand-dropdown\">\n          <li>\n            <a href=\"/\" class=\"nav-popup-li\">\n              {{\"Connexion\"|translate}}<i class=\"fa fa-sign-in\" aria-hidden=\"true\"></i>\n            </a>\n          </li>\n          <li>\n            <a href=\"/signup\" class=\"nav-popup-li\">\n              {{\"Inscription\"|translate}}<i class=\"fa fa-user\" aria-hidden=\"true\"></i>\n            </a>\n          </li>\n          <li>\n            <a href=\"/forgotten\" class=\"nav-popup-li\">\n              {{\"Mot de passe oublié\"|translate}}<i class=\"fa fa-lock\" aria-hidden=\"true\"></i>\n            </a>\n          </li>\n          <li role=\"separator\" class=\"divider\"></li>\n          <li>\n            <a href=\"/author\" class=\"nav-popup-li\">\n              {{\"Recherche auteurs\"|translate}}<i class=\"fa fa-search\" aria-hidden=\"true\"></i>\n            </a>\n          </li>\n          <li role=\"separator\" class=\"divider\"></li>\n          <li ng-controller=\"LanguageController\">\n            <a href=\"#\" class=\"nav-popup-li\" ng-click=\"changeLanguage('fr')\" ng-if=\"lang!='fr'\">\n              Version française <i class=\"fa fa-globe\" aria-hidden=\"true\"></i></a>\n            <a href=\"#\" class=\"nav-popup-li\" ng-click=\"changeLanguage('en')\" ng-if=\"lang!='en'\">\n              English version <i class=\"fa fa-globe\" aria-hidden=\"true\"></i></a>\n          </li>\n        </ul>\n        <p class=\"navbar-brand\" id=\"brand-text\"><span>{{$ctrl.pathTitle()}}</span></p>\n      </li>\n\n      <li ui-sref-active=\"active\" uib-dropdown ng-if=\"$ctrl.isLoggedIn()\" class=\"menu-icon\">\n        <a href=\"#\" class=\"dropdown-toggle navbar-brand\" uib-dropdown-toggle data-toggle=\"dropdown\" role=\"button\"\n          aria-haspopup=\"true\" aria-expanded=\"false\">\n          <i class=\"fa fa-bars\" aria-hidden=\"true\"></i>\n        </a>\n        <ul class=\"dropdown-menu navbar-brand-dropdown\">\n          <li>\n            <a ui-sref=\"permission\" class=\"nav-popup-li\">\n              {{\"Liste des projets / demandes\"|translate}}\n              <i class=\"fa fa-folder-open\" aria-hidden=\"true\"></i>\n            </a>\n          </li>\n          <li role=\"separator\" class=\"divider\"></li>\n          <li>\n            <a ui-sref=\"settings\" class=\"nav-popup-li\">\n              {{\"Mot de passe\"|translate}}\n              <i class=\"fa fa-cog\" aria-hidden=\"true\"></i>\n            </a>\n          </li>\n          <li>\n            <a ui-sref=\"logout\" class=\"nav-popup-li\">\n              {{\"Déconnexion\"|translate}}\n              <i class=\"fa fa-sign-out\" aria-hidden=\"true\"></i>\n            </a>\n          </li>\n          <li role=\"separator\" class=\"divider\"></li>\n          <li>\n            <a href=\"/author\" class=\"nav-popup-li\">\n              {{\"Recherche auteurs\"|translate}}<i class=\"fa fa-search\" aria-hidden=\"true\"></i>\n            </a>\n          </li>\n          <li role=\"separator\" class=\"divider\"></li>\n          <li ng-controller=\"LanguageController\">\n            <a href=\"#\" class=\"nav-popup-li\" ng-click=\"changeLanguage('fr')\" ng-if=\"lang!='fr'\">\n              Version française <i class=\"fa fa-globe\" aria-hidden=\"true\"></i></a>\n            <a href=\"#\" class=\"nav-popup-li\" ng-click=\"changeLanguage('en')\" ng-if=\"lang!='en'\">\n              English version <i class=\"fa fa-globe\" aria-hidden=\"true\"></i></a>\n          </li>\n        </ul>\n        <p class=\"navbar-brand\" id=\"brand-text\"><span>{{$ctrl.pathTitle()}}</span></p>\n      </li>\n\n    </div>\n\n    <p id=\"user-name\">\n      <span ng-if=\"$ctrl.isLoggedIn()\">{{ $ctrl.getCurrentUser().name }}</span>\n      <span ng-controller=\"LanguageController\" style=\"margin-left: 10px;\">\n        <button class=\"btn btn-sm btn-lang\" ng-click=\"changeLanguage('fr')\" ng-if=\"lang!='fr'\">\n          FR\n        </button>\n        <button class=\"btn btn-sm btn-lang\" ng-click=\"changeLanguage('en')\" ng-if=\"lang!='en'\">\n          EN\n        </button>\n      </span>\n    </p>\n\n\n    <!--div uib-collapse=\"$ctrl.isCollapsed\" class=\"navbar-collapse collapse\" id=\"navbar-main\"></div-->\n    <!-- /.navbar-collapse -->\n  </div><!-- /.container-fluid -->\n</nav>\n"

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FooterComponent = undefined;
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FooterComponent = exports.FooterComponent = ['screenSize', '$location', function FooterComponent(screenSize, $location) {
	  'ngInject';
	
	  _classCallCheck(this, FooterComponent);
	
	  var that = this;
	  this.isScreenSize = screenSize.is;
	  this.mobile = screenSize.is('xs');
	  this.mobile = screenSize.on('xs', function (match) {
	    that.mobile = match;
	  });
	
	  this.show = true;
	
	  if ($location.path() == "/wanted" || $location.path() == "/direct-dr-member-authors") {
	    this.show = false;
	  }
	}];
	
	exports.default = _angular2.default.module('directives.footer', []).component('footer', {
	  template: __webpack_require__(173),
	  controller: FooterComponent
	}).name;

/***/ }),
/* 173 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"footer-navbar navbar navbar-inverse navbar-fixed-bottom\" ng-if=\"$ctrl.show\"\n  style=\"min-height:10px !important;\">\n  <p style=\"margin:5px 0px; font-size:0.8em;\">\n    <a href=\"https://www.adagp.fr/\" target=\"_blank\"> Adagp</a> |\n    <a href=\"/contact\"> Contact</a> |\n    <a href=\"/legal\" translate> Mentions légales</a> |\n    <span style=\"color: black;\">Conception et développement : Adagp</span>\n  </p>\n</div>\n"

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MainController = undefined;
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(24);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _main = __webpack_require__(175);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _login = __webpack_require__(176);
	
	var _login2 = _interopRequireDefault(_login);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MainController =
	
	/*@ngInject*/
	exports.MainController = ['$http', '$location', 'Auth', '$state', 'LanguageService', function MainController($http, $location, Auth, $state, LanguageService) {
	  "ngInject";
	
	  _classCallCheck(this, MainController);
	
	  this.user = {};
	  this.$http = $http;
	  this.location = $location;
	  this.ls = LanguageService;
	
	  Auth.isLoggedIn().then(function (is) {
	    if (!is) {
	      return;
	    }
	    $state.go("permission");
	    return;
	  });
	
	  this.parameters = $location.search();
	  if (this.parameters && this.parameters.data) {
	    this.forgottenView = true;
	    this.resetPasswordView = true;
	  }
	}];
	
	exports.default = _angular2.default.module("dalApp.main", [_angularUiRouter2.default, _login2.default]).config(_main2.default).component("main", {
	  template: __webpack_require__(178),
	  controller: MainController
	}).name;

/***/ }),
/* 175 */
/***/ (function(module, exports) {

	"use strict";
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state("main", {
	    url: "/",
	    template: "<main></main>"
	  });
	}

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var loginComponent = exports.loginComponent = function () {
	
	  /*@ngInject*/
	  loginComponent.$inject = ['Auth', '$state', 'LanguageService'];
	  function loginComponent(Auth, $state, LanguageService) {
	    "ngInject";
	
	    _classCallCheck(this, loginComponent);
	
	    this.user = {
	      name: "",
	      email: "",
	      password: ""
	    };
	    this.errors = {
	      other: undefined
	    };
	    this.submitted = false;
	    this.Auth = Auth;
	    this.$state = $state;
	    this.ls = LanguageService;
	    this.showHomeMsg = +new Date() < +new Date("2025-01-02");
	  }
	  /*@ngInject*/
	
	
	  _createClass(loginComponent, [{
	    key: "login",
	    value: function login(form) {
	      var _this = this;
	
	      this.submitted = true;
	      this.errors.other = undefined;
	      this.errors.disabled = undefined;
	      if (form.$valid) {
	        this.Auth.login({
	          email: this.user.email,
	          password: this.user.password
	        }).then(function () {
	          _this.$state.go("permission");
	        }).catch(function (err) {
	          if (err) {
	            if (err.message == "This account is not enabled.") {
	              _this.errors.disabled = true;
	            } else {
	              _this.errors.other = err.message;
	            }
	          }
	        });
	      }
	    }
	  }]);
	
	  return loginComponent;
	}();
	
	exports.default = angular.module("dalApp.login", []).component("login", {
	  template: __webpack_require__(177),
	  controller: loginComponent
	}).name;

/***/ }),
/* 177 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"panel panel-dal\">\n  <div class=\"panel-body\">\n    <h2 class=\"main-header-title\">\n      <img src=\"assets/images/logo_adagp_64.png\" alt=\"Logo\" class=\"main-logo\" />\n      {{\"Connexion\"|translate}}\n    </h2>\n\n    <p class=\"main-header-text\" translate>\n      Veuillez-vous identifier pour accéder à vos demandes d'autorisation\n    </p>\n    <form\n      class=\"form\"\n      name=\"form_login\"\n      ng-submit=\"$ctrl.login(form_login)\"\n      novalidate\n    >\n      <div class=\"form-group\">\n        <!--label>{{'E-mail'|translate}}: </label-->\n        <input\n          type=\"email\"\n          name=\"email\"\n          class=\"form-control input-lg\"\n          ng-model=\"$ctrl.user.email\"\n          required\n          placeholder=\"{{'E-mail'|translate}}\"\n        />\n      </div>\n\n      <div class=\"form-group\">\n        <!--label >{{'Mot de passe'|translate}}: </label-->\n        <input\n          type=\"password\"\n          name=\"password\"\n          class=\"form-control input-lg\"\n          ng-model=\"$ctrl.user.password\"\n          required\n          placeholder=\"{{'Mot de passe'|translate}}\"\n        />\n      </div>\n\n      <div class=\"form-group has-error\">\n        <p\n          class=\"help-block\"\n          ng-show=\"(form_login.email.$error.required\n        || form_login.password.$error.required) && $ctrl.submitted\"\n          translate\n        >\n          Veuillez saisir votre adresse e-mail et votre mot de passe.\n        </p>\n        <p\n          class=\"help-block\"\n          ng-show=\"form_login.email.$error.email && $ctrl.submitted\"\n          translate\n        >\n          Veuillez saisir une adresse e-mail valide.\n        </p>\n\n        <p class=\"help-block\" ng-if=\"$ctrl.errors.other\" translate>\n          E-mail ou mot de passe incorrect\n        </p>\n        <p class=\"help-block\" ng-if=\"$ctrl.errors.disabled\" translate>\n          Ce compte est désactivé. Veuillez réinitialiser le mot de passe pour\n          l'activer.\n        </p>\n        <p align=\"right\">\n          <a href=\"/forgotten\" translate>Mot de passe oublié</a>\n        </p>\n      </div>\n\n      <button class=\"btn btn-danger btn-lg btn-block\" type=\"submit\" translate>\n        Se connecter\n      </button>\n\n      <div ng-if=\"$ctrl.ls.lang == 'fr' && $ctrl.showHomeMsg \">\n        <h3 style=\"color: #bd0e38\">\n          <i>Trêve des confiseurs pour l’ADAGP</i>\n        </h3>\n        <p style=\"color: #bd0e38\">\n          <i>\n            L’ADAGP sera fermée du mercredi 25 décembre au mercredi 1er janvier\n            inclus. Les demandes seront traitées au retour des équipes, à partir\n            du jeudi 2 janvier 2025.\n            <br />\n            Nous vous souhaitons de très belles fêtes de fin d’année !\n          </i>\n        </p>\n      </div>\n      <div ng-if=\"$ctrl.ls.lang != 'fr' && $ctrl.showHomeMsg \">\n        <h3 style=\"color: #bd0e38\">\n          <i>Christmas Break</i>\n        </h3>\n        <p style=\"color: #bd0e38\">\n          <i>\n            The ADAGP premices will be closing for the Christmas period from\n            Wednesday 25th December 2024 until Wednesday 1st January 2025. We\n            wish you a very happy Christmas break and we will process your\n            request in the new year!\n          </i>\n        </p>\n      </div>\n    </form>\n  </div>\n</div>\n\n<div class=\"panel panel-dal\">\n  <div class=\"panel-body\">\n    <p class=\"main-header-text\" translate>\n      Si vous n'avez pas encore créé de compte, veuillez vous inscrire\n    </p>\n    <a href=\"/signup\" class=\"btn btn-danger btn-lg btn-block\" translate>\n      Créer un compte</a\n    >\n  </div>\n</div>\n"

/***/ }),
/* 178 */
/***/ (function(module, exports) {

	module.exports = "<!--header class=\"hero-unit\" id=\"banner\">\n  <div class=\"container\">\n    <h1>'Allo, 'Allo!</h1>\n    <p class=\"lead\">Kick-start your next web app with Angular Fullstack</p>\n    <img src=\"assets/images/yeoman.png\" alt=\"I'm Yeoman\">\n  </div>\n</header-->\n<!--div class=\"jumbotron dal-jumbotron text-center\" >\n  <img class=\"img-circle\" src=\"assets/images/logo100.png\" alt=\"Adagp\">\n  <h2 align=\"center\" translate>Welcome</h2>\n  <p class=\"lead\" translate>Make your online request for permission</p>\n</div-->\n\n<!-- <div style=\"margin: 5px 5% -2% 5%; \" ng-if=\"$ctrl.ls.lang == 'fr' \">\n  <p>\n    Après l’interruption due à OVH, le service de <b>Demande d’autorisation en ligne est à nouveau accessible</b>, mais\n    certaines données ont été endommagées.\n  </p>\n  <p>\n    - Si vous avez créé votre compte <u>après le 6 janvier 2021</u> : vous devrez <b>recréer un compte</b>\n    (<a href=\"https://demande.adagp.fr/signup\">https://demande.adagp.fr/signup</a> )\n  </p>\n  <p>\n    - Si votre création de compte est <u>antérieure au 6 janvier 2021</u>, <b>votre identifiant et votre mot de passe\n      restent\n      actifs.</b>\n    <br>\n    Toutefois, <u>si depuis le 6 janvier, vous avez effectué des demandes d’autorisation</u> qui sont restées « en cours\n    de saisie » sur votre Espace utilisateur, les données sont malheureusement perdues. Si depuis lors, vous n’avez pas\n    effectué cette demande <b>à nos services par mail, vous devrez à nouveau compléter le formulaire de demande sur\n      l’Espace utilisateur.</b>\n  </p>\n\n  <p>\n    En vous remerciant pour votre compréhension et votre patience face à ce désagrément bien indépendant de notre\n    volonté,<br>\n    Bien cordialement,\n    <br><br>\n\n    L’équipe de l’ADAGP\n\n  </p>\n</div>\n\n<div style=\"margin: 5px 5% -2% 5%; \" ng-if=\"$ctrl.ls.lang != 'fr' \">\n  <p>\n    After the disruption due to OVH, the <b>Online Authorization Request service can be accessed again</b>, but some\n    data has been damaged.\n  </p>\n  <p>\n    - If you created your account <u>after January 6, 2021</u> : you will have to <b>recreate an account</b>\n    (<a href=\"https://demande.adagp.fr/signup\">https://demande.adagp.fr/signup</a> )\n  </p>\n  <p>\n    - If your account creation is <u>prior to January 6, 2021</u>, <b>your username and password remain active.</b>\n    <br>\n    However, <u>if since January 6, you have made authorization requests </u> that have remained \"in the process \" in\n    your User Space, the data is unfortunately lost. If since then you have not made this request to our services by\n    email, you will have to <b>complete the request form again in the User Space.</b>\n  </p>\n\n  <p>\n    Thank you for your understanding and your patience in the face of this inconvenience beyond our control,<br>\n    Best regards,\n    <br><br>\n\n    The ADAGP team\n\n  </p>\n</div> -->\n\n<div id=\"main-container\" class=\"container-fluid\">\n  <login></login>\n</div>\n"

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FilesComponent = undefined;
	
	var _files = __webpack_require__(180);
	
	var _files2 = _interopRequireDefault(_files);
	
	var _product = __webpack_require__(153);
	
	var _product2 = _interopRequireDefault(_product);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(1);
	
	var uiRouter = __webpack_require__(24);
	
	var FilesComponent =
	/*@ngInject*/
	exports.FilesComponent = ['$location', 'ProductAPI', function FilesComponent($location, ProductAPI) {
	  "ngInject";
	
	  _classCallCheck(this, FilesComponent);
	
	  this.location = $location;
	  this.file = $location.search().file;
	  this.params = this.file.split("-");
	  this.files = [];
	  this.notFound = false;
	  var that = this;
	  if (this.file && this.params.length === 3) {
	    ProductAPI.getFileInput({
	      inputId: parseInt(this.params[0]),
	      demandId: parseInt(this.params[1]),
	      createdBy: parseInt(this.params[2])
	    }).$promise.then(function (input) {
	      if (input) {
	        that.files = input.filePaths;
	      } else {
	        that.notFound = true;
	      }
	      return;
	    }).catch(function () {
	      that.notFound = true;
	    });
	  } else {
	    this.notFound = true;
	  }
	}];
	
	exports.default = angular.module("dalApp.files", [uiRouter, _product2.default]).config(_files2.default).component("files", {
	  template: __webpack_require__(181),
	  controller: FilesComponent,
	  controllerAs: "filesCtrl"
	}).name;

/***/ }),
/* 180 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state("files", {
	    url: "/files",
	    template: "<files></files>"
	  });
	}];

/***/ }),
/* 181 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div ng-if=\"filesCtrl.files.length>0\">\n    <h2 translate>Fichiers:</h2>\n    <ul>\n      <li ng-repeat=\"file in filesCtrl.files\">\n        <i\n          class=\"fa fa-download\"\n          aria-hidden=\"true\"\n          style=\"margin-right: 5px\"\n        ></i>\n        <a href=\"{{file.url}}\" target=\"_blank\" download\n          >{{file.originalname}}</a\n        >\n      </li>\n    </ul>\n  </div>\n\n  <div ng-if=\"filesCtrl.notFound\">\n    <h1 align=\"center\">404</h1>\n    <h1 align=\"center\">Page not found</h1>\n  </div>\n</div>\n"

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Socket.$inject = ['socketFactory'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(38);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _socket = __webpack_require__(183);
	
	var _socket2 = _interopRequireDefault(_socket);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function Socket(socketFactory) {
	  'ngInject';
	
	  var ioSocket = (0, _socket2.default)('', {
	    path: '/socket.io-client'
	  });
	
	  var socket = socketFactory({
	    ioSocket: ioSocket
	  });
	
	  return {
	    socket: socket,
	
	    syncUpdates: function syncUpdates(modelName, array, cb) {
	      cb = cb || _angular2.default.noop;
	
	      socket.on(modelName + ':save', function (item) {
	        var oldItem = _.find(array, {
	          _id: item._id
	        });
	        var index = array.indexOf(oldItem);
	        var event = 'created';
	
	        if (oldItem) {
	          array.splice(index, 1, item);
	          event = 'updated';
	        } else {
	          array.push(item);
	        }
	
	        cb(event, item, array);
	      });
	
	      socket.on(modelName + ':remove', function (item) {
	        var event = 'deleted';
	        _.remove(array, {
	          _id: item._id
	        });
	        cb(event, item, array);
	      });
	    },
	    unsyncUpdates: function unsyncUpdates(modelName) {
	      socket.removeAllListeners(modelName + ':save');
	      socket.removeAllListeners(modelName + ':remove');
	    }
	  };
	}
	
	exports.default = _angular2.default.module('dalApp.socket', []).factory('socket', Socket).name;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var url = __webpack_require__(184);
	var parser = __webpack_require__(190);
	var Manager = __webpack_require__(200);
	var debug = __webpack_require__(186)('socket.io-client');
	
	/**
	 * Module exports.
	 */
	
	module.exports = exports = lookup;
	
	/**
	 * Managers cache.
	 */
	
	var cache = exports.managers = {};
	
	/**
	 * Looks up an existing `Manager` for multiplexing.
	 * If the user summons:
	 *
	 *   `io('http://localhost/a');`
	 *   `io('http://localhost/b');`
	 *
	 * We reuse the existing instance based on same scheme/port/host,
	 * and we initialize sockets for each namespace.
	 *
	 * @api public
	 */
	
	function lookup (uri, opts) {
	  if (typeof uri === 'object') {
	    opts = uri;
	    uri = undefined;
	  }
	
	  opts = opts || {};
	
	  var parsed = url(uri);
	  var source = parsed.source;
	  var id = parsed.id;
	  var path = parsed.path;
	  var sameNamespace = cache[id] && path in cache[id].nsps;
	  var newConnection = opts.forceNew || opts['force new connection'] ||
	                      false === opts.multiplex || sameNamespace;
	
	  var io;
	
	  if (newConnection) {
	    debug('ignoring socket cache for %s', source);
	    io = Manager(source, opts);
	  } else {
	    if (!cache[id]) {
	      debug('new io instance for %s', source);
	      cache[id] = Manager(source, opts);
	    }
	    io = cache[id];
	  }
	  if (parsed.query && !opts.query) {
	    opts.query = parsed.query;
	  } else if (opts && 'object' === typeof opts.query) {
	    opts.query = encodeQueryString(opts.query);
	  }
	  return io.socket(parsed.path, opts);
	}
	/**
	 *  Helper method to parse query objects to string.
	 * @param {object} query
	 * @returns {string}
	 */
	function encodeQueryString (obj) {
	  var str = [];
	  for (var p in obj) {
	    if (obj.hasOwnProperty(p)) {
	      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
	    }
	  }
	  return str.join('&');
	}
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	exports.protocol = parser.protocol;
	
	/**
	 * `connect`.
	 *
	 * @param {String} uri
	 * @api public
	 */
	
	exports.connect = lookup;
	
	/**
	 * Expose constructors for standalone build.
	 *
	 * @api public
	 */
	
	exports.Manager = __webpack_require__(200);
	exports.Socket = __webpack_require__(231);


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module dependencies.
	 */
	
	var parseuri = __webpack_require__(185);
	var debug = __webpack_require__(186)('socket.io-client:url');
	
	/**
	 * Module exports.
	 */
	
	module.exports = url;
	
	/**
	 * URL parser.
	 *
	 * @param {String} url
	 * @param {Object} An object meant to mimic window.location.
	 *                 Defaults to window.location.
	 * @api public
	 */
	
	function url (uri, loc) {
	  var obj = uri;
	
	  // default to window.location
	  loc = loc || global.location;
	  if (null == uri) uri = loc.protocol + '//' + loc.host;
	
	  // relative path support
	  if ('string' === typeof uri) {
	    if ('/' === uri.charAt(0)) {
	      if ('/' === uri.charAt(1)) {
	        uri = loc.protocol + uri;
	      } else {
	        uri = loc.host + uri;
	      }
	    }
	
	    if (!/^(https?|wss?):\/\//.test(uri)) {
	      debug('protocol-less url %s', uri);
	      if ('undefined' !== typeof loc) {
	        uri = loc.protocol + '//' + uri;
	      } else {
	        uri = 'https://' + uri;
	      }
	    }
	
	    // parse
	    debug('parse %s', uri);
	    obj = parseuri(uri);
	  }
	
	  // make sure we treat `localhost:80` and `localhost` equally
	  if (!obj.port) {
	    if (/^(http|ws)$/.test(obj.protocol)) {
	      obj.port = '80';
	    } else if (/^(http|ws)s$/.test(obj.protocol)) {
	      obj.port = '443';
	    }
	  }
	
	  obj.path = obj.path || '/';
	
	  var ipv6 = obj.host.indexOf(':') !== -1;
	  var host = ipv6 ? '[' + obj.host + ']' : obj.host;
	
	  // define unique id
	  obj.id = obj.protocol + '://' + host + ':' + obj.port;
	  // define href
	  obj.href = obj.protocol + '://' + host + (loc && loc.port === obj.port ? '' : (':' + obj.port));
	
	  return obj;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 185 */
/***/ (function(module, exports) {

	/**
	 * Parses an URI
	 *
	 * @author Steven Levithan <stevenlevithan.com> (MIT license)
	 * @api private
	 */
	
	var re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
	
	var parts = [
	    'source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'
	];
	
	module.exports = function parseuri(str) {
	    var src = str,
	        b = str.indexOf('['),
	        e = str.indexOf(']');
	
	    if (b != -1 && e != -1) {
	        str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
	    }
	
	    var m = re.exec(str || ''),
	        uri = {},
	        i = 14;
	
	    while (i--) {
	        uri[parts[i]] = m[i] || '';
	    }
	
	    if (b != -1 && e != -1) {
	        uri.source = src;
	        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
	        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
	        uri.ipv6uri = true;
	    }
	
	    return uri;
	};


/***/ }),
/* 186 */
[511, 188],
/* 187 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 188 */
[512, 189],
/* 189 */
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000
	var m = s * 60
	var h = m * 60
	var d = h * 24
	var y = d * 365.25
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} options
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function (val, options) {
	  options = options || {}
	  var type = typeof val
	  if (type === 'string' && val.length > 0) {
	    return parse(val)
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ?
				fmtLong(val) :
				fmtShort(val)
	  }
	  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val))
	}
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str)
	  if (str.length > 10000) {
	    return
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str)
	  if (!match) {
	    return
	  }
	  var n = parseFloat(match[1])
	  var type = (match[2] || 'ms').toLowerCase()
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n
	    default:
	      return undefined
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd'
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h'
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm'
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's'
	  }
	  return ms + 'ms'
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms'
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's'
	}


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var debug = __webpack_require__(191)('socket.io-parser');
	var json = __webpack_require__(194);
	var Emitter = __webpack_require__(196);
	var binary = __webpack_require__(197);
	var isBuf = __webpack_require__(199);
	
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	exports.protocol = 4;
	
	/**
	 * Packet types.
	 *
	 * @api public
	 */
	
	exports.types = [
	  'CONNECT',
	  'DISCONNECT',
	  'EVENT',
	  'ACK',
	  'ERROR',
	  'BINARY_EVENT',
	  'BINARY_ACK'
	];
	
	/**
	 * Packet type `connect`.
	 *
	 * @api public
	 */
	
	exports.CONNECT = 0;
	
	/**
	 * Packet type `disconnect`.
	 *
	 * @api public
	 */
	
	exports.DISCONNECT = 1;
	
	/**
	 * Packet type `event`.
	 *
	 * @api public
	 */
	
	exports.EVENT = 2;
	
	/**
	 * Packet type `ack`.
	 *
	 * @api public
	 */
	
	exports.ACK = 3;
	
	/**
	 * Packet type `error`.
	 *
	 * @api public
	 */
	
	exports.ERROR = 4;
	
	/**
	 * Packet type 'binary event'
	 *
	 * @api public
	 */
	
	exports.BINARY_EVENT = 5;
	
	/**
	 * Packet type `binary ack`. For acks with binary arguments.
	 *
	 * @api public
	 */
	
	exports.BINARY_ACK = 6;
	
	/**
	 * Encoder constructor.
	 *
	 * @api public
	 */
	
	exports.Encoder = Encoder;
	
	/**
	 * Decoder constructor.
	 *
	 * @api public
	 */
	
	exports.Decoder = Decoder;
	
	/**
	 * A socket.io Encoder instance
	 *
	 * @api public
	 */
	
	function Encoder() {}
	
	/**
	 * Encode a packet as a single string if non-binary, or as a
	 * buffer sequence, depending on packet type.
	 *
	 * @param {Object} obj - packet object
	 * @param {Function} callback - function to handle encodings (likely engine.write)
	 * @return Calls callback with Array of encodings
	 * @api public
	 */
	
	Encoder.prototype.encode = function(obj, callback){
	  debug('encoding packet %j', obj);
	
	  if (exports.BINARY_EVENT == obj.type || exports.BINARY_ACK == obj.type) {
	    encodeAsBinary(obj, callback);
	  }
	  else {
	    var encoding = encodeAsString(obj);
	    callback([encoding]);
	  }
	};
	
	/**
	 * Encode packet as string.
	 *
	 * @param {Object} packet
	 * @return {String} encoded
	 * @api private
	 */
	
	function encodeAsString(obj) {
	  var str = '';
	  var nsp = false;
	
	  // first is type
	  str += obj.type;
	
	  // attachments if we have them
	  if (exports.BINARY_EVENT == obj.type || exports.BINARY_ACK == obj.type) {
	    str += obj.attachments;
	    str += '-';
	  }
	
	  // if we have a namespace other than `/`
	  // we append it followed by a comma `,`
	  if (obj.nsp && '/' != obj.nsp) {
	    nsp = true;
	    str += obj.nsp;
	  }
	
	  // immediately followed by the id
	  if (null != obj.id) {
	    if (nsp) {
	      str += ',';
	      nsp = false;
	    }
	    str += obj.id;
	  }
	
	  // json data
	  if (null != obj.data) {
	    if (nsp) str += ',';
	    str += json.stringify(obj.data);
	  }
	
	  debug('encoded %j as %s', obj, str);
	  return str;
	}
	
	/**
	 * Encode packet as 'buffer sequence' by removing blobs, and
	 * deconstructing packet into object with placeholders and
	 * a list of buffers.
	 *
	 * @param {Object} packet
	 * @return {Buffer} encoded
	 * @api private
	 */
	
	function encodeAsBinary(obj, callback) {
	
	  function writeEncoding(bloblessData) {
	    var deconstruction = binary.deconstructPacket(bloblessData);
	    var pack = encodeAsString(deconstruction.packet);
	    var buffers = deconstruction.buffers;
	
	    buffers.unshift(pack); // add packet info to beginning of data list
	    callback(buffers); // write all the buffers
	  }
	
	  binary.removeBlobs(obj, writeEncoding);
	}
	
	/**
	 * A socket.io Decoder instance
	 *
	 * @return {Object} decoder
	 * @api public
	 */
	
	function Decoder() {
	  this.reconstructor = null;
	}
	
	/**
	 * Mix in `Emitter` with Decoder.
	 */
	
	Emitter(Decoder.prototype);
	
	/**
	 * Decodes an ecoded packet string into packet JSON.
	 *
	 * @param {String} obj - encoded packet
	 * @return {Object} packet
	 * @api public
	 */
	
	Decoder.prototype.add = function(obj) {
	  var packet;
	  if ('string' == typeof obj) {
	    packet = decodeString(obj);
	    if (exports.BINARY_EVENT == packet.type || exports.BINARY_ACK == packet.type) { // binary packet's json
	      this.reconstructor = new BinaryReconstructor(packet);
	
	      // no attachments, labeled binary but no binary data to follow
	      if (this.reconstructor.reconPack.attachments === 0) {
	        this.emit('decoded', packet);
	      }
	    } else { // non-binary full packet
	      this.emit('decoded', packet);
	    }
	  }
	  else if (isBuf(obj) || obj.base64) { // raw binary data
	    if (!this.reconstructor) {
	      throw new Error('got binary data when not reconstructing a packet');
	    } else {
	      packet = this.reconstructor.takeBinaryData(obj);
	      if (packet) { // received final buffer
	        this.reconstructor = null;
	        this.emit('decoded', packet);
	      }
	    }
	  }
	  else {
	    throw new Error('Unknown type: ' + obj);
	  }
	};
	
	/**
	 * Decode a packet String (JSON data)
	 *
	 * @param {String} str
	 * @return {Object} packet
	 * @api private
	 */
	
	function decodeString(str) {
	  var p = {};
	  var i = 0;
	
	  // look up type
	  p.type = Number(str.charAt(0));
	  if (null == exports.types[p.type]) return error();
	
	  // look up attachments if type binary
	  if (exports.BINARY_EVENT == p.type || exports.BINARY_ACK == p.type) {
	    var buf = '';
	    while (str.charAt(++i) != '-') {
	      buf += str.charAt(i);
	      if (i == str.length) break;
	    }
	    if (buf != Number(buf) || str.charAt(i) != '-') {
	      throw new Error('Illegal attachments');
	    }
	    p.attachments = Number(buf);
	  }
	
	  // look up namespace (if any)
	  if ('/' == str.charAt(i + 1)) {
	    p.nsp = '';
	    while (++i) {
	      var c = str.charAt(i);
	      if (',' == c) break;
	      p.nsp += c;
	      if (i == str.length) break;
	    }
	  } else {
	    p.nsp = '/';
	  }
	
	  // look up id
	  var next = str.charAt(i + 1);
	  if ('' !== next && Number(next) == next) {
	    p.id = '';
	    while (++i) {
	      var c = str.charAt(i);
	      if (null == c || Number(c) != c) {
	        --i;
	        break;
	      }
	      p.id += str.charAt(i);
	      if (i == str.length) break;
	    }
	    p.id = Number(p.id);
	  }
	
	  // look up json data
	  if (str.charAt(++i)) {
	    p = tryParse(p, str.substr(i));
	  }
	
	  debug('decoded %s as %j', str, p);
	  return p;
	}
	
	function tryParse(p, str) {
	  try {
	    p.data = json.parse(str);
	  } catch(e){
	    return error();
	  }
	  return p; 
	};
	
	/**
	 * Deallocates a parser's resources
	 *
	 * @api public
	 */
	
	Decoder.prototype.destroy = function() {
	  if (this.reconstructor) {
	    this.reconstructor.finishedReconstruction();
	  }
	};
	
	/**
	 * A manager of a binary event's 'buffer sequence'. Should
	 * be constructed whenever a packet of type BINARY_EVENT is
	 * decoded.
	 *
	 * @param {Object} packet
	 * @return {BinaryReconstructor} initialized reconstructor
	 * @api private
	 */
	
	function BinaryReconstructor(packet) {
	  this.reconPack = packet;
	  this.buffers = [];
	}
	
	/**
	 * Method to be called when binary data received from connection
	 * after a BINARY_EVENT packet.
	 *
	 * @param {Buffer | ArrayBuffer} binData - the raw binary data received
	 * @return {null | Object} returns null if more binary data is expected or
	 *   a reconstructed packet object if all buffers have been received.
	 * @api private
	 */
	
	BinaryReconstructor.prototype.takeBinaryData = function(binData) {
	  this.buffers.push(binData);
	  if (this.buffers.length == this.reconPack.attachments) { // done with buffer list
	    var packet = binary.reconstructPacket(this.reconPack, this.buffers);
	    this.finishedReconstruction();
	    return packet;
	  }
	  return null;
	};
	
	/**
	 * Cleans up binary packet reconstruction variables.
	 *
	 * @api private
	 */
	
	BinaryReconstructor.prototype.finishedReconstruction = function() {
	  this.reconPack = null;
	  this.buffers = [];
	};
	
	function error(data){
	  return {
	    type: exports.ERROR,
	    data: 'parser error'
	  };
	}


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(192);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  return ('WebkitAppearance' in document.documentElement.style) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (window.console && (console.firebug || (console.exception && console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  return JSON.stringify(v);
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs() {
	  var args = arguments;
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return args;
	
	  var c = 'color: ' + this.color;
	  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	  return args;
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage(){
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = debug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(193);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lowercased letter, i.e. "n".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previously assigned color.
	 */
	
	var prevColor = 0;
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 *
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor() {
	  return exports.colors[prevColor++ % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function debug(namespace) {
	
	  // define the `disabled` version
	  function disabled() {
	  }
	  disabled.enabled = false;
	
	  // define the `enabled` version
	  function enabled() {
	
	    var self = enabled;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // add the `color` if not set
	    if (null == self.useColors) self.useColors = exports.useColors();
	    if (null == self.color && self.useColors) self.color = selectColor();
	
	    var args = Array.prototype.slice.call(arguments);
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %o
	      args = ['%o'].concat(args);
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    if ('function' === typeof exports.formatArgs) {
	      args = exports.formatArgs.apply(self, args);
	    }
	    var logFn = enabled.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	  enabled.enabled = true;
	
	  var fn = exports.enabled(namespace) ? enabled : disabled;
	
	  fn.namespace = namespace;
	
	  return fn;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  var split = (namespaces || '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ }),
/* 193 */
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} options
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options){
	  options = options || {};
	  if ('string' == typeof val) return parse(val);
	  return options.long
	    ? long(val)
	    : short(val);
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = '' + str;
	  if (str.length > 10000) return;
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
	  if (!match) return;
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function short(ms) {
	  if (ms >= d) return Math.round(ms / d) + 'd';
	  if (ms >= h) return Math.round(ms / h) + 'h';
	  if (ms >= m) return Math.round(ms / m) + 'm';
	  if (ms >= s) return Math.round(ms / s) + 's';
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function long(ms) {
	  return plural(ms, d, 'day')
	    || plural(ms, h, 'hour')
	    || plural(ms, m, 'minute')
	    || plural(ms, s, 'second')
	    || ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) return;
	  if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! JSON v3.3.2 | http://bestiejs.github.io/json3 | Copyright 2012-2014, Kit Cambridge | http://kit.mit-license.org */
	;(function () {
	  // Detect the `define` function exposed by asynchronous module loaders. The
	  // strict `define` check is necessary for compatibility with `r.js`.
	  var isLoader = "function" === "function" && __webpack_require__(195);
	
	  // A set of types used to distinguish objects from primitives.
	  var objectTypes = {
	    "function": true,
	    "object": true
	  };
	
	  // Detect the `exports` object exposed by CommonJS implementations.
	  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;
	
	  // Use the `global` object exposed by Node (including Browserify via
	  // `insert-module-globals`), Narwhal, and Ringo as the default context,
	  // and the `window` object in browsers. Rhino exports a `global` function
	  // instead.
	  var root = objectTypes[typeof window] && window || this,
	      freeGlobal = freeExports && objectTypes[typeof module] && module && !module.nodeType && typeof global == "object" && global;
	
	  if (freeGlobal && (freeGlobal["global"] === freeGlobal || freeGlobal["window"] === freeGlobal || freeGlobal["self"] === freeGlobal)) {
	    root = freeGlobal;
	  }
	
	  // Public: Initializes JSON 3 using the given `context` object, attaching the
	  // `stringify` and `parse` functions to the specified `exports` object.
	  function runInContext(context, exports) {
	    context || (context = root["Object"]());
	    exports || (exports = root["Object"]());
	
	    // Native constructor aliases.
	    var Number = context["Number"] || root["Number"],
	        String = context["String"] || root["String"],
	        Object = context["Object"] || root["Object"],
	        Date = context["Date"] || root["Date"],
	        SyntaxError = context["SyntaxError"] || root["SyntaxError"],
	        TypeError = context["TypeError"] || root["TypeError"],
	        Math = context["Math"] || root["Math"],
	        nativeJSON = context["JSON"] || root["JSON"];
	
	    // Delegate to the native `stringify` and `parse` implementations.
	    if (typeof nativeJSON == "object" && nativeJSON) {
	      exports.stringify = nativeJSON.stringify;
	      exports.parse = nativeJSON.parse;
	    }
	
	    // Convenience aliases.
	    var objectProto = Object.prototype,
	        getClass = objectProto.toString,
	        isProperty, forEach, undef;
	
	    // Test the `Date#getUTC*` methods. Based on work by @Yaffle.
	    var isExtended = new Date(-3509827334573292);
	    try {
	      // The `getUTCFullYear`, `Month`, and `Date` methods return nonsensical
	      // results for certain dates in Opera >= 10.53.
	      isExtended = isExtended.getUTCFullYear() == -109252 && isExtended.getUTCMonth() === 0 && isExtended.getUTCDate() === 1 &&
	        // Safari < 2.0.2 stores the internal millisecond time value correctly,
	        // but clips the values returned by the date methods to the range of
	        // signed 32-bit integers ([-2 ** 31, 2 ** 31 - 1]).
	        isExtended.getUTCHours() == 10 && isExtended.getUTCMinutes() == 37 && isExtended.getUTCSeconds() == 6 && isExtended.getUTCMilliseconds() == 708;
	    } catch (exception) {}
	
	    // Internal: Determines whether the native `JSON.stringify` and `parse`
	    // implementations are spec-compliant. Based on work by Ken Snyder.
	    function has(name) {
	      if (has[name] !== undef) {
	        // Return cached feature test result.
	        return has[name];
	      }
	      var isSupported;
	      if (name == "bug-string-char-index") {
	        // IE <= 7 doesn't support accessing string characters using square
	        // bracket notation. IE 8 only supports this for primitives.
	        isSupported = "a"[0] != "a";
	      } else if (name == "json") {
	        // Indicates whether both `JSON.stringify` and `JSON.parse` are
	        // supported.
	        isSupported = has("json-stringify") && has("json-parse");
	      } else {
	        var value, serialized = '{"a":[1,true,false,null,"\\u0000\\b\\n\\f\\r\\t"]}';
	        // Test `JSON.stringify`.
	        if (name == "json-stringify") {
	          var stringify = exports.stringify, stringifySupported = typeof stringify == "function" && isExtended;
	          if (stringifySupported) {
	            // A test function object with a custom `toJSON` method.
	            (value = function () {
	              return 1;
	            }).toJSON = value;
	            try {
	              stringifySupported =
	                // Firefox 3.1b1 and b2 serialize string, number, and boolean
	                // primitives as object literals.
	                stringify(0) === "0" &&
	                // FF 3.1b1, b2, and JSON 2 serialize wrapped primitives as object
	                // literals.
	                stringify(new Number()) === "0" &&
	                stringify(new String()) == '""' &&
	                // FF 3.1b1, 2 throw an error if the value is `null`, `undefined`, or
	                // does not define a canonical JSON representation (this applies to
	                // objects with `toJSON` properties as well, *unless* they are nested
	                // within an object or array).
	                stringify(getClass) === undef &&
	                // IE 8 serializes `undefined` as `"undefined"`. Safari <= 5.1.7 and
	                // FF 3.1b3 pass this test.
	                stringify(undef) === undef &&
	                // Safari <= 5.1.7 and FF 3.1b3 throw `Error`s and `TypeError`s,
	                // respectively, if the value is omitted entirely.
	                stringify() === undef &&
	                // FF 3.1b1, 2 throw an error if the given value is not a number,
	                // string, array, object, Boolean, or `null` literal. This applies to
	                // objects with custom `toJSON` methods as well, unless they are nested
	                // inside object or array literals. YUI 3.0.0b1 ignores custom `toJSON`
	                // methods entirely.
	                stringify(value) === "1" &&
	                stringify([value]) == "[1]" &&
	                // Prototype <= 1.6.1 serializes `[undefined]` as `"[]"` instead of
	                // `"[null]"`.
	                stringify([undef]) == "[null]" &&
	                // YUI 3.0.0b1 fails to serialize `null` literals.
	                stringify(null) == "null" &&
	                // FF 3.1b1, 2 halts serialization if an array contains a function:
	                // `[1, true, getClass, 1]` serializes as "[1,true,],". FF 3.1b3
	                // elides non-JSON values from objects and arrays, unless they
	                // define custom `toJSON` methods.
	                stringify([undef, getClass, null]) == "[null,null,null]" &&
	                // Simple serialization test. FF 3.1b1 uses Unicode escape sequences
	                // where character escape codes are expected (e.g., `\b` => `\u0008`).
	                stringify({ "a": [value, true, false, null, "\x00\b\n\f\r\t"] }) == serialized &&
	                // FF 3.1b1 and b2 ignore the `filter` and `width` arguments.
	                stringify(null, value) === "1" &&
	                stringify([1, 2], null, 1) == "[\n 1,\n 2\n]" &&
	                // JSON 2, Prototype <= 1.7, and older WebKit builds incorrectly
	                // serialize extended years.
	                stringify(new Date(-8.64e15)) == '"-271821-04-20T00:00:00.000Z"' &&
	                // The milliseconds are optional in ES 5, but required in 5.1.
	                stringify(new Date(8.64e15)) == '"+275760-09-13T00:00:00.000Z"' &&
	                // Firefox <= 11.0 incorrectly serializes years prior to 0 as negative
	                // four-digit years instead of six-digit years. Credits: @Yaffle.
	                stringify(new Date(-621987552e5)) == '"-000001-01-01T00:00:00.000Z"' &&
	                // Safari <= 5.1.5 and Opera >= 10.53 incorrectly serialize millisecond
	                // values less than 1000. Credits: @Yaffle.
	                stringify(new Date(-1)) == '"1969-12-31T23:59:59.999Z"';
	            } catch (exception) {
	              stringifySupported = false;
	            }
	          }
	          isSupported = stringifySupported;
	        }
	        // Test `JSON.parse`.
	        if (name == "json-parse") {
	          var parse = exports.parse;
	          if (typeof parse == "function") {
	            try {
	              // FF 3.1b1, b2 will throw an exception if a bare literal is provided.
	              // Conforming implementations should also coerce the initial argument to
	              // a string prior to parsing.
	              if (parse("0") === 0 && !parse(false)) {
	                // Simple parsing test.
	                value = parse(serialized);
	                var parseSupported = value["a"].length == 5 && value["a"][0] === 1;
	                if (parseSupported) {
	                  try {
	                    // Safari <= 5.1.2 and FF 3.1b1 allow unescaped tabs in strings.
	                    parseSupported = !parse('"\t"');
	                  } catch (exception) {}
	                  if (parseSupported) {
	                    try {
	                      // FF 4.0 and 4.0.1 allow leading `+` signs and leading
	                      // decimal points. FF 4.0, 4.0.1, and IE 9-10 also allow
	                      // certain octal literals.
	                      parseSupported = parse("01") !== 1;
	                    } catch (exception) {}
	                  }
	                  if (parseSupported) {
	                    try {
	                      // FF 4.0, 4.0.1, and Rhino 1.7R3-R4 allow trailing decimal
	                      // points. These environments, along with FF 3.1b1 and 2,
	                      // also allow trailing commas in JSON objects and arrays.
	                      parseSupported = parse("1.") !== 1;
	                    } catch (exception) {}
	                  }
	                }
	              }
	            } catch (exception) {
	              parseSupported = false;
	            }
	          }
	          isSupported = parseSupported;
	        }
	      }
	      return has[name] = !!isSupported;
	    }
	
	    if (!has("json")) {
	      // Common `[[Class]]` name aliases.
	      var functionClass = "[object Function]",
	          dateClass = "[object Date]",
	          numberClass = "[object Number]",
	          stringClass = "[object String]",
	          arrayClass = "[object Array]",
	          booleanClass = "[object Boolean]";
	
	      // Detect incomplete support for accessing string characters by index.
	      var charIndexBuggy = has("bug-string-char-index");
	
	      // Define additional utility methods if the `Date` methods are buggy.
	      if (!isExtended) {
	        var floor = Math.floor;
	        // A mapping between the months of the year and the number of days between
	        // January 1st and the first of the respective month.
	        var Months = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
	        // Internal: Calculates the number of days between the Unix epoch and the
	        // first day of the given month.
	        var getDay = function (year, month) {
	          return Months[month] + 365 * (year - 1970) + floor((year - 1969 + (month = +(month > 1))) / 4) - floor((year - 1901 + month) / 100) + floor((year - 1601 + month) / 400);
	        };
	      }
	
	      // Internal: Determines if a property is a direct property of the given
	      // object. Delegates to the native `Object#hasOwnProperty` method.
	      if (!(isProperty = objectProto.hasOwnProperty)) {
	        isProperty = function (property) {
	          var members = {}, constructor;
	          if ((members.__proto__ = null, members.__proto__ = {
	            // The *proto* property cannot be set multiple times in recent
	            // versions of Firefox and SeaMonkey.
	            "toString": 1
	          }, members).toString != getClass) {
	            // Safari <= 2.0.3 doesn't implement `Object#hasOwnProperty`, but
	            // supports the mutable *proto* property.
	            isProperty = function (property) {
	              // Capture and break the object's prototype chain (see section 8.6.2
	              // of the ES 5.1 spec). The parenthesized expression prevents an
	              // unsafe transformation by the Closure Compiler.
	              var original = this.__proto__, result = property in (this.__proto__ = null, this);
	              // Restore the original prototype chain.
	              this.__proto__ = original;
	              return result;
	            };
	          } else {
	            // Capture a reference to the top-level `Object` constructor.
	            constructor = members.constructor;
	            // Use the `constructor` property to simulate `Object#hasOwnProperty` in
	            // other environments.
	            isProperty = function (property) {
	              var parent = (this.constructor || constructor).prototype;
	              return property in this && !(property in parent && this[property] === parent[property]);
	            };
	          }
	          members = null;
	          return isProperty.call(this, property);
	        };
	      }
	
	      // Internal: Normalizes the `for...in` iteration algorithm across
	      // environments. Each enumerated key is yielded to a `callback` function.
	      forEach = function (object, callback) {
	        var size = 0, Properties, members, property;
	
	        // Tests for bugs in the current environment's `for...in` algorithm. The
	        // `valueOf` property inherits the non-enumerable flag from
	        // `Object.prototype` in older versions of IE, Netscape, and Mozilla.
	        (Properties = function () {
	          this.valueOf = 0;
	        }).prototype.valueOf = 0;
	
	        // Iterate over a new instance of the `Properties` class.
	        members = new Properties();
	        for (property in members) {
	          // Ignore all properties inherited from `Object.prototype`.
	          if (isProperty.call(members, property)) {
	            size++;
	          }
	        }
	        Properties = members = null;
	
	        // Normalize the iteration algorithm.
	        if (!size) {
	          // A list of non-enumerable properties inherited from `Object.prototype`.
	          members = ["valueOf", "toString", "toLocaleString", "propertyIsEnumerable", "isPrototypeOf", "hasOwnProperty", "constructor"];
	          // IE <= 8, Mozilla 1.0, and Netscape 6.2 ignore shadowed non-enumerable
	          // properties.
	          forEach = function (object, callback) {
	            var isFunction = getClass.call(object) == functionClass, property, length;
	            var hasProperty = !isFunction && typeof object.constructor != "function" && objectTypes[typeof object.hasOwnProperty] && object.hasOwnProperty || isProperty;
	            for (property in object) {
	              // Gecko <= 1.0 enumerates the `prototype` property of functions under
	              // certain conditions; IE does not.
	              if (!(isFunction && property == "prototype") && hasProperty.call(object, property)) {
	                callback(property);
	              }
	            }
	            // Manually invoke the callback for each non-enumerable property.
	            for (length = members.length; property = members[--length]; hasProperty.call(object, property) && callback(property));
	          };
	        } else if (size == 2) {
	          // Safari <= 2.0.4 enumerates shadowed properties twice.
	          forEach = function (object, callback) {
	            // Create a set of iterated properties.
	            var members = {}, isFunction = getClass.call(object) == functionClass, property;
	            for (property in object) {
	              // Store each property name to prevent double enumeration. The
	              // `prototype` property of functions is not enumerated due to cross-
	              // environment inconsistencies.
	              if (!(isFunction && property == "prototype") && !isProperty.call(members, property) && (members[property] = 1) && isProperty.call(object, property)) {
	                callback(property);
	              }
	            }
	          };
	        } else {
	          // No bugs detected; use the standard `for...in` algorithm.
	          forEach = function (object, callback) {
	            var isFunction = getClass.call(object) == functionClass, property, isConstructor;
	            for (property in object) {
	              if (!(isFunction && property == "prototype") && isProperty.call(object, property) && !(isConstructor = property === "constructor")) {
	                callback(property);
	              }
	            }
	            // Manually invoke the callback for the `constructor` property due to
	            // cross-environment inconsistencies.
	            if (isConstructor || isProperty.call(object, (property = "constructor"))) {
	              callback(property);
	            }
	          };
	        }
	        return forEach(object, callback);
	      };
	
	      // Public: Serializes a JavaScript `value` as a JSON string. The optional
	      // `filter` argument may specify either a function that alters how object and
	      // array members are serialized, or an array of strings and numbers that
	      // indicates which properties should be serialized. The optional `width`
	      // argument may be either a string or number that specifies the indentation
	      // level of the output.
	      if (!has("json-stringify")) {
	        // Internal: A map of control characters and their escaped equivalents.
	        var Escapes = {
	          92: "\\\\",
	          34: '\\"',
	          8: "\\b",
	          12: "\\f",
	          10: "\\n",
	          13: "\\r",
	          9: "\\t"
	        };
	
	        // Internal: Converts `value` into a zero-padded string such that its
	        // length is at least equal to `width`. The `width` must be <= 6.
	        var leadingZeroes = "000000";
	        var toPaddedString = function (width, value) {
	          // The `|| 0` expression is necessary to work around a bug in
	          // Opera <= 7.54u2 where `0 == -0`, but `String(-0) !== "0"`.
	          return (leadingZeroes + (value || 0)).slice(-width);
	        };
	
	        // Internal: Double-quotes a string `value`, replacing all ASCII control
	        // characters (characters with code unit values between 0 and 31) with
	        // their escaped equivalents. This is an implementation of the
	        // `Quote(value)` operation defined in ES 5.1 section 15.12.3.
	        var unicodePrefix = "\\u00";
	        var quote = function (value) {
	          var result = '"', index = 0, length = value.length, useCharIndex = !charIndexBuggy || length > 10;
	          var symbols = useCharIndex && (charIndexBuggy ? value.split("") : value);
	          for (; index < length; index++) {
	            var charCode = value.charCodeAt(index);
	            // If the character is a control character, append its Unicode or
	            // shorthand escape sequence; otherwise, append the character as-is.
	            switch (charCode) {
	              case 8: case 9: case 10: case 12: case 13: case 34: case 92:
	                result += Escapes[charCode];
	                break;
	              default:
	                if (charCode < 32) {
	                  result += unicodePrefix + toPaddedString(2, charCode.toString(16));
	                  break;
	                }
	                result += useCharIndex ? symbols[index] : value.charAt(index);
	            }
	          }
	          return result + '"';
	        };
	
	        // Internal: Recursively serializes an object. Implements the
	        // `Str(key, holder)`, `JO(value)`, and `JA(value)` operations.
	        var serialize = function (property, object, callback, properties, whitespace, indentation, stack) {
	          var value, className, year, month, date, time, hours, minutes, seconds, milliseconds, results, element, index, length, prefix, result;
	          try {
	            // Necessary for host object support.
	            value = object[property];
	          } catch (exception) {}
	          if (typeof value == "object" && value) {
	            className = getClass.call(value);
	            if (className == dateClass && !isProperty.call(value, "toJSON")) {
	              if (value > -1 / 0 && value < 1 / 0) {
	                // Dates are serialized according to the `Date#toJSON` method
	                // specified in ES 5.1 section 15.9.5.44. See section 15.9.1.15
	                // for the ISO 8601 date time string format.
	                if (getDay) {
	                  // Manually compute the year, month, date, hours, minutes,
	                  // seconds, and milliseconds if the `getUTC*` methods are
	                  // buggy. Adapted from @Yaffle's `date-shim` project.
	                  date = floor(value / 864e5);
	                  for (year = floor(date / 365.2425) + 1970 - 1; getDay(year + 1, 0) <= date; year++);
	                  for (month = floor((date - getDay(year, 0)) / 30.42); getDay(year, month + 1) <= date; month++);
	                  date = 1 + date - getDay(year, month);
	                  // The `time` value specifies the time within the day (see ES
	                  // 5.1 section 15.9.1.2). The formula `(A % B + B) % B` is used
	                  // to compute `A modulo B`, as the `%` operator does not
	                  // correspond to the `modulo` operation for negative numbers.
	                  time = (value % 864e5 + 864e5) % 864e5;
	                  // The hours, minutes, seconds, and milliseconds are obtained by
	                  // decomposing the time within the day. See section 15.9.1.10.
	                  hours = floor(time / 36e5) % 24;
	                  minutes = floor(time / 6e4) % 60;
	                  seconds = floor(time / 1e3) % 60;
	                  milliseconds = time % 1e3;
	                } else {
	                  year = value.getUTCFullYear();
	                  month = value.getUTCMonth();
	                  date = value.getUTCDate();
	                  hours = value.getUTCHours();
	                  minutes = value.getUTCMinutes();
	                  seconds = value.getUTCSeconds();
	                  milliseconds = value.getUTCMilliseconds();
	                }
	                // Serialize extended years correctly.
	                value = (year <= 0 || year >= 1e4 ? (year < 0 ? "-" : "+") + toPaddedString(6, year < 0 ? -year : year) : toPaddedString(4, year)) +
	                  "-" + toPaddedString(2, month + 1) + "-" + toPaddedString(2, date) +
	                  // Months, dates, hours, minutes, and seconds should have two
	                  // digits; milliseconds should have three.
	                  "T" + toPaddedString(2, hours) + ":" + toPaddedString(2, minutes) + ":" + toPaddedString(2, seconds) +
	                  // Milliseconds are optional in ES 5.0, but required in 5.1.
	                  "." + toPaddedString(3, milliseconds) + "Z";
	              } else {
	                value = null;
	              }
	            } else if (typeof value.toJSON == "function" && ((className != numberClass && className != stringClass && className != arrayClass) || isProperty.call(value, "toJSON"))) {
	              // Prototype <= 1.6.1 adds non-standard `toJSON` methods to the
	              // `Number`, `String`, `Date`, and `Array` prototypes. JSON 3
	              // ignores all `toJSON` methods on these objects unless they are
	              // defined directly on an instance.
	              value = value.toJSON(property);
	            }
	          }
	          if (callback) {
	            // If a replacement function was provided, call it to obtain the value
	            // for serialization.
	            value = callback.call(object, property, value);
	          }
	          if (value === null) {
	            return "null";
	          }
	          className = getClass.call(value);
	          if (className == booleanClass) {
	            // Booleans are represented literally.
	            return "" + value;
	          } else if (className == numberClass) {
	            // JSON numbers must be finite. `Infinity` and `NaN` are serialized as
	            // `"null"`.
	            return value > -1 / 0 && value < 1 / 0 ? "" + value : "null";
	          } else if (className == stringClass) {
	            // Strings are double-quoted and escaped.
	            return quote("" + value);
	          }
	          // Recursively serialize objects and arrays.
	          if (typeof value == "object") {
	            // Check for cyclic structures. This is a linear search; performance
	            // is inversely proportional to the number of unique nested objects.
	            for (length = stack.length; length--;) {
	              if (stack[length] === value) {
	                // Cyclic structures cannot be serialized by `JSON.stringify`.
	                throw TypeError();
	              }
	            }
	            // Add the object to the stack of traversed objects.
	            stack.push(value);
	            results = [];
	            // Save the current indentation level and indent one additional level.
	            prefix = indentation;
	            indentation += whitespace;
	            if (className == arrayClass) {
	              // Recursively serialize array elements.
	              for (index = 0, length = value.length; index < length; index++) {
	                element = serialize(index, value, callback, properties, whitespace, indentation, stack);
	                results.push(element === undef ? "null" : element);
	              }
	              result = results.length ? (whitespace ? "[\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "]" : ("[" + results.join(",") + "]")) : "[]";
	            } else {
	              // Recursively serialize object members. Members are selected from
	              // either a user-specified list of property names, or the object
	              // itself.
	              forEach(properties || value, function (property) {
	                var element = serialize(property, value, callback, properties, whitespace, indentation, stack);
	                if (element !== undef) {
	                  // According to ES 5.1 section 15.12.3: "If `gap` {whitespace}
	                  // is not the empty string, let `member` {quote(property) + ":"}
	                  // be the concatenation of `member` and the `space` character."
	                  // The "`space` character" refers to the literal space
	                  // character, not the `space` {width} argument provided to
	                  // `JSON.stringify`.
	                  results.push(quote(property) + ":" + (whitespace ? " " : "") + element);
	                }
	              });
	              result = results.length ? (whitespace ? "{\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "}" : ("{" + results.join(",") + "}")) : "{}";
	            }
	            // Remove the object from the traversed object stack.
	            stack.pop();
	            return result;
	          }
	        };
	
	        // Public: `JSON.stringify`. See ES 5.1 section 15.12.3.
	        exports.stringify = function (source, filter, width) {
	          var whitespace, callback, properties, className;
	          if (objectTypes[typeof filter] && filter) {
	            if ((className = getClass.call(filter)) == functionClass) {
	              callback = filter;
	            } else if (className == arrayClass) {
	              // Convert the property names array into a makeshift set.
	              properties = {};
	              for (var index = 0, length = filter.length, value; index < length; value = filter[index++], ((className = getClass.call(value)), className == stringClass || className == numberClass) && (properties[value] = 1));
	            }
	          }
	          if (width) {
	            if ((className = getClass.call(width)) == numberClass) {
	              // Convert the `width` to an integer and create a string containing
	              // `width` number of space characters.
	              if ((width -= width % 1) > 0) {
	                for (whitespace = "", width > 10 && (width = 10); whitespace.length < width; whitespace += " ");
	              }
	            } else if (className == stringClass) {
	              whitespace = width.length <= 10 ? width : width.slice(0, 10);
	            }
	          }
	          // Opera <= 7.54u2 discards the values associated with empty string keys
	          // (`""`) only if they are used directly within an object member list
	          // (e.g., `!("" in { "": 1})`).
	          return serialize("", (value = {}, value[""] = source, value), callback, properties, whitespace, "", []);
	        };
	      }
	
	      // Public: Parses a JSON source string.
	      if (!has("json-parse")) {
	        var fromCharCode = String.fromCharCode;
	
	        // Internal: A map of escaped control characters and their unescaped
	        // equivalents.
	        var Unescapes = {
	          92: "\\",
	          34: '"',
	          47: "/",
	          98: "\b",
	          116: "\t",
	          110: "\n",
	          102: "\f",
	          114: "\r"
	        };
	
	        // Internal: Stores the parser state.
	        var Index, Source;
	
	        // Internal: Resets the parser state and throws a `SyntaxError`.
	        var abort = function () {
	          Index = Source = null;
	          throw SyntaxError();
	        };
	
	        // Internal: Returns the next token, or `"$"` if the parser has reached
	        // the end of the source string. A token may be a string, number, `null`
	        // literal, or Boolean literal.
	        var lex = function () {
	          var source = Source, length = source.length, value, begin, position, isSigned, charCode;
	          while (Index < length) {
	            charCode = source.charCodeAt(Index);
	            switch (charCode) {
	              case 9: case 10: case 13: case 32:
	                // Skip whitespace tokens, including tabs, carriage returns, line
	                // feeds, and space characters.
	                Index++;
	                break;
	              case 123: case 125: case 91: case 93: case 58: case 44:
	                // Parse a punctuator token (`{`, `}`, `[`, `]`, `:`, or `,`) at
	                // the current position.
	                value = charIndexBuggy ? source.charAt(Index) : source[Index];
	                Index++;
	                return value;
	              case 34:
	                // `"` delimits a JSON string; advance to the next character and
	                // begin parsing the string. String tokens are prefixed with the
	                // sentinel `@` character to distinguish them from punctuators and
	                // end-of-string tokens.
	                for (value = "@", Index++; Index < length;) {
	                  charCode = source.charCodeAt(Index);
	                  if (charCode < 32) {
	                    // Unescaped ASCII control characters (those with a code unit
	                    // less than the space character) are not permitted.
	                    abort();
	                  } else if (charCode == 92) {
	                    // A reverse solidus (`\`) marks the beginning of an escaped
	                    // control character (including `"`, `\`, and `/`) or Unicode
	                    // escape sequence.
	                    charCode = source.charCodeAt(++Index);
	                    switch (charCode) {
	                      case 92: case 34: case 47: case 98: case 116: case 110: case 102: case 114:
	                        // Revive escaped control characters.
	                        value += Unescapes[charCode];
	                        Index++;
	                        break;
	                      case 117:
	                        // `\u` marks the beginning of a Unicode escape sequence.
	                        // Advance to the first character and validate the
	                        // four-digit code point.
	                        begin = ++Index;
	                        for (position = Index + 4; Index < position; Index++) {
	                          charCode = source.charCodeAt(Index);
	                          // A valid sequence comprises four hexdigits (case-
	                          // insensitive) that form a single hexadecimal value.
	                          if (!(charCode >= 48 && charCode <= 57 || charCode >= 97 && charCode <= 102 || charCode >= 65 && charCode <= 70)) {
	                            // Invalid Unicode escape sequence.
	                            abort();
	                          }
	                        }
	                        // Revive the escaped character.
	                        value += fromCharCode("0x" + source.slice(begin, Index));
	                        break;
	                      default:
	                        // Invalid escape sequence.
	                        abort();
	                    }
	                  } else {
	                    if (charCode == 34) {
	                      // An unescaped double-quote character marks the end of the
	                      // string.
	                      break;
	                    }
	                    charCode = source.charCodeAt(Index);
	                    begin = Index;
	                    // Optimize for the common case where a string is valid.
	                    while (charCode >= 32 && charCode != 92 && charCode != 34) {
	                      charCode = source.charCodeAt(++Index);
	                    }
	                    // Append the string as-is.
	                    value += source.slice(begin, Index);
	                  }
	                }
	                if (source.charCodeAt(Index) == 34) {
	                  // Advance to the next character and return the revived string.
	                  Index++;
	                  return value;
	                }
	                // Unterminated string.
	                abort();
	              default:
	                // Parse numbers and literals.
	                begin = Index;
	                // Advance past the negative sign, if one is specified.
	                if (charCode == 45) {
	                  isSigned = true;
	                  charCode = source.charCodeAt(++Index);
	                }
	                // Parse an integer or floating-point value.
	                if (charCode >= 48 && charCode <= 57) {
	                  // Leading zeroes are interpreted as octal literals.
	                  if (charCode == 48 && ((charCode = source.charCodeAt(Index + 1)), charCode >= 48 && charCode <= 57)) {
	                    // Illegal octal literal.
	                    abort();
	                  }
	                  isSigned = false;
	                  // Parse the integer component.
	                  for (; Index < length && ((charCode = source.charCodeAt(Index)), charCode >= 48 && charCode <= 57); Index++);
	                  // Floats cannot contain a leading decimal point; however, this
	                  // case is already accounted for by the parser.
	                  if (source.charCodeAt(Index) == 46) {
	                    position = ++Index;
	                    // Parse the decimal component.
	                    for (; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
	                    if (position == Index) {
	                      // Illegal trailing decimal.
	                      abort();
	                    }
	                    Index = position;
	                  }
	                  // Parse exponents. The `e` denoting the exponent is
	                  // case-insensitive.
	                  charCode = source.charCodeAt(Index);
	                  if (charCode == 101 || charCode == 69) {
	                    charCode = source.charCodeAt(++Index);
	                    // Skip past the sign following the exponent, if one is
	                    // specified.
	                    if (charCode == 43 || charCode == 45) {
	                      Index++;
	                    }
	                    // Parse the exponential component.
	                    for (position = Index; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
	                    if (position == Index) {
	                      // Illegal empty exponent.
	                      abort();
	                    }
	                    Index = position;
	                  }
	                  // Coerce the parsed value to a JavaScript number.
	                  return +source.slice(begin, Index);
	                }
	                // A negative sign may only precede numbers.
	                if (isSigned) {
	                  abort();
	                }
	                // `true`, `false`, and `null` literals.
	                if (source.slice(Index, Index + 4) == "true") {
	                  Index += 4;
	                  return true;
	                } else if (source.slice(Index, Index + 5) == "false") {
	                  Index += 5;
	                  return false;
	                } else if (source.slice(Index, Index + 4) == "null") {
	                  Index += 4;
	                  return null;
	                }
	                // Unrecognized token.
	                abort();
	            }
	          }
	          // Return the sentinel `$` character if the parser has reached the end
	          // of the source string.
	          return "$";
	        };
	
	        // Internal: Parses a JSON `value` token.
	        var get = function (value) {
	          var results, hasMembers;
	          if (value == "$") {
	            // Unexpected end of input.
	            abort();
	          }
	          if (typeof value == "string") {
	            if ((charIndexBuggy ? value.charAt(0) : value[0]) == "@") {
	              // Remove the sentinel `@` character.
	              return value.slice(1);
	            }
	            // Parse object and array literals.
	            if (value == "[") {
	              // Parses a JSON array, returning a new JavaScript array.
	              results = [];
	              for (;; hasMembers || (hasMembers = true)) {
	                value = lex();
	                // A closing square bracket marks the end of the array literal.
	                if (value == "]") {
	                  break;
	                }
	                // If the array literal contains elements, the current token
	                // should be a comma separating the previous element from the
	                // next.
	                if (hasMembers) {
	                  if (value == ",") {
	                    value = lex();
	                    if (value == "]") {
	                      // Unexpected trailing `,` in array literal.
	                      abort();
	                    }
	                  } else {
	                    // A `,` must separate each array element.
	                    abort();
	                  }
	                }
	                // Elisions and leading commas are not permitted.
	                if (value == ",") {
	                  abort();
	                }
	                results.push(get(value));
	              }
	              return results;
	            } else if (value == "{") {
	              // Parses a JSON object, returning a new JavaScript object.
	              results = {};
	              for (;; hasMembers || (hasMembers = true)) {
	                value = lex();
	                // A closing curly brace marks the end of the object literal.
	                if (value == "}") {
	                  break;
	                }
	                // If the object literal contains members, the current token
	                // should be a comma separator.
	                if (hasMembers) {
	                  if (value == ",") {
	                    value = lex();
	                    if (value == "}") {
	                      // Unexpected trailing `,` in object literal.
	                      abort();
	                    }
	                  } else {
	                    // A `,` must separate each object member.
	                    abort();
	                  }
	                }
	                // Leading commas are not permitted, object property names must be
	                // double-quoted strings, and a `:` must separate each property
	                // name and value.
	                if (value == "," || typeof value != "string" || (charIndexBuggy ? value.charAt(0) : value[0]) != "@" || lex() != ":") {
	                  abort();
	                }
	                results[value.slice(1)] = get(lex());
	              }
	              return results;
	            }
	            // Unexpected token encountered.
	            abort();
	          }
	          return value;
	        };
	
	        // Internal: Updates a traversed object member.
	        var update = function (source, property, callback) {
	          var element = walk(source, property, callback);
	          if (element === undef) {
	            delete source[property];
	          } else {
	            source[property] = element;
	          }
	        };
	
	        // Internal: Recursively traverses a parsed JSON object, invoking the
	        // `callback` function for each value. This is an implementation of the
	        // `Walk(holder, name)` operation defined in ES 5.1 section 15.12.2.
	        var walk = function (source, property, callback) {
	          var value = source[property], length;
	          if (typeof value == "object" && value) {
	            // `forEach` can't be used to traverse an array in Opera <= 8.54
	            // because its `Object#hasOwnProperty` implementation returns `false`
	            // for array indices (e.g., `![1, 2, 3].hasOwnProperty("0")`).
	            if (getClass.call(value) == arrayClass) {
	              for (length = value.length; length--;) {
	                update(value, length, callback);
	              }
	            } else {
	              forEach(value, function (property) {
	                update(value, property, callback);
	              });
	            }
	          }
	          return callback.call(source, property, value);
	        };
	
	        // Public: `JSON.parse`. See ES 5.1 section 15.12.2.
	        exports.parse = function (source, callback) {
	          var result, value;
	          Index = 0;
	          Source = "" + source;
	          result = get(lex());
	          // If a JSON string contains multiple tokens, it is invalid.
	          if (lex() != "$") {
	            abort();
	          }
	          // Reset the parser state.
	          Index = Source = null;
	          return callback && getClass.call(callback) == functionClass ? walk((value = {}, value[""] = result, value), "", callback) : result;
	        };
	      }
	    }
	
	    exports["runInContext"] = runInContext;
	    return exports;
	  }
	
	  if (freeExports && !isLoader) {
	    // Export for CommonJS environments.
	    runInContext(root, freeExports);
	  } else {
	    // Export for web browsers and JavaScript engines.
	    var nativeJSON = root.JSON,
	        previousJSON = root["JSON3"],
	        isRestored = false;
	
	    var JSON3 = runInContext(root, (root["JSON3"] = {
	      // Public: Restores the original value of the global `JSON` object and
	      // returns a reference to the `JSON3` object.
	      "noConflict": function () {
	        if (!isRestored) {
	          isRestored = true;
	          root.JSON = nativeJSON;
	          root["JSON3"] = previousJSON;
	          nativeJSON = previousJSON = null;
	        }
	        return JSON3;
	      }
	    }));
	
	    root.JSON = {
	      "parse": JSON3.parse,
	      "stringify": JSON3.stringify
	    };
	  }
	
	  // Export for asynchronous module loaders.
	  if (isLoader) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return JSON3;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)(module), (function() { return this; }())))

/***/ }),
/* 195 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 196 */
/***/ (function(module, exports) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	module.exports = Emitter;
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks[event] = this._callbacks[event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  var self = this;
	  this._callbacks = this._callbacks || {};
	
	  function on() {
	    self.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks[event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks[event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks[event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks[event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*global Blob,File*/
	
	/**
	 * Module requirements
	 */
	
	var isArray = __webpack_require__(198);
	var isBuf = __webpack_require__(199);
	
	/**
	 * Replaces every Buffer | ArrayBuffer in packet with a numbered placeholder.
	 * Anything with blobs or files should be fed through removeBlobs before coming
	 * here.
	 *
	 * @param {Object} packet - socket.io event packet
	 * @return {Object} with deconstructed packet and list of buffers
	 * @api public
	 */
	
	exports.deconstructPacket = function(packet){
	  var buffers = [];
	  var packetData = packet.data;
	
	  function _deconstructPacket(data) {
	    if (!data) return data;
	
	    if (isBuf(data)) {
	      var placeholder = { _placeholder: true, num: buffers.length };
	      buffers.push(data);
	      return placeholder;
	    } else if (isArray(data)) {
	      var newData = new Array(data.length);
	      for (var i = 0; i < data.length; i++) {
	        newData[i] = _deconstructPacket(data[i]);
	      }
	      return newData;
	    } else if ('object' == typeof data && !(data instanceof Date)) {
	      var newData = {};
	      for (var key in data) {
	        newData[key] = _deconstructPacket(data[key]);
	      }
	      return newData;
	    }
	    return data;
	  }
	
	  var pack = packet;
	  pack.data = _deconstructPacket(packetData);
	  pack.attachments = buffers.length; // number of binary 'attachments'
	  return {packet: pack, buffers: buffers};
	};
	
	/**
	 * Reconstructs a binary packet from its placeholder packet and buffers
	 *
	 * @param {Object} packet - event packet with placeholders
	 * @param {Array} buffers - binary buffers to put in placeholder positions
	 * @return {Object} reconstructed packet
	 * @api public
	 */
	
	exports.reconstructPacket = function(packet, buffers) {
	  var curPlaceHolder = 0;
	
	  function _reconstructPacket(data) {
	    if (data && data._placeholder) {
	      var buf = buffers[data.num]; // appropriate buffer (should be natural order anyway)
	      return buf;
	    } else if (isArray(data)) {
	      for (var i = 0; i < data.length; i++) {
	        data[i] = _reconstructPacket(data[i]);
	      }
	      return data;
	    } else if (data && 'object' == typeof data) {
	      for (var key in data) {
	        data[key] = _reconstructPacket(data[key]);
	      }
	      return data;
	    }
	    return data;
	  }
	
	  packet.data = _reconstructPacket(packet.data);
	  packet.attachments = undefined; // no longer useful
	  return packet;
	};
	
	/**
	 * Asynchronously removes Blobs or Files from data via
	 * FileReader's readAsArrayBuffer method. Used before encoding
	 * data as msgpack. Calls callback with the blobless data.
	 *
	 * @param {Object} data
	 * @param {Function} callback
	 * @api private
	 */
	
	exports.removeBlobs = function(data, callback) {
	  function _removeBlobs(obj, curKey, containingObject) {
	    if (!obj) return obj;
	
	    // convert any blob
	    if ((global.Blob && obj instanceof Blob) ||
	        (global.File && obj instanceof File)) {
	      pendingBlobs++;
	
	      // async filereader
	      var fileReader = new FileReader();
	      fileReader.onload = function() { // this.result == arraybuffer
	        if (containingObject) {
	          containingObject[curKey] = this.result;
	        }
	        else {
	          bloblessData = this.result;
	        }
	
	        // if nothing pending its callback time
	        if(! --pendingBlobs) {
	          callback(bloblessData);
	        }
	      };
	
	      fileReader.readAsArrayBuffer(obj); // blob -> arraybuffer
	    } else if (isArray(obj)) { // handle array
	      for (var i = 0; i < obj.length; i++) {
	        _removeBlobs(obj[i], i, obj);
	      }
	    } else if (obj && 'object' == typeof obj && !isBuf(obj)) { // and object
	      for (var key in obj) {
	        _removeBlobs(obj[key], key, obj);
	      }
	    }
	  }
	
	  var pendingBlobs = 0;
	  var bloblessData = data;
	  _removeBlobs(bloblessData);
	  if (!pendingBlobs) {
	    callback(bloblessData);
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 198 */
/***/ (function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 199 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	module.exports = isBuf;
	
	/**
	 * Returns true if obj is a buffer or an arraybuffer.
	 *
	 * @api private
	 */
	
	function isBuf(obj) {
	  return (global.Buffer && global.Buffer.isBuffer(obj)) ||
	         (global.ArrayBuffer && obj instanceof ArrayBuffer);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var eio = __webpack_require__(201);
	var Socket = __webpack_require__(231);
	var Emitter = __webpack_require__(232);
	var parser = __webpack_require__(190);
	var on = __webpack_require__(234);
	var bind = __webpack_require__(235);
	var debug = __webpack_require__(186)('socket.io-client:manager');
	var indexOf = __webpack_require__(229);
	var Backoff = __webpack_require__(236);
	
	/**
	 * IE6+ hasOwnProperty
	 */
	
	var has = Object.prototype.hasOwnProperty;
	
	/**
	 * Module exports
	 */
	
	module.exports = Manager;
	
	/**
	 * `Manager` constructor.
	 *
	 * @param {String} engine instance or engine uri/opts
	 * @param {Object} options
	 * @api public
	 */
	
	function Manager (uri, opts) {
	  if (!(this instanceof Manager)) return new Manager(uri, opts);
	  if (uri && ('object' === typeof uri)) {
	    opts = uri;
	    uri = undefined;
	  }
	  opts = opts || {};
	
	  opts.path = opts.path || '/socket.io';
	  this.nsps = {};
	  this.subs = [];
	  this.opts = opts;
	  this.reconnection(opts.reconnection !== false);
	  this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
	  this.reconnectionDelay(opts.reconnectionDelay || 1000);
	  this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
	  this.randomizationFactor(opts.randomizationFactor || 0.5);
	  this.backoff = new Backoff({
	    min: this.reconnectionDelay(),
	    max: this.reconnectionDelayMax(),
	    jitter: this.randomizationFactor()
	  });
	  this.timeout(null == opts.timeout ? 20000 : opts.timeout);
	  this.readyState = 'closed';
	  this.uri = uri;
	  this.connecting = [];
	  this.lastPing = null;
	  this.encoding = false;
	  this.packetBuffer = [];
	  this.encoder = new parser.Encoder();
	  this.decoder = new parser.Decoder();
	  this.autoConnect = opts.autoConnect !== false;
	  if (this.autoConnect) this.open();
	}
	
	/**
	 * Propagate given event to sockets and emit on `this`
	 *
	 * @api private
	 */
	
	Manager.prototype.emitAll = function () {
	  this.emit.apply(this, arguments);
	  for (var nsp in this.nsps) {
	    if (has.call(this.nsps, nsp)) {
	      this.nsps[nsp].emit.apply(this.nsps[nsp], arguments);
	    }
	  }
	};
	
	/**
	 * Update `socket.id` of all sockets
	 *
	 * @api private
	 */
	
	Manager.prototype.updateSocketIds = function () {
	  for (var nsp in this.nsps) {
	    if (has.call(this.nsps, nsp)) {
	      this.nsps[nsp].id = this.engine.id;
	    }
	  }
	};
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Manager.prototype);
	
	/**
	 * Sets the `reconnection` config.
	 *
	 * @param {Boolean} true/false if it should automatically reconnect
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnection = function (v) {
	  if (!arguments.length) return this._reconnection;
	  this._reconnection = !!v;
	  return this;
	};
	
	/**
	 * Sets the reconnection attempts config.
	 *
	 * @param {Number} max reconnection attempts before giving up
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionAttempts = function (v) {
	  if (!arguments.length) return this._reconnectionAttempts;
	  this._reconnectionAttempts = v;
	  return this;
	};
	
	/**
	 * Sets the delay between reconnections.
	 *
	 * @param {Number} delay
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionDelay = function (v) {
	  if (!arguments.length) return this._reconnectionDelay;
	  this._reconnectionDelay = v;
	  this.backoff && this.backoff.setMin(v);
	  return this;
	};
	
	Manager.prototype.randomizationFactor = function (v) {
	  if (!arguments.length) return this._randomizationFactor;
	  this._randomizationFactor = v;
	  this.backoff && this.backoff.setJitter(v);
	  return this;
	};
	
	/**
	 * Sets the maximum delay between reconnections.
	 *
	 * @param {Number} delay
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionDelayMax = function (v) {
	  if (!arguments.length) return this._reconnectionDelayMax;
	  this._reconnectionDelayMax = v;
	  this.backoff && this.backoff.setMax(v);
	  return this;
	};
	
	/**
	 * Sets the connection timeout. `false` to disable
	 *
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.timeout = function (v) {
	  if (!arguments.length) return this._timeout;
	  this._timeout = v;
	  return this;
	};
	
	/**
	 * Starts trying to reconnect if reconnection is enabled and we have not
	 * started reconnecting yet
	 *
	 * @api private
	 */
	
	Manager.prototype.maybeReconnectOnOpen = function () {
	  // Only try to reconnect if it's the first time we're connecting
	  if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) {
	    // keeps reconnection from firing twice for the same reconnection loop
	    this.reconnect();
	  }
	};
	
	/**
	 * Sets the current transport `socket`.
	 *
	 * @param {Function} optional, callback
	 * @return {Manager} self
	 * @api public
	 */
	
	Manager.prototype.open =
	Manager.prototype.connect = function (fn, opts) {
	  debug('readyState %s', this.readyState);
	  if (~this.readyState.indexOf('open')) return this;
	
	  debug('opening %s', this.uri);
	  this.engine = eio(this.uri, this.opts);
	  var socket = this.engine;
	  var self = this;
	  this.readyState = 'opening';
	  this.skipReconnect = false;
	
	  // emit `open`
	  var openSub = on(socket, 'open', function () {
	    self.onopen();
	    fn && fn();
	  });
	
	  // emit `connect_error`
	  var errorSub = on(socket, 'error', function (data) {
	    debug('connect_error');
	    self.cleanup();
	    self.readyState = 'closed';
	    self.emitAll('connect_error', data);
	    if (fn) {
	      var err = new Error('Connection error');
	      err.data = data;
	      fn(err);
	    } else {
	      // Only do this if there is no fn to handle the error
	      self.maybeReconnectOnOpen();
	    }
	  });
	
	  // emit `connect_timeout`
	  if (false !== this._timeout) {
	    var timeout = this._timeout;
	    debug('connect attempt will timeout after %d', timeout);
	
	    // set timer
	    var timer = setTimeout(function () {
	      debug('connect attempt timed out after %d', timeout);
	      openSub.destroy();
	      socket.close();
	      socket.emit('error', 'timeout');
	      self.emitAll('connect_timeout', timeout);
	    }, timeout);
	
	    this.subs.push({
	      destroy: function () {
	        clearTimeout(timer);
	      }
	    });
	  }
	
	  this.subs.push(openSub);
	  this.subs.push(errorSub);
	
	  return this;
	};
	
	/**
	 * Called upon transport open.
	 *
	 * @api private
	 */
	
	Manager.prototype.onopen = function () {
	  debug('open');
	
	  // clear old subs
	  this.cleanup();
	
	  // mark as open
	  this.readyState = 'open';
	  this.emit('open');
	
	  // add new subs
	  var socket = this.engine;
	  this.subs.push(on(socket, 'data', bind(this, 'ondata')));
	  this.subs.push(on(socket, 'ping', bind(this, 'onping')));
	  this.subs.push(on(socket, 'pong', bind(this, 'onpong')));
	  this.subs.push(on(socket, 'error', bind(this, 'onerror')));
	  this.subs.push(on(socket, 'close', bind(this, 'onclose')));
	  this.subs.push(on(this.decoder, 'decoded', bind(this, 'ondecoded')));
	};
	
	/**
	 * Called upon a ping.
	 *
	 * @api private
	 */
	
	Manager.prototype.onping = function () {
	  this.lastPing = new Date();
	  this.emitAll('ping');
	};
	
	/**
	 * Called upon a packet.
	 *
	 * @api private
	 */
	
	Manager.prototype.onpong = function () {
	  this.emitAll('pong', new Date() - this.lastPing);
	};
	
	/**
	 * Called with data.
	 *
	 * @api private
	 */
	
	Manager.prototype.ondata = function (data) {
	  this.decoder.add(data);
	};
	
	/**
	 * Called when parser fully decodes a packet.
	 *
	 * @api private
	 */
	
	Manager.prototype.ondecoded = function (packet) {
	  this.emit('packet', packet);
	};
	
	/**
	 * Called upon socket error.
	 *
	 * @api private
	 */
	
	Manager.prototype.onerror = function (err) {
	  debug('error', err);
	  this.emitAll('error', err);
	};
	
	/**
	 * Creates a new socket for the given `nsp`.
	 *
	 * @return {Socket}
	 * @api public
	 */
	
	Manager.prototype.socket = function (nsp, opts) {
	  var socket = this.nsps[nsp];
	  if (!socket) {
	    socket = new Socket(this, nsp, opts);
	    this.nsps[nsp] = socket;
	    var self = this;
	    socket.on('connecting', onConnecting);
	    socket.on('connect', function () {
	      socket.id = self.engine.id;
	    });
	
	    if (this.autoConnect) {
	      // manually call here since connecting evnet is fired before listening
	      onConnecting();
	    }
	  }
	
	  function onConnecting () {
	    if (!~indexOf(self.connecting, socket)) {
	      self.connecting.push(socket);
	    }
	  }
	
	  return socket;
	};
	
	/**
	 * Called upon a socket close.
	 *
	 * @param {Socket} socket
	 */
	
	Manager.prototype.destroy = function (socket) {
	  var index = indexOf(this.connecting, socket);
	  if (~index) this.connecting.splice(index, 1);
	  if (this.connecting.length) return;
	
	  this.close();
	};
	
	/**
	 * Writes a packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Manager.prototype.packet = function (packet) {
	  debug('writing packet %j', packet);
	  var self = this;
	  if (packet.query && packet.type === 0) packet.nsp += '?' + packet.query;
	
	  if (!self.encoding) {
	    // encode, then write to engine with result
	    self.encoding = true;
	    this.encoder.encode(packet, function (encodedPackets) {
	      for (var i = 0; i < encodedPackets.length; i++) {
	        self.engine.write(encodedPackets[i], packet.options);
	      }
	      self.encoding = false;
	      self.processPacketQueue();
	    });
	  } else { // add packet to the queue
	    self.packetBuffer.push(packet);
	  }
	};
	
	/**
	 * If packet buffer is non-empty, begins encoding the
	 * next packet in line.
	 *
	 * @api private
	 */
	
	Manager.prototype.processPacketQueue = function () {
	  if (this.packetBuffer.length > 0 && !this.encoding) {
	    var pack = this.packetBuffer.shift();
	    this.packet(pack);
	  }
	};
	
	/**
	 * Clean up transport subscriptions and packet buffer.
	 *
	 * @api private
	 */
	
	Manager.prototype.cleanup = function () {
	  debug('cleanup');
	
	  var subsLength = this.subs.length;
	  for (var i = 0; i < subsLength; i++) {
	    var sub = this.subs.shift();
	    sub.destroy();
	  }
	
	  this.packetBuffer = [];
	  this.encoding = false;
	  this.lastPing = null;
	
	  this.decoder.destroy();
	};
	
	/**
	 * Close the current socket.
	 *
	 * @api private
	 */
	
	Manager.prototype.close =
	Manager.prototype.disconnect = function () {
	  debug('disconnect');
	  this.skipReconnect = true;
	  this.reconnecting = false;
	  if ('opening' === this.readyState) {
	    // `onclose` will not fire because
	    // an open event never happened
	    this.cleanup();
	  }
	  this.backoff.reset();
	  this.readyState = 'closed';
	  if (this.engine) this.engine.close();
	};
	
	/**
	 * Called upon engine close.
	 *
	 * @api private
	 */
	
	Manager.prototype.onclose = function (reason) {
	  debug('onclose');
	
	  this.cleanup();
	  this.backoff.reset();
	  this.readyState = 'closed';
	  this.emit('close', reason);
	
	  if (this._reconnection && !this.skipReconnect) {
	    this.reconnect();
	  }
	};
	
	/**
	 * Attempt a reconnection.
	 *
	 * @api private
	 */
	
	Manager.prototype.reconnect = function () {
	  if (this.reconnecting || this.skipReconnect) return this;
	
	  var self = this;
	
	  if (this.backoff.attempts >= this._reconnectionAttempts) {
	    debug('reconnect failed');
	    this.backoff.reset();
	    this.emitAll('reconnect_failed');
	    this.reconnecting = false;
	  } else {
	    var delay = this.backoff.duration();
	    debug('will wait %dms before reconnect attempt', delay);
	
	    this.reconnecting = true;
	    var timer = setTimeout(function () {
	      if (self.skipReconnect) return;
	
	      debug('attempting reconnect');
	      self.emitAll('reconnect_attempt', self.backoff.attempts);
	      self.emitAll('reconnecting', self.backoff.attempts);
	
	      // check again for the case socket closed in above events
	      if (self.skipReconnect) return;
	
	      self.open(function (err) {
	        if (err) {
	          debug('reconnect attempt error');
	          self.reconnecting = false;
	          self.reconnect();
	          self.emitAll('reconnect_error', err.data);
	        } else {
	          debug('reconnect success');
	          self.onreconnect();
	        }
	      });
	    }, delay);
	
	    this.subs.push({
	      destroy: function () {
	        clearTimeout(timer);
	      }
	    });
	  }
	};
	
	/**
	 * Called upon successful reconnect.
	 *
	 * @api private
	 */
	
	Manager.prototype.onreconnect = function () {
	  var attempt = this.backoff.attempts;
	  this.reconnecting = false;
	  this.backoff.reset();
	  this.updateSocketIds();
	  this.emitAll('reconnect', attempt);
	};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	
	module.exports = __webpack_require__(202);


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	
	module.exports = __webpack_require__(203);
	
	/**
	 * Exports parser
	 *
	 * @api public
	 *
	 */
	module.exports.parser = __webpack_require__(210);


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var transports = __webpack_require__(204);
	var Emitter = __webpack_require__(219);
	var debug = __webpack_require__(223)('engine.io-client:socket');
	var index = __webpack_require__(229);
	var parser = __webpack_require__(210);
	var parseuri = __webpack_require__(185);
	var parsejson = __webpack_require__(230);
	var parseqs = __webpack_require__(220);
	
	/**
	 * Module exports.
	 */
	
	module.exports = Socket;
	
	/**
	 * Socket constructor.
	 *
	 * @param {String|Object} uri or options
	 * @param {Object} options
	 * @api public
	 */
	
	function Socket (uri, opts) {
	  if (!(this instanceof Socket)) return new Socket(uri, opts);
	
	  opts = opts || {};
	
	  if (uri && 'object' === typeof uri) {
	    opts = uri;
	    uri = null;
	  }
	
	  if (uri) {
	    uri = parseuri(uri);
	    opts.hostname = uri.host;
	    opts.secure = uri.protocol === 'https' || uri.protocol === 'wss';
	    opts.port = uri.port;
	    if (uri.query) opts.query = uri.query;
	  } else if (opts.host) {
	    opts.hostname = parseuri(opts.host).host;
	  }
	
	  this.secure = null != opts.secure ? opts.secure
	    : (global.location && 'https:' === location.protocol);
	
	  if (opts.hostname && !opts.port) {
	    // if no port is specified manually, use the protocol default
	    opts.port = this.secure ? '443' : '80';
	  }
	
	  this.agent = opts.agent || false;
	  this.hostname = opts.hostname ||
	    (global.location ? location.hostname : 'localhost');
	  this.port = opts.port || (global.location && location.port
	      ? location.port
	      : (this.secure ? 443 : 80));
	  this.query = opts.query || {};
	  if ('string' === typeof this.query) this.query = parseqs.decode(this.query);
	  this.upgrade = false !== opts.upgrade;
	  this.path = (opts.path || '/engine.io').replace(/\/$/, '') + '/';
	  this.forceJSONP = !!opts.forceJSONP;
	  this.jsonp = false !== opts.jsonp;
	  this.forceBase64 = !!opts.forceBase64;
	  this.enablesXDR = !!opts.enablesXDR;
	  this.timestampParam = opts.timestampParam || 't';
	  this.timestampRequests = opts.timestampRequests;
	  this.transports = opts.transports || ['polling', 'websocket'];
	  this.readyState = '';
	  this.writeBuffer = [];
	  this.prevBufferLen = 0;
	  this.policyPort = opts.policyPort || 843;
	  this.rememberUpgrade = opts.rememberUpgrade || false;
	  this.binaryType = null;
	  this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;
	  this.perMessageDeflate = false !== opts.perMessageDeflate ? (opts.perMessageDeflate || {}) : false;
	
	  if (true === this.perMessageDeflate) this.perMessageDeflate = {};
	  if (this.perMessageDeflate && null == this.perMessageDeflate.threshold) {
	    this.perMessageDeflate.threshold = 1024;
	  }
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx || null;
	  this.key = opts.key || null;
	  this.passphrase = opts.passphrase || null;
	  this.cert = opts.cert || null;
	  this.ca = opts.ca || null;
	  this.ciphers = opts.ciphers || null;
	  this.rejectUnauthorized = opts.rejectUnauthorized === undefined ? null : opts.rejectUnauthorized;
	  this.forceNode = !!opts.forceNode;
	
	  // other options for Node.js client
	  var freeGlobal = typeof global === 'object' && global;
	  if (freeGlobal.global === freeGlobal) {
	    if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) {
	      this.extraHeaders = opts.extraHeaders;
	    }
	
	    if (opts.localAddress) {
	      this.localAddress = opts.localAddress;
	    }
	  }
	
	  // set on handshake
	  this.id = null;
	  this.upgrades = null;
	  this.pingInterval = null;
	  this.pingTimeout = null;
	
	  // set on heartbeat
	  this.pingIntervalTimer = null;
	  this.pingTimeoutTimer = null;
	
	  this.open();
	}
	
	Socket.priorWebsocketSuccess = false;
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Socket.prototype);
	
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	Socket.protocol = parser.protocol; // this is an int
	
	/**
	 * Expose deps for legacy compatibility
	 * and standalone browser access.
	 */
	
	Socket.Socket = Socket;
	Socket.Transport = __webpack_require__(209);
	Socket.transports = __webpack_require__(204);
	Socket.parser = __webpack_require__(210);
	
	/**
	 * Creates transport of the given type.
	 *
	 * @param {String} transport name
	 * @return {Transport}
	 * @api private
	 */
	
	Socket.prototype.createTransport = function (name) {
	  debug('creating transport "%s"', name);
	  var query = clone(this.query);
	
	  // append engine.io protocol identifier
	  query.EIO = parser.protocol;
	
	  // transport name
	  query.transport = name;
	
	  // session id if we already have one
	  if (this.id) query.sid = this.id;
	
	  var transport = new transports[name]({
	    agent: this.agent,
	    hostname: this.hostname,
	    port: this.port,
	    secure: this.secure,
	    path: this.path,
	    query: query,
	    forceJSONP: this.forceJSONP,
	    jsonp: this.jsonp,
	    forceBase64: this.forceBase64,
	    enablesXDR: this.enablesXDR,
	    timestampRequests: this.timestampRequests,
	    timestampParam: this.timestampParam,
	    policyPort: this.policyPort,
	    socket: this,
	    pfx: this.pfx,
	    key: this.key,
	    passphrase: this.passphrase,
	    cert: this.cert,
	    ca: this.ca,
	    ciphers: this.ciphers,
	    rejectUnauthorized: this.rejectUnauthorized,
	    perMessageDeflate: this.perMessageDeflate,
	    extraHeaders: this.extraHeaders,
	    forceNode: this.forceNode,
	    localAddress: this.localAddress
	  });
	
	  return transport;
	};
	
	function clone (obj) {
	  var o = {};
	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) {
	      o[i] = obj[i];
	    }
	  }
	  return o;
	}
	
	/**
	 * Initializes transport to use and starts probe.
	 *
	 * @api private
	 */
	Socket.prototype.open = function () {
	  var transport;
	  if (this.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf('websocket') !== -1) {
	    transport = 'websocket';
	  } else if (0 === this.transports.length) {
	    // Emit error on next tick so it can be listened to
	    var self = this;
	    setTimeout(function () {
	      self.emit('error', 'No transports available');
	    }, 0);
	    return;
	  } else {
	    transport = this.transports[0];
	  }
	  this.readyState = 'opening';
	
	  // Retry with the next transport if the transport is disabled (jsonp: false)
	  try {
	    transport = this.createTransport(transport);
	  } catch (e) {
	    this.transports.shift();
	    this.open();
	    return;
	  }
	
	  transport.open();
	  this.setTransport(transport);
	};
	
	/**
	 * Sets the current transport. Disables the existing one (if any).
	 *
	 * @api private
	 */
	
	Socket.prototype.setTransport = function (transport) {
	  debug('setting transport %s', transport.name);
	  var self = this;
	
	  if (this.transport) {
	    debug('clearing existing transport %s', this.transport.name);
	    this.transport.removeAllListeners();
	  }
	
	  // set up transport
	  this.transport = transport;
	
	  // set up transport listeners
	  transport
	  .on('drain', function () {
	    self.onDrain();
	  })
	  .on('packet', function (packet) {
	    self.onPacket(packet);
	  })
	  .on('error', function (e) {
	    self.onError(e);
	  })
	  .on('close', function () {
	    self.onClose('transport close');
	  });
	};
	
	/**
	 * Probes a transport.
	 *
	 * @param {String} transport name
	 * @api private
	 */
	
	Socket.prototype.probe = function (name) {
	  debug('probing transport "%s"', name);
	  var transport = this.createTransport(name, { probe: 1 });
	  var failed = false;
	  var self = this;
	
	  Socket.priorWebsocketSuccess = false;
	
	  function onTransportOpen () {
	    if (self.onlyBinaryUpgrades) {
	      var upgradeLosesBinary = !this.supportsBinary && self.transport.supportsBinary;
	      failed = failed || upgradeLosesBinary;
	    }
	    if (failed) return;
	
	    debug('probe transport "%s" opened', name);
	    transport.send([{ type: 'ping', data: 'probe' }]);
	    transport.once('packet', function (msg) {
	      if (failed) return;
	      if ('pong' === msg.type && 'probe' === msg.data) {
	        debug('probe transport "%s" pong', name);
	        self.upgrading = true;
	        self.emit('upgrading', transport);
	        if (!transport) return;
	        Socket.priorWebsocketSuccess = 'websocket' === transport.name;
	
	        debug('pausing current transport "%s"', self.transport.name);
	        self.transport.pause(function () {
	          if (failed) return;
	          if ('closed' === self.readyState) return;
	          debug('changing transport and sending upgrade packet');
	
	          cleanup();
	
	          self.setTransport(transport);
	          transport.send([{ type: 'upgrade' }]);
	          self.emit('upgrade', transport);
	          transport = null;
	          self.upgrading = false;
	          self.flush();
	        });
	      } else {
	        debug('probe transport "%s" failed', name);
	        var err = new Error('probe error');
	        err.transport = transport.name;
	        self.emit('upgradeError', err);
	      }
	    });
	  }
	
	  function freezeTransport () {
	    if (failed) return;
	
	    // Any callback called by transport should be ignored since now
	    failed = true;
	
	    cleanup();
	
	    transport.close();
	    transport = null;
	  }
	
	  // Handle any error that happens while probing
	  function onerror (err) {
	    var error = new Error('probe error: ' + err);
	    error.transport = transport.name;
	
	    freezeTransport();
	
	    debug('probe transport "%s" failed because of error: %s', name, err);
	
	    self.emit('upgradeError', error);
	  }
	
	  function onTransportClose () {
	    onerror('transport closed');
	  }
	
	  // When the socket is closed while we're probing
	  function onclose () {
	    onerror('socket closed');
	  }
	
	  // When the socket is upgraded while we're probing
	  function onupgrade (to) {
	    if (transport && to.name !== transport.name) {
	      debug('"%s" works - aborting "%s"', to.name, transport.name);
	      freezeTransport();
	    }
	  }
	
	  // Remove all listeners on the transport and on self
	  function cleanup () {
	    transport.removeListener('open', onTransportOpen);
	    transport.removeListener('error', onerror);
	    transport.removeListener('close', onTransportClose);
	    self.removeListener('close', onclose);
	    self.removeListener('upgrading', onupgrade);
	  }
	
	  transport.once('open', onTransportOpen);
	  transport.once('error', onerror);
	  transport.once('close', onTransportClose);
	
	  this.once('close', onclose);
	  this.once('upgrading', onupgrade);
	
	  transport.open();
	};
	
	/**
	 * Called when connection is deemed open.
	 *
	 * @api public
	 */
	
	Socket.prototype.onOpen = function () {
	  debug('socket open');
	  this.readyState = 'open';
	  Socket.priorWebsocketSuccess = 'websocket' === this.transport.name;
	  this.emit('open');
	  this.flush();
	
	  // we check for `readyState` in case an `open`
	  // listener already closed the socket
	  if ('open' === this.readyState && this.upgrade && this.transport.pause) {
	    debug('starting upgrade probes');
	    for (var i = 0, l = this.upgrades.length; i < l; i++) {
	      this.probe(this.upgrades[i]);
	    }
	  }
	};
	
	/**
	 * Handles a packet.
	 *
	 * @api private
	 */
	
	Socket.prototype.onPacket = function (packet) {
	  if ('opening' === this.readyState || 'open' === this.readyState ||
	      'closing' === this.readyState) {
	    debug('socket receive: type "%s", data "%s"', packet.type, packet.data);
	
	    this.emit('packet', packet);
	
	    // Socket is live - any packet counts
	    this.emit('heartbeat');
	
	    switch (packet.type) {
	      case 'open':
	        this.onHandshake(parsejson(packet.data));
	        break;
	
	      case 'pong':
	        this.setPing();
	        this.emit('pong');
	        break;
	
	      case 'error':
	        var err = new Error('server error');
	        err.code = packet.data;
	        this.onError(err);
	        break;
	
	      case 'message':
	        this.emit('data', packet.data);
	        this.emit('message', packet.data);
	        break;
	    }
	  } else {
	    debug('packet received with socket readyState "%s"', this.readyState);
	  }
	};
	
	/**
	 * Called upon handshake completion.
	 *
	 * @param {Object} handshake obj
	 * @api private
	 */
	
	Socket.prototype.onHandshake = function (data) {
	  this.emit('handshake', data);
	  this.id = data.sid;
	  this.transport.query.sid = data.sid;
	  this.upgrades = this.filterUpgrades(data.upgrades);
	  this.pingInterval = data.pingInterval;
	  this.pingTimeout = data.pingTimeout;
	  this.onOpen();
	  // In case open handler closes socket
	  if ('closed' === this.readyState) return;
	  this.setPing();
	
	  // Prolong liveness of socket on heartbeat
	  this.removeListener('heartbeat', this.onHeartbeat);
	  this.on('heartbeat', this.onHeartbeat);
	};
	
	/**
	 * Resets ping timeout.
	 *
	 * @api private
	 */
	
	Socket.prototype.onHeartbeat = function (timeout) {
	  clearTimeout(this.pingTimeoutTimer);
	  var self = this;
	  self.pingTimeoutTimer = setTimeout(function () {
	    if ('closed' === self.readyState) return;
	    self.onClose('ping timeout');
	  }, timeout || (self.pingInterval + self.pingTimeout));
	};
	
	/**
	 * Pings server every `this.pingInterval` and expects response
	 * within `this.pingTimeout` or closes connection.
	 *
	 * @api private
	 */
	
	Socket.prototype.setPing = function () {
	  var self = this;
	  clearTimeout(self.pingIntervalTimer);
	  self.pingIntervalTimer = setTimeout(function () {
	    debug('writing ping packet - expecting pong within %sms', self.pingTimeout);
	    self.ping();
	    self.onHeartbeat(self.pingTimeout);
	  }, self.pingInterval);
	};
	
	/**
	* Sends a ping packet.
	*
	* @api private
	*/
	
	Socket.prototype.ping = function () {
	  var self = this;
	  this.sendPacket('ping', function () {
	    self.emit('ping');
	  });
	};
	
	/**
	 * Called on `drain` event
	 *
	 * @api private
	 */
	
	Socket.prototype.onDrain = function () {
	  this.writeBuffer.splice(0, this.prevBufferLen);
	
	  // setting prevBufferLen = 0 is very important
	  // for example, when upgrading, upgrade packet is sent over,
	  // and a nonzero prevBufferLen could cause problems on `drain`
	  this.prevBufferLen = 0;
	
	  if (0 === this.writeBuffer.length) {
	    this.emit('drain');
	  } else {
	    this.flush();
	  }
	};
	
	/**
	 * Flush write buffers.
	 *
	 * @api private
	 */
	
	Socket.prototype.flush = function () {
	  if ('closed' !== this.readyState && this.transport.writable &&
	    !this.upgrading && this.writeBuffer.length) {
	    debug('flushing %d packets in socket', this.writeBuffer.length);
	    this.transport.send(this.writeBuffer);
	    // keep track of current length of writeBuffer
	    // splice writeBuffer and callbackBuffer on `drain`
	    this.prevBufferLen = this.writeBuffer.length;
	    this.emit('flush');
	  }
	};
	
	/**
	 * Sends a message.
	 *
	 * @param {String} message.
	 * @param {Function} callback function.
	 * @param {Object} options.
	 * @return {Socket} for chaining.
	 * @api public
	 */
	
	Socket.prototype.write =
	Socket.prototype.send = function (msg, options, fn) {
	  this.sendPacket('message', msg, options, fn);
	  return this;
	};
	
	/**
	 * Sends a packet.
	 *
	 * @param {String} packet type.
	 * @param {String} data.
	 * @param {Object} options.
	 * @param {Function} callback function.
	 * @api private
	 */
	
	Socket.prototype.sendPacket = function (type, data, options, fn) {
	  if ('function' === typeof data) {
	    fn = data;
	    data = undefined;
	  }
	
	  if ('function' === typeof options) {
	    fn = options;
	    options = null;
	  }
	
	  if ('closing' === this.readyState || 'closed' === this.readyState) {
	    return;
	  }
	
	  options = options || {};
	  options.compress = false !== options.compress;
	
	  var packet = {
	    type: type,
	    data: data,
	    options: options
	  };
	  this.emit('packetCreate', packet);
	  this.writeBuffer.push(packet);
	  if (fn) this.once('flush', fn);
	  this.flush();
	};
	
	/**
	 * Closes the connection.
	 *
	 * @api private
	 */
	
	Socket.prototype.close = function () {
	  if ('opening' === this.readyState || 'open' === this.readyState) {
	    this.readyState = 'closing';
	
	    var self = this;
	
	    if (this.writeBuffer.length) {
	      this.once('drain', function () {
	        if (this.upgrading) {
	          waitForUpgrade();
	        } else {
	          close();
	        }
	      });
	    } else if (this.upgrading) {
	      waitForUpgrade();
	    } else {
	      close();
	    }
	  }
	
	  function close () {
	    self.onClose('forced close');
	    debug('socket closing - telling transport to close');
	    self.transport.close();
	  }
	
	  function cleanupAndClose () {
	    self.removeListener('upgrade', cleanupAndClose);
	    self.removeListener('upgradeError', cleanupAndClose);
	    close();
	  }
	
	  function waitForUpgrade () {
	    // wait for upgrade to finish since we can't send packets while pausing a transport
	    self.once('upgrade', cleanupAndClose);
	    self.once('upgradeError', cleanupAndClose);
	  }
	
	  return this;
	};
	
	/**
	 * Called upon transport error
	 *
	 * @api private
	 */
	
	Socket.prototype.onError = function (err) {
	  debug('socket error %j', err);
	  Socket.priorWebsocketSuccess = false;
	  this.emit('error', err);
	  this.onClose('transport error', err);
	};
	
	/**
	 * Called upon transport close.
	 *
	 * @api private
	 */
	
	Socket.prototype.onClose = function (reason, desc) {
	  if ('opening' === this.readyState || 'open' === this.readyState || 'closing' === this.readyState) {
	    debug('socket close with reason: "%s"', reason);
	    var self = this;
	
	    // clear timers
	    clearTimeout(this.pingIntervalTimer);
	    clearTimeout(this.pingTimeoutTimer);
	
	    // stop event from firing again for transport
	    this.transport.removeAllListeners('close');
	
	    // ensure transport won't stay open
	    this.transport.close();
	
	    // ignore further transport communication
	    this.transport.removeAllListeners();
	
	    // set ready state
	    this.readyState = 'closed';
	
	    // clear session id
	    this.id = null;
	
	    // emit close event
	    this.emit('close', reason, desc);
	
	    // clean buffers after, so users can still
	    // grab the buffers on `close` event
	    self.writeBuffer = [];
	    self.prevBufferLen = 0;
	  }
	};
	
	/**
	 * Filters upgrades, returning only those matching client transports.
	 *
	 * @param {Array} server upgrades
	 * @api private
	 *
	 */
	
	Socket.prototype.filterUpgrades = function (upgrades) {
	  var filteredUpgrades = [];
	  for (var i = 0, j = upgrades.length; i < j; i++) {
	    if (~index(this.transports, upgrades[i])) filteredUpgrades.push(upgrades[i]);
	  }
	  return filteredUpgrades;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies
	 */
	
	var XMLHttpRequest = __webpack_require__(205);
	var XHR = __webpack_require__(207);
	var JSONP = __webpack_require__(226);
	var websocket = __webpack_require__(227);
	
	/**
	 * Export transports.
	 */
	
	exports.polling = polling;
	exports.websocket = websocket;
	
	/**
	 * Polling transport polymorphic constructor.
	 * Decides on xhr vs jsonp based on feature detection.
	 *
	 * @api private
	 */
	
	function polling (opts) {
	  var xhr;
	  var xd = false;
	  var xs = false;
	  var jsonp = false !== opts.jsonp;
	
	  if (global.location) {
	    var isSSL = 'https:' === location.protocol;
	    var port = location.port;
	
	    // some user agents have empty `location.port`
	    if (!port) {
	      port = isSSL ? 443 : 80;
	    }
	
	    xd = opts.hostname !== location.hostname || port !== opts.port;
	    xs = opts.secure !== isSSL;
	  }
	
	  opts.xdomain = xd;
	  opts.xscheme = xs;
	  xhr = new XMLHttpRequest(opts);
	
	  if ('open' in xhr && !opts.forceJSONP) {
	    return new XHR(opts);
	  } else {
	    if (!jsonp) throw new Error('JSONP disabled');
	    return new JSONP(opts);
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// browser shim for xmlhttprequest module
	
	var hasCORS = __webpack_require__(206);
	
	module.exports = function (opts) {
	  var xdomain = opts.xdomain;
	
	  // scheme must be same when usign XDomainRequest
	  // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
	  var xscheme = opts.xscheme;
	
	  // XDomainRequest has a flow of not sending cookie, therefore it should be disabled as a default.
	  // https://github.com/Automattic/engine.io-client/pull/217
	  var enablesXDR = opts.enablesXDR;
	
	  // XMLHttpRequest can be disabled on IE
	  try {
	    if ('undefined' !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
	      return new XMLHttpRequest();
	    }
	  } catch (e) { }
	
	  // Use XDomainRequest for IE8 if enablesXDR is true
	  // because loading bar keeps flashing when using jsonp-polling
	  // https://github.com/yujiosaka/socke.io-ie8-loading-example
	  try {
	    if ('undefined' !== typeof XDomainRequest && !xscheme && enablesXDR) {
	      return new XDomainRequest();
	    }
	  } catch (e) { }
	
	  if (!xdomain) {
	    try {
	      return new global[['Active'].concat('Object').join('X')]('Microsoft.XMLHTTP');
	    } catch (e) { }
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 206 */
/***/ (function(module, exports) {

	
	/**
	 * Module exports.
	 *
	 * Logic borrowed from Modernizr:
	 *
	 *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
	 */
	
	try {
	  module.exports = typeof XMLHttpRequest !== 'undefined' &&
	    'withCredentials' in new XMLHttpRequest();
	} catch (err) {
	  // if XMLHttp support is disabled in IE then it will throw
	  // when trying to create
	  module.exports = false;
	}


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module requirements.
	 */
	
	var XMLHttpRequest = __webpack_require__(205);
	var Polling = __webpack_require__(208);
	var Emitter = __webpack_require__(219);
	var inherit = __webpack_require__(221);
	var debug = __webpack_require__(223)('engine.io-client:polling-xhr');
	
	/**
	 * Module exports.
	 */
	
	module.exports = XHR;
	module.exports.Request = Request;
	
	/**
	 * Empty function
	 */
	
	function empty () {}
	
	/**
	 * XHR Polling constructor.
	 *
	 * @param {Object} opts
	 * @api public
	 */
	
	function XHR (opts) {
	  Polling.call(this, opts);
	  this.requestTimeout = opts.requestTimeout;
	
	  if (global.location) {
	    var isSSL = 'https:' === location.protocol;
	    var port = location.port;
	
	    // some user agents have empty `location.port`
	    if (!port) {
	      port = isSSL ? 443 : 80;
	    }
	
	    this.xd = opts.hostname !== global.location.hostname ||
	      port !== opts.port;
	    this.xs = opts.secure !== isSSL;
	  } else {
	    this.extraHeaders = opts.extraHeaders;
	  }
	}
	
	/**
	 * Inherits from Polling.
	 */
	
	inherit(XHR, Polling);
	
	/**
	 * XHR supports binary
	 */
	
	XHR.prototype.supportsBinary = true;
	
	/**
	 * Creates a request.
	 *
	 * @param {String} method
	 * @api private
	 */
	
	XHR.prototype.request = function (opts) {
	  opts = opts || {};
	  opts.uri = this.uri();
	  opts.xd = this.xd;
	  opts.xs = this.xs;
	  opts.agent = this.agent || false;
	  opts.supportsBinary = this.supportsBinary;
	  opts.enablesXDR = this.enablesXDR;
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	  opts.requestTimeout = this.requestTimeout;
	
	  // other options for Node.js client
	  opts.extraHeaders = this.extraHeaders;
	
	  return new Request(opts);
	};
	
	/**
	 * Sends data.
	 *
	 * @param {String} data to send.
	 * @param {Function} called upon flush.
	 * @api private
	 */
	
	XHR.prototype.doWrite = function (data, fn) {
	  var isBinary = typeof data !== 'string' && data !== undefined;
	  var req = this.request({ method: 'POST', data: data, isBinary: isBinary });
	  var self = this;
	  req.on('success', fn);
	  req.on('error', function (err) {
	    self.onError('xhr post error', err);
	  });
	  this.sendXhr = req;
	};
	
	/**
	 * Starts a poll cycle.
	 *
	 * @api private
	 */
	
	XHR.prototype.doPoll = function () {
	  debug('xhr poll');
	  var req = this.request();
	  var self = this;
	  req.on('data', function (data) {
	    self.onData(data);
	  });
	  req.on('error', function (err) {
	    self.onError('xhr poll error', err);
	  });
	  this.pollXhr = req;
	};
	
	/**
	 * Request constructor
	 *
	 * @param {Object} options
	 * @api public
	 */
	
	function Request (opts) {
	  this.method = opts.method || 'GET';
	  this.uri = opts.uri;
	  this.xd = !!opts.xd;
	  this.xs = !!opts.xs;
	  this.async = false !== opts.async;
	  this.data = undefined !== opts.data ? opts.data : null;
	  this.agent = opts.agent;
	  this.isBinary = opts.isBinary;
	  this.supportsBinary = opts.supportsBinary;
	  this.enablesXDR = opts.enablesXDR;
	  this.requestTimeout = opts.requestTimeout;
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx;
	  this.key = opts.key;
	  this.passphrase = opts.passphrase;
	  this.cert = opts.cert;
	  this.ca = opts.ca;
	  this.ciphers = opts.ciphers;
	  this.rejectUnauthorized = opts.rejectUnauthorized;
	
	  // other options for Node.js client
	  this.extraHeaders = opts.extraHeaders;
	
	  this.create();
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Request.prototype);
	
	/**
	 * Creates the XHR object and sends the request.
	 *
	 * @api private
	 */
	
	Request.prototype.create = function () {
	  var opts = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	
	  var xhr = this.xhr = new XMLHttpRequest(opts);
	  var self = this;
	
	  try {
	    debug('xhr open %s: %s', this.method, this.uri);
	    xhr.open(this.method, this.uri, this.async);
	    try {
	      if (this.extraHeaders) {
	        xhr.setDisableHeaderCheck(true);
	        for (var i in this.extraHeaders) {
	          if (this.extraHeaders.hasOwnProperty(i)) {
	            xhr.setRequestHeader(i, this.extraHeaders[i]);
	          }
	        }
	      }
	    } catch (e) {}
	    if (this.supportsBinary) {
	      // This has to be done after open because Firefox is stupid
	      // http://stackoverflow.com/questions/13216903/get-binary-data-with-xmlhttprequest-in-a-firefox-extension
	      xhr.responseType = 'arraybuffer';
	    }
	
	    if ('POST' === this.method) {
	      try {
	        if (this.isBinary) {
	          xhr.setRequestHeader('Content-type', 'application/octet-stream');
	        } else {
	          xhr.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');
	        }
	      } catch (e) {}
	    }
	
	    try {
	      xhr.setRequestHeader('Accept', '*/*');
	    } catch (e) {}
	
	    // ie6 check
	    if ('withCredentials' in xhr) {
	      xhr.withCredentials = true;
	    }
	
	    if (this.requestTimeout) {
	      xhr.timeout = this.requestTimeout;
	    }
	
	    if (this.hasXDR()) {
	      xhr.onload = function () {
	        self.onLoad();
	      };
	      xhr.onerror = function () {
	        self.onError(xhr.responseText);
	      };
	    } else {
	      xhr.onreadystatechange = function () {
	        if (4 !== xhr.readyState) return;
	        if (200 === xhr.status || 1223 === xhr.status) {
	          self.onLoad();
	        } else {
	          // make sure the `error` event handler that's user-set
	          // does not throw in the same tick and gets caught here
	          setTimeout(function () {
	            self.onError(xhr.status);
	          }, 0);
	        }
	      };
	    }
	
	    debug('xhr data %s', this.data);
	    xhr.send(this.data);
	  } catch (e) {
	    // Need to defer since .create() is called directly fhrom the constructor
	    // and thus the 'error' event can only be only bound *after* this exception
	    // occurs.  Therefore, also, we cannot throw here at all.
	    setTimeout(function () {
	      self.onError(e);
	    }, 0);
	    return;
	  }
	
	  if (global.document) {
	    this.index = Request.requestsCount++;
	    Request.requests[this.index] = this;
	  }
	};
	
	/**
	 * Called upon successful response.
	 *
	 * @api private
	 */
	
	Request.prototype.onSuccess = function () {
	  this.emit('success');
	  this.cleanup();
	};
	
	/**
	 * Called if we have data.
	 *
	 * @api private
	 */
	
	Request.prototype.onData = function (data) {
	  this.emit('data', data);
	  this.onSuccess();
	};
	
	/**
	 * Called upon error.
	 *
	 * @api private
	 */
	
	Request.prototype.onError = function (err) {
	  this.emit('error', err);
	  this.cleanup(true);
	};
	
	/**
	 * Cleans up house.
	 *
	 * @api private
	 */
	
	Request.prototype.cleanup = function (fromError) {
	  if ('undefined' === typeof this.xhr || null === this.xhr) {
	    return;
	  }
	  // xmlhttprequest
	  if (this.hasXDR()) {
	    this.xhr.onload = this.xhr.onerror = empty;
	  } else {
	    this.xhr.onreadystatechange = empty;
	  }
	
	  if (fromError) {
	    try {
	      this.xhr.abort();
	    } catch (e) {}
	  }
	
	  if (global.document) {
	    delete Request.requests[this.index];
	  }
	
	  this.xhr = null;
	};
	
	/**
	 * Called upon load.
	 *
	 * @api private
	 */
	
	Request.prototype.onLoad = function () {
	  var data;
	  try {
	    var contentType;
	    try {
	      contentType = this.xhr.getResponseHeader('Content-Type').split(';')[0];
	    } catch (e) {}
	    if (contentType === 'application/octet-stream') {
	      data = this.xhr.response || this.xhr.responseText;
	    } else {
	      if (!this.supportsBinary) {
	        data = this.xhr.responseText;
	      } else {
	        try {
	          data = String.fromCharCode.apply(null, new Uint8Array(this.xhr.response));
	        } catch (e) {
	          var ui8Arr = new Uint8Array(this.xhr.response);
	          var dataArray = [];
	          for (var idx = 0, length = ui8Arr.length; idx < length; idx++) {
	            dataArray.push(ui8Arr[idx]);
	          }
	
	          data = String.fromCharCode.apply(null, dataArray);
	        }
	      }
	    }
	  } catch (e) {
	    this.onError(e);
	  }
	  if (null != data) {
	    this.onData(data);
	  }
	};
	
	/**
	 * Check if it has XDomainRequest.
	 *
	 * @api private
	 */
	
	Request.prototype.hasXDR = function () {
	  return 'undefined' !== typeof global.XDomainRequest && !this.xs && this.enablesXDR;
	};
	
	/**
	 * Aborts the request.
	 *
	 * @api public
	 */
	
	Request.prototype.abort = function () {
	  this.cleanup();
	};
	
	/**
	 * Aborts pending requests when unloading the window. This is needed to prevent
	 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
	 * emitted.
	 */
	
	Request.requestsCount = 0;
	Request.requests = {};
	
	if (global.document) {
	  if (global.attachEvent) {
	    global.attachEvent('onunload', unloadHandler);
	  } else if (global.addEventListener) {
	    global.addEventListener('beforeunload', unloadHandler, false);
	  }
	}
	
	function unloadHandler () {
	  for (var i in Request.requests) {
	    if (Request.requests.hasOwnProperty(i)) {
	      Request.requests[i].abort();
	    }
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var Transport = __webpack_require__(209);
	var parseqs = __webpack_require__(220);
	var parser = __webpack_require__(210);
	var inherit = __webpack_require__(221);
	var yeast = __webpack_require__(222);
	var debug = __webpack_require__(223)('engine.io-client:polling');
	
	/**
	 * Module exports.
	 */
	
	module.exports = Polling;
	
	/**
	 * Is XHR2 supported?
	 */
	
	var hasXHR2 = (function () {
	  var XMLHttpRequest = __webpack_require__(205);
	  var xhr = new XMLHttpRequest({ xdomain: false });
	  return null != xhr.responseType;
	})();
	
	/**
	 * Polling interface.
	 *
	 * @param {Object} opts
	 * @api private
	 */
	
	function Polling (opts) {
	  var forceBase64 = (opts && opts.forceBase64);
	  if (!hasXHR2 || forceBase64) {
	    this.supportsBinary = false;
	  }
	  Transport.call(this, opts);
	}
	
	/**
	 * Inherits from Transport.
	 */
	
	inherit(Polling, Transport);
	
	/**
	 * Transport name.
	 */
	
	Polling.prototype.name = 'polling';
	
	/**
	 * Opens the socket (triggers polling). We write a PING message to determine
	 * when the transport is open.
	 *
	 * @api private
	 */
	
	Polling.prototype.doOpen = function () {
	  this.poll();
	};
	
	/**
	 * Pauses polling.
	 *
	 * @param {Function} callback upon buffers are flushed and transport is paused
	 * @api private
	 */
	
	Polling.prototype.pause = function (onPause) {
	  var self = this;
	
	  this.readyState = 'pausing';
	
	  function pause () {
	    debug('paused');
	    self.readyState = 'paused';
	    onPause();
	  }
	
	  if (this.polling || !this.writable) {
	    var total = 0;
	
	    if (this.polling) {
	      debug('we are currently polling - waiting to pause');
	      total++;
	      this.once('pollComplete', function () {
	        debug('pre-pause polling complete');
	        --total || pause();
	      });
	    }
	
	    if (!this.writable) {
	      debug('we are currently writing - waiting to pause');
	      total++;
	      this.once('drain', function () {
	        debug('pre-pause writing complete');
	        --total || pause();
	      });
	    }
	  } else {
	    pause();
	  }
	};
	
	/**
	 * Starts polling cycle.
	 *
	 * @api public
	 */
	
	Polling.prototype.poll = function () {
	  debug('polling');
	  this.polling = true;
	  this.doPoll();
	  this.emit('poll');
	};
	
	/**
	 * Overloads onData to detect payloads.
	 *
	 * @api private
	 */
	
	Polling.prototype.onData = function (data) {
	  var self = this;
	  debug('polling got data %s', data);
	  var callback = function (packet, index, total) {
	    // if its the first message we consider the transport open
	    if ('opening' === self.readyState) {
	      self.onOpen();
	    }
	
	    // if its a close packet, we close the ongoing requests
	    if ('close' === packet.type) {
	      self.onClose();
	      return false;
	    }
	
	    // otherwise bypass onData and handle the message
	    self.onPacket(packet);
	  };
	
	  // decode payload
	  parser.decodePayload(data, this.socket.binaryType, callback);
	
	  // if an event did not trigger closing
	  if ('closed' !== this.readyState) {
	    // if we got data we're not polling
	    this.polling = false;
	    this.emit('pollComplete');
	
	    if ('open' === this.readyState) {
	      this.poll();
	    } else {
	      debug('ignoring poll - transport state "%s"', this.readyState);
	    }
	  }
	};
	
	/**
	 * For polling, send a close packet.
	 *
	 * @api private
	 */
	
	Polling.prototype.doClose = function () {
	  var self = this;
	
	  function close () {
	    debug('writing close packet');
	    self.write([{ type: 'close' }]);
	  }
	
	  if ('open' === this.readyState) {
	    debug('transport open - closing');
	    close();
	  } else {
	    // in case we're trying to close while
	    // handshaking is in progress (GH-164)
	    debug('transport not open - deferring close');
	    this.once('open', close);
	  }
	};
	
	/**
	 * Writes a packets payload.
	 *
	 * @param {Array} data packets
	 * @param {Function} drain callback
	 * @api private
	 */
	
	Polling.prototype.write = function (packets) {
	  var self = this;
	  this.writable = false;
	  var callbackfn = function () {
	    self.writable = true;
	    self.emit('drain');
	  };
	
	  parser.encodePayload(packets, this.supportsBinary, function (data) {
	    self.doWrite(data, callbackfn);
	  });
	};
	
	/**
	 * Generates uri for connection.
	 *
	 * @api private
	 */
	
	Polling.prototype.uri = function () {
	  var query = this.query || {};
	  var schema = this.secure ? 'https' : 'http';
	  var port = '';
	
	  // cache busting is forced
	  if (false !== this.timestampRequests) {
	    query[this.timestampParam] = yeast();
	  }
	
	  if (!this.supportsBinary && !query.sid) {
	    query.b64 = 1;
	  }
	
	  query = parseqs.encode(query);
	
	  // avoid port if default for schema
	  if (this.port && (('https' === schema && Number(this.port) !== 443) ||
	     ('http' === schema && Number(this.port) !== 80))) {
	    port = ':' + this.port;
	  }
	
	  // prepend ? to query
	  if (query.length) {
	    query = '?' + query;
	  }
	
	  var ipv6 = this.hostname.indexOf(':') !== -1;
	  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
	};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var parser = __webpack_require__(210);
	var Emitter = __webpack_require__(219);
	
	/**
	 * Module exports.
	 */
	
	module.exports = Transport;
	
	/**
	 * Transport abstract constructor.
	 *
	 * @param {Object} options.
	 * @api private
	 */
	
	function Transport (opts) {
	  this.path = opts.path;
	  this.hostname = opts.hostname;
	  this.port = opts.port;
	  this.secure = opts.secure;
	  this.query = opts.query;
	  this.timestampParam = opts.timestampParam;
	  this.timestampRequests = opts.timestampRequests;
	  this.readyState = '';
	  this.agent = opts.agent || false;
	  this.socket = opts.socket;
	  this.enablesXDR = opts.enablesXDR;
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx;
	  this.key = opts.key;
	  this.passphrase = opts.passphrase;
	  this.cert = opts.cert;
	  this.ca = opts.ca;
	  this.ciphers = opts.ciphers;
	  this.rejectUnauthorized = opts.rejectUnauthorized;
	  this.forceNode = opts.forceNode;
	
	  // other options for Node.js client
	  this.extraHeaders = opts.extraHeaders;
	  this.localAddress = opts.localAddress;
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Transport.prototype);
	
	/**
	 * Emits an error.
	 *
	 * @param {String} str
	 * @return {Transport} for chaining
	 * @api public
	 */
	
	Transport.prototype.onError = function (msg, desc) {
	  var err = new Error(msg);
	  err.type = 'TransportError';
	  err.description = desc;
	  this.emit('error', err);
	  return this;
	};
	
	/**
	 * Opens the transport.
	 *
	 * @api public
	 */
	
	Transport.prototype.open = function () {
	  if ('closed' === this.readyState || '' === this.readyState) {
	    this.readyState = 'opening';
	    this.doOpen();
	  }
	
	  return this;
	};
	
	/**
	 * Closes the transport.
	 *
	 * @api private
	 */
	
	Transport.prototype.close = function () {
	  if ('opening' === this.readyState || 'open' === this.readyState) {
	    this.doClose();
	    this.onClose();
	  }
	
	  return this;
	};
	
	/**
	 * Sends multiple packets.
	 *
	 * @param {Array} packets
	 * @api private
	 */
	
	Transport.prototype.send = function (packets) {
	  if ('open' === this.readyState) {
	    this.write(packets);
	  } else {
	    throw new Error('Transport not open');
	  }
	};
	
	/**
	 * Called upon open
	 *
	 * @api private
	 */
	
	Transport.prototype.onOpen = function () {
	  this.readyState = 'open';
	  this.writable = true;
	  this.emit('open');
	};
	
	/**
	 * Called with data.
	 *
	 * @param {String} data
	 * @api private
	 */
	
	Transport.prototype.onData = function (data) {
	  var packet = parser.decodePacket(data, this.socket.binaryType);
	  this.onPacket(packet);
	};
	
	/**
	 * Called with a decoded packet.
	 */
	
	Transport.prototype.onPacket = function (packet) {
	  this.emit('packet', packet);
	};
	
	/**
	 * Called upon close.
	 *
	 * @api private
	 */
	
	Transport.prototype.onClose = function () {
	  this.readyState = 'closed';
	  this.emit('close');
	};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var keys = __webpack_require__(211);
	var hasBinary = __webpack_require__(212);
	var sliceBuffer = __webpack_require__(214);
	var after = __webpack_require__(215);
	var utf8 = __webpack_require__(216);
	
	var base64encoder;
	if (global && global.ArrayBuffer) {
	  base64encoder = __webpack_require__(217);
	}
	
	/**
	 * Check if we are running an android browser. That requires us to use
	 * ArrayBuffer with polling transports...
	 *
	 * http://ghinda.net/jpeg-blob-ajax-android/
	 */
	
	var isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);
	
	/**
	 * Check if we are running in PhantomJS.
	 * Uploading a Blob with PhantomJS does not work correctly, as reported here:
	 * https://github.com/ariya/phantomjs/issues/11395
	 * @type boolean
	 */
	var isPhantomJS = typeof navigator !== 'undefined' && /PhantomJS/i.test(navigator.userAgent);
	
	/**
	 * When true, avoids using Blobs to encode payloads.
	 * @type boolean
	 */
	var dontSendBlobs = isAndroid || isPhantomJS;
	
	/**
	 * Current protocol version.
	 */
	
	exports.protocol = 3;
	
	/**
	 * Packet types.
	 */
	
	var packets = exports.packets = {
	    open:     0    // non-ws
	  , close:    1    // non-ws
	  , ping:     2
	  , pong:     3
	  , message:  4
	  , upgrade:  5
	  , noop:     6
	};
	
	var packetslist = keys(packets);
	
	/**
	 * Premade error packet.
	 */
	
	var err = { type: 'error', data: 'parser error' };
	
	/**
	 * Create a blob api even for blob builder when vendor prefixes exist
	 */
	
	var Blob = __webpack_require__(218);
	
	/**
	 * Encodes a packet.
	 *
	 *     <packet type id> [ <data> ]
	 *
	 * Example:
	 *
	 *     5hello world
	 *     3
	 *     4
	 *
	 * Binary is encoded in an identical principle
	 *
	 * @api private
	 */
	
	exports.encodePacket = function (packet, supportsBinary, utf8encode, callback) {
	  if ('function' == typeof supportsBinary) {
	    callback = supportsBinary;
	    supportsBinary = false;
	  }
	
	  if ('function' == typeof utf8encode) {
	    callback = utf8encode;
	    utf8encode = null;
	  }
	
	  var data = (packet.data === undefined)
	    ? undefined
	    : packet.data.buffer || packet.data;
	
	  if (global.ArrayBuffer && data instanceof ArrayBuffer) {
	    return encodeArrayBuffer(packet, supportsBinary, callback);
	  } else if (Blob && data instanceof global.Blob) {
	    return encodeBlob(packet, supportsBinary, callback);
	  }
	
	  // might be an object with { base64: true, data: dataAsBase64String }
	  if (data && data.base64) {
	    return encodeBase64Object(packet, callback);
	  }
	
	  // Sending data as a utf-8 string
	  var encoded = packets[packet.type];
	
	  // data fragment is optional
	  if (undefined !== packet.data) {
	    encoded += utf8encode ? utf8.encode(String(packet.data)) : String(packet.data);
	  }
	
	  return callback('' + encoded);
	
	};
	
	function encodeBase64Object(packet, callback) {
	  // packet data is an object { base64: true, data: dataAsBase64String }
	  var message = 'b' + exports.packets[packet.type] + packet.data.data;
	  return callback(message);
	}
	
	/**
	 * Encode packet helpers for binary types
	 */
	
	function encodeArrayBuffer(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  var data = packet.data;
	  var contentArray = new Uint8Array(data);
	  var resultBuffer = new Uint8Array(1 + data.byteLength);
	
	  resultBuffer[0] = packets[packet.type];
	  for (var i = 0; i < contentArray.length; i++) {
	    resultBuffer[i+1] = contentArray[i];
	  }
	
	  return callback(resultBuffer.buffer);
	}
	
	function encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  var fr = new FileReader();
	  fr.onload = function() {
	    packet.data = fr.result;
	    exports.encodePacket(packet, supportsBinary, true, callback);
	  };
	  return fr.readAsArrayBuffer(packet.data);
	}
	
	function encodeBlob(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  if (dontSendBlobs) {
	    return encodeBlobAsArrayBuffer(packet, supportsBinary, callback);
	  }
	
	  var length = new Uint8Array(1);
	  length[0] = packets[packet.type];
	  var blob = new Blob([length.buffer, packet.data]);
	
	  return callback(blob);
	}
	
	/**
	 * Encodes a packet with binary data in a base64 string
	 *
	 * @param {Object} packet, has `type` and `data`
	 * @return {String} base64 encoded message
	 */
	
	exports.encodeBase64Packet = function(packet, callback) {
	  var message = 'b' + exports.packets[packet.type];
	  if (Blob && packet.data instanceof global.Blob) {
	    var fr = new FileReader();
	    fr.onload = function() {
	      var b64 = fr.result.split(',')[1];
	      callback(message + b64);
	    };
	    return fr.readAsDataURL(packet.data);
	  }
	
	  var b64data;
	  try {
	    b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));
	  } catch (e) {
	    // iPhone Safari doesn't let you apply with typed arrays
	    var typed = new Uint8Array(packet.data);
	    var basic = new Array(typed.length);
	    for (var i = 0; i < typed.length; i++) {
	      basic[i] = typed[i];
	    }
	    b64data = String.fromCharCode.apply(null, basic);
	  }
	  message += global.btoa(b64data);
	  return callback(message);
	};
	
	/**
	 * Decodes a packet. Changes format to Blob if requested.
	 *
	 * @return {Object} with `type` and `data` (if any)
	 * @api private
	 */
	
	exports.decodePacket = function (data, binaryType, utf8decode) {
	  if (data === undefined) {
	    return err;
	  }
	  // String data
	  if (typeof data == 'string') {
	    if (data.charAt(0) == 'b') {
	      return exports.decodeBase64Packet(data.substr(1), binaryType);
	    }
	
	    if (utf8decode) {
	      data = tryDecode(data);
	      if (data === false) {
	        return err;
	      }
	    }
	    var type = data.charAt(0);
	
	    if (Number(type) != type || !packetslist[type]) {
	      return err;
	    }
	
	    if (data.length > 1) {
	      return { type: packetslist[type], data: data.substring(1) };
	    } else {
	      return { type: packetslist[type] };
	    }
	  }
	
	  var asArray = new Uint8Array(data);
	  var type = asArray[0];
	  var rest = sliceBuffer(data, 1);
	  if (Blob && binaryType === 'blob') {
	    rest = new Blob([rest]);
	  }
	  return { type: packetslist[type], data: rest };
	};
	
	function tryDecode(data) {
	  try {
	    data = utf8.decode(data);
	  } catch (e) {
	    return false;
	  }
	  return data;
	}
	
	/**
	 * Decodes a packet encoded in a base64 string
	 *
	 * @param {String} base64 encoded message
	 * @return {Object} with `type` and `data` (if any)
	 */
	
	exports.decodeBase64Packet = function(msg, binaryType) {
	  var type = packetslist[msg.charAt(0)];
	  if (!base64encoder) {
	    return { type: type, data: { base64: true, data: msg.substr(1) } };
	  }
	
	  var data = base64encoder.decode(msg.substr(1));
	
	  if (binaryType === 'blob' && Blob) {
	    data = new Blob([data]);
	  }
	
	  return { type: type, data: data };
	};
	
	/**
	 * Encodes multiple messages (payload).
	 *
	 *     <length>:data
	 *
	 * Example:
	 *
	 *     11:hello world2:hi
	 *
	 * If any contents are binary, they will be encoded as base64 strings. Base64
	 * encoded strings are marked with a b before the length specifier
	 *
	 * @param {Array} packets
	 * @api private
	 */
	
	exports.encodePayload = function (packets, supportsBinary, callback) {
	  if (typeof supportsBinary == 'function') {
	    callback = supportsBinary;
	    supportsBinary = null;
	  }
	
	  var isBinary = hasBinary(packets);
	
	  if (supportsBinary && isBinary) {
	    if (Blob && !dontSendBlobs) {
	      return exports.encodePayloadAsBlob(packets, callback);
	    }
	
	    return exports.encodePayloadAsArrayBuffer(packets, callback);
	  }
	
	  if (!packets.length) {
	    return callback('0:');
	  }
	
	  function setLengthHeader(message) {
	    return message.length + ':' + message;
	  }
	
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, !isBinary ? false : supportsBinary, true, function(message) {
	      doneCallback(null, setLengthHeader(message));
	    });
	  }
	
	  map(packets, encodeOne, function(err, results) {
	    return callback(results.join(''));
	  });
	};
	
	/**
	 * Async array map using after
	 */
	
	function map(ary, each, done) {
	  var result = new Array(ary.length);
	  var next = after(ary.length, done);
	
	  var eachWithIndex = function(i, el, cb) {
	    each(el, function(error, msg) {
	      result[i] = msg;
	      cb(error, result);
	    });
	  };
	
	  for (var i = 0; i < ary.length; i++) {
	    eachWithIndex(i, ary[i], next);
	  }
	}
	
	/*
	 * Decodes data when a payload is maybe expected. Possible binary contents are
	 * decoded from their base64 representation
	 *
	 * @param {String} data, callback method
	 * @api public
	 */
	
	exports.decodePayload = function (data, binaryType, callback) {
	  if (typeof data != 'string') {
	    return exports.decodePayloadAsBinary(data, binaryType, callback);
	  }
	
	  if (typeof binaryType === 'function') {
	    callback = binaryType;
	    binaryType = null;
	  }
	
	  var packet;
	  if (data == '') {
	    // parser error - ignoring payload
	    return callback(err, 0, 1);
	  }
	
	  var length = ''
	    , n, msg;
	
	  for (var i = 0, l = data.length; i < l; i++) {
	    var chr = data.charAt(i);
	
	    if (':' != chr) {
	      length += chr;
	    } else {
	      if ('' == length || (length != (n = Number(length)))) {
	        // parser error - ignoring payload
	        return callback(err, 0, 1);
	      }
	
	      msg = data.substr(i + 1, n);
	
	      if (length != msg.length) {
	        // parser error - ignoring payload
	        return callback(err, 0, 1);
	      }
	
	      if (msg.length) {
	        packet = exports.decodePacket(msg, binaryType, true);
	
	        if (err.type == packet.type && err.data == packet.data) {
	          // parser error in individual packet - ignoring payload
	          return callback(err, 0, 1);
	        }
	
	        var ret = callback(packet, i + n, l);
	        if (false === ret) return;
	      }
	
	      // advance cursor
	      i += n;
	      length = '';
	    }
	  }
	
	  if (length != '') {
	    // parser error - ignoring payload
	    return callback(err, 0, 1);
	  }
	
	};
	
	/**
	 * Encodes multiple messages (payload) as binary.
	 *
	 * <1 = binary, 0 = string><number from 0-9><number from 0-9>[...]<number
	 * 255><data>
	 *
	 * Example:
	 * 1 3 255 1 2 3, if the binary contents are interpreted as 8 bit integers
	 *
	 * @param {Array} packets
	 * @return {ArrayBuffer} encoded payload
	 * @api private
	 */
	
	exports.encodePayloadAsArrayBuffer = function(packets, callback) {
	  if (!packets.length) {
	    return callback(new ArrayBuffer(0));
	  }
	
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, true, true, function(data) {
	      return doneCallback(null, data);
	    });
	  }
	
	  map(packets, encodeOne, function(err, encodedPackets) {
	    var totalLength = encodedPackets.reduce(function(acc, p) {
	      var len;
	      if (typeof p === 'string'){
	        len = p.length;
	      } else {
	        len = p.byteLength;
	      }
	      return acc + len.toString().length + len + 2; // string/binary identifier + separator = 2
	    }, 0);
	
	    var resultArray = new Uint8Array(totalLength);
	
	    var bufferIndex = 0;
	    encodedPackets.forEach(function(p) {
	      var isString = typeof p === 'string';
	      var ab = p;
	      if (isString) {
	        var view = new Uint8Array(p.length);
	        for (var i = 0; i < p.length; i++) {
	          view[i] = p.charCodeAt(i);
	        }
	        ab = view.buffer;
	      }
	
	      if (isString) { // not true binary
	        resultArray[bufferIndex++] = 0;
	      } else { // true binary
	        resultArray[bufferIndex++] = 1;
	      }
	
	      var lenStr = ab.byteLength.toString();
	      for (var i = 0; i < lenStr.length; i++) {
	        resultArray[bufferIndex++] = parseInt(lenStr[i]);
	      }
	      resultArray[bufferIndex++] = 255;
	
	      var view = new Uint8Array(ab);
	      for (var i = 0; i < view.length; i++) {
	        resultArray[bufferIndex++] = view[i];
	      }
	    });
	
	    return callback(resultArray.buffer);
	  });
	};
	
	/**
	 * Encode as Blob
	 */
	
	exports.encodePayloadAsBlob = function(packets, callback) {
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, true, true, function(encoded) {
	      var binaryIdentifier = new Uint8Array(1);
	      binaryIdentifier[0] = 1;
	      if (typeof encoded === 'string') {
	        var view = new Uint8Array(encoded.length);
	        for (var i = 0; i < encoded.length; i++) {
	          view[i] = encoded.charCodeAt(i);
	        }
	        encoded = view.buffer;
	        binaryIdentifier[0] = 0;
	      }
	
	      var len = (encoded instanceof ArrayBuffer)
	        ? encoded.byteLength
	        : encoded.size;
	
	      var lenStr = len.toString();
	      var lengthAry = new Uint8Array(lenStr.length + 1);
	      for (var i = 0; i < lenStr.length; i++) {
	        lengthAry[i] = parseInt(lenStr[i]);
	      }
	      lengthAry[lenStr.length] = 255;
	
	      if (Blob) {
	        var blob = new Blob([binaryIdentifier.buffer, lengthAry.buffer, encoded]);
	        doneCallback(null, blob);
	      }
	    });
	  }
	
	  map(packets, encodeOne, function(err, results) {
	    return callback(new Blob(results));
	  });
	};
	
	/*
	 * Decodes data when a payload is maybe expected. Strings are decoded by
	 * interpreting each byte as a key code for entries marked to start with 0. See
	 * description of encodePayloadAsBinary
	 *
	 * @param {ArrayBuffer} data, callback method
	 * @api public
	 */
	
	exports.decodePayloadAsBinary = function (data, binaryType, callback) {
	  if (typeof binaryType === 'function') {
	    callback = binaryType;
	    binaryType = null;
	  }
	
	  var bufferTail = data;
	  var buffers = [];
	
	  var numberTooLong = false;
	  while (bufferTail.byteLength > 0) {
	    var tailArray = new Uint8Array(bufferTail);
	    var isString = tailArray[0] === 0;
	    var msgLength = '';
	
	    for (var i = 1; ; i++) {
	      if (tailArray[i] == 255) break;
	
	      if (msgLength.length > 310) {
	        numberTooLong = true;
	        break;
	      }
	
	      msgLength += tailArray[i];
	    }
	
	    if(numberTooLong) return callback(err, 0, 1);
	
	    bufferTail = sliceBuffer(bufferTail, 2 + msgLength.length);
	    msgLength = parseInt(msgLength);
	
	    var msg = sliceBuffer(bufferTail, 0, msgLength);
	    if (isString) {
	      try {
	        msg = String.fromCharCode.apply(null, new Uint8Array(msg));
	      } catch (e) {
	        // iPhone Safari doesn't let you apply to typed arrays
	        var typed = new Uint8Array(msg);
	        msg = '';
	        for (var i = 0; i < typed.length; i++) {
	          msg += String.fromCharCode(typed[i]);
	        }
	      }
	    }
	
	    buffers.push(msg);
	    bufferTail = sliceBuffer(bufferTail, msgLength);
	  }
	
	  var total = buffers.length;
	  buffers.forEach(function(buffer, i) {
	    callback(exports.decodePacket(buffer, binaryType, true), i, total);
	  });
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 211 */
/***/ (function(module, exports) {

	
	/**
	 * Gets the keys for an object.
	 *
	 * @return {Array} keys
	 * @api private
	 */
	
	module.exports = Object.keys || function keys (obj){
	  var arr = [];
	  var has = Object.prototype.hasOwnProperty;
	
	  for (var i in obj) {
	    if (has.call(obj, i)) {
	      arr.push(i);
	    }
	  }
	  return arr;
	};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/*
	 * Module requirements.
	 */
	
	var isArray = __webpack_require__(213);
	
	/**
	 * Module exports.
	 */
	
	module.exports = hasBinary;
	
	/**
	 * Checks for binary data.
	 *
	 * Right now only Buffer and ArrayBuffer are supported..
	 *
	 * @param {Object} anything
	 * @api public
	 */
	
	function hasBinary(data) {
	
	  function _hasBinary(obj) {
	    if (!obj) return false;
	
	    if ( (global.Buffer && global.Buffer.isBuffer && global.Buffer.isBuffer(obj)) ||
	         (global.ArrayBuffer && obj instanceof ArrayBuffer) ||
	         (global.Blob && obj instanceof Blob) ||
	         (global.File && obj instanceof File)
	        ) {
	      return true;
	    }
	
	    if (isArray(obj)) {
	      for (var i = 0; i < obj.length; i++) {
	          if (_hasBinary(obj[i])) {
	              return true;
	          }
	      }
	    } else if (obj && 'object' == typeof obj) {
	      // see: https://github.com/Automattic/has-binary/pull/4
	      if (obj.toJSON && 'function' == typeof obj.toJSON) {
	        obj = obj.toJSON();
	      }
	
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key) && _hasBinary(obj[key])) {
	          return true;
	        }
	      }
	    }
	
	    return false;
	  }
	
	  return _hasBinary(data);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 213 */
198,
/* 214 */
/***/ (function(module, exports) {

	/**
	 * An abstraction for slicing an arraybuffer even when
	 * ArrayBuffer.prototype.slice is not supported
	 *
	 * @api public
	 */
	
	module.exports = function(arraybuffer, start, end) {
	  var bytes = arraybuffer.byteLength;
	  start = start || 0;
	  end = end || bytes;
	
	  if (arraybuffer.slice) { return arraybuffer.slice(start, end); }
	
	  if (start < 0) { start += bytes; }
	  if (end < 0) { end += bytes; }
	  if (end > bytes) { end = bytes; }
	
	  if (start >= bytes || start >= end || bytes === 0) {
	    return new ArrayBuffer(0);
	  }
	
	  var abv = new Uint8Array(arraybuffer);
	  var result = new Uint8Array(end - start);
	  for (var i = start, ii = 0; i < end; i++, ii++) {
	    result[ii] = abv[i];
	  }
	  return result.buffer;
	};


/***/ }),
/* 215 */
/***/ (function(module, exports) {

	module.exports = after
	
	function after(count, callback, err_cb) {
	    var bail = false
	    err_cb = err_cb || noop
	    proxy.count = count
	
	    return (count === 0) ? callback() : proxy
	
	    function proxy(err, result) {
	        if (proxy.count <= 0) {
	            throw new Error('after called too many times')
	        }
	        --proxy.count
	
	        // after first error, rest are passed to err_cb
	        if (err) {
	            bail = true
	            callback(err)
	            // future error callbacks will go to error handler
	            callback = err_cb
	        } else if (proxy.count === 0 && !bail) {
	            callback(null, result)
	        }
	    }
	}
	
	function noop() {}


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/wtf8 v1.0.0 by @mathias */
	;(function(root) {
	
		// Detect free variables `exports`
		var freeExports = typeof exports == 'object' && exports;
	
		// Detect free variable `module`
		var freeModule = typeof module == 'object' && module &&
			module.exports == freeExports && module;
	
		// Detect free variable `global`, from Node.js or Browserified code,
		// and use it as `root`
		var freeGlobal = typeof global == 'object' && global;
		if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
			root = freeGlobal;
		}
	
		/*--------------------------------------------------------------------------*/
	
		var stringFromCharCode = String.fromCharCode;
	
		// Taken from https://mths.be/punycode
		function ucs2decode(string) {
			var output = [];
			var counter = 0;
			var length = string.length;
			var value;
			var extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		// Taken from https://mths.be/punycode
		function ucs2encode(array) {
			var length = array.length;
			var index = -1;
			var value;
			var output = '';
			while (++index < length) {
				value = array[index];
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
			}
			return output;
		}
	
		/*--------------------------------------------------------------------------*/
	
		function createByte(codePoint, shift) {
			return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
		}
	
		function encodeCodePoint(codePoint) {
			if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
				return stringFromCharCode(codePoint);
			}
			var symbol = '';
			if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
				symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
			}
			else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
				symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
				symbol += createByte(codePoint, 6);
			}
			else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
				symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
				symbol += createByte(codePoint, 12);
				symbol += createByte(codePoint, 6);
			}
			symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
			return symbol;
		}
	
		function wtf8encode(string) {
			var codePoints = ucs2decode(string);
			var length = codePoints.length;
			var index = -1;
			var codePoint;
			var byteString = '';
			while (++index < length) {
				codePoint = codePoints[index];
				byteString += encodeCodePoint(codePoint);
			}
			return byteString;
		}
	
		/*--------------------------------------------------------------------------*/
	
		function readContinuationByte() {
			if (byteIndex >= byteCount) {
				throw Error('Invalid byte index');
			}
	
			var continuationByte = byteArray[byteIndex] & 0xFF;
			byteIndex++;
	
			if ((continuationByte & 0xC0) == 0x80) {
				return continuationByte & 0x3F;
			}
	
			// If we end up here, it’s not a continuation byte.
			throw Error('Invalid continuation byte');
		}
	
		function decodeSymbol() {
			var byte1;
			var byte2;
			var byte3;
			var byte4;
			var codePoint;
	
			if (byteIndex > byteCount) {
				throw Error('Invalid byte index');
			}
	
			if (byteIndex == byteCount) {
				return false;
			}
	
			// Read the first byte.
			byte1 = byteArray[byteIndex] & 0xFF;
			byteIndex++;
	
			// 1-byte sequence (no continuation bytes)
			if ((byte1 & 0x80) == 0) {
				return byte1;
			}
	
			// 2-byte sequence
			if ((byte1 & 0xE0) == 0xC0) {
				var byte2 = readContinuationByte();
				codePoint = ((byte1 & 0x1F) << 6) | byte2;
				if (codePoint >= 0x80) {
					return codePoint;
				} else {
					throw Error('Invalid continuation byte');
				}
			}
	
			// 3-byte sequence (may include unpaired surrogates)
			if ((byte1 & 0xF0) == 0xE0) {
				byte2 = readContinuationByte();
				byte3 = readContinuationByte();
				codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
				if (codePoint >= 0x0800) {
					return codePoint;
				} else {
					throw Error('Invalid continuation byte');
				}
			}
	
			// 4-byte sequence
			if ((byte1 & 0xF8) == 0xF0) {
				byte2 = readContinuationByte();
				byte3 = readContinuationByte();
				byte4 = readContinuationByte();
				codePoint = ((byte1 & 0x0F) << 0x12) | (byte2 << 0x0C) |
					(byte3 << 0x06) | byte4;
				if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
					return codePoint;
				}
			}
	
			throw Error('Invalid WTF-8 detected');
		}
	
		var byteArray;
		var byteCount;
		var byteIndex;
		function wtf8decode(byteString) {
			byteArray = ucs2decode(byteString);
			byteCount = byteArray.length;
			byteIndex = 0;
			var codePoints = [];
			var tmp;
			while ((tmp = decodeSymbol()) !== false) {
				codePoints.push(tmp);
			}
			return ucs2encode(codePoints);
		}
	
		/*--------------------------------------------------------------------------*/
	
		var wtf8 = {
			'version': '1.0.0',
			'encode': wtf8encode,
			'decode': wtf8decode
		};
	
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return wtf8;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}	else if (freeExports && !freeExports.nodeType) {
			if (freeModule) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = wtf8;
			} else { // in Narwhal or RingoJS v0.7.0-
				var object = {};
				var hasOwnProperty = object.hasOwnProperty;
				for (var key in wtf8) {
					hasOwnProperty.call(wtf8, key) && (freeExports[key] = wtf8[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.wtf8 = wtf8;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)(module), (function() { return this; }())))

/***/ }),
/* 217 */
/***/ (function(module, exports) {

	/*
	 * base64-arraybuffer
	 * https://github.com/niklasvh/base64-arraybuffer
	 *
	 * Copyright (c) 2012 Niklas von Hertzen
	 * Licensed under the MIT license.
	 */
	(function(){
	  "use strict";
	
	  var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	
	  // Use a lookup table to find the index.
	  var lookup = new Uint8Array(256);
	  for (var i = 0; i < chars.length; i++) {
	    lookup[chars.charCodeAt(i)] = i;
	  }
	
	  exports.encode = function(arraybuffer) {
	    var bytes = new Uint8Array(arraybuffer),
	    i, len = bytes.length, base64 = "";
	
	    for (i = 0; i < len; i+=3) {
	      base64 += chars[bytes[i] >> 2];
	      base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
	      base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
	      base64 += chars[bytes[i + 2] & 63];
	    }
	
	    if ((len % 3) === 2) {
	      base64 = base64.substring(0, base64.length - 1) + "=";
	    } else if (len % 3 === 1) {
	      base64 = base64.substring(0, base64.length - 2) + "==";
	    }
	
	    return base64;
	  };
	
	  exports.decode =  function(base64) {
	    var bufferLength = base64.length * 0.75,
	    len = base64.length, i, p = 0,
	    encoded1, encoded2, encoded3, encoded4;
	
	    if (base64[base64.length - 1] === "=") {
	      bufferLength--;
	      if (base64[base64.length - 2] === "=") {
	        bufferLength--;
	      }
	    }
	
	    var arraybuffer = new ArrayBuffer(bufferLength),
	    bytes = new Uint8Array(arraybuffer);
	
	    for (i = 0; i < len; i+=4) {
	      encoded1 = lookup[base64.charCodeAt(i)];
	      encoded2 = lookup[base64.charCodeAt(i+1)];
	      encoded3 = lookup[base64.charCodeAt(i+2)];
	      encoded4 = lookup[base64.charCodeAt(i+3)];
	
	      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
	      bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
	      bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
	    }
	
	    return arraybuffer;
	  };
	})();


/***/ }),
/* 218 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Create a blob builder even when vendor prefixes exist
	 */
	
	var BlobBuilder = global.BlobBuilder
	  || global.WebKitBlobBuilder
	  || global.MSBlobBuilder
	  || global.MozBlobBuilder;
	
	/**
	 * Check if Blob constructor is supported
	 */
	
	var blobSupported = (function() {
	  try {
	    var a = new Blob(['hi']);
	    return a.size === 2;
	  } catch(e) {
	    return false;
	  }
	})();
	
	/**
	 * Check if Blob constructor supports ArrayBufferViews
	 * Fails in Safari 6, so we need to map to ArrayBuffers there.
	 */
	
	var blobSupportsArrayBufferView = blobSupported && (function() {
	  try {
	    var b = new Blob([new Uint8Array([1,2])]);
	    return b.size === 2;
	  } catch(e) {
	    return false;
	  }
	})();
	
	/**
	 * Check if BlobBuilder is supported
	 */
	
	var blobBuilderSupported = BlobBuilder
	  && BlobBuilder.prototype.append
	  && BlobBuilder.prototype.getBlob;
	
	/**
	 * Helper function that maps ArrayBufferViews to ArrayBuffers
	 * Used by BlobBuilder constructor and old browsers that didn't
	 * support it in the Blob constructor.
	 */
	
	function mapArrayBufferViews(ary) {
	  for (var i = 0; i < ary.length; i++) {
	    var chunk = ary[i];
	    if (chunk.buffer instanceof ArrayBuffer) {
	      var buf = chunk.buffer;
	
	      // if this is a subarray, make a copy so we only
	      // include the subarray region from the underlying buffer
	      if (chunk.byteLength !== buf.byteLength) {
	        var copy = new Uint8Array(chunk.byteLength);
	        copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
	        buf = copy.buffer;
	      }
	
	      ary[i] = buf;
	    }
	  }
	}
	
	function BlobBuilderConstructor(ary, options) {
	  options = options || {};
	
	  var bb = new BlobBuilder();
	  mapArrayBufferViews(ary);
	
	  for (var i = 0; i < ary.length; i++) {
	    bb.append(ary[i]);
	  }
	
	  return (options.type) ? bb.getBlob(options.type) : bb.getBlob();
	};
	
	function BlobConstructor(ary, options) {
	  mapArrayBufferViews(ary);
	  return new Blob(ary, options || {});
	};
	
	module.exports = (function() {
	  if (blobSupported) {
	    return blobSupportsArrayBufferView ? global.Blob : BlobConstructor;
	  } else if (blobBuilderSupported) {
	    return BlobBuilderConstructor;
	  } else {
	    return undefined;
	  }
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	if (true) {
	  module.exports = Emitter;
	}
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks['$' + event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ }),
/* 220 */
/***/ (function(module, exports) {

	/**
	 * Compiles a querystring
	 * Returns string representation of the object
	 *
	 * @param {Object}
	 * @api private
	 */
	
	exports.encode = function (obj) {
	  var str = '';
	
	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) {
	      if (str.length) str += '&';
	      str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
	    }
	  }
	
	  return str;
	};
	
	/**
	 * Parses a simple querystring into an object
	 *
	 * @param {String} qs
	 * @api private
	 */
	
	exports.decode = function(qs){
	  var qry = {};
	  var pairs = qs.split('&');
	  for (var i = 0, l = pairs.length; i < l; i++) {
	    var pair = pairs[i].split('=');
	    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
	  }
	  return qry;
	};


/***/ }),
/* 221 */
/***/ (function(module, exports) {

	
	module.exports = function(a, b){
	  var fn = function(){};
	  fn.prototype = b.prototype;
	  a.prototype = new fn;
	  a.prototype.constructor = a;
	};

/***/ }),
/* 222 */
/***/ (function(module, exports) {

	'use strict';
	
	var alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split('')
	  , length = 64
	  , map = {}
	  , seed = 0
	  , i = 0
	  , prev;
	
	/**
	 * Return a string representing the specified number.
	 *
	 * @param {Number} num The number to convert.
	 * @returns {String} The string representation of the number.
	 * @api public
	 */
	function encode(num) {
	  var encoded = '';
	
	  do {
	    encoded = alphabet[num % length] + encoded;
	    num = Math.floor(num / length);
	  } while (num > 0);
	
	  return encoded;
	}
	
	/**
	 * Return the integer value specified by the given string.
	 *
	 * @param {String} str The string to convert.
	 * @returns {Number} The integer value represented by the string.
	 * @api public
	 */
	function decode(str) {
	  var decoded = 0;
	
	  for (i = 0; i < str.length; i++) {
	    decoded = decoded * length + map[str.charAt(i)];
	  }
	
	  return decoded;
	}
	
	/**
	 * Yeast: A tiny growing id generator.
	 *
	 * @returns {String} A unique id.
	 * @api public
	 */
	function yeast() {
	  var now = encode(+new Date());
	
	  if (now !== prev) return seed = 0, prev = now;
	  return now +'.'+ encode(seed++);
	}
	
	//
	// Map each character to its index.
	//
	for (; i < length; i++) map[alphabet[i]] = i;
	
	//
	// Expose the `yeast`, `encode` and `decode` functions.
	//
	yeast.encode = encode;
	yeast.decode = decode;
	module.exports = yeast;


/***/ }),
/* 223 */
[511, 224],
/* 224 */
[512, 225],
/* 225 */
189,
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module requirements.
	 */
	
	var Polling = __webpack_require__(208);
	var inherit = __webpack_require__(221);
	
	/**
	 * Module exports.
	 */
	
	module.exports = JSONPPolling;
	
	/**
	 * Cached regular expressions.
	 */
	
	var rNewline = /\n/g;
	var rEscapedNewline = /\\n/g;
	
	/**
	 * Global JSONP callbacks.
	 */
	
	var callbacks;
	
	/**
	 * Noop.
	 */
	
	function empty () { }
	
	/**
	 * JSONP Polling constructor.
	 *
	 * @param {Object} opts.
	 * @api public
	 */
	
	function JSONPPolling (opts) {
	  Polling.call(this, opts);
	
	  this.query = this.query || {};
	
	  // define global callbacks array if not present
	  // we do this here (lazily) to avoid unneeded global pollution
	  if (!callbacks) {
	    // we need to consider multiple engines in the same page
	    if (!global.___eio) global.___eio = [];
	    callbacks = global.___eio;
	  }
	
	  // callback identifier
	  this.index = callbacks.length;
	
	  // add callback to jsonp global
	  var self = this;
	  callbacks.push(function (msg) {
	    self.onData(msg);
	  });
	
	  // append to query string
	  this.query.j = this.index;
	
	  // prevent spurious errors from being emitted when the window is unloaded
	  if (global.document && global.addEventListener) {
	    global.addEventListener('beforeunload', function () {
	      if (self.script) self.script.onerror = empty;
	    }, false);
	  }
	}
	
	/**
	 * Inherits from Polling.
	 */
	
	inherit(JSONPPolling, Polling);
	
	/*
	 * JSONP only supports binary as base64 encoded strings
	 */
	
	JSONPPolling.prototype.supportsBinary = false;
	
	/**
	 * Closes the socket.
	 *
	 * @api private
	 */
	
	JSONPPolling.prototype.doClose = function () {
	  if (this.script) {
	    this.script.parentNode.removeChild(this.script);
	    this.script = null;
	  }
	
	  if (this.form) {
	    this.form.parentNode.removeChild(this.form);
	    this.form = null;
	    this.iframe = null;
	  }
	
	  Polling.prototype.doClose.call(this);
	};
	
	/**
	 * Starts a poll cycle.
	 *
	 * @api private
	 */
	
	JSONPPolling.prototype.doPoll = function () {
	  var self = this;
	  var script = document.createElement('script');
	
	  if (this.script) {
	    this.script.parentNode.removeChild(this.script);
	    this.script = null;
	  }
	
	  script.async = true;
	  script.src = this.uri();
	  script.onerror = function (e) {
	    self.onError('jsonp poll error', e);
	  };
	
	  var insertAt = document.getElementsByTagName('script')[0];
	  if (insertAt) {
	    insertAt.parentNode.insertBefore(script, insertAt);
	  } else {
	    (document.head || document.body).appendChild(script);
	  }
	  this.script = script;
	
	  var isUAgecko = 'undefined' !== typeof navigator && /gecko/i.test(navigator.userAgent);
	
	  if (isUAgecko) {
	    setTimeout(function () {
	      var iframe = document.createElement('iframe');
	      document.body.appendChild(iframe);
	      document.body.removeChild(iframe);
	    }, 100);
	  }
	};
	
	/**
	 * Writes with a hidden iframe.
	 *
	 * @param {String} data to send
	 * @param {Function} called upon flush.
	 * @api private
	 */
	
	JSONPPolling.prototype.doWrite = function (data, fn) {
	  var self = this;
	
	  if (!this.form) {
	    var form = document.createElement('form');
	    var area = document.createElement('textarea');
	    var id = this.iframeId = 'eio_iframe_' + this.index;
	    var iframe;
	
	    form.className = 'socketio';
	    form.style.position = 'absolute';
	    form.style.top = '-1000px';
	    form.style.left = '-1000px';
	    form.target = id;
	    form.method = 'POST';
	    form.setAttribute('accept-charset', 'utf-8');
	    area.name = 'd';
	    form.appendChild(area);
	    document.body.appendChild(form);
	
	    this.form = form;
	    this.area = area;
	  }
	
	  this.form.action = this.uri();
	
	  function complete () {
	    initIframe();
	    fn();
	  }
	
	  function initIframe () {
	    if (self.iframe) {
	      try {
	        self.form.removeChild(self.iframe);
	      } catch (e) {
	        self.onError('jsonp polling iframe removal error', e);
	      }
	    }
	
	    try {
	      // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)
	      var html = '<iframe src="javascript:0" name="' + self.iframeId + '">';
	      iframe = document.createElement(html);
	    } catch (e) {
	      iframe = document.createElement('iframe');
	      iframe.name = self.iframeId;
	      iframe.src = 'javascript:0';
	    }
	
	    iframe.id = self.iframeId;
	
	    self.form.appendChild(iframe);
	    self.iframe = iframe;
	  }
	
	  initIframe();
	
	  // escape \n to prevent it from being converted into \r\n by some UAs
	  // double escaping is required for escaped new lines because unescaping of new lines can be done safely on server-side
	  data = data.replace(rEscapedNewline, '\\\n');
	  this.area.value = data.replace(rNewline, '\\n');
	
	  try {
	    this.form.submit();
	  } catch (e) {}
	
	  if (this.iframe.attachEvent) {
	    this.iframe.onreadystatechange = function () {
	      if (self.iframe.readyState === 'complete') {
	        complete();
	      }
	    };
	  } else {
	    this.iframe.onload = complete;
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var Transport = __webpack_require__(209);
	var parser = __webpack_require__(210);
	var parseqs = __webpack_require__(220);
	var inherit = __webpack_require__(221);
	var yeast = __webpack_require__(222);
	var debug = __webpack_require__(223)('engine.io-client:websocket');
	var BrowserWebSocket = global.WebSocket || global.MozWebSocket;
	var NodeWebSocket;
	if (typeof window === 'undefined') {
	  try {
	    NodeWebSocket = __webpack_require__(228);
	  } catch (e) { }
	}
	
	/**
	 * Get either the `WebSocket` or `MozWebSocket` globals
	 * in the browser or try to resolve WebSocket-compatible
	 * interface exposed by `ws` for Node-like environment.
	 */
	
	var WebSocket = BrowserWebSocket;
	if (!WebSocket && typeof window === 'undefined') {
	  WebSocket = NodeWebSocket;
	}
	
	/**
	 * Module exports.
	 */
	
	module.exports = WS;
	
	/**
	 * WebSocket transport constructor.
	 *
	 * @api {Object} connection options
	 * @api public
	 */
	
	function WS (opts) {
	  var forceBase64 = (opts && opts.forceBase64);
	  if (forceBase64) {
	    this.supportsBinary = false;
	  }
	  this.perMessageDeflate = opts.perMessageDeflate;
	  this.usingBrowserWebSocket = BrowserWebSocket && !opts.forceNode;
	  if (!this.usingBrowserWebSocket) {
	    WebSocket = NodeWebSocket;
	  }
	  Transport.call(this, opts);
	}
	
	/**
	 * Inherits from Transport.
	 */
	
	inherit(WS, Transport);
	
	/**
	 * Transport name.
	 *
	 * @api public
	 */
	
	WS.prototype.name = 'websocket';
	
	/*
	 * WebSockets support binary
	 */
	
	WS.prototype.supportsBinary = true;
	
	/**
	 * Opens socket.
	 *
	 * @api private
	 */
	
	WS.prototype.doOpen = function () {
	  if (!this.check()) {
	    // let probe timeout
	    return;
	  }
	
	  var uri = this.uri();
	  var protocols = void (0);
	  var opts = {
	    agent: this.agent,
	    perMessageDeflate: this.perMessageDeflate
	  };
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	  if (this.extraHeaders) {
	    opts.headers = this.extraHeaders;
	  }
	  if (this.localAddress) {
	    opts.localAddress = this.localAddress;
	  }
	
	  try {
	    this.ws = this.usingBrowserWebSocket ? new WebSocket(uri) : new WebSocket(uri, protocols, opts);
	  } catch (err) {
	    return this.emit('error', err);
	  }
	
	  if (this.ws.binaryType === undefined) {
	    this.supportsBinary = false;
	  }
	
	  if (this.ws.supports && this.ws.supports.binary) {
	    this.supportsBinary = true;
	    this.ws.binaryType = 'nodebuffer';
	  } else {
	    this.ws.binaryType = 'arraybuffer';
	  }
	
	  this.addEventListeners();
	};
	
	/**
	 * Adds event listeners to the socket
	 *
	 * @api private
	 */
	
	WS.prototype.addEventListeners = function () {
	  var self = this;
	
	  this.ws.onopen = function () {
	    self.onOpen();
	  };
	  this.ws.onclose = function () {
	    self.onClose();
	  };
	  this.ws.onmessage = function (ev) {
	    self.onData(ev.data);
	  };
	  this.ws.onerror = function (e) {
	    self.onError('websocket error', e);
	  };
	};
	
	/**
	 * Writes data to socket.
	 *
	 * @param {Array} array of packets.
	 * @api private
	 */
	
	WS.prototype.write = function (packets) {
	  var self = this;
	  this.writable = false;
	
	  // encodePacket efficient as it uses WS framing
	  // no need for encodePayload
	  var total = packets.length;
	  for (var i = 0, l = total; i < l; i++) {
	    (function (packet) {
	      parser.encodePacket(packet, self.supportsBinary, function (data) {
	        if (!self.usingBrowserWebSocket) {
	          // always create a new object (GH-437)
	          var opts = {};
	          if (packet.options) {
	            opts.compress = packet.options.compress;
	          }
	
	          if (self.perMessageDeflate) {
	            var len = 'string' === typeof data ? global.Buffer.byteLength(data) : data.length;
	            if (len < self.perMessageDeflate.threshold) {
	              opts.compress = false;
	            }
	          }
	        }
	
	        // Sometimes the websocket has already been closed but the browser didn't
	        // have a chance of informing us about it yet, in that case send will
	        // throw an error
	        try {
	          if (self.usingBrowserWebSocket) {
	            // TypeError is thrown when passing the second argument on Safari
	            self.ws.send(data);
	          } else {
	            self.ws.send(data, opts);
	          }
	        } catch (e) {
	          debug('websocket closed before onclose event');
	        }
	
	        --total || done();
	      });
	    })(packets[i]);
	  }
	
	  function done () {
	    self.emit('flush');
	
	    // fake drain
	    // defer to next tick to allow Socket to clear writeBuffer
	    setTimeout(function () {
	      self.writable = true;
	      self.emit('drain');
	    }, 0);
	  }
	};
	
	/**
	 * Called upon close
	 *
	 * @api private
	 */
	
	WS.prototype.onClose = function () {
	  Transport.prototype.onClose.call(this);
	};
	
	/**
	 * Closes socket.
	 *
	 * @api private
	 */
	
	WS.prototype.doClose = function () {
	  if (typeof this.ws !== 'undefined') {
	    this.ws.close();
	  }
	};
	
	/**
	 * Generates uri for connection.
	 *
	 * @api private
	 */
	
	WS.prototype.uri = function () {
	  var query = this.query || {};
	  var schema = this.secure ? 'wss' : 'ws';
	  var port = '';
	
	  // avoid port if default for schema
	  if (this.port && (('wss' === schema && Number(this.port) !== 443) ||
	    ('ws' === schema && Number(this.port) !== 80))) {
	    port = ':' + this.port;
	  }
	
	  // append timestamp to URI
	  if (this.timestampRequests) {
	    query[this.timestampParam] = yeast();
	  }
	
	  // communicate binary support capabilities
	  if (!this.supportsBinary) {
	    query.b64 = 1;
	  }
	
	  query = parseqs.encode(query);
	
	  // prepend ? to query
	  if (query.length) {
	    query = '?' + query;
	  }
	
	  var ipv6 = this.hostname.indexOf(':') !== -1;
	  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
	};
	
	/**
	 * Feature detection for WebSocket.
	 *
	 * @return {Boolean} whether this transport is available.
	 * @api public
	 */
	
	WS.prototype.check = function () {
	  return !!WebSocket && !('__initialize' in WebSocket && this.name === WS.prototype.name);
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 228 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 229 */
/***/ (function(module, exports) {

	
	var indexOf = [].indexOf;
	
	module.exports = function(arr, obj){
	  if (indexOf) return arr.indexOf(obj);
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	};

/***/ }),
/* 230 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * JSON parse.
	 *
	 * @see Based on jQuery#parseJSON (MIT) and JSON2
	 * @api private
	 */
	
	var rvalidchars = /^[\],:{}\s]*$/;
	var rvalidescape = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g;
	var rvalidtokens = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
	var rvalidbraces = /(?:^|:|,)(?:\s*\[)+/g;
	var rtrimLeft = /^\s+/;
	var rtrimRight = /\s+$/;
	
	module.exports = function parsejson(data) {
	  if ('string' != typeof data || !data) {
	    return null;
	  }
	
	  data = data.replace(rtrimLeft, '').replace(rtrimRight, '');
	
	  // Attempt to parse using the native JSON parser first
	  if (global.JSON && JSON.parse) {
	    return JSON.parse(data);
	  }
	
	  if (rvalidchars.test(data.replace(rvalidescape, '@')
	      .replace(rvalidtokens, ']')
	      .replace(rvalidbraces, ''))) {
	    return (new Function('return ' + data))();
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var parser = __webpack_require__(190);
	var Emitter = __webpack_require__(232);
	var toArray = __webpack_require__(233);
	var on = __webpack_require__(234);
	var bind = __webpack_require__(235);
	var debug = __webpack_require__(186)('socket.io-client:socket');
	var hasBin = __webpack_require__(212);
	
	/**
	 * Module exports.
	 */
	
	module.exports = exports = Socket;
	
	/**
	 * Internal events (blacklisted).
	 * These events can't be emitted by the user.
	 *
	 * @api private
	 */
	
	var events = {
	  connect: 1,
	  connect_error: 1,
	  connect_timeout: 1,
	  connecting: 1,
	  disconnect: 1,
	  error: 1,
	  reconnect: 1,
	  reconnect_attempt: 1,
	  reconnect_failed: 1,
	  reconnect_error: 1,
	  reconnecting: 1,
	  ping: 1,
	  pong: 1
	};
	
	/**
	 * Shortcut to `Emitter#emit`.
	 */
	
	var emit = Emitter.prototype.emit;
	
	/**
	 * `Socket` constructor.
	 *
	 * @api public
	 */
	
	function Socket (io, nsp, opts) {
	  this.io = io;
	  this.nsp = nsp;
	  this.json = this; // compat
	  this.ids = 0;
	  this.acks = {};
	  this.receiveBuffer = [];
	  this.sendBuffer = [];
	  this.connected = false;
	  this.disconnected = true;
	  if (opts && opts.query) {
	    this.query = opts.query;
	  }
	  if (this.io.autoConnect) this.open();
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Socket.prototype);
	
	/**
	 * Subscribe to open, close and packet events
	 *
	 * @api private
	 */
	
	Socket.prototype.subEvents = function () {
	  if (this.subs) return;
	
	  var io = this.io;
	  this.subs = [
	    on(io, 'open', bind(this, 'onopen')),
	    on(io, 'packet', bind(this, 'onpacket')),
	    on(io, 'close', bind(this, 'onclose'))
	  ];
	};
	
	/**
	 * "Opens" the socket.
	 *
	 * @api public
	 */
	
	Socket.prototype.open =
	Socket.prototype.connect = function () {
	  if (this.connected) return this;
	
	  this.subEvents();
	  this.io.open(); // ensure open
	  if ('open' === this.io.readyState) this.onopen();
	  this.emit('connecting');
	  return this;
	};
	
	/**
	 * Sends a `message` event.
	 *
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.send = function () {
	  var args = toArray(arguments);
	  args.unshift('message');
	  this.emit.apply(this, args);
	  return this;
	};
	
	/**
	 * Override `emit`.
	 * If the event is in `events`, it's emitted normally.
	 *
	 * @param {String} event name
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.emit = function (ev) {
	  if (events.hasOwnProperty(ev)) {
	    emit.apply(this, arguments);
	    return this;
	  }
	
	  var args = toArray(arguments);
	  var parserType = parser.EVENT; // default
	  if (hasBin(args)) { parserType = parser.BINARY_EVENT; } // binary
	  var packet = { type: parserType, data: args };
	
	  packet.options = {};
	  packet.options.compress = !this.flags || false !== this.flags.compress;
	
	  // event ack callback
	  if ('function' === typeof args[args.length - 1]) {
	    debug('emitting packet with ack id %d', this.ids);
	    this.acks[this.ids] = args.pop();
	    packet.id = this.ids++;
	  }
	
	  if (this.connected) {
	    this.packet(packet);
	  } else {
	    this.sendBuffer.push(packet);
	  }
	
	  delete this.flags;
	
	  return this;
	};
	
	/**
	 * Sends a packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.packet = function (packet) {
	  packet.nsp = this.nsp;
	  this.io.packet(packet);
	};
	
	/**
	 * Called upon engine `open`.
	 *
	 * @api private
	 */
	
	Socket.prototype.onopen = function () {
	  debug('transport is open - connecting');
	
	  // write connect packet if necessary
	  if ('/' !== this.nsp) {
	    if (this.query) {
	      this.packet({type: parser.CONNECT, query: this.query});
	    } else {
	      this.packet({type: parser.CONNECT});
	    }
	  }
	};
	
	/**
	 * Called upon engine `close`.
	 *
	 * @param {String} reason
	 * @api private
	 */
	
	Socket.prototype.onclose = function (reason) {
	  debug('close (%s)', reason);
	  this.connected = false;
	  this.disconnected = true;
	  delete this.id;
	  this.emit('disconnect', reason);
	};
	
	/**
	 * Called with socket packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onpacket = function (packet) {
	  if (packet.nsp !== this.nsp) return;
	
	  switch (packet.type) {
	    case parser.CONNECT:
	      this.onconnect();
	      break;
	
	    case parser.EVENT:
	      this.onevent(packet);
	      break;
	
	    case parser.BINARY_EVENT:
	      this.onevent(packet);
	      break;
	
	    case parser.ACK:
	      this.onack(packet);
	      break;
	
	    case parser.BINARY_ACK:
	      this.onack(packet);
	      break;
	
	    case parser.DISCONNECT:
	      this.ondisconnect();
	      break;
	
	    case parser.ERROR:
	      this.emit('error', packet.data);
	      break;
	  }
	};
	
	/**
	 * Called upon a server event.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onevent = function (packet) {
	  var args = packet.data || [];
	  debug('emitting event %j', args);
	
	  if (null != packet.id) {
	    debug('attaching ack callback to event');
	    args.push(this.ack(packet.id));
	  }
	
	  if (this.connected) {
	    emit.apply(this, args);
	  } else {
	    this.receiveBuffer.push(args);
	  }
	};
	
	/**
	 * Produces an ack callback to emit with an event.
	 *
	 * @api private
	 */
	
	Socket.prototype.ack = function (id) {
	  var self = this;
	  var sent = false;
	  return function () {
	    // prevent double callbacks
	    if (sent) return;
	    sent = true;
	    var args = toArray(arguments);
	    debug('sending ack %j', args);
	
	    var type = hasBin(args) ? parser.BINARY_ACK : parser.ACK;
	    self.packet({
	      type: type,
	      id: id,
	      data: args
	    });
	  };
	};
	
	/**
	 * Called upon a server acknowlegement.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onack = function (packet) {
	  var ack = this.acks[packet.id];
	  if ('function' === typeof ack) {
	    debug('calling ack %s with %j', packet.id, packet.data);
	    ack.apply(this, packet.data);
	    delete this.acks[packet.id];
	  } else {
	    debug('bad ack %s', packet.id);
	  }
	};
	
	/**
	 * Called upon server connect.
	 *
	 * @api private
	 */
	
	Socket.prototype.onconnect = function () {
	  this.connected = true;
	  this.disconnected = false;
	  this.emit('connect');
	  this.emitBuffered();
	};
	
	/**
	 * Emit buffered events (received and emitted).
	 *
	 * @api private
	 */
	
	Socket.prototype.emitBuffered = function () {
	  var i;
	  for (i = 0; i < this.receiveBuffer.length; i++) {
	    emit.apply(this, this.receiveBuffer[i]);
	  }
	  this.receiveBuffer = [];
	
	  for (i = 0; i < this.sendBuffer.length; i++) {
	    this.packet(this.sendBuffer[i]);
	  }
	  this.sendBuffer = [];
	};
	
	/**
	 * Called upon server disconnect.
	 *
	 * @api private
	 */
	
	Socket.prototype.ondisconnect = function () {
	  debug('server disconnect (%s)', this.nsp);
	  this.destroy();
	  this.onclose('io server disconnect');
	};
	
	/**
	 * Called upon forced client/server side disconnections,
	 * this method ensures the manager stops tracking us and
	 * that reconnections don't get triggered for this.
	 *
	 * @api private.
	 */
	
	Socket.prototype.destroy = function () {
	  if (this.subs) {
	    // clean subscriptions to avoid reconnections
	    for (var i = 0; i < this.subs.length; i++) {
	      this.subs[i].destroy();
	    }
	    this.subs = null;
	  }
	
	  this.io.destroy(this);
	};
	
	/**
	 * Disconnects the socket manually.
	 *
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.close =
	Socket.prototype.disconnect = function () {
	  if (this.connected) {
	    debug('performing disconnect (%s)', this.nsp);
	    this.packet({ type: parser.DISCONNECT });
	  }
	
	  // remove socket from pool
	  this.destroy();
	
	  if (this.connected) {
	    // fire events
	    this.onclose('io client disconnect');
	  }
	  return this;
	};
	
	/**
	 * Sets the compress flag.
	 *
	 * @param {Boolean} if `true`, compresses the sending data
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.compress = function (compress) {
	  this.flags = this.flags || {};
	  this.flags.compress = compress;
	  return this;
	};


/***/ }),
/* 232 */
219,
/* 233 */
/***/ (function(module, exports) {

	module.exports = toArray
	
	function toArray(list, index) {
	    var array = []
	
	    index = index || 0
	
	    for (var i = index || 0; i < list.length; i++) {
	        array[i - index] = list[i]
	    }
	
	    return array
	}


/***/ }),
/* 234 */
/***/ (function(module, exports) {

	
	/**
	 * Module exports.
	 */
	
	module.exports = on;
	
	/**
	 * Helper for subscriptions.
	 *
	 * @param {Object|EventEmitter} obj with `Emitter` mixin or `EventEmitter`
	 * @param {String} event name
	 * @param {Function} callback
	 * @api public
	 */
	
	function on (obj, ev, fn) {
	  obj.on(ev, fn);
	  return {
	    destroy: function () {
	      obj.removeListener(ev, fn);
	    }
	  };
	}


/***/ }),
/* 235 */
/***/ (function(module, exports) {

	/**
	 * Slice reference.
	 */
	
	var slice = [].slice;
	
	/**
	 * Bind `obj` to `fn`.
	 *
	 * @param {Object} obj
	 * @param {Function|String} fn or string
	 * @return {Function}
	 * @api public
	 */
	
	module.exports = function(obj, fn){
	  if ('string' == typeof fn) fn = obj[fn];
	  if ('function' != typeof fn) throw new Error('bind() requires a function');
	  var args = slice.call(arguments, 2);
	  return function(){
	    return fn.apply(obj, args.concat(slice.call(arguments)));
	  }
	};


/***/ }),
/* 236 */
/***/ (function(module, exports) {

	
	/**
	 * Expose `Backoff`.
	 */
	
	module.exports = Backoff;
	
	/**
	 * Initialize backoff timer with `opts`.
	 *
	 * - `min` initial timeout in milliseconds [100]
	 * - `max` max timeout [10000]
	 * - `jitter` [0]
	 * - `factor` [2]
	 *
	 * @param {Object} opts
	 * @api public
	 */
	
	function Backoff(opts) {
	  opts = opts || {};
	  this.ms = opts.min || 100;
	  this.max = opts.max || 10000;
	  this.factor = opts.factor || 2;
	  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
	  this.attempts = 0;
	}
	
	/**
	 * Return the backoff duration.
	 *
	 * @return {Number}
	 * @api public
	 */
	
	Backoff.prototype.duration = function(){
	  var ms = this.ms * Math.pow(this.factor, this.attempts++);
	  if (this.jitter) {
	    var rand =  Math.random();
	    var deviation = Math.floor(rand * this.jitter * ms);
	    ms = (Math.floor(rand * 10) & 1) == 0  ? ms - deviation : ms + deviation;
	  }
	  return Math.min(ms, this.max) | 0;
	};
	
	/**
	 * Reset the number of attempts.
	 *
	 * @api public
	 */
	
	Backoff.prototype.reset = function(){
	  this.attempts = 0;
	};
	
	/**
	 * Set the minimum duration
	 *
	 * @api public
	 */
	
	Backoff.prototype.setMin = function(min){
	  this.ms = min;
	};
	
	/**
	 * Set the maximum duration
	 *
	 * @api public
	 */
	
	Backoff.prototype.setMax = function(max){
	  this.max = max;
	};
	
	/**
	 * Set the jitter
	 *
	 * @api public
	 */
	
	Backoff.prototype.setJitter = function(jitter){
	  this.jitter = jitter;
	};
	


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _language = __webpack_require__(238);
	
	var _language2 = __webpack_require__(239);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('dalApp.language', []).service('LanguageService', _language2.LanguageService).controller('LanguageController', _language.LanguageController).name;

/***/ }),
/* 238 */
/***/ (function(module, exports) {

	'use strict';
	
	LanguageController.$inject = ['$scope', 'LanguageService', '$window'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LanguageController = LanguageController;
	function LanguageController($scope, LanguageService, $window) {
	  'ngInject';
	
	  LanguageService.init();
	  $scope.changeLanguage = function changeLanguage(lang) {
	    LanguageService.set(lang);
	    $scope.lang = lang;
	    $window.location.reload();
	  };
	  $scope.lang = LanguageService.get();
	}

/***/ }),
/* 239 */
/***/ (function(module, exports) {

	'use strict';
	
	LanguageService.$inject = ['$locale', '$http', 'gettextCatalog', 'localStorageService', 'Auth'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LanguageService = LanguageService;
	function LanguageService($locale, $http, gettextCatalog, localStorageService, Auth) {
	  'ngInject';
	
	  var _lang = {
	    supportedLanguages: ['en', 'fr'],
	    lang: 'fr', init: function init() {
	      var lsLang = localStorageService.get('this.lang');
	
	      if (!lsLang) {
	        var language = window.navigator.language || window.navigator.userLanguage;
	        language = language.substr(0, 2);
	        if (this.supportedLanguages.indexOf(language) !== -1) {
	          localStorageService.set('this.lang', language);
	        } else {
	          localStorageService.set('this.lang', this.lang);
	        }
	      }
	
	      gettextCatalog.baseLanguage = 'fr';
	      this.set(localStorageService.get('this.lang'), true);
	    },
	    get: function get() {
	      return this.lang;
	    },
	    set: function set(language, isInit) {
	      if (this.supportedLanguages.indexOf(language) === -1) {
	        return;
	      }
	      this.lang = language;
	      $locale.id = this.lang;
	      localStorageService.set('this.lang', language);
	
	      if (language === 'fr') {
	        gettextCatalog.setStrings(language, {});
	        gettextCatalog.setCurrentLanguage(language);
	      } else {
	        gettextCatalog.setCurrentLanguage(language);
	      }
	
	      if (!isInit && Auth.isLoggedInSync()) {
	        $http.put('api/users/me', {
	          language: language
	        }).catch(function (err) {
	          console.log('Error language');
	        });
	      }
	    }
	  };
	  return _lang;
	}

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.passwordService = passwordService;
	var angular = __webpack_require__(1);
	
	/*@ngInject*/
	function passwordService() {
	  "ngInject";
	
	  return {
	    getStrength: function getStrength(pass) {
	      var tests = [/[0-9]/, /[a-z]/, /[A-Z]/, /[^A-Z-0-9]/i];
	      if (pass === null || !pass) {
	        return -1;
	      }
	      var s = 0;
	      if (pass.length < 7) {
	        return 0;
	      }
	      for (var i in tests) {
	        if (tests[i].test(pass)) {
	          s++;
	        }
	      }
	      return s;
	    }
	  };
	}
	
	exports.default = angular.module("dalApp.pass", []).service("PasswordService", passwordService).name;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	elasticService.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.elasticService = elasticService;
	var angular = __webpack_require__(1);
	
	/*@ngInject*/
	function elasticService($resource) {
	  'ngInject';
	
	  return $resource('/api/searches/:controller', {}, {
	    searchAuthors: {
	      method: 'GET',
	      params: {
	        controller: 'authors'
	      },
	      isArray: true
	    },
	    searchDirectDrMemberAuthors: {
	      method: 'GET',
	      params: {
	        controller: 'direct-dr-member-authors'
	      },
	      isArray: true
	    },
	    searchWanted: {
	      method: 'GET',
	      params: {
	        controller: 'wanted'
	      },
	      isArray: true
	    }
	  });
	}
	
	exports.default = angular.module('dalApp.elastic', []).service('ElasticAPI', elasticService).name;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Modal.$inject = ['$rootScope', '$uibModal', 'gettextCatalog'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Modal = Modal;
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Modal($rootScope, $uibModal, gettextCatalog) {
	  'ngInject';
	
	  function openModal() {
	    var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var modalClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'modal-default';
	
	    var modalScope = $rootScope.$new();
	
	    _angular2.default.extend(modalScope, scope);
	
	    return $uibModal.open({
	      template: __webpack_require__(243),
	      windowClass: modalClass,
	      scope: modalScope
	    });
	  }
	
	  return {
	    confirm: {
	      delete: function _delete() {
	        var del = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _angular2.default.noop;
	
	        return function () {
	          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	          }
	
	          var slicedArgs = JSON.parse(JSON.stringify(args));
	
	          var title = slicedArgs[0];
	          var text = slicedArgs[1];
	          var confirmText = slicedArgs[2];
	          var cancelText = slicedArgs[3];
	
	          var deleteModal;
	
	          deleteModal = openModal({
	            modal: {
	              dismissable: true,
	              title: title,
	              text: text,
	              buttons: [{
	                classes: 'btn-default',
	                text: cancelText,
	                click: function click(e) {
	                  deleteModal.dismiss(e);
	                }
	              }, {
	                classes: 'btn-danger',
	                text: confirmText,
	                click: function click(e) {
	                  deleteModal.close(e);
	                }
	              }]
	            }
	          }, 'modal-danger');
	
	          deleteModal.result.then(function (event) {
	            Reflect.apply(del, event, slicedArgs);
	          }).catch(function () {
	            return null;
	          });
	        };
	      },
	      info: function info() {
	        var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _angular2.default.noop;
	
	        return function () {
	          var slicedArgs = JSON.parse(JSON.stringify(arguments));
	
	          var title = slicedArgs[0];
	          var text = slicedArgs[1];
	          var confirmText = slicedArgs[2];
	          var type = slicedArgs[3];
	
	          var savedModal;
	
	          savedModal = openModal({
	            modal: {
	              dismissable: true,
	              title: title,
	              text: text,
	              buttons: [{
	                classes: 'btn-' + type || 'default',
	                text: confirmText,
	                click: function click(e) {
	                  savedModal.close(e);
	                }
	              }]
	            }
	          }, 'modal-' + type || 'default');
	
	          savedModal.result.then(function (event) {
	            Reflect.apply(val, event, {});
	          }).catch(function () {
	            return null;
	          });
	        };
	      },
	      validate: function validate() {
	        var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _angular2.default.noop;
	
	        return function () {
	          var validateModal;
	
	          validateModal = openModal({
	            modal: {
	              dismissable: true,
	              title: gettextCatalog.getString('Envoyer la demande'),
	              html: '<p>' + gettextCatalog.getString('Voulez-vous envoyer cette demande?') + '</p>',
	              buttons: [{
	                classes: 'btn-success',
	                text: gettextCatalog.getString('Envoyer'),
	                click: function click(e) {
	                  validateModal.close(e);
	                }
	              }, {
	                classes: 'btn-default',
	                text: gettextCatalog.getString('Annuler'),
	                click: function click(e) {
	                  validateModal.dismiss(e);
	                }
	              }]
	            }
	          }, 'modal-success');
	
	          validateModal.result.then(function (event) {
	            Reflect.apply(val, event, {});
	          }).catch(function () {
	            return null;
	          });
	        };
	      }
	    }
	  };
	}
	
	exports.default = _angular2.default.module('dalApp.Modal', []).factory('Modal', Modal).name;

/***/ }),
/* 243 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <button ng-if=\"modal.dismissable\" type=\"button\" ng-click=\"$dismiss()\" class=\"close\">&times;</button>\n  <h4 ng-if=\"modal.title\" ng-bind=\"modal.title\" class=\"modal-title\"></h4>\n</div>\n<div class=\"modal-body\">\n  <p ng-if=\"modal.text\" ng-bind=\"modal.text\"></p>\n  <div ng-if=\"modal.html\" ng-bind-html=\"modal.html\"></div>\n</div>\n<div class=\"modal-footer\">\n  <button ng-repeat=\"button in modal.buttons\" ng-class=\"button.classes\" ng-click=\"button.click($event)\" ng-bind=\"button.text\" class=\"btn\"></button>\n</div>\n"

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _wanted = __webpack_require__(245);
	
	var _wanted2 = _interopRequireDefault(_wanted);
	
	var _wanted3 = __webpack_require__(247);
	
	var _wanted4 = _interopRequireDefault(_wanted3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module("dalApp.wanted", ["dalApp.auth", "ui.router"]).config(_wanted2.default).controller("WantedController", _wanted4.default).name;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state("wanted", {
	    url: "/wanted",
	    template: __webpack_require__(246),
	    controller: "WantedController",
	    controllerAs: "wantedCtrl"
	  });
	}

/***/ }),
/* 246 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container wanted-container\">\n  <form\n    class=\"form-inline\"\n    name=\"form_product\"\n    novalidate\n    style=\"margin-top: 15px\"\n  >\n    <input\n      type=\"text\"\n      class=\"form-control input-search\"\n      ng-model=\"wantedCtrl.query\"\n      placeholder=\"{{wantedCtrl.lang=='fr'? 'Tapez le nom de l\\'auteur' : 'Enter artist name'}}\"\n      ng-keydown=\"wantedCtrl.searchWantedKeyDown()\"\n    />\n    <button\n      type=\"button\"\n      class=\"btn btn-primary btn-search\"\n      ng-disabled=\"!wantedCtrl.query || wantedCtrl.query.length<2\"\n      ng-click=\"wantedCtrl.searchWanted()\"\n    >\n      {{wantedCtrl.lang=='fr'? 'RECHERCHER' : 'SEARCH'}}\n    </button>\n  </form>\n\n  <div class=\"card\" ng-if=\"wantedCtrl.enabled\">\n    <div class=\"card-header\">\n      <p\n        class=\"comment-result\"\n        ng-if=\"!wantedCtrl.results || wantedCtrl.results.length<100\"\n      >\n        {{wantedCtrl.results.length}} {{wantedCtrl.lang=='fr'? 'resultat(s)\n        pour' : 'result(s) for'}} {{wantedCtrl._query}}\n      </p>\n      <p class=\"comment-result\" ng-if=\"wantedCtrl.results.length>=100\">\n        <span ng-if=\"wantedCtrl.lang=='fr'\">\n          Seuls les 100 premiers résultats ont été affichés. Veuillez compléter\n          avec le prénom pour affiner votre recherche.\n        </span>\n        <span ng-if=\"wantedCtrl.lang!='fr'\">\n          Only the first 100 results are displayed. Please add the firstname to\n          refine your search.\n        </span>\n      </p>\n    </div>\n    <ul class=\"list-group list-group-flush\">\n      <li\n        class=\"list-wanted\"\n        ng-repeat=\"wanted in wantedCtrl.results\"\n        ng-class=\"{'list-wanted-selected': wantedCtrl.isSelected(wanted.detail.pos)}\"\n      >\n        <p\n          class=\"name-author\"\n          ng-class=\"{'name-author-selected': wantedCtrl.isSelected(wanted.detail.pos)}\"\n          ng-click=\"wantedCtrl.selectWanted(wanted.detail.pos);\"\n        >\n          <span\n            ng-class=\"{'text-selected': wantedCtrl.isSelected(wanted.detail.pos)}\"\n          >\n            <b>{{wanted.label}}</b>\n          </span>\n          <button\n            type=\"button\"\n            class=\"btn btn-xs btn-detail\"\n            ng-class=\"{'btn-detail-selected': wantedCtrl.isSelected(wanted.detail.pos)}\"\n            ng-click=\"wantedCtrl.selectWanted(wanted.detail.pos);\"\n          >\n            {{wantedCtrl.lang=='fr'? 'détails' : 'details'}}\n            <i class=\"glyphicon glyphicon-chevron-down\"></i>\n          </button>\n        </p>\n        <table\n          class=\"table-detail\"\n          ng-if=\"wantedCtrl.isSelected(wanted.detail.pos)\"\n        >\n          <tr class=\"row\">\n            <th class=\"col-sm-3\">\n              {{wantedCtrl.lang=='fr'? 'Type de droit' : 'Type of right'}}\n            </th>\n            <th class=\"col-sm-3\">\n              {{wantedCtrl.lang=='fr'? 'Territoire, année' : 'Territory, year'}}\n            </th>\n            <th class=\"col-sm-6\">\n              {{wantedCtrl.lang=='fr'? 'Informations complémentaires' : 'Other\n              information'}}\n            </th>\n          </tr>\n          <tr ng-repeat=\"elt in wanted.detail.detail\" class=\"row\">\n            <td class=\"col-sm-3\">{{elt.type_de_droit}}</td>\n            <td class=\"col-sm-3\">{{elt.nom_produit}}</td>\n            <td class=\"col-sm-6\">{{elt.autres_informations}}</td>\n          </tr>\n        </table>\n      </li>\n    </ul>\n  </div>\n</div>\n"

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _underscore = __webpack_require__(64);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var WantedController = function () {
	  /*@ngInject*/
	  WantedController.$inject = ['ElasticAPI', '$location'];
	  function WantedController(ElasticAPI, $location) {
	    _classCallCheck(this, WantedController);
	
	    this.ElasticAPI = ElasticAPI;
	    this.results = [];
	    this.enabled = false;
	    this._query = null;
	    this.selectedPos = [];
	
	    var params = $location.search();
	    this.lang = params && params.lang && (params.lang == "fr" || params.lang == "en") ? params.lang : "fr";
	  }
	
	  _createClass(WantedController, [{
	    key: "searchWantedKeyDown",
	    value: function searchWantedKeyDown() {
	      if (event.keyCode == 13 && this.query && this.query.length > 1) {
	        this.searchWanted();
	      }
	    }
	  }, {
	    key: "selectWanted",
	    value: function selectWanted(pos) {
	      this.selectedPos = [pos];
	    }
	  }, {
	    key: "isSelected",
	    value: function isSelected(pos) {
	      return this.selectedPos.indexOf(pos) != -1;
	    }
	  }, {
	    key: "searchWanted",
	    value: function searchWanted() {
	      this.results = null;
	      this.enabled = false;
	      this._query = this.query;
	      this.selectedPos = [];
	      var that = this;
	      if (this.query && this.query.length > 1) {
	        return this.ElasticAPI.searchWanted({
	          name: this.query
	        }, function (results) {
	          return results;
	        }).$promise.then(function (results) {
	          that.results = JSON.parse(JSON.stringify(results));
	
	          that.enabled = true;
	          return;
	        });
	      } else {
	        return;
	      }
	    }
	  }]);
	
	  return WantedController;
	}();
	
	exports.default = WantedController;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(249);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(21)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(20)();
	// imports
	exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Lato);", ""]);
	exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto&display=swap);", ""]);
	
	// module
	exports.push([module.id, "/*!\n * Bootstrap v3.3.7 (http://getbootstrap.com)\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n *//*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */@media print{*,:after,:before{background:transparent!important;color:#000!important;box-shadow:none!important;text-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}.navbar{display:none}.btn>.caret,.dropup>.btn>.caret{border-top-color:#000!important}.label{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}@font-face{font-family:Glyphicons Halflings;src:url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.eot\");src:url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.eot?#iefix\") format(\"embedded-opentype\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.woff2\") format(\"woff2\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.woff\") format(\"woff\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.ttf\") format(\"truetype\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.svg#glyphicons_halflingsregular\") format(\"svg\")}.glyphicon{position:relative;top:1px;display:inline-block;font-family:Glyphicons Halflings;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.glyphicon-asterisk:before{content:\"*\"}.glyphicon-plus:before{content:\"+\"}.glyphicon-eur:before,.glyphicon-euro:before{content:\"\\20AC\"}.glyphicon-minus:before{content:\"\\2212\"}.glyphicon-cloud:before{content:\"\\2601\"}.glyphicon-envelope:before{content:\"\\2709\"}.glyphicon-pencil:before{content:\"\\270F\"}.glyphicon-glass:before{content:\"\\E001\"}.glyphicon-music:before{content:\"\\E002\"}.glyphicon-search:before{content:\"\\E003\"}.glyphicon-heart:before{content:\"\\E005\"}.glyphicon-star:before{content:\"\\E006\"}.glyphicon-star-empty:before{content:\"\\E007\"}.glyphicon-user:before{content:\"\\E008\"}.glyphicon-film:before{content:\"\\E009\"}.glyphicon-th-large:before{content:\"\\E010\"}.glyphicon-th:before{content:\"\\E011\"}.glyphicon-th-list:before{content:\"\\E012\"}.glyphicon-ok:before{content:\"\\E013\"}.glyphicon-remove:before{content:\"\\E014\"}.glyphicon-zoom-in:before{content:\"\\E015\"}.glyphicon-zoom-out:before{content:\"\\E016\"}.glyphicon-off:before{content:\"\\E017\"}.glyphicon-signal:before{content:\"\\E018\"}.glyphicon-cog:before{content:\"\\E019\"}.glyphicon-trash:before{content:\"\\E020\"}.glyphicon-home:before{content:\"\\E021\"}.glyphicon-file:before{content:\"\\E022\"}.glyphicon-time:before{content:\"\\E023\"}.glyphicon-road:before{content:\"\\E024\"}.glyphicon-download-alt:before{content:\"\\E025\"}.glyphicon-download:before{content:\"\\E026\"}.glyphicon-upload:before{content:\"\\E027\"}.glyphicon-inbox:before{content:\"\\E028\"}.glyphicon-play-circle:before{content:\"\\E029\"}.glyphicon-repeat:before{content:\"\\E030\"}.glyphicon-refresh:before{content:\"\\E031\"}.glyphicon-list-alt:before{content:\"\\E032\"}.glyphicon-lock:before{content:\"\\E033\"}.glyphicon-flag:before{content:\"\\E034\"}.glyphicon-headphones:before{content:\"\\E035\"}.glyphicon-volume-off:before{content:\"\\E036\"}.glyphicon-volume-down:before{content:\"\\E037\"}.glyphicon-volume-up:before{content:\"\\E038\"}.glyphicon-qrcode:before{content:\"\\E039\"}.glyphicon-barcode:before{content:\"\\E040\"}.glyphicon-tag:before{content:\"\\E041\"}.glyphicon-tags:before{content:\"\\E042\"}.glyphicon-book:before{content:\"\\E043\"}.glyphicon-bookmark:before{content:\"\\E044\"}.glyphicon-print:before{content:\"\\E045\"}.glyphicon-camera:before{content:\"\\E046\"}.glyphicon-font:before{content:\"\\E047\"}.glyphicon-bold:before{content:\"\\E048\"}.glyphicon-italic:before{content:\"\\E049\"}.glyphicon-text-height:before{content:\"\\E050\"}.glyphicon-text-width:before{content:\"\\E051\"}.glyphicon-align-left:before{content:\"\\E052\"}.glyphicon-align-center:before{content:\"\\E053\"}.glyphicon-align-right:before{content:\"\\E054\"}.glyphicon-align-justify:before{content:\"\\E055\"}.glyphicon-list:before{content:\"\\E056\"}.glyphicon-indent-left:before{content:\"\\E057\"}.glyphicon-indent-right:before{content:\"\\E058\"}.glyphicon-facetime-video:before{content:\"\\E059\"}.glyphicon-picture:before{content:\"\\E060\"}.glyphicon-map-marker:before{content:\"\\E062\"}.glyphicon-adjust:before{content:\"\\E063\"}.glyphicon-tint:before{content:\"\\E064\"}.glyphicon-edit:before{content:\"\\E065\"}.glyphicon-share:before{content:\"\\E066\"}.glyphicon-check:before{content:\"\\E067\"}.glyphicon-move:before{content:\"\\E068\"}.glyphicon-step-backward:before{content:\"\\E069\"}.glyphicon-fast-backward:before{content:\"\\E070\"}.glyphicon-backward:before{content:\"\\E071\"}.glyphicon-play:before{content:\"\\E072\"}.glyphicon-pause:before{content:\"\\E073\"}.glyphicon-stop:before{content:\"\\E074\"}.glyphicon-forward:before{content:\"\\E075\"}.glyphicon-fast-forward:before{content:\"\\E076\"}.glyphicon-step-forward:before{content:\"\\E077\"}.glyphicon-eject:before{content:\"\\E078\"}.glyphicon-chevron-left:before{content:\"\\E079\"}.glyphicon-chevron-right:before{content:\"\\E080\"}.glyphicon-plus-sign:before{content:\"\\E081\"}.glyphicon-minus-sign:before{content:\"\\E082\"}.glyphicon-remove-sign:before{content:\"\\E083\"}.glyphicon-ok-sign:before{content:\"\\E084\"}.glyphicon-question-sign:before{content:\"\\E085\"}.glyphicon-info-sign:before{content:\"\\E086\"}.glyphicon-screenshot:before{content:\"\\E087\"}.glyphicon-remove-circle:before{content:\"\\E088\"}.glyphicon-ok-circle:before{content:\"\\E089\"}.glyphicon-ban-circle:before{content:\"\\E090\"}.glyphicon-arrow-left:before{content:\"\\E091\"}.glyphicon-arrow-right:before{content:\"\\E092\"}.glyphicon-arrow-up:before{content:\"\\E093\"}.glyphicon-arrow-down:before{content:\"\\E094\"}.glyphicon-share-alt:before{content:\"\\E095\"}.glyphicon-resize-full:before{content:\"\\E096\"}.glyphicon-resize-small:before{content:\"\\E097\"}.glyphicon-exclamation-sign:before{content:\"\\E101\"}.glyphicon-gift:before{content:\"\\E102\"}.glyphicon-leaf:before{content:\"\\E103\"}.glyphicon-fire:before{content:\"\\E104\"}.glyphicon-eye-open:before{content:\"\\E105\"}.glyphicon-eye-close:before{content:\"\\E106\"}.glyphicon-warning-sign:before{content:\"\\E107\"}.glyphicon-plane:before{content:\"\\E108\"}.glyphicon-calendar:before{content:\"\\E109\"}.glyphicon-random:before{content:\"\\E110\"}.glyphicon-comment:before{content:\"\\E111\"}.glyphicon-magnet:before{content:\"\\E112\"}.glyphicon-chevron-up:before{content:\"\\E113\"}.glyphicon-chevron-down:before{content:\"\\E114\"}.glyphicon-retweet:before{content:\"\\E115\"}.glyphicon-shopping-cart:before{content:\"\\E116\"}.glyphicon-folder-close:before{content:\"\\E117\"}.glyphicon-folder-open:before{content:\"\\E118\"}.glyphicon-resize-vertical:before{content:\"\\E119\"}.glyphicon-resize-horizontal:before{content:\"\\E120\"}.glyphicon-hdd:before{content:\"\\E121\"}.glyphicon-bullhorn:before{content:\"\\E122\"}.glyphicon-bell:before{content:\"\\E123\"}.glyphicon-certificate:before{content:\"\\E124\"}.glyphicon-thumbs-up:before{content:\"\\E125\"}.glyphicon-thumbs-down:before{content:\"\\E126\"}.glyphicon-hand-right:before{content:\"\\E127\"}.glyphicon-hand-left:before{content:\"\\E128\"}.glyphicon-hand-up:before{content:\"\\E129\"}.glyphicon-hand-down:before{content:\"\\E130\"}.glyphicon-circle-arrow-right:before{content:\"\\E131\"}.glyphicon-circle-arrow-left:before{content:\"\\E132\"}.glyphicon-circle-arrow-up:before{content:\"\\E133\"}.glyphicon-circle-arrow-down:before{content:\"\\E134\"}.glyphicon-globe:before{content:\"\\E135\"}.glyphicon-wrench:before{content:\"\\E136\"}.glyphicon-tasks:before{content:\"\\E137\"}.glyphicon-filter:before{content:\"\\E138\"}.glyphicon-briefcase:before{content:\"\\E139\"}.glyphicon-fullscreen:before{content:\"\\E140\"}.glyphicon-dashboard:before{content:\"\\E141\"}.glyphicon-paperclip:before{content:\"\\E142\"}.glyphicon-heart-empty:before{content:\"\\E143\"}.glyphicon-link:before{content:\"\\E144\"}.glyphicon-phone:before{content:\"\\E145\"}.glyphicon-pushpin:before{content:\"\\E146\"}.glyphicon-usd:before{content:\"\\E148\"}.glyphicon-gbp:before{content:\"\\E149\"}.glyphicon-sort:before{content:\"\\E150\"}.glyphicon-sort-by-alphabet:before{content:\"\\E151\"}.glyphicon-sort-by-alphabet-alt:before{content:\"\\E152\"}.glyphicon-sort-by-order:before{content:\"\\E153\"}.glyphicon-sort-by-order-alt:before{content:\"\\E154\"}.glyphicon-sort-by-attributes:before{content:\"\\E155\"}.glyphicon-sort-by-attributes-alt:before{content:\"\\E156\"}.glyphicon-unchecked:before{content:\"\\E157\"}.glyphicon-expand:before{content:\"\\E158\"}.glyphicon-collapse-down:before{content:\"\\E159\"}.glyphicon-collapse-up:before{content:\"\\E160\"}.glyphicon-log-in:before{content:\"\\E161\"}.glyphicon-flash:before{content:\"\\E162\"}.glyphicon-log-out:before{content:\"\\E163\"}.glyphicon-new-window:before{content:\"\\E164\"}.glyphicon-record:before{content:\"\\E165\"}.glyphicon-save:before{content:\"\\E166\"}.glyphicon-open:before{content:\"\\E167\"}.glyphicon-saved:before{content:\"\\E168\"}.glyphicon-import:before{content:\"\\E169\"}.glyphicon-export:before{content:\"\\E170\"}.glyphicon-send:before{content:\"\\E171\"}.glyphicon-floppy-disk:before{content:\"\\E172\"}.glyphicon-floppy-saved:before{content:\"\\E173\"}.glyphicon-floppy-remove:before{content:\"\\E174\"}.glyphicon-floppy-save:before{content:\"\\E175\"}.glyphicon-floppy-open:before{content:\"\\E176\"}.glyphicon-credit-card:before{content:\"\\E177\"}.glyphicon-transfer:before{content:\"\\E178\"}.glyphicon-cutlery:before{content:\"\\E179\"}.glyphicon-header:before{content:\"\\E180\"}.glyphicon-compressed:before{content:\"\\E181\"}.glyphicon-earphone:before{content:\"\\E182\"}.glyphicon-phone-alt:before{content:\"\\E183\"}.glyphicon-tower:before{content:\"\\E184\"}.glyphicon-stats:before{content:\"\\E185\"}.glyphicon-sd-video:before{content:\"\\E186\"}.glyphicon-hd-video:before{content:\"\\E187\"}.glyphicon-subtitles:before{content:\"\\E188\"}.glyphicon-sound-stereo:before{content:\"\\E189\"}.glyphicon-sound-dolby:before{content:\"\\E190\"}.glyphicon-sound-5-1:before{content:\"\\E191\"}.glyphicon-sound-6-1:before{content:\"\\E192\"}.glyphicon-sound-7-1:before{content:\"\\E193\"}.glyphicon-copyright-mark:before{content:\"\\E194\"}.glyphicon-registration-mark:before{content:\"\\E195\"}.glyphicon-cloud-download:before{content:\"\\E197\"}.glyphicon-cloud-upload:before{content:\"\\E198\"}.glyphicon-tree-conifer:before{content:\"\\E199\"}.glyphicon-tree-deciduous:before{content:\"\\E200\"}.glyphicon-cd:before{content:\"\\E201\"}.glyphicon-save-file:before{content:\"\\E202\"}.glyphicon-open-file:before{content:\"\\E203\"}.glyphicon-level-up:before{content:\"\\E204\"}.glyphicon-copy:before{content:\"\\E205\"}.glyphicon-paste:before{content:\"\\E206\"}.glyphicon-alert:before{content:\"\\E209\"}.glyphicon-equalizer:before{content:\"\\E210\"}.glyphicon-king:before{content:\"\\E211\"}.glyphicon-queen:before{content:\"\\E212\"}.glyphicon-pawn:before{content:\"\\E213\"}.glyphicon-bishop:before{content:\"\\E214\"}.glyphicon-knight:before{content:\"\\E215\"}.glyphicon-baby-formula:before{content:\"\\E216\"}.glyphicon-tent:before{content:\"\\26FA\"}.glyphicon-blackboard:before{content:\"\\E218\"}.glyphicon-bed:before{content:\"\\E219\"}.glyphicon-apple:before{content:\"\\F8FF\"}.glyphicon-erase:before{content:\"\\E221\"}.glyphicon-hourglass:before{content:\"\\231B\"}.glyphicon-lamp:before{content:\"\\E223\"}.glyphicon-duplicate:before{content:\"\\E224\"}.glyphicon-piggy-bank:before{content:\"\\E225\"}.glyphicon-scissors:before{content:\"\\E226\"}.glyphicon-bitcoin:before,.glyphicon-btc:before,.glyphicon-xbt:before{content:\"\\E227\"}.glyphicon-jpy:before,.glyphicon-yen:before{content:\"\\A5\"}.glyphicon-rub:before,.glyphicon-ruble:before{content:\"\\20BD\"}.glyphicon-scale:before{content:\"\\E230\"}.glyphicon-ice-lolly:before{content:\"\\E231\"}.glyphicon-ice-lolly-tasted:before{content:\"\\E232\"}.glyphicon-education:before{content:\"\\E233\"}.glyphicon-option-horizontal:before{content:\"\\E234\"}.glyphicon-option-vertical:before{content:\"\\E235\"}.glyphicon-menu-hamburger:before{content:\"\\E236\"}.glyphicon-modal-window:before{content:\"\\E237\"}.glyphicon-oil:before{content:\"\\E238\"}.glyphicon-grain:before{content:\"\\E239\"}.glyphicon-sunglasses:before{content:\"\\E240\"}.glyphicon-text-size:before{content:\"\\E241\"}.glyphicon-text-color:before{content:\"\\E242\"}.glyphicon-text-background:before{content:\"\\E243\"}.glyphicon-object-align-top:before{content:\"\\E244\"}.glyphicon-object-align-bottom:before{content:\"\\E245\"}.glyphicon-object-align-horizontal:before{content:\"\\E246\"}.glyphicon-object-align-left:before{content:\"\\E247\"}.glyphicon-object-align-vertical:before{content:\"\\E248\"}.glyphicon-object-align-right:before{content:\"\\E249\"}.glyphicon-triangle-right:before{content:\"\\E250\"}.glyphicon-triangle-left:before{content:\"\\E251\"}.glyphicon-triangle-bottom:before{content:\"\\E252\"}.glyphicon-triangle-top:before{content:\"\\E253\"}.glyphicon-console:before{content:\"\\E254\"}.glyphicon-superscript:before{content:\"\\E255\"}.glyphicon-subscript:before{content:\"\\E256\"}.glyphicon-menu-left:before{content:\"\\E257\"}.glyphicon-menu-right:before{content:\"\\E258\"}.glyphicon-menu-down:before{content:\"\\E259\"}.glyphicon-menu-up:before{content:\"\\E260\"}*,:after,:before{box-sizing:border-box}html{font-size:10px;-webkit-tap-highlight-color:transparent}body{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;line-height:1.428571429;color:#333;background-color:#fff}button,input,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}a{color:#337ab7;text-decoration:none}a:focus,a:hover{color:#23527c;text-decoration:underline}a:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}figure{margin:0}img{vertical-align:middle}.img-responsive{display:block;max-width:100%;height:auto}.img-rounded{border-radius:6px}.img-thumbnail{padding:4px;line-height:1.428571429;background-color:#fff;border:1px solid #ddd;border-radius:4px;transition:all .2s ease-in-out;display:inline-block;max-width:100%;height:auto}.img-circle{border-radius:50%}hr{margin-top:20px;margin-bottom:20px;border:0;border-top:1px solid #eee}[role=button]{cursor:pointer}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:500;line-height:1.1;color:inherit}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-weight:400;line-height:1;color:#777}.h1,.h2,.h3,h1,h2,h3{margin-top:20px;margin-bottom:10px}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small{font-size:65%}.h4,.h5,.h6,h4,h5,h6{margin-top:10px;margin-bottom:10px}.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-size:75%}.h1,h1{font-size:36px}.h2,h2{font-size:30px}.h3,h3{font-size:24px}.h4,h4{font-size:18px}.h5,h5{font-size:14px}.h6,h6{font-size:12px}p{margin:0 0 10px}.lead{margin-bottom:20px;font-size:16px;font-weight:300;line-height:1.4}@media (min-width:768px){.lead{font-size:21px}}.small,small{font-size:85%}.mark,mark{background-color:#fcf8e3;padding:.2em}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}.text-justify{text-align:justify}.text-nowrap{white-space:nowrap}.text-lowercase{text-transform:lowercase}.initialism,.text-uppercase{text-transform:uppercase}.text-capitalize{text-transform:capitalize}.text-muted{color:#777}.text-primary{color:#337ab7}a.text-primary:focus,a.text-primary:hover{color:#286090}.text-success{color:#3c763d}a.text-success:focus,a.text-success:hover{color:#2b542c}.text-info{color:#31708f}a.text-info:focus,a.text-info:hover{color:#245269}.text-warning{color:#8a6d3b}a.text-warning:focus,a.text-warning:hover{color:#66512c}.text-danger{color:#a94442}a.text-danger:focus,a.text-danger:hover{color:#843534}.bg-primary{color:#fff;background-color:#337ab7}a.bg-primary:focus,a.bg-primary:hover{background-color:#286090}.bg-success{background-color:#dff0d8}a.bg-success:focus,a.bg-success:hover{background-color:#c1e2b3}.bg-info{background-color:#d9edf7}a.bg-info:focus,a.bg-info:hover{background-color:#afd9ee}.bg-warning{background-color:#fcf8e3}a.bg-warning:focus,a.bg-warning:hover{background-color:#f7ecb5}.bg-danger{background-color:#f2dede}a.bg-danger:focus,a.bg-danger:hover{background-color:#e4b9b9}.page-header{padding-bottom:9px;margin:40px 0 20px;border-bottom:1px solid #eee}ol,ul{margin-top:0;margin-bottom:10px}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline{margin-left:-5px}.list-inline>li{display:inline-block;padding-left:5px;padding-right:5px}dl{margin-top:0;margin-bottom:20px}dd,dt{line-height:1.428571429}dt{font-weight:700}dd{margin-left:0}.dl-horizontal dd:after,.dl-horizontal dd:before{content:\" \";display:table}.dl-horizontal dd:after{clear:both}@media (min-width:768px){.dl-horizontal dt{float:left;width:160px;clear:left;text-align:right;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.dl-horizontal dd{margin-left:180px}}abbr[data-original-title],abbr[title]{cursor:help;border-bottom:1px dotted #777}.initialism{font-size:90%}blockquote{padding:10px 20px;margin:0 0 20px;font-size:17.5px;border-left:5px solid #eee}blockquote ol:last-child,blockquote p:last-child,blockquote ul:last-child{margin-bottom:0}blockquote .small,blockquote footer,blockquote small{display:block;font-size:80%;line-height:1.428571429;color:#777}blockquote .small:before,blockquote footer:before,blockquote small:before{content:\"\\2014   \\A0\"}.blockquote-reverse,blockquote.pull-right{padding-right:15px;padding-left:0;border-right:5px solid #eee;border-left:0;text-align:right}.blockquote-reverse .small:before,.blockquote-reverse footer:before,.blockquote-reverse small:before,blockquote.pull-right .small:before,blockquote.pull-right footer:before,blockquote.pull-right small:before{content:\"\"}.blockquote-reverse .small:after,.blockquote-reverse footer:after,.blockquote-reverse small:after,blockquote.pull-right .small:after,blockquote.pull-right footer:after,blockquote.pull-right small:after{content:\"\\A0   \\2014\"}address{margin-bottom:20px;font-style:normal;line-height:1.428571429}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,Courier New,monospace}code{color:#c7254e;background-color:#f9f2f4;border-radius:4px}code,kbd{padding:2px 4px;font-size:90%}kbd{color:#fff;background-color:#333;border-radius:3px;box-shadow:inset 0 -1px 0 rgba(0,0,0,.25)}kbd kbd{padding:0;font-size:100%;font-weight:700;box-shadow:none}pre{display:block;padding:9.5px;margin:0 0 10px;font-size:13px;line-height:1.428571429;word-break:break-all;word-wrap:break-word;color:#333;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px}pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px}.container:after,.container:before{content:\" \";display:table}.container:after{clear:both}@media (min-width:768px){.container{width:750px}}@media (min-width:992px){.container{width:970px}}@media (min-width:1200px){.container{width:1170px}}.container-fluid{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px}.container-fluid:after,.container-fluid:before{content:\" \";display:table}.container-fluid:after{clear:both}.row{margin-left:-15px;margin-right:-15px}.row:after,.row:before{content:\" \";display:table}.row:after{clear:both}.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{position:relative;min-height:1px;padding-left:15px;padding-right:15px}.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{float:left}.col-xs-1{width:8.3333333333%}.col-xs-2{width:16.6666666667%}.col-xs-3{width:25%}.col-xs-4{width:33.3333333333%}.col-xs-5{width:41.6666666667%}.col-xs-6{width:50%}.col-xs-7{width:58.3333333333%}.col-xs-8{width:66.6666666667%}.col-xs-9{width:75%}.col-xs-10{width:83.3333333333%}.col-xs-11{width:91.6666666667%}.col-xs-12{width:100%}.col-xs-pull-0{right:auto}.col-xs-pull-1{right:8.3333333333%}.col-xs-pull-2{right:16.6666666667%}.col-xs-pull-3{right:25%}.col-xs-pull-4{right:33.3333333333%}.col-xs-pull-5{right:41.6666666667%}.col-xs-pull-6{right:50%}.col-xs-pull-7{right:58.3333333333%}.col-xs-pull-8{right:66.6666666667%}.col-xs-pull-9{right:75%}.col-xs-pull-10{right:83.3333333333%}.col-xs-pull-11{right:91.6666666667%}.col-xs-pull-12{right:100%}.col-xs-push-0{left:auto}.col-xs-push-1{left:8.3333333333%}.col-xs-push-2{left:16.6666666667%}.col-xs-push-3{left:25%}.col-xs-push-4{left:33.3333333333%}.col-xs-push-5{left:41.6666666667%}.col-xs-push-6{left:50%}.col-xs-push-7{left:58.3333333333%}.col-xs-push-8{left:66.6666666667%}.col-xs-push-9{left:75%}.col-xs-push-10{left:83.3333333333%}.col-xs-push-11{left:91.6666666667%}.col-xs-push-12{left:100%}.col-xs-offset-0{margin-left:0}.col-xs-offset-1{margin-left:8.3333333333%}.col-xs-offset-2{margin-left:16.6666666667%}.col-xs-offset-3{margin-left:25%}.col-xs-offset-4{margin-left:33.3333333333%}.col-xs-offset-5{margin-left:41.6666666667%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-7{margin-left:58.3333333333%}.col-xs-offset-8{margin-left:66.6666666667%}.col-xs-offset-9{margin-left:75%}.col-xs-offset-10{margin-left:83.3333333333%}.col-xs-offset-11{margin-left:91.6666666667%}.col-xs-offset-12{margin-left:100%}@media (min-width:768px){.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12{float:left}.col-sm-1{width:8.3333333333%}.col-sm-2{width:16.6666666667%}.col-sm-3{width:25%}.col-sm-4{width:33.3333333333%}.col-sm-5{width:41.6666666667%}.col-sm-6{width:50%}.col-sm-7{width:58.3333333333%}.col-sm-8{width:66.6666666667%}.col-sm-9{width:75%}.col-sm-10{width:83.3333333333%}.col-sm-11{width:91.6666666667%}.col-sm-12{width:100%}.col-sm-pull-0{right:auto}.col-sm-pull-1{right:8.3333333333%}.col-sm-pull-2{right:16.6666666667%}.col-sm-pull-3{right:25%}.col-sm-pull-4{right:33.3333333333%}.col-sm-pull-5{right:41.6666666667%}.col-sm-pull-6{right:50%}.col-sm-pull-7{right:58.3333333333%}.col-sm-pull-8{right:66.6666666667%}.col-sm-pull-9{right:75%}.col-sm-pull-10{right:83.3333333333%}.col-sm-pull-11{right:91.6666666667%}.col-sm-pull-12{right:100%}.col-sm-push-0{left:auto}.col-sm-push-1{left:8.3333333333%}.col-sm-push-2{left:16.6666666667%}.col-sm-push-3{left:25%}.col-sm-push-4{left:33.3333333333%}.col-sm-push-5{left:41.6666666667%}.col-sm-push-6{left:50%}.col-sm-push-7{left:58.3333333333%}.col-sm-push-8{left:66.6666666667%}.col-sm-push-9{left:75%}.col-sm-push-10{left:83.3333333333%}.col-sm-push-11{left:91.6666666667%}.col-sm-push-12{left:100%}.col-sm-offset-0{margin-left:0}.col-sm-offset-1{margin-left:8.3333333333%}.col-sm-offset-2{margin-left:16.6666666667%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-4{margin-left:33.3333333333%}.col-sm-offset-5{margin-left:41.6666666667%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-7{margin-left:58.3333333333%}.col-sm-offset-8{margin-left:66.6666666667%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-10{margin-left:83.3333333333%}.col-sm-offset-11{margin-left:91.6666666667%}.col-sm-offset-12{margin-left:100%}}@media (min-width:992px){.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12{float:left}.col-md-1{width:8.3333333333%}.col-md-2{width:16.6666666667%}.col-md-3{width:25%}.col-md-4{width:33.3333333333%}.col-md-5{width:41.6666666667%}.col-md-6{width:50%}.col-md-7{width:58.3333333333%}.col-md-8{width:66.6666666667%}.col-md-9{width:75%}.col-md-10{width:83.3333333333%}.col-md-11{width:91.6666666667%}.col-md-12{width:100%}.col-md-pull-0{right:auto}.col-md-pull-1{right:8.3333333333%}.col-md-pull-2{right:16.6666666667%}.col-md-pull-3{right:25%}.col-md-pull-4{right:33.3333333333%}.col-md-pull-5{right:41.6666666667%}.col-md-pull-6{right:50%}.col-md-pull-7{right:58.3333333333%}.col-md-pull-8{right:66.6666666667%}.col-md-pull-9{right:75%}.col-md-pull-10{right:83.3333333333%}.col-md-pull-11{right:91.6666666667%}.col-md-pull-12{right:100%}.col-md-push-0{left:auto}.col-md-push-1{left:8.3333333333%}.col-md-push-2{left:16.6666666667%}.col-md-push-3{left:25%}.col-md-push-4{left:33.3333333333%}.col-md-push-5{left:41.6666666667%}.col-md-push-6{left:50%}.col-md-push-7{left:58.3333333333%}.col-md-push-8{left:66.6666666667%}.col-md-push-9{left:75%}.col-md-push-10{left:83.3333333333%}.col-md-push-11{left:91.6666666667%}.col-md-push-12{left:100%}.col-md-offset-0{margin-left:0}.col-md-offset-1{margin-left:8.3333333333%}.col-md-offset-2{margin-left:16.6666666667%}.col-md-offset-3{margin-left:25%}.col-md-offset-4{margin-left:33.3333333333%}.col-md-offset-5{margin-left:41.6666666667%}.col-md-offset-6{margin-left:50%}.col-md-offset-7{margin-left:58.3333333333%}.col-md-offset-8{margin-left:66.6666666667%}.col-md-offset-9{margin-left:75%}.col-md-offset-10{margin-left:83.3333333333%}.col-md-offset-11{margin-left:91.6666666667%}.col-md-offset-12{margin-left:100%}}@media (min-width:1200px){.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12{float:left}.col-lg-1{width:8.3333333333%}.col-lg-2{width:16.6666666667%}.col-lg-3{width:25%}.col-lg-4{width:33.3333333333%}.col-lg-5{width:41.6666666667%}.col-lg-6{width:50%}.col-lg-7{width:58.3333333333%}.col-lg-8{width:66.6666666667%}.col-lg-9{width:75%}.col-lg-10{width:83.3333333333%}.col-lg-11{width:91.6666666667%}.col-lg-12{width:100%}.col-lg-pull-0{right:auto}.col-lg-pull-1{right:8.3333333333%}.col-lg-pull-2{right:16.6666666667%}.col-lg-pull-3{right:25%}.col-lg-pull-4{right:33.3333333333%}.col-lg-pull-5{right:41.6666666667%}.col-lg-pull-6{right:50%}.col-lg-pull-7{right:58.3333333333%}.col-lg-pull-8{right:66.6666666667%}.col-lg-pull-9{right:75%}.col-lg-pull-10{right:83.3333333333%}.col-lg-pull-11{right:91.6666666667%}.col-lg-pull-12{right:100%}.col-lg-push-0{left:auto}.col-lg-push-1{left:8.3333333333%}.col-lg-push-2{left:16.6666666667%}.col-lg-push-3{left:25%}.col-lg-push-4{left:33.3333333333%}.col-lg-push-5{left:41.6666666667%}.col-lg-push-6{left:50%}.col-lg-push-7{left:58.3333333333%}.col-lg-push-8{left:66.6666666667%}.col-lg-push-9{left:75%}.col-lg-push-10{left:83.3333333333%}.col-lg-push-11{left:91.6666666667%}.col-lg-push-12{left:100%}.col-lg-offset-0{margin-left:0}.col-lg-offset-1{margin-left:8.3333333333%}.col-lg-offset-2{margin-left:16.6666666667%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-4{margin-left:33.3333333333%}.col-lg-offset-5{margin-left:41.6666666667%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-7{margin-left:58.3333333333%}.col-lg-offset-8{margin-left:66.6666666667%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-10{margin-left:83.3333333333%}.col-lg-offset-11{margin-left:91.6666666667%}.col-lg-offset-12{margin-left:100%}}table{background-color:transparent}caption{padding-top:8px;padding-bottom:8px;color:#777}caption,th{text-align:left}.table{width:100%;max-width:100%;margin-bottom:20px}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:8px;line-height:1.428571429;vertical-align:top;border-top:1px solid #ddd}.table>thead>tr>th{vertical-align:bottom;border-bottom:2px solid #ddd}.table>caption+thead>tr:first-child>td,.table>caption+thead>tr:first-child>th,.table>colgroup+thead>tr:first-child>td,.table>colgroup+thead>tr:first-child>th,.table>thead:first-child>tr:first-child>td,.table>thead:first-child>tr:first-child>th{border-top:0}.table>tbody+tbody{border-top:2px solid #ddd}.table .table{background-color:#fff}.table-condensed>tbody>tr>td,.table-condensed>tbody>tr>th,.table-condensed>tfoot>tr>td,.table-condensed>tfoot>tr>th,.table-condensed>thead>tr>td,.table-condensed>thead>tr>th{padding:5px}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #ddd}.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border-bottom-width:2px}.table-striped>tbody>tr:nth-of-type(odd){background-color:#f9f9f9}.table-hover>tbody>tr:hover{background-color:#f5f5f5}table col[class*=col-]{position:static;float:none;display:table-column}table td[class*=col-],table th[class*=col-]{position:static;float:none;display:table-cell}.table>tbody>tr.active>td,.table>tbody>tr.active>th,.table>tbody>tr>td.active,.table>tbody>tr>th.active,.table>tfoot>tr.active>td,.table>tfoot>tr.active>th,.table>tfoot>tr>td.active,.table>tfoot>tr>th.active,.table>thead>tr.active>td,.table>thead>tr.active>th,.table>thead>tr>td.active,.table>thead>tr>th.active{background-color:#f5f5f5}.table-hover>tbody>tr.active:hover>td,.table-hover>tbody>tr.active:hover>th,.table-hover>tbody>tr:hover>.active,.table-hover>tbody>tr>td.active:hover,.table-hover>tbody>tr>th.active:hover{background-color:#e8e8e8}.table>tbody>tr.success>td,.table>tbody>tr.success>th,.table>tbody>tr>td.success,.table>tbody>tr>th.success,.table>tfoot>tr.success>td,.table>tfoot>tr.success>th,.table>tfoot>tr>td.success,.table>tfoot>tr>th.success,.table>thead>tr.success>td,.table>thead>tr.success>th,.table>thead>tr>td.success,.table>thead>tr>th.success{background-color:#dff0d8}.table-hover>tbody>tr.success:hover>td,.table-hover>tbody>tr.success:hover>th,.table-hover>tbody>tr:hover>.success,.table-hover>tbody>tr>td.success:hover,.table-hover>tbody>tr>th.success:hover{background-color:#d0e9c6}.table>tbody>tr.info>td,.table>tbody>tr.info>th,.table>tbody>tr>td.info,.table>tbody>tr>th.info,.table>tfoot>tr.info>td,.table>tfoot>tr.info>th,.table>tfoot>tr>td.info,.table>tfoot>tr>th.info,.table>thead>tr.info>td,.table>thead>tr.info>th,.table>thead>tr>td.info,.table>thead>tr>th.info{background-color:#d9edf7}.table-hover>tbody>tr.info:hover>td,.table-hover>tbody>tr.info:hover>th,.table-hover>tbody>tr:hover>.info,.table-hover>tbody>tr>td.info:hover,.table-hover>tbody>tr>th.info:hover{background-color:#c4e3f3}.table>tbody>tr.warning>td,.table>tbody>tr.warning>th,.table>tbody>tr>td.warning,.table>tbody>tr>th.warning,.table>tfoot>tr.warning>td,.table>tfoot>tr.warning>th,.table>tfoot>tr>td.warning,.table>tfoot>tr>th.warning,.table>thead>tr.warning>td,.table>thead>tr.warning>th,.table>thead>tr>td.warning,.table>thead>tr>th.warning{background-color:#fcf8e3}.table-hover>tbody>tr.warning:hover>td,.table-hover>tbody>tr.warning:hover>th,.table-hover>tbody>tr:hover>.warning,.table-hover>tbody>tr>td.warning:hover,.table-hover>tbody>tr>th.warning:hover{background-color:#faf2cc}.table>tbody>tr.danger>td,.table>tbody>tr.danger>th,.table>tbody>tr>td.danger,.table>tbody>tr>th.danger,.table>tfoot>tr.danger>td,.table>tfoot>tr.danger>th,.table>tfoot>tr>td.danger,.table>tfoot>tr>th.danger,.table>thead>tr.danger>td,.table>thead>tr.danger>th,.table>thead>tr>td.danger,.table>thead>tr>th.danger{background-color:#f2dede}.table-hover>tbody>tr.danger:hover>td,.table-hover>tbody>tr.danger:hover>th,.table-hover>tbody>tr:hover>.danger,.table-hover>tbody>tr>td.danger:hover,.table-hover>tbody>tr>th.danger:hover{background-color:#ebcccc}.table-responsive{overflow-x:auto;min-height:.01%}@media screen and (max-width:767px){.table-responsive{width:100%;margin-bottom:15px;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;border:1px solid #ddd}.table-responsive>.table{margin-bottom:0}.table-responsive>.table>tbody>tr>td,.table-responsive>.table>tbody>tr>th,.table-responsive>.table>tfoot>tr>td,.table-responsive>.table>tfoot>tr>th,.table-responsive>.table>thead>tr>td,.table-responsive>.table>thead>tr>th{white-space:nowrap}.table-responsive>.table-bordered{border:0}.table-responsive>.table-bordered>tbody>tr>td:first-child,.table-responsive>.table-bordered>tbody>tr>th:first-child,.table-responsive>.table-bordered>tfoot>tr>td:first-child,.table-responsive>.table-bordered>tfoot>tr>th:first-child,.table-responsive>.table-bordered>thead>tr>td:first-child,.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.table-responsive>.table-bordered>tbody>tr>td:last-child,.table-responsive>.table-bordered>tbody>tr>th:last-child,.table-responsive>.table-bordered>tfoot>tr>td:last-child,.table-responsive>.table-bordered>tfoot>tr>th:last-child,.table-responsive>.table-bordered>thead>tr>td:last-child,.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.table-responsive>.table-bordered>tbody>tr:last-child>td,.table-responsive>.table-bordered>tbody>tr:last-child>th,.table-responsive>.table-bordered>tfoot>tr:last-child>td,.table-responsive>.table-bordered>tfoot>tr:last-child>th{border-bottom:0}}fieldset{margin:0;min-width:0}fieldset,legend{padding:0;border:0}legend{display:block;width:100%;margin-bottom:20px;font-size:21px;line-height:inherit;color:#333;border-bottom:1px solid #e5e5e5}label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}input[type=search]{box-sizing:border-box}input[type=checkbox],input[type=radio]{margin:4px 0 0;margin-top:1px\\9;line-height:normal}input[type=file]{display:block}input[type=range]{display:block;width:100%}select[multiple],select[size]{height:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}output{padding-top:7px}.form-control,output{display:block;font-size:14px;line-height:1.428571429;color:#555}.form-control{width:100%;height:34px;padding:6px 12px;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control:focus{border-color:#66afe9;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control::-moz-placeholder{color:#999;opacity:1}.form-control:-ms-input-placeholder{color:#999}.form-control::-webkit-input-placeholder{color:#999}.form-control::-ms-expand{border:0;background-color:transparent}.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control{background-color:#eee;opacity:1}.form-control[disabled],fieldset[disabled] .form-control{cursor:not-allowed}textarea.form-control{height:auto}input[type=search]{-webkit-appearance:none}@media screen and (-webkit-min-device-pixel-ratio:0){input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{line-height:34px}.input-group-sm>.input-group-btn>input[type=date].btn,.input-group-sm>.input-group-btn>input[type=datetime-local].btn,.input-group-sm>.input-group-btn>input[type=month].btn,.input-group-sm>.input-group-btn>input[type=time].btn,.input-group-sm>input[type=date].form-control,.input-group-sm>input[type=date].input-group-addon,.input-group-sm>input[type=datetime-local].form-control,.input-group-sm>input[type=datetime-local].input-group-addon,.input-group-sm>input[type=month].form-control,.input-group-sm>input[type=month].input-group-addon,.input-group-sm>input[type=time].form-control,.input-group-sm>input[type=time].input-group-addon,.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:30px}.input-group-lg>.input-group-btn>input[type=date].btn,.input-group-lg>.input-group-btn>input[type=datetime-local].btn,.input-group-lg>.input-group-btn>input[type=month].btn,.input-group-lg>.input-group-btn>input[type=time].btn,.input-group-lg>input[type=date].form-control,.input-group-lg>input[type=date].input-group-addon,.input-group-lg>input[type=datetime-local].form-control,.input-group-lg>input[type=datetime-local].input-group-addon,.input-group-lg>input[type=month].form-control,.input-group-lg>input[type=month].input-group-addon,.input-group-lg>input[type=time].form-control,.input-group-lg>input[type=time].input-group-addon,.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:46px}}.form-group{margin-bottom:15px}.checkbox,.radio{position:relative;display:block;margin-top:10px;margin-bottom:10px}.checkbox label,.radio label{min-height:20px;padding-left:20px;margin-bottom:0;font-weight:400;cursor:pointer}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{position:absolute;margin-left:-20px;margin-top:4px\\9}.checkbox+.checkbox,.radio+.radio{margin-top:-5px}.checkbox-inline,.radio-inline{position:relative;display:inline-block;padding-left:20px;margin-bottom:0;vertical-align:middle;font-weight:400;cursor:pointer}.checkbox-inline+.checkbox-inline,.radio-inline+.radio-inline{margin-top:0;margin-left:10px}.checkbox-inline.disabled,.checkbox.disabled label,.radio-inline.disabled,.radio.disabled label,fieldset[disabled] .checkbox-inline,fieldset[disabled] .checkbox label,fieldset[disabled] .radio-inline,fieldset[disabled] .radio label,fieldset[disabled] input[type=checkbox],fieldset[disabled] input[type=radio],input[type=checkbox].disabled,input[type=checkbox][disabled],input[type=radio].disabled,input[type=radio][disabled]{cursor:not-allowed}.form-control-static{padding-top:7px;padding-bottom:7px;margin-bottom:0;min-height:34px}.form-control-static.input-lg,.form-control-static.input-sm,.input-group-lg>.form-control-static.form-control,.input-group-lg>.form-control-static.input-group-addon,.input-group-lg>.input-group-btn>.form-control-static.btn,.input-group-sm>.form-control-static.form-control,.input-group-sm>.form-control-static.input-group-addon,.input-group-sm>.input-group-btn>.form-control-static.btn{padding-left:0;padding-right:0}.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn,.input-sm{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.input-group-sm>.input-group-btn>select.btn,.input-group-sm>select.form-control,.input-group-sm>select.input-group-addon,select.input-sm{height:30px;line-height:30px}.input-group-sm>.input-group-btn>select[multiple].btn,.input-group-sm>.input-group-btn>textarea.btn,.input-group-sm>select[multiple].form-control,.input-group-sm>select[multiple].input-group-addon,.input-group-sm>textarea.form-control,.input-group-sm>textarea.input-group-addon,select[multiple].input-sm,textarea.input-sm{height:auto}.form-group-sm .form-control{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.form-group-sm select.form-control{height:30px;line-height:30px}.form-group-sm select[multiple].form-control,.form-group-sm textarea.form-control{height:auto}.form-group-sm .form-control-static{height:30px;min-height:32px;padding:6px 10px;font-size:12px;line-height:1.5}.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn,.input-lg{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.input-group-lg>.input-group-btn>select.btn,.input-group-lg>select.form-control,.input-group-lg>select.input-group-addon,select.input-lg{height:46px;line-height:46px}.input-group-lg>.input-group-btn>select[multiple].btn,.input-group-lg>.input-group-btn>textarea.btn,.input-group-lg>select[multiple].form-control,.input-group-lg>select[multiple].input-group-addon,.input-group-lg>textarea.form-control,.input-group-lg>textarea.input-group-addon,select[multiple].input-lg,textarea.input-lg{height:auto}.form-group-lg .form-control{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.form-group-lg select.form-control{height:46px;line-height:46px}.form-group-lg select[multiple].form-control,.form-group-lg textarea.form-control{height:auto}.form-group-lg .form-control-static{height:46px;min-height:38px;padding:11px 16px;font-size:18px;line-height:1.3333333}.has-feedback{position:relative}.has-feedback .form-control{padding-right:42.5px}.form-control-feedback{position:absolute;top:0;right:0;z-index:2;display:block;width:34px;height:34px;line-height:34px;text-align:center;pointer-events:none}.form-group-lg .form-control+.form-control-feedback,.input-group-lg+.form-control-feedback,.input-group-lg>.form-control+.form-control-feedback,.input-group-lg>.input-group-addon+.form-control-feedback,.input-group-lg>.input-group-btn>.btn+.form-control-feedback,.input-lg+.form-control-feedback{width:46px;height:46px;line-height:46px}.form-group-sm .form-control+.form-control-feedback,.input-group-sm+.form-control-feedback,.input-group-sm>.form-control+.form-control-feedback,.input-group-sm>.input-group-addon+.form-control-feedback,.input-group-sm>.input-group-btn>.btn+.form-control-feedback,.input-sm+.form-control-feedback{width:30px;height:30px;line-height:30px}.has-success .checkbox,.has-success .checkbox-inline,.has-success.checkbox-inline label,.has-success.checkbox label,.has-success .control-label,.has-success .help-block,.has-success .radio,.has-success .radio-inline,.has-success.radio-inline label,.has-success.radio label{color:#3c763d}.has-success .form-control{border-color:#3c763d;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-success .form-control:focus{border-color:#2b542c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-success .input-group-addon{color:#3c763d;border-color:#3c763d;background-color:#dff0d8}.has-success .form-control-feedback{color:#3c763d}.has-warning .checkbox,.has-warning .checkbox-inline,.has-warning.checkbox-inline label,.has-warning.checkbox label,.has-warning .control-label,.has-warning .help-block,.has-warning .radio,.has-warning .radio-inline,.has-warning.radio-inline label,.has-warning.radio label{color:#8a6d3b}.has-warning .form-control{border-color:#8a6d3b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-warning .form-control:focus{border-color:#66512c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}.has-warning .input-group-addon{color:#8a6d3b;border-color:#8a6d3b;background-color:#fcf8e3}.has-warning .form-control-feedback{color:#8a6d3b}.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.radio-inline label,.has-error.radio label{color:#a94442}.has-error .form-control{border-color:#a94442;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-error .form-control:focus{border-color:#843534;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-error .input-group-addon{color:#a94442;border-color:#a94442;background-color:#f2dede}.has-error .form-control-feedback{color:#a94442}.has-feedback label~.form-control-feedback{top:25px}.has-feedback label.sr-only~.form-control-feedback{top:0}.help-block{display:block;margin-top:5px;margin-bottom:10px;color:#737373}@media (min-width:768px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .form-control,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn{width:auto}.form-inline .input-group>.form-control{width:100%}.form-inline .control-label{margin-bottom:0;vertical-align:middle}.form-inline .checkbox,.form-inline .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.form-inline .checkbox label,.form-inline .radio label{padding-left:0}.form-inline .checkbox input[type=checkbox],.form-inline .radio input[type=radio]{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{margin-top:0;margin-bottom:0;padding-top:7px}.form-horizontal .checkbox,.form-horizontal .radio{min-height:27px}.form-horizontal .form-group{margin-left:-15px;margin-right:-15px}.form-horizontal .form-group:after,.form-horizontal .form-group:before{content:\" \";display:table}.form-horizontal .form-group:after{clear:both}@media (min-width:768px){.form-horizontal .control-label{text-align:right;margin-bottom:0;padding-top:7px}}.form-horizontal .has-feedback .form-control-feedback{right:15px}@media (min-width:768px){.form-horizontal .form-group-lg .control-label{padding-top:11px;font-size:18px}}@media (min-width:768px){.form-horizontal .form-group-sm .control-label{padding-top:6px;font-size:12px}}.btn{display:inline-block;margin-bottom:0;font-weight:400;text-align:center;vertical-align:middle;touch-action:manipulation;cursor:pointer;background-image:none;border:1px solid transparent;white-space:nowrap;padding:6px 12px;font-size:14px;line-height:1.428571429;border-radius:4px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{color:#333;text-decoration:none}.btn.active,.btn:active{outline:0;background-image:none;box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn.disabled,.btn[disabled],fieldset[disabled] .btn{cursor:not-allowed;opacity:.65;filter:alpha(opacity=65);box-shadow:none}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-default{color:#333;background-color:#fff;border-color:#ccc}.btn-default.focus,.btn-default:focus{color:#333;background-color:#e6e6e6;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.btn-default:hover,.open>.btn-default.dropdown-toggle{color:#333;background-color:#e6e6e6;border-color:#adadad}.btn-default.active.focus,.btn-default.active:focus,.btn-default.active:hover,.btn-default:active.focus,.btn-default:active:focus,.btn-default:active:hover,.open>.btn-default.dropdown-toggle.focus,.open>.btn-default.dropdown-toggle:focus,.open>.btn-default.dropdown-toggle:hover{color:#333;background-color:#d4d4d4;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.open>.btn-default.dropdown-toggle{background-image:none}.btn-default.disabled.focus,.btn-default.disabled:focus,.btn-default.disabled:hover,.btn-default[disabled].focus,.btn-default[disabled]:focus,.btn-default[disabled]:hover,fieldset[disabled] .btn-default.focus,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default:hover{background-color:#fff;border-color:#ccc}.btn-default .badge{color:#fff;background-color:#333}.btn-primary{color:#fff;background-color:#337ab7;border-color:#2e6da4}.btn-primary.focus,.btn-primary:focus{color:#fff;background-color:#286090;border-color:#122b40}.btn-primary.active,.btn-primary:active,.btn-primary:hover,.open>.btn-primary.dropdown-toggle{color:#fff;background-color:#286090;border-color:#204d74}.btn-primary.active.focus,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active.focus,.btn-primary:active:focus,.btn-primary:active:hover,.open>.btn-primary.dropdown-toggle.focus,.open>.btn-primary.dropdown-toggle:focus,.open>.btn-primary.dropdown-toggle:hover{color:#fff;background-color:#204d74;border-color:#122b40}.btn-primary.active,.btn-primary:active,.open>.btn-primary.dropdown-toggle{background-image:none}.btn-primary.disabled.focus,.btn-primary.disabled:focus,.btn-primary.disabled:hover,.btn-primary[disabled].focus,.btn-primary[disabled]:focus,.btn-primary[disabled]:hover,fieldset[disabled] .btn-primary.focus,fieldset[disabled] .btn-primary:focus,fieldset[disabled] .btn-primary:hover{background-color:#337ab7;border-color:#2e6da4}.btn-primary .badge{color:#337ab7;background-color:#fff}.btn-success{color:#fff;background-color:#5cb85c;border-color:#4cae4c}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#449d44;border-color:#255625}.btn-success.active,.btn-success:active,.btn-success:hover,.open>.btn-success.dropdown-toggle{color:#fff;background-color:#449d44;border-color:#398439}.btn-success.active.focus,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active.focus,.btn-success:active:focus,.btn-success:active:hover,.open>.btn-success.dropdown-toggle.focus,.open>.btn-success.dropdown-toggle:focus,.open>.btn-success.dropdown-toggle:hover{color:#fff;background-color:#398439;border-color:#255625}.btn-success.active,.btn-success:active,.open>.btn-success.dropdown-toggle{background-image:none}.btn-success.disabled.focus,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success[disabled].focus,.btn-success[disabled]:focus,.btn-success[disabled]:hover,fieldset[disabled] .btn-success.focus,fieldset[disabled] .btn-success:focus,fieldset[disabled] .btn-success:hover{background-color:#5cb85c;border-color:#4cae4c}.btn-success .badge{color:#5cb85c;background-color:#fff}.btn-info{color:#fff;background-color:#5bc0de;border-color:#46b8da}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#31b0d5;border-color:#1b6d85}.btn-info.active,.btn-info:active,.btn-info:hover,.open>.btn-info.dropdown-toggle{color:#fff;background-color:#31b0d5;border-color:#269abc}.btn-info.active.focus,.btn-info.active:focus,.btn-info.active:hover,.btn-info:active.focus,.btn-info:active:focus,.btn-info:active:hover,.open>.btn-info.dropdown-toggle.focus,.open>.btn-info.dropdown-toggle:focus,.open>.btn-info.dropdown-toggle:hover{color:#fff;background-color:#269abc;border-color:#1b6d85}.btn-info.active,.btn-info:active,.open>.btn-info.dropdown-toggle{background-image:none}.btn-info.disabled.focus,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info[disabled].focus,.btn-info[disabled]:focus,.btn-info[disabled]:hover,fieldset[disabled] .btn-info.focus,fieldset[disabled] .btn-info:focus,fieldset[disabled] .btn-info:hover{background-color:#5bc0de;border-color:#46b8da}.btn-info .badge{color:#5bc0de;background-color:#fff}.btn-warning{color:#fff;background-color:#f0ad4e;border-color:#eea236}.btn-warning.focus,.btn-warning:focus{color:#fff;background-color:#ec971f;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.btn-warning:hover,.open>.btn-warning.dropdown-toggle{color:#fff;background-color:#ec971f;border-color:#d58512}.btn-warning.active.focus,.btn-warning.active:focus,.btn-warning.active:hover,.btn-warning:active.focus,.btn-warning:active:focus,.btn-warning:active:hover,.open>.btn-warning.dropdown-toggle.focus,.open>.btn-warning.dropdown-toggle:focus,.open>.btn-warning.dropdown-toggle:hover{color:#fff;background-color:#d58512;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.open>.btn-warning.dropdown-toggle{background-image:none}.btn-warning.disabled.focus,.btn-warning.disabled:focus,.btn-warning.disabled:hover,.btn-warning[disabled].focus,.btn-warning[disabled]:focus,.btn-warning[disabled]:hover,fieldset[disabled] .btn-warning.focus,fieldset[disabled] .btn-warning:focus,fieldset[disabled] .btn-warning:hover{background-color:#f0ad4e;border-color:#eea236}.btn-warning .badge{color:#f0ad4e;background-color:#fff}.btn-danger{color:#fff;background-color:#bd0e38;border-color:#a50c31}.btn-danger.focus,.btn-danger:focus{color:#fff;background-color:#8e0a2a;border-color:#2f030e}.btn-danger.active,.btn-danger:active,.btn-danger:hover,.open>.btn-danger.dropdown-toggle{color:#fff;background-color:#8e0a2a;border-color:#6c0820}.btn-danger.active.focus,.btn-danger.active:focus,.btn-danger.active:hover,.btn-danger:active.focus,.btn-danger:active:focus,.btn-danger:active:hover,.open>.btn-danger.dropdown-toggle.focus,.open>.btn-danger.dropdown-toggle:focus,.open>.btn-danger.dropdown-toggle:hover{color:#fff;background-color:#6c0820;border-color:#2f030e}.btn-danger.active,.btn-danger:active,.open>.btn-danger.dropdown-toggle{background-image:none}.btn-danger.disabled.focus,.btn-danger.disabled:focus,.btn-danger.disabled:hover,.btn-danger[disabled].focus,.btn-danger[disabled]:focus,.btn-danger[disabled]:hover,fieldset[disabled] .btn-danger.focus,fieldset[disabled] .btn-danger:focus,fieldset[disabled] .btn-danger:hover{background-color:#bd0e38;border-color:#a50c31}.btn-danger .badge{color:#bd0e38;background-color:#fff}.btn-link{color:#337ab7;font-weight:400;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link[disabled],fieldset[disabled] .btn-link{background-color:transparent;box-shadow:none}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#23527c;text-decoration:underline;background-color:transparent}.btn-link[disabled]:focus,.btn-link[disabled]:hover,fieldset[disabled] .btn-link:focus,fieldset[disabled] .btn-link:hover{color:#777;text-decoration:none}.btn-group-lg>.btn,.btn-lg{padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.btn-group-sm>.btn,.btn-sm{padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.btn-group-xs>.btn,.btn-xs{padding:1px 5px;font-size:12px;line-height:1.5;border-radius:3px}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:5px}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;transition:opacity .15s linear}.fade.in{opacity:1}.collapse{display:none}.collapse.in{display:block}tr.collapse.in{display:table-row}tbody.collapse.in{display:table-row-group}.collapsing{position:relative;height:0;overflow:hidden;transition-property:height,visibility;transition-duration:.35s;transition-timing-function:ease}.caret{display:inline-block;width:0;height:0;margin-left:2px;vertical-align:middle;border-top:4px dashed;border-top:4px solid\\9;border-right:4px solid transparent;border-left:4px solid transparent}.dropdown,.dropup{position:relative}.dropdown-toggle:focus{outline:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;list-style:none;font-size:14px;text-align:left;background-color:#fff;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;box-shadow:0 6px 12px rgba(0,0,0,.175);background-clip:padding-box}.dropdown-menu.pull-right{right:0;left:auto}.dropdown-menu .divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.dropdown-menu>li>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.428571429;color:#333;white-space:nowrap}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{text-decoration:none;color:#262626;background-color:#f5f5f5}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover{color:#fff;text-decoration:none;outline:0;background-color:#337ab7}.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{color:#777}.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{text-decoration:none;background-color:transparent;background-image:none;filter:progid:DXImageTransform.Microsoft.gradient(enabled = false);cursor:not-allowed}.open>.dropdown-menu{display:block}.open>a{outline:0}.dropdown-menu-right{left:auto;right:0}.dropdown-menu-left{left:0;right:auto}.dropdown-header{display:block;padding:3px 20px;font-size:12px;line-height:1.428571429;color:#777;white-space:nowrap}.dropdown-backdrop{position:fixed;left:0;right:0;bottom:0;top:0;z-index:990}.pull-right>.dropdown-menu{right:0;left:auto}.dropup .caret,.navbar-fixed-bottom .dropdown .caret{border-top:0;border-bottom:4px dashed;border-bottom:4px solid\\9;content:\"\"}.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:2px}@media (min-width:768px){.navbar-right .dropdown-menu{right:0;left:auto}.navbar-right .dropdown-menu-left{left:0;right:auto}}.btn-group,.btn-group-vertical{position:relative;display:inline-block;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;float:left}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:2}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{margin-left:-5px}.btn-toolbar:after,.btn-toolbar:before{content:\" \";display:table}.btn-toolbar:after{clear:both}.btn-toolbar .btn,.btn-toolbar .btn-group,.btn-toolbar .input-group{float:left}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group{margin-left:5px}.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0}.btn-group>.btn-group{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child{border-bottom-left-radius:0;border-top-left-radius:0}.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0}.btn-group>.btn+.dropdown-toggle{padding-left:8px;padding-right:8px}.btn-group-lg.btn-group>.btn+.dropdown-toggle,.btn-group>.btn-lg+.dropdown-toggle{padding-left:12px;padding-right:12px}.btn-group.open .dropdown-toggle{box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.open .dropdown-toggle.btn-link{box-shadow:none}.btn .caret{margin-left:0}.btn-group-lg>.btn .caret,.btn-lg .caret{border-width:5px 5px 0;border-bottom-width:0}.dropup .btn-group-lg>.btn .caret,.dropup .btn-lg .caret{border-width:0 5px 5px}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn{display:block;float:none;width:100%;max-width:100%}.btn-group-vertical>.btn-group:after,.btn-group-vertical>.btn-group:before{content:\" \";display:table}.btn-group-vertical>.btn-group:after{clear:both}.btn-group-vertical>.btn-group>.btn{float:none}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.btn:first-child:not(:last-child){border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn:last-child:not(:first-child){border-top-right-radius:0;border-top-left-radius:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-right-radius:0;border-top-left-radius:0}.btn-group-justified{display:table;width:100%;table-layout:fixed;border-collapse:separate}.btn-group-justified>.btn,.btn-group-justified>.btn-group{float:none;display:table-cell;width:1%}.btn-group-justified>.btn-group .btn{width:100%}.btn-group-justified>.btn-group .dropdown-menu{left:auto}[data-toggle=buttons]>.btn-group>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:table;border-collapse:separate}.input-group[class*=col-]{float:none;padding-left:0;padding-right:0}.input-group .form-control{position:relative;z-index:2;float:left;width:100%;margin-bottom:0}.input-group .form-control:focus{z-index:3}.input-group-addon,.input-group-btn,.input-group .form-control{display:table-cell}.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child){border-radius:0}.input-group-addon,.input-group-btn{width:1%;white-space:nowrap;vertical-align:middle}.input-group-addon{padding:6px 12px;font-size:14px;font-weight:400;line-height:1;color:#555;text-align:center;background-color:#eee;border:1px solid #ccc;border-radius:4px}.input-group-addon.input-sm,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.input-group-addon.btn{padding:5px 10px;font-size:12px;border-radius:3px}.input-group-addon.input-lg,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.input-group-addon.btn{padding:10px 16px;font-size:18px;border-radius:6px}.input-group-addon input[type=checkbox],.input-group-addon input[type=radio]{margin-top:0}.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group .form-control:first-child{border-bottom-right-radius:0;border-top-right-radius:0}.input-group-addon:first-child{border-right:0}.input-group-addon:last-child,.input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle,.input-group .form-control:last-child{border-bottom-left-radius:0;border-top-left-radius:0}.input-group-addon:last-child{border-left:0}.input-group-btn{font-size:0;white-space:nowrap}.input-group-btn,.input-group-btn>.btn{position:relative}.input-group-btn>.btn+.btn{margin-left:-1px}.input-group-btn>.btn:active,.input-group-btn>.btn:focus,.input-group-btn>.btn:hover{z-index:2}.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group{margin-right:-1px}.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group{z-index:2;margin-left:-1px}.nav{margin-bottom:0;padding-left:0;list-style:none}.nav:after,.nav:before{content:\" \";display:table}.nav:after{clear:both}.nav>li,.nav>li>a{position:relative;display:block}.nav>li>a{padding:10px 15px}.nav>li>a:focus,.nav>li>a:hover{text-decoration:none;background-color:#eee}.nav>li.disabled>a{color:#777}.nav>li.disabled>a:focus,.nav>li.disabled>a:hover{color:#777;text-decoration:none;background-color:transparent;cursor:not-allowed}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:#eee;border-color:#337ab7}.nav .nav-divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.nav>li>a>img{max-width:none}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs>li{float:left;margin-bottom:-1px}.nav-tabs>li>a{margin-right:2px;line-height:1.428571429;border:1px solid transparent;border-radius:4px 4px 0 0}.nav-tabs>li>a:hover{border-color:#eee #eee #ddd}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{color:#555;background-color:#fff;border:1px solid #ddd;border-bottom-color:transparent;cursor:default}.nav-pills>li{float:left}.nav-pills>li>a{border-radius:4px}.nav-pills>li+li{margin-left:2px}.nav-pills>li.active>a,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{color:#fff;background-color:#337ab7}.nav-stacked>li{float:none}.nav-stacked>li+li{margin-top:2px;margin-left:0}.nav-justified,.nav-tabs.nav-justified{width:100%}.nav-justified>li,.nav-tabs.nav-justified>li{float:none}.nav-justified>li>a,.nav-tabs.nav-justified>li>a{text-align:center;margin-bottom:5px}.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-justified>li,.nav-tabs.nav-justified>li{display:table-cell;width:1%}.nav-justified>li>a,.nav-tabs.nav-justified>li>a{margin-bottom:0}}.nav-tabs-justified,.nav-tabs.nav-justified{border-bottom:0}.nav-tabs-justified>li>a,.nav-tabs.nav-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover,.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs-justified>li>a,.nav-tabs.nav-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover,.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border-bottom-color:#fff}}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-right-radius:0;border-top-left-radius:0}.navbar{position:relative;min-height:50px;margin-bottom:20px;border:1px solid transparent}.navbar:after,.navbar:before{content:\" \";display:table}.navbar:after{clear:both}@media (min-width:768px){.navbar{border-radius:4px}}.navbar-header:after,.navbar-header:before{content:\" \";display:table}.navbar-header:after{clear:both}@media (min-width:768px){.navbar-header{float:left}}.navbar-collapse{overflow-x:visible;padding-right:15px;padding-left:15px;border-top:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1);-webkit-overflow-scrolling:touch}.navbar-collapse:after,.navbar-collapse:before{content:\" \";display:table}.navbar-collapse:after{clear:both}.navbar-collapse.in{overflow-y:auto}@media (min-width:768px){.navbar-collapse{width:auto;border-top:0;box-shadow:none}.navbar-collapse.collapse{display:block!important;height:auto!important;padding-bottom:0;overflow:visible!important}.navbar-collapse.in{overflow-y:visible}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse,.navbar-static-top .navbar-collapse{padding-left:0;padding-right:0}}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:340px}@media (max-device-width:480px) and (orientation:landscape){.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:200px}}.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:0;margin-left:0}}.navbar-static-top{z-index:1000;border-width:0 0 1px}@media (min-width:768px){.navbar-static-top{border-radius:0}}.navbar-fixed-bottom,.navbar-fixed-top{position:fixed;right:0;left:0;z-index:1030}@media (min-width:768px){.navbar-fixed-bottom,.navbar-fixed-top{border-radius:0}}.navbar-fixed-top{top:0;border-width:0 0 1px}.navbar-fixed-bottom{bottom:0;margin-bottom:0;border-width:1px 0 0}.navbar-brand{float:left;padding:15px;font-size:18px;line-height:20px;height:50px}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-brand>img{display:block}@media (min-width:768px){.navbar>.container-fluid .navbar-brand,.navbar>.container .navbar-brand{margin-left:-15px}}.navbar-toggle{position:relative;float:right;margin-right:15px;padding:9px 10px;margin-top:8px;margin-bottom:8px;background-color:transparent;background-image:none;border:1px solid transparent;border-radius:4px}.navbar-toggle:focus{outline:0}.navbar-toggle .icon-bar{display:block;width:22px;height:2px;border-radius:1px}.navbar-toggle .icon-bar+.icon-bar{margin-top:4px}@media (min-width:768px){.navbar-toggle{display:none}}.navbar-nav{margin:7.5px -15px}.navbar-nav>li>a{padding-top:10px;padding-bottom:10px;line-height:20px}@media (max-width:767px){.navbar-nav .open .dropdown-menu{position:static;float:none;width:auto;margin-top:0;background-color:transparent;border:0;box-shadow:none}.navbar-nav .open .dropdown-menu .dropdown-header,.navbar-nav .open .dropdown-menu>li>a{padding:5px 15px 5px 25px}.navbar-nav .open .dropdown-menu>li>a{line-height:20px}.navbar-nav .open .dropdown-menu>li>a:focus,.navbar-nav .open .dropdown-menu>li>a:hover{background-image:none}}@media (min-width:768px){.navbar-nav{float:left;margin:0}.navbar-nav>li{float:left}.navbar-nav>li>a{padding-top:15px;padding-bottom:15px}}.navbar-form{margin:8px -15px;padding:10px 15px;border-top:1px solid transparent;border-bottom:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1)}@media (min-width:768px){.navbar-form .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.navbar-form .form-control{display:inline-block;width:auto;vertical-align:middle}.navbar-form .form-control-static{display:inline-block}.navbar-form .input-group{display:inline-table;vertical-align:middle}.navbar-form .input-group .form-control,.navbar-form .input-group .input-group-addon,.navbar-form .input-group .input-group-btn{width:auto}.navbar-form .input-group>.form-control{width:100%}.navbar-form .control-label{margin-bottom:0;vertical-align:middle}.navbar-form .checkbox,.navbar-form .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.navbar-form .checkbox label,.navbar-form .radio label{padding-left:0}.navbar-form .checkbox input[type=checkbox],.navbar-form .radio input[type=radio]{position:relative;margin-left:0}.navbar-form .has-feedback .form-control-feedback{top:0}}@media (max-width:767px){.navbar-form .form-group{margin-bottom:5px}.navbar-form .form-group:last-child{margin-bottom:0}}@media (min-width:768px){.navbar-form{width:auto;border:0;margin-left:0;margin-right:0;padding-top:0;padding-bottom:0;box-shadow:none}}.navbar-nav>li>.dropdown-menu{margin-top:0;border-top-right-radius:0;border-top-left-radius:0}.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu{margin-bottom:0;border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.navbar-btn{margin-top:8px;margin-bottom:8px}.btn-group-sm>.navbar-btn.btn,.navbar-btn.btn-sm{margin-top:10px;margin-bottom:10px}.btn-group-xs>.navbar-btn.btn,.navbar-btn.btn-xs{margin-top:14px;margin-bottom:14px}.navbar-text{margin-top:15px;margin-bottom:15px}@media (min-width:768px){.navbar-text{float:left;margin-left:15px;margin-right:15px}}@media (min-width:768px){.navbar-left{float:left!important}.navbar-right{float:right!important;margin-right:-15px}.navbar-right~.navbar-right{margin-right:0}}.navbar-default{background-color:#f8f8f8;border-color:#e7e7e7}.navbar-default .navbar-brand{color:#777}.navbar-default .navbar-brand:focus,.navbar-default .navbar-brand:hover{color:#5e5e5e;background-color:transparent}.navbar-default .navbar-nav>li>a,.navbar-default .navbar-text{color:#777}.navbar-default .navbar-nav>li>a:focus,.navbar-default .navbar-nav>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:focus,.navbar-default .navbar-nav>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav>.disabled>a,.navbar-default .navbar-nav>.disabled>a:focus,.navbar-default .navbar-nav>.disabled>a:hover{color:#ccc;background-color:transparent}.navbar-default .navbar-toggle{border-color:#ddd}.navbar-default .navbar-toggle:focus,.navbar-default .navbar-toggle:hover{background-color:#ddd}.navbar-default .navbar-toggle .icon-bar{background-color:#888}.navbar-default .navbar-collapse,.navbar-default .navbar-form{border-color:#e7e7e7}.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:focus,.navbar-default .navbar-nav>.open>a:hover{background-color:#e7e7e7;color:#555}@media (max-width:767px){.navbar-default .navbar-nav .open .dropdown-menu>li>a{color:#777}.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#ccc;background-color:transparent}}.navbar-default .navbar-link{color:#777}.navbar-default .navbar-link:hover{color:#333}.navbar-default .btn-link{color:#777}.navbar-default .btn-link:focus,.navbar-default .btn-link:hover{color:#333}.navbar-default .btn-link[disabled]:focus,.navbar-default .btn-link[disabled]:hover,fieldset[disabled] .navbar-default .btn-link:focus,fieldset[disabled] .navbar-default .btn-link:hover{color:#ccc}.navbar-inverse{background-color:#222;border-color:#090909}.navbar-inverse .navbar-brand{color:#9d9d9d}.navbar-inverse .navbar-brand:focus,.navbar-inverse .navbar-brand:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>li>a,.navbar-inverse .navbar-text{color:#9d9d9d}.navbar-inverse .navbar-nav>li>a:focus,.navbar-inverse .navbar-nav>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.active>a:focus,.navbar-inverse .navbar-nav>.active>a:hover{color:#fff;background-color:#090909}.navbar-inverse .navbar-nav>.disabled>a,.navbar-inverse .navbar-nav>.disabled>a:focus,.navbar-inverse .navbar-nav>.disabled>a:hover{color:#444;background-color:transparent}.navbar-inverse .navbar-toggle{border-color:#333}.navbar-inverse .navbar-toggle:focus,.navbar-inverse .navbar-toggle:hover{background-color:#333}.navbar-inverse .navbar-toggle .icon-bar{background-color:#fff}.navbar-inverse .navbar-collapse,.navbar-inverse .navbar-form{border-color:#101010}.navbar-inverse .navbar-nav>.open>a,.navbar-inverse .navbar-nav>.open>a:focus,.navbar-inverse .navbar-nav>.open>a:hover{background-color:#090909;color:#fff}@media (max-width:767px){.navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header{border-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu .divider{background-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a{color:#9d9d9d}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover{color:#fff;background-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#444;background-color:transparent}}.navbar-inverse .navbar-link{color:#9d9d9d}.navbar-inverse .navbar-link:hover{color:#fff}.navbar-inverse .btn-link{color:#9d9d9d}.navbar-inverse .btn-link:focus,.navbar-inverse .btn-link:hover{color:#fff}.navbar-inverse .btn-link[disabled]:focus,.navbar-inverse .btn-link[disabled]:hover,fieldset[disabled] .navbar-inverse .btn-link:focus,fieldset[disabled] .navbar-inverse .btn-link:hover{color:#444}.breadcrumb{padding:8px 15px;margin-bottom:20px;list-style:none;background-color:#f5f5f5;border-radius:4px}.breadcrumb>li{display:inline-block}.breadcrumb>li+li:before{content:\"/\\A0\";padding:0 5px;color:#ccc}.breadcrumb>.active{color:#777}.pagination{display:inline-block;padding-left:0;margin:20px 0;border-radius:4px}.pagination>li{display:inline}.pagination>li>a,.pagination>li>span{position:relative;float:left;padding:6px 12px;line-height:1.428571429;text-decoration:none;color:#337ab7;background-color:#fff;border:1px solid #ddd;margin-left:-1px}.pagination>li:first-child>a,.pagination>li:first-child>span{margin-left:0;border-bottom-left-radius:4px;border-top-left-radius:4px}.pagination>li:last-child>a,.pagination>li:last-child>span{border-bottom-right-radius:4px;border-top-right-radius:4px}.pagination>li>a:focus,.pagination>li>a:hover,.pagination>li>span:focus,.pagination>li>span:hover{z-index:2;color:#23527c;background-color:#eee;border-color:#ddd}.pagination>.active>a,.pagination>.active>a:focus,.pagination>.active>a:hover,.pagination>.active>span,.pagination>.active>span:focus,.pagination>.active>span:hover{z-index:3;color:#fff;background-color:#337ab7;border-color:#337ab7;cursor:default}.pagination>.disabled>a,.pagination>.disabled>a:focus,.pagination>.disabled>a:hover,.pagination>.disabled>span,.pagination>.disabled>span:focus,.pagination>.disabled>span:hover{color:#777;background-color:#fff;border-color:#ddd;cursor:not-allowed}.pagination-lg>li>a,.pagination-lg>li>span{padding:10px 16px;font-size:18px;line-height:1.3333333}.pagination-lg>li:first-child>a,.pagination-lg>li:first-child>span{border-bottom-left-radius:6px;border-top-left-radius:6px}.pagination-lg>li:last-child>a,.pagination-lg>li:last-child>span{border-bottom-right-radius:6px;border-top-right-radius:6px}.pagination-sm>li>a,.pagination-sm>li>span{padding:5px 10px;font-size:12px;line-height:1.5}.pagination-sm>li:first-child>a,.pagination-sm>li:first-child>span{border-bottom-left-radius:3px;border-top-left-radius:3px}.pagination-sm>li:last-child>a,.pagination-sm>li:last-child>span{border-bottom-right-radius:3px;border-top-right-radius:3px}.pager{padding-left:0;margin:20px 0;list-style:none;text-align:center}.pager:after,.pager:before{content:\" \";display:table}.pager:after{clear:both}.pager li{display:inline}.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:#fff;border:1px solid #ddd;border-radius:15px}.pager li>a:focus,.pager li>a:hover{text-decoration:none;background-color:#eee}.pager .next>a,.pager .next>span{float:right}.pager .previous>a,.pager .previous>span{float:left}.pager .disabled>a,.pager .disabled>a:focus,.pager .disabled>a:hover,.pager .disabled>span{color:#777;background-color:#fff;cursor:not-allowed}.label{display:inline;padding:.2em .6em .3em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em}.label:empty{display:none}.btn .label{position:relative;top:-1px}a.label:focus,a.label:hover{color:#fff;text-decoration:none;cursor:pointer}.label-default{background-color:#777}.label-default[href]:focus,.label-default[href]:hover{background-color:#5e5e5e}.label-primary{background-color:#337ab7}.label-primary[href]:focus,.label-primary[href]:hover{background-color:#286090}.label-success{background-color:#5cb85c}.label-success[href]:focus,.label-success[href]:hover{background-color:#449d44}.label-info{background-color:#5bc0de}.label-info[href]:focus,.label-info[href]:hover{background-color:#31b0d5}.label-warning{background-color:#f0ad4e}.label-warning[href]:focus,.label-warning[href]:hover{background-color:#ec971f}.label-danger{background-color:#bd0e38}.label-danger[href]:focus,.label-danger[href]:hover{background-color:#8e0a2a}.badge{display:inline-block;min-width:10px;padding:3px 7px;font-size:12px;font-weight:700;color:#fff;line-height:1;vertical-align:middle;white-space:nowrap;text-align:center;background-color:#777;border-radius:10px}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.btn-group-xs>.btn .badge,.btn-xs .badge{top:0;padding:1px 5px}.list-group-item.active>.badge,.nav-pills>.active>a>.badge{color:#337ab7;background-color:#fff}.list-group-item>.badge{float:right}.list-group-item>.badge+.badge{margin-right:5px}.nav-pills>li>a>.badge{margin-left:3px}a.badge:focus,a.badge:hover{color:#fff;text-decoration:none;cursor:pointer}.jumbotron{padding-top:30px;padding-bottom:30px;margin-bottom:30px;background-color:#eee}.jumbotron,.jumbotron .h1,.jumbotron h1{color:inherit}.jumbotron p{margin-bottom:15px;font-size:21px;font-weight:200}.jumbotron>hr{border-top-color:#d5d5d5}.container-fluid .jumbotron,.container .jumbotron{border-radius:6px;padding-left:15px;padding-right:15px}.jumbotron .container{max-width:100%}@media screen and (min-width:768px){.jumbotron{padding-top:48px;padding-bottom:48px}.container-fluid .jumbotron,.container .jumbotron{padding-left:60px;padding-right:60px}.jumbotron .h1,.jumbotron h1{font-size:63px}}.thumbnail{display:block;padding:4px;margin-bottom:20px;line-height:1.428571429;background-color:#fff;border:1px solid #ddd;border-radius:4px;transition:border .2s ease-in-out}.thumbnail>img,.thumbnail a>img{display:block;max-width:100%;height:auto;margin-left:auto;margin-right:auto}.thumbnail .caption{padding:9px;color:#333}a.thumbnail.active,a.thumbnail:focus,a.thumbnail:hover{border-color:#337ab7}.alert{padding:15px;margin-bottom:20px;border:1px solid transparent;border-radius:4px}.alert h4{margin-top:0;color:inherit}.alert .alert-link{font-weight:700}.alert>p,.alert>ul{margin-bottom:0}.alert>p+p{margin-top:5px}.alert-dismissable,.alert-dismissible{padding-right:35px}.alert-dismissable .close,.alert-dismissible .close{position:relative;top:-2px;right:-21px;color:inherit}.alert-success{background-color:#dff0d8;border-color:#d6e9c6;color:#3c763d}.alert-success hr{border-top-color:#c9e2b3}.alert-success .alert-link{color:#2b542c}.alert-info{background-color:#d9edf7;border-color:#bce8f1;color:#31708f}.alert-info hr{border-top-color:#a6e1ec}.alert-info .alert-link{color:#245269}.alert-warning{background-color:#fcf8e3;border-color:#faebcc;color:#8a6d3b}.alert-warning hr{border-top-color:#f7e1b5}.alert-warning .alert-link{color:#66512c}.alert-danger{background-color:#f2dede;border-color:#ebccd1;color:#a94442}.alert-danger hr{border-top-color:#e4b9c0}.alert-danger .alert-link{color:#843534}@-webkit-keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}@keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}.progress{overflow:hidden;height:20px;margin-bottom:20px;background-color:#f5f5f5;border-radius:4px;box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress-bar{float:left;width:0;height:100%;font-size:12px;line-height:20px;color:#fff;text-align:center;background-color:#337ab7;box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);transition:width .6s ease}.progress-bar-striped,.progress-striped .progress-bar{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{-webkit-animation:progress-bar-stripes 2s linear infinite;animation:progress-bar-stripes 2s linear infinite}.progress-bar-success{background-color:#5cb85c}.progress-striped .progress-bar-success{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-info{background-color:#5bc0de}.progress-striped .progress-bar-info{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-warning{background-color:#f0ad4e}.progress-striped .progress-bar-warning{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-danger{background-color:#bd0e38}.progress-striped .progress-bar-danger{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.media{margin-top:15px}.media:first-child{margin-top:0}.media,.media-body{zoom:1;overflow:hidden}.media-body{width:10000px}.media-object{display:block}.media-object.img-thumbnail{max-width:none}.media-right,.media>.pull-right{padding-left:10px}.media-left,.media>.pull-left{padding-right:10px}.media-body,.media-left,.media-right{display:table-cell;vertical-align:top}.media-middle{vertical-align:middle}.media-bottom{vertical-align:bottom}.media-heading{margin-top:0;margin-bottom:5px}.media-list{padding-left:0;list-style:none}.list-group{margin-bottom:20px;padding-left:0}.list-group-item{position:relative;display:block;padding:10px 15px;margin-bottom:-1px;background-color:#fff;border:1px solid #ddd}.list-group-item:first-child{border-top-right-radius:4px;border-top-left-radius:4px}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}a.list-group-item,button.list-group-item{color:#555}a.list-group-item .list-group-item-heading,button.list-group-item .list-group-item-heading{color:#333}a.list-group-item:focus,a.list-group-item:hover,button.list-group-item:focus,button.list-group-item:hover{text-decoration:none;color:#555;background-color:#f5f5f5}button.list-group-item{width:100%;text-align:left}.list-group-item.disabled,.list-group-item.disabled:focus,.list-group-item.disabled:hover{background-color:#eee;color:#777;cursor:not-allowed}.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading{color:inherit}.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text{color:#777}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{z-index:2;color:#fff;background-color:#337ab7;border-color:#337ab7}.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading>small{color:inherit}.list-group-item.active .list-group-item-text,.list-group-item.active:focus .list-group-item-text,.list-group-item.active:hover .list-group-item-text{color:#c7ddef}.list-group-item-success{color:#3c763d;background-color:#dff0d8}a.list-group-item-success,button.list-group-item-success{color:#3c763d}a.list-group-item-success .list-group-item-heading,button.list-group-item-success .list-group-item-heading{color:inherit}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#3c763d;background-color:#d0e9c6}a.list-group-item-success.active,a.list-group-item-success.active:focus,a.list-group-item-success.active:hover,button.list-group-item-success.active,button.list-group-item-success.active:focus,button.list-group-item-success.active:hover{color:#fff;background-color:#3c763d;border-color:#3c763d}.list-group-item-info{color:#31708f;background-color:#d9edf7}a.list-group-item-info,button.list-group-item-info{color:#31708f}a.list-group-item-info .list-group-item-heading,button.list-group-item-info .list-group-item-heading{color:inherit}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#31708f;background-color:#c4e3f3}a.list-group-item-info.active,a.list-group-item-info.active:focus,a.list-group-item-info.active:hover,button.list-group-item-info.active,button.list-group-item-info.active:focus,button.list-group-item-info.active:hover{color:#fff;background-color:#31708f;border-color:#31708f}.list-group-item-warning{color:#8a6d3b;background-color:#fcf8e3}a.list-group-item-warning,button.list-group-item-warning{color:#8a6d3b}a.list-group-item-warning .list-group-item-heading,button.list-group-item-warning .list-group-item-heading{color:inherit}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#8a6d3b;background-color:#faf2cc}a.list-group-item-warning.active,a.list-group-item-warning.active:focus,a.list-group-item-warning.active:hover,button.list-group-item-warning.active,button.list-group-item-warning.active:focus,button.list-group-item-warning.active:hover{color:#fff;background-color:#8a6d3b;border-color:#8a6d3b}.list-group-item-danger{color:#a94442;background-color:#f2dede}a.list-group-item-danger,button.list-group-item-danger{color:#a94442}a.list-group-item-danger .list-group-item-heading,button.list-group-item-danger .list-group-item-heading{color:inherit}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#a94442;background-color:#ebcccc}a.list-group-item-danger.active,a.list-group-item-danger.active:focus,a.list-group-item-danger.active:hover,button.list-group-item-danger.active,button.list-group-item-danger.active:focus,button.list-group-item-danger.active:hover{color:#fff;background-color:#a94442;border-color:#a94442}.list-group-item-heading{margin-top:0;margin-bottom:5px}.list-group-item-text{margin-bottom:0;line-height:1.3}.panel{margin-bottom:20px;background-color:#fff;border:1px solid transparent;border-radius:4px;box-shadow:0 1px 1px rgba(0,0,0,.05)}.panel-body{padding:15px}.panel-body:after,.panel-body:before{content:\" \";display:table}.panel-body:after{clear:both}.panel-heading{padding:10px 15px;border-bottom:1px solid transparent;border-top-right-radius:3px;border-top-left-radius:3px}.panel-heading>.dropdown .dropdown-toggle,.panel-title{color:inherit}.panel-title{margin-top:0;margin-bottom:0;font-size:16px}.panel-title>.small,.panel-title>.small>a,.panel-title>a,.panel-title>small,.panel-title>small>a{color:inherit}.panel-footer{padding:10px 15px;background-color:#f5f5f5;border-top:1px solid #ddd;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.list-group,.panel>.panel-collapse>.list-group{margin-bottom:0}.panel>.list-group .list-group-item,.panel>.panel-collapse>.list-group .list-group-item{border-width:1px 0;border-radius:0}.panel>.list-group:first-child .list-group-item:first-child,.panel>.panel-collapse>.list-group:first-child .list-group-item:first-child{border-top:0;border-top-right-radius:3px;border-top-left-radius:3px}.panel>.list-group:last-child .list-group-item:last-child,.panel>.panel-collapse>.list-group:last-child .list-group-item:last-child{border-bottom:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.panel-heading+.panel-collapse>.list-group .list-group-item:first-child{border-top-right-radius:0;border-top-left-radius:0}.list-group+.panel-footer,.panel-heading+.list-group .list-group-item:first-child{border-top-width:0}.panel>.panel-collapse>.table,.panel>.table,.panel>.table-responsive>.table{margin-bottom:0}.panel>.panel-collapse>.table caption,.panel>.table-responsive>.table caption,.panel>.table caption{padding-left:15px;padding-right:15px}.panel>.table-responsive:first-child>.table:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child,.panel>.table:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child,.panel>.table:first-child>thead:first-child>tr:first-child{border-top-right-radius:3px;border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table:first-child>thead:first-child>tr:first-child th:first-child{border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table:first-child>thead:first-child>tr:first-child th:last-child{border-top-right-radius:3px}.panel>.table-responsive:last-child>.table:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child,.panel>.table:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child{border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child{border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child{border-bottom-right-radius:3px}.panel>.panel-body+.table,.panel>.panel-body+.table-responsive,.panel>.table+.panel-body,.panel>.table-responsive+.panel-body{border-top:1px solid #ddd}.panel>.table>tbody:first-child>tr:first-child td,.panel>.table>tbody:first-child>tr:first-child th{border-top:0}.panel>.table-bordered,.panel>.table-responsive>.table-bordered{border:0}.panel>.table-bordered>tbody>tr>td:first-child,.panel>.table-bordered>tbody>tr>th:first-child,.panel>.table-bordered>tfoot>tr>td:first-child,.panel>.table-bordered>tfoot>tr>th:first-child,.panel>.table-bordered>thead>tr>td:first-child,.panel>.table-bordered>thead>tr>th:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,.panel>.table-responsive>.table-bordered>thead>tr>td:first-child,.panel>.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.panel>.table-bordered>tbody>tr>td:last-child,.panel>.table-bordered>tbody>tr>th:last-child,.panel>.table-bordered>tfoot>tr>td:last-child,.panel>.table-bordered>tfoot>tr>th:last-child,.panel>.table-bordered>thead>tr>td:last-child,.panel>.table-bordered>thead>tr>th:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,.panel>.table-responsive>.table-bordered>thead>tr>td:last-child,.panel>.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.panel>.table-bordered>tbody>tr:first-child>td,.panel>.table-bordered>tbody>tr:first-child>th,.panel>.table-bordered>tbody>tr:last-child>td,.panel>.table-bordered>tbody>tr:last-child>th,.panel>.table-bordered>tfoot>tr:last-child>td,.panel>.table-bordered>tfoot>tr:last-child>th,.panel>.table-bordered>thead>tr:first-child>td,.panel>.table-bordered>thead>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>th,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th,.panel>.table-responsive>.table-bordered>thead>tr:first-child>td,.panel>.table-responsive>.table-bordered>thead>tr:first-child>th{border-bottom:0}.panel>.table-responsive{border:0;margin-bottom:0}.panel-group{margin-bottom:20px}.panel-group .panel{margin-bottom:0;border-radius:4px}.panel-group .panel+.panel{margin-top:5px}.panel-group .panel-heading{border-bottom:0}.panel-group .panel-heading+.panel-collapse>.list-group,.panel-group .panel-heading+.panel-collapse>.panel-body{border-top:1px solid #ddd}.panel-group .panel-footer{border-top:0}.panel-group .panel-footer+.panel-collapse .panel-body{border-bottom:1px solid #ddd}.panel-default{border-color:#ddd}.panel-default>.panel-heading{color:#333;background-color:#f5f5f5;border-color:#ddd}.panel-default>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ddd}.panel-default>.panel-heading .badge{color:#f5f5f5;background-color:#333}.panel-default>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ddd}.panel-primary{border-color:#337ab7}.panel-primary>.panel-heading{color:#fff;background-color:#337ab7;border-color:#337ab7}.panel-primary>.panel-heading+.panel-collapse>.panel-body{border-top-color:#337ab7}.panel-primary>.panel-heading .badge{color:#337ab7;background-color:#fff}.panel-primary>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#337ab7}.panel-success{border-color:#d6e9c6}.panel-success>.panel-heading{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.panel-success>.panel-heading+.panel-collapse>.panel-body{border-top-color:#d6e9c6}.panel-success>.panel-heading .badge{color:#dff0d8;background-color:#3c763d}.panel-success>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#d6e9c6}.panel-info{border-color:#bce8f1}.panel-info>.panel-heading{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.panel-info>.panel-heading+.panel-collapse>.panel-body{border-top-color:#bce8f1}.panel-info>.panel-heading .badge{color:#d9edf7;background-color:#31708f}.panel-info>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#bce8f1}.panel-warning{border-color:#faebcc}.panel-warning>.panel-heading{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.panel-warning>.panel-heading+.panel-collapse>.panel-body{border-top-color:#faebcc}.panel-warning>.panel-heading .badge{color:#fcf8e3;background-color:#8a6d3b}.panel-warning>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#faebcc}.panel-danger{border-color:#ebccd1}.panel-danger>.panel-heading{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.panel-danger>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ebccd1}.panel-danger>.panel-heading .badge{color:#f2dede;background-color:#a94442}.panel-danger>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ebccd1}.embed-responsive{position:relative;display:block;height:0;padding:0;overflow:hidden}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;left:0;bottom:0;height:100%;width:100%;border:0}.embed-responsive-16by9{padding-bottom:56.25%}.embed-responsive-4by3{padding-bottom:75%}.well{min-height:20px;padding:19px;margin-bottom:20px;background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.well blockquote{border-color:#ddd;border-color:rgba(0,0,0,.15)}.well-lg{padding:24px;border-radius:6px}.well-sm{padding:9px;border-radius:3px}.close{float:right;font-size:21px;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.2;filter:alpha(opacity=20)}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.5;filter:alpha(opacity=50)}button.close{padding:0;cursor:pointer;background:transparent;border:0;-webkit-appearance:none}.modal,.modal-open{overflow:hidden}.modal{display:none;position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;-webkit-overflow-scrolling:touch;outline:0}.modal.fade .modal-dialog{-webkit-transform:translateY(-25%);transform:translateY(-25%);transition:transform .3s ease-out}.modal.in .modal-dialog{-webkit-transform:translate(0);transform:translate(0)}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:10px}.modal-content{position:relative;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 3px 9px rgba(0,0,0,.5);background-clip:padding-box;outline:0}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{opacity:0;filter:alpha(opacity=0)}.modal-backdrop.in{opacity:.5;filter:alpha(opacity=50)}.modal-header{padding:15px;border-bottom:1px solid #e5e5e5}.modal-header:after,.modal-header:before{content:\" \";display:table}.modal-header:after{clear:both}.modal-header .close{margin-top:-2px}.modal-title{margin:0;line-height:1.428571429}.modal-body{position:relative;padding:15px}.modal-footer{padding:15px;text-align:right;border-top:1px solid #e5e5e5}.modal-footer:after,.modal-footer:before{content:\" \";display:table}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:768px){.modal-dialog{width:600px;margin:30px auto}.modal-content{box-shadow:0 5px 15px rgba(0,0,0,.5)}.modal-sm{width:300px}}@media (min-width:992px){.modal-lg{width:900px}}.tooltip{position:absolute;z-index:1070;display:block;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;letter-spacing:normal;line-break:auto;line-height:1.428571429;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;word-wrap:normal;font-size:12px;opacity:0;filter:alpha(opacity=0)}.tooltip.in{opacity:.9;filter:alpha(opacity=90)}.tooltip.top{margin-top:-3px;padding:5px 0}.tooltip.right{margin-left:3px;padding:0 5px}.tooltip.bottom{margin-top:3px;padding:5px 0}.tooltip.left{margin-left:-3px;padding:0 5px}.tooltip-inner{max-width:200px;padding:3px 8px;color:#fff;text-align:center;background-color:#000;border-radius:4px}.tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.tooltip.top .tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-left .tooltip-arrow{right:5px}.tooltip.top-left .tooltip-arrow,.tooltip.top-right .tooltip-arrow{bottom:0;margin-bottom:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-right .tooltip-arrow{left:5px}.tooltip.right .tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#000}.tooltip.left .tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#000}.tooltip.bottom .tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-left .tooltip-arrow{top:0;right:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-right .tooltip-arrow{top:0;left:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.popover{position:absolute;top:0;left:0;z-index:1060;display:none;max-width:276px;padding:1px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;letter-spacing:normal;line-break:auto;line-height:1.428571429;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;word-wrap:normal;font-size:14px;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 5px 10px rgba(0,0,0,.2)}.popover.top{margin-top:-10px}.popover.right{margin-left:10px}.popover.bottom{margin-top:10px}.popover.left{margin-left:-10px}.popover-title{margin:0;padding:8px 14px;font-size:14px;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-radius:5px 5px 0 0}.popover-content{padding:9px 14px}.popover>.arrow,.popover>.arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.popover>.arrow{border-width:11px}.popover>.arrow:after{border-width:10px;content:\"\"}.popover.top>.arrow{left:50%;margin-left:-11px;border-bottom-width:0;border-top-color:#999;border-top-color:rgba(0,0,0,.25);bottom:-11px}.popover.top>.arrow:after{content:\" \";bottom:1px;margin-left:-10px;border-bottom-width:0;border-top-color:#fff}.popover.right>.arrow{top:50%;left:-11px;margin-top:-11px;border-left-width:0;border-right-color:#999;border-right-color:rgba(0,0,0,.25)}.popover.right>.arrow:after{content:\" \";left:1px;bottom:-10px;border-left-width:0;border-right-color:#fff}.popover.bottom>.arrow{left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#999;border-bottom-color:rgba(0,0,0,.25);top:-11px}.popover.bottom>.arrow:after{content:\" \";top:1px;margin-left:-10px;border-top-width:0;border-bottom-color:#fff}.popover.left>.arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#999;border-left-color:rgba(0,0,0,.25)}.popover.left>.arrow:after{content:\" \";right:1px;border-right-width:0;border-left-color:#fff;bottom:-10px}.carousel,.carousel-inner{position:relative}.carousel-inner{overflow:hidden;width:100%}.carousel-inner>.item{display:none;position:relative;transition:left .6s ease-in-out}.carousel-inner>.item>a>img,.carousel-inner>.item>img{display:block;max-width:100%;height:auto;line-height:1}@media (-webkit-transform-3d),(transform-3d){.carousel-inner>.item{transition:transform .6s ease-in-out;-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-perspective:1000px;perspective:1000px}.carousel-inner>.item.active.right,.carousel-inner>.item.next{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0);left:0}.carousel-inner>.item.active.left,.carousel-inner>.item.prev{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0);left:0}.carousel-inner>.item.active,.carousel-inner>.item.next.left,.carousel-inner>.item.prev.right{-webkit-transform:translateZ(0);transform:translateZ(0);left:0}}.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev{display:block}.carousel-inner>.active{left:0}.carousel-inner>.next,.carousel-inner>.prev{position:absolute;top:0;width:100%}.carousel-inner>.next{left:100%}.carousel-inner>.prev{left:-100%}.carousel-inner>.next.left,.carousel-inner>.prev.right{left:0}.carousel-inner>.active.left{left:-100%}.carousel-inner>.active.right{left:100%}.carousel-control{position:absolute;top:0;left:0;bottom:0;width:15%;opacity:.5;filter:alpha(opacity=50);font-size:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6);background-color:transparent}.carousel-control.left{background-image:linear-gradient(90deg,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001));background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#80000000\",endColorstr=\"#00000000\",GradientType=1)}.carousel-control.right{left:auto;right:0;background-image:linear-gradient(90deg,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5));background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00000000\",endColorstr=\"#80000000\",GradientType=1)}.carousel-control:focus,.carousel-control:hover{outline:0;color:#fff;text-decoration:none;opacity:.9;filter:alpha(opacity=90)}.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{position:absolute;top:50%;margin-top:-10px;z-index:5;display:inline-block}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{left:50%;margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{right:50%;margin-right:-10px}.carousel-control .icon-next,.carousel-control .icon-prev{width:20px;height:20px;line-height:1;font-family:serif}.carousel-control .icon-prev:before{content:\"\\2039\"}.carousel-control .icon-next:before{content:\"\\203A\"}.carousel-indicators{position:absolute;bottom:10px;left:50%;z-index:15;width:60%;margin-left:-30%;padding-left:0;list-style:none;text-align:center}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:1px;text-indent:-999px;border:1px solid #fff;border-radius:10px;cursor:pointer;background-color:#000\\9;background-color:transparent}.carousel-indicators .active{margin:0;width:12px;height:12px;background-color:#fff}.carousel-caption{position:absolute;left:15%;right:15%;bottom:20px;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6)}.carousel-caption .btn{text-shadow:none}@media screen and (min-width:768px){.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{width:30px;height:30px;margin-top:-10px;font-size:30px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{margin-right:-10px}.carousel-caption{left:20%;right:20%;padding-bottom:30px}.carousel-indicators{bottom:20px}}.clearfix:after,.clearfix:before{content:\" \";display:table}.clearfix:after{clear:both}.center-block{display:block;margin-left:auto;margin-right:auto}.pull-right{float:right!important}.pull-left{float:left!important}.hide{display:none!important}.show{display:block!important}.invisible{visibility:hidden}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.hidden{display:none!important}.affix{position:fixed}@-ms-viewport{width:device-width}.visible-lg,.visible-lg-block,.visible-lg-inline,.visible-lg-inline-block,.visible-md,.visible-md-block,.visible-md-inline,.visible-md-inline-block,.visible-sm,.visible-sm-block,.visible-sm-inline,.visible-sm-inline-block,.visible-xs,.visible-xs-block,.visible-xs-inline,.visible-xs-inline-block{display:none!important}@media (max-width:767px){.visible-xs{display:block!important}table.visible-xs{display:table!important}tr.visible-xs{display:table-row!important}td.visible-xs,th.visible-xs{display:table-cell!important}}@media (max-width:767px){.visible-xs-block{display:block!important}}@media (max-width:767px){.visible-xs-inline{display:inline!important}}@media (max-width:767px){.visible-xs-inline-block{display:inline-block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm{display:block!important}table.visible-sm{display:table!important}tr.visible-sm{display:table-row!important}td.visible-sm,th.visible-sm{display:table-cell!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-block{display:block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline{display:inline!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline-block{display:inline-block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md{display:block!important}table.visible-md{display:table!important}tr.visible-md{display:table-row!important}td.visible-md,th.visible-md{display:table-cell!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-block{display:block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline{display:inline!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline-block{display:inline-block!important}}@media (min-width:1200px){.visible-lg{display:block!important}table.visible-lg{display:table!important}tr.visible-lg{display:table-row!important}td.visible-lg,th.visible-lg{display:table-cell!important}}@media (min-width:1200px){.visible-lg-block{display:block!important}}@media (min-width:1200px){.visible-lg-inline{display:inline!important}}@media (min-width:1200px){.visible-lg-inline-block{display:inline-block!important}}@media (max-width:767px){.hidden-xs{display:none!important}}@media (min-width:768px) and (max-width:991px){.hidden-sm{display:none!important}}@media (min-width:992px) and (max-width:1199px){.hidden-md{display:none!important}}@media (min-width:1200px){.hidden-lg{display:none!important}}.visible-print{display:none!important}@media print{.visible-print{display:block!important}table.visible-print{display:table!important}tr.visible-print{display:table-row!important}td.visible-print,th.visible-print{display:table-cell!important}}.visible-print-block{display:none!important}@media print{.visible-print-block{display:block!important}}.visible-print-inline{display:none!important}@media print{.visible-print-inline{display:inline!important}}.visible-print-inline-block{display:none!important}@media print{.visible-print-inline-block{display:inline-block!important}}@media print{.hidden-print{display:none!important}}/*!\n *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */@font-face{font-family:FontAwesome;src:url(\"/assets/fonts/font-awesome//fontawesome-webfont.eot?v=4.7.0\");src:url(\"/assets/fonts/font-awesome//fontawesome-webfont.eot?#iefix&v=4.7.0\") format(\"embedded-opentype\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.woff2?v=4.7.0\") format(\"woff2\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.woff?v=4.7.0\") format(\"woff\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.ttf?v=4.7.0\") format(\"truetype\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.svg?v=4.7.0#fontawesomeregular\") format(\"svg\");font-weight:400;font-style:normal}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-lg{font-size:1.3333333333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-fw{width:1.2857142857em;text-align:center}.fa-ul{padding-left:0;margin-left:2.1428571429em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.1428571429em;width:2.1428571429em;top:.1428571429em;text-align:center}.fa-li.fa-lg{left:-1.8571428571em}.fa-border{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left{margin-right:.3em}.fa.fa-pull-right{margin-left:.3em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa-spin{-webkit-animation:fa-spin 2s infinite linear;animation:fa-spin 2s infinite linear}.fa-pulse{-webkit-animation:fa-spin 1s infinite steps(8);animation:fa-spin 1s infinite steps(8)}@-webkit-keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}.fa-rotate-90{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";-webkit-transform:rotate(90deg);transform:rotate(90deg)}.fa-rotate-180{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";-webkit-transform:rotate(180deg);transform:rotate(180deg)}.fa-rotate-270{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";-webkit-transform:rotate(270deg);transform:rotate(270deg)}.fa-flip-horizontal{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";-webkit-transform:scaleX(-1);transform:scaleX(-1)}.fa-flip-vertical{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";-webkit-transform:scaleY(-1);transform:scaleY(-1)}:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270{filter:none}.fa-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;left:0;width:100%;text-align:center}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}.fa-glass:before{content:\"\\F000\"}.fa-music:before{content:\"\\F001\"}.fa-search:before{content:\"\\F002\"}.fa-envelope-o:before{content:\"\\F003\"}.fa-heart:before{content:\"\\F004\"}.fa-star:before{content:\"\\F005\"}.fa-star-o:before{content:\"\\F006\"}.fa-user:before{content:\"\\F007\"}.fa-film:before{content:\"\\F008\"}.fa-th-large:before{content:\"\\F009\"}.fa-th:before{content:\"\\F00A\"}.fa-th-list:before{content:\"\\F00B\"}.fa-check:before{content:\"\\F00C\"}.fa-close:before,.fa-remove:before,.fa-times:before{content:\"\\F00D\"}.fa-search-plus:before{content:\"\\F00E\"}.fa-search-minus:before{content:\"\\F010\"}.fa-power-off:before{content:\"\\F011\"}.fa-signal:before{content:\"\\F012\"}.fa-cog:before,.fa-gear:before{content:\"\\F013\"}.fa-trash-o:before{content:\"\\F014\"}.fa-home:before{content:\"\\F015\"}.fa-file-o:before{content:\"\\F016\"}.fa-clock-o:before{content:\"\\F017\"}.fa-road:before{content:\"\\F018\"}.fa-download:before{content:\"\\F019\"}.fa-arrow-circle-o-down:before{content:\"\\F01A\"}.fa-arrow-circle-o-up:before{content:\"\\F01B\"}.fa-inbox:before{content:\"\\F01C\"}.fa-play-circle-o:before{content:\"\\F01D\"}.fa-repeat:before,.fa-rotate-right:before{content:\"\\F01E\"}.fa-refresh:before{content:\"\\F021\"}.fa-list-alt:before{content:\"\\F022\"}.fa-lock:before{content:\"\\F023\"}.fa-flag:before{content:\"\\F024\"}.fa-headphones:before{content:\"\\F025\"}.fa-volume-off:before{content:\"\\F026\"}.fa-volume-down:before{content:\"\\F027\"}.fa-volume-up:before{content:\"\\F028\"}.fa-qrcode:before{content:\"\\F029\"}.fa-barcode:before{content:\"\\F02A\"}.fa-tag:before{content:\"\\F02B\"}.fa-tags:before{content:\"\\F02C\"}.fa-book:before{content:\"\\F02D\"}.fa-bookmark:before{content:\"\\F02E\"}.fa-print:before{content:\"\\F02F\"}.fa-camera:before{content:\"\\F030\"}.fa-font:before{content:\"\\F031\"}.fa-bold:before{content:\"\\F032\"}.fa-italic:before{content:\"\\F033\"}.fa-text-height:before{content:\"\\F034\"}.fa-text-width:before{content:\"\\F035\"}.fa-align-left:before{content:\"\\F036\"}.fa-align-center:before{content:\"\\F037\"}.fa-align-right:before{content:\"\\F038\"}.fa-align-justify:before{content:\"\\F039\"}.fa-list:before{content:\"\\F03A\"}.fa-dedent:before,.fa-outdent:before{content:\"\\F03B\"}.fa-indent:before{content:\"\\F03C\"}.fa-video-camera:before{content:\"\\F03D\"}.fa-image:before,.fa-photo:before,.fa-picture-o:before{content:\"\\F03E\"}.fa-pencil:before{content:\"\\F040\"}.fa-map-marker:before{content:\"\\F041\"}.fa-adjust:before{content:\"\\F042\"}.fa-tint:before{content:\"\\F043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\F044\"}.fa-share-square-o:before{content:\"\\F045\"}.fa-check-square-o:before{content:\"\\F046\"}.fa-arrows:before{content:\"\\F047\"}.fa-step-backward:before{content:\"\\F048\"}.fa-fast-backward:before{content:\"\\F049\"}.fa-backward:before{content:\"\\F04A\"}.fa-play:before{content:\"\\F04B\"}.fa-pause:before{content:\"\\F04C\"}.fa-stop:before{content:\"\\F04D\"}.fa-forward:before{content:\"\\F04E\"}.fa-fast-forward:before{content:\"\\F050\"}.fa-step-forward:before{content:\"\\F051\"}.fa-eject:before{content:\"\\F052\"}.fa-chevron-left:before{content:\"\\F053\"}.fa-chevron-right:before{content:\"\\F054\"}.fa-plus-circle:before{content:\"\\F055\"}.fa-minus-circle:before{content:\"\\F056\"}.fa-times-circle:before{content:\"\\F057\"}.fa-check-circle:before{content:\"\\F058\"}.fa-question-circle:before{content:\"\\F059\"}.fa-info-circle:before{content:\"\\F05A\"}.fa-crosshairs:before{content:\"\\F05B\"}.fa-times-circle-o:before{content:\"\\F05C\"}.fa-check-circle-o:before{content:\"\\F05D\"}.fa-ban:before{content:\"\\F05E\"}.fa-arrow-left:before{content:\"\\F060\"}.fa-arrow-right:before{content:\"\\F061\"}.fa-arrow-up:before{content:\"\\F062\"}.fa-arrow-down:before{content:\"\\F063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\F064\"}.fa-expand:before{content:\"\\F065\"}.fa-compress:before{content:\"\\F066\"}.fa-plus:before{content:\"\\F067\"}.fa-minus:before{content:\"\\F068\"}.fa-asterisk:before{content:\"\\F069\"}.fa-exclamation-circle:before{content:\"\\F06A\"}.fa-gift:before{content:\"\\F06B\"}.fa-leaf:before{content:\"\\F06C\"}.fa-fire:before{content:\"\\F06D\"}.fa-eye:before{content:\"\\F06E\"}.fa-eye-slash:before{content:\"\\F070\"}.fa-exclamation-triangle:before,.fa-warning:before{content:\"\\F071\"}.fa-plane:before{content:\"\\F072\"}.fa-calendar:before{content:\"\\F073\"}.fa-random:before{content:\"\\F074\"}.fa-comment:before{content:\"\\F075\"}.fa-magnet:before{content:\"\\F076\"}.fa-chevron-up:before{content:\"\\F077\"}.fa-chevron-down:before{content:\"\\F078\"}.fa-retweet:before{content:\"\\F079\"}.fa-shopping-cart:before{content:\"\\F07A\"}.fa-folder:before{content:\"\\F07B\"}.fa-folder-open:before{content:\"\\F07C\"}.fa-arrows-v:before{content:\"\\F07D\"}.fa-arrows-h:before{content:\"\\F07E\"}.fa-bar-chart-o:before,.fa-bar-chart:before{content:\"\\F080\"}.fa-twitter-square:before{content:\"\\F081\"}.fa-facebook-square:before{content:\"\\F082\"}.fa-camera-retro:before{content:\"\\F083\"}.fa-key:before{content:\"\\F084\"}.fa-cogs:before,.fa-gears:before{content:\"\\F085\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}.fa-thumbs-o-down:before{content:\"\\F088\"}.fa-star-half:before{content:\"\\F089\"}.fa-heart-o:before{content:\"\\F08A\"}.fa-sign-out:before{content:\"\\F08B\"}.fa-linkedin-square:before{content:\"\\F08C\"}.fa-thumb-tack:before{content:\"\\F08D\"}.fa-external-link:before{content:\"\\F08E\"}.fa-sign-in:before{content:\"\\F090\"}.fa-trophy:before{content:\"\\F091\"}.fa-github-square:before{content:\"\\F092\"}.fa-upload:before{content:\"\\F093\"}.fa-lemon-o:before{content:\"\\F094\"}.fa-phone:before{content:\"\\F095\"}.fa-square-o:before{content:\"\\F096\"}.fa-bookmark-o:before{content:\"\\F097\"}.fa-phone-square:before{content:\"\\F098\"}.fa-twitter:before{content:\"\\F099\"}.fa-facebook-f:before,.fa-facebook:before{content:\"\\F09A\"}.fa-github:before{content:\"\\F09B\"}.fa-unlock:before{content:\"\\F09C\"}.fa-credit-card:before{content:\"\\F09D\"}.fa-feed:before,.fa-rss:before{content:\"\\F09E\"}.fa-hdd-o:before{content:\"\\F0A0\"}.fa-bullhorn:before{content:\"\\F0A1\"}.fa-bell:before{content:\"\\F0F3\"}.fa-certificate:before{content:\"\\F0A3\"}.fa-hand-o-right:before{content:\"\\F0A4\"}.fa-hand-o-left:before{content:\"\\F0A5\"}.fa-hand-o-up:before{content:\"\\F0A6\"}.fa-hand-o-down:before{content:\"\\F0A7\"}.fa-arrow-circle-left:before{content:\"\\F0A8\"}.fa-arrow-circle-right:before{content:\"\\F0A9\"}.fa-arrow-circle-up:before{content:\"\\F0AA\"}.fa-arrow-circle-down:before{content:\"\\F0AB\"}.fa-globe:before{content:\"\\F0AC\"}.fa-wrench:before{content:\"\\F0AD\"}.fa-tasks:before{content:\"\\F0AE\"}.fa-filter:before{content:\"\\F0B0\"}.fa-briefcase:before{content:\"\\F0B1\"}.fa-arrows-alt:before{content:\"\\F0B2\"}.fa-group:before,.fa-users:before{content:\"\\F0C0\"}.fa-chain:before,.fa-link:before{content:\"\\F0C1\"}.fa-cloud:before{content:\"\\F0C2\"}.fa-flask:before{content:\"\\F0C3\"}.fa-cut:before,.fa-scissors:before{content:\"\\F0C4\"}.fa-copy:before,.fa-files-o:before{content:\"\\F0C5\"}.fa-paperclip:before{content:\"\\F0C6\"}.fa-floppy-o:before,.fa-save:before{content:\"\\F0C7\"}.fa-square:before{content:\"\\F0C8\"}.fa-bars:before,.fa-navicon:before,.fa-reorder:before{content:\"\\F0C9\"}.fa-list-ul:before{content:\"\\F0CA\"}.fa-list-ol:before{content:\"\\F0CB\"}.fa-strikethrough:before{content:\"\\F0CC\"}.fa-underline:before{content:\"\\F0CD\"}.fa-table:before{content:\"\\F0CE\"}.fa-magic:before{content:\"\\F0D0\"}.fa-truck:before{content:\"\\F0D1\"}.fa-pinterest:before{content:\"\\F0D2\"}.fa-pinterest-square:before{content:\"\\F0D3\"}.fa-google-plus-square:before{content:\"\\F0D4\"}.fa-google-plus:before{content:\"\\F0D5\"}.fa-money:before{content:\"\\F0D6\"}.fa-caret-down:before{content:\"\\F0D7\"}.fa-caret-up:before{content:\"\\F0D8\"}.fa-caret-left:before{content:\"\\F0D9\"}.fa-caret-right:before{content:\"\\F0DA\"}.fa-columns:before{content:\"\\F0DB\"}.fa-sort:before,.fa-unsorted:before{content:\"\\F0DC\"}.fa-sort-desc:before,.fa-sort-down:before{content:\"\\F0DD\"}.fa-sort-asc:before,.fa-sort-up:before{content:\"\\F0DE\"}.fa-envelope:before{content:\"\\F0E0\"}.fa-linkedin:before{content:\"\\F0E1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\F0E2\"}.fa-gavel:before,.fa-legal:before{content:\"\\F0E3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\F0E4\"}.fa-comment-o:before{content:\"\\F0E5\"}.fa-comments-o:before{content:\"\\F0E6\"}.fa-bolt:before,.fa-flash:before{content:\"\\F0E7\"}.fa-sitemap:before{content:\"\\F0E8\"}.fa-umbrella:before{content:\"\\F0E9\"}.fa-clipboard:before,.fa-paste:before{content:\"\\F0EA\"}.fa-lightbulb-o:before{content:\"\\F0EB\"}.fa-exchange:before{content:\"\\F0EC\"}.fa-cloud-download:before{content:\"\\F0ED\"}.fa-cloud-upload:before{content:\"\\F0EE\"}.fa-user-md:before{content:\"\\F0F0\"}.fa-stethoscope:before{content:\"\\F0F1\"}.fa-suitcase:before{content:\"\\F0F2\"}.fa-bell-o:before{content:\"\\F0A2\"}.fa-coffee:before{content:\"\\F0F4\"}.fa-cutlery:before{content:\"\\F0F5\"}.fa-file-text-o:before{content:\"\\F0F6\"}.fa-building-o:before{content:\"\\F0F7\"}.fa-hospital-o:before{content:\"\\F0F8\"}.fa-ambulance:before{content:\"\\F0F9\"}.fa-medkit:before{content:\"\\F0FA\"}.fa-fighter-jet:before{content:\"\\F0FB\"}.fa-beer:before{content:\"\\F0FC\"}.fa-h-square:before{content:\"\\F0FD\"}.fa-plus-square:before{content:\"\\F0FE\"}.fa-angle-double-left:before{content:\"\\F100\"}.fa-angle-double-right:before{content:\"\\F101\"}.fa-angle-double-up:before{content:\"\\F102\"}.fa-angle-double-down:before{content:\"\\F103\"}.fa-angle-left:before{content:\"\\F104\"}.fa-angle-right:before{content:\"\\F105\"}.fa-angle-up:before{content:\"\\F106\"}.fa-angle-down:before{content:\"\\F107\"}.fa-desktop:before{content:\"\\F108\"}.fa-laptop:before{content:\"\\F109\"}.fa-tablet:before{content:\"\\F10A\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\F10B\"}.fa-circle-o:before{content:\"\\F10C\"}.fa-quote-left:before{content:\"\\F10D\"}.fa-quote-right:before{content:\"\\F10E\"}.fa-spinner:before{content:\"\\F110\"}.fa-circle:before{content:\"\\F111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\F112\"}.fa-github-alt:before{content:\"\\F113\"}.fa-folder-o:before{content:\"\\F114\"}.fa-folder-open-o:before{content:\"\\F115\"}.fa-smile-o:before{content:\"\\F118\"}.fa-frown-o:before{content:\"\\F119\"}.fa-meh-o:before{content:\"\\F11A\"}.fa-gamepad:before{content:\"\\F11B\"}.fa-keyboard-o:before{content:\"\\F11C\"}.fa-flag-o:before{content:\"\\F11D\"}.fa-flag-checkered:before{content:\"\\F11E\"}.fa-terminal:before{content:\"\\F120\"}.fa-code:before{content:\"\\F121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\F122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\F123\"}.fa-location-arrow:before{content:\"\\F124\"}.fa-crop:before{content:\"\\F125\"}.fa-code-fork:before{content:\"\\F126\"}.fa-chain-broken:before,.fa-unlink:before{content:\"\\F127\"}.fa-question:before{content:\"\\F128\"}.fa-info:before{content:\"\\F129\"}.fa-exclamation:before{content:\"\\F12A\"}.fa-superscript:before{content:\"\\F12B\"}.fa-subscript:before{content:\"\\F12C\"}.fa-eraser:before{content:\"\\F12D\"}.fa-puzzle-piece:before{content:\"\\F12E\"}.fa-microphone:before{content:\"\\F130\"}.fa-microphone-slash:before{content:\"\\F131\"}.fa-shield:before{content:\"\\F132\"}.fa-calendar-o:before{content:\"\\F133\"}.fa-fire-extinguisher:before{content:\"\\F134\"}.fa-rocket:before{content:\"\\F135\"}.fa-maxcdn:before{content:\"\\F136\"}.fa-chevron-circle-left:before{content:\"\\F137\"}.fa-chevron-circle-right:before{content:\"\\F138\"}.fa-chevron-circle-up:before{content:\"\\F139\"}.fa-chevron-circle-down:before{content:\"\\F13A\"}.fa-html5:before{content:\"\\F13B\"}.fa-css3:before{content:\"\\F13C\"}.fa-anchor:before{content:\"\\F13D\"}.fa-unlock-alt:before{content:\"\\F13E\"}.fa-bullseye:before{content:\"\\F140\"}.fa-ellipsis-h:before{content:\"\\F141\"}.fa-ellipsis-v:before{content:\"\\F142\"}.fa-rss-square:before{content:\"\\F143\"}.fa-play-circle:before{content:\"\\F144\"}.fa-ticket:before{content:\"\\F145\"}.fa-minus-square:before{content:\"\\F146\"}.fa-minus-square-o:before{content:\"\\F147\"}.fa-level-up:before{content:\"\\F148\"}.fa-level-down:before{content:\"\\F149\"}.fa-check-square:before{content:\"\\F14A\"}.fa-pencil-square:before{content:\"\\F14B\"}.fa-external-link-square:before{content:\"\\F14C\"}.fa-share-square:before{content:\"\\F14D\"}.fa-compass:before{content:\"\\F14E\"}.fa-caret-square-o-down:before,.fa-toggle-down:before{content:\"\\F150\"}.fa-caret-square-o-up:before,.fa-toggle-up:before{content:\"\\F151\"}.fa-caret-square-o-right:before,.fa-toggle-right:before{content:\"\\F152\"}.fa-eur:before,.fa-euro:before{content:\"\\F153\"}.fa-gbp:before{content:\"\\F154\"}.fa-dollar:before,.fa-usd:before{content:\"\\F155\"}.fa-inr:before,.fa-rupee:before{content:\"\\F156\"}.fa-cny:before,.fa-jpy:before,.fa-rmb:before,.fa-yen:before{content:\"\\F157\"}.fa-rouble:before,.fa-rub:before,.fa-ruble:before{content:\"\\F158\"}.fa-krw:before,.fa-won:before{content:\"\\F159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\F15A\"}.fa-file:before{content:\"\\F15B\"}.fa-file-text:before{content:\"\\F15C\"}.fa-sort-alpha-asc:before{content:\"\\F15D\"}.fa-sort-alpha-desc:before{content:\"\\F15E\"}.fa-sort-amount-asc:before{content:\"\\F160\"}.fa-sort-amount-desc:before{content:\"\\F161\"}.fa-sort-numeric-asc:before{content:\"\\F162\"}.fa-sort-numeric-desc:before{content:\"\\F163\"}.fa-thumbs-up:before{content:\"\\F164\"}.fa-thumbs-down:before{content:\"\\F165\"}.fa-youtube-square:before{content:\"\\F166\"}.fa-youtube:before{content:\"\\F167\"}.fa-xing:before{content:\"\\F168\"}.fa-xing-square:before{content:\"\\F169\"}.fa-youtube-play:before{content:\"\\F16A\"}.fa-dropbox:before{content:\"\\F16B\"}.fa-stack-overflow:before{content:\"\\F16C\"}.fa-instagram:before{content:\"\\F16D\"}.fa-flickr:before{content:\"\\F16E\"}.fa-adn:before{content:\"\\F170\"}.fa-bitbucket:before{content:\"\\F171\"}.fa-bitbucket-square:before{content:\"\\F172\"}.fa-tumblr:before{content:\"\\F173\"}.fa-tumblr-square:before{content:\"\\F174\"}.fa-long-arrow-down:before{content:\"\\F175\"}.fa-long-arrow-up:before{content:\"\\F176\"}.fa-long-arrow-left:before{content:\"\\F177\"}.fa-long-arrow-right:before{content:\"\\F178\"}.fa-apple:before{content:\"\\F179\"}.fa-windows:before{content:\"\\F17A\"}.fa-android:before{content:\"\\F17B\"}.fa-linux:before{content:\"\\F17C\"}.fa-dribbble:before{content:\"\\F17D\"}.fa-skype:before{content:\"\\F17E\"}.fa-foursquare:before{content:\"\\F180\"}.fa-trello:before{content:\"\\F181\"}.fa-female:before{content:\"\\F182\"}.fa-male:before{content:\"\\F183\"}.fa-gittip:before,.fa-gratipay:before{content:\"\\F184\"}.fa-sun-o:before{content:\"\\F185\"}.fa-moon-o:before{content:\"\\F186\"}.fa-archive:before{content:\"\\F187\"}.fa-bug:before{content:\"\\F188\"}.fa-vk:before{content:\"\\F189\"}.fa-weibo:before{content:\"\\F18A\"}.fa-renren:before{content:\"\\F18B\"}.fa-pagelines:before{content:\"\\F18C\"}.fa-stack-exchange:before{content:\"\\F18D\"}.fa-arrow-circle-o-right:before{content:\"\\F18E\"}.fa-arrow-circle-o-left:before{content:\"\\F190\"}.fa-caret-square-o-left:before,.fa-toggle-left:before{content:\"\\F191\"}.fa-dot-circle-o:before{content:\"\\F192\"}.fa-wheelchair:before{content:\"\\F193\"}.fa-vimeo-square:before{content:\"\\F194\"}.fa-try:before,.fa-turkish-lira:before{content:\"\\F195\"}.fa-plus-square-o:before{content:\"\\F196\"}.fa-space-shuttle:before{content:\"\\F197\"}.fa-slack:before{content:\"\\F198\"}.fa-envelope-square:before{content:\"\\F199\"}.fa-wordpress:before{content:\"\\F19A\"}.fa-openid:before{content:\"\\F19B\"}.fa-bank:before,.fa-institution:before,.fa-university:before{content:\"\\F19C\"}.fa-graduation-cap:before,.fa-mortar-board:before{content:\"\\F19D\"}.fa-yahoo:before{content:\"\\F19E\"}.fa-google:before{content:\"\\F1A0\"}.fa-reddit:before{content:\"\\F1A1\"}.fa-reddit-square:before{content:\"\\F1A2\"}.fa-stumbleupon-circle:before{content:\"\\F1A3\"}.fa-stumbleupon:before{content:\"\\F1A4\"}.fa-delicious:before{content:\"\\F1A5\"}.fa-digg:before{content:\"\\F1A6\"}.fa-pied-piper-pp:before{content:\"\\F1A7\"}.fa-pied-piper-alt:before{content:\"\\F1A8\"}.fa-drupal:before{content:\"\\F1A9\"}.fa-joomla:before{content:\"\\F1AA\"}.fa-language:before{content:\"\\F1AB\"}.fa-fax:before{content:\"\\F1AC\"}.fa-building:before{content:\"\\F1AD\"}.fa-child:before{content:\"\\F1AE\"}.fa-paw:before{content:\"\\F1B0\"}.fa-spoon:before{content:\"\\F1B1\"}.fa-cube:before{content:\"\\F1B2\"}.fa-cubes:before{content:\"\\F1B3\"}.fa-behance:before{content:\"\\F1B4\"}.fa-behance-square:before{content:\"\\F1B5\"}.fa-steam:before{content:\"\\F1B6\"}.fa-steam-square:before{content:\"\\F1B7\"}.fa-recycle:before{content:\"\\F1B8\"}.fa-automobile:before,.fa-car:before{content:\"\\F1B9\"}.fa-cab:before,.fa-taxi:before{content:\"\\F1BA\"}.fa-tree:before{content:\"\\F1BB\"}.fa-spotify:before{content:\"\\F1BC\"}.fa-deviantart:before{content:\"\\F1BD\"}.fa-soundcloud:before{content:\"\\F1BE\"}.fa-database:before{content:\"\\F1C0\"}.fa-file-pdf-o:before{content:\"\\F1C1\"}.fa-file-word-o:before{content:\"\\F1C2\"}.fa-file-excel-o:before{content:\"\\F1C3\"}.fa-file-powerpoint-o:before{content:\"\\F1C4\"}.fa-file-image-o:before,.fa-file-photo-o:before,.fa-file-picture-o:before{content:\"\\F1C5\"}.fa-file-archive-o:before,.fa-file-zip-o:before{content:\"\\F1C6\"}.fa-file-audio-o:before,.fa-file-sound-o:before{content:\"\\F1C7\"}.fa-file-movie-o:before,.fa-file-video-o:before{content:\"\\F1C8\"}.fa-file-code-o:before{content:\"\\F1C9\"}.fa-vine:before{content:\"\\F1CA\"}.fa-codepen:before{content:\"\\F1CB\"}.fa-jsfiddle:before{content:\"\\F1CC\"}.fa-life-bouy:before,.fa-life-buoy:before,.fa-life-ring:before,.fa-life-saver:before,.fa-support:before{content:\"\\F1CD\"}.fa-circle-o-notch:before{content:\"\\F1CE\"}.fa-ra:before,.fa-rebel:before,.fa-resistance:before{content:\"\\F1D0\"}.fa-empire:before,.fa-ge:before{content:\"\\F1D1\"}.fa-git-square:before{content:\"\\F1D2\"}.fa-git:before{content:\"\\F1D3\"}.fa-hacker-news:before,.fa-y-combinator-square:before,.fa-yc-square:before{content:\"\\F1D4\"}.fa-tencent-weibo:before{content:\"\\F1D5\"}.fa-qq:before{content:\"\\F1D6\"}.fa-wechat:before,.fa-weixin:before{content:\"\\F1D7\"}.fa-paper-plane:before,.fa-send:before{content:\"\\F1D8\"}.fa-paper-plane-o:before,.fa-send-o:before{content:\"\\F1D9\"}.fa-history:before{content:\"\\F1DA\"}.fa-circle-thin:before{content:\"\\F1DB\"}.fa-header:before{content:\"\\F1DC\"}.fa-paragraph:before{content:\"\\F1DD\"}.fa-sliders:before{content:\"\\F1DE\"}.fa-share-alt:before{content:\"\\F1E0\"}.fa-share-alt-square:before{content:\"\\F1E1\"}.fa-bomb:before{content:\"\\F1E2\"}.fa-futbol-o:before,.fa-soccer-ball-o:before{content:\"\\F1E3\"}.fa-tty:before{content:\"\\F1E4\"}.fa-binoculars:before{content:\"\\F1E5\"}.fa-plug:before{content:\"\\F1E6\"}.fa-slideshare:before{content:\"\\F1E7\"}.fa-twitch:before{content:\"\\F1E8\"}.fa-yelp:before{content:\"\\F1E9\"}.fa-newspaper-o:before{content:\"\\F1EA\"}.fa-wifi:before{content:\"\\F1EB\"}.fa-calculator:before{content:\"\\F1EC\"}.fa-paypal:before{content:\"\\F1ED\"}.fa-google-wallet:before{content:\"\\F1EE\"}.fa-cc-visa:before{content:\"\\F1F0\"}.fa-cc-mastercard:before{content:\"\\F1F1\"}.fa-cc-discover:before{content:\"\\F1F2\"}.fa-cc-amex:before{content:\"\\F1F3\"}.fa-cc-paypal:before{content:\"\\F1F4\"}.fa-cc-stripe:before{content:\"\\F1F5\"}.fa-bell-slash:before{content:\"\\F1F6\"}.fa-bell-slash-o:before{content:\"\\F1F7\"}.fa-trash:before{content:\"\\F1F8\"}.fa-copyright:before{content:\"\\F1F9\"}.fa-at:before{content:\"\\F1FA\"}.fa-eyedropper:before{content:\"\\F1FB\"}.fa-paint-brush:before{content:\"\\F1FC\"}.fa-birthday-cake:before{content:\"\\F1FD\"}.fa-area-chart:before{content:\"\\F1FE\"}.fa-pie-chart:before{content:\"\\F200\"}.fa-line-chart:before{content:\"\\F201\"}.fa-lastfm:before{content:\"\\F202\"}.fa-lastfm-square:before{content:\"\\F203\"}.fa-toggle-off:before{content:\"\\F204\"}.fa-toggle-on:before{content:\"\\F205\"}.fa-bicycle:before{content:\"\\F206\"}.fa-bus:before{content:\"\\F207\"}.fa-ioxhost:before{content:\"\\F208\"}.fa-angellist:before{content:\"\\F209\"}.fa-cc:before{content:\"\\F20A\"}.fa-ils:before,.fa-shekel:before,.fa-sheqel:before{content:\"\\F20B\"}.fa-meanpath:before{content:\"\\F20C\"}.fa-buysellads:before{content:\"\\F20D\"}.fa-connectdevelop:before{content:\"\\F20E\"}.fa-dashcube:before{content:\"\\F210\"}.fa-forumbee:before{content:\"\\F211\"}.fa-leanpub:before{content:\"\\F212\"}.fa-sellsy:before{content:\"\\F213\"}.fa-shirtsinbulk:before{content:\"\\F214\"}.fa-simplybuilt:before{content:\"\\F215\"}.fa-skyatlas:before{content:\"\\F216\"}.fa-cart-plus:before{content:\"\\F217\"}.fa-cart-arrow-down:before{content:\"\\F218\"}.fa-diamond:before{content:\"\\F219\"}.fa-ship:before{content:\"\\F21A\"}.fa-user-secret:before{content:\"\\F21B\"}.fa-motorcycle:before{content:\"\\F21C\"}.fa-street-view:before{content:\"\\F21D\"}.fa-heartbeat:before{content:\"\\F21E\"}.fa-venus:before{content:\"\\F221\"}.fa-mars:before{content:\"\\F222\"}.fa-mercury:before{content:\"\\F223\"}.fa-intersex:before,.fa-transgender:before{content:\"\\F224\"}.fa-transgender-alt:before{content:\"\\F225\"}.fa-venus-double:before{content:\"\\F226\"}.fa-mars-double:before{content:\"\\F227\"}.fa-venus-mars:before{content:\"\\F228\"}.fa-mars-stroke:before{content:\"\\F229\"}.fa-mars-stroke-v:before{content:\"\\F22A\"}.fa-mars-stroke-h:before{content:\"\\F22B\"}.fa-neuter:before{content:\"\\F22C\"}.fa-genderless:before{content:\"\\F22D\"}.fa-facebook-official:before{content:\"\\F230\"}.fa-pinterest-p:before{content:\"\\F231\"}.fa-whatsapp:before{content:\"\\F232\"}.fa-server:before{content:\"\\F233\"}.fa-user-plus:before{content:\"\\F234\"}.fa-user-times:before{content:\"\\F235\"}.fa-bed:before,.fa-hotel:before{content:\"\\F236\"}.fa-viacoin:before{content:\"\\F237\"}.fa-train:before{content:\"\\F238\"}.fa-subway:before{content:\"\\F239\"}.fa-medium:before{content:\"\\F23A\"}.fa-y-combinator:before,.fa-yc:before{content:\"\\F23B\"}.fa-optin-monster:before{content:\"\\F23C\"}.fa-opencart:before{content:\"\\F23D\"}.fa-expeditedssl:before{content:\"\\F23E\"}.fa-battery-4:before,.fa-battery-full:before,.fa-battery:before{content:\"\\F240\"}.fa-battery-3:before,.fa-battery-three-quarters:before{content:\"\\F241\"}.fa-battery-2:before,.fa-battery-half:before{content:\"\\F242\"}.fa-battery-1:before,.fa-battery-quarter:before{content:\"\\F243\"}.fa-battery-0:before,.fa-battery-empty:before{content:\"\\F244\"}.fa-mouse-pointer:before{content:\"\\F245\"}.fa-i-cursor:before{content:\"\\F246\"}.fa-object-group:before{content:\"\\F247\"}.fa-object-ungroup:before{content:\"\\F248\"}.fa-sticky-note:before{content:\"\\F249\"}.fa-sticky-note-o:before{content:\"\\F24A\"}.fa-cc-jcb:before{content:\"\\F24B\"}.fa-cc-diners-club:before{content:\"\\F24C\"}.fa-clone:before{content:\"\\F24D\"}.fa-balance-scale:before{content:\"\\F24E\"}.fa-hourglass-o:before{content:\"\\F250\"}.fa-hourglass-1:before,.fa-hourglass-start:before{content:\"\\F251\"}.fa-hourglass-2:before,.fa-hourglass-half:before{content:\"\\F252\"}.fa-hourglass-3:before,.fa-hourglass-end:before{content:\"\\F253\"}.fa-hourglass:before{content:\"\\F254\"}.fa-hand-grab-o:before,.fa-hand-rock-o:before{content:\"\\F255\"}.fa-hand-paper-o:before,.fa-hand-stop-o:before{content:\"\\F256\"}.fa-hand-scissors-o:before{content:\"\\F257\"}.fa-hand-lizard-o:before{content:\"\\F258\"}.fa-hand-spock-o:before{content:\"\\F259\"}.fa-hand-pointer-o:before{content:\"\\F25A\"}.fa-hand-peace-o:before{content:\"\\F25B\"}.fa-trademark:before{content:\"\\F25C\"}.fa-registered:before{content:\"\\F25D\"}.fa-creative-commons:before{content:\"\\F25E\"}.fa-gg:before{content:\"\\F260\"}.fa-gg-circle:before{content:\"\\F261\"}.fa-tripadvisor:before{content:\"\\F262\"}.fa-odnoklassniki:before{content:\"\\F263\"}.fa-odnoklassniki-square:before{content:\"\\F264\"}.fa-get-pocket:before{content:\"\\F265\"}.fa-wikipedia-w:before{content:\"\\F266\"}.fa-safari:before{content:\"\\F267\"}.fa-chrome:before{content:\"\\F268\"}.fa-firefox:before{content:\"\\F269\"}.fa-opera:before{content:\"\\F26A\"}.fa-internet-explorer:before{content:\"\\F26B\"}.fa-television:before,.fa-tv:before{content:\"\\F26C\"}.fa-contao:before{content:\"\\F26D\"}.fa-500px:before{content:\"\\F26E\"}.fa-amazon:before{content:\"\\F270\"}.fa-calendar-plus-o:before{content:\"\\F271\"}.fa-calendar-minus-o:before{content:\"\\F272\"}.fa-calendar-times-o:before{content:\"\\F273\"}.fa-calendar-check-o:before{content:\"\\F274\"}.fa-industry:before{content:\"\\F275\"}.fa-map-pin:before{content:\"\\F276\"}.fa-map-signs:before{content:\"\\F277\"}.fa-map-o:before{content:\"\\F278\"}.fa-map:before{content:\"\\F279\"}.fa-commenting:before{content:\"\\F27A\"}.fa-commenting-o:before{content:\"\\F27B\"}.fa-houzz:before{content:\"\\F27C\"}.fa-vimeo:before{content:\"\\F27D\"}.fa-black-tie:before{content:\"\\F27E\"}.fa-fonticons:before{content:\"\\F280\"}.fa-reddit-alien:before{content:\"\\F281\"}.fa-edge:before{content:\"\\F282\"}.fa-credit-card-alt:before{content:\"\\F283\"}.fa-codiepie:before{content:\"\\F284\"}.fa-modx:before{content:\"\\F285\"}.fa-fort-awesome:before{content:\"\\F286\"}.fa-usb:before{content:\"\\F287\"}.fa-product-hunt:before{content:\"\\F288\"}.fa-mixcloud:before{content:\"\\F289\"}.fa-scribd:before{content:\"\\F28A\"}.fa-pause-circle:before{content:\"\\F28B\"}.fa-pause-circle-o:before{content:\"\\F28C\"}.fa-stop-circle:before{content:\"\\F28D\"}.fa-stop-circle-o:before{content:\"\\F28E\"}.fa-shopping-bag:before{content:\"\\F290\"}.fa-shopping-basket:before{content:\"\\F291\"}.fa-hashtag:before{content:\"\\F292\"}.fa-bluetooth:before{content:\"\\F293\"}.fa-bluetooth-b:before{content:\"\\F294\"}.fa-percent:before{content:\"\\F295\"}.fa-gitlab:before{content:\"\\F296\"}.fa-wpbeginner:before{content:\"\\F297\"}.fa-wpforms:before{content:\"\\F298\"}.fa-envira:before{content:\"\\F299\"}.fa-universal-access:before{content:\"\\F29A\"}.fa-wheelchair-alt:before{content:\"\\F29B\"}.fa-question-circle-o:before{content:\"\\F29C\"}.fa-blind:before{content:\"\\F29D\"}.fa-audio-description:before{content:\"\\F29E\"}.fa-volume-control-phone:before{content:\"\\F2A0\"}.fa-braille:before{content:\"\\F2A1\"}.fa-assistive-listening-systems:before{content:\"\\F2A2\"}.fa-american-sign-language-interpreting:before,.fa-asl-interpreting:before{content:\"\\F2A3\"}.fa-deaf:before,.fa-deafness:before,.fa-hard-of-hearing:before{content:\"\\F2A4\"}.fa-glide:before{content:\"\\F2A5\"}.fa-glide-g:before{content:\"\\F2A6\"}.fa-sign-language:before,.fa-signing:before{content:\"\\F2A7\"}.fa-low-vision:before{content:\"\\F2A8\"}.fa-viadeo:before{content:\"\\F2A9\"}.fa-viadeo-square:before{content:\"\\F2AA\"}.fa-snapchat:before{content:\"\\F2AB\"}.fa-snapchat-ghost:before{content:\"\\F2AC\"}.fa-snapchat-square:before{content:\"\\F2AD\"}.fa-pied-piper:before{content:\"\\F2AE\"}.fa-first-order:before{content:\"\\F2B0\"}.fa-yoast:before{content:\"\\F2B1\"}.fa-themeisle:before{content:\"\\F2B2\"}.fa-google-plus-circle:before,.fa-google-plus-official:before{content:\"\\F2B3\"}.fa-fa:before,.fa-font-awesome:before{content:\"\\F2B4\"}.fa-handshake-o:before{content:\"\\F2B5\"}.fa-envelope-open:before{content:\"\\F2B6\"}.fa-envelope-open-o:before{content:\"\\F2B7\"}.fa-linode:before{content:\"\\F2B8\"}.fa-address-book:before{content:\"\\F2B9\"}.fa-address-book-o:before{content:\"\\F2BA\"}.fa-address-card:before,.fa-vcard:before{content:\"\\F2BB\"}.fa-address-card-o:before,.fa-vcard-o:before{content:\"\\F2BC\"}.fa-user-circle:before{content:\"\\F2BD\"}.fa-user-circle-o:before{content:\"\\F2BE\"}.fa-user-o:before{content:\"\\F2C0\"}.fa-id-badge:before{content:\"\\F2C1\"}.fa-drivers-license:before,.fa-id-card:before{content:\"\\F2C2\"}.fa-drivers-license-o:before,.fa-id-card-o:before{content:\"\\F2C3\"}.fa-quora:before{content:\"\\F2C4\"}.fa-free-code-camp:before{content:\"\\F2C5\"}.fa-telegram:before{content:\"\\F2C6\"}.fa-thermometer-4:before,.fa-thermometer-full:before,.fa-thermometer:before{content:\"\\F2C7\"}.fa-thermometer-3:before,.fa-thermometer-three-quarters:before{content:\"\\F2C8\"}.fa-thermometer-2:before,.fa-thermometer-half:before{content:\"\\F2C9\"}.fa-thermometer-1:before,.fa-thermometer-quarter:before{content:\"\\F2CA\"}.fa-thermometer-0:before,.fa-thermometer-empty:before{content:\"\\F2CB\"}.fa-shower:before{content:\"\\F2CC\"}.fa-bath:before,.fa-bathtub:before,.fa-s15:before{content:\"\\F2CD\"}.fa-podcast:before{content:\"\\F2CE\"}.fa-window-maximize:before{content:\"\\F2D0\"}.fa-window-minimize:before{content:\"\\F2D1\"}.fa-window-restore:before{content:\"\\F2D2\"}.fa-times-rectangle:before,.fa-window-close:before{content:\"\\F2D3\"}.fa-times-rectangle-o:before,.fa-window-close-o:before{content:\"\\F2D4\"}.fa-bandcamp:before{content:\"\\F2D5\"}.fa-grav:before{content:\"\\F2D6\"}.fa-etsy:before{content:\"\\F2D7\"}.fa-imdb:before{content:\"\\F2D8\"}.fa-ravelry:before{content:\"\\F2D9\"}.fa-eercast:before{content:\"\\F2DA\"}.fa-microchip:before{content:\"\\F2DB\"}.fa-snowflake-o:before{content:\"\\F2DC\"}.fa-superpowers:before{content:\"\\F2DD\"}.fa-wpexplorer:before{content:\"\\F2DE\"}.fa-meetup:before{content:\"\\F2E0\"}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}.cc-window{font-family:Georgia}.browserupgrade{margin:.2em 0;background:#ccc;color:#000;padding:.2em 0}body{min-width:300px;font-family:Georgia,Times New Roman}.dal-jumbotron{background-color:#fff;padding:15px 25px;font-family:Montserrat,sans-serif!important}.dal-h2{font-size:24px;font-weight:600}.dal-h2,.dal-h4{color:#303030;margin-bottom:30px}.dal-h4{font-size:19px;line-height:1.375em;font-weight:400}.dal-container{padding:75px 25px}.panel-dal{border-color:#bd0e38}.main-header-text{font-size:16px;line-height:1.3333333;margin:5px 5px 10px;text-align:justify}.main-header-title{margin-top:0;margin-bottom:20px}#main-container{margin-top:5%;max-width:400px}.main-logo{float:right;margin-top:5px;width:108px;height:30px}.waitting-spinner{color:#bd0e38}.has-error,.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.radio-inline label,.has-error.radio label{color:red}.has-error .form-control{border-color:red}.legal p{text-align:justify}.legal h3{color:#000}.help-block{padding-left:0}.direct-dr-member-authors-page{padding-top:10px}.direct-dr-member-authors-lang{margin-bottom:10px}.direct-dr-member-authors-form .form-group{margin-right:8px;vertical-align:middle}#banner{border-bottom:none;margin-top:-20px}#banner h1{font-size:60px;line-height:1;letter-spacing:-1px}.hero-unit{position:relative;padding:30px 15px;color:#f5f5f5;text-align:center;text-shadow:0 1px 0 rgba(0,0,0,.1);background:#4393b9}#main-tabset .navbar-text{margin-left:15px}#main-tabset .nav-pills>li>a{line-height:1.8;font-size:1.2em;color:#bd0e38;background-color:#fff;border:1px solid #bd0e38}#main-tabset .nav-pills>li.active>a,#main-tabset .nav-pills>li.active>a:focus,#main-tabset .nav-pills>li.active>a:hover{color:#fff;background-color:#bd0e38}.panel-heading .panel-title button:active,.panel-heading .panel-title button:focus,.panel-heading .panel-title button:hover{text-decoration:none;outline:none!important;-webkit-tap-highlight-color:transparent!important}.project-panel{margin-bottom:19px!important;-o-box-shadow:0 1px 5px 0 #ebebeb;box-shadow:0 1px 5px 0 #ebebeb;border-color:#ccc}.project-panel-open>.panel-heading{background-color:#d8d8d8}.project-button{margin-bottom:15px}.project-title{margin:5px 0;text-align:justify}.project-header-text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;line-height:normal;width:80%}@media (min-width:480px){.project-header-text{width:90%}}@media (min-width:1200px){.project-header-text{width:95%}}.project-description{font-size:14px;margin:0}a:focus,a:hover{text-decoration:none}.btn-menu-project{margin-top:10px;margin-right:7px;float:right}.product-name{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;line-height:normal;padding-left:10px;padding-right:10px}.btn-demand-right{margin-top:15px;margin-right:7px;float:right}.demand-locked,.demand-locked :hover{background-color:gray!important;cursor:not-allowed}.list-artist{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;line-height:normal;width:95%}#btn-project{color:#8bc34a;background-color:#fbfff5;border-color:#b7d2b7}#btn-project,.btn-new-demand{border-style:dashed;display:block;width:100%}.btn-new-demand{margin-top:10px;color:#2196f3;background-color:#fff;border-color:#2196f3;height:57px}.btn-new-demand:hover{color:#333;background-color:#fff;border-color:#333}.bs-demand{cursor:pointer;padding-top:10px!important;padding-bottom:5px!important}.bs-callout{padding:10px!important;margin:7px auto!important}.bs-callout-success{border-color:#5cb85c!important}.bs-callout-primary{border-color:#3071a9!important}.bs-callout-info{border-color:#5bc0de!important}.bs-callout-danger{border-color:#bd0e38!important}.bs-callout-default{border-color:#777!important}.bs-callout-new{border-style:dotted!important}.empty-success{color:#5cb85c;background-color:#fff}.empty-primary{color:#3071a9;background-color:#fff}.empty-info{color:#5bc0de;background-color:#fff}.empty-danger{color:#bd0e38;background-color:#fff}.empty-default{color:#5cb85c;background-color:#fff}.modal{z-index:10000!important}.checked-block{color:green}#modal-title{color:#fff;font-style:normal}.close-contact-form{color:#fff!important;font-size:25px;opacity:1!important}.radio-client input[type=radio]{margin-left:-15px}.form-client .control-label{text-align:left!important}legend{padding-top:20px}.bs-small{font-size:.9em;margin:5px 0!important;padding:10px 20px!important}.col-sub{padding-left:0!important}.error-block{padding-top:5px;font-size:12px;font-style:italic;font-family:sans-serif;color:red}.notices{padding-left:10px;text-align:justify}.list-intro-1>li{list-style-type:disc!important}.list-intro-2>li{list-style-type:circle!important}b{font-size:1em!important}.list-intro-1 a,.list-intro-2 a{text-decoration:underline}.permission-tab-panel{margin-top:0}#tab-confirmation{margin-top:5%}#permission-tabset{margin-top:-30px}.previous>a{color:#337ab7!important;background-color:#fff!important;border-color:#337ab7!important}.next>a{color:#fff!important;background-color:#5cb85c!important;border-color:#4cae4c!important}.center>.primary{color:#fff!important;background-color:#337ab7!important;border-color:#2e6da4!important}.center>.danger{color:#fff!important;background-color:#bd0e38!important;border-color:#d43f3a!important}.center>.warning{color:#fff!important;background-color:#f0ad4e!important;border-color:#eea236!important}.blocked-input-msg{color:red;text-align:justify;margin-top:15px}.ul-confirmation>li{list-style-type:disc!important;margin-bottom:10px}#permission-tabset .nav-pills>li>a{color:#bd0e38;font-size:14px;background-color:#fff;text-decoration:none;padding:0}#permission-tabset .nav-pills>li.active>a,#permission-tabset .nav-pills>li.active>a:focus,#permission-tabset .nav-pills>li.active>a:hover{font-size:16px;font-weight:700;text-decoration:none}uib-tab-heading{padding:0 10px}uib-tab-heading>.badge{background-color:#bd0e38;margin-top:-5px}.permission-panel>.panel-body{padding:25px 25px 5px}.permission-panel{border:none}.permission-next{float:right}#permission-tabset .nav-pills{margin-left:15px}#permission-tabset .nav-pills>li>a{cursor:default}.bs-callout{padding:20px;margin:20px 0;border:1px solid #eee;border-left-width:5px;border-radius:3px}.bs-callout h4{margin-top:0;margin-bottom:5px;font-size:18px}.bs-callout p:last-child{margin-bottom:0}.bs-callout code{border-radius:3px}.bs-callout+.bs-callout{margin-top:-5px}.bs-callout-default{border-color:#777}.bs-callout-default h4{color:#777}.bs-callout-primary{border-color:#428bca}.bs-callout-primary h4{color:#428bca}.bs-callout-success{border-color:#5cb85c}.bs-callout-success h4{color:#5cb85c}.bs-callout-danger{border-color:#d9534f}.bs-callout-danger h4{color:#d9534f}.bs-callout-warning{border-color:#f0ad4e}.bs-callout-warning h4{color:#f0ad4e}.bs-callout-info{border-color:#5bc0de}.bs-callout-info h4{color:#5bc0de}.option-list-box{margin-left:0!important;margin-right:10px!important}.use-number,legend{margin-bottom:5px}legend{padding-top:5px;margin-top:5px}.div-new-use{padding-top:10px;padding-bottom:20px}.div-new-use>button{font-weight:700;border:1px dashed gray;margin-left:10px}.colored-fieldset{background-color:#f7f7f7}.use-fieldset{margin-bottom:-4px}.btn-upload{position:relative;overflow:hidden;margin-left:10px}.ul-file{padding-left:10px}.ul-file>li{margin-bottom:5px}.btn-trash-work{margin-left:15px;margin-right:0}.btn-trash-sketch{margin-right:10px}.fa-upload{margin-right:7px}.btn-upload input{position:absolute;top:0;right:0;margin:0;opacity:0;filter:alpha(opacity=0);transform:translate(-300px) scale(4);-webkit-transform:translate(-300px) scale(4);-ms-transform:translate(-300px) scale(4);-o-transform:translate(-300px) scale(4);font-size:23px;direction:ltr;cursor:pointer}* html .btn-upload{line-height:24px;margin:1px -3px 0 0}*+html .btn-upload{padding:2px 15px;margin:1px 0 0}.help-block{font-size:12px;font-style:italic;font-family:sans-serif}.required-block{color:#bd0e38}.info-block{color:#525050}.author-not-managed{color:#bd0e38;opacity:.8;cursor:not-allowed}.btn-uses{background-color:#663f80!important;color:#fff!important}.delete-manager{padding-left:10px;color:red}.bs-callout-margin{margin-right:15px;margin-left:15px}.use{margin-left:40px}form>div>p,form>p{padding-left:15px}h3{color:gray;font-size:18px}hr{background-color:#fff;border-top:1px solid #cecece}b,strong{font-weight:700;font-size:13.5px}.wanted-container{font-family:Roboto,\"sans-serif\"}.form-inline{display:flex;flex-flow:row wrap;align-items:center}.container{font-size:16px}.comment-result{color:#000;font-size:14px;font-weight:700;margin:15px 0 10px}.table-detail{width:100%}.table-detail td{background-color:#fcfcfc}.table-detail th{background-color:#f4efe7}.table-detail td,.table-detail th{font-size:14px;border:2px solid #fff;padding:5px 7px;font-family:Roboto,\"sans-serif\"}.list-wanted{position:relative;display:block;padding:0;background-color:#e6e6e6;border-bottom:2px solid #fff}.list-wanted-selected{background-color:#fff!important}.text-selected{color:#000}.name-author{margin:0;padding:9px;font-size:16px}.name-author-selected{background-color:#b3a6a6}.btn-detail{font-size:12px;margin-left:10px;border-radius:1px;background-color:#e6e6e6;color:blue;float:right}.btn-detail-selected{display:none}.btn-adagp:focus{color:#fff!important;outline:0!important;box-shadow:0 0 0 0 transparent!important}.input-search{width:300px!important;border-radius:1px!important}.input-search:focus{outline:none!important;border:2px solid #000;box-shadow:none!important}.btn-search{background-color:#b3a6a6!important;border-radius:1px;border-color:#b3a6a6;font-family:Roboto,\"sans-serif\"}footer{text-align:center;padding-top:50px;color:#fff}footer .container-fluid{padding:10px 0}.footer-navbar{background-color:#999!important;margin-bottom:0!important;border-color:#fff!important}.footer-navbar a{color:#fff!important}.modal-danger .modal-header,.modal-info .modal-header,.modal-primary .modal-header,.modal-success .modal-header,.modal-warning .modal-header{color:#fff;border-radius:5px 5px 0 0}.modal-primary .modal-header{background:#337ab7}.modal-info .modal-header{background:#5bc0de}.modal-success .modal-header{background:#5cb85c}.modal-warning .modal-header{background:#f0ad4e}.modal-danger .modal-header{background:#bd0e38}.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:0;margin-left:0}.navbar-header{float:left}.navbar>.container-fluid .navbar-brand,.navbar>.container .navbar-brand{margin-left:-15px}.navbar-header .open .dropdown-menu{position:absolute;float:left;min-width:300px;margin:2px 0 0;background-color:#fff;border:1px solid rgba(0,0,0,.15);box-shadow:0 6px 12px rgba(0,0,0,.175)}.navbar-right>li{float:left}.navbar-right{float:right!important;margin-right:-15px}.nav-popup-li{font-weight:700!important;color:#bd0e38!important;display:block}.navbar-brand-dropdown>li :hover{background-color:#d0d0d0!important}.nav-popup-li>i{float:right;margin-left:15px;margin-top:3px}.navbar-brand-dropdown{top:50px;left:-15px}.navbar-right{margin:0 -15px}.navbar-perso{background-color:#bd0e38;border-radius:2px;border:1px solid #bd0e38}.navbar-header .open>a,.navbar-header .open>a:focus,.navbar-header .open>a:hover{background-color:#eee;border-color:#bd0e38;color:#bd0e38!important}.navbar-header>li>a,.navbar-header>li>a:focus{color:#fff;background-color:#bd0e38}.navbar-header>li>a:hover{color:#fff;background-color:#9e2c29}.navbar-brand{padding:15px!important}li{list-style-type:none}#brand-text{margin:0;color:#fff;padding-left:0!important}#user-name{color:#fff;margin:15px 0 15px 15px;float:right!important}.btn-lang{background-color:#fff;color:#bd0e38;font-weight:700}", ""]);
	
	// exports


/***/ }),
/* 250 */
18,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/* WEBPACK VAR INJECTION */(function(process) {
	/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && 'WebkitAppearance' in document.documentElement.style) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (window.console && (console.firebug || (console.exception && console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs() {
	  var args = arguments;
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return args;
	
	  var c = 'color: ' + this.color;
	  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	  return args;
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    return exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (typeof process !== 'undefined' && 'env' in process) {
	    return ({"NODE_ENV":"production"}).DEBUG;
	  }
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage(){
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(187)))

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = debug.debug = debug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lowercased letter, i.e. "n".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previously assigned color.
	 */
	
	var prevColor = 0;
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 *
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor() {
	  return exports.colors[prevColor++ % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function debug(namespace) {
	
	  // define the `disabled` version
	  function disabled() {
	  }
	  disabled.enabled = false;
	
	  // define the `enabled` version
	  function enabled() {
	
	    var self = enabled;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // add the `color` if not set
	    if (null == self.useColors) self.useColors = exports.useColors();
	    if (null == self.color && self.useColors) self.color = selectColor();
	
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %o
	      args = ['%o'].concat(args);
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting
	    args = exports.formatArgs.apply(self, args);
	
	    var logFn = enabled.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	  enabled.enabled = true;
	
	  var fn = exports.enabled(namespace) ? enabled : disabled;
	
	  fn.namespace = namespace;
	
	  return fn;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  var split = (namespaces || '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/[\\^$+?.()|[\]{}]/g, '\\$&').replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ })
]);


// WEBPACK FOOTER //
// app.2e61d4e9e57d43f682d1.js